import * as i0 from '@angular/core';
import { EventEmitter, Directive, Input, Output, NgModule, Injectable, Optional, Inject, Component, SkipSelf, HostBinding, ViewChild, ContentChildren, Pipe, forwardRef, ElementRef, HostListener, InjectionToken, ChangeDetectionStrategy, ViewChildren, Self, QueryList, ViewEncapsulation, ContentChild, isDevMode, Attribute } from '@angular/core';
import * as i4 from '@angular/common';
import { CommonModule, DOCUMENT } from '@angular/common';
import { Subject, BehaviorSubject, isObservable, of } from 'rxjs';
import { TinyColor } from '@ctrl/tinycolor';
import { css } from 'emotion';
import { coerceBooleanProperty, coerceNumberProperty, coerceArray } from '@angular/cdk/coercion';
import * as i2 from '@angular/material/expansion';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import * as i3 from '@angular/material/button';
import { MatButtonModule } from '@angular/material/button';
import * as i4$1 from '@angular/material/card';
import { MatCardModule } from '@angular/material/card';
import * as i3$1 from '@angular/material/checkbox';
import { MatCheckboxModule } from '@angular/material/checkbox';
import * as i5 from '@angular/forms';
import { FormsModule, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import * as i4$2 from '@material-extended/mde';
import { MdePopoverTrigger, MdePopoverModule } from '@material-extended/mde';
import dayjs from 'dayjs';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { v4 } from 'uuid';
import * as i6 from '@angular/material/datepicker';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDayjsDateModule } from '@tabuckner/material-dayjs-adapter';
import * as i6$1 from '@angular/material/core';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS, MAT_RIPPLE_GLOBAL_OPTIONS, MatRipple } from '@angular/material/core';
import localeData from 'dayjs/plugin/localeData';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import relativeTime from 'dayjs/plugin/relativeTime';
import { Platform } from '@angular/cdk/platform';
import * as i4$3 from '@angular/material/menu';
import { MatMenuTrigger, MatMenuItem, MatMenuModule } from '@angular/material/menu';
import * as i1 from '@angular/platform-browser';
import * as i2$1 from '@angular/material/toolbar';
import { MatToolbarModule } from '@angular/material/toolbar';
import * as i2$2 from '@angular/material/progress-bar';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import * as i3$2 from '@angular/material/radio';
import { MatRadioModule } from '@angular/material/radio';
import * as i3$3 from '@angular/material/slider';
import { MatSliderModule } from '@angular/material/slider';
import * as i3$4 from '@angular/material/slide-toggle';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import * as i2$3 from '@angular/material/tabs';
import { MatTab, MatTabsModule, MatTabGroup } from '@angular/material/tabs';
import * as i8 from '@angular/material/input';
import { MatInputModule } from '@angular/material/input';
import * as i4$4 from '@angular/material/form-field';
import { MatFormFieldModule } from '@angular/material/form-field';
import * as i5$1 from '@angular/material/autocomplete';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import * as i3$5 from '@angular/material/tooltip';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { EventEmitter as EventEmitter$1 } from 'events';
import { DataSource, isDataSource } from '@angular/cdk/collections';
import * as i1$1 from '@angular/cdk/bidi';
import { ObserversModule } from '@angular/cdk/observers';

;
class ScrollSpyDirective {
    constructor(_el) {
        this._el = _el;
        this.spiedTags = [];
        this.offset = 0;
        this.sectionChange = new EventEmitter();
    }
    ;
    track(event) {
        let currentSection;
        const children = this._el.nativeElement.children;
        const scrollTop = event.target.scrollingElement.scrollTop;
        const parentOffset = event.target.scrollingElement.offsetTop + this.offset;
        for (let i = 0; i < children.length; i++) {
            const element = children[i];
            if (this.spiedTags.some(spiedTag => spiedTag === element.tagName)) {
                if ((element.offsetTop - parentOffset - 5) <= scrollTop) {
                    currentSection = element.id;
                }
            }
        }
        if (currentSection !== this.currentSection && currentSection !== undefined) {
            this.currentSection = currentSection.substr(currentSection.length - 1);
            this.sectionChange.emit(this.currentSection);
        }
    }
}
ScrollSpyDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: ScrollSpyDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
ScrollSpyDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.2.5", type: ScrollSpyDirective, selector: "[scroll-spy]", inputs: { spiedTags: "spiedTags", offset: "offset" }, outputs: { sectionChange: "sectionChange" }, host: { listeners: { "window:scroll": "track($event)" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: ScrollSpyDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[scroll-spy]',
                    host: { '(window:scroll)': 'track($event)' }
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { spiedTags: [{
                type: Input
            }], offset: [{
                type: Input
            }], sectionChange: [{
                type: Output
            }] } });

class ScrollSpyModule {
}
ScrollSpyModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: ScrollSpyModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
ScrollSpyModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: ScrollSpyModule, declarations: [ScrollSpyDirective], exports: [ScrollSpyDirective] });
ScrollSpyModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: ScrollSpyModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: ScrollSpyModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [ScrollSpyDirective],
                    exports: [ScrollSpyDirective]
                }]
        }] });

class ThemeService {
    constructor() {
        this.themeChange = new EventEmitter();
        this.themeAdvanceChange = new EventEmitter();
        this.theme = {};
        this.advancedTheme = {};
    }
    getTheme() {
        return this.theme;
    }
    getAdvancedTheme() {
        return this.advancedTheme;
    }
    registerTheme(theme) {
        this.theme = theme;
        this.themeChange.emit(theme);
    }
    registerAdvancedTheme(advancedTheme) {
        this.advancedTheme = advancedTheme;
        this.themeAdvanceChange.emit(advancedTheme);
    }
}
ThemeService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: ThemeService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
ThemeService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: ThemeService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: ThemeService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return []; } });

const globalTokens = {
    // Color
    inherit: "inherit",
    transparent: "transparent",
    hal_white: "#ffffff",
    hal_grey_l_95: "#f2f2f2",
    hal_grey_l_90: "#e6e6e6",
    hal_grey_l_80: "#cccccc",
    hal_grey_l_75: "#bfbfbf",
    hal_grey_l_60: "#999999",
    hal_grey_s_40: "#666666",
    color_grey_800: "#4d4d4d",
    hal_black: "#000000",
    darkWhite: "#eeeeee",
    lightGrey: "#D9D9D9",
    softGrey: "#cecece",
    lighterGrey: "#F8F8F8",
    lighterBlack: "#b1b1b1",
    mediumBlack: "#676767",
    mediumGreyBlack: "#dbdbdb",
    softBlack: "#565656",
    hal_purple_l_95: "#f2eafa",
    hal_purple_l_90: "#e5d5f6",
    hal_purple_l_65: "#a46ede",
    hal_purple_s_38: "#5f249f",
    hal_purple_d_30: "#4b1c7d",
    hal_purple_d_20: "#321353",
    color_purple_300: "#cbacec",
    purple: "#6f2c91",
    mediumPurple: "#ead8f3",
    lighterPurple: "#d0bddb",
    lightPurple: "#f5ebf9",
    violet: "#8800F6",
    hal_blue_l_95: "#e6f4ff",
    hal_blue_l_80: "#99d5ff",
    hal_blue_l_50: "#0095ff",
    hal_blue_l_45: "#0086e6",
    hal_blue_s_35: "#0067b3",
    hal_blue_d_20: "#003c66",
    color_blue_200: "#cceaff",
    blue: "#005FCC",
    darkBlue: "#006BF6",
    softBlue: "#b1cee6",
    mediumWhite: "#f9f9f9",
    lightBlue: "#CEE0F5",
    hal_red_l_95: "#ffe6e9",
    hal_red_l_80: "#fe9aa7",
    hal_red_l_60: "#fe344f",
    hal_red_s_41: "#d0011b",
    hal_red_d_30: "#980115",
    hal_red_d_20: "#65010e",
    hal_green_l_95: "#eafaef",
    hal_green_l_80: "#acecbe",
    hal_green_s_39: "#24a148",
    hal_green_d_30: "#1c7d38",
    hal_green_d_20: "#135325",
    lightGreen: "#DBF1C4",
    hal_yellow_l_95: "#fef9e6",
    hal_yellow_l_80: "#fbe89d",
    hal_yellow_s_57: "#f7cf2b",
    hal_yellow_d_40: "#c59f07",
    hal_yellow_d_30: "#947705",
    lightYellow: "#FCF2BD",
    hal_orange_s_54: "#f38f20",
    lightPink: "#F9CFCF",
    color_grey_50: "#fafafa",
    color_grey_600: "#808080",
    color_red_600: "#fe0123",
    color_red_400: "#fe677b",
    // Typography
    type_sans: "Open Sans, sans-serif",
    type_scale_root: "16px",
    type_scale_08: "3.75rem",
    type_scale_07: "2.5rem",
    type_scale_06: "2rem",
    type_scale_05: "1.5rem",
    type_scale_04: "1.25rem",
    type_scale_03: "1rem",
    type_scale_02: "0.875rem",
    type_scale_01: "0.75rem",
    type_light: "300",
    type_regular: "400",
    type_semibold: "600",
    type_bold: "bold",
    type_italic: "italic",
    type_normal: "normal",
    type_spacing_tight_02: "-0.05em",
    type_spacing_tight_01: "-0.025em",
    type_spacing_normal: "0",
    type_spacing_wide_01: "0.025em",
    type_spacing_wide_02: "0.05em",
    type_spacing_wide_03: "0.1em",
    type_initial: "initial",
    type_uppercase: "uppercase",
    type_no_line: "none",
    type_underline: "underline",
    type_line_through: "line-through",
    type_leading_compact_03: "1em",
    type_leading_compact_02: "1.25em",
    type_leading_compact_01: "1.365em",
    type_leading_normal: "1.5em",
    type_leading_loose_01: "1.715em",
    type_leading_loose_02: "2em",
    // Spacing
    spacing_00: "0rem",
    spacing_01: "0.125rem",
    spacing_02: "0.25rem",
    spacing_03: "0.5rem",
    spacing_04: "0.75rem",
    spacing_05: "1rem",
    spacing_06: "1.5rem",
    spacing_07: "2rem",
    spacing_08: "2.5rem",
    spacing_09: "3rem",
    spacing_10: "3.5rem",
    spacing_11: "4rem",
    spacing_12: "5rem",
    spacing_13: "6rem",
    spacing_14: "7rem",
    // Border
    // Border
    border_width_0: "0px",
    border_width_1: "1px",
    border_width_2: "2px",
    border_width_4: "4px",
    border_radius_none: "0rem",
    border_radius_small: "0.125rem",
    border_radius_medium: "0.25rem",
    border_radius_large: "0.375rem",
    border_radius_full: "9999px",
    border_solid: "solid",
    border_dashed: "dashed",
    border_none: "none",
};
const componentTokens = {
    "--accordion-backgroundColor": globalTokens.hal_white,
    "--accordion-arrowColor": globalTokens.hal_purple_s_38,
    "--accordion-hoverBackgroundColor": globalTokens.hal_purple_l_95,
    "--accordion-titleLabelFontFamily": globalTokens.type_sans,
    "--accordion-titleLabelFontSize": globalTokens.type_scale_03,
    "--accordion-titleLabelFontWeight": globalTokens.type_regular,
    "--accordion-titleLabelFontStyle": globalTokens.type_normal,
    "--accordion-titleLabelFontColor": globalTokens.hal_black,
    "--accordion-disabledTitleLabelFontColor": globalTokens.hal_grey_l_60,
    "--accordion-titleLabelPaddingLeft": "0px",
    "--accordion-titleLabelPaddingRight": "16px",
    "--accordion-titleLabelPaddingTop": "0px",
    "--accordion-titleLabelPaddingBottom": "0px",
    "--accordion-assistiveTextFontFamily": globalTokens.type_sans,
    "--accordion-assistiveTextFontSize": globalTokens.type_scale_03,
    "--accordion-assistiveTextFontWeight": globalTokens.type_light,
    "--accordion-assistiveTextFontStyle": globalTokens.type_italic,
    "--accordion-assistiveTextFontColor": globalTokens.hal_grey_s_40,
    "--accordion-assistiveTextLetterSpacing": globalTokens.type_spacing_wide_01,
    "--accordion-assistiveTextMinWidth": "100px",
    "--accordion-assistiveTextPaddingLeft": "0px",
    "--accordion-assistiveTextPaddingRight": "24px",
    "--accordion-iconSize": "24px",
    "--accordion-iconColor": globalTokens.hal_purple_s_38,
    "--accordion-disabledIconColor": globalTokens.hal_grey_l_60,
    "--accordion-iconMarginLeft": "0px",
    "--accordion-iconMarginRight": "12px",
    "--accordion-borderRadius": "4px",
    "--accordion-boxShadowOffsetX": "0px",
    "--accordion-boxShadowOffsetY": "6px",
    "--accordion-boxShadowBlur": "10px",
    "--accordion-boxShadowColor": "#00000024",
    "--accordion-accordionGroupSeparatorBorderColor": "#00000024",
    "--accordion-accordionGroupSeparatorBorderThickness": "1px",
    "--accordion-accordionGroupSeparatorBorderStyle": globalTokens.border_solid,
    "--accordion-disabledBackgroundColor": globalTokens.transparent,
    "--accordion-disabledArrowColor": globalTokens.hal_grey_l_60,
    "--accordion-disabledAssistiveTextFontColor": globalTokens.hal_grey_l_60,
    "--accordion-focusBorderStyle": "auto",
    "--accordion-focusBorderThickness": "1px",
    "--accordion-focusBorderOffset": "-1px",
    "--accordion-focusBorderColor": globalTokens.hal_purple_s_38,
    //ALERT
    "--alert-titlePaddingTop": "0px",
    "--alert-titlePaddingBottom": "0px",
    "--alert-inlineTextPaddingTop": "0px",
    "--alert-inlineTextPaddingBottom": "0px",
    "--alert-iconPaddingTop": "0px",
    "--alert-iconPaddingBottom": "0px",
    "--alert-boxShadowOffsetX": "0px",
    "--alert-boxShadowOffsetY": "3px",
    "--alert-boxShadowBlur": "6px",
    "--alert-boxShadowColor": "#00000012",
    "--alert-titleFontFamily": globalTokens.type_sans,
    "--alert-titleFontColor": globalTokens.hal_black,
    "--alert-titleFontSize": globalTokens.type_scale_01,
    "--alert-titleFontStyle": globalTokens.type_normal,
    "--alert-titleFontWeight": globalTokens.type_bold,
    "--alert-titleTextTransform": globalTokens.type_uppercase,
    "--alert-titlePaddingRight": "0px",
    "--alert-titlePaddingLeft": "0px",
    "--alert-inlineTextFontFamily": globalTokens.type_sans,
    "--alert-inlineTextFontColor": globalTokens.hal_black,
    "--alert-inlineTextFontSize": globalTokens.type_scale_01,
    "--alert-inlineTextFontStyle": globalTokens.type_normal,
    "--alert-inlineTextFontWeight": globalTokens.type_regular,
    "--alert-inlineTextPaddingLeft": "0px",
    "--alert-inlineTextPaddingRight": "0px",
    "--alert-contentPaddingLeft": "0px",
    "--alert-contentPaddingRight": "0px",
    "--alert-contentPaddingTop": "20px",
    "--alert-contentPaddingBottom": "30px",
    "--alert-borderRadius": "4px",
    "--alert-borderStyle": globalTokens.border_solid,
    "--alert-borderThickness": "1px",
    "--alert-infoBorderColor": globalTokens.hal_blue_s_35,
    "--alert-successBorderColor": globalTokens.hal_green_s_39,
    "--alert-warningBorderColor": globalTokens.hal_yellow_d_40,
    "--alert-errorBorderColor": globalTokens.hal_red_s_41,
    "--alert-iconSize": "24px",
    "--alert-iconPaddingLeft": "0px",
    "--alert-iconPaddingRight": "0px",
    "--alert-infoIconColor": globalTokens.hal_blue_s_35,
    "--alert-successIconColor": globalTokens.hal_green_s_39,
    "--alert-warningIconColor": globalTokens.hal_yellow_d_40,
    "--alert-errorIconColor": globalTokens.hal_red_s_41,
    "--alert-infoBackgroundColor": globalTokens.hal_blue_l_95,
    "--alert-successBackgroundColor": globalTokens.hal_green_l_95,
    "--alert-warningBackgroundColor": globalTokens.hal_yellow_l_95,
    "--alert-errorBackgroundColor": globalTokens.hal_red_l_95,
    "--alert-overlayColor": "#000000B3",
    "--alert-hoverActionBackgroundColor": "#0000000D",
    "--alert-focusActionBorderColor": globalTokens.hal_blue_l_50,
    "--alert-activeActionBackgroundColor": "#0000001A",
    //BOX
    "--box-backgroundColor": globalTokens.hal_white,
    "--box-letterSpacing": globalTokens.type_spacing_wide_01,
    "--box-borderRadius": "4px",
    "--box-borderThickness": "0px",
    "--box-borderColor": globalTokens.transparent,
    "--box-borderStyle": globalTokens.type_no_line,
    "--box-noneShadowDepthShadowOffsetX": "none",
    "--box-noneShadowDepthShadowOffsetY": "none",
    "--box-noneShadowDepthShadowBlur": "none",
    "--box-noneShadowDepthShadowSpread": "none",
    "--box-noneShadowDepthShadowColor": globalTokens.transparent,
    "--box-oneShadowDepthShadowOffsetX": "0px",
    "--box-oneShadowDepthShadowOffsetY": "3px",
    "--box-oneShadowDepthShadowBlur": "6px",
    "--box-oneShadowDepthShadowSpread": "0px",
    "--box-oneShadowDepthShadowColor": "#00000033",
    "--box-twoShadowDepthShadowOffsetX": "0px",
    "--box-twoShadowDepthShadowOffsetY": "3px",
    "--box-twoShadowDepthShadowBlur": "10px",
    "--box-twoShadowDepthShadowSpread": "0px",
    "--box-twoShadowDepthShadowColor": "#00000033",
    //BUTTON
    "--button-labelFontLineHeight": "1.5em",
    "--button-labelLetterSpacing": "0.025em",
    "--button-paddingLeft": globalTokens.spacing_03,
    "--button-paddingRight": globalTokens.spacing_03,
    "--button-paddingTop": globalTokens.spacing_03,
    "--button-paddingBottom": globalTokens.spacing_03,
    "--button-focusBorderColor": globalTokens.hal_blue_l_50,
    "--button-focusBorderColorOnDark": globalTokens.hal_blue_l_50,
    "--button-primaryBackgroundColor": globalTokens.hal_purple_s_38,
    "--button-primaryBackgroundColorOnDark": globalTokens.hal_purple_s_38,
    "--button-primaryFontColor": globalTokens.hal_white,
    "--button-primaryFontColorOnDark": globalTokens.hal_white,
    "--button-primaryHoverBackgroundColor": globalTokens.hal_purple_d_30,
    "--button-primaryHoverBackgroundColorOnDark": "#7D2FD0",
    "--button-primaryActiveBackgroundColor": globalTokens.hal_purple_d_20,
    "--button-primaryActiveBackgroundColorOnDark": globalTokens.hal_purple_d_30,
    "--button-primaryDisabledBackgroundColor": globalTokens.hal_grey_l_95,
    "--button-primaryDisabledBackgroundColorOnDark": "#4d4d4d",
    "--button-primaryDisabledFontColor": globalTokens.hal_grey_l_60,
    "--button-primaryDisabledFontColorOnDark": globalTokens.hal_grey_l_60,
    "--button-primaryBorderThickness": "0px",
    "--button-primaryBorderStyle": "none",
    "--button-primaryBorderRadius": "4px",
    "--button-primaryFontFamily": globalTokens.type_sans,
    "--button-primaryFontSize": globalTokens.type_scale_03,
    "--button-primaryFontWeight": globalTokens.type_regular,
    "--button-secondaryBackgroundColor": globalTokens.transparent,
    "--button-secondaryBackgroundColorOnDark": globalTokens.transparent,
    "--button-secondaryFontColor": globalTokens.hal_purple_s_38,
    "--button-secondaryFontColorOnDark": globalTokens.hal_white,
    "--button-secondaryHoverFontColor": globalTokens.hal_white,
    "--button-secondaryHoverFontColorOnDark": globalTokens.hal_black,
    "--button-secondaryBorderColor": globalTokens.hal_purple_s_38,
    "--button-secondaryBorderColorOnDark": globalTokens.hal_white,
    "--button-secondaryHoverBackgroundColor": globalTokens.hal_purple_s_38,
    "--button-secondaryHoverBackgroundColorOnDark": globalTokens.hal_white,
    "--button-secondaryActiveBackgroundColor": globalTokens.hal_purple_d_20,
    "--button-secondaryActiveBackgroundColorOnDark": "#e6e6e6",
    "--button-secondaryDisabledBackgroundColor": globalTokens.transparent,
    "--button-secondaryDisabledBackgroundColorOnDark": globalTokens.transparent,
    "--button-secondaryDisabledFontColor": "#b1b1b1",
    "--button-secondaryDisabledFontColorOnDark": globalTokens.hal_grey_l_60,
    "--button-secondaryDisabledBorderColor": globalTokens.hal_grey_l_60,
    "--button-secondaryDisabledBorderColorOnDark": globalTokens.hal_grey_l_60,
    "--button-secondaryBorderThickness": "1px",
    "--button-secondaryBorderStyle": globalTokens.border_solid,
    "--button-secondaryBorderRadius": "4px",
    "--button-secondaryFontFamily": globalTokens.type_sans,
    "--button-secondaryFontSize": globalTokens.type_scale_03,
    "--button-secondaryFontWeight": globalTokens.type_regular,
    "--button-textBackgroundColor": globalTokens.transparent,
    "--button-textBackgroundColorOnDark": globalTokens.transparent,
    "--button-textFontColor": globalTokens.hal_purple_s_38,
    "--button-textFontColorOnDark": globalTokens.hal_white,
    "--button-textHoverBackgroundColor": globalTokens.hal_purple_l_95,
    "--button-textHoverBackgroundColorOnDark": "#4d4d4d",
    "--button-textActiveBackgroundColor": globalTokens.hal_purple_l_90,
    "--button-textActiveBackgroundColorOnDark": globalTokens.hal_grey_s_40,
    "--button-textDisabledBackgroundColor": globalTokens.transparent,
    "--button-textDisabledBackgroundColorOnDark": globalTokens.transparent,
    "--button-textDisabledFontColor": globalTokens.hal_grey_l_60,
    "--button-textDisabledFontColorOnDark": globalTokens.hal_grey_l_60,
    "--button-textBorderThickness": "0px",
    "--button-textBorderStyle": "none",
    "--button-textBorderRadius": "4px",
    "--button-textFontFamily": globalTokens.type_sans,
    "--button-textFontSize": globalTokens.type_scale_03,
    "--button-textFontWeight": globalTokens.type_regular,
    //CARD
    "--card-height": "220px",
    "--card-width": "400px",
    //CHECKBOX
    "--checkbox-selectedBackgroundColor": globalTokens.hal_blue_s_35,
    "--checkbox-selectedBackgroundColorOnDark": globalTokens.hal_grey_l_90,
    "--checkbox-selectedHoverBackgroundColor": globalTokens.hal_blue_d_20,
    "--checkbox-selectedHoverBackgroundColorOnDark": globalTokens.hal_white,
    "--checkbox-selectedDisabledBackgroundColor": globalTokens.hal_grey_l_60,
    "--checkbox-selectedDisabledBackgroundColorOnDark": globalTokens.color_grey_800,
    "--checkbox-borderColor": globalTokens.hal_blue_s_35,
    "--checkbox-borderColorOnDark": globalTokens.hal_grey_l_90,
    "--checkbox-hoverBorderColor": globalTokens.hal_blue_d_20,
    "--checkbox-hoverBorderColorOnDark": globalTokens.hal_white,
    "--checkbox-disabledBorderColor": globalTokens.hal_grey_l_60,
    "--checkbox-disabledBorderColorOnDark": globalTokens.color_grey_800,
    "--checkbox-checkColor": globalTokens.hal_white,
    "--checkbox-checkColorOnDark": globalTokens.hal_black,
    "--checkbox-disabledCheckColor": globalTokens.hal_white,
    "--checkbox-disabledCheckColorOnDark": globalTokens.hal_grey_l_60,
    "--checkbox-fontFamily": globalTokens.type_sans,
    "--checkbox-fontSize": globalTokens.type_scale_02,
    "--checkbox-fontWeight": globalTokens.type_regular,
    "--checkbox-fontColor": globalTokens.hal_black,
    "--checkbox-fontColorOnDark": globalTokens.hal_white,
    "--checkbox-disabledFontColor": globalTokens.hal_grey_l_60,
    "--checkbox-disabledFontColorOnDark": globalTokens.hal_grey_l_60,
    "--checkbox-focusColor": globalTokens.hal_blue_l_50,
    "--checkbox-focusColorOnDark": globalTokens.hal_blue_l_50,
    "--checkbox-checkLabelSpacing": "0.5rem",
    //CHIP
    "--chip-backgroundColor": globalTokens.hal_grey_l_90,
    "--chip-disabledBackgroundColor": globalTokens.hal_grey_l_95,
    "--chip-fontFamily": globalTokens.type_sans,
    "--chip-fontSize": globalTokens.type_scale_03,
    "--chip-fontStyle": globalTokens.type_normal,
    "--chip-fontWeight": globalTokens.type_regular,
    "--chip-fontColor": globalTokens.hal_black,
    "--chip-disabledFontColor": globalTokens.hal_grey_l_60,
    "--chip-borderColor": globalTokens.transparent,
    "--chip-borderRadius": "80px",
    "--chip-borderThickness": "0px",
    "--chip-borderStyle": "solid",
    "--chip-contentPaddingLeft": "16px",
    "--chip-contentPaddingRight": "16px",
    "--chip-contentPaddingTop": "0px",
    "--chip-contentPaddingBottom": "0px",
    "--chip-iconSize": "24px",
    "--chip-iconSpacing": "8px",
    "--chip-iconColor": globalTokens.hal_black,
    "--chip-disabledIconColor": globalTokens.hal_grey_l_60,
    "--chip-focusColor": globalTokens.hal_blue_s_35,
    //DATE
    "--date-pickerSelectedDateBackgroundColor": globalTokens.hal_purple_s_38,
    "--date-pickerSelectedDateColor": globalTokens.hal_white,
    "--date-pickerBackgroundColor": globalTokens.hal_white,
    "--date-pickerActualDateColor": globalTokens.lightGrey,
    "--date-pickerFontColor": globalTokens.hal_black,
    "--date-pickerHoverDateFontColor": globalTokens.hal_black,
    "--date-pickerHoverDateBackgroundColor": globalTokens.lighterPurple,
    "--date-focusColor": globalTokens.hal_blue_l_50,
    "--date-pickerYearColor": globalTokens.hal_black,
    "--date-pickerMonthColor": globalTokens.hal_black,
    "--date-pickerWeekLabelColor": globalTokens.hal_black,
    "--date-pickerBackgroundColorMonthArrows": globalTokens.transparent,
    "--date-fontFamily": globalTokens.type_sans,
    "--date-pickerHeight": "316px",
    "--date-pickerWidth": "290px",
    //NEW DATE
    "--dateInput-pickerSelectedDateBackgroundColor": globalTokens.hal_purple_s_38,
    "--dateInput-pickerSelectedDateColor": globalTokens.hal_white,
    "--dateInput-pickerBackgroundColor": globalTokens.hal_white,
    "--dateInput-pickerActualDateColor": globalTokens.lightGrey,
    "--dateInput-pickerFontColor": globalTokens.hal_black,
    "--dateInput-pickerHoverDateFontColor": globalTokens.hal_black,
    "--dateInput-pickerHoverDateBackgroundColor": globalTokens.lighterPurple,
    "--dateInput-focusColor": globalTokens.hal_blue_l_50,
    "--dateInput-pickerYearColor": globalTokens.hal_black,
    "--dateInput-pickerMonthColor": globalTokens.lighterBlack,
    "--dateInput-pickerWeekLabelColor": globalTokens.lighterBlack,
    "--dateInput-pickerBackgroundColorMonthArrows": globalTokens.transparent,
    "--dateInput-fontFamily": globalTokens.type_sans,
    "--dateInput-pickerHeight": "300px",
    "--dateInput-pickerWidth": "290px",
    //DIALOG
    "--dialog-overlayColor": globalTokens.hal_black,
    "--dialog-overlayOpacity": "0.7",
    "--dialog-backgroundColor": globalTokens.hal_white,
    "--dialog-closeIconWidth": "24px",
    "--dialog-closeIconHeight": "24px",
    "--dialog-closeIconTopPosition": "20px",
    "--dialog-closeIconRightPosition": "20px",
    "--dialog-closeIconBackgroundColor": "none",
    "--dialog-closeIconColor": globalTokens.hal_black,
    "--dialog-closeIconBorderColor": globalTokens.type_no_line,
    "--dialog-closeIconBorderThickness": "0px",
    "--dialog-closeIconBorderStyle": globalTokens.border_solid,
    "--dialog-closeIconBorderRadius": "0px",
    "--dialog-boxShadowOffsetX": "0px",
    "--dialog-boxShadowOffsetY": "1px",
    "--dialog-boxShadowBlur": "3px",
    "--dialog-boxShadowColor": "rgba(0, 0, 0, 0.2)",
    //DROPDOWN
    "--dropdown-buttonBackgroundColor": globalTokens.hal_white,
    "--dropdown-hoverButtonBackgroundColor": globalTokens.hal_grey_l_95,
    "--dropdown-activeButtonBackgroundColor": globalTokens.lightGrey,
    "--dropdown-buttonFontFamily": globalTokens.type_sans,
    "--dropdown-buttonFontSize": globalTokens.type_scale_03,
    "--dropdown-buttonFontStyle": globalTokens.type_normal,
    "--dropdown-buttonFontWeight": globalTokens.type_regular,
    "--dropdown-buttonFontColor": globalTokens.hal_black,
    "--dropdown-buttonIconSize": "20px",
    "--dropdown-buttonIconSpacing": "10px",
    "--dropdown-buttonIconColor": globalTokens.hal_black,
    "--dropdown-buttonPaddingTop": "0px",
    "--dropdown-buttonPaddingBottom": "0px",
    "--dropdown-buttonPaddingLeft": "16px",
    "--dropdown-buttonPaddingRight": "16px",
    "--dropdown-disabledColor": globalTokens.lighterBlack,
    "--dropdown-disabledButtonBackgroundColor": globalTokens.transparent,
    "--dropdown-disabledBorderColor": globalTokens.lighterBlack,
    "--dropdown-optionBackgroundColor": globalTokens.hal_white,
    "--dropdown-hoverOptionBackgroundColor": globalTokens.hal_grey_l_95,
    "--dropdown-activeOptionBackgroundColor": globalTokens.lightGrey,
    "--dropdown-optionFontFamily": globalTokens.type_sans,
    "--dropdown-optionFontSize": globalTokens.type_scale_root,
    "--dropdown-optionFontStyle": globalTokens.type_normal,
    "--dropdown-optionFontWeight": globalTokens.type_regular,
    "--dropdown-optionFontColor": globalTokens.hal_black,
    "--dropdown-optionIconSize": "20px",
    "--dropdown-optionIconSpacing": "10px",
    "--dropdown-optionIconColor": globalTokens.hal_black,
    "--dropdown-optionPaddingTop": "6px",
    "--dropdown-optionPaddingBottom": "6px",
    "--dropdown-optionPaddingLeft": "16px",
    "--dropdown-optionPaddingRight": "16px",
    "--dropdown-caretIconSize": "24px",
    "--dropdown-caretIconColor": globalTokens.hal_black,
    "--dropdown-caretIconSpacing": "12px",
    "--dropdown-borderRadius": "4px",
    "--dropdown-borderStyle": "none",
    "--dropdown-borderThickness": "0px",
    "--dropdown-borderColor": globalTokens.transparent,
    "--dropdown-scrollBarThumbColor": globalTokens.hal_grey_s_40,
    "--dropdown-scrollBarTrackColor": globalTokens.lightGrey,
    "--dropdown-focusColor": globalTokens.hal_blue_l_50,
    //FILE INPUT
    "--fileInput-dropBorderColor": globalTokens.hal_black,
    "--fileInput-fileItemBorderColor": globalTokens.hal_grey_l_80,
    "--fileInput-deleteFileItemIconColor": globalTokens.hal_black,
    "--fileInput-fileNameFontColor": globalTokens.hal_black,
    "--fileInput-labelFontColor": globalTokens.hal_black,
    "--fileInput-helperTextFontColor": globalTokens.hal_black,
    "--fileInput-dropLabelFontColor": globalTokens.hal_black,
    "--fileInput-filePreviewBackgroundColor": globalTokens.hal_grey_l_95,
    "--fileInput-filePreviewIconColor": globalTokens.hal_black,
    "--fileInput-errorFilePreviewBackgroundColor": "#ffccd3",
    "--fileInput-errorFilePreviewIconColor": globalTokens.hal_red_s_41,
    "--fileInput-disabledLabelFontColor": globalTokens.hal_grey_l_60,
    "--fileInput-disabledHelperTextFontColor": globalTokens.hal_grey_l_60,
    "--fileInput-disabledDropLabelFontColor": globalTokens.hal_grey_l_60,
    "--fileInput-focusDropBorderColor": globalTokens.hal_blue_l_50,
    "--fileInput-disabledDropBorderColor": globalTokens.hal_grey_l_60,
    "--fileInput-dragoverDropBackgroundColor": "#f5fbff",
    "--fileInput-hoverDeleteFileItemBackgroundColor": "#0000000d",
    "--fileInput-activeDeleteFileItemBackgroundColor": "#00000033",
    "--fileInput-focusDeleteFileItemBackgroundColor": globalTokens.hal_blue_l_50,
    "--fileInput-errorFileItemBorderColor": globalTokens.hal_red_s_41,
    "--fileInput-errorFileItemBackgroundColor": "#FFF5F6",
    "--fileInput-errorMessageFontColor": globalTokens.hal_red_s_41,
    "--fileInput-labelFontFamily": globalTokens.type_sans,
    "--fileInput-labelFontSize": globalTokens.type_scale_02,
    "--fileInput-labelFontWeight": globalTokens.type_semibold,
    "--fileInput-labelLineHeight": globalTokens.type_leading_loose_01,
    "--fileInput-fileItemFontFamily": globalTokens.type_sans,
    "--fileInput-fileItemFontSize": globalTokens.type_scale_02,
    "--fileInput-fileItemFontWeight": globalTokens.type_regular,
    "--fileInput-fileItemLineHeight": globalTokens.type_leading_normal,
    "--fileInput-helperTextFontFamily": globalTokens.type_sans,
    "--fileInput-helperTextFontSize": globalTokens.type_scale_01,
    "--fileInput-helperTextFontWeight": globalTokens.type_regular,
    "--fileInput-helperTextLineHeight": globalTokens.type_leading_normal,
    "--fileInput-dropLabelFontFamily": globalTokens.type_sans,
    "--fileInput-dropLabelFontSize": globalTokens.type_scale_03,
    "--fileInput-dropLabelFontWeight": globalTokens.type_regular,
    "--fileInput-errorMessageFontFamily": globalTokens.type_sans,
    "--fileInput-errorMessageFontSize": globalTokens.type_scale_01,
    "--fileInput-errorMessageFontWeight": globalTokens.type_regular,
    "--fileInput-errorMessageLineHeight": globalTokens.type_leading_normal,
    "--fileInput-dropBorderStyle": "dashed",
    "--fileInput-dropBorderThickness": "1px",
    "--fileInput-dropBorderRadius": "6px",
    "--fileInput-fileItemBorderStyle": "solid",
    "--fileInput-fileItemBorderThickness": "1px",
    "--fileInput-fileItemBorderRadius": "4px",
    //FOOTER
    "--footer-height": "124px",
    "--footer-backgroundColor": globalTokens.hal_black,
    "--footer-bottomLinksDividerColor": globalTokens.hal_blue_l_50,
    "--footer-bottomLinksDividerThickness": "1px",
    "--footer-bottomLinksDividerStyle": "solid",
    "--footer-bottomLinksDividerSpacing": "8px",
    "--footer-bottomLinksFontFamily": globalTokens.type_sans,
    "--footer-bottomLinksFontSize": globalTokens.type_scale_01,
    "--footer-bottomLinksFontStyle": globalTokens.type_normal,
    "--footer-bottomLinksFontWeight": globalTokens.type_regular,
    "--footer-bottomLinksFontColor": globalTokens.hal_white,
    "--footer-bottomLinksTextDecoration": globalTokens.type_no_line,
    "--footer-copyrightFontFamily": globalTokens.type_sans,
    "--footer-copyrightFontSize": globalTokens.type_scale_01,
    "--footer-copyrightFontStyle": globalTokens.type_normal,
    "--footer-copyrightFontWeight": globalTokens.type_regular,
    "--footer-copyrightFontColor": globalTokens.hal_white,
    "--footer-logo": "assets/dxc-logo-wh.svg",
    "--footer-logoHeight": "32px",
    "--footer-logoWidth": "auto",
    "--footer-socialLinksSize": "24px",
    "--footer-socialLinksGutter": "16px",
    "--footer-socialLinksColor": globalTokens.hal_white,
    //HEADER
    "--header-backgroundColor": globalTokens.hal_white,
    "--header-hamburguerFocusColor": globalTokens.blue,
    "--header-hamburguerFontFamily": globalTokens.type_sans,
    "--header-hamburguerFontStyle": globalTokens.type_normal,
    "--header-hamburguerFontColor": globalTokens.hal_black,
    "--header-hamburguerFontSize": "10px",
    "--header-hamburguerFontWeight": globalTokens.type_semibold,
    "--header-hamburguerIconColor": globalTokens.hal_black,
    "--header-hamburguerHoverColor": globalTokens.mediumGreyBlack,
    "--header-hamburguerTextTransform": globalTokens.type_uppercase,
    "--header-logoHeight": "40px",
    "--header-logoWidth": "auto",
    "--header-menuBackgroundColor": globalTokens.hal_white,
    "--header-menuZindex": "2000",
    "--header-menuTabletWidth": "60vw",
    "--header-menuMobileWidth": "100vw",
    "--header-minHeight": "64px",
    "--header-overlayColor": globalTokens.softBlack,
    "--header-overlayOpacity": "0.7",
    "--header-overlayZindex": "1600",
    "--header-paddingTop": "0px",
    "--header-paddingBottom": "0px",
    "--header-paddingRight": "24px",
    "--header-paddingLeft": "24px",
    "--header-underlinedColor": globalTokens.hal_black,
    "--header-underlinedThickness": "2px",
    "--header-underlinedStyle": "solid",
    //HEADING
    "--heading-level1FontColor": globalTokens.hal_black,
    "--heading-level1FontFamily": globalTokens.type_sans,
    "--heading-level1FontSize": globalTokens.type_scale_07,
    "--heading-level1FontStyle": globalTokens.type_normal,
    "--heading-level1FontWeight": globalTokens.type_semibold,
    "--heading-level1LineHeight": globalTokens.type_leading_compact_01,
    "--heading-level1LetterSpacing": globalTokens.type_spacing_tight_01,
    "--heading-level2FontColor": globalTokens.hal_black,
    "--heading-level2FontFamily": globalTokens.type_sans,
    "--heading-level2FontSize": globalTokens.type_scale_05,
    "--heading-level2FontStyle": globalTokens.type_normal,
    "--heading-level2FontWeight": globalTokens.type_semibold,
    "--heading-level2LineHeight": globalTokens.type_leading_normal,
    "--heading-level2LetterSpacing": globalTokens.type_spacing_normal,
    "--heading-level3FontColor": globalTokens.hal_black,
    "--heading-level3FontFamily": globalTokens.type_sans,
    "--heading-level3FontSize": globalTokens.type_scale_04,
    "--heading-level3FontStyle": globalTokens.type_semibold,
    "--heading-level3FontWeight": globalTokens.type_regular,
    "--heading-level3LineHeight": globalTokens.type_leading_compact_01,
    "--heading-level3LetterSpacing": globalTokens.type_spacing_wide_01,
    "--heading-level4FontColor": globalTokens.hal_black,
    "--heading-level4FontFamily": globalTokens.type_sans,
    "--heading-level4FontSize": globalTokens.type_scale_03,
    "--heading-level4FontStyle": globalTokens.type_normal,
    "--heading-level4FontWeight": globalTokens.type_semibold,
    "--heading-level4LineHeight": globalTokens.type_scale_05,
    "--heading-level4LetterSpacing": globalTokens.type_spacing_normal,
    "--heading-level5FontColor": globalTokens.hal_black,
    "--heading-level5FontFamily": globalTokens.type_sans,
    "--heading-level5FontSize": globalTokens.type_scale_02,
    "--heading-level5FontStyle": globalTokens.type_normal,
    "--heading-level5FontWeight": globalTokens.type_semibold,
    "--heading-level5LineHeight": globalTokens.type_leading_normal,
    "--heading-level5LetterSpacing": globalTokens.type_spacing_wide_01,
    //INPUT TEXT
    "--inputText-fontFamily": globalTokens.type_sans,
    "--inputText-assistiveTextFontColor": globalTokens.hal_black,
    "--inputText-assistiveTextFontColorOnDark": globalTokens.hal_white,
    "--inputText-assistiveTextFontSize": globalTokens.type_scale_01,
    "--inputText-assistiveTextFontStyle": globalTokens.type_normal,
    "--inputText-assistiveTextFontWeight": globalTokens.type_regular,
    "--inputText-disabledColor": globalTokens.lighterBlack,
    "--inputText-disabledColorOnDark": "#575757",
    "--inputText-errorColor": globalTokens.hal_red_s_41,
    "--inputText-errorColorOnDark": globalTokens.hal_red_l_60,
    "--inputText-optionBackgroundColor": globalTokens.hal_white,
    "--inputText-optionBorderColor": globalTokens.hal_black,
    "--inputText-optionBorderThickness": "0px",
    "--inputText-optionBorderStyle": "solid",
    "--inputText-optionFontColor": globalTokens.hal_black,
    "--inputText-optionFontColorOnDark": globalTokens.hal_white,
    "--inputText-optionFontSize": globalTokens.type_scale_03,
    "--inputText-optionFontStyle": globalTokens.type_normal,
    "--inputText-optionFontWeight": globalTokens.type_regular,
    "--inputText-optionPaddingBottom": "6px",
    "--inputText-optionPaddingTop": "6px",
    "--inputText-hoverOptionColor": globalTokens.hal_black,
    "--inputText-hoverOptionBackgroundColor": globalTokens.lightGrey,
    "--inputText-hoverOptionBackgroundColorOnDark": globalTokens.hal_grey_l_75,
    "--inputText-scrollBarThumbColor": globalTokens.hal_grey_s_40,
    "--inputText-scrollBarTrackColor": globalTokens.lightGrey,
    "--inputText-selectedOptionBackgroundColor": globalTokens.lightGrey,
    "--inputText-selectedOptionBackgroundColorOnDark": globalTokens.lightGrey,
    "--inputText-labelFontColor": globalTokens.hal_black,
    "--inputText-labelFontColorOnDark": globalTokens.hal_white,
    "--inputText-labelFontSize": globalTokens.type_scale_03,
    "--inputText-labelFontStyle": globalTokens.type_normal,
    "--inputText-labelFontWeight": globalTokens.type_regular,
    "--inputText-valueFontColor": globalTokens.hal_black,
    "--inputText-valueFontColorOnDark": globalTokens.hal_white,
    "--inputText-valueFontSize": globalTokens.type_scale_03,
    "--inputText-valueFontStyle": globalTokens.type_normal,
    "--inputText-valueFontWeight": globalTokens.type_regular,
    "--inputText-prefixIconColor": globalTokens.hal_black,
    "--inputText-prefixIconColorOnDark": globalTokens.hal_white,
    "--inputText-prefixLabelFontColor": globalTokens.hal_black,
    "--inputText-prefixLabelFontColorOnDark": globalTokens.hal_white,
    "--inputText-prefixLabelFontSize": globalTokens.type_scale_03,
    "--inputText-prefixLabelFontStyle": globalTokens.type_normal,
    "--inputText-prefixLabelFontWeight": globalTokens.type_regular,
    "--inputText-suffixIconColor": globalTokens.hal_black,
    "--inputText-suffixIconColorOnDark": globalTokens.hal_white,
    "--inputText-suffixLabelFontColor": globalTokens.hal_black,
    "--inputText-suffixLabelFontColorOnDark": globalTokens.hal_white,
    "--inputText-suffixLabelFontSize": globalTokens.type_scale_03,
    "--inputText-suffixLabelFontStyle": globalTokens.type_normal,
    "--inputText-suffixLabelFontWeight": globalTokens.type_regular,
    "--inputText-underlineColor": globalTokens.hal_black,
    "--inputText-underlineColorOnDark": globalTokens.hal_white,
    "--inputText-underlineFocusColor": globalTokens.hal_black,
    "--inputText-underlineFocusColorOnDark": globalTokens.hal_white,
    "--inputText-underlineThickness": "1px",
    // NEW TEXT INPUT
    "--textInput-disabledBorderColor": globalTokens.hal_grey_l_60,
    "--textInput-disabledBorderColorOnDark": globalTokens.hal_grey_l_60,
    "--textInput-disabledContainerFillColor": globalTokens.hal_grey_l_95,
    "--textInput-disabledContainerFillColorOnDark": globalTokens.hal_grey_s_40,
    "--textInput-disabledLabelFontColor": globalTokens.hal_grey_l_60,
    "--textInput-disabledLabelFontColorOnDark": globalTokens.hal_grey_l_60,
    "--textInput-disabledValueFontColor": globalTokens.hal_grey_l_60,
    "--textInput-disabledValueFontColorOnDark": globalTokens.hal_grey_l_60,
    "--textInput-disabledSuffixColor": globalTokens.hal_grey_l_75,
    "--textInput-disabledSuffixColorOnDark": globalTokens.hal_grey_s_40,
    "--textInput-disabledHelperTextFontColor": globalTokens.hal_grey_l_60,
    "--textInput-disabledHelperTextFontColorOnDark": globalTokens.hal_grey_l_60,
    "--textInput-disabledPlaceholderFontColor": globalTokens.hal_grey_l_60,
    "--textInput-disabledPlaceholderFontColorOnDark": globalTokens.hal_grey_l_60,
    "--textInput-disabledPrefixColor": globalTokens.hal_grey_l_75,
    "--textInput-disabledPrefixColorOnDark": globalTokens.hal_grey_s_40,
    "--textInput-disabledActionIconColor": globalTokens.hal_grey_l_60,
    "--textInput-disabledActionIconColorOnDark": globalTokens.hal_grey_s_40,
    "--textInput-disabledActionBackgroundColor": globalTokens.transparent,
    "--textInput-disabledActionBackgroundColorOnDark": globalTokens.transparent,
    "--textInput-hoverActionIconColor": globalTokens.hal_black,
    "--textInput-hoverActionIconColorOnDark": globalTokens.hal_white,
    "--textInput-focusActionIconColor": globalTokens.hal_black,
    "--textInput-focusActionIconColorOnDark": globalTokens.hal_white,
    "--textInput-activeActionIconColor": globalTokens.hal_black,
    "--textInput-activeActionIconColorOnDark": globalTokens.hal_black,
    "--textInput-fontFamily": globalTokens.type_sans,
    "--textInput-labelFontColor": globalTokens.hal_black,
    "--textInput-labelFontColorOnDark": globalTokens.hal_white,
    "--textInput-labelFontSize": globalTokens.type_scale_02,
    "--textInput-labelFontStyle": globalTokens.type_normal,
    "--textInput-labelFontWeight": globalTokens.type_semibold,
    "--textInput-labelLineHeight": globalTokens.type_leading_loose_01,
    "--textInput-optionalLabelFontWeight": globalTokens.type_regular,
    "--textInput-helperTextFontColor": globalTokens.hal_black,
    "--textInput-helperTextFontColorOnDark": globalTokens.hal_white,
    "--textInput-helperTextFontSize": globalTokens.type_scale_01,
    "--textInput-helperTextFontStyle": globalTokens.type_normal,
    "--textInput-helperTextFontWeight": globalTokens.type_regular,
    "--textInput-helperTextLineHeight": globalTokens.type_leading_normal,
    "--textInput-enabledBorderColor": globalTokens.hal_black,
    "--textInput-enabledBorderColorOnDark": globalTokens.hal_white,
    "--textInput-hoverBorderColor": globalTokens.hal_purple_l_65,
    "--textInput-hoverBorderColorOnDark": globalTokens.hal_purple_l_65,
    "--textInput-focusBorderColor": globalTokens.hal_blue_l_50,
    "--textInput-focusBorderColorOnDark": globalTokens.hal_blue_l_50,
    "--textInput-placeholderFontColor": globalTokens.color_grey_600,
    "--textInput-placeholderFontColorOnDark": globalTokens.hal_grey_l_95,
    "--textInput-valueFontColor": globalTokens.hal_black,
    "--textInput-valueFontColorOnDark": globalTokens.hal_white,
    "--textInput-valueFontSize": globalTokens.type_scale_03,
    "--textInput-valueFontStyle": globalTokens.type_normal,
    "--textInput-valueFontWeight": globalTokens.type_regular,
    "--textInput-actionIconColor": globalTokens.hal_black,
    "--textInput-actionIconColorOnDark": globalTokens.hal_white,
    "--textInput-actionBackgroundColor": globalTokens.transparent,
    "--textInput-actionBackgroundColorOnDark": globalTokens.transparent,
    "--textInput-hoverActionBackgroundColor": globalTokens.hal_grey_l_95,
    "--textInput-focusActionBorderColor": globalTokens.hal_blue_l_50,
    "--textInput-activeActionBackgroundColor": globalTokens.hal_grey_l_80,
    "--textInput-hoverActionBackgroundColorOnDark": globalTokens.hal_grey_s_40,
    "--textInput-focusActionBorderColorOnDark": globalTokens.hal_blue_l_50,
    "--textInput-activeActionBackgroundColorOnDark": globalTokens.hal_grey_l_60,
    "--textInput-prefixColor": globalTokens.hal_grey_s_40,
    "--textInput-prefixColorOnDark": globalTokens.hal_white,
    "--textInput-prefixFontSize": globalTokens.type_scale_03,
    "--textInput-prefixFontStyle": globalTokens.type_normal,
    "--textInput-prefixFontWeight": globalTokens.type_regular,
    "--textInput-suffixColor": globalTokens.hal_grey_s_40,
    "--textInput-suffixColorOnDark": globalTokens.hal_white,
    "--textInput-suffixFontSize": globalTokens.type_scale_03,
    "--textInput-suffixFontStyle": globalTokens.type_normal,
    "--textInput-suffixFontWeight": globalTokens.type_regular,
    "--textInput-errorBorderColor": globalTokens.hal_red_s_41,
    "--textInput-errorBorderColorOnDark": globalTokens.hal_red_l_60,
    "--textInput-errorMessageColor": globalTokens.hal_red_s_41,
    "--textInput-errorMessageColorOnDark": globalTokens.hal_red_l_60,
    "--textInput-errorIconColor": globalTokens.hal_red_s_41,
    "--textInput-errorIconColorOnDark": globalTokens.hal_red_l_60,
    "--textInput-hoverErrorBorderColor": globalTokens.color_red_600,
    "--textInput-hoverErrorBorderColorOnDark": globalTokens.color_red_400,
    "--textInput-errorFontSize": globalTokens.type_scale_01,
    "--textInput-errorFontStyle": globalTokens.type_normal,
    "--textInput-errorFontWeight": globalTokens.type_regular,
    "--textInput-listOptionFontColor": globalTokens.hal_black,
    "--textInput-listOptionFontFamily": globalTokens.type_sans,
    "--textInput-listOptionFontSize": globalTokens.type_scale_03,
    "--textInput-listOptionFontWeight": globalTokens.type_regular,
    "--textInput-listOptionTypedFontWeight": globalTokens.type_bold,
    "--textInput-systemMessageFontColor": globalTokens.hal_grey_s_40,
    "--textInput-systemMessageFontFamily": globalTokens.type_sans,
    "--textInput-systemMessageFontSize": globalTokens.type_scale_02,
    "--textInput-systemMessageFontWeight": globalTokens.type_regular,
    "--textInput-errorMessageFontFamily": globalTokens.type_sans,
    "--textInput-errorMessageFontSize": globalTokens.type_scale_01,
    "--textInput-errorMessageFontWeight": globalTokens.type_regular,
    "--textInput-errorMessageBorderColor": globalTokens.hal_red_s_41,
    "--textInput-errorMessageBackgroundColor": globalTokens.hal_red_l_95,
    "--textInput-hoverListOptionBackgroundColor": globalTokens.hal_grey_l_95,
    "--textInput-activeListOptionBackgroundColor": globalTokens.hal_grey_l_80,
    "--textInput-inputMarginTop": globalTokens.spacing_02,
    "--textInput-inputMarginBottom": globalTokens.spacing_02,
    "--textInput-scrollBarThumbColor": globalTokens.hal_grey_s_40,
    "--textInput-scrollBarTrackColor": globalTokens.lightGrey,
    "--textInput-selectedOptionBackgroundColor": globalTokens.lightGrey,
    // NEW TEXTAREA
    "--textarea-disabledBorderColor": globalTokens.color_grey_600,
    "--textarea-disabledBorderColorOnDark": globalTokens.hal_grey_l_60,
    "--textarea-disabledContainerFillColor": globalTokens.hal_grey_l_95,
    "--textarea-disabledContainerFillColorOnDark": globalTokens.hal_grey_s_40,
    "--textarea-disabledLabelFontColor": globalTokens.hal_grey_l_60,
    "--textarea-disabledLabelFontColorOnDark": globalTokens.hal_grey_l_60,
    "--textarea-disabledValueFontColor": globalTokens.hal_grey_l_60,
    "--textarea-disabledValueFontColorOnDark": globalTokens.hal_grey_l_60,
    "--textarea-disabledHelperTextFontColor": globalTokens.hal_grey_l_60,
    "--textarea-disabledHelperTextFontColorOnDark": globalTokens.hal_grey_l_60,
    "--textarea-disabledPlaceholderFontColor": globalTokens.hal_grey_l_60,
    "--textarea-disabledPlaceholderFontColorOnDark": globalTokens.hal_grey_l_60,
    "--textarea-fontFamily": globalTokens.type_sans,
    "--textarea-labelFontColor": globalTokens.hal_black,
    "--textarea-labelFontColorOnDark": globalTokens.hal_white,
    "--textarea-labelFontSize": globalTokens.type_scale_02,
    "--textarea-labelFontStyle": globalTokens.type_normal,
    "--textarea-labelFontWeight": globalTokens.type_semibold,
    "--textarea-labelLineHeight": globalTokens.type_leading_loose_01,
    "--textarea-optionalLabelFontWeight": globalTokens.type_regular,
    "--textarea-helperTextFontColor": globalTokens.hal_black,
    "--textarea-helperTextFontColorOnDark": globalTokens.hal_white,
    "--textarea-helperTextFontSize": globalTokens.type_scale_01,
    "--textarea-helperTextFontStyle": globalTokens.type_normal,
    "--textarea-helperTextFontWeight": globalTokens.type_regular,
    "--textarea-helperTextLineHeight": globalTokens.type_leading_normal,
    "--textarea-enabledBorderColor": globalTokens.hal_black,
    "--textarea-enabledBorderColorOnDark": globalTokens.hal_white,
    "--textarea-hoverBorderColor": globalTokens.hal_purple_l_65,
    "--textarea-hoverBorderColorOnDark": globalTokens.hal_purple_l_65,
    "--textarea-focusBorderColor": globalTokens.hal_blue_l_50,
    "--textarea-focusBorderColorOnDark": globalTokens.hal_blue_l_50,
    "--textarea-placeholderFontColor": globalTokens.color_grey_600,
    "--textarea-placeholderFontColorOnDark": globalTokens.hal_grey_l_95,
    "--textarea-valueFontColor": globalTokens.hal_black,
    "--textarea-valueFontColorOnDark": globalTokens.hal_white,
    "--textarea-valueFontSize": globalTokens.type_scale_03,
    "--textarea-valueFontStyle": globalTokens.type_normal,
    "--textarea-valueFontWeight": globalTokens.type_regular,
    "--textarea-errorBorderColor": globalTokens.hal_red_s_41,
    "--textarea-errorBorderColorOnDark": globalTokens.hal_red_l_60,
    "--textarea-errorMessageColor": globalTokens.hal_red_s_41,
    "--textarea-errorMessageColorOnDark": globalTokens.hal_red_l_60,
    "--textarea-hoverErrorBorderColor": globalTokens.color_red_600,
    "--textarea-hoverErrorBorderColorOnDark": globalTokens.color_red_400,
    "--textarea-errorFontSize": globalTokens.type_scale_01,
    "--textarea-errorFontStyle": globalTokens.type_normal,
    "--textarea-errorFontWeight": globalTokens.type_regular,
    "--textarea-systemMessageFontColor": globalTokens.hal_grey_s_40,
    "--textarea-systemMessageFontFamily": globalTokens.type_sans,
    "--textarea-systemMessageFontSize": globalTokens.type_scale_02,
    "--textarea-systemMessageFontWeight": globalTokens.type_regular,
    "--textarea-errorMessageFontFamily": globalTokens.type_sans,
    "--textarea-errorMessageFontSize": globalTokens.type_scale_02,
    "--textarea-errorMessageFontWeight": globalTokens.type_regular,
    "--textarea-errorMessageBorderColor": globalTokens.hal_red_s_41,
    "--textarea-errorMessageBackgroundColor": globalTokens.hal_red_l_95,
    //LINK
    "--link-fontColor": globalTokens.blue,
    "--link-visitedFontColor": globalTokens.violet,
    "--link-disabledColor": globalTokens.lightGrey,
    "--link-hoverFontColor": globalTokens.darkBlue,
    "--link-underlinedBackgroundColor": globalTokens.blue,
    "--link-fontFamily": globalTokens.inherit,
    "--link-fontSize": "16px",
    "--link-fontStyle": globalTokens.type_normal,
    "--link-fontWeight": globalTokens.type_regular,
    "--link-iconSize": "16px",
    "--link-iconSpacing": "4px",
    "--link-underlineSpacing": "1px",
    "--link-underlineStyle": "solid",
    "--link-underlineThickness": "1px",
    "--link-hoverUnderlineColor": globalTokens.hal_blue_s_35,
    "--link-visitedUnderlineColor": globalTokens.hal_purple_s_38,
    "--link-activeFontColor": globalTokens.hal_black,
    "--link-activeUnderlineColor": globalTokens.hal_black,
    "--link-focusColor": globalTokens.hal_blue_l_50,
    //PAGINATOR
    "--paginator-backgroundColor": globalTokens.darkWhite,
    "--paginator-fontColor": globalTokens.hal_black,
    "--paginator-fontFamily": globalTokens.type_sans,
    "--paginator-fontSize": globalTokens.type_scale_02,
    "--paginator-fontStyle": globalTokens.type_normal,
    "--paginator-fontWeight": globalTokens.type_regular,
    "--paginator-fontTextTransform": "none",
    "--paginator-height": "64px",
    "--paginator-width": "100%",
    "--paginator-marginRight": "40px",
    "--paginator-marginLeft": "20px",
    "--paginator-itemsPerPageSelectorMarginLeft": "0px",
    "--paginator-itemsPerPageSelectorMarginRight": "30px",
    "--paginator-pageSelectorMarginRight": "30px",
    "--paginator-pageSelectorMarginLeft": "0px",
    "--paginator-totalItemsContainerMarginRight": "30px",
    "--paginator-totalItemsContainerMarginLeft": "0px",
    //PROGRESSBAR
    "--progressBar-trackLineColor": globalTokens.hal_purple_s_38,
    "--progressBar-trackLineColorOnDark": globalTokens.hal_purple_l_65,
    "--progressBar-totalLineColor": globalTokens.softGrey,
    "--progressBar-labelFontFamily": globalTokens.type_sans,
    "--progressBar-labelFontSize": globalTokens.type_scale_01,
    "--progressBar-labelFontStyle": globalTokens.type_normal,
    "--progressBar-labelFontWeight": globalTokens.type_regular,
    "--progressBar-labelFontColor": globalTokens.hal_black,
    "--progressBar-labelFontColorOnDark": globalTokens.hal_white,
    "--progressBar-labelFontTextTransform": globalTokens.type_uppercase,
    "--progressBar-valueFontFamily": globalTokens.type_sans,
    "--progressBar-valueFontSize": globalTokens.type_scale_01,
    "--progressBar-valueFontStyle": globalTokens.type_normal,
    "--progressBar-valueFontWeight": globalTokens.type_regular,
    "--progressBar-valueFontColor": globalTokens.hal_black,
    "--progressBar-valueFontColorOnDark": globalTokens.hal_white,
    "--progressBar-valueFontTextTransform": globalTokens.type_uppercase,
    "--progressBar-helperTextFontColor": globalTokens.hal_black,
    "--progressBar-helperTextFontColorOnDark": globalTokens.hal_white,
    "--progressBar-helperTextFontSize": globalTokens.type_scale_01,
    "--progressBar-helperTextFontStyle": globalTokens.type_normal,
    "--progressBar-helperTextFontWeight": globalTokens.type_regular,
    "--progressBar-helperTextFontFamily": globalTokens.type_sans,
    "--progressBar-thickness": "9px",
    "--progressBar-borderRadius": "5px",
    "--progressBar-overlayColor": globalTokens.hal_black,
    "--progressBar-overlayOpacity": "0.8",
    //RADIO
    "--radio-color": globalTokens.hal_black,
    "--radio-disabledColor": globalTokens.lighterBlack,
    "--radio-fontColor": globalTokens.hal_black,
    "--radio-disabledFontColor": globalTokens.lighterBlack,
    "--radio-focusColor": globalTokens.hal_blue_l_50,
    "--radio-circleLabelSpacing": "8px",
    "--radio-circleSize": "20px",
    "--radio-colorOnDark": globalTokens.hal_white,
    "--radio-disabledColorOnDark": "#575757",
    "--radio-disabledFontColorOnDark": "#575757",
    "--radio-focusColorOnDark": "#1682FF",
    "--radio-fontColorOnDark": globalTokens.hal_white,
    "--radio-fontFamily": globalTokens.type_sans,
    "--radio-fontSize": globalTokens.type_scale_root,
    "--radio-fontStyle": globalTokens.type_normal,
    "--radio-fontWeight": globalTokens.type_regular,
    //RADIO GROUP
    "--radioGroup-radioInputColor": globalTokens.hal_blue_l_45,
    "--radioGroup-hoverRadioInputColor": globalTokens.hal_blue_s_35,
    "--radioGroup-focusRadioInputColor": globalTokens.hal_blue_l_50,
    "--radioGroup-activeRadioInputColor": globalTokens.hal_blue_d_20,
    "--radioGroup-errorRadioInputColor": globalTokens.hal_red_s_41,
    "--radioGroup-hoverErrorRadioInputColor": globalTokens.hal_red_d_30,
    "--radioGroup-activeErrorRadioInputColor": globalTokens.hal_red_d_20,
    "--radioGroup-disabledRadioInputColor": globalTokens.hal_grey_l_60,
    "--radioGroup-readonlyRadioInputColor": globalTokens.hal_grey_l_60,
    "--radioGroup-hoverReadonlyRadioInputColor": globalTokens.color_grey_600,
    "--radioGroup-activeReadonlyRadioInputColor": globalTokens.hal_grey_s_40,
    "--radioGroup-labelFontColor": globalTokens.hal_black,
    "--radioGroup-disabledLabelFontColor": globalTokens.hal_grey_l_60,
    "--radioGroup-helperTextFontColor": globalTokens.hal_black,
    "--radioGroup-disabledHelperTextFontColor": globalTokens.hal_grey_l_60,
    "--radioGroup-radioInputLabelFontColor": globalTokens.hal_black,
    "--radioGroup-disabledRadioInputLabelFontColor": globalTokens.hal_grey_l_60,
    "--radioGroup-errorMessageColor": globalTokens.hal_red_s_41,
    "--radioGroup-labelFontFamily": globalTokens.type_sans,
    "--radioGroup-labelFontSize": globalTokens.type_scale_02,
    "--radioGroup-labelFontWeight": globalTokens.type_semibold,
    "--radioGroup-labelLineHeight": globalTokens.type_leading_loose_01,
    "--radioGroup-labelFontStyle": globalTokens.type_normal,
    "--radioGroup-helperTextFontFamily": globalTokens.type_sans,
    "--radioGroup-helperTextFontSize": globalTokens.type_scale_01,
    "--radioGroup-helperTextFontWeight": globalTokens.type_regular,
    "--radioGroup-helperTextFontStyle": globalTokens.hal_grey_l_60,
    "--radioGroup-helperTextLineHeight": globalTokens.type_leading_normal,
    "--radioGroup-radioInputLabelFontFamily": globalTokens.type_sans,
    "--radioGroup-radioInputLabelFontSize": globalTokens.type_scale_02,
    "--radioGroup-radioInputLabelFontWeight": globalTokens.type_regular,
    "--radioGroup-radioInputLabelFontStyle": globalTokens.type_normal,
    "--radioGroup-errorMessageFontSize": globalTokens.type_scale_01,
    "--radioGroup-errorMessageFontWeight": globalTokens.type_regular,
    "--radioGroup-errorMessageLineHeight": globalTokens.type_leading_normal,
    "--radioGroup-radioInputBorderWidth": globalTokens.border_width_2,
    "--radioGroup-radioInputBorderStyle": globalTokens.border_solid,
    "--radioGroup-focusBorderWidth": globalTokens.border_width_2,
    "--radioGroup-focusBorderStyle": globalTokens.border_solid,
    "--radioGroup-groupLabelMargin": globalTokens.spacing_03,
    "--radioGroup-radioInputLabelMargin": globalTokens.spacing_03,
    "--radioGroup-groupVerticalGutter": globalTokens.spacing_02,
    "--radioGroup-groupHorizontalGutter": globalTokens.spacing_07,
    // "--radioGroup-radioInputwidth": "18px",
    // "--radioGroup-focusOutlineWidth": "24px",
    // "--radioGroup-radioInputHeight": "18px",
    // "--radioGroup-focusOutlineHeight": "24px",
    //SELECT
    "--select-fontFamily": globalTokens.type_sans,
    "--select-enabledInputBorderColor": globalTokens.hal_black,
    "--select-hoverInputBorderColor": globalTokens.hal_purple_l_65,
    "--select-focusInputBorderColor": globalTokens.hal_blue_l_50,
    "--select-errorInputBorderColor": globalTokens.hal_red_s_41,
    "--select-hoverInputErrorBorderColor": globalTokens.color_red_600,
    "--select-disabledInputBorderColor": globalTokens.hal_grey_l_60,
    "--select-disabledInputBackgroundColor": globalTokens.hal_grey_l_95,
    "--select-labelFontSize": globalTokens.type_scale_02,
    "--select-labelFontStyle": globalTokens.type_normal,
    "--select-labelFontWeight": globalTokens.type_semibold,
    "--select-labelLineHeight": globalTokens.type_leading_loose_01,
    "--select-labelFontColor": globalTokens.hal_black,
    "--select-valueFontSize": globalTokens.type_scale_03,
    "--select-valueFontStyle": globalTokens.type_normal,
    "--select-valueFontWeight": globalTokens.type_regular,
    "--select-valueFontColor": globalTokens.hal_black,
    "--select-valueIconColor": globalTokens.hal_black,
    "--select-valueLineHeight": globalTokens.type_leading_normal,
    "--select-placeholderFontSize": globalTokens.type_scale_03,
    "--select-placeholderFontStyle": globalTokens.type_normal,
    "--select-placeholderFontWeight": globalTokens.type_regular,
    "--select-placeholderFontColor": "#000000b3",
    "--select-helperTextFontSize": globalTokens.type_scale_01,
    "--select-helperTextFontStyle": globalTokens.type_normal,
    "--select-helperTextFontWeight": globalTokens.type_regular,
    "--select-helperTextLineHeight": globalTokens.type_leading_normal,
    "--select-helperTextFontColor": globalTokens.hal_black,
    "--select-optionalLabelFontWeight": globalTokens.type_regular,
    "--select-errorMessageFontSize": globalTokens.type_scale_01,
    "--select-errorMessagetFontStyle": globalTokens.type_normal,
    "--select-errorMessageFontWeight": globalTokens.type_regular,
    "--select-errorMessagetLineHeight": globalTokens.type_leading_normal,
    "--select-errorMessageColor": globalTokens.hal_red_s_41,
    "--select-errorIconColor": globalTokens.hal_red_s_41,
    "--select-selectionIndicatorFontColor": globalTokens.hal_black,
    "--select-selectionIndicatorBorderColor": globalTokens.hal_grey_l_75,
    "--select-selectionIndicatorBackgroundColor": globalTokens.color_grey_50,
    "--select-enabledSelectionIndicatorActionBackgroundColor": globalTokens.transparent,
    "--select-hoverSelectionIndicatorActionBackgroundColor": globalTokens.hal_grey_l_95,
    "--select-activeSelectionIndicatorActionBackgroundColor": globalTokens.hal_grey_l_80,
    "--select-enabledSelectionIndicatorActionIconColor": globalTokens.hal_black,
    "--select-hoverSelectionIndicatorActionIconColor": globalTokens.hal_black,
    "--select-activeSelectionIndicatorActionIconColor": globalTokens.hal_black,
    "--select-actionBackgroundColor": globalTokens.transparent,
    "--select-hoverActionBackgroundColor": globalTokens.hal_grey_l_95,
    "--select-activeActionBackgroundColor": globalTokens.hal_grey_l_80,
    "--select-actionIconColor": globalTokens.hal_black,
    "--select-hoverActionIconColor": globalTokens.hal_black,
    "--select-activeActionIconColor": globalTokens.hal_black,
    "--select-disabledColor": globalTokens.hal_grey_l_60,
    "--select-listDialogBackgroundColor": globalTokens.hal_white,
    "--select-listDialogBorderColor": globalTokens.hal_grey_l_75,
    "--select-listOptionFontSize": globalTokens.type_scale_02,
    "--select-listOptionFontStyle": globalTokens.type_normal,
    "--select-listOptionFontWeight": globalTokens.type_regular,
    "--select-listOptionFontColor": globalTokens.hal_black,
    "--select-listOptionIconColor": globalTokens.hal_black,
    "--select-listOptionDividerColor": globalTokens.hal_grey_l_90,
    "--select-listGroupLabelFontWeight": globalTokens.type_semibold,
    "--select-unselectedHoverListOptionBackgroundColor": globalTokens.hal_grey_l_95,
    "--select-unselectedActiveListOptionBackgroundColor": globalTokens.hal_grey_l_90,
    "--select-selectedListOptionBackgroundColor": globalTokens.hal_blue_l_95,
    "--select-selectedHoverListOptionBackgroundColor": globalTokens.color_blue_200,
    "--select-selectedActiveListOptionBackgroundColor": globalTokens.hal_blue_l_80,
    "--select-selectedListOptionIconColor": globalTokens.hal_blue_d_20,
    "--select-optionBorderThickness": "0px",
    "--select-optionBorderStyle": globalTokens.border_solid,
    "--select-optionFontColor": globalTokens.hal_black,
    "--select-optionFontSize": globalTokens.type_scale_root,
    "--select-optionFontStyle": globalTokens.type_normal,
    "--select-optionFontWeight": globalTokens.type_regular,
    "--select-optionIconSpacing": "12px",
    "--select-optionIconColor": globalTokens.hal_black,
    "--select-optionIconSize": "20px",
    "--select-selectedOptionBackgroundColor": globalTokens.lightGrey,
    "--select-hoverOptionBackgroundColor": globalTokens.hal_grey_l_95,
    "--select-optionPaddingBottom": "6px",
    "--select-optionPaddingTop": "6px",
    "--select-optionPaddingLeft": "16px",
    "--select-optionPaddingRight": "16px",
    "--select-optionCheckboxSpacing": "12px",
    "--select-systemMessageFontColor": globalTokens.hal_grey_s_40,
    "--select-required": globalTokens.hal_red_s_41,
    "--select-focusColor": globalTokens.hal_blue_l_50,
    "--select-focusListOptionBorderColor": globalTokens.hal_blue_l_50,
    "--select-scrollBarThumbColor": globalTokens.hal_grey_s_40,
    "--select-scrollBarTrackColor": globalTokens.lightGrey,
    "--select-underlineColor": globalTokens.hal_black,
    "--select-underlineColorOnDark": globalTokens.hal_white,
    "--select-underlineFocusColor": globalTokens.hal_black,
    "--select-underlineFocusColorOnDark": globalTokens.hal_white,
    "--select-underlineThickness": "1px",
    "--select-arrowColor": globalTokens.hal_black,
    "--select-arrowColorOnDark": globalTokens.hal_white,
    "--select-collapseIndicatorColor": globalTokens.hal_black,
    //SIDENAV
    "--sidenav-backgroundColor": globalTokens.lighterGrey,
    "--sidenav-arrowContainerColor": globalTokens.lightGrey,
    "--sidenav-arrowColor": globalTokens.hal_black,
    "--sidenav-titleFontFamily": globalTokens.type_sans,
    "--sidenav-titleFontSize": globalTokens.type_scale_05,
    "--sidenav-titleFontStyle": globalTokens.type_normal,
    "--sidenav-titleFontWeight": globalTokens.type_regular,
    "--sidenav-titleFontColor": "#000000de",
    "--sidenav-titleFontTextTransform": globalTokens.type_no_line,
    "--sidenav-titleFontLetterSpacing": globalTokens.type_spacing_normal,
    "--sidenav-subtitleFontFamily": globalTokens.type_sans,
    "--sidenav-subtitleFontSize": globalTokens.type_scale_01,
    "--sidenav-subtitleFontStyle": globalTokens.type_normal,
    "--sidenav-subtitleFontWeight": globalTokens.type_regular,
    "--sidenav-subtitleFontColor": "#00000099",
    "--sidenav-subtitleFontTextTransform": globalTokens.type_uppercase,
    "--sidenav-subtitleFontLetterSpacing": globalTokens.type_spacing_wide_03,
    "--sidenav-linkFontFamily": globalTokens.type_sans,
    "--sidenav-linkFontSize": globalTokens.type_scale_02,
    "--sidenav-linkFontStyle": globalTokens.type_normal,
    "--sidenav-linkFontWeight": globalTokens.type_regular,
    "--sidenav-linkFontColor": "#00000099",
    "--sidenav-linkFontTextTransform": globalTokens.type_no_line,
    "--sidenav-linkFontLetterSpacing": globalTokens.type_spacing_wide_01,
    "--sidenav-linkTextDecoration": "none",
    "--sidenav-linkMarginTop": "6px",
    "--sidenav-linkMarginRight": "18px",
    "--sidenav-linkMarginBottom": "6px",
    "--sidenav-linkMarginLeft": "18px",
    "--sidenav-scrollBarThumbColor": "#66666626",
    "--sidenav-scrollBarTrackColor": globalTokens.transparent,
    //SLIDER
    "--slider-fontFamily": globalTokens.type_sans,
    "--slider-fontSize": globalTokens.type_scale_03,
    "--slider-fontStyle": globalTokens.type_normal,
    "--slider-fontWeight": globalTokens.type_regular,
    "--slider-labelFontFamily": globalTokens.type_sans,
    "--slider-labelFontSize": globalTokens.type_scale_02,
    "--slider-labelFontStyle": globalTokens.type_normal,
    "--slider-labelFontWeight": globalTokens.type_semibold,
    "--slider-labelLineHeight": globalTokens.type_leading_loose_01,
    "--slider-helperTextFontFamily": globalTokens.type_sans,
    "--slider-helperTextFontSize": globalTokens.type_scale_01,
    "--slider-helperTextFontStyle": globalTokens.type_normal,
    "--slider-helperTextFontWeight": globalTokens.type_regular,
    "--slider-helperTextLineHeight": globalTokens.type_leading_normal,
    "--slider-fontColor": globalTokens.hal_black,
    "--slider-fontColorOnDark": globalTokens.hal_white,
    "--slider-labelFontColor": globalTokens.hal_black,
    "--slider-helperTextFontColor": globalTokens.hal_black,
    "--slider-fontLetterSpacing": globalTokens.type_spacing_normal,
    "--slider-thumbHeight": "12px",
    "--slider-thumbWidth": "12px",
    "--slider-hoverThumbHeight": "14px",
    "--slider-hoverThumbWidth": "14px",
    "--slider-thumbVerticalPosition": "-6px",
    "--slider-thumbBackgroundColor": globalTokens.hal_blue_s_35,
    "--slider-thumbBackgroundColorOnDark": globalTokens.hal_blue_l_50,
    "--slider-activeThumbBackgroundColor": globalTokens.hal_blue_d_20,
    "--slider-activeThumbBackgroundColorOnDark": globalTokens.hal_blue_d_20,
    "--slider-hoverThumbBackgroundColor": globalTokens.hal_blue_d_20,
    "--slider-hoverThumbBackgroundColorOnDark": globalTokens.hal_blue_d_20,
    "--slider-focusThumbBackgroundColor": globalTokens.hal_blue_s_35,
    "--slider-focusThumbBackgroundColorOnDark": globalTokens.hal_blue_l_50,
    "--slider-tickSize": "4px",
    "--slider-tickVerticalPosition": "-1px",
    "--slider-tickBackgroundColor": globalTokens.hal_blue_s_35,
    "--slider-tickBackgroundColorOnDark": globalTokens.hal_blue_l_50,
    "--slider-lineThickness": "2px",
    "--slider-lineVerticalPosition": "0px",
    "--slider-trackLineColor": globalTokens.hal_blue_s_35,
    "--slider-trackLineColorOnDark": globalTokens.hal_blue_l_50,
    "--slider-totalLineColor": globalTokens.hal_grey_l_90,
    "--slider-totalLineColorOnDark": globalTokens.hal_grey_l_75,
    "--slider-disabledThumbVerticalPosition": "-6px",
    "--slider-disabledThumbBackgroundColor": globalTokens.hal_grey_l_75,
    "--slider-disabledThumbBackgroundColorOnDark": globalTokens.hal_grey_l_60,
    "--slider-disabledTickVerticalPosition": "-1px",
    "--slider-disabledTickBackgroundColor": globalTokens.hal_grey_l_75,
    "--slider-disabledTickBackgroundColorOnDark": globalTokens.hal_grey_l_60,
    "--slider-disabledTrackLineColor": globalTokens.hal_blue_l_95,
    "--slider-disabledTrackLineColorOnDark": globalTokens.hal_grey_l_60,
    "--slider-disabledTotalLineColor": globalTokens.hal_grey_l_95,
    "--slider-disabledTotalLineColorOnDark": globalTokens.hal_grey_s_40,
    "--slider-focusColor": globalTokens.hal_blue_s_35,
    "--slider-focusColorOnDark": globalTokens.hal_blue_l_50,
    "--slider-disabledFontColor": globalTokens.hal_grey_l_60,
    "--slider-floorLabelMarginRight": globalTokens.type_scale_03,
    "--slider-ceilLabelMarginLeft": globalTokens.type_scale_03,
    "--slider-inputMarginLeft": globalTokens.type_scale_06,
    //SPINNER
    "--spinner-trackCircleColor": globalTokens.hal_purple_s_38,
    "--spinner-trackCircleColorOnDark": globalTokens.hal_purple_l_65,
    "--spinner-totalCircleColor": globalTokens.hal_white,
    "--spinner-overlayBackgroundColor": globalTokens.hal_black,
    "--spinner-labelFontFamily": globalTokens.type_sans,
    "--spinner-labelFontSize": globalTokens.type_scale_02,
    "--spinner-labelFontStyle": globalTokens.type_normal,
    "--spinner-labelFontWeight": globalTokens.type_regular,
    "--spinner-labelFontColor": globalTokens.hal_black,
    "--spinner-labelTextAlign": "center",
    "--spinner-progressValueFontFamily": globalTokens.type_sans,
    "--spinner-progressValueFontSize": globalTokens.type_scale_02,
    "--spinner-progressValueFontStyle": globalTokens.type_normal,
    "--spinner-progressValueFontWeight": globalTokens.type_semibold,
    "--spinner-progressValueFontColor": globalTokens.hal_black,
    "--spinner-progressValueTextAlign": "center",
    "--spinner-overlayOpacity": "0.8",
    "--spinner-overlayLabelFontFamily": globalTokens.type_sans,
    "--spinner-overlayLabelFontSize": globalTokens.type_scale_02,
    "--spinner-overlayLabelFontStyle": globalTokens.type_normal,
    "--spinner-overlayLabelFontWeight": globalTokens.type_regular,
    "--spinner-overlayLabelFontColor": globalTokens.hal_white,
    "--spinner-overlayLabelTextAlign": "center",
    "--spinner-overlayProgressValueFontFamily": globalTokens.type_sans,
    "--spinner-overlayProgressValueFontSize": globalTokens.type_scale_01,
    "--spinner-overlayProgressValueFontStyle": globalTokens.type_normal,
    "--spinner-overlayProgressValueFontWeight": globalTokens.type_bold,
    "--spinner-overlayProgressValueFontColor": globalTokens.hal_white,
    "--spinner-overlayProgressValueTextAlign": "center",
    //SWITCH
    "--switch-requiredColor": globalTokens.hal_red_s_41,
    "--switch-checkedTrackBackgroundColor": globalTokens.hal_purple_s_38,
    "--switch-checkedTrackBackgroundColorOnDark": globalTokens.hal_purple_s_38,
    "--switch-checkedThumbBackgroundColor": globalTokens.hal_white,
    "--switch-checkedThumbBackgroundColorOnDark": globalTokens.hal_white,
    "--switch-uncheckedThumbBackgroundColor": globalTokens.hal_white,
    "--switch-uncheckedThumbBackgroundColorOnDark": globalTokens.hal_white,
    "--switch-uncheckedTrackBackgroundColor": globalTokens.lightGrey,
    "--switch-uncheckedTrackBackgroundColorOnDark": globalTokens.lightGrey,
    "--switch-disabledCheckedTrackBackgroundColor": globalTokens.lightPurple,
    "--switch-disabledCheckedTrackBackgroundColorOnDark": "#1c0b24",
    "--switch-disabledCheckedThumbBackgroundColor": globalTokens.hal_white,
    "--switch-disabledCheckedThumbBackgroundColorOnDark": globalTokens.hal_white,
    "--switch-disabledUncheckedTrackBackgroundColor": globalTokens.hal_grey_l_95,
    "--switch-disabledUncheckedTrackBackgroundColorOnDark": "#363636",
    "--switch-disabledUncheckedThumbBackgroundColor": globalTokens.hal_white,
    "--switch-disabledUncheckedThumbBackgroundColorOnDark": globalTokens.hal_white,
    "--switch-disabledLabelFontColor": globalTokens.lighterBlack,
    "--switch-disabledLabelFontColorOnDark": "#575757",
    "--switch-disabledLabelFontStyle": globalTokens.type_normal,
    "--switch-labelFontFamily": globalTokens.type_sans,
    "--switch-labelFontSize": globalTokens.type_scale_root,
    "--switch-labelFontStyle": globalTokens.type_normal,
    "--switch-labelFontWeight": globalTokens.type_regular,
    "--switch-labelFontColor": globalTokens.hal_black,
    "--switch-labelFontColorOnDark": globalTokens.hal_white,
    "--switch-thumbFocusColor": globalTokens.blue,
    "--switch-thumbFocusColorOnDark": "#1682FF",
    "--switch-thumbHeight": "24px",
    "--switch-thumbWidth": "24px",
    "--switch-thumbShift": "-2px",
    "--switch-trackHeight": "12px",
    "--switch-trackWidth": "60px",
    "--switch-spaceBetweenLabelSwitch": "0px",
    //TABLE
    "--table-rowSeparatorThickness": "1px",
    "--table-rowSeparatorStyle": "solid",
    "--table-rowSeparatorColor": globalTokens.lightGrey,
    "--table-dataBackgroundColor": globalTokens.hal_white,
    "--table-dataFontFamily": globalTokens.type_sans,
    "--table-dataFontSize": globalTokens.type_scale_02,
    "--table-dataFontStyle": globalTokens.type_normal,
    "--table-dataFontWeight": globalTokens.type_regular,
    "--table-dataFontColor": globalTokens.hal_black,
    "--table-dataFontTextTransform": "none",
    "--table-dataPaddingTop": "14px",
    "--table-dataPaddingBottom": "12px",
    "--table-dataPaddingRight": "20px",
    "--table-dataPaddingLeft": "40px",
    "--table-dataTextAlign": "left",
    "--table-dataTextLineHeight": "normal",
    "--table-headerBackgroundColor": globalTokens.hal_purple_s_38,
    "--table-headerBorderRadius": "4px",
    "--table-headerFontFamily": globalTokens.type_sans,
    "--table-headerFontSize": globalTokens.type_scale_02,
    "--table-headerFontStyle": globalTokens.type_normal,
    "--table-headerFontWeight": globalTokens.type_regular,
    "--table-headerFontColor": globalTokens.hal_white,
    "--table-headerFontTextTransform": "none",
    "--table-headerPaddingTop": "16px",
    "--table-headerPaddingBottom": "16px",
    "--table-headerPaddingRight": "20px",
    "--table-headerPaddingLeft": "40px",
    "--table-headerTextAlign": "left",
    "--table-headerTextLineHeight": "normal",
    "--table-scrollBarThumbColor": globalTokens.hal_grey_s_40,
    "--table-scrollBarTrackColor": globalTokens.lightGrey,
    "--table-sortIconColor": globalTokens.hal_white,
    //TABS
    "--tabs-fontFamily": globalTokens.type_sans,
    "--tabs-fontSize": globalTokens.type_scale_03,
    "--tabs-fontStyle": globalTokens.type_normal,
    "--tabs-fontWeight": globalTokens.type_semibold,
    "--tabs-fontTextTransform": "none",
    "--tabs-selectedBackgroundColor": globalTokens.hal_white,
    "--tabs-selectedFontColor": globalTokens.hal_purple_s_38,
    "--tabs-selectedIconColor": globalTokens.hal_purple_s_38,
    "--tabs-selectedUnderlineColor": globalTokens.hal_purple_s_38,
    "--tabs-selectedUnderlineThickness": "2px",
    "--tabs-unselectedBackgroundColor": globalTokens.hal_white,
    "--tabs-unselectedFontColor": globalTokens.hal_grey_s_40,
    "--tabs-unselectedIconColor": globalTokens.hal_grey_s_40,
    "--tabs-disabledFontColor": globalTokens.hal_grey_l_75,
    "--tabs-disabledIconColor": globalTokens.hal_grey_l_75,
    "--tabs-disabledFontStyle": globalTokens.type_normal,
    "--tabs-hoverBackgroundColor": globalTokens.lightPurple,
    "--tabs-pressedBackgroundColor": globalTokens.mediumPurple,
    "--tabs-pressedFontWeight": globalTokens.type_semibold,
    "--tabs-dividerColor": globalTokens.hal_grey_l_75,
    "--tabs-dividerThickness": "1px",
    "--tabs-focusOutline": globalTokens.hal_purple_s_38,
    "--tabs-scrollButtonsWidth": "48px",
    "--tabs-badgeBackgroundColor": globalTokens.hal_red_s_41,
    "--tabs-badgeFontFamily": globalTokens.type_sans,
    "--tabs-badgeFontSize": "10px",
    "--tabs-badgeFontStyle": globalTokens.type_normal,
    "--tabs-badgeFontWeight": "500",
    "--tabs-badgeFontColor": globalTokens.hal_white,
    "--tabs-badgeLetterSpacing": globalTokens.type_spacing_wide_02,
    "--tabs-badgeWidth": "16px",
    "--tabs-badgeHeight": "16px",
    "--tabs-badgeRadius": "10px",
    "--tabs-badgeWidthWithNotificationNumber": "23px",
    "--tabs-badgeHeightWithNotificationNumber": "17px",
    "--tabs-badgeRadiusWithNotificationNumber": "10px",
    //TAG
    "--tag-iconColor": globalTokens.hal_white,
    "--tag-fontFamily": globalTokens.type_sans,
    "--tag-fontStyle": globalTokens.type_normal,
    "--tag-fontColor": globalTokens.hal_black,
    "--tag-fontSize": globalTokens.type_scale_02,
    "--tag-fontWeight": globalTokens.type_regular,
    "--tag-height": "40px",
    "--tag-iconSectionWidth": "40px",
    "--tag-iconHeight": "24px",
    "--tag-iconWidth": "24px",
    "--tag-focusColor": "#0095ff",
    "--tag-labelPaddingTop": "0rem",
    "--tag-labelPaddingBottom": "0rem",
    "--tag-labelPaddingLeft": "1rem",
    "--tag-labelPaddingRight": "1rem",
    "--tag-disabledFontColor": globalTokens.hal_grey_l_60,
    //TOGGLE GROUP
    "--toggleGroup-containerBackgroundColor": globalTokens.color_grey_50,
    "--toggleGroup-containerBorderColor": globalTokens.hal_grey_l_60,
    "--toggleGroup-labelFontColor": globalTokens.hal_black,
    "--toggleGroup-disabledLabelFontColor": globalTokens.hal_grey_l_60,
    "--toggleGroup-helperTextFontColor": globalTokens.hal_black,
    "--toggleGroup-disabledHelperTextFontcolor": globalTokens.hal_grey_l_60,
    "--toggleGroup-unselectedBackgroundColor": globalTokens.hal_grey_l_90,
    "--toggleGroup-unselectedHoverBackgroundColor": globalTokens.hal_grey_l_80,
    "--toggleGroup-unselectedActiveBackgroundColor": globalTokens.hal_purple_s_38,
    "--toggleGroup-unselectedFontColor": globalTokens.hal_black,
    "--toggleGroup-unselectedDisabledBackgroundColor": globalTokens.hal_grey_l_95,
    "--toggleGroup-unselectedDisabledFontColor": globalTokens.hal_grey_l_60,
    "--toggleGroup-selectedBackgroundColor": globalTokens.hal_purple_s_38,
    "--toggleGroup-selectedHoverBackgroundColor": globalTokens.hal_purple_d_30,
    "--toggleGroup-selectedActiveBackgroundColor": globalTokens.hal_purple_d_20,
    "--toggleGroup-selectedDisabledBackgroundColor": globalTokens.hal_purple_l_95,
    "--toggleGroup-selectedFontColor": globalTokens.hal_white,
    "--toggleGroup-selectedDisabledFontColor": globalTokens.hal_purple_l_95,
    "--toggleGroup-focusColor": globalTokens.hal_blue_l_50,
    "--toggleGroup-labelFontFamily": globalTokens.type_sans,
    "--toggleGroup-labelFontSize": globalTokens.type_scale_02,
    "--toggleGroup-labelFontStyle": globalTokens.type_normal,
    "--toggleGroup-labelFontWeight": globalTokens.type_semibold,
    "--toggleGroup-labelLineHeight": globalTokens.type_leading_loose_01,
    "--toggleGroup-helperTextFontFamily": globalTokens.type_sans,
    "--toggleGroup-helperTextFontSize": globalTokens.type_scale_01,
    "--toggleGroup-helperTextFontStyle": globalTokens.type_normal,
    "--toggleGroup-helperTextFontWeight": globalTokens.type_regular,
    "--toggleGroup-helperTextLineHeight": globalTokens.type_leading_normal,
    "--toggleGroup-optionLabelFontFamily": globalTokens.type_sans,
    "--toggleGroup-optionLabelFontSize": globalTokens.type_scale_03,
    "--toggleGroup-optionLabelFontStyle": globalTokens.type_normal,
    "--toggleGroup-optionLabelFontWeight": globalTokens.type_regular,
    "--toggleGroup-iconPaddingRight": globalTokens.spacing_03,
    "--toggleGroup-iconPaddingLeft": globalTokens.spacing_03,
    "--toggleGroup-labelPaddingLeft": globalTokens.spacing_06,
    "--toggleGroup-labelPaddingRight": globalTokens.spacing_06,
    "--toggleGroup-iconMarginRight": globalTokens.spacing_03,
    "--toggleGroup-containerMarginTop": globalTokens.spacing_02,
    "--toggleGroup-optionBorderThickness": globalTokens.border_width_0,
    "--toggleGroup-optionBorderStyle": globalTokens.border_none,
    "--toggleGroup-optionBorderRadius": globalTokens.border_radius_medium,
    "--toggleGroup-containerBorderThickness": globalTokens.border_width_1,
    "--toggleGroup-containerBorderStyle": globalTokens.border_solid,
    "--toggleGroup-containerBorderRadius": globalTokens.border_radius_large,
    "--toggleGroup-optionFocusBorderThickness": globalTokens.border_width_2,
    "--toggleGroup-optionFocusBorderStyle": globalTokens.border_solid,
    "--toggleGroup-optionFocusBorderRadius": globalTokens.border_radius_medium,
    //UPLOAD
    "--upload-shadowColor": globalTokens.hal_grey_l_95,
    "--upload-hoverFileColor": globalTokens.darkWhite,
    "--upload-scrollBarThumbColor": globalTokens.hal_grey_s_40,
    "--upload-scrollBarTrackColor": globalTokens.lightGrey,
    "--upload-errorColor": globalTokens.hal_red_s_41,
    "--upload-backgroundColor": globalTokens.hal_white,
    "--upload-fontFamily": globalTokens.type_sans,
    "--upload-draggingStateBackgroundColor": globalTokens.hal_grey_l_95,
    "--upload-dragAndDropIconColor": globalTokens.hal_purple_s_38,
    "--upload-dragAndDropIconSize": "43.5px",
    "--upload-dragAndDropTitleFontSize": globalTokens.type_scale_04,
    "--upload-dragAndDropTitleFontStyle": globalTokens.type_normal,
    "--upload-dragAndDropTitleFontWeight": globalTokens.type_bold,
    "--upload-dragAndDropTitleFontTextTransform": "none",
    "--upload-dragAndDropTitleFontColor": globalTokens.hal_black,
    "--upload-dragAndDropDescriptionFontSize": globalTokens.type_scale_03,
    "--upload-dragAndDropDescriptionFontStyle": globalTokens.type_italic,
    "--upload-dragAndDropDescriptionFontWeight": globalTokens.type_normal,
    "--upload-dragAndDropDescriptionFontTextTransform": "none",
    "--upload-dragAndDropDescriptionFontColor": globalTokens.hal_grey_s_40,
    "--upload-dragAndDropDraggingStateIconColor": globalTokens.hal_grey_s_40,
    "--upload-dragAndDropDraggingStateIconSize": "43.5px",
    "--upload-dragAndDropDraggingStateIconWidth": "43.5px",
    "--upload-dragAndDropDraggingStateFontSize": globalTokens.type_scale_03,
    "--upload-dragAndDropDraggingStateFontStyle": globalTokens.type_normal,
    "--upload-dragAndDropDraggingStateFontWeight": globalTokens.type_normal,
    "--upload-dragAndDropDraggingStateFontTextTransform": "none",
    "--upload-dragAndDropDraggingStateFontColor": globalTokens.hal_grey_s_40,
    "--upload-dragAndDropAreaIconColor": globalTokens.hal_black,
    "--upload-dragAndDropAreaIconSize": "24px",
    "--upload-dragAndDropAreaTextFontSize": globalTokens.type_scale_01,
    "--upload-dragAndDropAreaTextFontStyle": globalTokens.type_normal,
    "--upload-dragAndDropAreaTextFontWeight": globalTokens.type_regular,
    "--upload-dragAndDropAreaTextFontTextTransform": "none",
    "--upload-dragAndDropAreaTextFontColor": globalTokens.hal_black,
    "--upload-fileDeleteIconColor": globalTokens.hal_black,
    "--upload-fileDeleteIconSize": "24px",
    "--upload-fileUnderlineColor": globalTokens.lightGrey,
    "--upload-fileUnderlineThickness": "1px",
    "--upload-fileNameFontSize": globalTokens.type_scale_03,
    "--upload-fileNameFontStyle": globalTokens.type_normal,
    "--upload-fileNameFontWeight": globalTokens.type_regular,
    "--upload-fileNameFontTextTransform": "none",
    "--upload-fileNameFontColor": globalTokens.hal_black,
    "--upload-fileTypeFontSize": globalTokens.type_scale_01,
    "--upload-fileTypeFontStyle": globalTokens.type_normal,
    "--upload-fileTypeFontWeight": globalTokens.type_regular,
    "--upload-fileTypeFontTextTransform": globalTokens.type_uppercase,
    "--upload-fileTypeFontColor": globalTokens.hal_black,
    "--upload-uploadedFileIconColor": globalTokens.hal_black,
    "--upload-uploadedFileIconSize": "24px",
    "--upload-uploadedFilesTitleFontSize": globalTokens.type_scale_04,
    "--upload-uploadedFilesTitleFontStyle": globalTokens.type_normal,
    "--upload-uploadedFilesTitleFontWeight": globalTokens.type_regular,
    "--upload-uploadedFilesTitleFontTextTransform": "none",
    "--upload-uploadedFilesTitleFontColor": globalTokens.hal_black,
    "--upload-uploadedFilesSubtitleFontSize": globalTokens.type_scale_02,
    "--upload-uploadedFilesSubtitleFontStyle": globalTokens.type_normal,
    "--upload-uploadedFilesSubtitleFontWeight": globalTokens.type_regular,
    "--upload-uploadedFilesSubtitleFontTextTransform": "none",
    "--upload-uploadedFilesSubtitleFontColor": globalTokens.hal_grey_s_40,
    "--upload-uploadedFilesNumberFontWeight": globalTokens.type_bold,
    //WIZARD
    "--wizard-focusColor": globalTokens.hal_blue_l_50,
    "--wizard-disabledBackgroundColor": globalTokens.lightGrey,
    "--wizard-disabledFontColor": globalTokens.hal_grey_s_40,
    "--wizard-stepContainerFontSize": globalTokens.type_scale_03,
    "--wizard-stepContainerFontFamily": globalTokens.type_sans,
    "--wizard-stepContainerFontStyle": globalTokens.type_normal,
    "--wizard-stepContainerFontWeight": globalTokens.type_regular,
    "--wizard-stepContainerLetterSpacing": globalTokens.type_spacing_wide_02,
    "--wizard-stepContainerFontColor": globalTokens.hal_black,
    "--wizard-stepContainerSelectedFontColor": globalTokens.hal_white,
    "--wizard-stepContainerSelectedBackgroundColor": globalTokens.hal_purple_s_38,
    "--wizard-stepContainerBackgroundColor": globalTokens.hal_white,
    "--wizard-stepContainerIconSize": "20px",
    "--wizard-labelFontSize": globalTokens.type_scale_03,
    "--wizard-labelFontFamily": globalTokens.type_sans,
    "--wizard-labelFontStyle": globalTokens.type_normal,
    "--wizard-labelFontWeight": globalTokens.type_regular,
    "--wizard-labelLetterSpacing": globalTokens.type_spacing_normal,
    "--wizard-labelFontTextTransform": "none",
    "--wizard-labelTextAlign": "left",
    "--wizard-labelFontColor": globalTokens.hal_grey_s_40,
    "--wizard-visitedLabelFontColor": globalTokens.hal_black,
    "--wizard-descriptionFontSize": globalTokens.type_scale_01,
    "--wizard-descriptionFontFamily": globalTokens.type_sans,
    "--wizard-descriptionFontStyle": globalTokens.type_normal,
    "--wizard-descriptionFontWeight": globalTokens.type_regular,
    "--wizard-descriptionLetterSpacing": globalTokens.type_spacing_wide_01,
    "--wizard-descriptionFontTextTransform": "none",
    "--wizard-descriptionFontColor": globalTokens.hal_grey_s_40,
    "--wizard-visitedDescriptionFontColor": globalTokens.hal_black,
    "--wizard-descriptionTextAlign": "left",
    "--wizard-circleBorderThickness": "2px",
    "--wizard-circleBorderStyle": globalTokens.border_solid,
    "--wizard-circleBorderRadius": "45px",
    "--wizard-circleBorderColor": globalTokens.hal_black,
    "--wizard-selectedCircleWidth": "32px",
    "--wizard-selectedCircleHeight": "32px",
    "--wizard-selectedCircleBorderThickness": "2px",
    "--wizard-selectedCircleBorderStyle": globalTokens.border_solid,
    "--wizard-selectedCircleBorderRadius": "45px",
    "--wizard-selectedCircleBorderColor": globalTokens.hal_purple_s_38,
    "--wizard-disabledCircleWidth": "32px",
    "--wizard-disabledCircleHeight": "32px",
    "--wizard-disabledCircleBorderThickness": "2px",
    "--wizard-disabledCircleBorderStyle": globalTokens.border_solid,
    "--wizard-disabledCircleBorderRadius": "45px",
    "--wizard-disabledCircleBorderColor": globalTokens.lightGrey,
    "--wizard-circleWidth": "32px",
    "--wizard-circleHeight": "32px",
    "--wizard-separatorBorderThickness": "1px",
    "--wizard-separatorBorderStyle": globalTokens.border_solid,
    "--wizard-separatorColor": globalTokens.lightGrey,
};
const componentIcons = {
    footer: {
        logo: "assets/dxc-logo-wh.svg",
    },
    header: {
        logo: "assets/DXC_Logo_Black_RGB.svg",
        logoResponsive: "assets/DXC_Logo_Black_RGB.svg",
    },
};

class BindingContext {
    constructor(mappingStrategy) {
        this.mappingStrategy = mappingStrategy;
    }
    setMappingStrategy(mappingStrategy) {
        this.mappingStrategy = mappingStrategy;
    }
    bindProperties(theme) {
        return this.mappingStrategy.bindProperties(theme, componentTokens);
    }
}

class ComplexThemeBindingStrategy {
    constructor() { }
    addLightness(hexColor, newLightness) {
        if (hexColor) {
            let colorInstance = new TinyColor(hexColor);
            // const hslColor = colorInstance.toHsl();
            const lightnessColor = colorInstance.lighten(newLightness);
            const lightnessColorHex = lightnessColor.toHexString();
            return lightnessColorHex;
        }
        return null;
    }
    subLightness(hexColor, newLightness) {
        try {
            if (hexColor) {
                let colorInstance = new TinyColor(hexColor);
                const lightnessColor = colorInstance.darken(newLightness);
                const lightnessColorHex = lightnessColor.toHexString();
                return lightnessColorHex;
            }
        }
        catch (e) {
            return null;
        }
    }
    setOpacity(hexColor, newOpacity) {
        if (hexColor) {
            let colorInstance = new TinyColor(hexColor);
            return colorInstance.setAlpha(newOpacity)?.toHex8String();
        }
        return null;
    }
    bindProperties(theme, tokens) {
        let proccessedTokens = tokens;
        //ACCORDION
        proccessedTokens["--accordion-arrowColor"] =
            theme?.accordion?.accentColor ?? tokens["--accordion-arrowColor"];
        proccessedTokens["--accordion-hoverBackgroundColor"] =
            this.setOpacity(theme?.accordion?.accentColor, 0.16) ??
                tokens["--accordion-hoverBackgroundColor"];
        proccessedTokens["--accordion-assistiveTextFontColor"] =
            theme?.accordion?.fontColor ??
                tokens["--accordion-assistiveTextFontColor"];
        proccessedTokens["--accordion-titleLabelFontColor"] =
            theme?.accordion?.fontColor ?? tokens["--accordion-titleLabelFontColor"];
        proccessedTokens["--accordion-iconColor"] =
            theme?.accordion?.accentColor ?? tokens["--accordion-iconColor"];
        proccessedTokens["--accordion-focusBorderColor"] =
            theme?.accordion?.accentColor ?? tokens["--accordion-focusBorderColor"];
        proccessedTokens["--accordion-disabledAssistiveTextFontColor"] =
            this.setOpacity(theme?.accordion?.fontColor, 0.34) ??
                tokens["--accordion-disabledAssistiveTextFontColor"];
        proccessedTokens["--accordion-disabledTitleLabelFontColor"] =
            this.setOpacity(theme?.accordion?.fontColor, 0.34) ??
                tokens["--accordion-disabledTitleLabelFontColor"];
        proccessedTokens["--accordion-disabledArrowColor"] =
            this.setOpacity(theme?.accordion?.accentColor, 0.34) ??
                tokens["--accordion-disabledArrowColor"];
        proccessedTokens["--accordion-disabledIconColor"] =
            this.setOpacity(theme?.accordion?.accentColor, 0.34) ??
                tokens["--accordion-disabledIconColor"];
        //BUTTON
        proccessedTokens["--button-primaryBackgroundColor"] =
            theme?.button?.baseColor ?? tokens["--button-primaryBackgroundColor"];
        proccessedTokens["--button-secondaryFontColor"] =
            theme?.button?.baseColor ?? tokens["--button-secondaryFontColor"];
        proccessedTokens["--button-secondaryHoverBackgroundColor"] =
            theme?.button?.baseColor ??
                tokens["--button-secondaryHoverBackgroundColor"];
        proccessedTokens["--button-textFontColor"] =
            theme?.button?.baseColor ?? tokens["--button-textFontColor"];
        proccessedTokens["--button-primaryFontColor"] =
            theme?.button?.primaryFontColor ?? tokens["--button-primaryFontColor"];
        proccessedTokens["--button-secondaryBorderColor"] =
            theme?.button?.baseColor ?? tokens["--button-secondaryBorderColor"];
        proccessedTokens["--button-secondaryHoverFontColor"] =
            theme?.button?.secondaryHoverFontColor ??
                tokens["--button-secondaryHoverFontColor"];
        proccessedTokens["--button-primaryHoverBackgroundColor"] =
            this.subLightness(theme?.button?.baseColor, 8) ??
                tokens["--button-primaryHoverBackgroundColor"];
        proccessedTokens["--button-primaryActiveBackgroundColor"] =
            this.subLightness(theme?.button?.baseColor, 18) ??
                tokens["--button-primaryActiveBackgroundColor"];
        proccessedTokens["--button-secondaryActiveBackgroundColor"] =
            this.subLightness(theme?.button?.baseColor, 18) ??
                tokens["--button-secondaryActiveBackgroundColor"];
        proccessedTokens["--button-textHoverBackgroundColor"] =
            this.addLightness(theme?.button?.baseColor, 57) ??
                tokens["--button-textHoverBackgroundColor"];
        proccessedTokens["--button-textActiveBackgroundColor"] =
            this.addLightness(theme?.button?.baseColor, 52) ??
                tokens["--button-textActiveBackgroundColor"];
        //CHECKBOX
        proccessedTokens["--checkbox-borderColor"] =
            theme?.checkbox?.baseColor ?? tokens["--checkbox-borderColor"];
        proccessedTokens["--checkbox-checkColor"] =
            theme?.checkbox?.checkColor ?? tokens["--checkbox-checkColor"];
        proccessedTokens["--checkbox-selectedBackgroundColor"] =
            theme?.checkbox?.baseColor ??
                tokens["--checkbox-selectedBackgroundColor"];
        proccessedTokens["--checkbox-selectedDisabledBackgroundColor"] =
            this.setOpacity(theme?.checkbox?.baseColor, 0.34) ??
                tokens["--checkbox-selectedDisabledBackgroundColor"];
        proccessedTokens["--checkbox-disabledBorderColor"] =
            this.setOpacity(theme?.checkbox?.baseColor, 0.34) ??
                tokens["--checkbox-disabledBorderColor"];
        proccessedTokens["--checkbox-disabledCheckColor"] =
            this.setOpacity(theme?.checkbox?.checkColor, 0.34) ??
                tokens["--checkbox-disabledCheckColor"];
        //CHIP
        proccessedTokens["--chip-backgroundColor"] =
            theme?.chip?.baseColor ?? tokens["--chip-backgroundColor"];
        proccessedTokens["--chip-fontColor"] =
            theme?.chip?.fontColor ?? tokens["--chip-fontColor"];
        proccessedTokens["--chip-disabledBackgroundColor"] =
            this.setOpacity(theme?.chip?.baseColor, 0.34) ??
                tokens["--chip-disabledBackgroundColor"];
        proccessedTokens["--chip-disabledFontColor"] =
            this.setOpacity(theme?.chip?.fontColor, 0.34) ??
                tokens["--chip-disabledFontColor"];
        //DATE
        proccessedTokens["--date-pickerSelectedDateBackgroundColor"] =
            theme?.date?.baseColor ??
                tokens["--date-pickerSelectedDateBackgroundColor"];
        proccessedTokens["--date-pickerSelectedDateColor"] =
            theme?.date?.accentColor ?? tokens["--date-pickerSelectedDateColor"];
        proccessedTokens["--date-pickerHoverDateBackgroundColor"] =
            this.setOpacity(theme?.date?.baseColor, 0.34) ??
                tokens["--date-pickerHoverDateBackgroundColor"];
        //dateInput
        proccessedTokens["--dateInput-pickerSelectedDateBackgroundColor"] =
            theme?.dateInput?.baseColor ??
                tokens["--dateInput-pickerSelectedDateBackgroundColor"];
        proccessedTokens["--dateInput-pickerSelectedDateColor"] =
            theme?.dateInput?.accentColor ??
                tokens["--dateInput-pickerSelectedDateColor"];
        proccessedTokens["--dateInput-pickerHoverDateBackgroundColor"] =
            this.setOpacity(theme?.dateInput?.baseColor, 0.34) ??
                tokens["--dateInput-pickerHoverDateBackgroundColor"];
        //DROPDOWN
        proccessedTokens["--dropdown-buttonBackgroundColor"] =
            theme?.dropdown?.baseColor ?? tokens["--dropdown-buttonBackgroundColor"];
        proccessedTokens["--dropdown-buttonFontColor"] =
            theme?.dropdown?.fontColor ?? tokens["--dropdown-buttonFontColor"];
        proccessedTokens["--dropdown-hoverButtonBackgroundColor"] =
            this.setOpacity(theme?.dropdown?.baseColor, 0.8) ??
                tokens["--dropdown-hoverButtonBackgroundColor"];
        proccessedTokens["--dropdown-hoverOptionBackgroundColor"] =
            this.setOpacity(theme?.dropdown?.baseColor, 0.34) ??
                tokens["--dropdown-hoverOptionBackgroundColor"];
        proccessedTokens["--dropdown-activeButtonBackgroundColor"] =
            this.setOpacity(theme?.dropdown?.baseColor, 0.7) ??
                tokens["--dropdown-activeButtonBackgroundColor"];
        proccessedTokens["--dropdown-activeOptionBackgroundColor"] =
            this.setOpacity(theme?.dropdown?.baseColor, 0.7) ??
                tokens["--dropdown-activeOptionBackgroundColor"];
        //FOOTER
        proccessedTokens["--footer-backgroundColor"] =
            theme?.footer?.baseColor ?? tokens["--footer-backgroundColor"];
        proccessedTokens["--footer-bottomLinksDividerColor"] =
            theme?.footer?.accentColor ?? tokens["--footer-bottomLinksDividerColor"];
        proccessedTokens["--footer-bottomLinksFontColor"] =
            theme?.footer?.fontColor ?? tokens["--footer-bottomLinksFontColor"];
        proccessedTokens["--footer-copyrightFontColor"] =
            theme?.footer?.fontColor ?? tokens["--footer-copyrightFontColor"];
        proccessedTokens["--footer-socialLinksColor"] =
            theme?.footer?.fontColor ?? tokens["--footer-socialLinksColor"];
        //HEADER
        proccessedTokens["--header-backgroundColor"] =
            theme?.header?.baseColor ?? tokens["--header-backgroundColor"];
        proccessedTokens["--header-underlinedColor"] =
            theme?.header?.accentColor ?? tokens["--header-underlinedColor"];
        proccessedTokens["--header-customContentFontColor"] =
            theme?.header?.fontColor ?? tokens["--header-customContentFontColor"];
        proccessedTokens["--header-menuCustomContentFontColor"] =
            theme?.header?.fontColor ?? tokens["--header-menuCustomContentFontColor"];
        proccessedTokens["--header-hamburguerFontColor"] =
            theme?.header?.fontColor ?? tokens["--header-hamburguerFontColor"];
        proccessedTokens["--header-menuBackgroundColor"] =
            theme?.header?.menuBaseColor ?? tokens["--header-menuBackgroundColor"];
        proccessedTokens["--header-hamburguerIconColor"] =
            theme?.header?.hamburguerColor ?? tokens["--header-hamburguerIconColor"];
        proccessedTokens["--header-hoverHamburguerColor"] =
            this.setOpacity(theme?.header?.hamburguerColor, 0.16) ??
                tokens["--header-hoverHamburguerColor"];
        proccessedTokens["--header-hamburguerHoverColor"] =
            this.setOpacity(theme?.header?.hamburguerColor, 0.16) ??
                tokens["--header-hamburguerHoverColor"];
        //INPUT TEXT
        proccessedTokens["--inputText-hoverOptionBackgroundColor"] =
            this.setOpacity(theme?.inputText?.selectedBaseColor, 0.34) ??
                tokens["--inputText-hoverOptionBackgroundColor"];
        //TEXT INPUT
        proccessedTokens["--textInput-hoverListOptionBackgroundColor"] =
            theme?.textInput?.selectedBaseColor ??
                tokens["--textInput-hoverListOptionBackgroundColor"];
        proccessedTokens["--textInput-activeListOptionBackgroundColor"] =
            this.subLightness(theme?.textInput?.selectedBaseColor, 15) ??
                tokens["--textInput-activeListOptionBackgroundColor"];
        //PAGINATOR
        proccessedTokens["--paginator-backgroundColor"] =
            theme?.paginator?.baseColor ?? tokens["--paginator-backgroundColor"];
        proccessedTokens["--paginator-fontColor"] =
            theme?.paginator?.fontColor ?? tokens["--paginator-fontColor"];
        //PROGRESSBAR
        proccessedTokens["--progressBar-trackLineColor"] =
            theme?.progressBar?.accentColor ?? tokens["--progressBar-trackLineColor"];
        proccessedTokens["--progressBar-totalLineColor"] =
            theme?.progressBar?.baseColor ?? tokens["--progressBar-totalLineColor"];
        //RADIO
        proccessedTokens["--radio-color"] =
            theme?.radio?.baseColor ?? tokens["--radio-color"];
        proccessedTokens["--radio-disabledColor"] =
            this.setOpacity(theme?.radio?.baseColor, 0.34) ??
                tokens["--radio-disabledColor"];
        //SELECT
        proccessedTokens["--select-selectedListItemBackgroundColor"] =
            theme?.select?.baseColor ??
                tokens["--select-selectedListItemBackgroundColor"];
        proccessedTokens["unselectedHoverListItemBackgroundColor"] =
            this.setOpacity(theme?.select?.baseColor, 0.34) ??
                tokens["unselectedHoverListItemBackgroundColor"];
        //SIDENAV
        proccessedTokens["--sidenav-backgroundColor"] =
            theme?.sidenav?.baseColor ?? tokens["--sidenav-backgroundColor"];
        proccessedTokens["--sidenav-arrowContainerColor"] =
            this.setOpacity(theme?.sidenav?.arrowBaseColor, 0.8) ??
                tokens["--sidenav-arrowContainerColor"];
        proccessedTokens["--sidenav-arrowColor"] =
            theme?.sidenav?.arrowAccentColor ?? tokens["--sidenav-arrowColor"];
        //SLIDER
        proccessedTokens["--slider-totalLineColor"] =
            this.setOpacity(theme?.slider?.baseColor, 0.34) ??
                tokens["--slider-totalLineColor"];
        proccessedTokens["--slider-disabledThumbBackgroundColor"] =
            this.setOpacity(theme?.slider?.baseColor, 0.34) ??
                tokens["--slider-disabledThumbBackgroundColor"];
        proccessedTokens["--slider-disabledTrackLineColor"] =
            this.setOpacity(theme?.slider?.baseColor, 0.34) ??
                tokens["--slider-disabledTrackLineColor"];
        proccessedTokens["--slider-thumbBackgroundColor"] =
            theme?.slider?.baseColor ?? tokens["--slider-thumbBackgroundColor"];
        proccessedTokens["--slider-tickBackgroundColor"] =
            theme?.slider?.baseColor ?? tokens["--slider-tickBackgroundColor"];
        proccessedTokens["--slider-trackLineColor"] =
            theme?.slider?.baseColor ?? tokens["--slider-trackLineColor"];
        proccessedTokens["--slider-disabledTickBackgroundColor"] =
            this.setOpacity(theme?.slider?.baseColor, 0.34) ??
                tokens["--slider-disabledTickBackgroundColor"];
        proccessedTokens["--slider-activeThumbBackgroundColor"] =
            this.subLightness(theme?.slider?.baseColor, 15) ??
                tokens["--slider-activeThumbBackgroundColor"];
        proccessedTokens["--slider-hoverThumbBackgroundColor"] =
            this.subLightness(theme?.slider?.baseColor, 15) ??
                tokens["--slider-hoverThumbBackgroundColor"];
        //SPINNER
        proccessedTokens["--spinner-trackCircleColor"] =
            theme?.spinner?.accentColor ?? tokens["--spinner-trackCircleColor"];
        proccessedTokens["--spinner-totalCircleColor"] =
            theme?.spinner?.baseColor ?? tokens["--spinner-totalCircleColor"];
        //SWITCH
        proccessedTokens["--switch-checkedTrackBackgroundColor"] =
            theme?.switch?.checkedBaseColor ??
                tokens["--switch-checkedTrackBackgroundColor"];
        proccessedTokens["--switch-disabledCheckedTrackBackgroundColor"] =
            this.setOpacity(theme?.switch?.checkedBaseColor, 0.34) ??
                tokens["--switch-disabledCheckedTrackBackgroundColor"];
        //TABLE
        proccessedTokens["--table-headerBackgroundColor"] =
            theme?.table?.baseColor ?? tokens["--table-headerBackgroundColor"];
        proccessedTokens["--table-headerFontColor"] =
            theme?.table?.fontColor ?? tokens["--table-headerFontColor"];
        //TABS
        proccessedTokens["--tabs-selectedFontColor"] =
            theme?.tabs?.baseColor ?? tokens["--tabs-selectedFontColor"];
        proccessedTokens["--tabs-selectedIconColor"] =
            theme?.tabs?.baseColor ?? tokens["--tabs-selectedIconColor"];
        proccessedTokens["--tabs-selectedUnderlineColor"] =
            theme?.tabs?.baseColor ?? tokens["--tabs-selectedUnderlineColor"];
        proccessedTokens["--tabs-focusOutline"] =
            theme?.tabs?.baseColor ?? tokens["--tabs-focusOutline"];
        proccessedTokens["--tabs-hoverBackgroundColor"] =
            this.addLightness(theme?.tabs?.baseColor, 58) ??
                tokens["--tabs-hoverBackgroundColor"];
        proccessedTokens["--tabs-pressedBackgroundColor"] =
            this.addLightness(theme?.tabs?.baseColor, 53) ??
                tokens["--tabs-pressedBackgroundColor"];
        //TOGGLE GROUP
        proccessedTokens["--toggleGroup-unselectedBackgroundColor"] =
            theme?.toggleGroup?.unselectedBaseColor ??
                tokens["--toggleGroup-unselectedBackgroundColor"];
        proccessedTokens["--toggleGroup-unselectedHoverBackgroundColor"] =
            this.subLightness(theme?.toggleGroup?.unselectedBaseColor, 8) ??
                tokens["--toggleGroup-unselectedHoverBackgroundColor"];
        proccessedTokens["--toggleGroup-unselectedActiveBackgroundColor"] =
            theme?.toggleGroup?.selectedBaseColor ??
                tokens["--toggleGroup-unselectedActiveBackgroundColor"];
        proccessedTokens["--toggleGroup-unselectedFontColor"] =
            theme?.toggleGroup?.unselectedFontColor ??
                tokens["--toggleGroup-unselectedFontColor"];
        proccessedTokens["--toggleGroup-selectedBackgroundColor"] =
            theme?.toggleGroup?.selectedBaseColor ??
                tokens["--toggleGroup-selectedBackgroundColor"];
        proccessedTokens["--toggleGroup-selectedHoverBackgroundColor"] =
            this.subLightness(theme?.toggleGroup?.selectedBaseColor, 8) ??
                tokens["--toggleGroup-selectedHoverBackgroundColor"];
        proccessedTokens["--toggleGroup-selectedActiveBackgroundColor"] =
            this.subLightness(theme?.toggleGroup?.selectedBaseColor, 18) ??
                tokens["--toggleGroup-selectedActiveBackgroundColor"];
        proccessedTokens["--toggleGroup-selectedFontColor"] =
            theme?.toggleGroup?.selectedFontColor ??
                tokens["--toggleGroup-selectedFontColor"];
        proccessedTokens["--toggleGroup-selectedDisabledBackgroundColor"] =
            this.addLightness(theme?.toggleGroup?.selectedBaseColor, 57) ??
                tokens["--toggleGroup-selectedDisabledBackgroundColor"];
        proccessedTokens["--toggleGroup-selectedDisabledFontColor"] =
            this.addLightness(theme?.toggleGroup?.selectedBaseColor, 42) ??
                tokens["--toggleGroup-selectedDisabledFontColor"];
        proccessedTokens["--toggleGroup-unselectedDisabledBackgroundColor"] =
            this.addLightness(theme?.toggleGroup?.unselectedBaseColor, 5) ??
                tokens["--toggleGroup-unselectedDisabledBackgroundColor"];
        proccessedTokens["--toggleGroup-unselectedDisabledFontColor"] =
            this.setOpacity(theme?.toggleGroup?.unselectedFontColor, 0.34) ??
                tokens["--toggleGroup-unselectedDisabledFontColor"];
        //WIZARD
        proccessedTokens["--wizard-stepContainerSelectedBackgroundColor"] =
            theme?.wizard?.baseColor ??
                tokens["--wizard-stepContainerSelectedBackgroundColor"];
        proccessedTokens["--wizard-stepContainerSelectedFontColor"] =
            theme?.wizard?.fontColor ??
                tokens["--wizard-stepContainerSelectedFontColor"];
        return proccessedTokens;
    }
}

class AdvancedThemeBindingStrategy {
    constructor() { }
    bindProperties(advancedTheme, tokens) {
        const allTokensCopy = JSON.parse(JSON.stringify(tokens));
        Object.keys(allTokensCopy).map(currentToken => {
            let tokenComponentName = currentToken.split('-')[2];
            let currentTokenComponent = advancedTheme[tokenComponentName];
            if (currentTokenComponent !== undefined) {
                Object.keys(currentTokenComponent).map(objectKey => {
                    if (currentTokenComponent[objectKey]) {
                        let tokenFullKey = `--${currentToken.split('-')[2]}-${objectKey}`;
                        if (allTokensCopy[tokenFullKey] !== undefined) {
                            allTokensCopy[tokenFullKey] = currentTokenComponent[objectKey];
                        }
                    }
                });
            }
        });
        return allTokensCopy;
    }
}

class ThemeDirective {
    constructor(_themeService) {
        this._themeService = _themeService;
        this._destroy$ = new Subject();
    }
    ngOnInit() {
        this.getTheme();
    }
    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }
    updateTheme(theme) {
        this.theme = theme;
        this.setPropertiesCss(this.theme);
        this.setVariableLinks(this.theme);
    }
    setPropertiesCss(theme) {
        const ctx = new BindingContext(!theme.advanced
            ? new ComplexThemeBindingStrategy()
            : new AdvancedThemeBindingStrategy());
        let processedTokens = ctx.bindProperties(theme.theme);
        for (const key in processedTokens) {
            document.body.style.setProperty(key, processedTokens[key]);
        }
    }
    setVariableLinks(themeObj) {
        const footerLogo = themeObj.theme?.footer?.logo ?? componentIcons.footer.logo;
        const headerLogo = themeObj.theme?.header?.logo ?? componentIcons.header.logo;
        const headerLogoResponsive = themeObj?.theme?.header?.logoResponsive ??
            componentIcons.header.logoResponsive;
        document.body.setAttribute("footer-logo", footerLogo);
        document.body.setAttribute("header-logo", headerLogo);
        document.body.setAttribute("header-logoResponsive", headerLogoResponsive);
    }
    getTheme() {
        const active = this._themeService?.getTheme();
        this.updateTheme({ theme: active, advanced: false });
        this._themeService?.themeChange.subscribe((theme) => {
            this.updateTheme({ theme: theme, advanced: false });
        });
        this._themeService?.themeAdvanceChange.subscribe((theme) => {
            this.updateTheme({ theme: theme, advanced: true });
        });
    }
}
ThemeDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: ThemeDirective, deps: [{ token: "ThemeService", optional: true }], target: i0.ɵɵFactoryTarget.Directive });
ThemeDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.2.5", type: ThemeDirective, selector: "[theme]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: ThemeDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: "[theme]",
                }]
        }], ctorParameters: function () { return [{ type: ThemeService, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: ["ThemeService"]
                }] }]; } });

class ThemeModule {
}
ThemeModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: ThemeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
ThemeModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: ThemeModule, declarations: [ThemeDirective], imports: [CommonModule], exports: [ThemeDirective] });
ThemeModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: ThemeModule, providers: [ThemeService], imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: ThemeModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    providers: [ThemeService],
                    declarations: [ThemeDirective],
                    exports: [ThemeDirective],
                }]
        }] });

class BackgroundProviderService {
    constructor() {
        this.$changeColor = new Subject();
    }
    changeBackgroundColor(color) {
        this.$changeColor.next(color);
    }
}
BackgroundProviderService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: BackgroundProviderService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
BackgroundProviderService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: BackgroundProviderService, providedIn: "any" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: BackgroundProviderService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: "any",
                }]
        }], ctorParameters: function () { return []; } });

class BackgroundProviderComponent {
    constructor(bgProviderService) {
        this.bgProviderService = bgProviderService;
    }
    ngOnInit() {
        if (this.color) {
            this.setType();
        }
    }
    setType() {
        const colorType = this.checkColorType(this.color);
        this.bgProviderService.changeBackgroundColor(colorType ? colorType : null);
    }
    checkColorType(color) {
        const colorInstance = new TinyColor(color);
        return colorInstance.isDark() ? 'dark' : 'light';
    }
}
BackgroundProviderComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: BackgroundProviderComponent, deps: [{ token: BackgroundProviderService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
BackgroundProviderComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.5", type: BackgroundProviderComponent, selector: "background-provider", inputs: { color: "color" }, providers: [BackgroundProviderService], ngImport: i0, template: "<div><ng-content></ng-content></div>", isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: BackgroundProviderComponent, decorators: [{
            type: Component,
            args: [{
                    selector: "background-provider",
                    template: "<div><ng-content></ng-content></div>",
                    providers: [BackgroundProviderService]
                }]
        }], ctorParameters: function () { return [{ type: BackgroundProviderService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { color: [{
                type: Input
            }] } });

class BackgroundProviderModule {
}
BackgroundProviderModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: BackgroundProviderModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
BackgroundProviderModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: BackgroundProviderModule, declarations: [BackgroundProviderComponent], imports: [CommonModule], exports: [BackgroundProviderComponent] });
BackgroundProviderModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: BackgroundProviderModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: BackgroundProviderModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [BackgroundProviderComponent],
                    exports: [BackgroundProviderComponent],
                }]
        }] });

const colors = {
    black: "#000000",
    lightBlack: "#212121",
    white: "#FFFFFF",
    darkWhite: "#EEEEEE",
    yellow: "#FFED00",
    darkGrey: "#666666",
    lightGrey: "#D9D9D9",
    darkRed: "#D0011B",
    lightRed: "#FF6161",
    //Alert colors
    lightBlue: "#CEE0F5",
    lightYellow: "#FCF2BD",
    lightPink: "#F9CFCF",
    lightGreen: "#DBF1C4"
};
const spaces = {
    xxsmall: "6px",
    xsmall: "16px",
    small: "24px",
    medium: "36px",
    large: "48px",
    xlarge: "64px",
    xxlarge: "100px"
};
const responsiveSizes = {
    xsmall: "20",
    small: "30",
    medium: "45",
    large: "66",
    xlarge: "90",
};

class CssUtils {
    constructor() {
        this.getMarginValue = (margin, type) => {
            const marginSize = margin && margin !== null ? spaces[margin[type]] : "0px";
            return marginSize;
        };
    }
    getMargins(margin) {
        return margin && typeof margin !== "object"
            ? css `
          margin: ${spaces[margin]};
        `
            : margin && margin !== null
                ? css `
          margin-left: ${spaces[margin["left"]]};
          margin-top: ${spaces[margin["top"]]};
          margin-right: ${spaces[margin["right"]]};
          margin-bottom: ${spaces[margin["bottom"]]};
        `
                : css `
          margin: 0px;
        `;
    }
    getTopMargin(margin) {
        return margin && typeof margin !== "object"
            ? css `
          margin-top: ${spaces[margin]};
        `
            : margin && margin !== null
                ? css `
          margin-top: ${spaces[margin["top"]]};
        `
                : css `
          margin: 0px;
        `;
    }
    getPaddings(padding) {
        return padding && typeof padding !== "object"
            ? css `
          padding: ${spaces[padding]};
        `
            : padding && padding !== null
                ? css `
          padding-left: ${spaces[padding["left"]]};
          padding-top: ${spaces[padding["top"]]};
          padding-right: ${spaces[padding["right"]]};
          padding-bottom: ${spaces[padding["bottom"]]};
        `
                : css `
          padding: 0px;
        `;
    }
    calculateWidth(sizes, inputs) {
        const width = sizes[inputs.size];
        let margins = "";
        if (inputs.size === "fillParent" && inputs.margin) {
            margins = this.getPaddingOrMargin(sizes, inputs.margin);
        }
        let paddings = "";
        if (inputs.padding) {
            paddings = this.getPaddingOrMargin(sizes, inputs.padding);
        }
        if (paddings || margins) {
            return css `
        width: calc(${width} ${paddings} ${margins});
      `;
        }
        else {
            return css `
        width: ${width};
      `;
        }
    }
    getPaddingOrMargin(size, paddingOrMargin) {
        let finalPaddingOrMargin = "";
        if (paddingOrMargin && typeof paddingOrMargin !== "object") {
            finalPaddingOrMargin =
                " - " + spaces[paddingOrMargin] + " - " + spaces[paddingOrMargin];
        }
        else if (size) {
            if (!paddingOrMargin["right"] && paddingOrMargin["left"]) {
                finalPaddingOrMargin = " - " + spaces[paddingOrMargin["left"]];
            }
            else if (!paddingOrMargin["left"] && paddingOrMargin["right"]) {
                finalPaddingOrMargin = " - " + spaces[paddingOrMargin["right"]];
            }
            else if (paddingOrMargin["left"] && paddingOrMargin["right"]) {
                finalPaddingOrMargin =
                    " - " +
                        spaces[paddingOrMargin["left"]] +
                        " - " +
                        spaces[paddingOrMargin["right"]];
            }
        }
        return finalPaddingOrMargin;
    }
    calculateWidthWithSize(size, padding) {
        let paddings = "";
        if (padding) {
            paddings =
                padding && typeof padding !== "object"
                    ? " - " + spaces[padding] + " - " + spaces[padding]
                    : padding && size
                        ? padding["right"] === undefined && padding["left"]
                            ? " - " + spaces[padding["left"]]
                            : padding["left"] === undefined && padding["right"]
                                ? " - " + spaces[padding["right"]]
                                : padding["left"] && padding["right"]
                                    ? " - " + spaces[padding["left"]] + " - " + spaces[padding["right"]]
                                    : ""
                        : "";
        }
        return css `
      width: calc(${size} ${paddings});
    `;
    }
    calculateHeightWithSize(size, padding) {
        let paddings = "";
        if (padding) {
            paddings =
                padding && typeof padding !== "object"
                    ? " - " + spaces[padding] + " - " + spaces[padding]
                    : padding && size
                        ? padding["top"] === undefined && padding["bottom"]
                            ? " - " + spaces[padding["bottom"]]
                            : padding["bottom"] === undefined && padding["top"]
                                ? " - " + spaces[padding["top"]]
                                : padding["bottom"] && padding["top"]
                                    ? " - " + spaces[padding["bottom"]] + " - " + spaces[padding["top"]]
                                    : ""
                        : "";
        }
        return css `
      height: calc(${size} ${paddings});
    `;
    }
    calculateMinWidth(sizes, margin) {
        const value = margin && typeof margin !== "object"
            ? css `
            min-width: calc(
              ${sizes["small"]} - ${spaces[margin]} - ${spaces[margin]}
            );
          `
            : margin
                ? margin["right"] === undefined && margin["left"]
                    ? css `
              min-width: calc(${sizes["small"]} - ${spaces[margin["left"]]});
            `
                    : margin["left"] === undefined && margin["right"]
                        ? css `
              min-width: calc(${sizes["small"]} - ${spaces[margin["right"]]});
            `
                        : margin["left"] && margin["right"]
                            ? css `
              min-width: calc(
                ${sizes["small"]} - ${spaces[margin["left"]]} -${spaces[margin["right"]]}
              );
            `
                            : css `
              min-width: ${sizes["small"]};
            `
                : css `
            min-width: ${sizes["small"]};
          `;
        return value;
    }
    getBoxShadow(shadowDepth, isImportant = false) {
        switch (shadowDepth) {
            case 1:
                return css `
          box-shadow: var(--box-oneShadowDepthShadowOffsetX)
            var(--box-oneShadowDepthShadowOffsetY)
            var(--box-oneShadowDepthShadowBlur)
            var(--box-oneShadowDepthShadowSpread)
            var(--box-oneShadowDepthShadowColor)
            ${this.isPropertyImportant(isImportant)};
        `;
            case 2:
                return css `
          box-shadow: var(--box-twoShadowDepthShadowOffsetX)
            var(--box-twoShadowDepthShadowOffsetY)
            var(--box-twoShadowDepthShadowBlur)
            var(--box-twoShadowDepthShadowSpread)
            var(--box-twoShadowDepthShadowColor)
            ${this.isPropertyImportant(isImportant)};
        `;
            default:
                return css `
          box-shadow: var(--box-noneShadowDepthShadowOffsetX)
            var(--box-noneShadowDepthShadowOffsetY)
            var(--box-noneShadowDepthShadowBlur)
            var(--box-noneShadowDepthShadowSpread)
            var(--box-noneShadowDepthShadowColor)
            ${this.isPropertyImportant(isImportant)};
        `;
        }
    }
    readProperty(name) {
        let bodyStyles = window.getComputedStyle(document.body);
        return bodyStyles.getPropertyValue(name);
    }
    isPropertyImportant(isImportant) {
        return isImportant ? " !important" : "";
    }
}
CssUtils.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: CssUtils, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
CssUtils.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: CssUtils });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: CssUtils, decorators: [{
            type: Injectable
        }] });

class DxcAccordionIconComponent {
    constructor() { }
}
DxcAccordionIconComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcAccordionIconComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
DxcAccordionIconComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.5", type: DxcAccordionIconComponent, selector: "dxc-accordion-icon", ngImport: i0, template: "<ng-content></ng-content>" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcAccordionIconComponent, decorators: [{
            type: Component,
            args: [{ selector: "dxc-accordion-icon", template: "<ng-content></ng-content>" }]
        }], ctorParameters: function () { return []; } });

class BackgroundProviderInnerComponent {
    constructor(element, bgProviderService) {
        this.element = element;
        this.bgProviderService = bgProviderService;
    }
    ngOnInit() {
        if (this.color) {
            this.setType();
        }
        this.className = `${this.getDynamicStyle()}`;
    }
    setType() {
        const colorType = this.checkColorType(this.color);
        this.bgProviderService.changeBackgroundColor(colorType ? colorType : null);
    }
    checkColorType(color) {
        const colorInstance = new TinyColor(color);
        return colorInstance.isDark() ? "dark" : "light";
    }
    getDynamicStyle() {
        return css `
      display: contents;
    `;
    }
}
BackgroundProviderInnerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: BackgroundProviderInnerComponent, deps: [{ token: i0.ElementRef }, { token: BackgroundProviderService, optional: true, skipSelf: true }], target: i0.ɵɵFactoryTarget.Component });
BackgroundProviderInnerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.5", type: BackgroundProviderInnerComponent, selector: "background-provider-inner", inputs: { color: "color" }, host: { properties: { "class": "this.className" } }, ngImport: i0, template: "<ng-content></ng-content>", isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: BackgroundProviderInnerComponent, decorators: [{
            type: Component,
            args: [{
                    selector: "background-provider-inner",
                    template: "<ng-content></ng-content>",
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: BackgroundProviderService, decorators: [{
                    type: Optional
                }, {
                    type: SkipSelf
                }] }]; }, propDecorators: { className: [{
                type: HostBinding,
                args: ["class"]
            }], color: [{
                type: Input
            }] } });

class DxcAccordionComponent {
    constructor(cssUtils, cdRef, elementRef) {
        this.cssUtils = cssUtils;
        this.cdRef = cdRef;
        this.elementRef = elementRef;
        /**
         * The panel label.
         */
        this.label = "";
        /**
         * Assistive text to be placed on the right side of the panel.
         */
        this.assistiveText = "";
        this._disabled = false;
        /**
         * This event will emit in case the user clicks the accordion to expand or collapse
         * the panel. The new state of the panel will be passed as a parameter.
         */
        this.onClick = new EventEmitter();
        /**
         * Initial state of the panel, only when it is uncontrolled.
         */
        this.defaultIsExpanded = false;
        this._tabIndexValue = 0;
        this.defaultInputs = new BehaviorSubject({
            label: "",
            assistiveText: "",
            isExpanded: false,
            defaultIsExpanded: false,
            margin: null,
            padding: null,
            disabled: false,
            tabIndexValue: 0,
        });
    }
    /**
     * If true, the component will be disabled.
     */
    get disabled() {
        return this._disabled;
    }
    set disabled(value) {
        this._disabled = coerceBooleanProperty(value);
    }
    /**
     * Represents the state of the panel. When true, the component will be
     * expanded. If undefined, the component will be uncontrolled and its
     * value will be managed internally by the component.
     */
    get isExpanded() {
        return this._isExpanded;
    }
    set isExpanded(value) {
        this._isExpanded = coerceBooleanProperty(value);
    }
    /**
     * Value of the tabindex.
     */
    get tabIndexValue() {
        return this._tabIndexValue;
    }
    set tabIndexValue(value) {
        this._tabIndexValue = coerceNumberProperty(value);
    }
    getElement() {
        return this.elementRef;
    }
    ngAfterViewInit() {
        if (this.dxcAccordionIcon.length !== 0) {
            this.iconSrc = "";
        }
        this.cdRef.detectChanges();
    }
    ngOnInit() {
        this.renderedIsExpanded = this.isExpanded || this.defaultIsExpanded;
        console.log(this.renderedIsExpanded);
        this.className = `${this.getDynamicStyle(this.defaultInputs.getValue())}`;
    }
    ngOnChanges(changes) {
        this.renderedIsExpanded = this.isExpanded;
        const inputs = Object.keys(changes).reduce((result, item) => {
            result[item] = changes[item].currentValue;
            return result;
        }, {});
        this.defaultInputs.next({ ...this.defaultInputs.getValue(), ...inputs });
        this.currentBackgroundColor = this.cssUtils.readProperty("--accordion-backgroundColor");
        this.className = `${this.getDynamicStyle(this.defaultInputs.getValue())}`;
    }
    onClickHandler($event) {
        if (!this.disabled) {
            this.onClick.emit(!this.renderedIsExpanded);
            if (this.isExpanded === undefined || this.isExpanded === null) {
                this.renderedIsExpanded = !this.renderedIsExpanded;
            }
        }
        this.renderedIsExpanded === true
            ? this._matExpansionPanel.open()
            : this._matExpansionPanel.close();
    }
    getDynamicStyle(inputs) {
        return css `
      cursor: ${inputs.disabled ? "not-allowed" : "pointer"};
      ${this.cssUtils.getMargins(inputs.margin)}
      min-width: 280px;
      display: block;
      div.mat-expansion-panel-content {
        div.mat-expansion-panel-body {
          cursor: default;
          ${inputs.padding
            ? this.cssUtils.getPaddings(inputs.padding)
            : `padding:0px;`}
          margin: 16px 16px 16px 16px;
          dxc-accordion {
            width: 100%;
          }
        }
      }
      .mat-accordion .mat-expansion-panel:last-of-type {
        border-bottom-right-radius: var(--accordion-borderRadius);
        border-bottom-left-radius: var(--accordion-borderRadius);
      }
      .mat-accordion .mat-expansion-panel:first-of-type {
        border-top-right-radius: var(--accordion-borderRadius);
        border-top-left-radius: var(--accordion-borderRadius);
      }

      .mat-expansion-panel:not(.mat-expanded)
        .mat-expansion-panel-header:not([aria-disabled="true"]).cdk-keyboard-focused {
        background: transparent !important;
      }
      .mat-expansion-panel {
        border-radius: var(--accordion-borderRadius);
        background-color: var(--accordion-backgroundColor) !important;
        box-shadow: var(--accordion-boxShadowOffsetX)
          var(--accordion-boxShadowOffsetY) var(--accordion-boxShadowBlur)
          var(--accordion-boxShadowColor) !important;
        mat-expansion-panel-header {
          min-height: 48px;
          padding: 0 16px;
          .mat-expansion-panel-header-title {
            font-family: var(--accordion-titleLabelFontFamily);
            font-size: var(--accordion-titleLabelFontSize);
            font-weight: var(--accordion-titleLabelFontWeight);
            font-style: var(--accordion-titleLabelFontStyle);
            color: var(--accordion-titleLabelFontColor);
            padding-right: var(--accordion-titleLabelPaddingRight);
            padding-left: var(--accordion-titleLabelPaddingLeft);
            padding-top: var(--accordion-titleLabelPaddingTop);
            padding-bottom: var(--accordion-titleLabelPaddingBottom);
          }
          span.mat-expansion-indicator {
            display: none;
          }
          span.mat-content {
            align-items: center;
          }
          mat-panel-title {
            display: flex;
            align-items: center;
            .imageIcon {
              width: 24px;
              height: 24px;
            }
            &.before {
              flex-direction: row-reverse;
              justify-content: flex-end;
              .imageIcon,
              dxc-accordion-icon {
                margin-right: var(--accordion-iconMarginRight);
                margin-left: var(--accordion-iconMarginLeft);
              }
            }
            dxc-accordion-icon {
              display: flex;
              svg,
              img {
                fill: var(--accordion-iconColor);
                color: var(--accordion-iconColor);
                width: var(--accordion-iconSize);
                height: var(--accordion-iconSize);
              }
            }
          }
          mat-panel-description {
            justify-content: flex-end;
            overflow: hidden;
            font-family: var(--accordion-assistiveTextFontFamily);
            font-size: var(--accordion-assistiveTextFontSize);
            font-weight: var(--accordion-assistiveTextFontWeight);
            font-style: var(--accordion-assistiveTextFontStyle);
            color: var(--accordion-assistiveTextFontColor);
            letter-spacing: var(assistiveTextLetterSpacing);
            min-width: var(--accordion-assistiveTextMinWidth);
            padding-right: var(--accordion-assistiveTextPaddingRight);
            padding-left: var(--accordion-assistiveTextPaddingLeft);
            span {
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              text-align: end;
              width: 100%;
            }
          }
        }
        &:not(.disabled) {
          mat-expansion-panel-header {
            &:focus,
            &:focus-visible {
              outline: -webkit-focus-ring-color
                var(--accordion-focusBorderStyle)
                var(--accordion-focusBorderThickness);
              outline-color: var(--accordion-focusBorderColor);
              outline-offset: var(--accordion-focusBorderOffset);
            }
            &:hover {
              background-color: var(
                --accordion-hoverBackgroundColor
              ) !important;
            }
            .caret-indicator {
              transform: rotate(-180deg);
              transition: transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
            }

            .caret-indicator svg {
              display: block;
              fill: var(--accordion-arrowColor);
            }

            &.mat-expanded {
              .caret-indicator {
                transform: rotate(0deg);
                transition: transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
              }
              border-bottom-left-radius: 0px;
              border-bottom-right-radius: 0px;
            }
          }
        }
      }

      mat-expansion-panel.disabled {
        cursor: not-allowed;
        background-color: var(--accordion-disabledBackgroundColor) !important;
        mat-expansion-panel-header {
          .mat-expansion-panel-header-title {
            color: var(--accordion-disabledTitleLabelFontColor);
          }
          dxc-accordion-icon {
            svg,
            img {
              fill: var(--accordion-disabledIconColor);
              color: var(--accordion-disabledIconColor);
            }
          }
          .caret-indicator svg {
            fill: var(--accordion-disabledArrowColor);
          }
          mat-panel-description {
            color: var(--accordion-disabledAssistiveTextFontColor);
          }
        }
      }
    `;
    }
}
DxcAccordionComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcAccordionComponent, deps: [{ token: CssUtils }, { token: i0.ChangeDetectorRef }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
DxcAccordionComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.5", type: DxcAccordionComponent, selector: "dxc-accordion", inputs: { label: "label", iconSrc: "iconSrc", assistiveText: "assistiveText", disabled: "disabled", margin: "margin", padding: "padding", isExpanded: "isExpanded", defaultIsExpanded: "defaultIsExpanded", tabIndexValue: "tabIndexValue" }, outputs: { onClick: "onClick" }, host: { properties: { "class": "this.className" } }, providers: [CssUtils, BackgroundProviderComponent], queries: [{ propertyName: "dxcAccordionIcon", predicate: DxcAccordionIconComponent }], viewQueries: [{ propertyName: "_matExpansionPanel", first: true, predicate: ["matExpansionPanel"], descendants: true, static: true }], usesOnChanges: true, ngImport: i0, template: "<mat-accordion>\n  <mat-expansion-panel\n    #matExpansionPanel\n    [ngClass]=\"[disabled ? 'disabled' : '']\"\n    [disabled]=\"disabled\"\n    [expanded]=\"renderedIsExpanded\"\n  >\n    <mat-expansion-panel-header\n      (click)=\"onClickHandler($event)\"\n      [expandedHeight]=\"'48px'\"\n      [tabindex]=\"disabled ? -1 : tabIndexValue\"\n    >\n      <mat-panel-title [ngClass]=\"'before'\">\n        <span *ngIf=\"label\">{{ label }}</span>\n        <img [src]=\"iconSrc\" *ngIf=\"iconSrc\" class=\"imageIcon\" />\n        <ng-content select=\"dxc-accordion-icon\"></ng-content>\n      </mat-panel-title>\n      <mat-panel-description>\n        <span *ngIf=\"assistiveText\">{{ assistiveText }}</span>\n      </mat-panel-description>\n      <span class=\"caret-indicator\">\n        <svg\n          class=\"up\"\n          xmlns=\"http://www.w3.org/2000/svg\"\n          width=\"24\"\n          height=\"24\"\n          viewBox=\"0 0 24 24\"\n        >\n          <path d=\"M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z\" />\n          <path d=\"M0 0h24v24H0z\" fill=\"none\" />\n        </svg>\n      </span>\n    </mat-expansion-panel-header>\n    <background-provider-inner color=\"{{ currentBackgroundColor }}\">\n      <ng-content></ng-content>\n    </background-provider-inner>\n  </mat-expansion-panel>\n</mat-accordion>\n", components: [{ type: i2.MatExpansionPanel, selector: "mat-expansion-panel", inputs: ["disabled", "expanded", "hideToggle", "togglePosition"], outputs: ["opened", "closed", "expandedChange", "afterExpand", "afterCollapse"], exportAs: ["matExpansionPanel"] }, { type: i2.MatExpansionPanelHeader, selector: "mat-expansion-panel-header", inputs: ["tabIndex", "expandedHeight", "collapsedHeight"] }, { type: BackgroundProviderInnerComponent, selector: "background-provider-inner", inputs: ["color"] }], directives: [{ type: i2.MatAccordion, selector: "mat-accordion", inputs: ["multi", "displayMode", "togglePosition", "hideToggle"], exportAs: ["matAccordion"] }, { type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i2.MatExpansionPanelTitle, selector: "mat-panel-title" }, { type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i2.MatExpansionPanelDescription, selector: "mat-panel-description" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcAccordionComponent, decorators: [{
            type: Component,
            args: [{ selector: "dxc-accordion", providers: [CssUtils, BackgroundProviderComponent], template: "<mat-accordion>\n  <mat-expansion-panel\n    #matExpansionPanel\n    [ngClass]=\"[disabled ? 'disabled' : '']\"\n    [disabled]=\"disabled\"\n    [expanded]=\"renderedIsExpanded\"\n  >\n    <mat-expansion-panel-header\n      (click)=\"onClickHandler($event)\"\n      [expandedHeight]=\"'48px'\"\n      [tabindex]=\"disabled ? -1 : tabIndexValue\"\n    >\n      <mat-panel-title [ngClass]=\"'before'\">\n        <span *ngIf=\"label\">{{ label }}</span>\n        <img [src]=\"iconSrc\" *ngIf=\"iconSrc\" class=\"imageIcon\" />\n        <ng-content select=\"dxc-accordion-icon\"></ng-content>\n      </mat-panel-title>\n      <mat-panel-description>\n        <span *ngIf=\"assistiveText\">{{ assistiveText }}</span>\n      </mat-panel-description>\n      <span class=\"caret-indicator\">\n        <svg\n          class=\"up\"\n          xmlns=\"http://www.w3.org/2000/svg\"\n          width=\"24\"\n          height=\"24\"\n          viewBox=\"0 0 24 24\"\n        >\n          <path d=\"M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z\" />\n          <path d=\"M0 0h24v24H0z\" fill=\"none\" />\n        </svg>\n      </span>\n    </mat-expansion-panel-header>\n    <background-provider-inner color=\"{{ currentBackgroundColor }}\">\n      <ng-content></ng-content>\n    </background-provider-inner>\n  </mat-expansion-panel>\n</mat-accordion>\n" }]
        }], ctorParameters: function () { return [{ type: CssUtils }, { type: i0.ChangeDetectorRef }, { type: i0.ElementRef }]; }, propDecorators: { label: [{
                type: Input
            }], iconSrc: [{
                type: Input
            }], assistiveText: [{
                type: Input
            }], disabled: [{
                type: Input
            }], onClick: [{
                type: Output
            }], margin: [{
                type: Input
            }], padding: [{
                type: Input
            }], isExpanded: [{
                type: Input
            }], defaultIsExpanded: [{
                type: Input
            }], tabIndexValue: [{
                type: Input
            }], className: [{
                type: HostBinding,
                args: ["class"]
            }], _matExpansionPanel: [{
                type: ViewChild,
                args: ["matExpansionPanel", { static: true }]
            }], dxcAccordionIcon: [{
                type: ContentChildren,
                args: [DxcAccordionIconComponent]
            }] } });

class BackgroundProviderInnerModule {
}
BackgroundProviderInnerModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: BackgroundProviderInnerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
BackgroundProviderInnerModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: BackgroundProviderInnerModule, declarations: [BackgroundProviderInnerComponent], imports: [CommonModule], exports: [BackgroundProviderInnerComponent] });
BackgroundProviderInnerModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: BackgroundProviderInnerModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: BackgroundProviderInnerModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [BackgroundProviderInnerComponent],
                    exports: [BackgroundProviderInnerComponent],
                }]
        }] });

class DxcAccordionModule {
}
DxcAccordionModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcAccordionModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DxcAccordionModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcAccordionModule, declarations: [DxcAccordionComponent, DxcAccordionIconComponent], imports: [CommonModule,
        MatExpansionModule,
        MatIconModule,
        BackgroundProviderInnerModule], exports: [DxcAccordionComponent, DxcAccordionIconComponent] });
DxcAccordionModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcAccordionModule, imports: [[
            CommonModule,
            MatExpansionModule,
            MatIconModule,
            BackgroundProviderInnerModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcAccordionModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [DxcAccordionComponent, DxcAccordionIconComponent],
                    imports: [
                        CommonModule,
                        MatExpansionModule,
                        MatIconModule,
                        BackgroundProviderInnerModule,
                    ],
                    exports: [DxcAccordionComponent, DxcAccordionIconComponent],
                }]
        }] });

class AccordionService {
    constructor() {
        this.accordionActive = new BehaviorSubject(undefined);
    }
}
AccordionService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: AccordionService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
AccordionService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: AccordionService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: AccordionService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return []; } });

class DxcAccordionGroupComponent {
    constructor(cssUtils, accordionService, cdRef) {
        this.cssUtils = cssUtils;
        this.accordionService = accordionService;
        this.cdRef = cdRef;
        this._disabled = false;
        /**
         * This event will emit in case the user clicks on an accordion.
         * The index of the clicked accordion will be passed as a parameter.
         */
        this.onActiveChange = new EventEmitter();
        this.defaultInputs = new BehaviorSubject({
            margin: null,
            indexActive: null,
            disabled: false,
        });
    }
    /**
     * The index of the active accordion. If undefined, the component will be uncontrolled and the active accordion will be managed internally by the component.
     * If null, the component will be controlled and all accordions will be closed.
     */
    get indexActive() {
        return this._indexActive;
    }
    set indexActive(value) {
        if (value == null)
            this._indexActive = value;
        else
            this._indexActive = coerceNumberProperty(value);
    }
    /**
     * If true, the component will be disabled.
     */
    get disabled() {
        return this._disabled;
    }
    set disabled(value) {
        this._disabled = coerceBooleanProperty(value);
    }
    ngOnChanges(changes) {
        const inputs = Object.keys(changes).reduce((result, item) => {
            result[item] = changes[item].currentValue;
            return result;
        }, {});
        this.defaultInputs.next({ ...this.defaultInputs.getValue(), ...inputs });
        this.accordionContent = `${this.getDynamicStyle(this.defaultInputs.getValue())}`;
        if (this.indexActive !== undefined &&
            this.accordionService.accordionActive.getValue() !== this.indexActive) {
            this.accordionService.accordionActive.next(this.indexActive);
        }
    }
    ngOnInit() {
        this.accordionContent = `${this.getDynamicStyle(this.defaultInputs.getValue())}`;
    }
    ngAfterContentInit() {
        if (this.indexActive === undefined) {
            this.uncontrolledAccordionGroup();
        }
        else {
            this.controlledAccordionGroup();
        }
        this.setClassNamesAccordions();
        this.cdRef.detectChanges();
    }
    setClassNamesAccordions() {
        this.dxcAccordion.forEach((instance, index) => {
            if (this.dxcAccordion.length === 1 && index === 0) {
                instance.className += " one";
            }
            else if (this.dxcAccordion.length > 1) {
                if (index === 0) {
                    instance.className += " first";
                }
                else if (index === this.dxcAccordion.length - 1) {
                    instance.className += " last";
                }
                else {
                    instance.className += " middle";
                }
            }
        });
    }
    uncontrolledAccordionGroup() {
        this.dxcAccordion.forEach((instance, index) => {
            this.setDisabledAccordion(instance);
            instance.onClickHandler = (event) => {
                if (!instance.disabled) {
                    instance.renderedIsExpanded = !instance.renderedIsExpanded;
                }
                this.accordionService.accordionActive.next(instance.renderedIsExpanded
                    ? index
                    : this.accordionService.accordionActive.getValue() === index &&
                        !instance.renderedIsExpanded &&
                        undefined);
            };
        });
        this.accordionService.accordionActive.subscribe((value) => {
            this.dxcAccordion.forEach((instance, index) => {
                if (value === index) {
                    this.onActiveChange.emit(index);
                }
                this.setIsExpanded(instance, value === index);
            });
        });
    }
    controlledAccordionGroup() {
        this.accordionService.accordionActive.next(this.indexActive);
        this.dxcAccordion.forEach((instance, index) => {
            this.setDisabledAccordion(instance);
            if (index === this.accordionService.accordionActive.getValue()) {
                this.setIsExpanded(instance, true);
            }
            instance.onClickHandler = ($event) => {
                this.onActiveChange.emit(index);
                this.setIsExpanded(instance, this.accordionService.accordionActive.getValue() === index);
            };
        });
        this.accordionService.accordionActive.subscribe((value) => {
            this.dxcAccordion.forEach((instance, index) => {
                this.setIsExpanded(instance, value === index);
            });
        });
    }
    setIsExpanded(instance, value) {
        instance.isExpanded = value;
        instance.renderedIsExpanded = value;
        instance.renderedIsExpanded === true
            ? instance._matExpansionPanel.open()
            : instance._matExpansionPanel.close();
    }
    setDisabledAccordion(instance) {
        if (this.disabled) {
            instance.disabled = true;
        }
    }
    getDynamicStyle(inputs) {
        return css `
      ${this.cssUtils.getMargins(inputs.margin)}
      dxc-accordion {
        margin: 0px;
        width: 100%;
        dxc-accordion-group {
          width: 100%;
        }
      }
      dxc-accordion.one,
      dxc-accordion:not(.first):not(.middle):not(.last) {
        .mat-accordion .mat-expansion-panel {
          border-radius: var(--accordion-borderRadius) !important;
        }
      }
      dxc-accordion.first {
        .mat-accordion .mat-expansion-panel {
          border-top-right-radius: var(--accordion-borderRadius);
          border-top-left-radius: var(--accordion-borderRadius);
          border-bottom-right-radius: 0px;
          border-bottom-left-radius: 0px;
          border-bottom: var(--accordion-accordionGroupSeparatorBorderThickness)
            var(--accordion-accordionGroupSeparatorBorderStyle)
            var(--accordion-accordionGroupSeparatorBorderColor);
        }
      }
      dxc-accordion.middle {
        .mat-accordion .mat-expansion-panel {
          border-bottom-right-radius: 0px;
          border-bottom-left-radius: 0px;
          border-top-right-radius: 0px;
          border-top-left-radius: 0px;
          border-bottom: var(--accordion-accordionGroupSeparatorBorderThickness)
            var(--accordion-accordionGroupSeparatorBorderStyle)
            var(--accordion-accordionGroupSeparatorBorderColor);
        }
      }
      dxc-accordion.last {
        .mat-accordion .mat-expansion-panel {
          border-bottom-right-radius: var(--accordion-borderRadius);
          border-bottom-left-radius: var(--accordion-borderRadius);
          border-top-right-radius: 0px;
          border-top-left-radius: 0px;
        }
      }
    `;
    }
}
DxcAccordionGroupComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcAccordionGroupComponent, deps: [{ token: CssUtils }, { token: AccordionService }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
DxcAccordionGroupComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.5", type: DxcAccordionGroupComponent, selector: "dxc-accordion-group", inputs: { margin: "margin", indexActive: "indexActive", disabled: "disabled" }, outputs: { onActiveChange: "onActiveChange" }, host: { properties: { "class": "this.className" } }, providers: [CssUtils, AccordionService], queries: [{ propertyName: "dxcAccordion", predicate: DxcAccordionComponent }], usesOnChanges: true, ngImport: i0, template: "<div [class]=\"accordionContent\">\n  <ng-content select=\"dxc-accordion\"></ng-content>\n</div>\n" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcAccordionGroupComponent, decorators: [{
            type: Component,
            args: [{ selector: "dxc-accordion-group", providers: [CssUtils, AccordionService], template: "<div [class]=\"accordionContent\">\n  <ng-content select=\"dxc-accordion\"></ng-content>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: CssUtils }, { type: AccordionService }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { margin: [{
                type: Input
            }], indexActive: [{
                type: Input
            }], disabled: [{
                type: Input
            }], onActiveChange: [{
                type: Output
            }], className: [{
                type: HostBinding,
                args: ["class"]
            }], dxcAccordion: [{
                type: ContentChildren,
                args: [DxcAccordionComponent]
            }] } });

class DxcAccordionGroupModule {
}
DxcAccordionGroupModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcAccordionGroupModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DxcAccordionGroupModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcAccordionGroupModule, declarations: [DxcAccordionGroupComponent], imports: [CommonModule,
        MatExpansionModule,
        MatIconModule,
        DxcAccordionModule], exports: [DxcAccordionGroupComponent] });
DxcAccordionGroupModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcAccordionGroupModule, imports: [[
            CommonModule,
            MatExpansionModule,
            MatIconModule,
            DxcAccordionModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcAccordionGroupModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [DxcAccordionGroupComponent],
                    imports: [
                        CommonModule,
                        MatExpansionModule,
                        MatIconModule,
                        DxcAccordionModule
                    ],
                    exports: [DxcAccordionGroupComponent],
                }]
        }] });

class DxcAlertComponent {
    constructor(utils) {
        this.utils = utils;
        /**
         * Uses on of the available alert types.
         */
        this.type = "info";
        /**
         * Uses on of the available alert modes:
         *    'inline': If onClose eventEmitter is received, close button will be visible and the
         *              event will be emitted when it's clicked. There is no overlay layer.
         *              Position should be decided by the user.
         *    'modal': The alert will be displayed in the middle of the screen with an overlay
         *             layer behind. The onClose event will be emitted when the X button or
         *             the overlay is clicked. The user has the responsibility of hidding the modal
         *             in the onClose event, otherwise the modal will remain visible.
         */
        this.mode = "inline";
        this._tabIndexValue = 0;
        /**
         * This event will emit in case the user clicks the close button. If there is no
         * eventEmitter we should close the alert by default.
         */
        this.onClose = new EventEmitter();
        /**
         * Size of the component.
         */
        this.size = "fitContent";
        this.isCloseVisible = false;
        this.sizes = {
            small: "280px",
            medium: "480px",
            large: "820px",
            fillParent: "100%",
            fitContent: "auto",
        };
        this.defaultInputs = new BehaviorSubject({
            type: "info",
            mode: "inline",
            inlineText: null,
            tabIndexValue: 0,
            margin: null,
            size: "fitContent",
        });
    }
    /**
     * Tabindex value given to the close button.
     */
    get tabIndexValue() {
        return this._tabIndexValue;
    }
    set tabIndexValue(value) {
        this._tabIndexValue = coerceNumberProperty(value);
    }
    ngOnInit() {
        this.isCloseVisible = this.onClose.observers.length > 0;
        this.className = `${this.getDynamicStyle(this.defaultInputs.getValue())}`;
    }
    ngOnChanges(changes) {
        const inputs = Object.keys(changes).reduce((result, item) => {
            result[item] = changes[item].currentValue;
            return result;
        }, {});
        this.defaultInputs.next({ ...this.defaultInputs.getValue(), ...inputs });
        this.className = `${this.getDynamicStyle(this.defaultInputs.getValue())}`;
    }
    getDynamicStyle(inputs) {
        return css `
      .container {
        overflow: hidden;
        box-shadow: var(--alert-boxShadowOffsetX) var(--alert-boxShadowOffsetY)
          var(--alert-boxShadowBlur) var(--alert-boxShadowColor);
        border-radius: var(--alert-borderRadius);
        z-index: 300;
        ${this.utils.getMargins(inputs.margin)}
        ${this.utils.calculateWidth(this.sizes, inputs)}
      cursor: default;
        ${inputs.mode && inputs.mode === "modal"
            ? css `
              justify-content: center;
              align-items: center;
            `
            : css ``}
        ${this.setBackgroundColorByAlertType(inputs.type)}
      }
    `;
    }
    setBackgroundColorByAlertType(type) {
        switch (type) {
            case "info":
                this.currentBackgroundColor = this.utils.readProperty("--alert-infoBackgroundColor");
                return css `
          background-color: var(--alert-infoBackgroundColor);
          border-color: var(--alert-infoBorderColor);
          .icon svg {
            fill: var(--alert-infoIconColor);
          }
        `;
            case "confirm":
                this.currentBackgroundColor = this.utils.readProperty("--alert-successBackgroundColor");
                return css `
          background-color: var(--alert-successBackgroundColor);
          border-color: var(--alert-successBorderColor);
          .icon svg {
            fill: var(--alert-successIconColor);
          }
        `;
            case "warning":
                this.currentBackgroundColor = this.utils.readProperty("--alert-warningBackgroundColor");
                return css `
          background-color: var(--alert-warningBackgroundColor);
          border-color: var(--alert-warningBorderColor);
          .icon svg {
            fill: var(--alert-warningIconColor);
          }
        `;
            case "error":
                this.currentBackgroundColor = this.utils.readProperty("--alert-errorBackgroundColor");
                return css `
          background-color: var(--alert-errorBackgroundColor);
          border-color: var(--alert-errorBorderColor);
          .icon svg {
            fill: var(--alert-errorIconColor);
          }
        `;
            default:
                this.currentBackgroundColor = this.utils.readProperty("--alert-errorBackgroundColor");
                return css `
          background-color: var(--alert-errorBackgroundColor);
          border-color: var(--alert-errorBorderColor);
          .icon svg {
            fill: var(--alert-errorIconColor);
          }
        `;
        }
    }
    onCloseHandler($event) {
        this.onClose.emit($event);
    }
    ngAfterViewChecked() {
        if (this.content &&
            this.content.element &&
            this.content.element.nativeElement &&
            (this.content.element.nativeElement.children.length > 0 ||
                this.content.element.nativeElement.innerText)) {
            this.content.element.nativeElement.classList.add("content");
        }
    }
}
DxcAlertComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcAlertComponent, deps: [{ token: CssUtils }], target: i0.ɵɵFactoryTarget.Component });
DxcAlertComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.5", type: DxcAlertComponent, selector: "dxc-alert", inputs: { type: "type", mode: "mode", inlineText: "inlineText", tabIndexValue: "tabIndexValue", margin: "margin", size: "size" }, outputs: { onClose: "onClose" }, host: { properties: { "class": "this.className" } }, providers: [CssUtils, BackgroundProviderService], viewQueries: [{ propertyName: "content", first: true, predicate: ["contents"], descendants: true, static: true }], usesOnChanges: true, ngImport: i0, template: "<div class=\"alert\" [ngClass]=\"{ modal: mode == 'modal' }\">\n  <div\n    class=\"backOverlay\"\n    (click)=\"onCloseHandler($event)\"\n    [ngClass]=\"{ backVisible: mode == 'modal' }\"\n    *ngIf=\"mode == 'modal'\"\n  ></div>\n  <div\n    class=\"container\"\n    [ngClass]=\"{\n      infoHeader: type == 'info',\n      warningHeader: type == 'warning',\n      errorHeader: type == 'error',\n      confirmHeader: type == 'confirm'\n    }\"\n  >\n    <div class=\"alertHeader\">\n      <div *ngIf=\"type == 'info'\" class=\"headerLabel\">\n        <div class=\"icon\">\n          <svg\n            xmlns=\"http://www.w3.org/2000/svg\"\n            width=\"24\"\n            height=\"24\"\n            viewBox=\"0 0 24 24\"\n            fill=\"#0067b3\"\n          >\n            <path d=\"M0 0h24v24H0z\" fill=\"none\" />\n            <path\n              d=\"M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z\"\n            />\n          </svg>\n        </div>\n        <span class=\"mainLabel\"> information </span>\n      </div>\n      <div *ngIf=\"type == 'warning'\" class=\"headerLabel\">\n        <div class=\"icon\">\n          <svg\n            xmlns=\"http://www.w3.org/2000/svg\"\n            width=\"24\"\n            height=\"24\"\n            viewBox=\"0 0 24 24\"\n            fill=\"#c59f07\"\n          >\n            <path d=\"M0 0h24v24H0z\" fill=\"none\" />\n            <path d=\"M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z\" />\n          </svg>\n        </div>\n        <span class=\"mainLabel\"> warning </span>\n      </div>\n      <div *ngIf=\"type == 'error'\" class=\"headerLabel\">\n        <div class=\"icon\">\n          <svg\n            xmlns=\"http://www.w3.org/2000/svg\"\n            width=\"24\"\n            height=\"24\"\n            viewBox=\"0 0 24 24\"\n            fill=\"#d0011b\"\n          >\n            <path\n              d=\"M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z\"\n            />\n            <path d=\"M0 0h24v24H0z\" fill=\"none\" />\n          </svg>\n        </div>\n        <span class=\"mainLabel\"> error </span>\n      </div>\n      <div *ngIf=\"type == 'confirm'\" class=\"headerLabel\">\n        <div class=\"icon\">\n          <svg\n            xmlns=\"http://www.w3.org/2000/svg\"\n            width=\"24\"\n            height=\"24\"\n            viewBox=\"0 0 24 24\"\n            fill=\"#24a148\"\n          >\n            <path d=\"M0 0h24v24H0z\" fill=\"none\" />\n            <path\n              d=\"M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z\"\n            />\n          </svg>\n        </div>\n        <span class=\"mainLabel\"> success </span>\n      </div>\n      <span *ngIf=\"inlineText\" class=\"spacer\"> - </span>\n      <div class=\"inlineContainer\">\n        <span *ngIf=\"inlineText\" class=\"inlineText\"> {{ inlineText }} </span>\n        <span\n          class=\"closeIcon\"\n          *ngIf=\"isCloseVisible || mode == 'modal'\"\n          (click)=\"onCloseHandler($event)\"\n          data-testId=\"closeIcon\"\n          [tabindex]=\"tabIndexValue\"\n        >\n          <svg\n            xmlns=\"http://www.w3.org/2000/svg\"\n            width=\"24\"\n            height=\"24\"\n            viewBox=\"0 0 24 24\"\n          >\n            <path\n              d=\"M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z\"\n            />\n            <path d=\"M0 0h24v24H0z\" fill=\"none\" />\n          </svg>\n        </span>\n      </div>\n    </div>\n    <background-provider-inner #contents class=\"contentContainer\" color=\"{{currentBackgroundColor}}\">\n      <ng-content></ng-content>\n    </background-provider-inner>\n  </div>\n</div>\n", styles: [":host .alert{display:flex}:host .alert.modal{width:100%;height:100%;justify-content:center;align-items:center;top:0;left:0;position:fixed;z-index:1000}:host .alert.modal .container{max-height:50vh;height:auto}:host .alert.modal .container .contentContainer.content{display:block;overflow:auto}:host .alert.modal .container .contentContainer.content ::ng-deep span{display:block}:host .backOverlay{top:0;left:0;right:0;bottom:0;position:fixed;opacity:1;background-color:transparent;transition:opacity 225ms cubic-bezier(.4,0,.2,1) 0ms}:host .backVisible{background-color:var(--alert-overlayColor);opacity:.8}:host .container{outline:none;opacity:1;transition:opacity 225ms cubic-bezier(.4,0,.2,1) 0ms;box-shadow:var(--alert-boxShadowColor) var(--alert-boxShadowOffsetX) var(--alert-boxShadowOffsetY) var(--alert-boxShadowBlur);border-radius:var(--alert-borderRadius);border-style:var(--alert-borderStyle);border-width:var(--alert-borderThickness);z-index:1;padding-left:12px;padding-right:12px}:host .container .alertHeader{height:48px;position:relative;color:var(--alert-titleFontColor);transition:box-shadow .3s cubic-bezier(.4,0,.2,1) 0ms;display:flex;align-items:center}:host .container .alertHeader .inlineContainer{display:flex;flex-grow:1;overflow:hidden;align-items:center}:host .container .alertHeader .headerLabel{display:flex;align-items:center}:host .container .alertHeader .headerLabel .icon{padding-left:var(--alert-iconPaddingLeft);padding-right:var(--alert-iconPaddingRight);padding-top:var(--alert-iconPaddingTop);padding-bottom:var(--alert-iconPaddingBottom);display:inline-flex;width:var(--alert-iconSize);border-top-left-radius:4px;border-bottom-left-radius:4px;margin-right:12px}:host .container .alertHeader .headerLabel .mainLabel{padding-left:var(--alert-titlePaddingLeft);padding-right:var(--alert-titlePaddingRight);padding-top:var(--alert-titlePaddingTop);padding-bottom:var(--alert-titlePaddingBottom);font-family:var(--alert-titleFontFamily);font-weight:var(--alert-titleFontWeight);font-style:var(--alert-titleFontStyle);font-size:var(--alert-titleFontSize);text-transform:var(--alert-titleTextTransform);color:var(--alert-titleFontColor);margin-right:8px}:host .container .alertHeader .closeIcon{display:flex;justify-content:flex-end;margin-right:12px;padding:3px;margin-left:12px}:host .container .alertHeader .closeIcon svg{cursor:pointer;width:20px;height:20px}:host .container .alertHeader .closeIcon:hover{background-color:var(--alert-hoverActionBackgroundColor)}:host .container .alertHeader .closeIcon:focus,:host .container .alertHeader .closeIcon:focus-visible{outline-color:var(--alert-focusActionBorderColor)}:host .container .alertHeader .closeIcon:active{outline-color:var(--alert-focusActionBorderColor);outline:-webkit-focus-ring-color auto 1px;background-color:var(--alert-activeActionBackgroundColor)}:host .container .alertHeader .spacer{font-family:var(--alert-titleFontFamily);font-size:var(--alert-titleFontSize)}:host .container .alertHeader .inlineText{width:100%;font-family:var(--alert-inlineTextFontFamily);font-size:var(--alert-inlineTextFontSize);color:var(--alert-inlineTextFontColor);font-style:var(--alert-inlineTextFontStyle);font-weight:var(--alert-inlineTextFontWeight);text-overflow:ellipsis;white-space:nowrap;overflow:hidden;padding-left:var(--alert-inlineTextPaddingLeft);padding-right:var(--alert-inlineTextPaddingRight);padding-top:var(--alert-inlineTextPaddingTop);padding-bottom:var(--alert-inlineTextPaddingBottom);margin-left:8px}:host .container .contentContainer:not(.content){display:none}:host .container .content{display:block;padding:var(--alert-contentPaddingTop) var(--alert-contentPaddingRight) var(--alert-contentPaddingBottom) var(--alert-contentPaddingLeft)}\n"], components: [{ type: BackgroundProviderInnerComponent, selector: "background-provider-inner", inputs: ["color"] }], directives: [{ type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcAlertComponent, decorators: [{
            type: Component,
            args: [{ selector: "dxc-alert", providers: [CssUtils, BackgroundProviderService], template: "<div class=\"alert\" [ngClass]=\"{ modal: mode == 'modal' }\">\n  <div\n    class=\"backOverlay\"\n    (click)=\"onCloseHandler($event)\"\n    [ngClass]=\"{ backVisible: mode == 'modal' }\"\n    *ngIf=\"mode == 'modal'\"\n  ></div>\n  <div\n    class=\"container\"\n    [ngClass]=\"{\n      infoHeader: type == 'info',\n      warningHeader: type == 'warning',\n      errorHeader: type == 'error',\n      confirmHeader: type == 'confirm'\n    }\"\n  >\n    <div class=\"alertHeader\">\n      <div *ngIf=\"type == 'info'\" class=\"headerLabel\">\n        <div class=\"icon\">\n          <svg\n            xmlns=\"http://www.w3.org/2000/svg\"\n            width=\"24\"\n            height=\"24\"\n            viewBox=\"0 0 24 24\"\n            fill=\"#0067b3\"\n          >\n            <path d=\"M0 0h24v24H0z\" fill=\"none\" />\n            <path\n              d=\"M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z\"\n            />\n          </svg>\n        </div>\n        <span class=\"mainLabel\"> information </span>\n      </div>\n      <div *ngIf=\"type == 'warning'\" class=\"headerLabel\">\n        <div class=\"icon\">\n          <svg\n            xmlns=\"http://www.w3.org/2000/svg\"\n            width=\"24\"\n            height=\"24\"\n            viewBox=\"0 0 24 24\"\n            fill=\"#c59f07\"\n          >\n            <path d=\"M0 0h24v24H0z\" fill=\"none\" />\n            <path d=\"M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z\" />\n          </svg>\n        </div>\n        <span class=\"mainLabel\"> warning </span>\n      </div>\n      <div *ngIf=\"type == 'error'\" class=\"headerLabel\">\n        <div class=\"icon\">\n          <svg\n            xmlns=\"http://www.w3.org/2000/svg\"\n            width=\"24\"\n            height=\"24\"\n            viewBox=\"0 0 24 24\"\n            fill=\"#d0011b\"\n          >\n            <path\n              d=\"M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z\"\n            />\n            <path d=\"M0 0h24v24H0z\" fill=\"none\" />\n          </svg>\n        </div>\n        <span class=\"mainLabel\"> error </span>\n      </div>\n      <div *ngIf=\"type == 'confirm'\" class=\"headerLabel\">\n        <div class=\"icon\">\n          <svg\n            xmlns=\"http://www.w3.org/2000/svg\"\n            width=\"24\"\n            height=\"24\"\n            viewBox=\"0 0 24 24\"\n            fill=\"#24a148\"\n          >\n            <path d=\"M0 0h24v24H0z\" fill=\"none\" />\n            <path\n              d=\"M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z\"\n            />\n          </svg>\n        </div>\n        <span class=\"mainLabel\"> success </span>\n      </div>\n      <span *ngIf=\"inlineText\" class=\"spacer\"> - </span>\n      <div class=\"inlineContainer\">\n        <span *ngIf=\"inlineText\" class=\"inlineText\"> {{ inlineText }} </span>\n        <span\n          class=\"closeIcon\"\n          *ngIf=\"isCloseVisible || mode == 'modal'\"\n          (click)=\"onCloseHandler($event)\"\n          data-testId=\"closeIcon\"\n          [tabindex]=\"tabIndexValue\"\n        >\n          <svg\n            xmlns=\"http://www.w3.org/2000/svg\"\n            width=\"24\"\n            height=\"24\"\n            viewBox=\"0 0 24 24\"\n          >\n            <path\n              d=\"M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z\"\n            />\n            <path d=\"M0 0h24v24H0z\" fill=\"none\" />\n          </svg>\n        </span>\n      </div>\n    </div>\n    <background-provider-inner #contents class=\"contentContainer\" color=\"{{currentBackgroundColor}}\">\n      <ng-content></ng-content>\n    </background-provider-inner>\n  </div>\n</div>\n", styles: [":host .alert{display:flex}:host .alert.modal{width:100%;height:100%;justify-content:center;align-items:center;top:0;left:0;position:fixed;z-index:1000}:host .alert.modal .container{max-height:50vh;height:auto}:host .alert.modal .container .contentContainer.content{display:block;overflow:auto}:host .alert.modal .container .contentContainer.content ::ng-deep span{display:block}:host .backOverlay{top:0;left:0;right:0;bottom:0;position:fixed;opacity:1;background-color:transparent;transition:opacity 225ms cubic-bezier(.4,0,.2,1) 0ms}:host .backVisible{background-color:var(--alert-overlayColor);opacity:.8}:host .container{outline:none;opacity:1;transition:opacity 225ms cubic-bezier(.4,0,.2,1) 0ms;box-shadow:var(--alert-boxShadowColor) var(--alert-boxShadowOffsetX) var(--alert-boxShadowOffsetY) var(--alert-boxShadowBlur);border-radius:var(--alert-borderRadius);border-style:var(--alert-borderStyle);border-width:var(--alert-borderThickness);z-index:1;padding-left:12px;padding-right:12px}:host .container .alertHeader{height:48px;position:relative;color:var(--alert-titleFontColor);transition:box-shadow .3s cubic-bezier(.4,0,.2,1) 0ms;display:flex;align-items:center}:host .container .alertHeader .inlineContainer{display:flex;flex-grow:1;overflow:hidden;align-items:center}:host .container .alertHeader .headerLabel{display:flex;align-items:center}:host .container .alertHeader .headerLabel .icon{padding-left:var(--alert-iconPaddingLeft);padding-right:var(--alert-iconPaddingRight);padding-top:var(--alert-iconPaddingTop);padding-bottom:var(--alert-iconPaddingBottom);display:inline-flex;width:var(--alert-iconSize);border-top-left-radius:4px;border-bottom-left-radius:4px;margin-right:12px}:host .container .alertHeader .headerLabel .mainLabel{padding-left:var(--alert-titlePaddingLeft);padding-right:var(--alert-titlePaddingRight);padding-top:var(--alert-titlePaddingTop);padding-bottom:var(--alert-titlePaddingBottom);font-family:var(--alert-titleFontFamily);font-weight:var(--alert-titleFontWeight);font-style:var(--alert-titleFontStyle);font-size:var(--alert-titleFontSize);text-transform:var(--alert-titleTextTransform);color:var(--alert-titleFontColor);margin-right:8px}:host .container .alertHeader .closeIcon{display:flex;justify-content:flex-end;margin-right:12px;padding:3px;margin-left:12px}:host .container .alertHeader .closeIcon svg{cursor:pointer;width:20px;height:20px}:host .container .alertHeader .closeIcon:hover{background-color:var(--alert-hoverActionBackgroundColor)}:host .container .alertHeader .closeIcon:focus,:host .container .alertHeader .closeIcon:focus-visible{outline-color:var(--alert-focusActionBorderColor)}:host .container .alertHeader .closeIcon:active{outline-color:var(--alert-focusActionBorderColor);outline:-webkit-focus-ring-color auto 1px;background-color:var(--alert-activeActionBackgroundColor)}:host .container .alertHeader .spacer{font-family:var(--alert-titleFontFamily);font-size:var(--alert-titleFontSize)}:host .container .alertHeader .inlineText{width:100%;font-family:var(--alert-inlineTextFontFamily);font-size:var(--alert-inlineTextFontSize);color:var(--alert-inlineTextFontColor);font-style:var(--alert-inlineTextFontStyle);font-weight:var(--alert-inlineTextFontWeight);text-overflow:ellipsis;white-space:nowrap;overflow:hidden;padding-left:var(--alert-inlineTextPaddingLeft);padding-right:var(--alert-inlineTextPaddingRight);padding-top:var(--alert-inlineTextPaddingTop);padding-bottom:var(--alert-inlineTextPaddingBottom);margin-left:8px}:host .container .contentContainer:not(.content){display:none}:host .container .content{display:block;padding:var(--alert-contentPaddingTop) var(--alert-contentPaddingRight) var(--alert-contentPaddingBottom) var(--alert-contentPaddingLeft)}\n"] }]
        }], ctorParameters: function () { return [{ type: CssUtils }]; }, propDecorators: { type: [{
                type: Input
            }], mode: [{
                type: Input
            }], inlineText: [{
                type: Input
            }], tabIndexValue: [{
                type: Input
            }], onClose: [{
                type: Output
            }], margin: [{
                type: Input
            }], size: [{
                type: Input
            }], className: [{
                type: HostBinding,
                args: ["class"]
            }], content: [{
                type: ViewChild,
                args: ["contents", { static: true }]
            }] } });

class DxcAlertModule {
}
DxcAlertModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcAlertModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DxcAlertModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcAlertModule, declarations: [DxcAlertComponent], imports: [CommonModule, MatSnackBarModule, BackgroundProviderInnerModule], exports: [DxcAlertComponent] });
DxcAlertModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcAlertModule, imports: [[CommonModule, MatSnackBarModule, BackgroundProviderInnerModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcAlertModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [DxcAlertComponent],
                    imports: [CommonModule, MatSnackBarModule, BackgroundProviderInnerModule],
                    exports: [DxcAlertComponent],
                }]
        }] });

class DxcBoxComponent {
    constructor(utils) {
        this.utils = utils;
        /**
         * The size of the shadow to be displayed around the box.
         */
        this.shadowDepth = 2;
        /**
         * Changes the display CSS property of the box div.
         */
        this.display = "inline-flex";
        /**
         * Size of the component.
         */
        this.size = "fitContent";
        this.sizes = {
            small: "60px",
            medium: "240px",
            large: "480px",
            fillParent: "100%",
            fitContent: "fit-content",
        };
        this.defaultInputs = new BehaviorSubject({
            display: "inline-flex",
            shadowDepth: 2,
            margin: null,
            padding: null,
            size: null,
        });
    }
    calculateWidth(inputs) {
        if (inputs.size === undefined || inputs.size === null) {
            return css `
        width: unset;
      `;
        }
        if (inputs.size !== "fitContent") {
            return this.utils.calculateWidth(this.sizes, inputs);
        }
        return css `
      width: ${this.sizes[inputs.size]};
    `;
    }
    ngOnChanges(changes) {
        const inputs = Object.keys(changes).reduce((result, item) => {
            result[item] = changes[item].currentValue;
            return result;
        }, {});
        this.currentBackgroundColor = this.utils.readProperty("--box-backgroundColor");
        this.defaultInputs.next({ ...this.defaultInputs.getValue(), ...inputs });
        this.className = `${this.getDynamicStyle(this.defaultInputs.getValue())}`;
    }
    ngOnInit() {
        this.className = `${this.getDynamicStyle(this.defaultInputs.getValue())}`;
    }
    getDynamicStyle(inputs) {
        return css `
      display: ${inputs.display};
      border: var(--box-borderThickness) solid;
      border-radius: var(--box-borderRadius);
      border-color: var(--box-borderColor);
      overflow: hidden;
      background-color: var(--box-backgroundColor);
      letter-spacing: var(--box-letterSpacing);

      ${this.utils.getBoxShadow(inputs.shadowDepth)}
      ${this.utils.getMargins(inputs.margin)}
      ${this.utils.getPaddings(inputs.padding)}
      ${this.calculateWidth(inputs)}
    `;
    }
}
DxcBoxComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcBoxComponent, deps: [{ token: CssUtils }], target: i0.ɵɵFactoryTarget.Component });
DxcBoxComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.5", type: DxcBoxComponent, selector: "dxc-box", inputs: { shadowDepth: "shadowDepth", display: "display", margin: "margin", padding: "padding", size: "size" }, host: { properties: { "class": "this.className" } }, providers: [CssUtils, BackgroundProviderService], usesOnChanges: true, ngImport: i0, template: "\n<background-provider-inner [color]=\"currentBackgroundColor\">\n  <ng-content></ng-content>\n</background-provider-inner>\n\n", components: [{ type: BackgroundProviderInnerComponent, selector: "background-provider-inner", inputs: ["color"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcBoxComponent, decorators: [{
            type: Component,
            args: [{ selector: "dxc-box", providers: [CssUtils, BackgroundProviderService], template: "\n<background-provider-inner [color]=\"currentBackgroundColor\">\n  <ng-content></ng-content>\n</background-provider-inner>\n\n" }]
        }], ctorParameters: function () { return [{ type: CssUtils }]; }, propDecorators: { className: [{
                type: HostBinding,
                args: ["class"]
            }], shadowDepth: [{
                type: Input
            }], display: [{
                type: Input
            }], margin: [{
                type: Input
            }], padding: [{
                type: Input
            }], size: [{
                type: Input
            }] } });

class DxcBoxModule {
}
DxcBoxModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcBoxModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DxcBoxModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcBoxModule, declarations: [DxcBoxComponent], imports: [CommonModule, BackgroundProviderInnerModule], exports: [DxcBoxComponent] });
DxcBoxModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcBoxModule, imports: [[CommonModule, BackgroundProviderInnerModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcBoxModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [DxcBoxComponent],
                    imports: [CommonModule, BackgroundProviderInnerModule],
                    exports: [DxcBoxComponent],
                }]
        }] });

class DxcButtonIconComponent {
    constructor() { }
    ngOnChanges() {
    }
}
DxcButtonIconComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcButtonIconComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
DxcButtonIconComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.5", type: DxcButtonIconComponent, selector: "dxc-button-icon", usesOnChanges: true, ngImport: i0, template: "<ng-content></ng-content>" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcButtonIconComponent, decorators: [{
            type: Component,
            args: [{ selector: "dxc-button-icon", template: "<ng-content></ng-content>" }]
        }], ctorParameters: function () { return []; } });

class DxcButtonComponent {
    constructor(utils, cdRef, bgProviderService) {
        this.utils = utils;
        this.cdRef = cdRef;
        this.bgProviderService = bgProviderService;
        /**
         * Uses one of the available button modes.
         */
        this.mode = "primary";
        this._disabled = false;
        /**
         * Whether the icon should appear after or before the label.
         */
        this.iconPosition = "before";
        /**
         * Size of the component.
         */
        this.size = "fitContent";
        /**
         * This prop corresponds to the 'type' prop of the button in html.
         */
        this.type = "button";
        this._tabIndexValue = 0;
        /**
         * This function will be called when the user clicks the button.
         */
        this.onClick = new EventEmitter();
        this.lightBackground = true;
        this.darkBackground = false;
        this.defaultInputs = new BehaviorSubject({
            mode: "primary",
            disabled: false,
            label: null,
            iconSrc: null,
            iconPosition: "before",
            margin: null,
            size: "fitContent",
            tabIndexValue: 0,
            type: "button"
        });
        this.sizes = {
            small: "42px",
            medium: "120px",
            large: "240px",
            fillParent: "100%",
            fitContent: "unset",
        };
        this.bgProviderService.$changeColor.subscribe((value) => {
            if (value === "dark") {
                this.lightBackground = false;
                this.darkBackground = true;
            }
            else if (value === "light") {
                this.lightBackground = true;
                this.darkBackground = false;
            }
            this.className = `${this.getDynamicStyle(this.defaultInputs.getValue())}`;
        });
    }
    /**
     * If true, the component will be disabled.
     */
    get disabled() {
        return this._disabled;
    }
    set disabled(value) {
        this._disabled = coerceBooleanProperty(value);
    }
    /**
     * Value of the tabindex attribute.
     */
    get tabIndexValue() {
        return this._tabIndexValue;
    }
    set tabIndexValue(value) {
        this._tabIndexValue = coerceNumberProperty(value);
    }
    ngAfterViewInit() {
        if (this.dxcButtonIcon?.length !== 0) {
            this.iconSrc = "";
        }
        this.cdRef.detectChanges();
    }
    ngOnChanges(changes) {
        if (this.iconPosition !== "after") {
            this.iconPosition = "before";
        }
        const inputs = Object.keys(changes).reduce((result, item) => {
            result[item] = changes[item].currentValue;
            return result;
        }, {});
        this.defaultInputs.next({ ...this.defaultInputs.getValue(), ...inputs });
        this.className = `${this.getDynamicStyle(this.defaultInputs.getValue())}`;
    }
    ngOnInit() {
        this.className = `${this.getDynamicStyle(this.defaultInputs.getValue())}`;
    }
    onClickHandler($event) {
        this.onClick.emit($event);
    }
    setPadding(size) {
        if (size === "small") {
            return css `
        padding: 11px;
        min-width: calc(100% - 22px);
      `;
        }
        return css `
      min-width: unset;
    `;
    }
    getDynamicStyle(inputs) {
        return css `
      ${this.utils.getMargins(inputs.margin)}
      ${this.getModeStyle()}
      ${this.utils.calculateWidth(this.sizes, inputs)}
      display: inline-flex;
      vertical-align: middle;
      .dxcButton {
        padding-top: var(--button-paddingTop);
        padding-bottom: var(--button-paddingBottom);
        padding-left: var(--button-paddingLeft);
        padding-right: var(--button-paddingRight);
        ${this.setPadding(inputs.size)}
        width: 100%;
        height: 40px;
        line-height: var(--button-labelFontLineHeight);
        letter-spacing: var(--button-labelLetterSpacing);
        white-space: normal;
        display: inline-flex;
        align-items: center;
        span.mat-button-wrapper {
          width: 100%;
          display: flex;
          align-items: inherit;
          justify-content: center;
          ${this.iconPosition === "after"
            ? "flex-direction: row-reverse;"
            : "flex-direction: row;"}

          & > span {
            margin: 0 8px;
            display: block;
            width: 100%;
            z-index: 20;
            white-space: normal;
            overflow: hidden;
            text-overflow: ellipsis;
            text-align: center;
          }
          dxc-button-icon {
            display: flex;
          }
          img,
          svg {
            ${this.label
            ? this.iconPosition === "before"
                ? "margin-left: 8px;"
                : "margin-right: 8px;"
            : ""}
            height: 100%;
            width: 100%;
            z-index: 20;
          }
          mat-icon {
            font-size: 24px;
            width: auto;
            height: auto;
            margin-bottom: -2.5px;
            margin-top: -2.5px;
          }

          i {
            font-size: 18px;
            margin-bottom: -2.5px;
            margin-top: -2.5px;
          }

          mat-icon:first-child,
          i:first-child {
            margin-right: 6px;

            &:last-child {
              margin-right: 6px;
              margin-left: 6px;
            }
          }

          span + mat-icon,
          span + i {
            margin-left: 6px;
          }
        }

        &:attr(disabled) {
          cursor: not-allowed;
        }

        &:disabled {
          cursor: not-allowed;
        }
      }
    `;
    }
    getModeStyle() {
        if (this.mode === "secondary") {
            return this.getSecondaryStyle();
        }
        else if (this.mode === "text") {
            return this.getTextStyle();
        }
        else {
            return this.getPrimaryStyle();
        }
    }
    getPrimaryStyle() {
        return css `
      ${this.lightBackground
            ? this.getPrimaryLightStyle()
            : this.getPrimaryDarkStyle()}
      button {
        span.mat-button-ripple {
          border-style: var(--button-primaryBorderStyle);
          border-radius: var(--button-primaryBorderRadius);
          border-width: var(--button-primaryBorderThickness);
        }
        .mat-button-wrapper,
        .mat-button-wrapper span {
          font-family: var(--button-primaryFontFamily) !important;
          font-size: var(--button-primaryFontSize) !important;
          font-weight: var(--button-primaryFontWeight) !important;
        }
      }
    `;
    }
    getSecondaryStyle() {
        return css `
      ${this.lightBackground
            ? this.getSecondaryLightStyle()
            : this.getSecondaryDarkStyle()}
      button {
        padding-top: var(--button-secondaryPaddingTop);
        padding-bottom: var(--button-secondaryPaddingBottom);
        span.mat-button-ripple {
          border-style: var(--button-secondaryBorderStyle);
          border-radius: var(--button-secondaryBorderRadius);
          border-width: var(--button-secondaryBorderThickness);
        }
        .mat-button-wrapper span {
          font-family: var(--button-secondaryFontFamily) !important;
          font-size: var(--button-secondaryFontSize) !important;
          font-weight: var(--button-secondaryFontWeight) !important;
        }
      }
    `;
    }
    getTextStyle() {
        return css `
      ${this.lightBackground
            ? this.getTextLightStyle()
            : this.getTextDarkStyle()}
      button {
        padding-top: var(--button-textPaddingTop);
        padding-bottom: var(--button-textPaddingBottom);
        span.mat-button-ripple {
          border-style: var(--button-textBorderStyle);
          border-radius: var(--button-textBorderRadius);
          border-width: var(--button-textBorderThickness);
        }
        .mat-button-wrapper span {
          font-family: var(--button-textFontFamily) !important;
          font-size: var(--button-textFontSize) !important;
          font-weight: var(--button-textFontWeight) !important;
        }
        &:hover:not([disabled]) {
          background: var(--button-textHoverBackgroundColor);
          color: #ffffff;
        }
        &:disabled {
          background: var(--button-textDisabledBackgroundColor);
          color: var(--button-textDisabledFontColor) !important;
        }
        &:active:not([disabled]) {
          background: var(--button-textActiveBackgroundColor);
        }
      }
    `;
    }
    getPrimaryLightStyle() {
        return css `
      button {
        background: var(--button-primaryBackgroundColor);
        color: var(--button-primaryFontColor);
        span.mat-button-ripple {
          border-color: transparent;
        }
        &:hover:not([disabled]) {
          background: var(--button-primaryHoverBackgroundColor);
          color: #ffffff;
        }
        &:disabled {
          background: var(--button-primaryDisabledBackgroundColor);
          color: var(--button-primaryDisabledFontColor) !important;
        }
        &:focus:not([disabled]) {
          box-shadow: var(--button-focusBorderColor) 0px 0px 0px 2px;
        }
        &:active:not([disabled]) {
          background: var(--button-primaryActiveBackgroundColor);
        }
      }
    `;
    }
    getPrimaryDarkStyle() {
        return css `
      button {
        background: var(--button-primaryBackgroundColorOnDark);
        color: var(--button-primaryFontColorOnDark);
        span.mat-button-ripple {
          border-color: transparent;
        }
        &:hover:not([disabled]) {
          background: var(--button-primaryHoverBackgroundColorOnDark);
          color: #ffffff;
        }
        &:disabled {
          background: var(--button-primaryDisabledBackgroundColorOnDark);
          color: var(--button-primaryDisabledFontColorOnDark) !important;
        }
        &:focus:not([disabled]) {
          box-shadow: var(--button-focusBorderColorOnDark) 0px 0px 0px 2px;
        }
        &:active:not([disabled]) {
          background: var(--button-primaryActiveBackgroundColorOnDark);
          color: #ffffff;
        }
      }
    `;
    }
    getSecondaryLightStyle() {
        return css `
      button {
        color: var(--button-secondaryFontColor);
        background-color: var(--button-secondaryBackgroundColor);
        span.mat-button-ripple {
          border-color: var(--button-secondaryBorderColor);
        }
        &:hover:not([disabled]) {
          span.mat-button-ripple {
            border-color: #5f249f;
          }
          background: var(--button-secondaryHoverBackgroundColor);
          color: var(--button-secondaryHoverFontColor);
        }
        &:disabled {
          background-color: var(--button-secondaryDisabledBackgroundColor);
          color: var(--button-secondaryDisabledFontColor) !important;
          span.mat-button-ripple {
            border-color: var(--button-secondaryDisabledBorderColor);
          }
        }
        &:focus {
          box-shadow: var(--button-focusBorderColor) 0px 0px 0px 2px;
          background-color: var(--button-secondaryBackgroundColor);
        }
        &:active:not([disabled]) {
          background: var(--button-secondaryActiveBackgroundColor);
          color: var(--button-secondaryHoverFontColor);
          span.mat-button-ripple {
            border-color: var(--button-secondaryBorderColor);
          }
        }
      }
    `;
    }
    getSecondaryDarkStyle() {
        return css `
      button {
        color: var(--button-secondaryFontColorOnDark);
        background-color: var(--button-secondaryBackgroundColorOnDark);
        span.mat-button-ripple {
          border-color: var(--button-secondaryBorderColorOnDark);
        }
        &:hover:not([disabled]) {
          span.mat-button-ripple {
            border-color: #ffffff;
          }
          background: var(--button-secondaryHoverBackgroundColorOnDark);
          color: var(--button-secondaryHoverFontColorOnDark);
        }
        &:disabled {
          background-color: var(
            --button-secondaryDisabledBackgroundColorOnDark
          );
          border-color: var(--button-secondaryDisabledBorderColorOnDark);
          color: var(--button-secondaryDisabledFontColorOnDark) !important;
          span.mat-button-ripple {
            border-color: var(--button-secondaryDisabledBorderColorOnDark);
          }
        }
        &:focus {
          box-shadow: var(--button-focusBorderColorOnDark) 0px 0px 0px 2px;
          background-color: var(--button-secondaryBackgroundColorOnDark);
        }
        &:active:not([disabled]) {
          span.mat-button-ripple {
            border-color: var(--button-secondaryBorderColorOnDark);
          }
          background: var(--button-secondaryActiveBackgroundColorOnDark);
          color: var(--button-secondaryHoverFontColorOnDark);
        }
      }
    `;
    }
    getTextLightStyle() {
        return css `
      button {
        background-color: var(--button-textBackgroundColor);
        color: var(--button-textFontColor);
        span.mat-button-ripple {
          border-color: transparent;
        }
        &:hover:not([disabled]) {
          background: var(--button-textHoverBackgroundColor);
        }
        &:disabled {
          color: var(--button-textDisabledFontColor) !important;
          background: var(--button-textDisabledBackgroundColor);
        }
        &:focus {
          box-shadow: var(--button-focusBorderColor) 0px 0px 0px 2px;
          background-color: var(--button-textBackgroundColor);
        }
        &:active:not([disabled]) {
          background-color: var(--button-textActiveBackgroundColor);
        }
      }
    `;
    }
    getTextDarkStyle() {
        return css `
      button {
        background-color: var(--button-textBackgroundColorOnDark);
        color: var(--button-textFontColorOnDark);
        span.mat-button-ripple {
          border-color: transparent;
        }
        &:hover:not([disabled]) {
          background: var(--button-textHoverBackgroundColorOnDark);
          color: #ffffff;
        }
        &:disabled {
          color: var(--button-textDisabledFontColorOnDark) !important;
          background: var(--button-textDisabledBackgroundColorOnDark);
        }
        &:focus {
          box-shadow: var(--button-focusBorderColorOnDark) 0px 0px 0px 2px;
          background-color: var(--button-textBackgroundColorOnDark);
        }
        &:active:not([disabled]) {
          background-color: var(--button-textActiveBackgroundColorOnDark);
          color: #ffffff;
        }
      }
    `;
    }
}
DxcButtonComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcButtonComponent, deps: [{ token: CssUtils }, { token: i0.ChangeDetectorRef }, { token: BackgroundProviderService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
DxcButtonComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.5", type: DxcButtonComponent, selector: "dxc-button", inputs: { mode: "mode", disabled: "disabled", label: "label", iconSrc: "iconSrc", iconPosition: "iconPosition", margin: "margin", size: "size", type: "type", tabIndexValue: "tabIndexValue" }, outputs: { onClick: "onClick" }, host: { properties: { "class": "this.className" } }, providers: [CssUtils], queries: [{ propertyName: "dxcButtonIcon", predicate: DxcButtonIconComponent }], usesOnChanges: true, ngImport: i0, template: "<button\n  class=\"dxcButton\"\n  [type]=\"type\"\n  disableRipple\n  mat-button\n  [disabled]=\"disabled\"\n  (click)=\"onClickHandler($event)\"\n  [tabindex]=\"disabled ? -1 : tabIndexValue\"\n>\n  <img src=\"{{ iconSrc }}\" *ngIf=\"iconSrc\" />\n  <ng-content select=\"dxc-button-icon\"></ng-content>\n  <span *ngIf=\"label\">{{ label }}</span>\n</button>\n", components: [{ type: i3.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }], directives: [{ type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcButtonComponent, decorators: [{
            type: Component,
            args: [{ selector: "dxc-button", providers: [CssUtils], template: "<button\n  class=\"dxcButton\"\n  [type]=\"type\"\n  disableRipple\n  mat-button\n  [disabled]=\"disabled\"\n  (click)=\"onClickHandler($event)\"\n  [tabindex]=\"disabled ? -1 : tabIndexValue\"\n>\n  <img src=\"{{ iconSrc }}\" *ngIf=\"iconSrc\" />\n  <ng-content select=\"dxc-button-icon\"></ng-content>\n  <span *ngIf=\"label\">{{ label }}</span>\n</button>\n" }]
        }], ctorParameters: function () { return [{ type: CssUtils }, { type: i0.ChangeDetectorRef }, { type: BackgroundProviderService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { mode: [{
                type: Input
            }], disabled: [{
                type: Input
            }], label: [{
                type: Input
            }], iconSrc: [{
                type: Input
            }], iconPosition: [{
                type: Input
            }], margin: [{
                type: Input
            }], size: [{
                type: Input
            }], type: [{
                type: Input
            }], tabIndexValue: [{
                type: Input
            }], onClick: [{
                type: Output
            }], className: [{
                type: HostBinding,
                args: ["class"]
            }], dxcButtonIcon: [{
                type: ContentChildren,
                args: [DxcButtonIconComponent]
            }] } });

class DxcButtonModule {
}
DxcButtonModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcButtonModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DxcButtonModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcButtonModule, declarations: [DxcButtonComponent, DxcButtonIconComponent], imports: [CommonModule, MatButtonModule, MatIconModule], exports: [DxcButtonComponent, DxcButtonIconComponent] });
DxcButtonModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcButtonModule, imports: [[CommonModule, MatButtonModule, MatIconModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcButtonModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [DxcButtonComponent, DxcButtonIconComponent],
                    imports: [CommonModule, MatButtonModule, MatIconModule],
                    exports: [DxcButtonComponent, DxcButtonIconComponent],
                }]
        }] });

class DxcCardComponent {
    constructor(utils, cdRef, bgProviderService) {
        this.utils = utils;
        this.cdRef = cdRef;
        this.bgProviderService = bgProviderService;
        /**
         * Color of the image background.
         */
        this.imageBgColor = "black";
        /**
         * Whether the image should appear in relation to the content.
         */
        this.imagePosition = "before";
        /**
         * This event will emit when the user clicks the card. Component will show some
         * visual feedback on hover.
         */
        this.onClick = new EventEmitter();
        this._imageCover = false;
        this._tabIndexValue = 0;
        /**
         * Whether the card must be outlined.
         */
        this.outlined = true;
        this.defaultInputs = new BehaviorSubject({
            imageSrc: null,
            imageBgColor: "black",
            imagePadding: null,
            imagePosition: "before",
            contentPadding: null,
            linkHref: null,
            imageCover: false,
            margin: null,
            tabIndexValue: 0,
            outlined: true,
        });
    }
    /**
     * Whether the image must cover the whole image area of the card.
     */
    get imageCover() {
        return this._imageCover;
    }
    set imageCover(value) {
        this._imageCover = coerceBooleanProperty(value);
    }
    /**
     * Value of the tabindex given when there is an href.
     */
    get tabIndexValue() {
        return this._tabIndexValue;
    }
    set tabIndexValue(value) {
        this._tabIndexValue = coerceNumberProperty(value);
    }
    ngOnChanges(changes) {
        if (this.onClick.observers.length <= 0 && !this.linkHref) {
            this.tabIndexValue = -1;
        }
        const inputs = Object.keys(changes).reduce((result, item) => {
            result[item] = changes[item].currentValue;
            return result;
        }, {});
        this.defaultInputs.next({ ...this.defaultInputs.getValue(), ...inputs });
        this.className = `${this.getDynamicStyle(this.defaultInputs.getValue())}`;
    }
    ngOnInit() {
        this.className = `${this.getDynamicStyle(this.defaultInputs.getValue())}`;
    }
    ngAfterContentChecked() {
        if (this.content &&
            this.content.nativeElement &&
            this.content.nativeElement.children.length > 0) {
            this.content.nativeElement.classList.add("childComponents");
            this.content.nativeElement.parentElement.classList.add("hasChildren");
        }
        this.cdRef.detectChanges();
    }
    onClickHandler($event) {
        this.onClick.emit($event);
    }
    applyTheme(href, outlined) {
        return css `
      mat-card {
        ${this.utils.getBoxShadow(0, true)}
      }

      mat-card:hover {
        ${this.utils.getBoxShadow(0, true)}
      }
    `;
    }
    changeIsHovered(isHovered) {
        this.isHovered = isHovered;
    }
    getShadowDepth() {
        return !this.defaultInputs.value.outlined
            ? "0"
            : this.isHovered &&
                this.onClick.observers.length > 0 &&
                this.linkHref !== ""
                ? "2"
                : "1";
    }
    getCursor(href) {
        if (this.onClick.observers.length > 0 || href) {
            return css `
        cursor: pointer;
      `;
        }
        else {
            return css ``;
        }
    }
    getShadowDepthOnHover(href) {
        if (this.onClick.observers.length > 0 || href) {
            return "2";
        }
        else {
            return "1";
        }
    }
    getDynamicStyle(inputs) {
        return css `
      display: inline-flex;
      ${this.utils.getMargins(inputs.margin)}
      ${this.getCursor(inputs.linkHref)}
      width: var(--card-width);
      height: var(--card-height);

      mat-card {
        font-size: 14px;
        display: inline-flex;
        padding: 0px;
        ${this.tabIndexValue === -1 ? "outline:none;" : ""}
        .content {
          overflow: hidden;
          width: 260px;
          ${this.utils.getPaddings(inputs.contentPadding)}
        }
        img,
        svg {
          height: 100%;
          ${this.utils.calculateWidthWithSize("140px", inputs.imagePadding)}
          ${inputs.imageCover
            ? css `
                object-fit: cover;
              `
            : css `
                object-fit: contain;
              `};
        }

        .imageContainer {
          display: inline-flex;
          background-color: ${inputs.imageBgColor};
          ${this.utils.calculateWidthWithSize("140px", inputs.imagePadding)}
          ${this.utils.getPaddings(inputs.imagePadding)}
        }
      }

      mat-card.after {
        flex-direction: row-reverse;
        align-items: stretch;
      }

      mat-card.before {
        flex-direction: row;
        align-items: stretch;
      }

      mat-card.above {
        flex-direction: column;
        align-items: center;
      }

      mat-card.below {
        flex-direction: column-reverse;
        align-items: center;
      }

      mat-card.before {
        .imageContainer {
          img,
          svg {
            border-top-left-radius: 4px;
            border-bottom-left-radius: 4px;
          }
          border-top-left-radius: 4px;
          border-bottom-left-radius: 4px;
        }
      }

      mat-card.after {
        .imageContainer {
          img,
          svg {
            border-top-right-radius: 4px;
            border-bottom-right-radius: 4px;
          }
          border-top-right-radius: 4px;
          border-bottom-right-radius: 4px;
        }
      }
      ${this.applyTheme(inputs.linkHref, inputs.outlined)}
    `;
    }
}
DxcCardComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcCardComponent, deps: [{ token: CssUtils }, { token: i0.ChangeDetectorRef }, { token: BackgroundProviderService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
DxcCardComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.5", type: DxcCardComponent, selector: "dxc-card", inputs: { imageSrc: "imageSrc", imageBgColor: "imageBgColor", imagePadding: "imagePadding", imagePosition: "imagePosition", contentPadding: "contentPadding", linkHref: "linkHref", imageCover: "imageCover", margin: "margin", tabIndexValue: "tabIndexValue", outlined: "outlined" }, outputs: { onClick: "onClick" }, host: { properties: { "class": "this.className" } }, providers: [CssUtils], viewQueries: [{ propertyName: "content", first: true, predicate: ["content"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "\n<dxc-box [shadowDepth]=\"getShadowDepth()\">\n  <mat-card\n  (click)=\"onClickHandler($event)\"\n  (mouseEnter)=\"changeIsHovered(true)\"\n  (mouseLeave)=\"changeIsHovered(false)\"\n  [ngClass]=\"[\n    imagePosition === 'before'\n      ? 'before'\n      : imagePosition === 'after'\n      ? 'after'\n      : 'before'\n  ]\"\n  [tabindex]=\"tabIndexValue\"\n>\n  <div class=\"imageContainer\">\n    <img *ngIf=\"imageSrc\" src=\"{{ imageSrc }}\" />\n  </div>\n  <div class=\"content\" #content>\n    <ng-content></ng-content>\n  </div>\n</mat-card>\n\n</dxc-box>\n", components: [{ type: DxcBoxComponent, selector: "dxc-box", inputs: ["shadowDepth", "display", "margin", "padding", "size"] }, { type: i4$1.MatCard, selector: "mat-card", exportAs: ["matCard"] }], directives: [{ type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcCardComponent, decorators: [{
            type: Component,
            args: [{ selector: "dxc-card", providers: [CssUtils], template: "\n<dxc-box [shadowDepth]=\"getShadowDepth()\">\n  <mat-card\n  (click)=\"onClickHandler($event)\"\n  (mouseEnter)=\"changeIsHovered(true)\"\n  (mouseLeave)=\"changeIsHovered(false)\"\n  [ngClass]=\"[\n    imagePosition === 'before'\n      ? 'before'\n      : imagePosition === 'after'\n      ? 'after'\n      : 'before'\n  ]\"\n  [tabindex]=\"tabIndexValue\"\n>\n  <div class=\"imageContainer\">\n    <img *ngIf=\"imageSrc\" src=\"{{ imageSrc }}\" />\n  </div>\n  <div class=\"content\" #content>\n    <ng-content></ng-content>\n  </div>\n</mat-card>\n\n</dxc-box>\n", styles: [] }]
        }], ctorParameters: function () { return [{ type: CssUtils }, { type: i0.ChangeDetectorRef }, { type: BackgroundProviderService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { imageSrc: [{
                type: Input
            }], imageBgColor: [{
                type: Input
            }], imagePadding: [{
                type: Input
            }], imagePosition: [{
                type: Input
            }], contentPadding: [{
                type: Input
            }], linkHref: [{
                type: Input
            }], onClick: [{
                type: Output
            }], imageCover: [{
                type: Input
            }], margin: [{
                type: Input
            }], tabIndexValue: [{
                type: Input
            }], outlined: [{
                type: Input
            }], className: [{
                type: HostBinding,
                args: ["class"]
            }], content: [{
                type: ViewChild,
                args: ["content", { static: false }]
            }] } });

class DxcCardModule {
}
DxcCardModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcCardModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DxcCardModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcCardModule, declarations: [DxcCardComponent], imports: [CommonModule, MatCardModule, DxcBoxModule, BackgroundProviderModule], exports: [DxcCardComponent] });
DxcCardModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcCardModule, imports: [[CommonModule, MatCardModule, DxcBoxModule, BackgroundProviderModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcCardModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [DxcCardComponent],
                    imports: [CommonModule, MatCardModule, DxcBoxModule, BackgroundProviderModule],
                    exports: [DxcCardComponent]
                }]
        }] });

class DxcCheckboxComponent {
    constructor(utils, bgProviderService) {
        this.utils = utils;
        this.bgProviderService = bgProviderService;
        /**
         * 	Initial state of the checkbox, only when it is uncontrolled.
         */
        this.defaultChecked = false;
        /**
         * Whether the label should appear after or before the checkbox.
         */
        this.labelPosition = "before";
        this._disabled = false;
        this._required = false;
        this._tabIndexValue = 0;
        /**
         * Size of the component.
         */
        this.size = "fitContent";
        this.darkBackground = false;
        this.lightBackground = true;
        this.hover = false;
        this.defaultInputs = new BehaviorSubject({
            checked: false,
            defaultChecked: false,
            value: null,
            label: null,
            labelPosition: "before",
            name: null,
            disabled: false,
            required: false,
            tabIndexValue: 0,
            margin: null,
            size: "fitContent"
        });
        this.sizes = {
            small: "120px",
            medium: "240px",
            large: "480px",
            fillParent: "100%",
            fitContent: "unset",
        };
        this.onChange = new EventEmitter();
        this.bgProviderService.$changeColor.subscribe((value) => {
            if (value === "dark") {
                this.lightBackground = false;
                this.darkBackground = true;
            }
            else if (value === "light") {
                this.lightBackground = true;
                this.darkBackground = false;
            }
        });
    }
    /**
     * If true, the component is checked. If undefined the component will be uncontrolled
     * and the value will be managed internally by the component.
     */
    get checked() {
        return this._checked;
    }
    set checked(value) {
        this._checked = coerceBooleanProperty(value);
    }
    /**
     * If true, the component will be disabled.
     */
    get disabled() {
        return this._disabled;
    }
    set disabled(value) {
        this._disabled = coerceBooleanProperty(value);
    }
    /**
     * If true, the checkbox will change its appearence, showing that the value is required.
     */
    get required() {
        return this._required;
    }
    set required(value) {
        this._required = coerceBooleanProperty(value);
    }
    /**
     * Value of the tabindex attribute.
     */
    get tabIndexValue() {
        return this._tabIndexValue;
    }
    set tabIndexValue(value) {
        this._tabIndexValue = coerceNumberProperty(value);
    }
    ngOnChanges(changes) {
        this.renderedChecked = this.checked;
        this.labelPosition === "after" ? "after" : "before";
        const inputs = Object.keys(changes).reduce((result, item) => {
            result[item] = changes[item].currentValue;
            return result;
        }, {});
        this.defaultInputs.next({ ...this.defaultInputs.getValue(), ...inputs });
        this.className = `${this.getDynamicStyle(this.defaultInputs.getValue())}`;
    }
    ngOnInit() {
        this.renderedChecked = this.checked || this.defaultChecked;
        this.className = `${this.getDynamicStyle(this.defaultInputs.getValue())}`;
        if (this.disabled) {
            this.required = false;
        }
    }
    onValueChange($event) {
        this.onChange.emit($event.checked);
        if (this.checked === undefined || this.checked === null) {
            this.renderedChecked = $event.checked;
        }
        else {
            $event.source.checked = this.renderedChecked;
            $event.source._checked = this.renderedChecked;
            $event.source._inputElement.nativeElement.checked = this.renderedChecked;
        }
    }
    calculateWidth(size) {
        if (size === "fillParent") {
            return css `
        width: ${this.sizes[size]};
      `;
        }
        return css `
      width: ${this.sizes[size]};
    `;
    }
    setTextAlign(labelPosition) {
        if (labelPosition === "before") {
            return css `
        text-align: end;
      `;
        }
    }
    hoverCheckbox() {
        if (!this.disabled) {
            this.hover = !this.hover;
        }
    }
    getDynamicStyle(inputs) {
        return css `
      ${this.utils.getMargins(inputs.margin)}
      ${this.calculateWidth(inputs.size)}
      display: inline-flex;
      vertical-align: top;
      .mat-checkbox-indeterminate.mat-accent .mat-checkbox-background,
      .mat-checkbox-checked.mat-accent .mat-checkbox-background {
        background: var(--checkbox-selectedBackgroundColor) !important;
      }

      .mat-checkbox-checked .mat-checkbox-inner-container {
        &:hover {
          .mat-checkbox-background {
            background: var(--checkbox-selectedHoverBackgroundColor) !important;
          }
        }
      }

      .mat-checkbox:not(.mat-checkbox-disabled).mat-accent
        .mat-checkbox-ripple
        .mat-ripple-element {
        background-color: transparent;
      }
      mat-checkbox {
        display: inline-flex;
        width: 100%;
        &.cdk-focused:not(.mat-checkbox-disabled) {
          label.mat-checkbox-layout {
            .mat-checkbox-inner-container {
              .mat-checkbox-background {
                outline: 2px solid var(--checkbox-focusColor);
                outline-offset: 1px;
                border-radius: 2px;
              }
            }
          }
        }
        label.mat-checkbox-layout {
          display: inline-flex;
          align-items: center;
          width: 100%;
          white-space: normal;
          height: 24px;
          margin-left: 3px;
          span.mat-checkbox-label {
            line-height: 18px;
            span.checkboxLabel {
              word-break: normal;
              color: var(--checkbox-fontColor);
              font-family: var(--checkbox-fontFamily) !important;
              font-size: var(--checkbox-fontSize);
              font-weight: var(--checkbox-fontWeight);
              display: flex;
              justify-content: flex-end;
            }
          }

          .mat-checkbox-inner-container {
            margin: ${inputs.labelPosition === "after"
            ? "0px var(--checkbox-checkLabelSpacing) 0px 0px;"
            : "0px 0px 0px var(--checkbox-checkLabelSpacing);"};
            width: 18px;
            height: 18px;

            .mat-checkbox-background,
            .mat-checkbox-frame {
              border-radius: 2px;
              border-color: var(--checkbox-borderColor);
              border-width: 2px;
            }

            .mat-checkbox-background {
              outline-offset: 1px;
              svg path {
                stroke: var(--checkbox-checkColor) !important;
                stroke-width: 3px;
              }
            }

            &:hover {
              .mat-checkbox-background,
              .mat-checkbox-frame {
                border-color: var(--checkbox-hoverBorderColor);
              }
            }
          }
        }
        &.mat-checkbox-disabled {
          cursor: not-allowed;
          .mat-checkbox-inner-container {
            .mat-checkbox-frame {
              border-color: var(--checkbox-disabledBorderColor) !important;
            }
          }
          label.mat-checkbox-layout span.mat-checkbox-label span.checkboxLabel {
            color: var(--checkbox-disabledFontColor) !important;
          }
        }
        &.mat-checkbox-disabled.mat-checkbox-checked {
          .mat-checkbox-inner-container {
            .mat-checkbox-frame {
              border-color: transparent !important;
            }
            .mat-checkbox-background {
              background: var(
                --checkbox-selectedDisabledBackgroundColor
              ) !important;
              svg path {
                stroke: var(--checkbox-disabledCheckColor) !important;
              }
            }
          }
        }
      }
      &.dark {
        mat-checkbox {
          &.cdk-focused:not(.mat-checkbox-disabled) {
            label.mat-checkbox-layout {
              .mat-checkbox-inner-container {
                .mat-checkbox-background {
                  outline: -webkit-focus-ring-color auto 2px;
                  outline-color: var(--checkbox-focusColorOnDark);
                  outline-offset: 3px;
                }
              }
            }
          }
        }
        .mat-checkbox-indeterminate.mat-accent .mat-checkbox-background,
        .mat-checkbox-checked.mat-accent .mat-checkbox-background {
          background: var(--checkbox-selectedBackgroundColorOnDark) !important;
        }

        .mat-checkbox-checked .mat-checkbox-inner-container {
          &:hover {
            .mat-checkbox-background {
              background: var(
                --checkbox-selectedHoverBackgroundColorOnDark
              ) !important;
            }
          }
        }

        label.mat-checkbox-layout {
          span.mat-checkbox-label {
            span.checkboxLabel {
              color: var(--checkbox-fontColorOnDark);
            }
          }
          .mat-checkbox-inner-container {
            .mat-checkbox-background,
            .mat-checkbox-frame {
              border-color: var(--checkbox-borderColorOnDark);
            }
            .mat-checkbox-background {
              svg path {
                stroke: var(--checkbox-checkColorOnDark) !important;
              }
            }

            &:hover {
              .mat-checkbox-background,
              .mat-checkbox-frame {
                border-color: var(--checkbox-hoverBorderColorOnDark);
              }
            }
          }
        }

        .mat-checkbox-disabled {
          .mat-checkbox-inner-container {
            .mat-checkbox-frame {
              border-color: var(
                --checkbox-disabledBorderColorOnDark
              ) !important;
            }
          }
          span.checkboxLabel {
            color: var(--checkbox-disabledFontColorOnDark) !important;
          }
        }
        .mat-checkbox-disabled.mat-checkbox-checked {
          .mat-checkbox-inner-container {
            .mat-checkbox-frame {
              border-color: var(
                --checkbox-disabledBorderColorOnDark
              ) !important;
            }
            .mat-checkbox-background {
              background: var(
                --checkbox-selectedDisabledBackgroundColorOnDark
              ) !important;
              svg path {
                stroke: var(--checkbox-disabledCheckColorOnDark) !important;
              }
            }
          }
        }
      }
      &.hover:not(.dark) {
        .mat-checkbox-checked .mat-checkbox-inner-container {
          .mat-checkbox-background {
            background: var(--checkbox-selectedHoverBackgroundColor) !important;
          }
        }
        label.mat-checkbox-layout
          .mat-checkbox-inner-container
          .mat-checkbox-background,
        label.mat-checkbox-layout
          .mat-checkbox-inner-container
          .mat-checkbox-frame {
          border-color: var(--checkbox-hoverBorderColor);
        }
      }
      &.hover {
        .mat-checkbox-checked .mat-checkbox-inner-container {
          .mat-checkbox-background {
            background: var(
              --checkbox-selectedHoverBackgroundColorOnDark
            ) !important;
          }
        }
        label.mat-checkbox-layout
          .mat-checkbox-inner-container
          .mat-checkbox-background,
        label.mat-checkbox-layout
          .mat-checkbox-inner-container
          .mat-checkbox-frame {
          border-color: var(--checkbox-hoverBorderColorOnDark);
        }
      }
    `;
    }
}
DxcCheckboxComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcCheckboxComponent, deps: [{ token: CssUtils }, { token: BackgroundProviderService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
DxcCheckboxComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.5", type: DxcCheckboxComponent, selector: "dxc-checkbox", inputs: { checked: "checked", defaultChecked: "defaultChecked", value: "value", label: "label", labelPosition: "labelPosition", name: "name", disabled: "disabled", required: "required", tabIndexValue: "tabIndexValue", margin: "margin", size: "size", id: "id" }, outputs: { onChange: "onChange" }, host: { properties: { "class": "this.className", "class.dark": "this.darkBackground", "class.light": "this.lightBackground", "class.hover": "this.hover" } }, providers: [CssUtils], usesOnChanges: true, ngImport: i0, template: "<mat-checkbox\n  disableRipple\n  [checked]=\"renderedChecked\"\n  [labelPosition]=\"labelPosition ? labelPosition : 'before'\"\n  [value]=\"value\"\n  [disabled]=\"disabled\"\n  [required]=\"required\"\n  [aria-label]=\"label\"\n  [name]=\"name\"\n  [id]=\"id\"\n  (change)=\"onValueChange($event)\"\n  data-testid=\"dxcCheckbox\"\n  [tabIndex]=\"disabled ? -1 : tabIndexValue\"\n>\n  <span *ngIf=\"label\">\n    <span *ngIf=\"required\" class=\"mat-checkbox-required\">*</span>\n    <span class=\"checkboxLabel\" (mouseover)=\"hoverCheckbox()\" (mouseout)=\"hoverCheckbox()\">{{ label }}</span>\n  </span>\n</mat-checkbox>\n", components: [{ type: i3$1.MatCheckbox, selector: "mat-checkbox", inputs: ["disableRipple", "color", "tabIndex", "aria-label", "aria-labelledby", "id", "labelPosition", "name", "required", "checked", "disabled", "indeterminate", "aria-describedby", "value"], outputs: ["change", "indeterminateChange"], exportAs: ["matCheckbox"] }], directives: [{ type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcCheckboxComponent, decorators: [{
            type: Component,
            args: [{ selector: "dxc-checkbox", providers: [CssUtils], template: "<mat-checkbox\n  disableRipple\n  [checked]=\"renderedChecked\"\n  [labelPosition]=\"labelPosition ? labelPosition : 'before'\"\n  [value]=\"value\"\n  [disabled]=\"disabled\"\n  [required]=\"required\"\n  [aria-label]=\"label\"\n  [name]=\"name\"\n  [id]=\"id\"\n  (change)=\"onValueChange($event)\"\n  data-testid=\"dxcCheckbox\"\n  [tabIndex]=\"disabled ? -1 : tabIndexValue\"\n>\n  <span *ngIf=\"label\">\n    <span *ngIf=\"required\" class=\"mat-checkbox-required\">*</span>\n    <span class=\"checkboxLabel\" (mouseover)=\"hoverCheckbox()\" (mouseout)=\"hoverCheckbox()\">{{ label }}</span>\n  </span>\n</mat-checkbox>\n" }]
        }], ctorParameters: function () { return [{ type: CssUtils }, { type: BackgroundProviderService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { checked: [{
                type: Input
            }], defaultChecked: [{
                type: Input
            }], value: [{
                type: Input
            }], label: [{
                type: Input
            }], labelPosition: [{
                type: Input
            }], name: [{
                type: Input
            }], disabled: [{
                type: Input
            }], required: [{
                type: Input
            }], tabIndexValue: [{
                type: Input
            }], onChange: [{
                type: Output
            }], margin: [{
                type: Input
            }], size: [{
                type: Input
            }], id: [{
                type: Input
            }], className: [{
                type: HostBinding,
                args: ["class"]
            }], darkBackground: [{
                type: HostBinding,
                args: ["class.dark"]
            }], lightBackground: [{
                type: HostBinding,
                args: ["class.light"]
            }], hover: [{
                type: HostBinding,
                args: ["class.hover"]
            }] } });

class DxcCheckboxModule {
}
DxcCheckboxModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcCheckboxModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DxcCheckboxModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcCheckboxModule, declarations: [DxcCheckboxComponent], imports: [CommonModule, FormsModule, MatCheckboxModule, ThemeModule], exports: [DxcCheckboxComponent] });
DxcCheckboxModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcCheckboxModule, imports: [[CommonModule, FormsModule, MatCheckboxModule, ThemeModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcCheckboxModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [DxcCheckboxComponent],
                    imports: [CommonModule, FormsModule, MatCheckboxModule, ThemeModule],
                    exports: [DxcCheckboxComponent],
                }]
        }] });

class DxcChipPrefixIconComponent {
    constructor() { }
}
DxcChipPrefixIconComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcChipPrefixIconComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
DxcChipPrefixIconComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.5", type: DxcChipPrefixIconComponent, selector: "dxc-chip-prefix-icon", ngImport: i0, template: "<ng-content></ng-content>" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcChipPrefixIconComponent, decorators: [{
            type: Component,
            args: [{ selector: "dxc-chip-prefix-icon", template: "<ng-content></ng-content>" }]
        }], ctorParameters: function () { return []; } });

class DxcChipSuffixIconComponent {
    constructor() { }
}
DxcChipSuffixIconComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcChipSuffixIconComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
DxcChipSuffixIconComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.5", type: DxcChipSuffixIconComponent, selector: "dxc-chip-suffix-icon", ngImport: i0, template: "<ng-content></ng-content>" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcChipSuffixIconComponent, decorators: [{
            type: Component,
            args: [{ selector: "dxc-chip-suffix-icon", template: "<ng-content></ng-content>" }]
        }], ctorParameters: function () { return []; } });

class DxcChipComponent {
    constructor(utils, cdRef) {
        this.utils = utils;
        this.cdRef = cdRef;
        this.hasTabIndexPrefix = false;
        this.hasTabIndexSuffix = false;
        /**
         * Event that will be emitted when the suffix icon is clicked.
         */
        this.suffixIconClick = new EventEmitter();
        /**
         * Event that will be emitted when the prefix icon is clicked.
         */
        this.prefixIconClick = new EventEmitter();
        this.defaultInputs = new BehaviorSubject({
            label: "",
            suffixIconSrc: null,
            prefixIconSrc: null,
            disabled: false,
            margin: null,
            tabIndexValue: 0,
        });
        this.getMarginLeft = () => ((this.label ||
            this.dxcChipPrefixIcon?.length !== 0 ||
            this.prefixIconSrc) &&
            "10px") ||
            ((this.dxcChipPrefixIcon?.length !== 0 || this.prefixIconSrc) && "0");
        this.getMarginRight = () => ((this.label ||
            this.dxcChipSuffixIcon?.length !== 0 ||
            this.suffixIconSrc) &&
            "10px") ||
            ((this.dxcChipPrefixIcon?.length !== 0 || this.prefixIconSrc) && "0");
    }
    /**
     * If true, the component will be disabled.
     */
    get disabled() {
        return this._disabled;
    }
    set disabled(value) {
        this._disabled = coerceBooleanProperty(value);
    }
    /**
     * Value of the tabindex, it also applies to prefix and suffix icons when a function is given.
     */
    get tabIndexValue() {
        return this._tabIndexValue;
    }
    set tabIndexValue(value) {
        this._tabIndexValue = coerceNumberProperty(value);
    }
    ngAfterViewInit() {
        if (this.dxcChipPrefixIcon.length !== 0) {
            this.prefixIconSrc = "";
        }
        if (this.dxcChipSuffixIcon.length !== 0) {
            this.suffixIconSrc = "";
        }
        this.cdRef.detectChanges();
    }
    ngOnInit() {
        this.className = `${this.getDynamicStyle(this.defaultInputs.getValue())}`;
    }
    ngOnChanges(changes) {
        const inputs = Object.keys(changes).reduce((result, item) => {
            result[item] = changes[item].currentValue;
            return result;
        }, {});
        this.defaultInputs.next({ ...this.defaultInputs.getValue(), ...inputs });
        this.className = `${this.getDynamicStyle(this.defaultInputs.getValue())}`;
        if (this.prefixIconClick.observers.length <= 0 &&
            this.suffixIconClick.observers.length <= 0) {
            this.tabIndexValue = -1;
        }
    }
    handlePrefrixClick() {
        this.prefixIconClick.emit();
    }
    handleSuffixClick() {
        this.suffixIconClick.emit();
    }
    handlePrefrixKey($event) {
        if ($event.keyCode && $event.keyCode === 32) {
            $event.preventDefault();
            this.prefixIconClick.emit();
        }
    }
    handleSuffixKey($event) {
        if ($event.keyCode && $event.keyCode === 32) {
            $event.preventDefault();
            this.suffixIconClick.emit();
        }
    }
    getDisabledStyleSuffixIcon(disabled) {
        if (disabled) {
            if (this.suffixIconClick.observers.length > 0) {
                return css `
          cursor: not-allowed;
        `;
            }
        }
        else {
            if (this.suffixIconClick.observers.length > 0) {
                return css `
          cursor: pointer;
          &:focus {
            outline-color: var(--chip-focusColor);
          }
        `;
            }
        }
        return css `
      cursor: default;
    `;
    }
    getDisabledStylePrefixIcon(disabled) {
        if (disabled) {
            if (this.prefixIconClick.observers.length > 0) {
                return css `
          cursor: not-allowed;
        `;
            }
        }
        else {
            if (this.prefixIconClick.observers.length > 0) {
                return css `
          cursor: pointer;
          &:focus {
            outline-color: var(--chip-focusColor);
          }
        `;
            }
        }
        return css `
      cursor: default;
    `;
    }
    getDynamicStyle(inputs) {
        return css `
      ${this.utils.getMargins(inputs.margin)}
      display: inline-flex;
      align-items: center;
      border-radius: var(--chip-borderRadius);
      max-width: calc(
        100% - 40px - ${this.utils.getMarginValue(inputs.margin, "left")} -
          ${this.utils.getMarginValue(inputs.margin, "right")}
      );
      min-height: 40px;
      background-color: ${inputs.disabled
            ? "var(--chip-disabledBackgroundColor)"
            : "var(--chip-backgroundColor)"};

      border-width: var(--chip-borderThickness);
      border-style: var(--chip-borderStyle);
      border-color: var(--chip-borderColor);
      padding-top: var(--chip-contentPaddingTop);
      padding-bottom: var(--chip-contentPaddingBottom);
      padding-left: var(--chip-contentPaddingLeft);
      padding-right: var(--chip-contentPaddingRight);
      ${inputs.disabled ? "cursor: not-allowed" : ""};
      cursor: ${inputs.disabled ? "not-allowed" : "default"};

      .labelContainer {
        font-size: var(--chip-fontSize);
        font-family: var(--chip-fontFamily);
        font-weight: var(--chip-fontWeight);
        font-style: var(--chip-fontStyle);
        color: ${inputs.disabled
            ? "var(--chip-disabledFontColor)"
            : "var(--chip-fontColor)"};
        ${inputs.disabled ? "cursor: not-allowed" : "default"};
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }

      .prefixIcon {
        cursor: ${inputs.disabled
            ? "not-allowed"
            : this.prefixIconClick.observers.length > 0
                ? "pointer"
                : "default"};
        color: ${inputs.disabled
            ? "var(--chip-disabledIconColor)"
            : "var(--chip-iconColor)"};
        ${this.label || this.suffixIconSrc
            ? "margin-right: var(--chip-iconSpacing);"
            : this.prefixIconSrc
                ? "5px"
                : ""};
        height: var(--chip-iconSize);
        width: var(--chip-iconSize);
        &:focus-within {
          ${this.prefixIconClick.observers.length > 0
            ? "outline: -webkit-focus-ring-color auto 1px; outline-color: var(--chip-focusColor);"
            : "outline: none"};
        }
      }
      .suffixIcon {
        cursor: ${inputs.disabled
            ? "not-allowed"
            : this.suffixIconClick.observers.length > 0
                ? "pointer"
                : "default"};
        color: ${inputs.disabled
            ? "var(--chip-disabledIconColor)"
            : "var(--chip-iconColor)"};
        ${this.label || this.suffixIconSrc
            ? "margin-left: var(--chip-iconSpacing);"
            : this.prefixIconSrc
                ? "5px"
                : ""};
        height: var(--chip-iconSize);
        width: var(--chip-iconSize);
        &:focus-within {
          ${this.suffixIconClick.observers.length > 0
            ? "outline: -webkit-focus-ring-color auto 1px; outline-color: var(--chip-focusColor);"
            : "outline: none"};
        }
      }
    `;
    }
}
DxcChipComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcChipComponent, deps: [{ token: CssUtils }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
DxcChipComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.5", type: DxcChipComponent, selector: "dxc-chip", inputs: { label: "label", suffixIconSrc: "suffixIconSrc", prefixIconSrc: "prefixIconSrc", disabled: "disabled", margin: "margin", tabIndexValue: "tabIndexValue" }, outputs: { suffixIconClick: "suffixIconClick", prefixIconClick: "prefixIconClick" }, host: { properties: { "class": "this.className", "class.hasTabIndexPrefix": "this.hasTabIndexPrefix", "class.hasTabIndexSuffix": "this.hasTabIndexSuffix" } }, providers: [CssUtils], queries: [{ propertyName: "dxcChipPrefixIcon", predicate: DxcChipPrefixIconComponent }, { propertyName: "dxcChipSuffixIcon", predicate: DxcChipSuffixIconComponent }], usesOnChanges: true, ngImport: i0, template: "<img\n  (click)=\"handlePrefrixClick()\"\n  [tabindex]=\"tabIndexValue\"\n  (keydown)=\"handlePrefrixKey($event)\"\n  class=\"prefixIcon\"\n  *ngIf=\"prefixIconSrc\"\n  src=\"{{ prefixIconSrc }}\"\n/>\n<div\n  class=\"prefixIcon\"\n  (click)=\"handlePrefrixClick()\"\n  [tabindex]=\"tabIndexValue\"\n  (keydown)=\"handlePrefrixKey($event)\"\n  *ngIf=\"dxcChipPrefixIcon.length !== 0\"\n>\n  <ng-content select=\"dxc-chip-prefix-icon\"></ng-content>\n</div>\n\n<span class=\"labelContainer\">{{ label }}</span>\n\n<div\n  (click)=\"handleSuffixClick()\"\n  [tabindex]=\"tabIndexValue\"\n  (keydown)=\"handleSuffixKey($event)\"\n  class=\"suffixIcon\"\n  *ngIf=\"dxcChipSuffixIcon.length !== 0\"\n>\n  <ng-content select=\"dxc-chip-suffix-icon\"></ng-content>\n</div>\n<img\n  (click)=\"handleSuffixClick()\"\n  [tabindex]=\"tabIndexValue\"\n  (keydown)=\"handleSuffixKey($event)\"\n  class=\"suffixIcon\"\n  *ngIf=\"suffixIconSrc\"\n  src=\"{{ suffixIconSrc }}\"\n/>\n", directives: [{ type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcChipComponent, decorators: [{
            type: Component,
            args: [{ selector: "dxc-chip", providers: [CssUtils], template: "<img\n  (click)=\"handlePrefrixClick()\"\n  [tabindex]=\"tabIndexValue\"\n  (keydown)=\"handlePrefrixKey($event)\"\n  class=\"prefixIcon\"\n  *ngIf=\"prefixIconSrc\"\n  src=\"{{ prefixIconSrc }}\"\n/>\n<div\n  class=\"prefixIcon\"\n  (click)=\"handlePrefrixClick()\"\n  [tabindex]=\"tabIndexValue\"\n  (keydown)=\"handlePrefrixKey($event)\"\n  *ngIf=\"dxcChipPrefixIcon.length !== 0\"\n>\n  <ng-content select=\"dxc-chip-prefix-icon\"></ng-content>\n</div>\n\n<span class=\"labelContainer\">{{ label }}</span>\n\n<div\n  (click)=\"handleSuffixClick()\"\n  [tabindex]=\"tabIndexValue\"\n  (keydown)=\"handleSuffixKey($event)\"\n  class=\"suffixIcon\"\n  *ngIf=\"dxcChipSuffixIcon.length !== 0\"\n>\n  <ng-content select=\"dxc-chip-suffix-icon\"></ng-content>\n</div>\n<img\n  (click)=\"handleSuffixClick()\"\n  [tabindex]=\"tabIndexValue\"\n  (keydown)=\"handleSuffixKey($event)\"\n  class=\"suffixIcon\"\n  *ngIf=\"suffixIconSrc\"\n  src=\"{{ suffixIconSrc }}\"\n/>\n" }]
        }], ctorParameters: function () { return [{ type: CssUtils }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { className: [{
                type: HostBinding,
                args: ["class"]
            }], hasTabIndexPrefix: [{
                type: HostBinding,
                args: ["class.hasTabIndexPrefix"]
            }], hasTabIndexSuffix: [{
                type: HostBinding,
                args: ["class.hasTabIndexSuffix"]
            }], label: [{
                type: Input
            }], suffixIconSrc: [{
                type: Input
            }], prefixIconSrc: [{
                type: Input
            }], disabled: [{
                type: Input
            }], margin: [{
                type: Input
            }], suffixIconClick: [{
                type: Output
            }], prefixIconClick: [{
                type: Output
            }], dxcChipPrefixIcon: [{
                type: ContentChildren,
                args: [DxcChipPrefixIconComponent]
            }], dxcChipSuffixIcon: [{
                type: ContentChildren,
                args: [DxcChipSuffixIconComponent]
            }], tabIndexValue: [{
                type: Input
            }] } });

class DxcChipModule {
}
DxcChipModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcChipModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DxcChipModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcChipModule, declarations: [DxcChipComponent, DxcChipPrefixIconComponent, DxcChipSuffixIconComponent], imports: [CommonModule], exports: [DxcChipComponent, DxcChipPrefixIconComponent, DxcChipSuffixIconComponent] });
DxcChipModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcChipModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcChipModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [DxcChipComponent, DxcChipPrefixIconComponent, DxcChipSuffixIconComponent],
                    imports: [CommonModule],
                    exports: [DxcChipComponent, DxcChipPrefixIconComponent, DxcChipSuffixIconComponent],
                }]
        }] });

class DxcDateInputHelper {
    constructor(utils) {
        this.utils = utils;
    }
    getDynamicStyle(inputs) {
        return css ``;
    }
    getCalendarContentStyle() {
        return css `
      width: var(--dateInput-pickerWidth);
      dxc-box {
        background: var(--dateInput-pickerBackgroundColor);
        height: var(--dateInput-pickerHeight);
        display: inline-block;
      }
      .mat-calendar {
        width: 100%;
        height: 100%;
      }
      .mat-calendar-content {
        height: 88%;
        padding: 0 8px 0px 8px;
      }
      .mat-calendar-table {
        height: 100%;
      }
      .mat-calendar-header {
        color: var(--dateInput-color);
        padding: 0px;
        margin-bottom: 5px;
        .mat-calendar-controls {
          margin: 0px;
        }
        .mat-calendar-arrow {
          margin-left: 8px;
        }
      }
      .mat-calendar-table-header-divider::after {
        left: 0px;
        right: 0px;
      }

      .mat-calendar-table-header th {
        font-size: 12px;
      }

      .mat-calendar-period-button {
        font-size: 16px;
      }
      .mat-calendar-body-today:not(.mat-calendar-body-selected) {
        border-color: var(--dateInput-pickerActualDateColor);
      }
      .mat-calendar-body-selected {
        border-color: var(--dateInput-pickerSelectedDateBackgroundColor);
        background-color: var(--dateInput-pickerSelectedDateBackgroundColor);
        color: var(--dateInput-pickerSelectedDateColor) !important;
        &.mat-calendar-body-today {
          border: none;
          box-shadow: none;
        }
      }
      .mat-calendar-body-cell-content,
      .mat-button-wrapper,
      .mat-calendar-body-label,
      .mat-calendar-table-header,
      th {
        font-family: var(--dateInput-fontFamily);
      }

      .mat-calendar-previous-button,
      .mat-calendar-next-button {
        background: var(--dateInput-pickerBackgroundColorMonthArrows);
      }

      .mat-calendar-table-header {
        color: var(--dateInput-pickerWeekLabelColor);
      }

      .mat-calendar-body-label {
        color: var(--dateInput-pickerMonthColor);
      }

      .mat-calendar-period-button {
        color: var(--dateInput-pickerYearColor);
      }

      .mat-calendar-body-cell:not(.mat-calendar-body-disabled):hover
        > .mat-calendar-body-cell-content:not(.mat-calendar-body-selected),
      .cdk-keyboard-focused
        .mat-calendar-body-active
        > .mat-calendar-body-cell-content:not(.mat-calendar-body-selected),
      .cdk-program-focused
        .mat-calendar-body-active
        > .mat-calendar-body-cell-content:not(.mat-calendar-body-selected) {
        background-color: transparent;
      }

      mat-month-view .mat-calendar-body-cell-content {
        width: 28px;
        height: 28px;
        color: var(--dateInput-pickerFontColor);
      }

      td:not(.mat-calendar-body-disabled) .mat-calendar-body-cell-content:focus,
      .mat-calendar-previous-button:focus,
      .mat-calendar-next-button:focus,
      .mat-calendar-period-button:focus {
        outline: -webkit-focus-ring-color auto 1px;
        outline-color: var(--dateInput-focusColor);
      }

      .mat-button-focus-overlay {
        background: none;
      }

      .mat-calendar-period-button:hover,
      .mat-calendar-previous-button:hover,
      .mat-calendar-next-button:hover {
        background: #0000000a;
      }

      .mat-button-wrapper {
        font-weight: bold;
      }

      td:not(.mat-calendar-body-disabled) .mat-calendar-body-cell-content {
        &:not(.mat-calendar-body-selected):hover {
          background-color: var(
            --dateInput-pickerHoverDateBackgroundColor
          ) !important;
          color: var(--dateInput-pickerHoverDateFontColor) !important;
        }
        mat-multi-year-view .mat-calendar-body-cell-content,
        mat-year-view .mat-calendar-body-cell-content {
          width: 55px;
          height: 33px;
        }
        .mat-calendar-period-button {
          padding: 0px;
          height: 34px;
          width: 94px;
          &:hover {
            background: #00000012;
          }
        }
      }
    `;
    }
}
DxcDateInputHelper.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcDateInputHelper, deps: [{ token: CssUtils }], target: i0.ɵɵFactoryTarget.Injectable });
DxcDateInputHelper.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcDateInputHelper });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcDateInputHelper, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: CssUtils }]; } });

class DxcTextInputService {
    constructor() {
        this.visualFocused = new BehaviorSubject(-1);
        this.activeOption = new BehaviorSubject(-1);
        this.filteredOptions = new BehaviorSubject(null);
    }
    setSelectedIndex(selected) {
        this.visualFocused.next(selected);
    }
    setFilteredOptions(array) {
        this.filteredOptions.next(array);
    }
    onArrowDown() {
        if (this.filteredOptions &&
            this.filteredOptions.value &&
            this.visualFocused.value < this.filteredOptions.value.length - 1) {
            this.visualFocused.next(this.visualFocused.value + 1);
        }
        else if (this.filteredOptions &&
            this.filteredOptions.value &&
            this.visualFocused.value === this.filteredOptions.value.length - 1) {
            this.visualFocused.next(0);
        }
        if (this.activeOption.value > 0) {
            this.activeOption.next(-1);
        }
    }
    onArrowUp() {
        if (this.visualFocused.value > 0) {
            this.visualFocused.next(this.visualFocused.value - 1);
        }
        else if (this.filteredOptions &&
            this.filteredOptions.value &&
            this.visualFocused.value === 0) {
            this.visualFocused.next(this.filteredOptions.value.length - 1);
        }
        else if (this.filteredOptions &&
            this.filteredOptions.value &&
            this.visualFocused.value < 0) {
            this.visualFocused.next(this.filteredOptions.value.length - 1);
        }
        if (this.activeOption.value > 0) {
            this.activeOption.next(-1);
        }
    }
}
DxcTextInputService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcTextInputService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
DxcTextInputService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcTextInputService, providedIn: "root" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcTextInputService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: "root",
                }]
        }], ctorParameters: function () { return []; } });

class DxcTextInputHelper {
    constructor(utils) {
        this.utils = utils;
        this.sizes = {
            small: "240px",
            medium: "360px",
            large: "480px",
            fillParent: "100%",
        };
        this.debounced = (cb, time) => {
            const db = new Subject();
            const sub = db.pipe(debounceTime(time)).subscribe(cb);
            const func = (v) => db.next(v);
            func.unsubscribe = () => sub.unsubscribe();
            return func;
        };
    }
    calculateWidth(inputs) {
        if (inputs.size === "fillParent") {
            return this.utils.calculateWidth(this.sizes, inputs);
        }
        return css `
      width: ${this.sizes[inputs.size]};
    `;
    }
    getDisabledStyle() {
        return css `
      dxc-text-input-prefix {
        border-right: 1px solid var(--textInput-disabledPrefixColor);
        color: var(--textInput-disabledPrefixColor);
      }
      dxc-text-input-suffix {
        border-left: 1px solid var(--textInput-disabledSuffixColor);
        color: var(--textInput-disabledSuffixColor);
      }
      .inputLabel,
      .inputOptionalLabel {
        color: var(--textInput-disabledLabelFontColor);
      }
      .helperText {
        color: var(--textInput-disabledHelperTextFontColor);
      }
      .inputText {
        color: var(--textInput-disabledValueFontColor);
      }
      .inputText::placeholder {
        color: var(--textInput-disabledPlaceholderFontColor);
      }
      .inputAction {
        pointer-events: none;
        background-color: var(--textInput-disabledActionBackgroundColor);
        color: var(--textInput-disabledActionIconColor);
        fill: var(--textInput-disabledActionIconColor);
      }
      .inputText,
      .inputAction {
        cursor: not-allowed;
      }
      .inputContainer,
      .inputContainer:hover {
        border: 1px solid var(--textInput-disabledBorderColor);
        box-shadow: none;
        cursor: not-allowed;
        background-color: var(--textInput-disabledContainerFillColor);
      }
    `;
    }
    getDisabledDarkStyle() {
        return css ``;
        // return css`
        //   dxc-text-input-prefix {
        //     border-right: 1px solid var(--textInput-disabledPrefixColorOnDark);
        //     color: var(--textInput-disabledPrefixColorOnDark);
        //   }
        //   dxc-text-input-suffix {
        //     border-left: 1px solid var(--textInput-disabledSuffixColorOnDark);
        //     color: var(--textInput-disabledSuffixColorOnDark);
        //   }
        //   .inputLabel,
        //   .inputOptionalLabel {
        //     color: var(--textInput-disabledLabelFontColorOnDark);
        //   }
        //   .helperText {
        //     color: var(--textInput-disabledHelperTextFontColorOnDark);
        //   }
        //   .inputText {
        //     color: var(--textInput-disabledValueFontColorOnDark);
        //   }
        //   .inputText::placeholder {
        //     color: var(--textInput-disabledPlaceholderFontColorOnDark);
        //   }
        //   .inputAction {
        //     pointer-events: none;
        //     background-color: var(--textInput-disabledActionBackgroundColorOnDark);
        //     color: var(--textInput-disabledActionIconColorOnDark);
        //     fill: var(--textInput-disabledActionIconColorOnDark);
        //   }
        //   .inputText,
        //   .inputAction {
        //     cursor: not-allowed;
        //   }
        //   .inputContainer,
        //   .inputContainer:hover {
        //     border: 1px solid var(--textInput-disabledBorderColorOnDark);
        //     box-shadow: none;
        //     cursor: not-allowed;
        //     background-color: var(--textInput-disabledContainerFillColorOnDark);
        //   }
        // `;
    }
    getDynamicStyle(inputs) {
        return css `
      position: relative;
      display: flex;
      flex-direction: column;
      ${this.utils.getMargins(inputs.margin)}
      ${this.calculateWidth(inputs)}

      &.hasError {
        .inputContainer {
          border: 1px solid var(--textInput-errorBorderColor);
          box-shadow: inset 0 0 0 1px var(--textInput-errorBorderColor);
          &:hover {
            border-color: var(--textInput-hoverErrorBorderColor);
            box-shadow: inset 0 0 0 1px var(--textInput-hoverErrorBorderColor);
          }
        }
      }

      dxc-text-input-action{
        div {
          width: 24px;
          height: 24px;
        }
        svg{
          width: 18px !important;
          height: 100%;
        }
      }

      dxc-text-input-prefix, dxc-text-input-suffix{
        height: 1.5rem;
        line-height: 1.5rem;
        font-family: var(--textInput-fontFamily);
        pointer-events: none;
      }

      dxc-text-input-suffix{
        border-left: 1px solid var(--textInput-suffixColor);
        margin-right: 0.25rem;
        margin-left: 0.25rem;
        padding: 0 0 0 0.5rem;
        color: var(--textInput-suffixColor);
        font-size: var(--textInput-suffixFontSize);
        font-style: var(--textInput-suffixFontStyle);
        font-weight: var(--textInput-suffixFontWeight);
      }

      dxc-text-input-prefix{
        border-right: 1px solid var(--textInput-prefixColor);
        margin-left: 0.25rem;
        padding: 0 0.5rem 0 0;
        color: var(--textInput-prefixColor);
        font-size: var(--textInput-prefixFontSize);
        font-style: var(--textInput-prefixFontStyle);
        font-weight: var(--textInput-prefixFontWeight);
      }

      .overlay:not(.overlayVisible) {
        display: none;
      }
      .overlay.overlayVisible {
        display: block;
        position: fixed;
        top: 0px;
        left: 0px;
        z-index
      }
      .inputLabel, .inputOptionalLabel {
        color: var(--textInput-labelFontColor);
        font-family: var(--textInput-fontFamily);
        font-size: var(--textInput-labelFontSize);
        font-style: var(--textInput-labelFontStyle);
        font-weight: var(--textInput-labelFontWeight);
        line-height: var(--textInput-labelLineHeight);
        min-height: 24px;
      }
      .inputOptionalLabel {
        font-weight: var(--textInput-optionalLabelFontWeight);
      }

      .helperText {
        color: var(--textInput-helperTextFontColor);
        font-family: var(--textInput-fontFamily);
        font-size: var(--textInput-helperTextFontSize);
        font-style: var(--textInput-helperTextFontStyle);
        font-weight: var(--textInput-helperTextFontWeight);
        line-height: var(--textInput-helperTextLineHeight);
        min-height: 18px;
      }

      .inputContainer {
        margin-top: var(--textInput-inputMarginTop);
        margin-bottom: var(--textInput-inputMarginBottom);
        position: relative;
        display: flex;
        align-items: center;
        height: 38px;
        border: ${inputs.error
            ? `1px solid var(--textInput-errorBorderColor)`
            : "1px solid var(--textInput-enabledBorderColor)"};
        ${inputs.error
            ? `box-shadow: inset 0 0 0 1px var(--textInput-errorBorderColor);`
            : ""};
        border-radius: 4px;
        padding: 0 0.5rem;
        &:hover {
          ${inputs.error
            ? `border-color: var(--textInput-hoverErrorBorderColor);
                 box-shadow: inset 0 0 0 1px var(--textInput-hoverErrorBorderColor);`
            : `border-color: var(--textInput-hoverBorderColor);`};
        }
        &:focus-within {
          border: 1px solid var(--textInput-focusBorderColor);
          box-shadow: inset 0 0 0 1px var(--textInput-focusBorderColor);
        }
      }

      .inputText {
        height: calc(100% - 2px);
        width: 100%;
        background: none;
        border: none;
        outline: none;
        padding: 0 0.5rem;
        color: var(--textInput-valueFontColor);
        font-family: var(--textInput-fontFamily);
        font-size: var(--textInput-valueFontSize);
        font-style: var(--textInput-valueFontStyle);
        font-weight: var(--textInput-valueFontWeight);
        caret-color: var(--textInput-valueFontColor);
        &::placeholder {
          color: var(--textInput-placeholderFontColor);
        }

      }

      .inputAction {
        padding: 3px;
        height: 24px;
        max-width: 24px;
        margin-left: 0.25rem;
        font-size: 1rem;
        font-family: var(--textInput-fontFamily);
        border: 1px solid var(--textInput-actionBackgroundColor);
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        background-color: var(--textInput-actionBackgroundColor);
        color: var(--textInput-actionIconColor);
        &:hover {
          background-color: var(--textInput-hoverActionBackgroundColor);
          color: var(--textInput-hoverActionIconColor);
        }
        &:focus {
          color: var(--textInput-focusActionIconColor);
          border: 2px solid var(--textInput-focusActionBorderColor);
          outline: none;
        }
        &:focus-visible {
          border: 2px solid var(--textInput-focusActionBorderColor);
          outline: none;
        }
        &:active {
          border: 2px solid var(--textInput-focusActionBorderColor);
          box-shadow: inset 0 0 0 1px var(--textInput-activeActionBackgroundColor);
          outline: none;
          background-color: var(--textInput-activeActionBackgroundColor);
          color: var(--textInput-activeActionIconColor);
        }
        svg {
          line-height: 16px;
        }
      }
      .inputErrorIcon {
        height: 18px;
        width: 18px;
        margin-left: 0.25rem;
        display: flex;
        align-items: center;
        justify-content: center;
        pointer-events: none;
        color: var(--textInput-errorIconColor);
        svg {
          line-height: 18px;
          height: 18px;
          width: 18px;
        }
      }
      .inputErrorMessage {
        font-family: var(--textInput-fontFamily);
        color: var(--textInput-errorMessageColor);
        font-size: var(--textInput-errorFontSize);
        font-style: var(--textInput-errorFontStyle);
        font-weight: var(--textInput-errorFontWeight);
        line-height: 1.5em;
        min-height: 18px;
      }

      dxc-text-input-action {
        display: flex;
      }

      .options {
        display: none;
        &.visible {
          display: block;
        }
        position: absolute;
        left: 0;
        top: calc(100% + 4px);
        background-color: white;
        box-sizing: border-box;
        border: 1px solid #707070;
        border-radius: 4px;
        width: 100%;
        z-index: 1;
        margin: 0;
        padding: 0;
        list-style: none;
        overflow: auto;
        overflow-x: hidden;
        max-height: 160px;
        li {
          color: var(--textInput-listOptionFontColor);
          font-family: var(--textInput-listOptionFontFamily);
          font-size: var(--textInput-listOptionFontSize);
          font-weight: var(--textInput-listOptionFontWeight);
          line-height: 1.75em;
          padding-top: calc((39px - 1.75em) / 2);
          padding-bottom: calc((39px - 1.75em) / 2);
          padding-left: 1em;
          cursor: pointer;
          :hover{
            background-color: var(--textInput-hoverListOptionBackgroundColor);
          }
          &.focused {
            box-shadow: inset 0 0 0 2px #0095ff;
          }
          &.active.focused {
            background-color: var(--textInput-activeListOptionBackgroundColor);
          }
          b{
            font-weight: var(--textInput-listOptionTypedFontWeight);
          }
          &.systemMessage{
            color: var(--textInput-systemMessageFontColor);
            font-family: var(--textInput-systemMessageFontFamily);
            font-size: var(--textInput-systemMessageFontSize);
            font-weight: var(--textInput-systemMessageFontWeight);
          }
        }

        &.fetchingError{
          border: 1px solid var(--textInput-errorMessageBorderColor);
          li{
            font-family: var(--textInput-errorMessageFontFamily);
            font-size: var(--textInput-errorMessageFontSize);
            font-weight: var(--textInput-errorMessageFontWeight);
            align-items: center;
            display: flex;
            background-color: var(--textInput-errorMessageBackgroundColor);
            svg{
              height: 18px;
              width: 18px;
              fill: var(--textInput-errorIconColor);
            }
            span{
              margin-left: 8px;
            }
          }
        }

        &::-webkit-scrollbar {
          width: 3px;
        }
        &::-webkit-scrollbar-track {
          background-color: var(--inputText-scrollBarTrackColor);
          opacity: 0.34;
          border-radius: 3px;
        }
        &::-webkit-scrollbar-thumb {
          background-color: var(--inputText-scrollBarThumbColor);
          border-radius: 3px;
        }
      }

      ${inputs.darkBackground ? this.getDarkStyle(inputs) : ""}

      ${inputs.disabled
            ? inputs.darkBackground
                ? this.getDisabledDarkStyle()
                : this.getDisabledStyle()
            : ""}
    `;
    }
    getDarkStyle(inputs) {
        return css ``;
        // return css`
        //   dxc-text-input-prefix {
        //     border-right: 1px solid var(--textInput-prefixColorOnDark);
        //     color: var(--textInput-prefixColorOnDark);
        //   }
        //   dxc-text-input-suffix {
        //     border-left: 1px solid var(--textInput-suffixColorOnDark);
        //     color: var(--textInput-suffixColorOnDark);
        //   }
        //   .inputLabel,
        //   .inputOptionalLabel {
        //     color: var(--textInput-labelFontColorOnDark);
        //   }
        //   .helperText {
        //     color: var(--textInput-helperTextFontColorOnDark);
        //   }
        //   .inputText {
        //     color: var(--textInput-valueFontColorOnDark);
        //     caret-color: var(--textInput-valueFontColorOnDark);
        //     &::placeholder {
        //       color: var(--textInput-placeholderFontColorOnDark);
        //     }
        //   }
        //   .inputContainer {
        //     border: ${inputs.error
        //       ? `1px solid var(--textInput-errorBorderColorOnDark)`
        //       : "1px solid var(--textInput-enabledBorderColorOnDark)"};
        //     ${inputs.error
        //       ? `box-shadow: inset 0 0 0 1px var(--textInput-errorBorderColorOnDark);`
        //       : ""};
        //     &:hover {
        //       ${inputs.error
        //         ? `border-color: var(--textInput-hoverErrorBorderColorOnDark);
        //                box-shadow: inset 0 0 0 1px var(--textInput-hoverErrorBorderColorOnDark);`
        //         : `border-color: var(--textInput-hoverBorderColorOnDark);`};
        //     }
        //     &:focus-within {
        //       border: 1px solid var(--textInput-focusBorderColorOnDark);
        //       box-shadow: inset 0 0 0 1px var(--textInput-focusBorderColorOnDark);
        //     }
        //   }
        //   .inputAction {
        //     border: 1px solid var(--textInput-actionBackgroundColorOnDark);
        //     background-color: var(--textInput-actionBackgroundColorOnDark);
        //     color: var(--textInput-actionIconColorOnDark);
        //     &:hover {
        //       color: var(--textInput-hoverActionIconColorOnDark);
        //       background-color: var(--textInput-hoverActionBackgroundColorOnDark);
        //     }
        //     &:focus {
        //       color: var(--textInput-focusActionIconColorOnDark);
        //       border: 2px solid var(--textInput-focusActionBorderColorOnDark);
        //     }
        //     &:focus-visible {
        //       color: var(--textInput-focusActionIconColorOnDark);
        //       border: 2px solid var(--textInput-focusActionBorderColorOnDark);
        //     }
        //     &:active {
        //       border: 2px solid var(--textInput-focusActionBorderColorOnDark);
        //       box-shadow: inset 0 0 0 1px
        //         var(--textInput-activeActionBackgroundColorOnDark);
        //       background-color: var(--textInput-activeActionBackgroundColorOnDark);
        //       color: var(--textInput-activeActionIconColorOnDark);
        //     }
        //   }
        //   .inputErrorIcon {
        //     color: var(--textInput-errorIconColorOnDark);
        //   }
        //   .inputErrorMessage {
        //     color: var(--textInput-errorMessageColorOnDark);
        //   }
        // `;
    }
}
DxcTextInputHelper.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcTextInputHelper, deps: [{ token: CssUtils }], target: i0.ɵɵFactoryTarget.Injectable });
DxcTextInputHelper.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcTextInputHelper });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcTextInputHelper, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: CssUtils }]; } });

class BoldOptionsPipe {
    transform(option, actualValue) {
        let boldString = option.slice(0, actualValue.length);
        return option.replace(boldString, "<b>" + boldString + "</b>");
    }
}
BoldOptionsPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: BoldOptionsPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
BoldOptionsPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: BoldOptionsPipe, name: "boldOptions" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: BoldOptionsPipe, decorators: [{
            type: Pipe,
            args: [{ name: "boldOptions" }]
        }] });

class FilterOptionsPipe$1 {
    constructor(service) {
        this.service = service;
    }
    transform(options, actualValue) {
        if (actualValue) {
            const value = typeof actualValue === "string"
                ? actualValue?.toLowerCase()
                : actualValue?.value.toLowerCase();
            const array = options?.filter((element) => element.toLowerCase().startsWith(value));
            this.service.setFilteredOptions(array);
            return array;
        }
        return options;
    }
}
FilterOptionsPipe$1.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: FilterOptionsPipe$1, deps: [{ token: DxcTextInputService }], target: i0.ɵɵFactoryTarget.Pipe });
FilterOptionsPipe$1.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: FilterOptionsPipe$1, name: "filterOptions" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: FilterOptionsPipe$1, decorators: [{
            type: Pipe,
            args: [{ name: "filterOptions", pure: true }]
        }], ctorParameters: function () { return [{ type: DxcTextInputService }]; } });

class DxcTextInputComponent {
    constructor(cdRef, service, helper, bgProviderService) {
        this.cdRef = cdRef;
        this.service = service;
        this.helper = helper;
        this.bgProviderService = bgProviderService;
        this.hasError = false;
        /**
         * Name attribute of the input element.
         */
        this.name = "";
        /**
         * Text to be put as placeholder of the input.
         */
        this.placeholder = "";
        /**
         * HTML autocomplete attribute. Lets the user specify if any permission the user agent has to provide automated assistance in filling out the input value.
         * Its value must be one of all the possible values of the HTML autocomplete attribute: 'on', 'off', 'email', 'username', 'new-password', ...
         */
        this.autocomplete = "off";
        this.hasAction = () => this.onActionClick.observers.length;
        this._disabled = false;
        this._optional = false;
        /**
         * If true, the input will have an action to clear the entered value.
         */
        this.clearable = false;
        /**
         * If it is a defined value and also a truthy string, the component will
         * change its appearance, showing the error below the input component. If the
         * defined value is an empty string, it will reserve a space below the
         * component for a future error, but it would not change its look. In case of
         * being undefined or null, both the appearance and the space for the error
         * message would not be modified.
         */
        this.error = undefined;
        /**
         * Value of the tabindex attribute.
         */
        this.tabIndexValue = 0;
        /**
         * Size of the component ('small' | 'medium' | 'large' | 'fillParent').
         */
        this.size = "medium";
        this.defaultInputs = new BehaviorSubject({
            placeholder: "",
            error: undefined,
            clearable: false,
            optional: false,
            disabled: false,
            helperText: "",
            value: undefined,
            name: "",
            label: "",
            margin: null,
            suggestions: [],
            tabIndexValue: 0,
            size: "medium",
        });
        /**
         * This event will emit when the user types within the input element
         * of the component. An object including the current value and the error (if
         * the value entered is not valid) will be passed to this function. An
         * example of this object is: { value: value, error: error }. If there is no
         * error, error will not be defined.
         */
        this.onChange = new EventEmitter();
        /**
         * This event will emit when the input element loses the focus. An object
         * including the input value and the error (if the value entered is not
         * valid) will be passed to this function. An example of this object is: {
         * value: value, error: error }. If there is no error, error will not be
         * defined.
         */
        this.onBlur = new EventEmitter();
        /**
         * This event will emit when the action is clicked.
         */
        this.onActionClick = new EventEmitter();
        this.autosuggestVisible = false;
        this.darkBackground = false;
        this.isDirty = false;
        this.options = [];
        this.loading = new BehaviorSubject(false);
        this.fetchingError = new BehaviorSubject(false);
        this.validationError = "";
        this.isInputNumber = false;
        this.onTouch = () => { };
        this.isRequired = (value) => value === "" && !this.optional;
        this.isLengthIncorrect = (value) => (value !== "" &&
            this.minLength &&
            value &&
            value.length < +this.minLength) ||
            (this.maxLength && value && value.length > +this.maxLength);
        this.bgProviderService.$changeColor.subscribe((value) => {
            setTimeout(() => {
                if (value === "dark") {
                    this.darkBackground = true;
                }
                else if (value === "light") {
                    this.darkBackground = false;
                }
                this.className = `${this.helper.getDynamicStyle({
                    ...this.defaultInputs.getValue(),
                    darkBackground: this.darkBackground,
                    validationError: this.validationError,
                })}`;
            }, 0);
        });
    }
    /**
     * If true, the component will be disabled.
     */
    get disabled() {
        return this._disabled;
    }
    set disabled(value) {
        this._disabled = coerceBooleanProperty(value);
    }
    /**
     * If true, the input will be optional, showing '(Optional)'
     * next to the label. Otherwise, the field will be considered required and an error will be
     * passed as a parameter to the OnBlur and onChange events when it has
     * not been filled.
     */
    get optional() {
        return this._optional;
    }
    set optional(value) {
        this._optional = coerceBooleanProperty(value);
    }
    writeValue(value) {
        if (value) {
            this.value = value || "";
        }
        else {
            this.value = "";
        }
    }
    registerOnChange(fn) {
        this.handleOnChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouch = fn;
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    ngOnDestroy() { }
    ngOnInit() {
        this.id = this.id || v4();
        this.autoSuggestId = this.id + "-listBox";
        this.className = `${this.helper.getDynamicStyle({
            ...this.defaultInputs.getValue(),
            darkBackground: this.darkBackground,
            validationError: this.validationError,
        })}`;
        if (this.value === undefined) {
            this.defaultValue ? (this.value = this.defaultValue) : (this.value = "");
            this.controlled = false;
        }
        else {
            this.controlled = true;
        }
        this.service.visualFocused.subscribe((value) => {
            this.focusedOption = value;
            if (this.optionsRef &&
                this.optionsRef.nativeElement.children[this.focusedOption]) {
                this.optionsRef.nativeElement.children[this.focusedOption].scrollIntoView({
                    behavior: "smooth",
                    block: "nearest",
                    inline: "nearest",
                });
            }
        });
        this.service.activeOption.subscribe((value) => {
            this.activedOption = value;
        });
        this.service.filteredOptions.subscribe((filteredArray) => {
            this.filteredOptions = filteredArray;
            if (this.suggestions &&
                (this.suggestions.length || this.autosuggestType === "async") &&
                this.filteredOptions?.length > 0 &&
                this.isDirty) {
                this.autosuggestVisible = true;
            }
            else {
                this.autosuggestVisible = false;
            }
            this.cdRef.detectChanges();
        });
        if (this.suggestions && typeof this.suggestions === "function") {
            this.getAsyncSuggestions();
            this.autosuggestType = "async";
        }
        else if (this.suggestions && Array.isArray(this.suggestions)) {
            this.options = this.suggestions;
            this.autosuggestType = "array";
        }
    }
    ngAfterViewInit() {
        if (this.inputRef) {
            if (this.suggestions && this.suggestions.length) {
                this.optionsRef.nativeElement.ariaLabel = this.label;
            }
            this.inputRef.nativeElement.ariaDisabled = this.disabled;
        }
    }
    ngOnChanges(changes) {
        this.hasError = this.error && !this.disabled ? true : false;
        const inputs = Object.keys(changes).reduce((result, item) => {
            result[item] = changes[item].currentValue;
            return result;
        }, {});
        this.defaultInputs.next({ ...this.defaultInputs.getValue(), ...inputs });
        this.className = `${this.helper.getDynamicStyle({
            ...this.defaultInputs.getValue(),
            darkBackground: this.darkBackground,
            validationError: this.validationError,
        })}`;
    }
    handleOnChange(event) {
        if (this.value !== event && this.isDirty) {
            this.onChange.emit({ value: event, error: this.validateValue(event) });
        }
        if (!this.controlled) {
            this.value = event;
            if (this.autosuggestType === "async") {
                this.getAsyncSuggestions();
            }
        }
        else {
            setTimeout(() => {
                if (this.inputRef.nativeElement.value !== this.value) {
                    this.inputRef.nativeElement.value = this.value;
                    this.cdRef.detectChanges();
                }
                if (this.autosuggestType === "async") {
                    this.getAsyncSuggestions();
                }
            }, 0);
        }
        this.cdRef.detectChanges();
        this.service.setSelectedIndex(-1);
    }
    handleDefaultClearAction() {
        if (!this.isDirty) {
            this.isDirty = true;
        }
        this.handleOnChange("");
        this.inputRef.nativeElement.focus();
        if (this.suggestions) {
            this.autosuggestVisible = false;
            this.cdRef.detectChanges();
        }
    }
    handleActionOnClick(event) {
        this.handleOnBlur();
        this.onActionClick.emit(this.value);
    }
    handleOnBlur() {
        this.onBlur.emit({
            value: this.value,
            error: this.handleValidationError(),
        });
    }
    handleOnFocus() {
        if (!this.isDirty) {
            this.isDirty = true;
        }
        if (this.suggestions &&
            (this.suggestions.length || this.autosuggestType === "async") &&
            this.filteredOptions?.length > 0) {
            this.autosuggestVisible = true;
            this.cdRef.detectChanges();
        }
        else {
            this.autosuggestVisible = false;
            this.cdRef.detectChanges();
        }
    }
    focusInput() {
        this.inputRef.nativeElement.focus();
    }
    handleOnClick() {
        if (this.suggestions &&
            (this.suggestions.length || this.autosuggestType === "async") &&
            this.filteredOptions?.length > 0) {
            this.autosuggestVisible = true;
            this.cdRef.detectChanges();
        }
        else {
            this.autosuggestVisible = false;
            this.cdRef.detectChanges();
        }
    }
    handleOnClose() {
        if (this.autosuggestVisible) {
            this.service.visualFocused.next(-1);
            this.autosuggestVisible = false;
            this.cdRef.detectChanges();
        }
    }
    handleOnClickOption(event) {
        this.onChange.emit({ value: event, error: this.validateValue(event) });
        this.value = event;
        this.handleOnClose();
        this.service.activeOption.next(-1);
    }
    handleEnterKey() {
        if (this.focusedOption >= 0) {
            this.handleOnChange(this.filteredOptions[this.focusedOption]);
        }
        this.handleOnClose();
    }
    handleMouseDown(event, index) {
        this.service.activeOption.next(index);
        event.preventDefault();
    }
    handleOnLeave() {
        this.service.activeOption.next(-1);
    }
    handleOnKeyDown(event) {
        switch (event.key) {
            case "ArrowDown":
                event.preventDefault();
                this.service.onArrowDown();
                this.handleOnClick();
                break;
            case "ArrowUp":
                event.preventDefault();
                this.service.onArrowUp();
                this.handleOnFocus();
                break;
            case "Enter":
                this.handleEnterKey();
                break;
            case "Escape":
                if (this.suggestions && this.suggestions.length) {
                    event.preventDefault();
                    this.handleDefaultClearAction();
                    this.handleOnClose();
                }
                break;
        }
    }
    patternMatch(pattern, value) {
        const patternToMatch = new RegExp(pattern);
        return patternToMatch.test(value);
    }
    validateValue(value) {
        if (this.isRequired(value))
            return `This field is required. Please, enter a value.`;
        if (this.isLengthIncorrect(value))
            return `Min length ${this.minLength}, Max length ${this.maxLength}`;
        if (value && !this.patternMatch(this.pattern, value))
            return `Please use a valid pattern`;
        return undefined;
    }
    handleValidationError() {
        const validationError = this.validateValue(this.value);
        this.validationError = validationError;
        return validationError;
    }
    getAsyncSuggestions() {
        this.loading.next(true);
        this.fetchingError.next(false);
        this.suggestions(this.value).subscribe((suggestionsOptionsList) => {
            this.options = suggestionsOptionsList;
            this.autosuggestVisible = true;
            this.cdRef.markForCheck();
            this.loading.next(false);
        }, (err) => {
            this.fetchingError.next(true);
            this.autosuggestVisible = false;
            this.loading.next(false);
            this.cdRef.markForCheck();
        });
    }
}
DxcTextInputComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcTextInputComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: DxcTextInputService }, { token: DxcTextInputHelper }, { token: BackgroundProviderService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
DxcTextInputComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.5", type: DxcTextInputComponent, selector: "dxc-text-input", inputs: { label: "label", name: "name", value: "value", defaultValue: "defaultValue", helperText: "helperText", placeholder: "placeholder", autocomplete: "autocomplete", disabled: "disabled", optional: "optional", clearable: "clearable", error: "error", pattern: "pattern", minLength: "minLength", maxLength: "maxLength", margin: "margin", suggestions: "suggestions", tabIndexValue: "tabIndexValue", size: "size" }, outputs: { onChange: "onChange", onBlur: "onBlur", onActionClick: "onActionClick" }, host: { properties: { "class": "this.className", "class.hasError": "this.hasError" } }, providers: [
        DxcTextInputService,
        DxcTextInputHelper,
        CssUtils,
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => DxcTextInputComponent),
            multi: true,
        },
    ], viewQueries: [{ propertyName: "inputRef", first: true, predicate: ["inputRef"], descendants: true, static: true }, { propertyName: "optionsRef", first: true, predicate: ["autoSuggestOptions"], descendants: true }, { propertyName: "stepButtonMinus", first: true, predicate: ["stepButtonMinus"], descendants: true }, { propertyName: "stepButtonPlus", first: true, predicate: ["stepButtonPlus"], descendants: true }, { propertyName: "actionButton", first: true, predicate: ["actionButton"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<label *ngIf=\"label\" class=\"inputLabel\" htmlFor=\"{{ id }}\">\n  {{ label }}\n  <span *ngIf=\"optional\" class=\"inputOptionalLabel\">(Optional)</span>\n</label>\n<span *ngIf=\"helperText\" class=\"helperText\">{{ helperText }}</span>\n<div class=\"inputContainer\">\n  <span (click)=\"focusInput()\"\n    ><ng-content select=\"dxc-text-input-prefix\"></ng-content\n  ></span>\n  <input\n    #inputRef\n    (focus)=\"handleOnFocus()\"\n    (focusout)=\"handleOnClose()\"\n    (keydown)=\"handleOnKeyDown($event)\"\n    (blur)=\"handleOnBlur()\"\n    (ngModelChange)=\"handleOnChange($event)\"\n    (click)=\"handleOnClick()\"\n    type=\"text\"\n    class=\"inputText\"\n    [attr.role]=\"suggestions ? 'combobox' : 'textbox'\"\n    [id]=\"id\"\n    [placeholder]=\"placeholder\"\n    [ngModel]=\"value\"\n    [name]=\"name\"\n    [disabled]=\"disabled\"\n    [pattern]=\"pattern\"\n    [tabindex]=\"tabIndexValue\"\n    [attr.aria-activedescendant]=\"\n      suggestions && autosuggestVisible && suggestions[focusedOption]\n    \"\n    [attr.aria-expanded]=\"suggestions && autosuggestVisible\"\n    [attr.aria-controls]=\"suggestions && autoSuggestId\"\n    [attr.aria-autocomplete]=\"suggestions && 'list'\"\n    [autocomplete]=\"autocomplete\"\n  />\n  <span *ngIf=\"error && !disabled\" class=\"inputErrorIcon\" aria-label=\"Error\">\n    <svg\n      xmlns=\"http://www.w3.org/2000/svg\"\n      height=\"24px\"\n      viewBox=\"0 0 24 24\"\n      width=\"24px\"\n      fill=\"currentColor\"\n    >\n      <path\n        d=\"M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z\"\n      />\n    </svg>\n  </span>\n  <button\n    *ngIf=\"clearable && !disabled && value\"\n    class=\"inputAction\"\n    (click)=\"handleDefaultClearAction()\"\n    [disabled]=\"disabled\"\n    aria-label=\"Clear\"\n    [tabindex]=\"tabIndexValue\"\n  >\n    <svg\n      xmlns=\"http://www.w3.org/2000/svg\"\n      width=\"24\"\n      height=\"24\"\n      viewBox=\"0 0 24 24\"\n      fill=\"currentColor\"\n    >\n      <path d=\"M0 0h24v24H0V0z\" fill=\"none\" />\n      <path\n        d=\"M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z\"\n      />\n    </svg>\n  </button>\n  <button\n    #actionButton\n    *ngIf=\"hasAction()\"\n    class=\"inputAction\"\n    (click)=\"handleActionOnClick($event)\"\n    [disabled]=\"disabled\"\n    aria-label=\"Action\"\n    [tabindex]=\"tabIndexValue\"\n  >\n    <ng-content select=\"dxc-text-input-action\"></ng-content>\n  </button>\n  <button\n    #stepButtonMinus\n    *ngIf=\"isInputNumber\"\n    class=\"inputAction\"\n    [disabled]=\"disabled\"\n    aria-label=\"Decrement\"\n    [tabindex]=\"tabIndexValue\"\n  >\n    <svg\n      xmlns=\"http://www.w3.org/2000/svg\"\n      height=\"24\"\n      viewBox=\"0 0 24 24\"\n      width=\"24\"\n      fill=\"currentColor\"\n    >\n      <path d=\"M0 0h24v24H0z\" fill=\"none\" />\n      <path d=\"M19 13H5v-2h14v2z\" />\n    </svg>\n  </button>\n  <button\n    #stepButtonPlus\n    *ngIf=\"isInputNumber\"\n    class=\"inputAction\"\n    [disabled]=\"disabled\"\n    aria-label=\"Increment\"\n    [tabindex]=\"tabIndexValue\"\n  >\n    <svg\n      xmlns=\"http://www.w3.org/2000/svg\"\n      height=\"24\"\n      viewBox=\"0 0 24 24\"\n      width=\"24\"\n      fill=\"currentColor\"\n    >\n      <path d=\"M0 0h24v24H0z\" fill=\"none\" />\n      <path d=\"M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z\" />\n    </svg>\n  </button>\n  <span (click)=\"focusInput()\">\n    <ng-content select=\"dxc-text-input-suffix\"></ng-content>\n  </span>\n  <ul\n    #autoSuggestOptions\n    [ngClass]=\"{\n      visible: autosuggestVisible,\n      fetchingError: fetchingError.getValue()\n    }\"\n    [id]=\"autoSuggestId\"\n    role=\"listbox\"\n    class=\"options\"\n    *ngIf=\"suggestions && autosuggestType\"\n  >\n    <li\n      *ngFor=\"\n        let item of autosuggestType && autosuggestType === 'async'\n          ? !loading.getValue()\n            ? options\n            : []\n          : (suggestions | filterOptions: value);\n        let i = index\n      \"\n      role=\"option\"\n      [attr.aria-selected]=\"focusedOption === i\"\n      [ngClass]=\"{\n        focused: focusedOption === i,\n        active: focusedOption === i && activedOption === i\n      }\"\n      [innerHtml]=\"\n        autosuggestType === 'async' ? item : (item | boldOptions: value)\n      \"\n      [id]=\"item\"\n      (mousedown)=\"handleMouseDown($event, i)\"\n      (mouseup)=\"handleOnClickOption(item)\"\n      (mouseleave)=\"handleOnLeave()\"\n    ></li>\n    <li *ngIf=\"fetchingError.getValue() && !loading.getValue()\">\n      <svg\n        xmlns=\"http://www.w3.org/2000/svg\"\n        height=\"24px\"\n        viewBox=\"0 0 24 24\"\n        width=\"24px\"\n      >\n        <path\n          d=\"M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z\"\n        />\n      </svg>\n      <span>Error fetching data</span>\n    </li>\n    <li *ngIf=\"loading.getValue()\">\n      <span>Searching...</span>\n    </li>\n  </ul>\n</div>\n\n<span *ngIf=\"(error || error === '') && !disabled\" class=\"inputErrorMessage\">{{\n  error\n}}</span>\n", directives: [{ type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i5.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i5.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i5.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i5.PatternValidator, selector: "[pattern][formControlName],[pattern][formControl],[pattern][ngModel]", inputs: ["pattern"] }, { type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i4.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], pipes: { "boldOptions": BoldOptionsPipe, "filterOptions": FilterOptionsPipe$1 } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcTextInputComponent, decorators: [{
            type: Component,
            args: [{ selector: "dxc-text-input", providers: [
                        DxcTextInputService,
                        DxcTextInputHelper,
                        CssUtils,
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => DxcTextInputComponent),
                            multi: true,
                        },
                    ], template: "<label *ngIf=\"label\" class=\"inputLabel\" htmlFor=\"{{ id }}\">\n  {{ label }}\n  <span *ngIf=\"optional\" class=\"inputOptionalLabel\">(Optional)</span>\n</label>\n<span *ngIf=\"helperText\" class=\"helperText\">{{ helperText }}</span>\n<div class=\"inputContainer\">\n  <span (click)=\"focusInput()\"\n    ><ng-content select=\"dxc-text-input-prefix\"></ng-content\n  ></span>\n  <input\n    #inputRef\n    (focus)=\"handleOnFocus()\"\n    (focusout)=\"handleOnClose()\"\n    (keydown)=\"handleOnKeyDown($event)\"\n    (blur)=\"handleOnBlur()\"\n    (ngModelChange)=\"handleOnChange($event)\"\n    (click)=\"handleOnClick()\"\n    type=\"text\"\n    class=\"inputText\"\n    [attr.role]=\"suggestions ? 'combobox' : 'textbox'\"\n    [id]=\"id\"\n    [placeholder]=\"placeholder\"\n    [ngModel]=\"value\"\n    [name]=\"name\"\n    [disabled]=\"disabled\"\n    [pattern]=\"pattern\"\n    [tabindex]=\"tabIndexValue\"\n    [attr.aria-activedescendant]=\"\n      suggestions && autosuggestVisible && suggestions[focusedOption]\n    \"\n    [attr.aria-expanded]=\"suggestions && autosuggestVisible\"\n    [attr.aria-controls]=\"suggestions && autoSuggestId\"\n    [attr.aria-autocomplete]=\"suggestions && 'list'\"\n    [autocomplete]=\"autocomplete\"\n  />\n  <span *ngIf=\"error && !disabled\" class=\"inputErrorIcon\" aria-label=\"Error\">\n    <svg\n      xmlns=\"http://www.w3.org/2000/svg\"\n      height=\"24px\"\n      viewBox=\"0 0 24 24\"\n      width=\"24px\"\n      fill=\"currentColor\"\n    >\n      <path\n        d=\"M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z\"\n      />\n    </svg>\n  </span>\n  <button\n    *ngIf=\"clearable && !disabled && value\"\n    class=\"inputAction\"\n    (click)=\"handleDefaultClearAction()\"\n    [disabled]=\"disabled\"\n    aria-label=\"Clear\"\n    [tabindex]=\"tabIndexValue\"\n  >\n    <svg\n      xmlns=\"http://www.w3.org/2000/svg\"\n      width=\"24\"\n      height=\"24\"\n      viewBox=\"0 0 24 24\"\n      fill=\"currentColor\"\n    >\n      <path d=\"M0 0h24v24H0V0z\" fill=\"none\" />\n      <path\n        d=\"M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z\"\n      />\n    </svg>\n  </button>\n  <button\n    #actionButton\n    *ngIf=\"hasAction()\"\n    class=\"inputAction\"\n    (click)=\"handleActionOnClick($event)\"\n    [disabled]=\"disabled\"\n    aria-label=\"Action\"\n    [tabindex]=\"tabIndexValue\"\n  >\n    <ng-content select=\"dxc-text-input-action\"></ng-content>\n  </button>\n  <button\n    #stepButtonMinus\n    *ngIf=\"isInputNumber\"\n    class=\"inputAction\"\n    [disabled]=\"disabled\"\n    aria-label=\"Decrement\"\n    [tabindex]=\"tabIndexValue\"\n  >\n    <svg\n      xmlns=\"http://www.w3.org/2000/svg\"\n      height=\"24\"\n      viewBox=\"0 0 24 24\"\n      width=\"24\"\n      fill=\"currentColor\"\n    >\n      <path d=\"M0 0h24v24H0z\" fill=\"none\" />\n      <path d=\"M19 13H5v-2h14v2z\" />\n    </svg>\n  </button>\n  <button\n    #stepButtonPlus\n    *ngIf=\"isInputNumber\"\n    class=\"inputAction\"\n    [disabled]=\"disabled\"\n    aria-label=\"Increment\"\n    [tabindex]=\"tabIndexValue\"\n  >\n    <svg\n      xmlns=\"http://www.w3.org/2000/svg\"\n      height=\"24\"\n      viewBox=\"0 0 24 24\"\n      width=\"24\"\n      fill=\"currentColor\"\n    >\n      <path d=\"M0 0h24v24H0z\" fill=\"none\" />\n      <path d=\"M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z\" />\n    </svg>\n  </button>\n  <span (click)=\"focusInput()\">\n    <ng-content select=\"dxc-text-input-suffix\"></ng-content>\n  </span>\n  <ul\n    #autoSuggestOptions\n    [ngClass]=\"{\n      visible: autosuggestVisible,\n      fetchingError: fetchingError.getValue()\n    }\"\n    [id]=\"autoSuggestId\"\n    role=\"listbox\"\n    class=\"options\"\n    *ngIf=\"suggestions && autosuggestType\"\n  >\n    <li\n      *ngFor=\"\n        let item of autosuggestType && autosuggestType === 'async'\n          ? !loading.getValue()\n            ? options\n            : []\n          : (suggestions | filterOptions: value);\n        let i = index\n      \"\n      role=\"option\"\n      [attr.aria-selected]=\"focusedOption === i\"\n      [ngClass]=\"{\n        focused: focusedOption === i,\n        active: focusedOption === i && activedOption === i\n      }\"\n      [innerHtml]=\"\n        autosuggestType === 'async' ? item : (item | boldOptions: value)\n      \"\n      [id]=\"item\"\n      (mousedown)=\"handleMouseDown($event, i)\"\n      (mouseup)=\"handleOnClickOption(item)\"\n      (mouseleave)=\"handleOnLeave()\"\n    ></li>\n    <li *ngIf=\"fetchingError.getValue() && !loading.getValue()\">\n      <svg\n        xmlns=\"http://www.w3.org/2000/svg\"\n        height=\"24px\"\n        viewBox=\"0 0 24 24\"\n        width=\"24px\"\n      >\n        <path\n          d=\"M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z\"\n        />\n      </svg>\n      <span>Error fetching data</span>\n    </li>\n    <li *ngIf=\"loading.getValue()\">\n      <span>Searching...</span>\n    </li>\n  </ul>\n</div>\n\n<span *ngIf=\"(error || error === '') && !disabled\" class=\"inputErrorMessage\">{{\n  error\n}}</span>\n" }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: DxcTextInputService }, { type: DxcTextInputHelper }, { type: BackgroundProviderService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { className: [{
                type: HostBinding,
                args: ["class"]
            }], hasError: [{
                type: HostBinding,
                args: ["class.hasError"]
            }], label: [{
                type: Input
            }], name: [{
                type: Input
            }], value: [{
                type: Input
            }], defaultValue: [{
                type: Input
            }], helperText: [{
                type: Input
            }], placeholder: [{
                type: Input
            }], autocomplete: [{
                type: Input
            }], disabled: [{
                type: Input
            }], optional: [{
                type: Input
            }], clearable: [{
                type: Input
            }], error: [{
                type: Input
            }], pattern: [{
                type: Input
            }], minLength: [{
                type: Input
            }], maxLength: [{
                type: Input
            }], margin: [{
                type: Input
            }], suggestions: [{
                type: Input
            }], tabIndexValue: [{
                type: Input
            }], size: [{
                type: Input
            }], onChange: [{
                type: Output
            }], onBlur: [{
                type: Output
            }], onActionClick: [{
                type: Output
            }], inputRef: [{
                type: ViewChild,
                args: ["inputRef", { static: true }]
            }], optionsRef: [{
                type: ViewChild,
                args: ["autoSuggestOptions", { static: false }]
            }], stepButtonMinus: [{
                type: ViewChild,
                args: ["stepButtonMinus", { static: false }]
            }], stepButtonPlus: [{
                type: ViewChild,
                args: ["stepButtonPlus", { static: false }]
            }], actionButton: [{
                type: ViewChild,
                args: ["actionButton", { static: false }]
            }] } });

class DxcTextInputActionComponent {
    constructor() { }
    ngOnInit() {
    }
}
DxcTextInputActionComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcTextInputActionComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
DxcTextInputActionComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.5", type: DxcTextInputActionComponent, selector: "dxc-text-input-action", ngImport: i0, template: "<div>\n    <ng-content select=\"svg\"></ng-content>\n</div>" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcTextInputActionComponent, decorators: [{
            type: Component,
            args: [{ selector: 'dxc-text-input-action', template: "<div>\n    <ng-content select=\"svg\"></ng-content>\n</div>" }]
        }], ctorParameters: function () { return []; } });

class DxcDateInputComponent {
    constructor(helper, cdRef) {
        this.helper = helper;
        this.cdRef = cdRef;
        /**
         * The format in which the date value will be displayed. User must follow this format when editing the value or it will be considered as an invalid date.
         * In this case, the onBlur and onChange events will be called with an internal error as a parameter reporting the situation.
         */
        this.format = "dd-MM-yyyy";
        this._disabled = false;
        this._placeholder = false;
        this._optional = false;
        this._clearable = false;
        /**
         * Size of the component.
         */
        this.size = "medium";
        /**
         * Value of the tabindex attribute.
         */
        this.tabIndexValue = 0;
        this.autocomplete = "off";
        this.defaultInputs = new BehaviorSubject({
            error: "",
            clearable: false,
            optional: false,
            disabled: false,
            helperText: "",
            value: undefined,
            name: "",
            label: "",
            margin: null,
            size: "medium",
            format: "dd-MM-yyyy",
            tabIndexValue: 0,
            placeholder: false,
            autocomplete: "off",
            defaultValue: undefined,
        });
        /**
         * This event will emit in case the user types within the input element of the component. An object including the string value,
         * the error and the date value will be emitted. If the string value is a valid date, error will be undefined.
         * Also, if the string value is not a valid date, date will be undefined.
         */
        this.onChange = new EventEmitter();
        /**
         * This event will emit in case the input element loses the focus. An object including the string value,
         * the error and the date value will be emitted. If the string value is a valid date, error will be undefined.
         * Also, if the string value is not a valid date, date will be undefined.
         */
        this.onBlur = new EventEmitter();
        this._sizes = [
            "medium",
            "large",
            "fillParent",
        ];
        this._isOpenClicked = false;
        this._isCalendarOpened = false;
        this._isSelectingDate = false;
    }
    /**
     * If true, the component will be disabled.
     */
    get disabled() {
        return this._disabled;
    }
    set disabled(value) {
        this._disabled = coerceBooleanProperty(value);
    }
    /**
     * If true, the date format will appear as placeholder in the field.
     */
    get placeholder() {
        return this._placeholder;
    }
    set placeholder(value) {
        this._placeholder = coerceBooleanProperty(value);
    }
    /**
     * If true, the date will be optional, showing (Optional) next to the label. Otherwise, the field will be considered required
     * and an error will be passed as a parameter to the OnBlur and onChange events when it has not been filled.
     */
    get optional() {
        return this._optional;
    }
    set optional(value) {
        this._optional = coerceBooleanProperty(value);
    }
    /**
     * If true, the date input will have an action to clear the entered value.
     */
    get clearable() {
        return this._clearable;
    }
    set clearable(value) {
        this._clearable = coerceBooleanProperty(value);
    }
    onClickOutsideHandler(event) {
        this.removeRippleCalendarControls();
        if (event.target.offsetParent &&
            event.target.offsetParent?.getAttribute("class")) {
            if (!event.target.offsetParent
                .getAttribute("class")
                .includes("mde-popover-panel") &&
                !event.target.offsetParent
                    .getAttribute("class")
                    .includes("mat-calendar-period") &&
                !event.target.offsetParent
                    .getAttribute("class")
                    .includes("mat-calendar-table")) {
                this.checkOpenCalendar();
            }
        }
        else {
            this.checkOpenCalendar();
        }
    }
    ngOnChanges(changes) {
        if (this.dxcInputRef && this.dxcInputRef.inputRef) {
            this.controlled
                ? (this.dxcInputRef.inputRef.nativeElement.value = this.value)
                : (this.renderedValue = this.dxcInputRef.inputRef.nativeElement.value);
        }
        this.calculateComponentValues();
        const inputs = Object.keys(changes).reduce((result, item) => {
            result[item] = changes[item].currentValue;
            return result;
        }, {});
        this.defaultInputs.next({ ...this.defaultInputs.getValue(), ...inputs });
        this.className = `${this.helper.getDynamicStyle(this.defaultInputs.getValue())}`;
        this.calendarDynamicStyle = `${this.helper.getCalendarContentStyle()}`;
    }
    ngOnInit() {
        this.calculateComponentValues();
        if (this.value === undefined) {
            this.value = "";
            this.controlled = false;
        }
        else {
            this.controlled = true;
        }
        this.className = `${this.helper.getDynamicStyle(this.defaultInputs.getValue())}`;
        this.calendarDynamicStyle = `${this.helper.getCalendarContentStyle()}`;
    }
    ngAfterViewInit() {
        this.dxcInputRef.actionButton.nativeElement.ariaLabel = "Choose Date";
    }
    calculateComponentValues() {
        this.size = this.size
            ? this._sizes.find((item) => item === this.size)
            : "medium";
        this.popOverOffsetX = this.size === "fillParent" ? null : "130";
        this.format = this.format
            ? this.format
            : this.defaultInputs.getValue().format;
        this.renderedValue = this.value;
        this.dateValue = this.getMomentValue(this.renderedValue, this.format);
    }
    removeRippleCalendarControls() {
        Array.from(this.calendar.nativeElement
            .getElementsByClassName("mat-calendar-header")[0]
            .getElementsByClassName("mat-button-ripple mat-ripple")).forEach((el) => el.remove());
    }
    handleOnChange(value) {
        if (this._isCalendarOpened)
            this.closeCalendar();
        let _dateValue = this.getMomentValue(value.value, this.format);
        let _dateReturn = {
            value: value.value,
            error: value.error,
            date: _dateValue.isValid() ? _dateValue.toDate() : undefined,
        };
        this.onChange.emit(_dateReturn);
        this.controlled
            ? (this.dxcInputRef.inputRef.nativeElement.value = this.value)
            : (this.value = value);
        if (!this.value) {
            this.renderedValue = value;
            this.dateValue = _dateValue;
        }
    }
    handleOnBlur(event) {
        let _dateValue = this.getMomentValue(event.value, this.format);
        this.onBlur.emit({
            value: event.value,
            error: event.error,
            date: _dateValue.isValid() ? _dateValue.toDate() : undefined,
        });
        if (!this.controlled) {
            this.renderedValue = event.value;
            this.dateValue = _dateValue;
            this.cdRef.detectChanges();
        }
    }
    onSelectedChangeHandler(value) {
        let _stringValue = this.getDateStringValue(value, this.format);
        let _dateReturn = {
            value: _stringValue,
            date: value.isValid() ? value.toDate() : undefined,
            error: this.dxcInputRef.error,
        };
        this.onChange.emit(_dateReturn);
        if (!this.controlled) {
            this.dateValue = value;
            this.renderedValue = _stringValue;
        }
        this.onBlur.emit(_dateReturn);
        this.closeCalendar();
    }
    checkOpenCalendar() {
        if (this._isCalendarOpened) {
            if (!this._isOpenClicked && !this._isSelectingDate) {
                this.closeCalendar();
            }
            else {
                this._isOpenClicked = false;
                this._isSelectingDate = false;
            }
        }
    }
    handleCalendar() {
        if (this._isCalendarOpened) {
            if (!this._isOpenClicked && !this._isSelectingDate) {
                this.closeCalendar();
            }
            else {
                this._isOpenClicked = false;
            }
        }
        else {
            this._dxcCalendar.activeDate = this.dateValue.isValid()
                ? this.dateValue
                : dayjs();
            this._dxcCalendar.currentView = "month";
            this._dxcTrigger.openPopover();
            this.resetCalendarState(true);
        }
    }
    closeCalendar() {
        this._dxcTrigger.closePopover();
        this.resetCalendarState();
    }
    onSelectingDateHandler() {
        this._isSelectingDate = true;
    }
    resetCalendarState(value = false) {
        this._isOpenClicked =
            this._isCalendarOpened =
                this._isSelectingDate =
                    value;
    }
    getMomentValue(value, format) {
        return dayjs(value, format.toUpperCase());
    }
    getDateStringValue(value, format) {
        return dayjs(value).format(format.toUpperCase());
    }
}
DxcDateInputComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcDateInputComponent, deps: [{ token: DxcDateInputHelper }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
DxcDateInputComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.5", type: DxcDateInputComponent, selector: "dxc-date-input", inputs: { label: "label", name: "name", value: "value", defaultValue: "defaultValue", helperText: "helperText", format: "format", disabled: "disabled", placeholder: "placeholder", optional: "optional", clearable: "clearable", error: "error", margin: "margin", size: "size", tabIndexValue: "tabIndexValue", autocomplete: "autocomplete" }, outputs: { onChange: "onChange", onBlur: "onBlur" }, host: { listeners: { "document:click": "onClickOutsideHandler($event)" }, properties: { "class": "this.className" } }, providers: [DxcDateInputHelper, CssUtils], viewQueries: [{ propertyName: "dxcInputRef", first: true, predicate: ["dxcInput"], descendants: true }, { propertyName: "_dxcTrigger", first: true, predicate: MdePopoverTrigger, descendants: true }, { propertyName: "_dxcCalendar", first: true, predicate: ["dxcCalendar"], descendants: true }, { propertyName: "calendar", first: true, predicate: ["dxcCalendar"], descendants: true, read: ElementRef }], usesOnChanges: true, ngImport: i0, template: "<dxc-text-input\n  #dxcInput\n  [value]=\"renderedValue\"\n  [defaultValue]=\"defaultValue\"\n  [clearable]=\"clearable\"\n  [error]=\"error\"\n  [label]=\"label\"\n  [name]=\"name\"\n  [helperText]=\"helperText\"\n  [optional]=\"optional\"\n  [placeholder]=\"placeholder ? format : ''\"\n  [disabled]=\"disabled\"\n  [margin]=\"margin\"\n  [size]=\"size\"\n  (onChange)=\"handleOnChange($event)\"\n  (onBlur)=\"handleOnBlur($event)\"\n  (onActionClick)=\"handleCalendar()\"\n  [mdePopoverTriggerFor]=\"dxcPopover\"\n  mdePopoverTriggerOn=\"none\"\n  [mdePopoverOffsetX]=\"popOverOffsetX\"\n  [mdePopoverPositionX]=\"'before'\"\n  [tabIndexValue]=\"tabIndexValue\"\n  [autocomplete]=\"autocomplete\"\n>\n  <dxc-text-input-action>\n    <svg\n      role=\"calendarIcon\"\n      xmlns=\"http://www.w3.org/2000/svg\"\n      height=\"24\"\n      viewBox=\"0 0 24 24\"\n      width=\"24\"\n      fill=\"currentColor\"\n    >\n      <path\n        d=\"M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z\"\n      />\n      <path d=\"M0 0h24v24H0z\" fill=\"none\" />\n    </svg>\n  </dxc-text-input-action>\n</dxc-text-input>\n\n<mde-popover\n  #dxcPopover=\"mdePopover\"\n  [mdePopoverOverlapTrigger]=\"false\"\n  [mdePopoverCloseOnClick]=\"false\"\n  [mdePopoverArrowWidth]=\"0\"\n  role=\"dialog\"\n  aria-modal=\"true\"\n>\n  <div [class]=\"calendarDynamicStyle\">\n    <dxc-box theme size=\"fillParent\" padding=\"xsmall\">\n      <mat-calendar\n        #dxcCalendar\n        [selected]=\"dateValue\"\n        (selectedChange)=\"onSelectedChangeHandler($event)\"\n        (yearSelected)=\"onSelectingDateHandler()\"\n        (monthSelected)=\"onSelectingDateHandler()\"\n      >\n      </mat-calendar>\n    </dxc-box>\n  </div>\n</mde-popover>\n", components: [{ type: DxcTextInputComponent, selector: "dxc-text-input", inputs: ["label", "name", "value", "defaultValue", "helperText", "placeholder", "autocomplete", "disabled", "optional", "clearable", "error", "pattern", "minLength", "maxLength", "margin", "suggestions", "tabIndexValue", "size"], outputs: ["onChange", "onBlur", "onActionClick"] }, { type: DxcTextInputActionComponent, selector: "dxc-text-input-action" }, { type: i4$2.MdePopover, selector: "mde-popover", inputs: ["mdePopoverPositionX", "mdePopoverPositionY", "mdePopoverTriggerOn", "mdePopoverEnterDelay", "mdePopoverLeaveDelay", "mdePopoverOverlapTrigger", "mdePopoverOffsetX", "mdePopoverOffsetY", "mdePopoverArrowOffsetX", "mdePopoverArrowWidth", "mdePopoverArrowColor", "mdePopoverCloseOnClick", "mdePopoverDisableAnimation", "mdeFocusTrapEnabled", "mdeFocusTrapAutoCaptureEnabled", "class", "classList"], outputs: ["close"], exportAs: ["mdePopover"] }, { type: DxcBoxComponent, selector: "dxc-box", inputs: ["shadowDepth", "display", "margin", "padding", "size"] }, { type: i6.MatCalendar, selector: "mat-calendar", inputs: ["startView", "startAt", "selected", "minDate", "maxDate", "headerComponent", "dateFilter", "dateClass", "comparisonStart", "comparisonEnd"], outputs: ["selectedChange", "yearSelected", "monthSelected", "viewChanged", "_userSelection"], exportAs: ["matCalendar"] }], directives: [{ type: i4$2.MdePopoverTrigger, selector: "[mdePopoverTriggerFor]", inputs: ["mdePopoverBackdropCloseOnClick", "mdePopoverTriggerFor", "mdePopoverTargetAt", "mdePopoverPositionX", "mdePopoverPositionY", "mdePopoverTriggerOn", "mdePopoverEnterDelay", "mdePopoverLeaveDelay", "mdePopoverOverlapTrigger", "mdePopoverOffsetX", "mdePopoverOffsetY", "mdePopoverArrowOffsetX", "mdePopoverArrowWidth", "mdePopoverArrowColor", "mdePopoverCloseOnClick"], outputs: ["opened", "closed"], exportAs: ["mdePopoverTrigger"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcDateInputComponent, decorators: [{
            type: Component,
            args: [{ selector: "dxc-date-input", providers: [DxcDateInputHelper, CssUtils], template: "<dxc-text-input\n  #dxcInput\n  [value]=\"renderedValue\"\n  [defaultValue]=\"defaultValue\"\n  [clearable]=\"clearable\"\n  [error]=\"error\"\n  [label]=\"label\"\n  [name]=\"name\"\n  [helperText]=\"helperText\"\n  [optional]=\"optional\"\n  [placeholder]=\"placeholder ? format : ''\"\n  [disabled]=\"disabled\"\n  [margin]=\"margin\"\n  [size]=\"size\"\n  (onChange)=\"handleOnChange($event)\"\n  (onBlur)=\"handleOnBlur($event)\"\n  (onActionClick)=\"handleCalendar()\"\n  [mdePopoverTriggerFor]=\"dxcPopover\"\n  mdePopoverTriggerOn=\"none\"\n  [mdePopoverOffsetX]=\"popOverOffsetX\"\n  [mdePopoverPositionX]=\"'before'\"\n  [tabIndexValue]=\"tabIndexValue\"\n  [autocomplete]=\"autocomplete\"\n>\n  <dxc-text-input-action>\n    <svg\n      role=\"calendarIcon\"\n      xmlns=\"http://www.w3.org/2000/svg\"\n      height=\"24\"\n      viewBox=\"0 0 24 24\"\n      width=\"24\"\n      fill=\"currentColor\"\n    >\n      <path\n        d=\"M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z\"\n      />\n      <path d=\"M0 0h24v24H0z\" fill=\"none\" />\n    </svg>\n  </dxc-text-input-action>\n</dxc-text-input>\n\n<mde-popover\n  #dxcPopover=\"mdePopover\"\n  [mdePopoverOverlapTrigger]=\"false\"\n  [mdePopoverCloseOnClick]=\"false\"\n  [mdePopoverArrowWidth]=\"0\"\n  role=\"dialog\"\n  aria-modal=\"true\"\n>\n  <div [class]=\"calendarDynamicStyle\">\n    <dxc-box theme size=\"fillParent\" padding=\"xsmall\">\n      <mat-calendar\n        #dxcCalendar\n        [selected]=\"dateValue\"\n        (selectedChange)=\"onSelectedChangeHandler($event)\"\n        (yearSelected)=\"onSelectingDateHandler()\"\n        (monthSelected)=\"onSelectingDateHandler()\"\n      >\n      </mat-calendar>\n    </dxc-box>\n  </div>\n</mde-popover>\n" }]
        }], ctorParameters: function () { return [{ type: DxcDateInputHelper }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { className: [{
                type: HostBinding,
                args: ["class"]
            }], label: [{
                type: Input
            }], name: [{
                type: Input
            }], value: [{
                type: Input
            }], defaultValue: [{
                type: Input
            }], helperText: [{
                type: Input
            }], format: [{
                type: Input
            }], disabled: [{
                type: Input
            }], placeholder: [{
                type: Input
            }], optional: [{
                type: Input
            }], clearable: [{
                type: Input
            }], error: [{
                type: Input
            }], margin: [{
                type: Input
            }], size: [{
                type: Input
            }], tabIndexValue: [{
                type: Input
            }], autocomplete: [{
                type: Input
            }], onChange: [{
                type: Output
            }], onBlur: [{
                type: Output
            }], dxcInputRef: [{
                type: ViewChild,
                args: ["dxcInput", { static: false }]
            }], _dxcTrigger: [{
                type: ViewChild,
                args: [MdePopoverTrigger, { static: false }]
            }], _dxcCalendar: [{
                type: ViewChild,
                args: ["dxcCalendar", { static: false }]
            }], calendar: [{
                type: ViewChild,
                args: ["dxcCalendar", { read: ElementRef }]
            }], onClickOutsideHandler: [{
                type: HostListener,
                args: ["document:click", ["$event"]]
            }] } });

class DxcTextInputPrefixComponent {
    constructor() {
        this.value = "";
    }
    ngOnInit() {
    }
}
DxcTextInputPrefixComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcTextInputPrefixComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
DxcTextInputPrefixComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.5", type: DxcTextInputPrefixComponent, selector: "dxc-text-input-prefix", inputs: { value: "value" }, ngImport: i0, template: "{{value}}\n<ng-content select=\"svg\"></ng-content>" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcTextInputPrefixComponent, decorators: [{
            type: Component,
            args: [{ selector: 'dxc-text-input-prefix', template: "{{value}}\n<ng-content select=\"svg\"></ng-content>" }]
        }], ctorParameters: function () { return []; }, propDecorators: { value: [{
                type: Input
            }] } });

class DxcTextInputSuffixComponent {
    constructor() {
        this.value = "";
    }
    ngOnInit() {
    }
}
DxcTextInputSuffixComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcTextInputSuffixComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
DxcTextInputSuffixComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.5", type: DxcTextInputSuffixComponent, selector: "dxc-text-input-suffix", inputs: { value: "value" }, ngImport: i0, template: "{{value}}\n<ng-content select=\"svg\"></ng-content>" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcTextInputSuffixComponent, decorators: [{
            type: Component,
            args: [{ selector: 'dxc-text-input-suffix', template: "{{value}}\n<ng-content select=\"svg\"></ng-content>" }]
        }], ctorParameters: function () { return []; }, propDecorators: { value: [{
                type: Input
            }] } });

class DxcTextInputModule {
}
DxcTextInputModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcTextInputModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DxcTextInputModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcTextInputModule, declarations: [DxcTextInputComponent,
        DxcTextInputActionComponent,
        FilterOptionsPipe$1,
        BoldOptionsPipe,
        DxcTextInputPrefixComponent,
        DxcTextInputSuffixComponent], imports: [CommonModule, FormsModule], exports: [DxcTextInputComponent,
        DxcTextInputActionComponent,
        DxcTextInputPrefixComponent,
        DxcTextInputSuffixComponent] });
DxcTextInputModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcTextInputModule, imports: [[CommonModule, FormsModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcTextInputModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        DxcTextInputComponent,
                        DxcTextInputActionComponent,
                        FilterOptionsPipe$1,
                        BoldOptionsPipe,
                        DxcTextInputPrefixComponent,
                        DxcTextInputSuffixComponent,
                    ],
                    imports: [CommonModule, FormsModule],
                    exports: [
                        DxcTextInputComponent,
                        DxcTextInputActionComponent,
                        DxcTextInputPrefixComponent,
                        DxcTextInputSuffixComponent,
                    ],
                }]
        }] });

const DAYJS_DATE_FORMATS = {
    parse: {
        dateInput: "DD/MM/YYYY",
    },
    display: {
        dateInput: "DD/MM/YYYY",
        monthYearLabel: "MMMM YYYY",
        dateA11yLabel: "DD/MM/YYYY",
        monthYearA11yLabel: "MMMM YYYY",
    },
};
/** InjectionToken for dayjs date adapter to configure options. */
const DAYJS_DATE_ADAPTER_OPTIONS = new InjectionToken("DAYJS_DATE_ADAPTER_OPTIONS", {
    providedIn: "root",
    factory: DAYJS_DATE_ADAPTER_OPTIONS_FACTORY,
});
/** @docs-private */
function DAYJS_DATE_ADAPTER_OPTIONS_FACTORY() {
    return {
        useUtc: false,
    };
}
/** Creates an array and fills it with values. */
function range(length, valueFunction) {
    const valuesArray = Array(length);
    for (let i = 0; i < length; i++) {
        valuesArray[i] = valueFunction(i);
    }
    return valuesArray;
}
/** Adapts dayjs Dates for use with Angular Material. */
class DayjsDateAdapter extends DateAdapter {
    constructor(dateLocale, options) {
        super();
        this.options = options;
        dayjs.extend(localizedFormat);
        dayjs.extend(customParseFormat);
        dayjs.extend(localeData);
        dayjs.extend(relativeTime);
        this.setLocale(dateLocale);
    }
    setLocale(dateLocale) {
        super.setLocale(dateLocale);
        const dayJsLocaleData = dayjs().localeData();
        this._localeData = {
            firstDayOfWeek: 0,
            longMonths: dayJsLocaleData.months(),
            shortMonths: dayJsLocaleData.monthsShort(),
            dates: range(31, (i) => this.createDate(2017, 0, i + 1).format("D")),
            longDaysOfWeek: dayJsLocaleData.weekdays(),
            shortDaysOfWeek: dayJsLocaleData.weekdaysShort(),
            narrowDaysOfWeek: dayJsLocaleData.weekdaysMin(),
        };
    }
    getYear(date) {
        return this.clone(date).year();
    }
    getMonth(date) {
        return this.clone(date).month();
    }
    getDate(date) {
        return this.clone(date).date();
    }
    getDayOfWeek(date) {
        return this.clone(date).day();
    }
    getMonthNames(style) {
        // dayjs.js doesn't support narrow month names, so we just use short if narrow is requested.
        return style === "long"
            ? this._localeData.longMonths
            : this._localeData.shortMonths;
    }
    getDateNames() {
        return this._localeData.dates;
    }
    getDayOfWeekNames(style) {
        if (style === "long") {
            return this._localeData.longDaysOfWeek;
        }
        if (style === "short") {
            return this._localeData.shortDaysOfWeek;
        }
        return this._localeData.narrowDaysOfWeek;
    }
    getYearName(date) {
        return this.clone(date).format("YYYY");
    }
    getFirstDayOfWeek() {
        return this._localeData.firstDayOfWeek;
    }
    getNumDaysInMonth(date) {
        return this.clone(date).daysInMonth();
    }
    clone(date, format) {
        return format ? dayjs(dayjs(date, format)) : date.clone();
    }
    new(date = undefined, format = undefined) {
        if (!date) {
            return dayjs();
        }
        if (format) {
            return dayjs(date, format);
        }
        else {
            return dayjs(date);
        }
    }
    createDate(year, month, date) {
        // dayjs.js will create an invalid date if any of the components are out of bounds, but we
        // explicitly check each case so we can throw more descriptive errors.
        if (month < 0 || month > 11) {
            throw Error(`Invalid month index "${month}". Month index has to be between 0 and 11.`);
        }
        if (date < 1) {
            throw Error(`Invalid date "${date}". Date has to be greater than 0.`);
        }
        const result = this._createDayjs({ year, month, date });
        // If the result isn't valid, the date must have been out of bounds for this month.
        if (!result.isValid()) {
            throw Error(`Invalid date "${date}" for month with index "${month}".`);
        }
        return result;
    }
    today() {
        return this._createDayjs();
    }
    parse(value) {
        if (value && typeof value === "string") {
            return this._createDayjs(value);
        }
        return value ? this._createDayjs(value) : null;
    }
    format(date, displayFormat) {
        date = this.clone(date);
        if (!this.isValid(date)) {
            throw Error("DayjsDateAdapter: Cannot format invalid date.");
        }
        return date.format(displayFormat);
    }
    addCalendarYears(date, years) {
        return this.clone(date).add(years, "year");
    }
    addCalendarMonths(date, months) {
        return this.clone(date).add(months, "month");
    }
    addCalendarDays(date, days) {
        return this.clone(date).add(days, "day");
    }
    toIso8601(date) {
        return this.clone(date).toISOString();
    }
    /**
     * Returns the given value if given a valid dayjs or null. Deserializes valid ISO 8601 strings
     * (https://www.ietf.org/rfc/rfc3339.txt) and valid Date objects into valid dayjss and empty
     * string into null. Returns an invalid date for all other values.
     */
    deserialize(value) {
        let date;
        if (value instanceof Date) {
            date = this._createDayjs(value).locale(this.locale);
        }
        else if (this.isDateInstance(value)) {
            // Note: assumes that cloning also sets the correct locale.
            return this.clone(dayjs(value, "DD/MM/YYYY"));
        }
        if (typeof value === "string") {
            if (!value) {
                return null;
            }
            date = this._createDayjs(value).locale(this.locale);
        }
        if (date && this.isValid(date)) {
            return this._createDayjs(date).locale(this.locale);
        }
        return super.deserialize(value);
    }
    isDateInstance(obj) {
        return dayjs.isDayjs(obj);
    }
    isValid(date) {
        return this.clone(date).isValid();
    }
    invalid() {
        return dayjs(null);
    }
    /** Creates a dayjs instance */
    _createDayjs(args) {
        if (dayjs.isDayjs(args)) {
            return this.clone(args);
        }
        else if (args instanceof Date) {
            return this.clone(dayjs(args));
        }
        else {
            let djs = dayjs();
            let key;
            for (key in args) {
                if (args.hasOwnProperty(key)) {
                    djs = djs.set(key, args[key]);
                }
            }
            return this.clone(djs, "DD/MM/YYYY");
        }
    }
}
DayjsDateAdapter.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DayjsDateAdapter, deps: [{ token: MAT_DATE_LOCALE, optional: true }, { token: DAYJS_DATE_ADAPTER_OPTIONS, optional: true }], target: i0.ɵɵFactoryTarget.Injectable });
DayjsDateAdapter.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DayjsDateAdapter });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DayjsDateAdapter, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [MAT_DATE_LOCALE]
                }] }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [DAYJS_DATE_ADAPTER_OPTIONS]
                }] }]; } });

class DxcDateInputModule {
}
DxcDateInputModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcDateInputModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DxcDateInputModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcDateInputModule, declarations: [DxcDateInputComponent], imports: [CommonModule,
        DxcTextInputModule,
        FormsModule,
        DxcBoxModule,
        MdePopoverModule,
        MatDayjsDateModule,
        MatDatepickerModule], exports: [DxcDateInputComponent] });
DxcDateInputModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcDateInputModule, providers: [
        { provide: MAT_DATE_FORMATS, useValue: DAYJS_DATE_FORMATS },
        {
            provide: DateAdapter,
            useClass: DayjsDateAdapter,
            deps: [MAT_DATE_LOCALE, Platform],
        },
    ], imports: [[
            CommonModule,
            DxcTextInputModule,
            FormsModule,
            DxcBoxModule,
            MdePopoverModule,
            MatDayjsDateModule,
            MatDatepickerModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcDateInputModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [DxcDateInputComponent],
                    imports: [
                        CommonModule,
                        DxcTextInputModule,
                        FormsModule,
                        DxcBoxModule,
                        MdePopoverModule,
                        MatDayjsDateModule,
                        MatDatepickerModule,
                    ],
                    exports: [DxcDateInputComponent],
                    providers: [
                        { provide: MAT_DATE_FORMATS, useValue: DAYJS_DATE_FORMATS },
                        {
                            provide: DateAdapter,
                            useClass: DayjsDateAdapter,
                            deps: [MAT_DATE_LOCALE, Platform],
                        },
                    ],
                }]
        }] });

class DxcDialogComponent {
    constructor(utils) {
        this.utils = utils;
        this._isCloseVisible = true;
        /**
         * Size of the padding to be applied to the component ('xxsmall' | 'xsmall' |
         * 'small' | 'medium' | 'large' | 'xlarge' | 'xxlarge'). You can pass an
         * object with 'top', 'bottom', 'left' and 'right' to
         * specify different padding sizes.
         */
        this.padding = "small";
        /**
         * This event will emit when the user clicks the close 'x' button.
         * The responsibility of hiding the dialog lies with the user.
         */
        this.onCloseClick = new EventEmitter();
        /**
         * This event will emit when the user clicks the background.
         * The responsibility of hiding the dialog lies with the user.
         * */
        this.onBackgroundClick = new EventEmitter();
        this.defaultInputs = new BehaviorSubject({
            overlay: true,
            isCloseVisible: true,
            padding: "small",
            margin: null,
            tabIndexValue: 0,
        });
    }
    /**
     * If true, the dialog will be displayed over a darker background that covers the content behind.
     */
    get overlay() {
        return this._overlay;
    }
    set overlay(value) {
        this._overlay = coerceBooleanProperty(value);
    }
    /**
     * If true, the close 'x' button will be visible.
     */
    get isCloseVisible() {
        return this._isCloseVisible;
    }
    set isCloseVisible(value) {
        this._isCloseVisible = coerceBooleanProperty(value);
    }
    /**
     * Value of the tabindex given to the close button.
     */
    get tabIndexValue() {
        return this._tabIndexValue;
    }
    set tabIndexValue(value) {
        this._tabIndexValue = coerceNumberProperty(value);
    }
    ngOnInit() {
        this.className = `${this.getDynamicStyle(this.defaultInputs.getValue())}`;
    }
    ngOnChanges(changes) {
        const inputs = Object.keys(changes).reduce((result, item) => {
            result[item] = changes[item].currentValue;
            return result;
        }, {});
        this.defaultInputs.next({ ...this.defaultInputs.getValue(), ...inputs });
        this.currentBackgroundColor = this.utils.readProperty("--dialog-backgroundColor");
        this.className = `${this.getDynamicStyle(this.defaultInputs.getValue())}`;
    }
    onCloseHandler($event) {
        this.onCloseClick.emit();
    }
    onBackgroundClickHandler($event) {
        this.onBackgroundClick.emit();
    }
    overlayStyle(overlay) {
        if (overlay === true) {
            return css `
        background-color: var(--dialog-overlayColor);
        opacity: var(--dialog-overlayOpacity) !important;
      `;
        }
        else
            return css `
        background-color: transparent;
      `;
    }
    getDynamicStyle(inputs) {
        return css `
      .dialog {
        position: fixed;
        z-index: 3300;
        right: 0px;
        bottom: 0px;
        top: 0px;
        left: 0px;
        .backOverlay {
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          position: fixed;
          opacity: 1;
          ${this.overlayStyle(inputs.overlay)}
          transition: opacity 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
        }
        .container {
          display: flex;
          align-items: center;
          justify-content: center;
          height: 100%;
          outline: none;
          opacity: 1;
          transition: opacity 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
          .dialogContainer {
            overflow: unset;
            max-width: 80%;
            min-width: 800px;
            ${inputs.isCloseVisible
            ? css `
                  min-height: 72px;
                `
            : css ``}
            box-shadow: rgba(0, 0, 0, 0.2) 0px 1px 3px;
            ${this.utils.getPaddings(inputs.padding)}
            display: flex;
            max-height: calc(100% - 96px);
            flex-direction: column;
            margin: 48px;
            position: relative;
            overflow-y: auto;
            border-radius: 4px;
            transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
            background-color: var(--dialog-backgroundColor);
            .closeIcon {
              display: flex;
              justify-content: flex-end;
              position: absolute;
              top: var(--dialog-closeIconTopPosition);
              right: var(--dialog-closeIconRightPosition);
              color: var(--dialog-closeIconColor);
              svg {
                cursor: pointer;
                background-color: var(--dialog-closeIconBackgroundColor);
                width: var(--dialog-closeIconWidth);
                height: var(--dialog-closeIconHeight);
                border-radius: var(--dialog-closeIconBorderRadius);
                border-width: var(--dialog-closeIconBorderThickness);
                border-style: var(--dialog-closeIconBorderStyle);
                border-color: var(--dialog-closeIconBorderColor);
              }
            }
            .content,
            .content > div,
            .content > span,
            .content > p {
              overflow-y: auto;
              ::-webkit-scrollbar {
                width: 3px;
              }
              ::-webkit-scrollbar-track {
                background-color: #d9d9d9;
                border-radius: 3px;
              }
              ::-webkit-scrollbar-thumb {
                background-color: #666666;
                border-radius: 3px;
              }
            }
          }
        }
      }
    `;
    }
}
DxcDialogComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcDialogComponent, deps: [{ token: CssUtils }], target: i0.ɵɵFactoryTarget.Component });
DxcDialogComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.5", type: DxcDialogComponent, selector: "dxc-dialog", inputs: { overlay: "overlay", isCloseVisible: "isCloseVisible", padding: "padding", tabIndexValue: "tabIndexValue" }, outputs: { onCloseClick: "onCloseClick", onBackgroundClick: "onBackgroundClick" }, host: { properties: { "class": "this.className" } }, providers: [CssUtils, BackgroundProviderService], usesOnChanges: true, ngImport: i0, template: "<div class=\"dialog\">\n  <div\n    class=\"backOverlay\"\n    role=\"overlay\"\n    (click)=\"onBackgroundClickHandler($event)\"\n    [class.backVisible]=\"overlay\"\n  ></div>\n  <div class=\"container\">\n    <div class=\"dialogContainer\">\n      <span\n        class=\"closeIcon\"\n        role=\"closeIcon\"\n        *ngIf=\"isCloseVisible\"\n        (click)=\"onCloseHandler($event)\"\n        [tabindex]=\"tabIndexValue\"\n      >\n        <svg\n          xmlns=\"http://www.w3.org/2000/svg\"\n          width=\"24\"\n          height=\"24\"\n          viewBox=\"0 0 24 24\"\n          fill=\"currentColor\"\n        >\n          <path\n            d=\"M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z\"\n          />\n          <path d=\"M0 0h24v24H0z\" fill=\"none\" />\n        </svg>\n      </span>\n      <div class=\"content\">\n        <background-provider-inner color=\"{{ currentBackgroundColor }}\">\n          <ng-content></ng-content>\n        </background-provider-inner>\n      </div>\n    </div>\n  </div>\n</div>\n", components: [{ type: BackgroundProviderInnerComponent, selector: "background-provider-inner", inputs: ["color"] }], directives: [{ type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: "dxc-dialog", providers: [CssUtils, BackgroundProviderService], template: "<div class=\"dialog\">\n  <div\n    class=\"backOverlay\"\n    role=\"overlay\"\n    (click)=\"onBackgroundClickHandler($event)\"\n    [class.backVisible]=\"overlay\"\n  ></div>\n  <div class=\"container\">\n    <div class=\"dialogContainer\">\n      <span\n        class=\"closeIcon\"\n        role=\"closeIcon\"\n        *ngIf=\"isCloseVisible\"\n        (click)=\"onCloseHandler($event)\"\n        [tabindex]=\"tabIndexValue\"\n      >\n        <svg\n          xmlns=\"http://www.w3.org/2000/svg\"\n          width=\"24\"\n          height=\"24\"\n          viewBox=\"0 0 24 24\"\n          fill=\"currentColor\"\n        >\n          <path\n            d=\"M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z\"\n          />\n          <path d=\"M0 0h24v24H0z\" fill=\"none\" />\n        </svg>\n      </span>\n      <div class=\"content\">\n        <background-provider-inner color=\"{{ currentBackgroundColor }}\">\n          <ng-content></ng-content>\n        </background-provider-inner>\n      </div>\n    </div>\n  </div>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: CssUtils }]; }, propDecorators: { overlay: [{
                type: Input
            }], isCloseVisible: [{
                type: Input
            }], padding: [{
                type: Input
            }], tabIndexValue: [{
                type: Input
            }], onCloseClick: [{
                type: Output
            }], onBackgroundClick: [{
                type: Output
            }], className: [{
                type: HostBinding,
                args: ["class"]
            }] } });

class DxcDialogModule {
}
DxcDialogModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcDialogModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DxcDialogModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcDialogModule, declarations: [DxcDialogComponent], imports: [CommonModule, BackgroundProviderInnerModule], exports: [DxcDialogComponent] });
DxcDialogModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcDialogModule, imports: [[CommonModule, BackgroundProviderInnerModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcDialogModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [DxcDialogComponent],
                    imports: [CommonModule, BackgroundProviderInnerModule],
                    exports: [DxcDialogComponent],
                }]
        }] });

class DropdownService {
    constructor() {
        this.selected = new BehaviorSubject(null);
        this.items = [];
    }
    focusFirstItem() {
        this.items[0]?.setFocus();
    }
    changeFocus(direction, focusedItem) {
        const index = this.items.indexOf(focusedItem);
        if (!(index === 0 && direction === "previous") ||
            !(index === this.items.length - 1 && direction === "next")) {
            direction === "previous"
                ? this.items[index - 1]?.setFocus()
                : this.items[index + 1]?.setFocus();
        }
    }
    setSelected(selected) {
        this.selected.next(selected);
    }
}
DropdownService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DropdownService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
DropdownService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DropdownService, providedIn: "root" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DropdownService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: "root",
                }]
        }], ctorParameters: function () { return []; } });

class DxcDropdownComponent {
    constructor(utils, ren, _element, service) {
        this.utils = utils;
        this.ren = ren;
        this._element = _element;
        this.service = service;
        /**
         * In case options include icons, whether the icon should appear after or before the label.
         */
        this.optionsIconPosition = "before";
        /**
         * Whether the icon should appear after or before the label.
         */
        this.iconPosition = "before";
        /**
         * Text to be placed when the list of options is not displayed.
         */
        this.label = "";
        this._caretHidden = false;
        /**
         * Size of the component.
         */
        this.size = "fitContent";
        /**
         * This event will emit in case the selection changes. The value of the selected
         * value will be passed as a parameter.
         */
        this.onSelectOption = new EventEmitter();
        this._tabIndexValue = 0;
        this._expandOnHover = false;
        this._disabled = false;
        this.defaultInputs = new BehaviorSubject({
            optionsIconPosition: "before",
            iconPosition: "before",
            label: null,
            name: null,
            caretHidden: false,
            margin: null,
            size: "fitContent",
            tabIndexValue: 0,
            disabled: false,
            expandOnHover: false,
        });
        this.arrowClass = "down";
        this.menuOpened = "closed";
        this.enterButton = false;
        this.menuOpen = false;
        this.width = "";
        this.sizes = {
            small: "60px",
            medium: "240px",
            large: "480px",
            fillParent: "100%",
            fitContent: "unset",
        };
    }
    /**
     * Whether the arrow next to the label is displayed or not.
     */
    get caretHidden() {
        return this._caretHidden;
    }
    set caretHidden(value) {
        this._caretHidden = coerceBooleanProperty(value);
    }
    /**
     * Value of the tabindex.
     */
    get tabIndexValue() {
        return this._tabIndexValue;
    }
    set tabIndexValue(value) {
        this._tabIndexValue = coerceNumberProperty(value);
    }
    /**
     * If true, the options are showed when the dropdown is hover.
     */
    get expandOnHover() {
        return this._expandOnHover;
    }
    set expandOnHover(value) {
        this._expandOnHover = coerceBooleanProperty(value);
    }
    /**
     * If true, the component will be disabled.
     */
    get disabled() {
        return this._disabled;
    }
    set disabled(value) {
        this._disabled = coerceBooleanProperty(value);
    }
    clickout(event) {
        if (!this._element.nativeElement.contains(event.target)) {
            if (this.menuOpened === "opened") {
                this.menuTrigger.closeMenu();
            }
        }
    }
    ngOnInit() {
        this.className = `${this.getDynamicStyle(this.defaultInputs.getValue())}`;
    }
    ngAfterViewInit() {
        if (this.dropdownButton &&
            this.dropdownButton._elementRef &&
            this.dropdownButton._elementRef.nativeElement &&
            this.dropdownButton._elementRef.nativeElement.offsetWidth) {
            this.width = this.dropdownButton._elementRef.nativeElement.offsetWidth;
            this.menuOptions = `${this.setDxcMenuOptionsStyle()}`;
        }
        this.service.selected.subscribe((value) => {
            if (value) {
                this.onSelectOption.emit(value);
            }
        });
    }
    ngOnChanges(changes) {
        const inputs = Object.keys(changes).reduce((result, item) => {
            result[item] = changes[item].currentValue;
            return result;
        }, {});
        this.defaultInputs.next({ ...this.defaultInputs.getValue(), ...inputs });
        if (this.dropdownButton &&
            this.dropdownButton._elementRef &&
            this.dropdownButton._elementRef.nativeElement &&
            this.dropdownButton._elementRef.nativeElement.offsetWidth) {
            this.width = this.dropdownButton._elementRef.nativeElement.offsetWidth;
            this.menuOptions = `${this.setDxcMenuOptionsStyle()}`;
        }
        this.className = `${this.getDynamicStyle(this.defaultInputs.getValue())}`;
        this.triggerStyles = this.triggerButtonStyles(this.defaultInputs.getValue());
    }
    isMenuOpened() {
        this.arrowClass = this.arrowClass === "down" ? "up" : "down";
        this.menuOpened = this.menuOpened === "opened" ? "closed" : "opened";
    }
    selectedOption(option) {
        this.onSelectOption.emit(option.value);
    }
    calculateWidth(inputs) {
        if (inputs.size === undefined || inputs.size === null) {
            return css `
        width: unset;
      `;
        }
        if (inputs.size !== "fitContent") {
            return this.utils.calculateWidth(this.sizes, inputs);
        }
        return css `
      width: ${this.sizes[inputs.size]};
    `;
    }
    updateCss() {
        this.triggerStyles = this.triggerButtonStyles(this.defaultInputs.getValue());
        this.menuOpened === "opened" && this.service.focusFirstItem();
    }
    iconPositionAfter(iconPositionAfter) {
        if (iconPositionAfter) {
            return css `
        div {
          display: flex;
          flex-grow: unset;
          width: fit-content;
          flex-direction: row-reverse;
          align-items: center;
        }
      `;
        }
        else {
            return css `
        div {
          display: flex;
          flex-grow: unset;
          width: fit-content;
          align-items: center;
        }
      `;
        }
    }
    setDxcMenuOptionsStyle() {
        return css `
      border-color: var(--dropdown-borderColor);
      border-radius: var(--dropdown-borderRadius) !important;
      border-width: var(--dropdown-borderThickness);
      border-style: var(--dropdown-borderStyle);
      overflow-x: hidden;
      &::-webkit-scrollbar {
        width: 3px;
      }
      &::-webkit-scrollbar-track {
        background-color: var(--dropdown-scrollBarTrackColor);
        border-radius: 3px;
      }
      &::-webkit-scrollbar-thumb {
        background-color: var(--dropdown-scrollBarThumbColor);
        border-radius: 3px;
      }
      img,
      svg {
        width: var(--dropdown-optionIconSize);
        height: var(--dropdown-optionIconSize);
        vertical-align: middle;
        fill: var(--dropdown-optionIconColor);
      }
      ${this.optionsIconPosition === "after"
            ? css `
            dxc-dropdown-icon {
              margin-left: var(--dropdown-optionIconSpacing);
            }
          `
            : css `
            dxc-dropdown-icon {
              margin-right: var(--dropdown-optionIconSpacing);
            }
          `}
      dxc-dropdown-icon {
        img,
        svg {
          fill: var(--dropdown-optionIconColor);
        }
      }
      .mat-menu-content {
        padding-top: 0px !important;
        padding-bottom: 0px !important;
        width: ${this.width + "px"};
        .mat-menu-item {
          ${this.iconPositionAfter(this.optionsIconPosition === "after")}
          background-color: var(--dropdown-optionBackgroundColor);
          border-color: var(--dropdown-optionBackgroundColor);
          line-height: 24px;
          height: 36px;
          padding-top: var(--dropdown-optionPaddingTop);
          padding-right: var(--dropdown-optionPaddingRight);
          padding-bottom: var(--dropdown-optionPaddingBottom);
          padding-left: var(--dropdown-optionPaddingLeft);
          span {
            text-overflow: ellipsis;
            vertical-align: middle;
            color: var(--dropdown-optionFontColor);
            font-family: var(--dropdown-optionFontFamily);
            font-size: var(--dropdown-optionFontSize);
            font-style: var(--dropdown-optionFontStyle);
            font-weight: var(--dropdown-optionFontWeight);
          }
          &:hover {
            background-color: var(--dropdown-hoverOptionBackgroundColor);
            border-color: var(--dropdown-hoverOptionBackgroundColor);
          }
          &.cdk-focused {
            outline: -webkit-focus-ring-color auto 2px !important;
            outline-color: var(--dropdown-focusColor) !important;
          }
          &:active {
            background-color: var(--dropdown-activeOptionBackgroundColor);
            border-color: var(--dropdown-activeOptionBackgroundColor);
          }
        }
      }
      max-width: none;
    `;
    }
    triggerButtonStyles(inputs) {
        return css `
      ${this.calculateWidth(inputs)}
      min-height: 40px;
      padding-top: var(--dropdown-buttonPaddingTop);
      padding-right: var(--dropdown-buttonPaddingRight);
      padding-bottom: var(--dropdown-buttonPaddingBottom);
      padding-left: var(--dropdown-buttonPaddingLeft);
      display: inline-flex;
      align-items: center;
      border-color: var(--dropdown-borderColor);
      border-radius: var(--dropdown-borderRadius);
      border-width: var(--dropdown-borderThickness);
      border-style: var(--dropdown-borderStyle);
      background-color: var(--dropdown-buttonBackgroundColor);
      &:hover:not(.mat-button-disabled) {
        cursor: pointer;
        background-color: var(--dropdown-hoverButtonBackgroundColor) !important;
      }
      &:active:not(.mat-button-disabled) {
        background-color: var(
          --dropdown-activeButtonBackgroundColor
        ) !important;
      }
      ${this.label === "" && this.caretHidden
            ? css `
            padding: 10px 15px;
          `
            : ""};
      .menu-buttom-label {
        color: var(--dropdown-buttonFontColor);
        font-family: var(--dropdown-buttonFontFamily);
        font-size: var(--dropdown-buttonFontSize);
        font-style: var(--dropdown-buttonFontStyle);
        font-weight: var(--dropdown-buttonFontWeight);
      }
      .arrow-down {
        border-top: 5px solid var(--dropdown-caretIconColor);
      }
      .arrow-up {
        border-bottom: 5px solid var(--dropdown-caretIconColor);
      }
      &.mat-button-disabled {
        cursor: not-allowed;
        background-color: transparent;
        border-color: var(--dropdown-disabledBorderColor);
        .buttonContent {
          img,
          svg {
            fill: var(--dropdown-disabledColor);
          }
        }
        .menu-buttom-label {
          color: var(--dropdown-disabledColor);
        }
        .arrow-down {
          border-top: 5px solid var(--dropdown-disabledColor);
        }
        .arrow-up {
          border-bottom: 5px solid var(--dropdown-disabledColor);
        }
      }
    `;
    }
    getDynamicStyle(inputs) {
        return css `
      ${this.utils.getMargins(inputs.margin)}
      display: inline-flex;
      ${this.calculateWidth(inputs)}
      align-items: center;
      opacity: 1;
      .cdk-focused {
        outline: -webkit-focus-ring-color auto 2px !important;
        outline-color: var(--dropdown-focusColor) !important;
      }
      .cdk-keyboard-focused {
        .mat-button-focus-overlay {
          opacity: 0;
        }
      }
      .menu-buttom-label {
        font-size: 16px;
        text-overflow: ellipsis;
        overflow: hidden;
        text-align: left;
        letter-spacing: 0.49px;
        flex-grow: 1;
        opacity: 1;
        vertical-align: middle;
        ${this.calculateWidth(inputs)}
      }
      .dxc-arrow {
        width: 0;
        height: 0;
        border-left: 5px solid transparent;
        border-right: 5px solid transparent;
      }
      .mat-button-wrapper {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        & > div:first-child {
          overflow: hidden;
          text-overflow: ellipsis;
          align-items: center;
          display: flex;
          width: 100%;
        }
      }
      .icon-after span.mat-button-wrapper > div:first-child {
        display: flex;
        flex-grow: unset;
        flex-direction: row-reverse;
        align-items: center;
        width: 100%;
      }
      .mat-select-arrow-wrapper {
        margin-left: 7px;
        margin-right: 7px;
        margin-top: 1px;
      }
      .arrow-container {
        margin-left: var(--dropdown-caretIconSpacing);
        width: var(--dropdown-caretIconSize);
        display: flex;
        height: var(--dropdown-caretIconSize);
        align-items: center;
        justify-content: center;
      }
      .buttonContent {
        display: flex;
        flex-grow: unset;
        width: fit-content;
        align-items: center;
        img,
        svg {
          width: var(--dropdown-buttonIconSize);
          height: var(--dropdown-buttonIconSize);
          vertical-align: middle;
          fill: var(--dropdown-buttonIconColor);
        }
      }
      ${this.iconPosition === "after"
            ? css `
            .buttonContent {
              flex-direction: row-reverse;
              dxc-dropdown-icon {
                margin-right: var(--dropdown-buttonIconSpacing);
              }
            }
          `
            : css `
            .buttonContent dxc-dropdown-icon {
              margin-right: var(--dropdown-buttonIconSpacing);
            }
          `}
    `;
    }
    buttonEnter(trigger) {
        if (this.expandOnHover) {
            setTimeout(() => {
                if (this.btnTrigger && this.btnTrigger != trigger) {
                    this.btnTrigger.closeMenu();
                    this.btnTrigger = trigger;
                    this.menuOpen = false;
                    trigger.openMenu();
                }
                else if (!this.menuOpen) {
                    this.enterButton = true;
                    this.btnTrigger = trigger;
                    trigger.openMenu();
                }
                else {
                    this.enterButton = true;
                    this.btnTrigger = trigger;
                }
            });
        }
    }
    buttonLeave(trigger, button) {
        if (this.expandOnHover) {
            setTimeout(() => {
                if (this.enterButton && !this.menuOpen) {
                    trigger.closeMenu();
                    this.ren.removeClass(button["_elementRef"].nativeElement, "cdk-focused");
                    this.ren.removeClass(button["_elementRef"].nativeElement, "cdk-program-focused");
                }
                if (!this.menuOpen) {
                    trigger.closeMenu();
                    this.ren.removeClass(button["_elementRef"].nativeElement, "cdk-focused");
                    this.ren.removeClass(button["_elementRef"].nativeElement, "cdk-program-focused");
                }
                else {
                    this.enterButton = false;
                }
            }, 100);
        }
    }
    menuenter() {
        if (this.expandOnHover) {
            this.menuOpen = true;
        }
    }
    menuLeave(trigger, button) {
        if (this.expandOnHover) {
            setTimeout(() => {
                if (!this.enterButton) {
                    this.menuOpen = false;
                    trigger.closeMenu();
                    this.ren.removeClass(button["_elementRef"].nativeElement, "cdk-focused");
                    this.ren.removeClass(button["_elementRef"].nativeElement, "cdk-program-focused");
                }
                else {
                    this.menuOpen = false;
                }
            }, 80);
        }
    }
}
DxcDropdownComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcDropdownComponent, deps: [{ token: CssUtils }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: DropdownService }], target: i0.ɵɵFactoryTarget.Component });
DxcDropdownComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.5", type: DxcDropdownComponent, selector: "dxc-dropdown", inputs: { optionsIconPosition: "optionsIconPosition", iconPosition: "iconPosition", label: "label", name: "name", caretHidden: "caretHidden", margin: "margin", size: "size", tabIndexValue: "tabIndexValue", expandOnHover: "expandOnHover", disabled: "disabled" }, outputs: { onSelectOption: "onSelectOption" }, host: { listeners: { "document:click": "clickout($event)" }, properties: { "class": "this.className" } }, providers: [CssUtils, DropdownService], viewQueries: [{ propertyName: "dropdownButton", first: true, predicate: ["dropdownButton"], descendants: true, static: true }, { propertyName: "menuTrigger", first: true, predicate: MatMenuTrigger, descendants: true }], usesOnChanges: true, ngImport: i0, template: "<button\n  disableRipple\n  #dropdownButton\n  mat-button\n  (menuClosed)=\"isMenuOpened()\"\n  (menuOpened)=\"isMenuOpened()\"\n  [matMenuTriggerFor]=\"menu\"\n  [class]=\"triggerStyles\"\n  #menuTrigger=\"matMenuTrigger\"\n  (mouseenter)=\"buttonEnter(menuTrigger)\"\n  (mouseleave)=\"buttonLeave(menuTrigger, dropdownButton)\"\n  (click)=\"updateCss()\"\n  [tabIndex]=\"disabled ? -1 : tabIndexValue\"\n  [disabled]=\"disabled\"\n>\n  <div class=\"buttonContent\">\n    <ng-content select=\"dxc-dropdown-icon\"></ng-content>\n    <span class=\"menu-buttom-label\" *ngIf=\"label\">{{ label }}</span>\n  </div>\n\n  <div class=\"arrow-container\" *ngIf=\"!caretHidden\">\n    <div class=\"mat-select-arrow-wrapper\">\n      <div class=\"dxc-arrow arrow-{{ arrowClass }}\"></div>\n    </div>\n  </div>\n</button>\n\n<mat-menu\n  disableRipple\n  #menu=\"matMenu\"\n  [class]=\"menuOptions\"\n  [hasBackdrop]=\"false\"\n>\n  <span\n    (mouseenter)=\"menuenter()\"\n    (mouseleave)=\"menuLeave(menuTrigger, dropdownButton)\"\n  >\n    <ng-content></ng-content>\n  </span>\n</mat-menu>\n", styles: ["::ng-deep .cdk-overlay-pane{max-height:200px}::ng-deep .cdk-overlay-pane .mat-menu-panel{border-radius:unset;min-width:100%;margin-top:1px;margin-bottom:2px}\n"], components: [{ type: i3.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { type: i4$3.MatMenu, selector: "mat-menu", exportAs: ["matMenu"] }], directives: [{ type: i4$3.MatMenuTrigger, selector: "[mat-menu-trigger-for], [matMenuTriggerFor]", exportAs: ["matMenuTrigger"] }, { type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcDropdownComponent, decorators: [{
            type: Component,
            args: [{ selector: "dxc-dropdown", changeDetection: ChangeDetectionStrategy.OnPush, providers: [CssUtils, DropdownService], template: "<button\n  disableRipple\n  #dropdownButton\n  mat-button\n  (menuClosed)=\"isMenuOpened()\"\n  (menuOpened)=\"isMenuOpened()\"\n  [matMenuTriggerFor]=\"menu\"\n  [class]=\"triggerStyles\"\n  #menuTrigger=\"matMenuTrigger\"\n  (mouseenter)=\"buttonEnter(menuTrigger)\"\n  (mouseleave)=\"buttonLeave(menuTrigger, dropdownButton)\"\n  (click)=\"updateCss()\"\n  [tabIndex]=\"disabled ? -1 : tabIndexValue\"\n  [disabled]=\"disabled\"\n>\n  <div class=\"buttonContent\">\n    <ng-content select=\"dxc-dropdown-icon\"></ng-content>\n    <span class=\"menu-buttom-label\" *ngIf=\"label\">{{ label }}</span>\n  </div>\n\n  <div class=\"arrow-container\" *ngIf=\"!caretHidden\">\n    <div class=\"mat-select-arrow-wrapper\">\n      <div class=\"dxc-arrow arrow-{{ arrowClass }}\"></div>\n    </div>\n  </div>\n</button>\n\n<mat-menu\n  disableRipple\n  #menu=\"matMenu\"\n  [class]=\"menuOptions\"\n  [hasBackdrop]=\"false\"\n>\n  <span\n    (mouseenter)=\"menuenter()\"\n    (mouseleave)=\"menuLeave(menuTrigger, dropdownButton)\"\n  >\n    <ng-content></ng-content>\n  </span>\n</mat-menu>\n", styles: ["::ng-deep .cdk-overlay-pane{max-height:200px}::ng-deep .cdk-overlay-pane .mat-menu-panel{border-radius:unset;min-width:100%;margin-top:1px;margin-bottom:2px}\n"] }]
        }], ctorParameters: function () { return [{ type: CssUtils }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: DropdownService }]; }, propDecorators: { optionsIconPosition: [{
                type: Input
            }], iconPosition: [{
                type: Input
            }], label: [{
                type: Input
            }], name: [{
                type: Input
            }], caretHidden: [{
                type: Input
            }], margin: [{
                type: Input
            }], size: [{
                type: Input
            }], onSelectOption: [{
                type: Output
            }], tabIndexValue: [{
                type: Input
            }], expandOnHover: [{
                type: Input
            }], disabled: [{
                type: Input
            }], className: [{
                type: HostBinding,
                args: ["class"]
            }], dropdownButton: [{
                type: ViewChild,
                args: ["dropdownButton", { static: true }]
            }], menuTrigger: [{
                type: ViewChild,
                args: [MatMenuTrigger, { static: false }]
            }], clickout: [{
                type: HostListener,
                args: ["document:click", ["$event"]]
            }] } });

class DxcDropdownOptionComponent {
    constructor(service) {
        this.service = service;
        this.service.items.push(this);
    }
    ngOnChanges() { }
    setFocus() {
        this.menuItem?.focus();
    }
    arrowKey($event) {
        if ($event.keyCode === 40 || $event.keyCode === 38) {
            $event.preventDefault();
            const direction = $event.keyCode === 38
                ? "previous"
                : $event.keyCode === 40
                    ? "next"
                    : "";
            this.service.changeFocus(direction, this);
        }
    }
    selectedOption() {
        this.service.setSelected(this.value);
    }
}
DxcDropdownOptionComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcDropdownOptionComponent, deps: [{ token: DropdownService }], target: i0.ɵɵFactoryTarget.Component });
DxcDropdownOptionComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.5", type: DxcDropdownOptionComponent, selector: "dxc-dropdown-option", inputs: { value: "value", label: "label" }, viewQueries: [{ propertyName: "menuItem", first: true, predicate: MatMenuItem, descendants: true }], usesOnChanges: true, ngImport: i0, template: "<button mat-menu-item (keydown)=\"arrowKey($event)\" (click)=\"selectedOption()\" class=\"option\">\n  <div>\n    <ng-content select=\"dxc-dropdown-icon\"></ng-content>\n    <span>{{label}}</span>\n  </div>\n</button>\n", components: [{ type: i4$3.MatMenuItem, selector: "[mat-menu-item]", inputs: ["disabled", "disableRipple", "role"], exportAs: ["matMenuItem"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcDropdownOptionComponent, decorators: [{
            type: Component,
            args: [{ selector: "dxc-dropdown-option", template: "<button mat-menu-item (keydown)=\"arrowKey($event)\" (click)=\"selectedOption()\" class=\"option\">\n  <div>\n    <ng-content select=\"dxc-dropdown-icon\"></ng-content>\n    <span>{{label}}</span>\n  </div>\n</button>\n" }]
        }], ctorParameters: function () { return [{ type: DropdownService }]; }, propDecorators: { value: [{
                type: Input
            }], label: [{
                type: Input
            }], menuItem: [{
                type: ViewChild,
                args: [MatMenuItem]
            }] } });

class DxcDropdownIconComponent {
    constructor() { }
    ngOnInit() {
        this.iconClass = `${this.getDynamicStyle()}`;
    }
    getDynamicStyle() {
        return css `
      display: flex;
    `;
    }
}
DxcDropdownIconComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcDropdownIconComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
DxcDropdownIconComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.5", type: DxcDropdownIconComponent, selector: "dxc-dropdown-icon", host: { properties: { "class": "this.iconClass" } }, ngImport: i0, template: "<ng-content></ng-content>" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcDropdownIconComponent, decorators: [{
            type: Component,
            args: [{ selector: "dxc-dropdown-icon", template: "<ng-content></ng-content>" }]
        }], ctorParameters: function () { return []; }, propDecorators: { iconClass: [{
                type: HostBinding,
                args: ["class"]
            }] } });

class DxcDropdownModule {
}
DxcDropdownModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcDropdownModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DxcDropdownModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcDropdownModule, declarations: [DxcDropdownComponent,
        DxcDropdownOptionComponent,
        DxcDropdownIconComponent], imports: [CommonModule, MatMenuModule, MatButtonModule], exports: [DxcDropdownComponent,
        DxcDropdownOptionComponent,
        DxcDropdownIconComponent] });
DxcDropdownModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcDropdownModule, imports: [[CommonModule, MatMenuModule, MatButtonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcDropdownModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        DxcDropdownComponent,
                        DxcDropdownOptionComponent,
                        DxcDropdownIconComponent,
                    ],
                    imports: [CommonModule, MatMenuModule, MatButtonModule],
                    exports: [
                        DxcDropdownComponent,
                        DxcDropdownOptionComponent,
                        DxcDropdownIconComponent,
                    ],
                }]
        }] });

class FilesService {
    constructor() {
        this.files = new BehaviorSubject({
            files: new Array(),
            event: null,
        });
    }
    addFile(file) {
        // Check if exist
        const existingFile = this.files.value.files.filter(item => item.data.name === file.data.name);
        let updatedValue;
        if (existingFile.length > 0) {
            updatedValue = this.files.value.files.map(item => {
                if (item.data.name === file.data.name) {
                    item.data = file.data;
                    item.error = file.error;
                }
                return item;
            });
        }
        else {
            updatedValue = [...this.files.value.files, file];
        }
        this.files.next({
            files: updatedValue,
            event: "add",
        });
    }
    removeFile(file) {
        const array = this.files.value.files.filter((item) => {
            return item.data.name !== file.data.name;
        });
        this.files.next({
            files: array,
            event: "remove",
        });
    }
    emptyArrayFiles() {
        this.files.next({
            files: [],
            event: "",
        });
    }
}
FilesService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: FilesService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
FilesService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: FilesService, providedIn: "root" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: FilesService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: "root",
                }]
        }], ctorParameters: function () { return []; } });

class FileFormatDirective {
    constructor(elementRef, document) {
        this.elementRef = elementRef;
        this.document = document;
    }
    ngOnInit() {
        let xmlns = "http://www.w3.org/2000/svg";
        const commonPathChild = this.document.createElementNS(xmlns, "path");
        commonPathChild.setAttributeNS(null, 'd', 'M0 0h24v24H0V0z');
        commonPathChild.setAttributeNS(null, 'fill', 'none');
        const child = this.document.createElementNS(xmlns, "path");
        switch (this.categorizeFileFormat(this.format)) {
            case 'image':
                child.setAttributeNS(null, 'd', 'M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zM6 20V4h7v5h5v11H6z');
                break;
            case 'video':
                child.setAttributeNS(null, 'd', 'M4 6.47L5.76 10H20v8H4V6.47M22 4h-4l2 4h-3l-2-4h-2l2 4h-3l-2-4H8l2 4H7L5 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4z');
                break;
            case 'audio':
                child.setAttributeNS(null, 'd', 'M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h18v14zM8 15c0-1.66 1.34-3 3-3 .35 0 .69.07 1 .18V6h5v2h-3v7.03c-.02 1.64-1.35 2.97-3 2.97-1.66 0-3-1.34-3-3z');
                break;
            default:
                child.setAttributeNS(null, 'd', 'M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zM6 20V4h7v5h5v11H6z');
                break;
        }
        this.elementRef.nativeElement.append(commonPathChild);
        this.elementRef.nativeElement.append(child);
    }
    categorizeFileFormat(fileFormat) {
        if (fileFormat.includes("image")) {
            return 'image';
        }
        else if (fileFormat.includes("video")) {
            return 'video';
        }
        else if (fileFormat.includes("audio")) {
            return 'audio';
        }
        return 'default';
    }
}
FileFormatDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: FileFormatDirective, deps: [{ token: i0.ElementRef }, { token: DOCUMENT }], target: i0.ɵɵFactoryTarget.Directive });
FileFormatDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.2.5", type: FileFormatDirective, selector: "[dxcFileFormat]", inputs: { format: "format" }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: FileFormatDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[dxcFileFormat]'
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }]; }, propDecorators: { format: [{
                type: Input
            }] } });

class DxcFileComponent {
    constructor(service) {
        this.service = service;
        this._showPreview = false;
        this._tabIndexValue = 0;
        this.hasError = false;
        this.hasShowError = false;
        this.hasShowPreviewImage = false;
        this.hasShowPreviewIcon = false;
        this.hasShowPreview = false;
        this.defaultInputs = new BehaviorSubject({
            showPreview: false,
            multiple: false,
            mode: null,
        });
    }
    get showPreview() {
        return this._showPreview;
    }
    set showPreview(value) {
        this._showPreview = coerceBooleanProperty(value);
    }
    get tabIndexValue() {
        return this._tabIndexValue;
    }
    set tabIndexValue(value) {
        this._tabIndexValue = coerceNumberProperty(value);
    }
    ngOnChanges(changes) {
        this.file.error !== null &&
            this.file.error !== undefined &&
            this.file.error.length !== 0
            ? (this.hasError = true)
            : (this.hasError = false);
        this.hasShowError = this.isErrorPrintable();
        this.hasShowPreviewImage = this.isShowPreviewPrintable();
        this.hasShowPreviewIcon = this.isShowPreviewPrintable(false);
        this.hasShowPreview = this.isShowPreview();
        const inputs = Object.keys(changes).reduce((result, item) => {
            result[item] = changes[item].currentValue;
            return result;
        }, {});
        this.defaultInputs.next({ ...this.defaultInputs.getValue(), ...inputs });
        this.className = `${this.getDynamicStyle(this.defaultInputs.getValue())}`;
    }
    ngOnInit() {
        this.className = `${this.getDynamicStyle(this.defaultInputs.getValue())}`;
    }
    onRemoveHandler(event) {
        if (this.updatable) {
            this.service.removeFile(this.file);
        }
    }
    isShowPreview() {
        return ((this.showPreview && this.mode !== "file") ||
            (this.showPreview && this.mode === "file" && this.multiple));
    }
    isShowPreviewPrintable(containsImage = true) {
        return containsImage
            ? (this.showPreview && this.file.image && this.mode !== "file") ||
                (this.showPreview &&
                    this.file.image &&
                    this.mode === "file" &&
                    this.multiple)
            : (this.showPreview && !this.file.image && this.mode !== "file") ||
                (this.showPreview &&
                    !this.file.image &&
                    this.mode === "file" &&
                    this.multiple);
    }
    isErrorPrintable() {
        return (this.hasError &&
            ((this.multiple && this.mode === "file") || this.mode !== "file"));
    }
    getIconAriaLabel() {
        if (this.file.data.type.includes("video")) {
            return "video";
        }
        if (this.file.data.type.includes("audio")) {
            return "audio";
        }
        if (this.file.data.type.includes("image")) {
            return "image";
        }
        return "file";
    }
    getRemoveAriaLabel() {
        return "Remove " + this.file.data.name;
    }
    getDynamicStyle(inputs) {
        return css `
      height: ${this.hasError
            ? inputs.mode !== "file"
                ? "fit-content"
                : !inputs.multiple
                    ? "40px"
                    : "fit-content"
            : this.hasShowPreviewImage || this.hasShowPreviewIcon
                ? "64px"
                : "40px"};
      background: ${this.hasError
            ? "var(--fileInput-errorFileItemBackgroundColor)"
            : "#ffffff"}
        0% 0% no-repeat padding-box;
      border: var(--fileInput-fileItemBorderThickness)
        var(--fileInput-fileItemBorderStyle);
      border-color: ${this.hasError
            ? "var(--fileInput-errorFileItemBorderColor)"
            : "var(--fileInput-fileItemBorderColor)"};
      width: ${inputs.multiple || inputs.mode !== "file" ? "320px" : "230px"};
      border-radius: var(--fileInput-fileItemBorderRadius);
      padding: 8px;
      box-sizing: border-box;
      display: flex;
      flex-direction: row;
      margin-top: ${inputs.multiple || inputs.mode !== "file" ? "4px" : ""};
      margin-left: ${!inputs.multiple && inputs.mode === "file" ? "4px" : ""};
      .previewContainer {
        background-color: ${this.hasError
            ? "var(--fileInput-errorFilePreviewBackgroundColor)"
            : "var(--fileInput-filePreviewBackgroundColor)"};
        display: flex;
        align-items: center;
        place-content: center;
        padding: 12px;
        box-sizing: border-box;
        height: 48px;
        width: 48px;
        svg,
        img {
          fill: ${this.hasError
            ? "var(--fileInput-errorFilePreviewIconColor)"
            : "var(--fileInput-filePreviewIconColor)"};
          height: 24px;
          width: 24px;
        }
      }
      .infoContainer {
        display: flex;
        flex-direction: column;
        width: ${(inputs.showPreview &&
            inputs.mode === "file" &&
            !inputs.multiple) ||
            !inputs.showPreview
            ? "100% "
            : "calc(100% - 48px)"};
        .fileContainer {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          .fileName {
            color: var(--fileInput-fileNameFontColor);
            padding-left: 8px;
            height: 24px;
            white-space: nowrap;
            text-overflow: ellipsis;
            width: 100%;
            display: block;
            overflow: hidden;
            box-sizing: border-box;
            font-family: var(--fileInput-fileItemFontFamily);
            font-size: var(--fileInput-fileItemFontSize);
            font-weight: var(--fileInput-fileItemFontWeight);
            line-height: var(--fileInput-fileItemLineHeight);
          }
          .fileIcons {
            display: flex;
            flex-direction: row;
            .removeIcon,
            .errorIcon {
              display: flex;
              align-items: center;
              height: 24px;
              width: 24px;
              justify-content: center;
            }
            .removeIcon {
              svg {
                height: 16px;
                width: 16px;
                fill: var(--fileInput-deleteFileItemIconColor);
              }
              &:hover,
              &:active {
                border-radius: 4px;
                cursor: pointer;
              }
              &:hover {
                background-color: var(
                  --fileInput-hoverDeleteFileItemBackgroundColor
                );
              }
              &:active {
                background-color: var(
                  --fileInput-activeDeleteFileItemBackgroundColor
                );
              }
              &:focus {
                outline: var(--fileInput-focusDeleteFileItemBackgroundColor)
                  auto 1px;
              }
            }
            .errorIcon {
              margin-right: 4px;
              svg {
                height: 18px;
                width: 18px;
                fill: #d0011b;
              }
            }
          }
        }
      }
      .errorContainer {
        width: 100%;
        padding-left: 8px;
        box-sizing: border-box;
        .errorMessage {
          text-align: left;
          letter-spacing: 0.37px;
          color: var(--fileInput-errorMessageFontColor);
          font-family: var(--fileInput-errorMessageFontFamily);
          font-size: var(--fileInput-errorMessageFontSize);
          font-weight: var(--fileInput-errorMessageFontWeight);
          line-height: var(--fileInput-errorMessageLineHeight);
        }
      }
    `;
    }
}
DxcFileComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcFileComponent, deps: [{ token: FilesService }], target: i0.ɵɵFactoryTarget.Component });
DxcFileComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.5", type: DxcFileComponent, selector: "dxc-file", inputs: { file: "file", multiple: "multiple", mode: "mode", updatable: "updatable", showPreview: "showPreview", tabIndexValue: "tabIndexValue" }, host: { properties: { "class": "this.className" } }, usesOnChanges: true, ngImport: i0, template: "<div\n  class=\"previewContainer\"\n  [attr.aria-label]=\"getIconAriaLabel()\"\n  *ngIf=\"hasShowPreview\"\n>\n  <svg\n    xmlns=\"http://www.w3.org/2000/svg\"\n    height=\"24px\"\n    viewBox=\"0 0 24 24\"\n    width=\"24px\"\n    dxcFileFormat\n    [format]=\"file.data.type\"\n    *ngIf=\"hasShowPreviewIcon\"\n  ></svg>\n  <img [src]=\"file.image\" *ngIf=\"hasShowPreviewImage\" />\n</div>\n\n<div class=\"infoContainer\">\n  <div class=\"fileContainer\">\n    <span class=\"fileName\">{{ file.data.name }}</span>\n    <div class=\"fileIcons\">\n      <span *ngIf=\"hasError\" aria-label=\"Error\" class=\"errorIcon\">\n        <svg\n          fill=\"currentColor\"\n          height=\"24px\"\n          viewBox=\"0 0 24 24\"\n          width=\"24px\"\n          xmlns=\"http://www.w3.org/2000/svg\"\n        >\n          <path\n            d=\"M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z\"\n          ></path>\n        </svg>\n      </span>\n      <span\n        class=\"removeIcon\"\n        [tabindex]=\"tabIndexValue\"\n        [attr.aria-label]=\"getRemoveAriaLabel()\"\n        (click)=\"onRemoveHandler($event)\"\n        data-testid=\"removeIcon\"\n      >\n        <svg\n          xmlns=\"http://www.w3.org/2000/svg\"\n          height=\"18px\"\n          viewBox=\"0 0 24 24\"\n          width=\"18px\"\n          fill=\"#000000\"\n        >\n          <path d=\"M0 0h24v24H0z\" fill=\"none\" />\n          <path\n            d=\"M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z\"\n          />\n        </svg>\n      </span>\n    </div>\n  </div>\n  <div class=\"errorContainer\">\n    <span *ngIf=\"hasShowError\" class=\"errorMessage\">{{ file.error }}</span>\n  </div>\n</div>\n", directives: [{ type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: FileFormatDirective, selector: "[dxcFileFormat]", inputs: ["format"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcFileComponent, decorators: [{
            type: Component,
            args: [{ selector: "dxc-file", template: "<div\n  class=\"previewContainer\"\n  [attr.aria-label]=\"getIconAriaLabel()\"\n  *ngIf=\"hasShowPreview\"\n>\n  <svg\n    xmlns=\"http://www.w3.org/2000/svg\"\n    height=\"24px\"\n    viewBox=\"0 0 24 24\"\n    width=\"24px\"\n    dxcFileFormat\n    [format]=\"file.data.type\"\n    *ngIf=\"hasShowPreviewIcon\"\n  ></svg>\n  <img [src]=\"file.image\" *ngIf=\"hasShowPreviewImage\" />\n</div>\n\n<div class=\"infoContainer\">\n  <div class=\"fileContainer\">\n    <span class=\"fileName\">{{ file.data.name }}</span>\n    <div class=\"fileIcons\">\n      <span *ngIf=\"hasError\" aria-label=\"Error\" class=\"errorIcon\">\n        <svg\n          fill=\"currentColor\"\n          height=\"24px\"\n          viewBox=\"0 0 24 24\"\n          width=\"24px\"\n          xmlns=\"http://www.w3.org/2000/svg\"\n        >\n          <path\n            d=\"M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z\"\n          ></path>\n        </svg>\n      </span>\n      <span\n        class=\"removeIcon\"\n        [tabindex]=\"tabIndexValue\"\n        [attr.aria-label]=\"getRemoveAriaLabel()\"\n        (click)=\"onRemoveHandler($event)\"\n        data-testid=\"removeIcon\"\n      >\n        <svg\n          xmlns=\"http://www.w3.org/2000/svg\"\n          height=\"18px\"\n          viewBox=\"0 0 24 24\"\n          width=\"18px\"\n          fill=\"#000000\"\n        >\n          <path d=\"M0 0h24v24H0z\" fill=\"none\" />\n          <path\n            d=\"M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z\"\n          />\n        </svg>\n      </span>\n    </div>\n  </div>\n  <div class=\"errorContainer\">\n    <span *ngIf=\"hasShowError\" class=\"errorMessage\">{{ file.error }}</span>\n  </div>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: FilesService }]; }, propDecorators: { className: [{
                type: HostBinding,
                args: ["class"]
            }], file: [{
                type: Input
            }], multiple: [{
                type: Input
            }], mode: [{
                type: Input
            }], updatable: [{
                type: Input
            }], showPreview: [{
                type: Input
            }], tabIndexValue: [{
                type: Input
            }] } });

class DxcFileErrorComponent {
    constructor() { }
    ngOnInit() {
    }
}
DxcFileErrorComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcFileErrorComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
DxcFileErrorComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.5", type: DxcFileErrorComponent, selector: "dxc-file-error", inputs: { error: "error" }, ngImport: i0, template: "<span\n  class=\"errorMessage\"\n  >{{error}}</span>\n", styles: [".errorMessage{text-align:left;letter-spacing:.37px;color:var(--fileInput-errorMessageFontColor);font-family:var(--fileInput-errorMessageFontFamily);font-size:var(--fileInput-errorMessageFontSize);font-weight:var(--fileInput-errorMessageFontWeight);line-height:var(--fileInput-errorMessageLineHeight)}\n"], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcFileErrorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'dxc-file-error', changeDetection: ChangeDetectionStrategy.OnPush, template: "<span\n  class=\"errorMessage\"\n  >{{error}}</span>\n", styles: [".errorMessage{text-align:left;letter-spacing:.37px;color:var(--fileInput-errorMessageFontColor);font-family:var(--fileInput-errorMessageFontFamily);font-size:var(--fileInput-errorMessageFontSize);font-weight:var(--fileInput-errorMessageFontWeight);line-height:var(--fileInput-errorMessageLineHeight)}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { error: [{
                type: Input
            }] } });

class DxcFileInputComponent {
    constructor(utils, service) {
        this.utils = utils;
        this.service = service;
        /**
         * Name attribute.
         */
        this.name = "";
        /**
         * Available modes of the component.
         */
        this.mode = "file";
        /**
         * Text to be placed above the component.
         */
        this.label = "";
        /**
         * Helper text to be placed above the component.
         */
        this.helperText = "";
        this._multiple = true;
        this._showPreview = false;
        this._disabled = false;
        this._tabIndexValue = 0;
        this.hasShowError = false;
        /**
         * This event will emit when the user selects or drops a file. The file or list of files will be sent as a parameter.
         */
        this.callbackFile = new EventEmitter();
        this.defaultInputs = new BehaviorSubject({
            name: null,
            mode: "file",
            label: null,
            buttonLabel: null,
            helperText: null,
            accept: null,
            multiple: true,
            showPreview: false,
            disabled: false,
            margin: null,
            tabIndexValue: 0,
            value: null,
            maxSize: null,
            minSize: null,
        });
        this.files = [];
        this.hoveringWithFile = false;
        this.filesLoaded = false;
        this.numberFiles = 0;
        this.hasMultipleFiles = false;
        this.hasSingleFile = false;
        this.hasErrorSingleFile = false;
        this.hasValue = false;
        this.isErrorShow = () => this.value?.length === 1 &&
            this.mode === "file" &&
            this.value[0]?.error &&
            !this.multiple &&
            !this.disabled;
        this.service.files.subscribe(({ files, event }) => {
            if (event !== "reset" && (files.length || this.hasValue)) {
                this.hasShowError = this.isErrorShow();
                this.hasMultipleFiles = this.isMultipleFilesPrintables();
                this.hasSingleFile = this.isSingleFilesPrintables();
                this.callbackFile.emit(files);
            }
        });
    }
    /**
     * If true, the component allows multiple file items and will show all of them. If false, only one file will be shown,
     * and if there is already one file selected and a new one is chosen, it will be replaced by the new selected one.
     */
    get multiple() {
        return this._multiple;
    }
    set multiple(value) {
        this._multiple = coerceBooleanProperty(value);
    }
    /**
     * If true, if the file is an image, a preview of it will be shown. If not, an icon refering to the file type will be shown.
     */
    get showPreview() {
        return this._showPreview;
    }
    set showPreview(value) {
        this._showPreview = coerceBooleanProperty(value);
    }
    /**
     * If true, the component will be disabled.
     */
    get disabled() {
        return this._disabled;
    }
    set disabled(value) {
        this._disabled = coerceBooleanProperty(value);
    }
    /**
     * The minimum file size (in bytes) allowed. If the size of the file does not comply the minSize, the file will have an error.
     */
    get minSize() {
        return this._minSize;
    }
    set minSize(value) {
        this._minSize = coerceNumberProperty(value);
    }
    /**
     * The maximum file size (in bytes) allowed. If the size of the file does not comply the maxSize, the file will have an error.
     */
    get maxSize() {
        return this._maxSize;
    }
    set maxSize(value) {
        this._maxSize = coerceNumberProperty(value);
    }
    /**
     * Value of the tabindex attribute.
     */
    get tabIndexValue() {
        return this._tabIndexValue;
    }
    set tabIndexValue(value) {
        this._tabIndexValue = coerceNumberProperty(value);
    }
    ngOnInit() {
        this.id = this.id || v4();
        this.value ? (this.hasValue = true) : (this.hasValue = false);
        this.hasShowError = this.isErrorShow();
        this.hasMultipleFiles = this.isMultipleFilesPrintables();
        this.hasSingleFile = this.isSingleFilesPrintables();
        this.className = `${this.getDynamicStyle(this.defaultInputs.getValue())}`;
        if (!this.buttonLabel) {
            this.buttonLabel =
                this.mode === "file"
                    ? this.multiple
                        ? "Select files"
                        : "Select file"
                    : "Select";
        }
    }
    ngOnChanges(changes) {
        if (this.fileInputNative) {
            this.multiple
                ? this.fileInputNative.nativeElement.setAttribute("multiple", true)
                : this.fileInputNative.nativeElement.removeAttribute("multiple");
        }
        if (this.value?.length > 0) {
            const arr = [];
            this.service.files.next({ files: arr, event: "reset" });
            this.value.forEach((file) => {
                if (!file.error) {
                    file.error = this.checkFileSize(file.data);
                }
                this.service.addFile(file);
            });
        }
        const inputs = Object.keys(changes).reduce((result, item) => {
            result[item] = changes[item].currentValue;
            return result;
        }, {});
        this.defaultInputs.next({ ...this.defaultInputs.getValue(), ...inputs });
        this.className = `${this.getDynamicStyle(this.defaultInputs.getValue())}`;
    }
    ngAfterViewInit() {
        if (this.fileInputNative) {
            this.multiple
                ? this.fileInputNative.nativeElement.setAttribute("multiple", true)
                : this.fileInputNative.nativeElement.removeAttribute("multiple");
        }
    }
    checkFileSize(file) {
        if (file.size < this.minSize) {
            return "File size must be greater than min size.";
        }
        if (file.size > this.maxSize) {
            return "File size must be less than max size.";
        }
        return null;
    }
    /**
     * File drop y drop zone
     * @param event
     */
    dragOver(event) {
        event.preventDefault();
        this.hoveringWithFile = true;
    }
    /**
     * File drop y drop zone
     * @param event
     */
    dragLeave(event) {
        event.preventDefault();
        this.hoveringWithFile = false;
    }
    /**
     * File drop y drop zone
     * @param event
     */
    drop(event) {
        event.preventDefault();
        this.hoveringWithFile = false;
        if (this.callbackFile.observers?.length > 0 && this.hasValue) {
            if (!this.multiple) {
                this.service.emptyArrayFiles();
            }
            this.getPreviewsFiles(event.dataTransfer.files);
        }
    }
    /**
     * Common function for both file modes.
     * @param event
     */
    onFileInput(event) {
        if (this.callbackFile.observers?.length > 0 && this.hasValue) {
            if (!this.multiple) {
                this.service.emptyArrayFiles();
            }
            this.getPreviewsFiles(event.target.files);
            event.target.value = "";
        }
    }
    /**
     * Common function for both file modes.
     * @param eventFiles
     */
    getPreviewsFiles(eventFiles) {
        this.numberFiles = eventFiles?.length;
        Array.from(eventFiles).map((file) => {
            this.getPreview(file);
        });
    }
    /**
     * Common function for both file modes.
     * @param file
     */
    getPreview(file) {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (event) => {
            if (!file.type.includes("image") || file.type.includes("image/svg")) {
                let fileToAdd = {
                    data: file,
                    image: null,
                    error: this.checkFileSize(file),
                };
                this.service.addFile(fileToAdd);
            }
            else {
                let fileToAdd = {
                    data: file,
                    image: event.target["result"],
                    error: this.checkFileSize(file),
                };
                this.service.addFile(fileToAdd);
            }
        };
    }
    isMultipleFilesPrintables(isSingle = false) {
        return isSingle
            ? this.value?.length > 0 && !this.disabled && !this.multiple
            : this.value?.length > 0 && !this.disabled && this.multiple;
    }
    isSingleFilesPrintables() {
        return this.mode === "file" && this.value?.length === 1 && !this.multiple;
    }
    /**
     * Define the type of file component. Just for styling
     * @param inputs
     * @returns
     */
    getModeStyle(inputs) {
        if (inputs.mode === "filedrop") {
            return this.getFileDropStyle();
        }
        else if (inputs.mode === "dropzone") {
            return this.getDropZoneStyle();
        }
        else {
            return this.getFileStyle();
        }
    }
    /**
     * Just for file mode.
     * @param inputs
     * @returns
     */
    getFileStyle() {
        return css `
      .fileInputContainer {
        flex-direction: ${this.value?.length > 1 || this.multiple
            ? "column"
            : "row"};
      }
    `;
    }
    /**
     * Just for drop zone.
     * @param inputs
     * @returns
     */
    getDropZoneStyle() {
        return css `
      .fileInputContainer {
        flex-direction: column;
        .dragDropArea {
          height: 160px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          .dropLabel {
            margin-top: 8px;
          }
        }
      }
    `;
    }
    /**
     * Just for drop zone.
     * @param inputs
     * @returns
     */
    getFileDropStyle() {
        return css `
      .fileInputContainer {
        flex-direction: column;
        .dragDropArea {
          padding: 3px;
          height: 48px;
          box-sizing: border-box;
          .dropLabel {
            margin-left: 12px;
          }
        }
      }
    `;
    }
    /**
     * Common functionality for styling
     * @param inputs
     * @returns
     */
    getDynamicStyle(inputs) {
        return css `
      ${this.utils.getMargins(inputs.margin)}
      ${this.getModeStyle(inputs)}
      width: fit-content;
      display: flex;
      flex-direction: column;
      ${inputs.disabled ? "cursor: not-allowed;" : ""}
      .fileInputContainer {
        display: flex;
        dxc-button {
          width: fit-content;
        }
        input {
          visibility: hidden;
          width: 0px;
          height: 0px;
        }
        .dragDropArea {
          width: 320px;
          box-sizing: border-box;
          background: #ffffff 0% 0% no-repeat padding-box;
          border: var(--fileInput-dropBorderThickness)
            var(--fileInput-dropBorderStyle)
            ${!inputs.disabled
            ? "var(--fileInput-dropBorderColor)"
            : "var(--fileInput-disabledDropBorderColor)"};
          border-radius: var(--fileInput-dropBorderRadius);
          .dropLabel {
            text-align: left;
            letter-spacing: 0.49px;
            color: ${!inputs.disabled
            ? "var(--fileInput-dropLabelFontColor)"
            : "var(--fileInput-disabledDropLabelFontColor)"};
            font-family: var(--fileInput-dropLabelFontFamily);
            font-size: var(--fileInput-dropLabelFontSize);
            font-weight: var(--fileInput-dropLabelFontWeight);
          }
          &.hovering {
            ${!inputs.disabled
            ? "border: 2px solid var(--fileInput-focusDropBorderColor); background: var(--fileInput-dragoverDropBackgroundColor) 0% 0% no-repeat padding-box;"
            : ""}
          }
        }
        .fileContainer {
          display: flex;
          flex-direction: column;
        }
      }
      .label {
        text-align: left;
        letter-spacing: 0px;
        color: ${!inputs.disabled
            ? "var(--fileInput-labelFontColor)"
            : "var(--fileInput-disabledLabelFontColor)"};
        font-family: var(--fileInput-labelFontFamily);
        font-size: var(--fileInput-labelFontSize);
        font-weight: var(--fileInput-labelFontWeight);
        line-height: var(--fileInput-labelLineHeight);
      }
      .helperText {
        margin-bottom: 4px;
        text-align: left;
        letter-spacing: 0px;
        color: ${!inputs.disabled
            ? "var(--fileInput-helperTextFontColor)"
            : "var(--fileInput-disabledHelperTextFontColor)"};
        font-family: var(--fileInput-helperTextFontFamily);
        font-size: var(--fileInput-helperTextFontSize);
        font-weight: var(--fileInput-helperTextFontWeight);
        line-height: var(--fileInput-helperTextLineHeight);
      }
    `;
    }
}
DxcFileInputComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcFileInputComponent, deps: [{ token: CssUtils }, { token: FilesService }], target: i0.ɵɵFactoryTarget.Component });
DxcFileInputComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.5", type: DxcFileInputComponent, selector: "dxc-file-input", inputs: { name: "name", mode: "mode", label: "label", buttonLabel: "buttonLabel", helperText: "helperText", value: "value", accept: "accept", multiple: "multiple", showPreview: "showPreview", disabled: "disabled", minSize: "minSize", maxSize: "maxSize", margin: "margin", tabIndexValue: "tabIndexValue" }, outputs: { callbackFile: "callbackFile" }, host: { properties: { "class": "this.className" } }, providers: [CssUtils, FilesService], viewQueries: [{ propertyName: "fileInputNative", first: true, predicate: ["fileInput"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<label class=\"label\" htmlFor=\"{{ id }}\">{{ label }}</label>\n<span *ngIf=\"helperText\" class=\"helperText\">{{ helperText }}</span>\n<div class=\"fileInputContainer\">\n  <input\n    #fileInput\n    data-testid=\"input\"\n    type=\"file\"\n    (change)=\"onFileInput($event)\"\n    [accept]=\"accept\"\n  />\n  <dxc-button\n    *ngIf=\"mode === 'file'\"\n    [label]=\"buttonLabel\"\n    mode=\"secondary\"\n    [disabled]=\"disabled\"\n    (onClick)=\"fileInput.click()\"\n    [tabIndexValue]=\"tabIndexValue\"\n  ></dxc-button>\n  <div\n    *ngIf=\"mode !== 'file'\"\n    class=\"dragDropArea\"\n    [ngClass]=\"{\n      hovering: hoveringWithFile === true\n    }\"\n    (drop)=\"drop($event)\"\n    (dragleave)=\"dragLeave($event)\"\n    (dragover)=\"dragOver($event)\"\n  >\n    <dxc-button\n      [label]=\"buttonLabel\"\n      mode=\"secondary\"\n      [disabled]=\"disabled\"\n      [tabIndexValue]=\"tabIndexValue\"\n      (onClick)=\"fileInput.click()\"\n    ></dxc-button>\n    <span *ngIf=\"mode === 'filedrop' || mode === 'dropzone'\" class=\"dropLabel\"\n      >or drop files</span\n    >\n  </div>\n  <div class=\"fileContainer\">\n    <dxc-file\n      *ngFor=\"let file of value\"\n      [file]=\"file\"\n      [showPreview]=\"showPreview\"\n      [multiple]=\"!hasSingleFile\"\n      [mode]=\"mode\"\n      [tabIndexValue]=\"tabIndexValue\"\n      [updatable]=\"callbackFile?.observers?.length > 0\"\n    ></dxc-file>\n  </div>\n</div>\n\n<dxc-file-error *ngIf=\"hasShowError\" [error]=\"value[0]?.error\"></dxc-file-error>\n", components: [{ type: DxcButtonComponent, selector: "dxc-button", inputs: ["mode", "disabled", "label", "iconSrc", "iconPosition", "margin", "size", "type", "tabIndexValue"], outputs: ["onClick"] }, { type: DxcFileComponent, selector: "dxc-file", inputs: ["file", "multiple", "mode", "updatable", "showPreview", "tabIndexValue"] }, { type: DxcFileErrorComponent, selector: "dxc-file-error", inputs: ["error"] }], directives: [{ type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i4.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcFileInputComponent, decorators: [{
            type: Component,
            args: [{ selector: "dxc-file-input", providers: [CssUtils, FilesService], template: "<label class=\"label\" htmlFor=\"{{ id }}\">{{ label }}</label>\n<span *ngIf=\"helperText\" class=\"helperText\">{{ helperText }}</span>\n<div class=\"fileInputContainer\">\n  <input\n    #fileInput\n    data-testid=\"input\"\n    type=\"file\"\n    (change)=\"onFileInput($event)\"\n    [accept]=\"accept\"\n  />\n  <dxc-button\n    *ngIf=\"mode === 'file'\"\n    [label]=\"buttonLabel\"\n    mode=\"secondary\"\n    [disabled]=\"disabled\"\n    (onClick)=\"fileInput.click()\"\n    [tabIndexValue]=\"tabIndexValue\"\n  ></dxc-button>\n  <div\n    *ngIf=\"mode !== 'file'\"\n    class=\"dragDropArea\"\n    [ngClass]=\"{\n      hovering: hoveringWithFile === true\n    }\"\n    (drop)=\"drop($event)\"\n    (dragleave)=\"dragLeave($event)\"\n    (dragover)=\"dragOver($event)\"\n  >\n    <dxc-button\n      [label]=\"buttonLabel\"\n      mode=\"secondary\"\n      [disabled]=\"disabled\"\n      [tabIndexValue]=\"tabIndexValue\"\n      (onClick)=\"fileInput.click()\"\n    ></dxc-button>\n    <span *ngIf=\"mode === 'filedrop' || mode === 'dropzone'\" class=\"dropLabel\"\n      >or drop files</span\n    >\n  </div>\n  <div class=\"fileContainer\">\n    <dxc-file\n      *ngFor=\"let file of value\"\n      [file]=\"file\"\n      [showPreview]=\"showPreview\"\n      [multiple]=\"!hasSingleFile\"\n      [mode]=\"mode\"\n      [tabIndexValue]=\"tabIndexValue\"\n      [updatable]=\"callbackFile?.observers?.length > 0\"\n    ></dxc-file>\n  </div>\n</div>\n\n<dxc-file-error *ngIf=\"hasShowError\" [error]=\"value[0]?.error\"></dxc-file-error>\n" }]
        }], ctorParameters: function () { return [{ type: CssUtils }, { type: FilesService }]; }, propDecorators: { fileInputNative: [{
                type: ViewChild,
                args: ["fileInput", { static: false }]
            }], className: [{
                type: HostBinding,
                args: ["class"]
            }], name: [{
                type: Input
            }], mode: [{
                type: Input
            }], label: [{
                type: Input
            }], buttonLabel: [{
                type: Input
            }], helperText: [{
                type: Input
            }], value: [{
                type: Input
            }], accept: [{
                type: Input
            }], multiple: [{
                type: Input
            }], showPreview: [{
                type: Input
            }], disabled: [{
                type: Input
            }], minSize: [{
                type: Input
            }], maxSize: [{
                type: Input
            }], margin: [{
                type: Input
            }], tabIndexValue: [{
                type: Input
            }], callbackFile: [{
                type: Output
            }] } });

class DxcFileInputModule {
}
DxcFileInputModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcFileInputModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DxcFileInputModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcFileInputModule, declarations: [DxcFileInputComponent, DxcFileComponent, DxcFileErrorComponent, FileFormatDirective], imports: [CommonModule, DxcButtonModule], exports: [DxcFileInputComponent] });
DxcFileInputModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcFileInputModule, imports: [[CommonModule, DxcButtonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcFileInputModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [DxcFileInputComponent, DxcFileComponent, DxcFileErrorComponent, FileFormatDirective],
                    imports: [CommonModule, DxcButtonModule],
                    exports: [DxcFileInputComponent],
                }]
        }] });

class SafeUrlPipe {
    constructor(sanitizer) {
        this.sanitizer = sanitizer;
    }
    transform(url) {
        return this.sanitizer.bypassSecurityTrustResourceUrl(url);
    }
}
SafeUrlPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: SafeUrlPipe, deps: [{ token: i1.DomSanitizer }], target: i0.ɵɵFactoryTarget.Pipe });
SafeUrlPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: SafeUrlPipe, name: "safeResourceUrl" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: SafeUrlPipe, decorators: [{
            type: Pipe,
            args: [{ name: 'safeResourceUrl' }]
        }], ctorParameters: function () { return [{ type: i1.DomSanitizer }]; } });

class DxcFooterComponent {
    constructor(utils) {
        this.utils = utils;
        /**
         * The text that will be displayed as copyright disclaimer.
         */
        this.copyright = "© DXC Technology 2022. All rights reserved.";
        this._tabIndexValue = 0;
        this.defaultInputs = new BehaviorSubject({
            margin: null,
            padding: null,
            socialLinks: [],
            bottomLinks: [],
            copyright: "© DXC Technology 2022. All rights reserved.",
            logoSrc: null,
            tabIndexValue: 0,
        });
        this.footerHeaderStyle = css `
    display: flex;
    justify-content: space-between;
  `;
        this.socialIconsStyle = css `
    display: flex;
    align-items: center;
  `;
        this.socialIconStyle = css `
    display: inline-flex;
  `;
        this.socialIconImageStyle = css `
    display: inline-flex;
    height: var(--footer-socialLinksSize);
    width: var(--footer-socialLinksSize);
    color: var(--footer-socialLinksColor);
    fill: var(--footer-socialLinksColor);
  `;
        this.socialLinksStyle = css `
    display: inline-flex;
    margin-left: var(--footer-socialLinksGutter);
    &:first-child {
      margin-left: 0px;
    }
  `;
        this.bottomLinkStyle = css `
    text-decoration: none;
    font-size: 12px;
  `;
    }
    /**
     * Value of the tabindex for all interactuable elements, except those
     * inside the custom area.
     */
    get tabIndexValue() {
        return this._tabIndexValue;
    }
    set tabIndexValue(value) {
        this._tabIndexValue = coerceNumberProperty(value);
    }
    ngOnInit() {
        this.innerWidth = window.innerWidth;
        this.currentBackgroundColor = this.utils.readProperty("--footer-backgroundColor");
        this.childComponentsStyle = `${this.setChildComponentsStyle(this.defaultInputs.getValue())}`;
        this.footerFooterStyle = `${this.setFooterFooterStyle()}`;
        if (this.bottomLinks) {
            this.bottomLinksLength = this.bottomLinks.length - 1;
        }
    }
    ngOnChanges(changes) {
        const inputs = Object.keys(changes).reduce((result, item) => {
            result[item] = changes[item].currentValue;
            return result;
        }, {});
        this.defaultInputs.next({ ...this.defaultInputs.getValue(), ...inputs });
        this.footerContainerStyle = `${this.setFooterContainerStyle(this.defaultInputs.getValue())}`;
        this.childComponentsStyle = `${this.setChildComponentsStyle(this.defaultInputs.getValue())}`;
        this.footerFooterStyle = `${this.setFooterFooterStyle()}`;
        if (this.bottomLinks) {
            this.bottomLinksLength = this.bottomLinks.length - 1;
        }
    }
    getLogoDxc() {
        return document.body.getAttribute("footer-logo");
    }
    setFooterContainerStyle(input) {
        return css `
      @media (min-width: ${responsiveSizes.small}rem) {
        padding: 24px 36px 24px 36px;
      }

      @media (max-width: ${responsiveSizes.small}rem) {
        padding: 20px;
      }
      background-color: var(--footer-backgroundColor);
      ${this.utils.getTopMargin(input.margin)}
      width: 100%;
      box-sizing: border-box;
      min-height: var(--footer-height);
      display: flex;
      flex-direction: column;
      -webkit-box-pack: justify;
      justify-content: space-between;
    `;
    }
    setChildComponentsStyle(inputs) {
        return css `
      min-height: 16px;
      ${this.utils.getPaddings(inputs.padding)}
    `;
    }
    setFooterFooterStyle() {
        return css `
      display: flex;
      justify-content: space-between;
      @media (min-width: ${responsiveSizes.small}rem) {
        flex-direction: row;
        align-items: flex-end;
      }
    
      @media (max-width: ${responsiveSizes.small}rem) {
        flex-direction: column;
        align-items: center;
      }
      border-top: var(--footer-bottomLinksDividerThickness)
        var(--footer-bottomLinksDividerStyle)
        var(--footer-bottomLinksDividerColor);

      .copyrightStyle {
        color: var(--footer-copyrightFontColor);
        font-family: var(--footer-copyrightFontFamily);
        font-style: var(--footer-copyrightFontStyle);
        font-size: var(--footer-copyrightFontSize);
        font-weight: var(--footer-copyrightFontWeight);
        @media (min-width: ${responsiveSizes.small}rem) {
          max-width: 40%;
          text-align: right;
        }
      
        @media (max-width: ${responsiveSizes.small}rem) {
          max-width: 100%;
          width: 100%;
          text-align: left;
        }
      }

      .bottomLinksStyle {
        padding-top: var(--footer-bottomLinksDividerSpacing);
        display: inline-flex;
        flex-wrap: wrap;
        @media (min-width: ${responsiveSizes.small}rem) {
          max-width: 60%;
        }
      
        @media (max-width: ${responsiveSizes.small}rem) {
          max-width: 100%;
          width: 100%;
          text-align: center;
          margin: 40px 0 40px 0;
        }
      
        color: var(--footer-bottomLinksFontColor);
        .point {
          margin: 0px 10px;
          font-family: var(--footer-bottomLinksFontFamily);
          font-size: var(--footer-bottomLinksFontSize);
          font-style: var(--footer-bottomLinksFontStyle);
          font-weight: var(--footer-bottomLinksFontWeight);
          color: var(--footer-bottomLinksFontColor);
        }
        a,
        a * {
          text-decoration: var(--footer-bottomLinksTextDecoration);
          font-size: var(--footer-bottomLinksFontSize);
          font-family: var(--footer-bottomLinksFontFamily);
          font-style: var(--footer-bottomLinksFontStyle);
          font-weight: var(--footer-bottomLinksFontWeight);
          color: var(--footer-bottomLinksFontColor);
        }
      }
    `;
    }
}
DxcFooterComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcFooterComponent, deps: [{ token: CssUtils }], target: i0.ɵɵFactoryTarget.Component });
DxcFooterComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.5", type: DxcFooterComponent, selector: "dxc-footer", inputs: { socialLinks: "socialLinks", bottomLinks: "bottomLinks", copyright: "copyright", margin: "margin", padding: "padding", logoSrc: "logoSrc", tabIndexValue: "tabIndexValue" }, host: { properties: { "class": "this.className" } }, providers: [CssUtils, BackgroundProviderService], usesOnChanges: true, ngImport: i0, template: "<div [class]=\"footerContainerStyle\">\n  <div [class]=\"footerHeaderStyle\">\n    <img class=\"logo\" [src]=\"getLogoDxc() | safeResourceUrl\" *ngIf=\"!logoSrc\" />\n    <img class=\"logo\" *ngIf=\"logoSrc\" src=\"{{ logoSrc }}\" />\n    <div>\n      <div\n        [class]=\"socialLinksStyle\"\n        *ngFor=\"let link of socialLinks; index as i\"\n      >\n        <a\n          [class]=\"socialIconStyle\"\n          [class.spacing]=\"i != 0\"\n          ngClass\n          *ngIf=\"link.logoSrc\"\n          href=\"{{ link.href }}\"\n          [tabIndex]=\"tabIndexValue\"\n        >\n          <img [class]=\"socialIconImageStyle\" src=\"{{ link.logoSrc }}\" />\n        </a>\n      </div>\n    </div>\n  </div>\n  <div>\n    <div [class]=\"childComponentsStyle\">\n      <background-provider-inner color=\"{{ currentBackgroundColor }}\">\n        <ng-content></ng-content>\n      </background-provider-inner>\n    </div>\n    <div [class]=\"footerFooterStyle\">\n      <div class=\"bottomLinksStyle\">\n        <span *ngFor=\"let bottomLink of bottomLinks; index as i\">\n          <a\n            *ngIf=\"bottomLink.text\"\n            href=\"{{ bottomLink.href }}\"\n            [class]=\"bottomLinkStyle\"\n            [tabIndex]=\"tabIndexValue\"\n          >\n            <span>\n              {{ bottomLink.text }}\n            </span>\n            <span *ngIf=\"i != bottomLinksLength\" class=\"point\">\u00B7</span>\n          </a>\n        </span>\n      </div>\n      <div class=\"copyrightStyle\">\n        {{ copyright }}\n      </div>\n    </div>\n  </div>\n</div>\n", styles: [".logo{height:var(--footer-logoHeight);width:var(--footer-logoWidth)}\n"], components: [{ type: BackgroundProviderInnerComponent, selector: "background-provider-inner", inputs: ["color"] }], directives: [{ type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i4.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }], pipes: { "safeResourceUrl": SafeUrlPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcFooterComponent, decorators: [{
            type: Component,
            args: [{ selector: "dxc-footer", providers: [CssUtils, BackgroundProviderService], template: "<div [class]=\"footerContainerStyle\">\n  <div [class]=\"footerHeaderStyle\">\n    <img class=\"logo\" [src]=\"getLogoDxc() | safeResourceUrl\" *ngIf=\"!logoSrc\" />\n    <img class=\"logo\" *ngIf=\"logoSrc\" src=\"{{ logoSrc }}\" />\n    <div>\n      <div\n        [class]=\"socialLinksStyle\"\n        *ngFor=\"let link of socialLinks; index as i\"\n      >\n        <a\n          [class]=\"socialIconStyle\"\n          [class.spacing]=\"i != 0\"\n          ngClass\n          *ngIf=\"link.logoSrc\"\n          href=\"{{ link.href }}\"\n          [tabIndex]=\"tabIndexValue\"\n        >\n          <img [class]=\"socialIconImageStyle\" src=\"{{ link.logoSrc }}\" />\n        </a>\n      </div>\n    </div>\n  </div>\n  <div>\n    <div [class]=\"childComponentsStyle\">\n      <background-provider-inner color=\"{{ currentBackgroundColor }}\">\n        <ng-content></ng-content>\n      </background-provider-inner>\n    </div>\n    <div [class]=\"footerFooterStyle\">\n      <div class=\"bottomLinksStyle\">\n        <span *ngFor=\"let bottomLink of bottomLinks; index as i\">\n          <a\n            *ngIf=\"bottomLink.text\"\n            href=\"{{ bottomLink.href }}\"\n            [class]=\"bottomLinkStyle\"\n            [tabIndex]=\"tabIndexValue\"\n          >\n            <span>\n              {{ bottomLink.text }}\n            </span>\n            <span *ngIf=\"i != bottomLinksLength\" class=\"point\">\u00B7</span>\n          </a>\n        </span>\n      </div>\n      <div class=\"copyrightStyle\">\n        {{ copyright }}\n      </div>\n    </div>\n  </div>\n</div>\n", styles: [".logo{height:var(--footer-logoHeight);width:var(--footer-logoWidth)}\n"] }]
        }], ctorParameters: function () { return [{ type: CssUtils }]; }, propDecorators: { className: [{
                type: HostBinding,
                args: ["class"]
            }], socialLinks: [{
                type: Input
            }], bottomLinks: [{
                type: Input
            }], copyright: [{
                type: Input
            }], margin: [{
                type: Input
            }], padding: [{
                type: Input
            }], logoSrc: [{
                type: Input
            }], tabIndexValue: [{
                type: Input
            }] } });

class SafeHTMLPipe {
    constructor(sanitizer) {
        this.sanitizer = sanitizer;
    }
    transform(code) {
        return this.sanitizer.bypassSecurityTrustHtml(code);
    }
}
SafeHTMLPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: SafeHTMLPipe, deps: [{ token: i1.DomSanitizer }], target: i0.ɵɵFactoryTarget.Pipe });
SafeHTMLPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: SafeHTMLPipe, name: "safeHtml" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: SafeHTMLPipe, decorators: [{
            type: Pipe,
            args: [{ name: 'safeHtml' }]
        }], ctorParameters: function () { return [{ type: i1.DomSanitizer }]; } });

class PipesModule {
}
PipesModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: PipesModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
PipesModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: PipesModule, declarations: [SafeUrlPipe, SafeHTMLPipe], imports: [CommonModule], exports: [SafeUrlPipe, SafeHTMLPipe] });
PipesModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: PipesModule, imports: [[
            CommonModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: PipesModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [SafeUrlPipe, SafeHTMLPipe],
                    imports: [
                        CommonModule
                    ],
                    exports: [SafeUrlPipe, SafeHTMLPipe]
                }]
        }] });

class DxcFooterModule {
}
DxcFooterModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcFooterModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DxcFooterModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcFooterModule, declarations: [DxcFooterComponent], imports: [CommonModule,
        MatToolbarModule,
        PipesModule,
        BackgroundProviderInnerModule], exports: [DxcFooterComponent] });
DxcFooterModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcFooterModule, imports: [[
            CommonModule,
            MatToolbarModule,
            PipesModule,
            BackgroundProviderInnerModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcFooterModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [DxcFooterComponent],
                    imports: [
                        CommonModule,
                        MatToolbarModule,
                        PipesModule,
                        BackgroundProviderInnerModule,
                    ],
                    exports: [DxcFooterComponent],
                }]
        }] });

class DxcHeaderComponent {
    constructor(utils, elRef) {
        this.utils = utils;
        this.elRef = elRef;
        this._underlined = false;
        /**
         * This event will emit in case the user clicks the header logo.
         */
        this.onClick = new EventEmitter();
        this._tabIndexValue = 0;
        this.isResponsive = false;
        this.isMenuVisible = false;
        this.isClickDefined = false;
        this.defaultInputs = new BehaviorSubject({
            underlined: false,
            logoSrc: null,
            logoResponsiveSrc: null,
            tabIndexValue: 0,
            margin: null,
            padding: null,
        });
    }
    /**
     * Wether a contrast line should appear at the bottom of the header.
     */
    get underlined() {
        return this._underlined;
    }
    set underlined(value) {
        this._underlined = coerceBooleanProperty(value);
    }
    /**
     * Value of the tabindex for all interactuable elements, except those inside the custom area.
     */
    get tabIndexValue() {
        return this._tabIndexValue;
    }
    set tabIndexValue(value) {
        this._tabIndexValue = coerceNumberProperty(value);
    }
    onResize() {
        this.isResponsive = window.matchMedia(`(max-width: ${responsiveSizes.medium}rem)`).matches;
        if (!this.isResponsive) {
            this.isMenuVisible = false;
        }
        this.updateCss();
    }
    updateCss() {
        this.currentBackgroundColor = this.utils.readProperty("--header-backgroundColor");
        this.className = `${this.getDynamicStyle({
            ...this.defaultInputs.getValue(),
            isMenuVisible: this.isMenuVisible,
            isResponsive: this.isResponsive
        })}`;
        this.responsiveMenu = `${this.getResponsiveMenuStyle({
            ...this.defaultInputs.getValue(),
            isMenuVisible: this.isMenuVisible,
            isResponsive: this.isResponsive
        })}`;
    }
    ngOnInit() {
        this.isClickDefined = this.onClick.observers?.length > 0;
        this.isResponsive = window.matchMedia(`(max-width: ${responsiveSizes.medium}rem)`).matches;
        this.updateCss();
    }
    showMenu() {
        this.isMenuVisible = !this.isMenuVisible;
        this.updateCss();
    }
    showMenuKey($event) {
        if ($event.keyCode === 32) {
            this.isMenuVisible = !this.isMenuVisible;
            this.updateCss();
        }
    }
    getBottomMargin(margin) {
        return margin && typeof margin !== "object"
            ? css `
          margin-bottom: ${spaces[margin]};
        `
            : margin && margin !== null
                ? css `
          margin-bottom: ${spaces[margin["bottom"]]};
        `
                : css `
          margin-bottom: 0px;
        `;
    }
    ngOnChanges(changes) {
        const inputs = Object.keys(changes).reduce((result, item) => {
            result[item] = changes[item].currentValue;
            return result;
        }, {});
        this.defaultInputs.next({ ...this.defaultInputs.getValue(), ...inputs });
        this.updateCss();
    }
    onClickHandler($event) {
        this.onClick.emit($event);
    }
    checkMenuVisible(isMenuVisible) {
        return css `
      transform: ${isMenuVisible ? "translateX(0)" : "translateX(100vw)"};
      opacity: ${isMenuVisible ? "1" : "0.96"};
    `;
    }
    getLogoDxc() {
        const pic = document.body.getAttribute("header-logo");
        return pic;
    }
    getLogoResponsiveDxc() {
        return document.body.getAttribute("header-logoResponsive");
    }
    getDynamicStyle(inputs) {
        return css `
      font-family: var(--header-fontFamily);
      ${this.getBottomMargin(inputs.margin)}
      .headerAnchor {
        cursor: ${this.isClickDefined ? "pointer;" : "default; "};
        ${!this.isClickDefined ? "outline: none;" : ""};
      }
      .mat-toolbar {
        font-size: unset;
        .mat-toolbar-row {
          min-height: var(--header-minHeight);
          padding-top: var(--header-paddingTop);
          padding-right: var(--header-paddingRight);
          padding-bottom: var(--header-paddingBottom);
          padding-left: var(--header-paddingLeft);
        }
        &.underlined {
          .mat-toolbar-row {
            border-bottom: ${inputs.underlined
            ? `var(--header-underlinedThickness) var(--header-underlinedStyle) var(--header-underlinedColor);`
            : "unset;"};
          }
        }
      }
      mat-toolbar-row.mat-toolbar-row,
      .mat-toolbar-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      .mat-toolbar-row {
        background: var(--header-backgroundColor);
      }
      .dxc-logo,
      img {
        height: var(--header-logoHeight);
        width: var(--header-logoWidth);
        vertical-align: middle;
      }

      .content {
        width: calc(100% - 186px);
        display: flex;
        align-items: center;
        flex-grow: 1;
        justify-content: flex-end;
        ${this.utils.getPaddings(inputs.padding)}
        align-items: center;
        flex-wrap: wrap;
      }
      .hamburger {
        color: var(--header-fontColor);
        ${this.utils.getPaddings(inputs.padding)}

        .hamburgerItem {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          width: 54px;
          cursor: pointer;
          &:hover {
            cursor: pointer;
            background-color: var(--header-hamburguerHoverColor);
          }
          &:focus {
            outline: var(--header-hamburguerFocusColor) auto 1px;
          }
          .hamburgerIcon {
            width: 24px;
            height: 24px;
            svg path {
              fill: var(--header-hamburguerIconColor) !important;
            }
          }
          .hamburgerTitle {
            font-family: var(--header-hamburguerFontFamily);
            font-style: var(--header-hamburguerFontStyle);
            font-size: var(--header-hamburguerFontSize);
            text-transform: var(--header-hamburguerTextTransform);
            font-weight: var(--header-hamburguerFontWeight);
            color: var(--header-hamburguerFontColor);
          }
        }
      }
      .overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background-color: var(--header-overlayColor);
        opacity: var(--header-overlayOpacity) !important;
        @media (max-width: ${responsiveSizes.small}rem) { 
          display: none;
        }
        transition: opacity 0.2s 0.2s ease-in-out;
        z-index: var(--header-overlayZindex);
      }
    `;
    }
    getResponsiveMenuStyle(inputs) {
        return css `
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
      background-color: var(--header-menuBackgroundColor);
      position: fixed;
      top: 0;
      right: 0;
      z-index: var(--header-menuZindex);


      @media (max-width: ${responsiveSizes.large}rem) and (min-width: ${responsiveSizes.small}rem) {
        width: "var(--header-menuTabletWidth)";
      }
      @media not((max-width: ${responsiveSizes.large}rem) and (min-width: ${responsiveSizes.small}rem)) {
        width: "var(--header-menuMobileWidth)"};
      }

      height: 100vh;
      padding: 20px;

      ${this.checkMenuVisible(inputs.isMenuVisible)}
      transition-property: transform, opacity;
      transition-duration: 0.6s;
      transition-timing-function: ease-in-out;
      box-sizing: border-box;

      .responsiveMenu-Header {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        width: 100%;
        .closeIcon {
          cursor: pointer;
          display: flex;
          justify-content: flex-end;
          width: 24px;
          &:hover {
            cursor: pointer;
          }
          &:focus {
            outline: var(--header-hamburguerFocusColor) solid 1px;
          }
          svg {
            fill: var(--header-fontColorMenu);
          }
        }
      }

      .menuContent {
        display: flex;
        flex-direction: column;
      }
    `;
    }
}
DxcHeaderComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcHeaderComponent, deps: [{ token: CssUtils }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
DxcHeaderComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.5", type: DxcHeaderComponent, selector: "dxc-header", inputs: { underlined: "underlined", logoSrc: "logoSrc", logoResponsiveSrc: "logoResponsiveSrc", tabIndexValue: "tabIndexValue", margin: "margin", padding: "padding" }, outputs: { onClick: "onClick" }, host: { listeners: { "window:resize": "onResize($event)" }, properties: { "class": "this.className" } }, providers: [CssUtils, BackgroundProviderService], usesOnChanges: true, ngImport: i0, template: "<mat-toolbar [ngClass]=\"underlined ? 'underlined' : ''\">\n  <mat-toolbar-row>\n    <a class=\"headerAnchor\" (click)=\"onClickHandler($event)\" [tabindex]=\"isClickDefined ? tabIndexValue : -1\">\n      <img [src]=\"getLogoDxc() | safeResourceUrl\" *ngIf=\"!logoSrc\" />\n      <img *ngIf=\"logoSrc\" src=\"{{ logoSrc }}\" />\n    </a>\n    <div class=\"hamburger\">\n      <span\n        id=\"hamburguer\"\n        [tabindex]=\"tabIndexValue\"\n        (keydown)=\"showMenuKey($event)\"\n        (click)=\"showMenu()\"\n        *ngIf=\"isResponsive\"\n        class=\"hamburgerItem\"\n      >\n        <div class=\"hamburgerIcon\">\n          <svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\">\n            <path\n              d=\"M3,8H21a1,1,0,0,0,0-2H3A1,1,0,0,0,3,8Zm18,8H3a1,1,0,0,0,0,2H21a1,1,0,0,0,0-2Zm0-5H3a1,1,0,0,0,0,2H21a1,1,0,0,0,0-2Z\"\n              fill=\"white\"\n            />\n          </svg>\n        </div>\n        <span class=\"hamburgerTitle\">Menu</span>\n      </span>\n    </div>\n\n    <div *ngIf=\"!isResponsive\" class=\"content\">\n      <background-provider-inner color=\"{{ currentBackgroundColor }}\">\n        <ng-content select=\"[id=unresponsive]\"></ng-content>\n      </background-provider-inner>\n    </div>\n  </mat-toolbar-row>\n</mat-toolbar>\n<div [class]=\"responsiveMenu\">\n  <div class=\"responsiveMenu-Header\">\n    <a class=\"headerAnchor\" (click)=\"onClickHandler($event)\" [tabindex]=\"isClickDefined ? tabIndexValue : -1\">\n      <img [src]=\"getLogoResponsiveDxc()\" *ngIf=\"!logoResponsiveSrc\" />\n      <img *ngIf=\"logoResponsiveSrc\" src=\"{{ logoResponsiveSrc }}\" />\n    </a>\n    <div\n      class=\"closeIcon\"\n      (keydown)=\"showMenuKey($event)\"\n      (click)=\"showMenu()\"\n      id=\"closeIcon\"\n      [tabIndex]=\"tabIndexValue\"\n    >\n      <svg\n        xmlns=\"http://www.w3.org/2000/svg\"\n        width=\"24\"\n        height=\"24\"\n        viewBox=\"0 0 24 24\"\n      >\n        <path\n          d=\"M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z\"\n        />\n        <path d=\"M0 0h24v24H0z\" fill=\"none\" />\n      </svg>\n    </div>\n  </div>\n  <div class=\"menuContent\">\n    <background-provider-inner color=\"{{ currentBackgroundColor }}\">\n      <ng-content select=\"[id=responsive]\"></ng-content>\n    </background-provider-inner>\n  </div>\n</div>\n<div (click)=\"showMenu()\" *ngIf=\"isMenuVisible\" class=\"overlay\"></div>\n", components: [{ type: i2$1.MatToolbar, selector: "mat-toolbar", inputs: ["color"], exportAs: ["matToolbar"] }, { type: BackgroundProviderInnerComponent, selector: "background-provider-inner", inputs: ["color"] }], directives: [{ type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i2$1.MatToolbarRow, selector: "mat-toolbar-row", exportAs: ["matToolbarRow"] }, { type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], pipes: { "safeResourceUrl": SafeUrlPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcHeaderComponent, decorators: [{
            type: Component,
            args: [{ selector: "dxc-header", providers: [CssUtils, BackgroundProviderService], template: "<mat-toolbar [ngClass]=\"underlined ? 'underlined' : ''\">\n  <mat-toolbar-row>\n    <a class=\"headerAnchor\" (click)=\"onClickHandler($event)\" [tabindex]=\"isClickDefined ? tabIndexValue : -1\">\n      <img [src]=\"getLogoDxc() | safeResourceUrl\" *ngIf=\"!logoSrc\" />\n      <img *ngIf=\"logoSrc\" src=\"{{ logoSrc }}\" />\n    </a>\n    <div class=\"hamburger\">\n      <span\n        id=\"hamburguer\"\n        [tabindex]=\"tabIndexValue\"\n        (keydown)=\"showMenuKey($event)\"\n        (click)=\"showMenu()\"\n        *ngIf=\"isResponsive\"\n        class=\"hamburgerItem\"\n      >\n        <div class=\"hamburgerIcon\">\n          <svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\">\n            <path\n              d=\"M3,8H21a1,1,0,0,0,0-2H3A1,1,0,0,0,3,8Zm18,8H3a1,1,0,0,0,0,2H21a1,1,0,0,0,0-2Zm0-5H3a1,1,0,0,0,0,2H21a1,1,0,0,0,0-2Z\"\n              fill=\"white\"\n            />\n          </svg>\n        </div>\n        <span class=\"hamburgerTitle\">Menu</span>\n      </span>\n    </div>\n\n    <div *ngIf=\"!isResponsive\" class=\"content\">\n      <background-provider-inner color=\"{{ currentBackgroundColor }}\">\n        <ng-content select=\"[id=unresponsive]\"></ng-content>\n      </background-provider-inner>\n    </div>\n  </mat-toolbar-row>\n</mat-toolbar>\n<div [class]=\"responsiveMenu\">\n  <div class=\"responsiveMenu-Header\">\n    <a class=\"headerAnchor\" (click)=\"onClickHandler($event)\" [tabindex]=\"isClickDefined ? tabIndexValue : -1\">\n      <img [src]=\"getLogoResponsiveDxc()\" *ngIf=\"!logoResponsiveSrc\" />\n      <img *ngIf=\"logoResponsiveSrc\" src=\"{{ logoResponsiveSrc }}\" />\n    </a>\n    <div\n      class=\"closeIcon\"\n      (keydown)=\"showMenuKey($event)\"\n      (click)=\"showMenu()\"\n      id=\"closeIcon\"\n      [tabIndex]=\"tabIndexValue\"\n    >\n      <svg\n        xmlns=\"http://www.w3.org/2000/svg\"\n        width=\"24\"\n        height=\"24\"\n        viewBox=\"0 0 24 24\"\n      >\n        <path\n          d=\"M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z\"\n        />\n        <path d=\"M0 0h24v24H0z\" fill=\"none\" />\n      </svg>\n    </div>\n  </div>\n  <div class=\"menuContent\">\n    <background-provider-inner color=\"{{ currentBackgroundColor }}\">\n      <ng-content select=\"[id=responsive]\"></ng-content>\n    </background-provider-inner>\n  </div>\n</div>\n<div (click)=\"showMenu()\" *ngIf=\"isMenuVisible\" class=\"overlay\"></div>\n" }]
        }], ctorParameters: function () { return [{ type: CssUtils }, { type: i0.ElementRef }]; }, propDecorators: { underlined: [{
                type: Input
            }], logoSrc: [{
                type: Input
            }], logoResponsiveSrc: [{
                type: Input
            }], onClick: [{
                type: Output
            }], tabIndexValue: [{
                type: Input
            }], margin: [{
                type: Input
            }], padding: [{
                type: Input
            }], className: [{
                type: HostBinding,
                args: ["class"]
            }], onResize: [{
                type: HostListener,
                args: ['window:resize', ['$event']]
            }] } });

class DxcHeaderDropdownComponent {
    constructor() {
        /**
         * In case options include icons, whether the icon should appear after or before the label.
         */
        this.optionsIconPosition = "before";
        /**
         * Whether the icon should appear after or before the label.
         */
        this.iconPosition = "before";
        /**
         * Text to be placed when the list of options is not displayed.
         */
        this.label = "";
        /**
         * Whether the arrow next to the label is displayed or not.
         */
        this.caretHidden = false;
        /**
         * Size of the component.
         */
        this.size = "fitContent";
        /**
         * This event will emit in case the selection changes. The value of the selected
         * value will be passed as a parameter.
         */
        this.onSelectOption = new EventEmitter();
        /**
         * Value of the tabindex.
         */
        this.tabIndexValue = 0;
        /**
         * If true, the options are showed when the dropdown is hover.
         */
        this.expandOnHover = false;
        /**
         * If true, the component will be disabled.
         */
        this.disabled = false;
    }
    ngOnInit() {
        this.triggerStyles = this.triggerButtonStyles();
    }
    ngOnChanges() {
        this.triggerStyles = this.triggerButtonStyles();
    }
    handleSelect($event) {
        this.onSelectOption.emit($event);
    }
    triggerButtonStyles() {
        return css `
      dxc-dropdown {
        .menu-buttom-label {
          color: var(--header-fontColor) !important;
        }
        button {
          background-color: transparent !important;
        }
      }
    `;
    }
}
DxcHeaderDropdownComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcHeaderDropdownComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
DxcHeaderDropdownComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.5", type: DxcHeaderDropdownComponent, selector: "dxc-header-dropdown", inputs: { optionsIconPosition: "optionsIconPosition", iconPosition: "iconPosition", label: "label", name: "name", caretHidden: "caretHidden", margin: "margin", size: "size", tabIndexValue: "tabIndexValue", expandOnHover: "expandOnHover", disabled: "disabled" }, outputs: { onSelectOption: "onSelectOption" }, host: { properties: { "class": "this.triggerStyles" } }, usesOnChanges: true, ngImport: i0, template: "<dxc-dropdown\n  [optionsIconPosition]=\"optionsIconPosition\"\n  [iconPosition]=\"iconPosition\"\n  [label]=\"label\"\n  [name]=\"name\"\n  [caretHidden]=\"caretHidden\"\n  [margin]=\"margin\"\n  [size]=\"size\"\n  [tabIndexValue]=\"tabIndexValue\"\n  [disabled]=\"disabled\"\n>\n  <ng-content></ng-content>\n</dxc-dropdown>\n", components: [{ type: DxcDropdownComponent, selector: "dxc-dropdown", inputs: ["optionsIconPosition", "iconPosition", "label", "name", "caretHidden", "margin", "size", "tabIndexValue", "expandOnHover", "disabled"], outputs: ["onSelectOption"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcHeaderDropdownComponent, decorators: [{
            type: Component,
            args: [{ selector: "dxc-header-dropdown", template: "<dxc-dropdown\n  [optionsIconPosition]=\"optionsIconPosition\"\n  [iconPosition]=\"iconPosition\"\n  [label]=\"label\"\n  [name]=\"name\"\n  [caretHidden]=\"caretHidden\"\n  [margin]=\"margin\"\n  [size]=\"size\"\n  [tabIndexValue]=\"tabIndexValue\"\n  [disabled]=\"disabled\"\n>\n  <ng-content></ng-content>\n</dxc-dropdown>\n", styles: [] }]
        }], ctorParameters: function () { return []; }, propDecorators: { optionsIconPosition: [{
                type: Input
            }], iconPosition: [{
                type: Input
            }], label: [{
                type: Input
            }], name: [{
                type: Input
            }], caretHidden: [{
                type: Input
            }], margin: [{
                type: Input
            }], size: [{
                type: Input
            }], onSelectOption: [{
                type: Output
            }], tabIndexValue: [{
                type: Input
            }], expandOnHover: [{
                type: Input
            }], disabled: [{
                type: Input
            }], triggerStyles: [{
                type: HostBinding,
                args: ["class"]
            }] } });

class ClosableDirective {
    constructor(elementRef, viewContainerRef, parent) {
        this.elementRef = elementRef;
        this.viewContainerRef = viewContainerRef;
        if (parent) {
            this.parent = parent;
        }
    }
    click() {
        this.parent.showMenu();
    }
}
ClosableDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: ClosableDirective, deps: [{ token: i0.ElementRef }, { token: i0.ViewContainerRef }, { token: DxcHeaderComponent, optional: true }], target: i0.ɵɵFactoryTarget.Directive });
ClosableDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.2.5", type: ClosableDirective, selector: "[isClosable]", host: { listeners: { "click": "click()" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: ClosableDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: "[isClosable]",
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.ViewContainerRef }, { type: DxcHeaderComponent, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { click: [{
                type: HostListener,
                args: ["click"]
            }] } });

class DxcHeaderModule {
}
DxcHeaderModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcHeaderModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DxcHeaderModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcHeaderModule, declarations: [DxcHeaderComponent,
        DxcHeaderDropdownComponent,
        ClosableDirective], imports: [CommonModule,
        MatToolbarModule,
        DxcDropdownModule,
        PipesModule,
        BackgroundProviderInnerModule], exports: [DxcHeaderComponent, DxcHeaderDropdownComponent, ClosableDirective] });
DxcHeaderModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcHeaderModule, imports: [[
            CommonModule,
            MatToolbarModule,
            DxcDropdownModule,
            PipesModule,
            BackgroundProviderInnerModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcHeaderModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        DxcHeaderComponent,
                        DxcHeaderDropdownComponent,
                        ClosableDirective,
                    ],
                    imports: [
                        CommonModule,
                        MatToolbarModule,
                        DxcDropdownModule,
                        PipesModule,
                        BackgroundProviderInnerModule,
                    ],
                    exports: [DxcHeaderComponent, DxcHeaderDropdownComponent, ClosableDirective],
                }]
        }] });

class DxcTableComponent {
    constructor(utils) {
        this.utils = utils;
        this.defaultInputs = new BehaviorSubject({
            margin: null,
        });
    }
    ngOnChanges(changes) {
        const inputs = Object.keys(changes).reduce((result, item) => {
            result[item] = changes[item].currentValue;
            return result;
        }, {});
        this.currentBackgroundColor = this.utils.readProperty("--table-dataBackgroundColor");
        this.defaultInputs.next({ ...this.defaultInputs.getValue(), ...inputs });
        this.className = `${this.getDynamicStyle(this.defaultInputs.getValue())}`;
    }
    ngOnInit() {
        this.className = `${this.getDynamicStyle(this.defaultInputs.getValue())}`;
    }
    getDynamicStyle(inputs) {
        return css `
      ${this.utils.getMargins(inputs.margin)}
      display: flex;
      overflow: auto;

      table {
        border-collapse: collapse;
        width: 100%;
        & tr {
          border-bottom: var(--table-rowSeparatorThickness)
            var(--table-rowSeparatorStyle) var(--table-rowSeparatorColor);
        }

        & td {
          background-color: var(--table-dataBackgroundColor);
          font-family: var(--table-dataFontFamily);
          font-size: var(--table-dataFontSize);
          font-style: var(--table-dataFontStyle);
          font-weight: var(--table-dataFontWeight);
          color: var(--table-dataFontColor);
          text-transform: var(--table-dataFontTextTransform);
          text-align: var(--table-dataTextAlign);
          line-height: var(--table-dataTextLineHeight);
          text-align: var(--table-dataTextAlign);
          padding: var(--table-dataPaddingTop) var(--table-dataPaddingRight)
            var(--table-dataPaddingBottom) var(--table-dataPaddingLeft);
        }

        & th {
          background-color: var(--table-headerBackgroundColor);
          font-family: var(--table-headerFontFamily);
          font-size: var(--table-headerFontSize);
          font-style: var(--table-headerFontStyle);
          font-weight: var(--table-headerFontWeight);
          color: var(--table-headerFontColor);
          text-transform: var(--table-headerFontTextTransform);
          text-align: var(--table-headerTextAlign);
          line-height: var(--table-headerTextLineHeight);
          padding: var(--table-headerPaddingTop) var(--table-headerPaddingRight)
            var(--table-headerPaddingBottom) var(--table-headerPaddingLeft);
        }

        & th:first-child {
          border-top-left-radius: var(--table-headerBorderRadius);
        }

        & th:last-of-type {
          border-top-right-radius: var(--table-headerBorderRadius);
        }
      }
    `;
    }
}
DxcTableComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcTableComponent, deps: [{ token: CssUtils }], target: i0.ɵɵFactoryTarget.Component });
DxcTableComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.5", type: DxcTableComponent, selector: "dxc-table", inputs: { margin: "margin" }, host: { properties: { "class": "this.className" } }, providers: [CssUtils, BackgroundProviderService], usesOnChanges: true, ngImport: i0, template: "<table>\n  <background-provider-inner color=\"{{ currentBackgroundColor }}\">\n    <ng-content></ng-content>\n  </background-provider-inner>\n</table>\n", components: [{ type: BackgroundProviderInnerComponent, selector: "background-provider-inner", inputs: ["color"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcTableComponent, decorators: [{
            type: Component,
            args: [{ selector: "dxc-table", providers: [CssUtils, BackgroundProviderService], template: "<table>\n  <background-provider-inner color=\"{{ currentBackgroundColor }}\">\n    <ng-content></ng-content>\n  </background-provider-inner>\n</table>\n", styles: [] }]
        }], ctorParameters: function () { return [{ type: CssUtils }]; }, propDecorators: { margin: [{
                type: Input
            }], className: [{
                type: HostBinding,
                args: ["class"]
            }] } });

class DxcTableModule {
}
DxcTableModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcTableModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DxcTableModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcTableModule, declarations: [DxcTableComponent], imports: [CommonModule,
        MatButtonModule,
        MatIconModule,
        BackgroundProviderInnerModule], exports: [DxcTableComponent] });
DxcTableModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcTableModule, imports: [[
            CommonModule,
            MatButtonModule,
            MatIconModule,
            BackgroundProviderInnerModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcTableModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [DxcTableComponent],
                    imports: [
                        CommonModule,
                        MatButtonModule,
                        MatIconModule,
                        BackgroundProviderInnerModule,
                    ],
                    exports: [DxcTableComponent],
                }]
        }] });

class DxcTagIconComponent {
    constructor() { }
}
DxcTagIconComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcTagIconComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
DxcTagIconComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.5", type: DxcTagIconComponent, selector: "dxc-tag-icon", ngImport: i0, template: "<ng-content></ng-content>" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcTagIconComponent, decorators: [{
            type: Component,
            args: [{ selector: "dxc-tag-icon", template: "<ng-content></ng-content>" }]
        }], ctorParameters: function () { return []; } });

class DxcTagComponent {
    constructor(utils, cdRef) {
        this.utils = utils;
        this.cdRef = cdRef;
        this.isHovered = false;
        /**
         * Background color of the icon section of the tag.
         */
        this.iconBgColor = "#5f249f";
        /**
         * Whether the label should appear after or before the icon.
         */
        this.labelPosition = "after";
        this._newWindow = false;
        this._disabled = false;
        /**
         * Size of the component.
         */
        this.size = "fitContent";
        this._tabIndexValue = 0;
        /**
         * If defined, the tag will be displayed as a button. This event will emit in case the user clicks the tag.
         * Component will show some visual feedback on hover.
         */
        this.onClick = new EventEmitter();
        this.isClickDefined = false;
        this.defaultInputs = new BehaviorSubject({
            size: "fitContent",
            iconSrc: null,
            iconBgColor: "#5f249f",
            label: null,
            linkHref: null,
            labelPosition: "after",
            margin: null,
            newWindow: false,
            tabIndexValue: 0,
        });
        this.sizes = {
            small: "42px",
            medium: "240px",
            large: "480px",
            fillParent: "100%",
            fitContent: "unset",
        };
    }
    /**
     * If true, the page is opened in a new browser tab.
     */
    get newWindow() {
        return this._newWindow;
    }
    set newWindow(value) {
        this._newWindow = coerceBooleanProperty(value);
    }
    /**
     * If true, the component will be disabled.
     */
    get disabled() {
        return this._disabled;
    }
    set disabled(value) {
        this._disabled = coerceBooleanProperty(value);
    }
    /**
     * Value of the tabindex.
     */
    get tabIndexValue() {
        return this._tabIndexValue;
    }
    set tabIndexValue(value) {
        this._tabIndexValue = coerceNumberProperty(value);
    }
    ngOnInit() {
        this.isClickDefined = this.onClick.observers.length > 0;
        this.className = `${this.getDynamicStyle(this.defaultInputs.getValue())}`;
        this.shadowDepth = this.getShadowDepth();
    }
    ngOnChanges(changes) {
        const inputs = Object.keys(changes).reduce((result, item) => {
            result[item] = changes[item].currentValue;
            return result;
        }, {});
        this.defaultInputs.next({ ...this.defaultInputs.getValue(), ...inputs });
        this.className = `${this.getDynamicStyle(this.defaultInputs.getValue())}`;
        this.shadowDepth = this.getShadowDepth();
    }
    ngAfterViewInit() {
        this.setStyleDxcBox();
        this.setIconDisplay();
        this.cdRef.detectChanges();
    }
    setIconDisplay() {
        if (this.dxcTagIcon.length !== 0) {
            this.iconSrc = "";
        }
        else if ((this.iconSrc === null || this.iconSrc === undefined) &&
            this.dxcTagIcon.length === 0) {
            this.iconContainer.toArray().forEach((el) => {
                el.nativeElement.style.display = "none";
            });
        }
    }
    setStyleDxcBox() {
        this.dxcBox.toArray().forEach((el) => {
            if (!this.label && this.size == "small") {
                el.nativeElement.style.width =
                    "var(--tag-iconSectionWidth)";
            }
        });
    }
    mouseEnter() {
        this.isHovered = true;
        this.shadowDepth = this.getShadowDepth();
    }
    mouseLeave() {
        this.isHovered = false;
        this.shadowDepth = this.getShadowDepth();
    }
    onClickHandler($event) {
        if (!this.disabled) {
            this.onClick.emit($event);
        }
    }
    getShadowDepth() {
        return this.isHovered &&
            (this.isClickDefined ||
                (this.linkHref !== null && this.linkHref !== undefined))
            ? "2"
            : "1";
    }
    setActionStyle(inputs) {
        if (!inputs.disabled) {
            return css `
        button:focus,
        button:focus-visible,
        button:focus-within,
        button:active,
        a:focus,
        a:focus-visible,
        a:focus-within,
        a:active {
          outline: var(--tag-focusColor) auto 2px;
        }
        button:active,
        button:hover,
        a:active,
        a:hover {
          dxc-box {
            box-shadow: 0 8px 14px -2px rgba(0, 0, 0, 0.1);
          }
        }
      `;
        }
    }
    getDynamicStyle(inputs) {
        return css `
      display: inline-flex;
      ${!this.isClickDefined &&
            (this.linkHref === null || this.linkHref === undefined)
            ? css `
            cursor: unset;
          `
            : this.disabled
                ? css `
            cursor: not-allowed;
          `
                : css `
            cursor: pointer;
          `};
      ${this.utils.getMargins(inputs.margin)};
      dxc-box {
        box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
        border: 0px solid;
      }
      .tagContent {
        display: inline-flex;
        align-items: center;
        height: var(--tag-height);
        ${this.utils.calculateWidth(this.sizes, inputs)};
        ${inputs.labelPosition &&
            inputs.labelPosition != null &&
            inputs.labelPosition === "before"
            ? css `
              flex-direction: row-reverse;
            `
            : css `
              flex-direction: row;
            `};
        .tagLabel {
          padding-top: var(--tag-labelPaddingTop);
          padding-left: var(--tag-labelPaddingLeft);
          padding-bottom: var(--tag-labelPaddingBottom);
          padding-right: var(--tag-labelPaddingRight);
          font-style: var(--tag-fontStyle);
          font-family: var(--tag-fontFamily);
          color: ${inputs.disabled
            ? "var(--tag-disabledFontColor)"
            : "var(--tag-fontColor)"};
          font-weight: var(--tag-fontWeight);
          font-size: var(--tag-fontSize);
          letter-spacing: 1px;
          flex-grow: 1;
          text-align: center;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          display: ${inputs.label ? "inline-flex" : "none"};
        }
        .iconContainer {
          opacity: ${inputs.disabled ? "0.4" : "1"};
          height: 100%;
          display: inline-flex;
          width: var(--tag-iconSectionWidth);
          justify-content: center;
          background: ${inputs.iconBgColor};
          .tagIcon {
            display: flex;
            align-self: center;
            height: var(--tag-iconHeight);
            width: var(--tag-iconWidth);
            fill: var(--tag-iconColor);
          }
          dxc-tag-icon {
            display: flex;
            align-self: center;
            img,
            svg {
              height: var(--tag-iconHeight);
              width: var(--tag-iconWidth);
              fill: var(--tag-iconColor);
            }
          }
        }
      }
      .styledButton {
        background: none;
        border: none;
        padding: 0;
        cursor: ${!this.disabled ? "pointer" : "not-allowed"};
        outline: 0;
      }
      .styledLink {
        text-decoration: none;
        outline: none;
        cursor: ${!this.disabled ? "pointer" : "not-allowed"};
        ${this.disabled ? "pointer-events: none;" : ""}
      }
      ${this.setActionStyle(inputs)};
    `;
    }
}
DxcTagComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcTagComponent, deps: [{ token: CssUtils }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
DxcTagComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.5", type: DxcTagComponent, selector: "dxc-tag", inputs: { label: "label", iconSrc: "iconSrc", iconBgColor: "iconBgColor", labelPosition: "labelPosition", linkHref: "linkHref", margin: "margin", newWindow: "newWindow", disabled: "disabled", size: "size", tabIndexValue: "tabIndexValue" }, outputs: { onClick: "onClick" }, host: { properties: { "class": "this.className" } }, providers: [CssUtils], queries: [{ propertyName: "dxcTagIcon", predicate: DxcTagIconComponent }], viewQueries: [{ propertyName: "dxcBox", predicate: ["dxcBox"], descendants: true, read: ElementRef }, { propertyName: "iconContainer", predicate: ["iconContainer"], descendants: true, read: ElementRef }], usesOnChanges: true, ngImport: i0, template: "<div\n  (mouseenter)=\"mouseEnter()\"\n  (mouseleave)=\"mouseLeave()\"\n  (click)=\"onClickHandler($event)\"\n>\n  <button\n    *ngIf=\"isClickDefined == true && linkHref == null\"\n    class=\"styledButton\"\n  >\n    <dxc-box [size]=\"size\" [shadowDepth]=\"shadowDepth\" #dxcBox>\n      <div class=\"tagContent\">\n        <div class=\"iconContainer\" #iconContainer>\n          <ng-container *ngTemplateOutlet=\"dxcTagIcon\"></ng-container>\n          <img src=\"{{ iconSrc }}\" class=\"tagIcon\" *ngIf=\"iconSrc\" />\n        </div>\n        <div\n          class=\"tagLabel\"\n          *ngIf=\"size !== 'small' && (label !== undefined || label !== null)\"\n        >\n          {{ label }}\n        </div>\n      </div>\n    </dxc-box>\n  </button>\n  <dxc-box\n    *ngIf=\"linkHref == null && isClickDefined == false\"\n    [size]=\"size\"\n    [shadowDepth]=\"shadowDepth\"\n    #dxcBox\n  >\n    <div class=\"tagContent\">\n      <div class=\"iconContainer\" #iconContainer>\n        <ng-container *ngTemplateOutlet=\"dxcTagIcon\"></ng-container>\n        <img src=\"{{ iconSrc }}\" class=\"tagIcon\" *ngIf=\"iconSrc\" />\n      </div>\n      <div\n        class=\"tagLabel\"\n        *ngIf=\"size !== 'small' && (label !== undefined || label !== null)\"\n      >\n        {{ label }}\n      </div>\n    </div>\n  </dxc-box>\n\n  <a\n    *ngIf=\"linkHref != null\"\n    [tabindex]=\"tabIndexValue\"\n    class=\"styledLink\"\n    href=\"{{ linkHref }}\"\n    [target]=\"newWindow ? '_blank' : '_self'\"\n  >\n    <dxc-box [size]=\"size\" [shadowDepth]=\"shadowDepth\" #dxcBox>\n      <div class=\"tagContent\">\n        <div class=\"iconContainer\" #iconContainer>\n          <ng-container *ngTemplateOutlet=\"dxcTagIcon\"></ng-container>\n          <img src=\"{{ iconSrc }}\" class=\"tagIcon\" *ngIf=\"iconSrc\" />\n        </div>\n        <div\n          class=\"tagLabel\"\n          *ngIf=\"size !== 'small' && (label !== undefined || label !== null)\"\n        >\n          {{ label }}\n        </div>\n      </div>\n    </dxc-box>\n  </a>\n</div>\n<ng-template #dxcTagIcon\n  ><ng-content select=\"dxc-tag-icon\"></ng-content\n></ng-template>\n", components: [{ type: DxcBoxComponent, selector: "dxc-box", inputs: ["shadowDepth", "display", "margin", "padding", "size"] }], directives: [{ type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i4.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcTagComponent, decorators: [{
            type: Component,
            args: [{ selector: "dxc-tag", providers: [CssUtils], template: "<div\n  (mouseenter)=\"mouseEnter()\"\n  (mouseleave)=\"mouseLeave()\"\n  (click)=\"onClickHandler($event)\"\n>\n  <button\n    *ngIf=\"isClickDefined == true && linkHref == null\"\n    class=\"styledButton\"\n  >\n    <dxc-box [size]=\"size\" [shadowDepth]=\"shadowDepth\" #dxcBox>\n      <div class=\"tagContent\">\n        <div class=\"iconContainer\" #iconContainer>\n          <ng-container *ngTemplateOutlet=\"dxcTagIcon\"></ng-container>\n          <img src=\"{{ iconSrc }}\" class=\"tagIcon\" *ngIf=\"iconSrc\" />\n        </div>\n        <div\n          class=\"tagLabel\"\n          *ngIf=\"size !== 'small' && (label !== undefined || label !== null)\"\n        >\n          {{ label }}\n        </div>\n      </div>\n    </dxc-box>\n  </button>\n  <dxc-box\n    *ngIf=\"linkHref == null && isClickDefined == false\"\n    [size]=\"size\"\n    [shadowDepth]=\"shadowDepth\"\n    #dxcBox\n  >\n    <div class=\"tagContent\">\n      <div class=\"iconContainer\" #iconContainer>\n        <ng-container *ngTemplateOutlet=\"dxcTagIcon\"></ng-container>\n        <img src=\"{{ iconSrc }}\" class=\"tagIcon\" *ngIf=\"iconSrc\" />\n      </div>\n      <div\n        class=\"tagLabel\"\n        *ngIf=\"size !== 'small' && (label !== undefined || label !== null)\"\n      >\n        {{ label }}\n      </div>\n    </div>\n  </dxc-box>\n\n  <a\n    *ngIf=\"linkHref != null\"\n    [tabindex]=\"tabIndexValue\"\n    class=\"styledLink\"\n    href=\"{{ linkHref }}\"\n    [target]=\"newWindow ? '_blank' : '_self'\"\n  >\n    <dxc-box [size]=\"size\" [shadowDepth]=\"shadowDepth\" #dxcBox>\n      <div class=\"tagContent\">\n        <div class=\"iconContainer\" #iconContainer>\n          <ng-container *ngTemplateOutlet=\"dxcTagIcon\"></ng-container>\n          <img src=\"{{ iconSrc }}\" class=\"tagIcon\" *ngIf=\"iconSrc\" />\n        </div>\n        <div\n          class=\"tagLabel\"\n          *ngIf=\"size !== 'small' && (label !== undefined || label !== null)\"\n        >\n          {{ label }}\n        </div>\n      </div>\n    </dxc-box>\n  </a>\n</div>\n<ng-template #dxcTagIcon\n  ><ng-content select=\"dxc-tag-icon\"></ng-content\n></ng-template>\n" }]
        }], ctorParameters: function () { return [{ type: CssUtils }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { label: [{
                type: Input
            }], iconSrc: [{
                type: Input
            }], iconBgColor: [{
                type: Input
            }], labelPosition: [{
                type: Input
            }], linkHref: [{
                type: Input
            }], margin: [{
                type: Input
            }], newWindow: [{
                type: Input
            }], disabled: [{
                type: Input
            }], size: [{
                type: Input
            }], tabIndexValue: [{
                type: Input
            }], onClick: [{
                type: Output
            }], className: [{
                type: HostBinding,
                args: ["class"]
            }], dxcBox: [{
                type: ViewChildren,
                args: ["dxcBox", { read: ElementRef }]
            }], dxcTagIcon: [{
                type: ContentChildren,
                args: [DxcTagIconComponent]
            }], iconContainer: [{
                type: ViewChildren,
                args: ["iconContainer", { read: ElementRef }]
            }] } });

class DxcTagModule {
}
DxcTagModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcTagModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DxcTagModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcTagModule, declarations: [DxcTagComponent, DxcTagIconComponent], imports: [CommonModule, MatIconModule, DxcBoxModule], exports: [DxcTagComponent, DxcTagIconComponent] });
DxcTagModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcTagModule, imports: [[CommonModule, MatIconModule, DxcBoxModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcTagModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [DxcTagComponent, DxcTagIconComponent],
                    imports: [CommonModule, MatIconModule, DxcBoxModule],
                    exports: [DxcTagComponent, DxcTagIconComponent],
                    entryComponents: [DxcBoxComponent],
                }]
        }] });

class DxcProgressbarComponent {
    constructor(utils) {
        this.utils = utils;
        /**
         * Text to be placed above the progress bar.
         */
        this.label = "";
        this._showValue = false;
        this._overlay = false;
        this.isAbsolute = false;
        this.mode = "indeterminate";
        this.defaultInputs = new BehaviorSubject({
            overlay: false,
            margin: null,
            value: null,
            label: null,
            helperText: null,
            showValue: false,
        });
    }
    /**
     * If true, the value is displayed above the progress bar.
     */
    get showValue() {
        return this._showValue;
    }
    set showValue(value) {
        this._showValue = coerceBooleanProperty(value);
    }
    /**
     * If true, the progress bar will be displayed as a modal.
     */
    get overlay() {
        return this._overlay;
    }
    set overlay(value) {
        this._overlay = coerceBooleanProperty(value);
    }
    ngOnChanges(changes) {
        if (this.showValue) {
            this.mode = "determinate";
            if (this.value || this.value === 0) {
                if (this.value <= 100 && this.value >= 0) {
                    this.mode = "determinate";
                }
                else {
                    if (this.value > 100) {
                        this.mode = "determinate";
                        this.value = 100;
                    }
                    else if (this.value < 0) {
                        this.mode = "determinate";
                        this.value = 0;
                    }
                    else {
                        this.value = undefined;
                        this.mode = "indeterminate";
                    }
                }
            }
            else {
                this.value = 0;
            }
        }
        else {
            this.mode = "indeterminate";
        }
        if (this.overlay === true) {
            this.isAbsolute = true;
        }
        else {
            this.isAbsolute = false;
        }
        const inputs = Object.keys(changes).reduce((result, item) => {
            result[item] = changes[item].currentValue;
            return result;
        }, {});
        this.defaultInputs.next({ ...this.defaultInputs.getValue(), ...inputs });
        this.className = `${this.getDynamicStyle(this.defaultInputs.getValue())}`;
    }
    ngOnInit() {
        this.className = `${this.getDynamicStyle(this.defaultInputs.getValue())}`;
        if (this.value) {
            this.mode = "determinate";
        }
    }
    getDynamicStyle(inputs) {
        return css `
      ${this.utils.getMargins(inputs.margin)}
      display: block;
      height: auto;
      width: auto;
      .progressContainer {
        width: auto;
      }
      &.absolute {
        position: absolute;
        width: auto;
        margin: 0px;
        height: 100%;
        mat-progress-bar {
          width: 80%;
        }
        .labelContainer {
          width: 80%;
        }
        .backOverlay {
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          position: fixed;
          opacity: var(--progressBar-overlayOpacity);
          transition: opacity 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
          background-color: var(--progressBar-overlayColor);
        }
        .overlayed {
          height: 100%;
          justify-content: center;
          align-items: center;
          top: 0;
          left: 0;
          flex-direction: column;
          position: fixed;
          z-index: 3120;
          display: flex;
          width: 100%;
          .labelContainer .label,
          .labelContainer .value {
            color: var(--progressBar-labelFontColorOnDark);
          }
        }
      }
      mat-progress-bar {
        border-radius: var(--progressBar-borderRadius);
        height: var(--progressBar-thickness);
        z-index: 1;
        width: auto;
        margin-bottom: 8px;
        margin-top: 8px;
        .mat-progress-bar-fill::after {
          background-color: ${inputs.overlay
            ? `var(--progressBar-trackLineColorOnDark);`
            : `var(--progressBar-trackLineColor);`};
        }
        .mat-progress-bar-background {
          fill: transparent;
        }
      }
      .helperText {
        width: 80%;
        z-index: 1;
        font-family: var(--progressBar-helperTextFontFamily);
        font-size: var(--progressBar-helperTextFontSize);
        font-style: var(--progressBar-helperTextFontStyle);
        font-weight: var(--progressBar-helperTextFontWeight);
        color: ${inputs.overlay
            ? `var(--progressBar-helperTextFontColorOnDark);`
            : `var(--progressBar-helperTextFontColor);`};
      }
      .labelContainer {
        z-index: 1;
        width: auto;
        display: flex;
        .label {
          display: block;
          text-align: left;
          width: 95%;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          font-family: var(--progressBar-labelFontFamily);
          font-size: var(--progressBar-labelFontSize);
          font-style: var(--progressBar-labelFontStyle);
          font-weight: var(--progressBar-labelFontWeight);
          color: var(--progressBar-labelFontColor);
          text-transform: var(--progressBar-labelFontTextTransform);
        }
        .value {
          display: inline-flex;
          justify-content: flex-end;
          width: 5%;
          font-family: var(--progressBar-valueFontFamily);
          font-size: var(--progressBar-valueFontSize);
          font-style: var(--progressBar-valueFontStyle);
          font-weight: var(--progressBar-valueFontWeight);
          color: ${inputs.overlay
            ? `var(--progressBar-valueFontColorOnDark);`
            : `var(--progressBar-valueFontColor);`};
          text-transform: var(--progressBar-valueFontTextTransform);
        }
      }
      mat-progress-bar {
        .mat-progress-bar-buffer {
          background-color: var(--progressBar-totalLineColor);
        }
      }
    `;
    }
}
DxcProgressbarComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcProgressbarComponent, deps: [{ token: CssUtils }], target: i0.ɵɵFactoryTarget.Component });
DxcProgressbarComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.5", type: DxcProgressbarComponent, selector: "dxc-progressbar", inputs: { value: "value", label: "label", helperText: "helperText", showValue: "showValue", overlay: "overlay", margin: "margin" }, host: { properties: { "class": "this.className", "class.absolute": "this.isAbsolute" } }, providers: [CssUtils], usesOnChanges: true, ngImport: i0, template: "<div class=\"progressContainer\" [ngClass]=\"[overlay ? 'overlayed' : '']\">\n  <div class=\"backOverlay\" *ngIf=\"overlay\"></div>\n  <div class=\"labelContainer\" [ngClass]=\"[overlay ? '' : 'notOverlayed']\">\n    <span class=\"label\">{{ label }}</span>\n    <span class=\"value\" *ngIf=\"(value || value === 0) && showValue\"\n      >{{ value }}%</span\n    >\n  </div>\n  <mat-progress-bar value=\"{{ value }}\" mode=\"{{ mode }}\"></mat-progress-bar>\n  <span class=\"helperText\" *ngIf=\"helperText\">{{ helperText }}</span>\n</div>\n", components: [{ type: i2$2.MatProgressBar, selector: "mat-progress-bar", inputs: ["color", "mode", "value", "bufferValue"], outputs: ["animationEnd"], exportAs: ["matProgressBar"] }], directives: [{ type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcProgressbarComponent, decorators: [{
            type: Component,
            args: [{ selector: "dxc-progressbar", providers: [CssUtils], template: "<div class=\"progressContainer\" [ngClass]=\"[overlay ? 'overlayed' : '']\">\n  <div class=\"backOverlay\" *ngIf=\"overlay\"></div>\n  <div class=\"labelContainer\" [ngClass]=\"[overlay ? '' : 'notOverlayed']\">\n    <span class=\"label\">{{ label }}</span>\n    <span class=\"value\" *ngIf=\"(value || value === 0) && showValue\"\n      >{{ value }}%</span\n    >\n  </div>\n  <mat-progress-bar value=\"{{ value }}\" mode=\"{{ mode }}\"></mat-progress-bar>\n  <span class=\"helperText\" *ngIf=\"helperText\">{{ helperText }}</span>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: CssUtils }]; }, propDecorators: { value: [{
                type: Input
            }], label: [{
                type: Input
            }], helperText: [{
                type: Input
            }], showValue: [{
                type: Input
            }], overlay: [{
                type: Input
            }], margin: [{
                type: Input
            }], className: [{
                type: HostBinding,
                args: ["class"]
            }], isAbsolute: [{
                type: HostBinding,
                args: ["class.absolute"]
            }] } });

class DxcProgressbarModule {
}
DxcProgressbarModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcProgressbarModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DxcProgressbarModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcProgressbarModule, declarations: [DxcProgressbarComponent], imports: [CommonModule, MatProgressBarModule], exports: [DxcProgressbarComponent] });
DxcProgressbarModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcProgressbarModule, imports: [[CommonModule, MatProgressBarModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcProgressbarModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [DxcProgressbarComponent],
                    imports: [CommonModule, MatProgressBarModule],
                    exports: [DxcProgressbarComponent],
                }]
        }] });

class DxcRadioComponent {
    constructor(utils, bgProviderService) {
        this.utils = utils;
        this.bgProviderService = bgProviderService;
        /**
         * Whether the label should appear after or before the radio.
         */
        this.labelPosition = "before";
        /**
         * Name attribute of the input element.
         */
        this.name = "";
        this._disabled = false;
        this._required = false;
        /**
         * Size of the component.
         */
        this.size = "fitContent";
        this.darkBackground = false;
        this.lightBackground = true;
        this.defaultInputs = new BehaviorSubject({
            checked: false,
            value: null,
            label: null,
            labelPosition: "before",
            name: null,
            disabled: false,
            required: false,
            margin: null,
            size: "fitContent",
        });
        this.sizes = {
            small: "120px",
            medium: "240px",
            large: "480px",
            fillParent: "100%",
            fitContent: "unset",
        };
        this.onChange = new EventEmitter();
        this.bgProviderService.$changeColor.subscribe((value) => {
            if (value === "dark") {
                this.lightBackground = false;
                this.darkBackground = true;
            }
            else if (value === "light") {
                this.lightBackground = true;
                this.darkBackground = false;
            }
        });
    }
    /**
     * If true, the radio is selected. If undefined the component will be uncontrolled and
     * the value will be managed internally by the component.
     */
    get checked() {
        return this._checked;
    }
    set checked(value) {
        this._checked = coerceBooleanProperty(value);
    }
    /**
     * If true, the component will be disabled.
     */
    get disabled() {
        return this._disabled;
    }
    set disabled(value) {
        this._disabled = coerceBooleanProperty(value);
    }
    /**
     * If true, the radio will change its appearence, showing that the value is required.
     */
    get required() {
        return this._required;
    }
    set required(value) {
        this._required = coerceBooleanProperty(value);
    }
    ngOnChanges(changes) {
        this.renderedChecked = this.checked;
        this.labelPosition === "before" ? "before" : "after";
        const inputs = Object.keys(changes).reduce((result, item) => {
            result[item] = changes[item].currentValue;
            return result;
        }, {});
        this.defaultInputs.next({ ...this.defaultInputs.getValue(), ...inputs });
        this.className = `${this.getDynamicStyle(this.defaultInputs.getValue())}`;
    }
    calculateWidth(inputs) {
        if (inputs.size === "fillParent") {
            return this.utils.calculateWidth(this.sizes, inputs);
        }
        return css `
      width: ${this.sizes[inputs.size]};
    `;
    }
    ngOnInit() {
        this.renderedChecked = this.checked;
        this.className = `${this.getDynamicStyle(this.defaultInputs.getValue())}`;
    }
    onValueChange($event) {
        this.onChange.emit($event.source.checked);
        if (this.checked === undefined || this.checked === null) {
            this.renderedChecked = $event.source.checked;
        }
        else {
            $event.source.checked = this.renderedChecked;
            $event.source._inputElement.nativeElement.checked = this.renderedChecked;
        }
    }
    setTextAlign(labelPosition) {
        if (labelPosition === "before") {
            return css `
        text-align: end;
      `;
        }
    }
    getDynamicStyle(inputs) {
        return css `
      display: inline-flex;
      ${this.utils.getMargins(inputs.margin)}
      ${this.calculateWidth(inputs)}
      ${this.getDarkStyle()}
      ${this.getLightStyle()}
      mat-radio-button {
        width: 100%;
        height: 24px;
        .mat-radio-label {
          width: inherit;
          height: inherit;
          white-space: normal;
          display: inline-flex;
          align-items: center;
          .mat-radio-label-content {
            padding: 0px !important;
            width: calc(100% - 50px);
            ${this.setTextAlign(inputs.labelPosition)}
            font-family: var(--radio-fontFamily);
            font-size: var(--radio-fontSize);
            font-style: var(--radio-fontStyle);
            font-weight: var(--radio-fontWeight);
            width: 100%;
          }
          .mat-radio-required {
            margin-right: 1px;
          }
          .mat-radio-container {
            height: var(--radio-circleSize);
            width: var(--radio-circleSize);
            ${inputs.labelPosition === "after"
            ? css `
                  margin-right: var(--radio-circleLabelSpacing);
                `
            : inputs.labelPosition === "before"
                ? css `
                  margin-left: var(--radio-circleLabelSpacing);
                `
                : css ``}
            .mat-radio-frame {
              border-radius: 4px;
            }
            .mat-radio-outer-circle,
            .mat-radio-inner-circle {
              height: var(--radio-circleSize);
              width: var(--radio-circleSize);
            }
            .mat-ripple-element {
              background-color: transparent;
            }
          }
        }

        &.mat-radio-disabled {
          .mat-radio-label {
            cursor: not-allowed;
          }
        }
      }
    `;
    }
    getDarkStyle() {
        return css `
      &.dark {
        mat-radio-button {
          &.cdk-focused:not(.mat-radio-disabled) {
            .mat-radio-label {
              .mat-radio-container {
                .mat-radio-outer-circle {
                  outline: -webkit-focus-ring-color auto 2px;
                  outline-color: var(--radio-focusColorOnDark);
                  outline-offset: 2px;
                  outline-style: solid;
                }
              }
            }
          }
          .mat-radio-label-content {
            color: var(--radio-fontColorOnDark);
          }
          .mat-radio-container {
            .mat-radio-inner-circle {
              background-color: var(--radio-colorOnDark);
            }
            .mat-radio-outer-circle {
              border-color: var(--radio-colorOnDark);
            }
          }
          &.mat-radio-disabled {
            .mat-radio-label {
              .mat-radio-outer-circle {
                border-color: var(--radio-disabledColorOnDark);
              }
              .mat-radio-inner-circle {
                background-color: var(--radio-disabledColorOnDark);
              }
              .mat-radio-label-content {
                color: var(--radio-disabledFontColorOnDark);
              }
            }
          }
        }
      }
    `;
    }
    getLightStyle() {
        return css `
      &.light {
        mat-radio-button {
          &.cdk-focused:not(.mat-radio-disabled) {
            .mat-radio-label {
              .mat-radio-container {
                .mat-radio-outer-circle {
                  outline: -webkit-focus-ring-color auto 2px;
                  outline-color: var(--radio-focusColor);
                  outline-offset: 2px;
                  outline-style: solid;
                }
              }
            }
          }
          .mat-radio-label-content {
            color: var(--radio-fontColor);
          }
          .mat-radio-container {
            .mat-radio-inner-circle {
              background-color: var(--radio-color);
            }
            .mat-radio-outer-circle {
              border-color: var(--radio-color);
            }
          }
          &.mat-radio-disabled {
            .mat-radio-label {
              .mat-radio-outer-circle {
                border-color: var(--radio-disabledColor);
              }
              .mat-radio-inner-circle {
                background-color: var(--radio-disabledColor);
              }
              .mat-radio-label-content {
                color: var(--radio-disabledFontColor);
              }
            }
          }
        }
      }
    `;
    }
    ngOnDestroy() {
        this.utils = null;
    }
}
DxcRadioComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcRadioComponent, deps: [{ token: CssUtils }, { token: BackgroundProviderService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
DxcRadioComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.5", type: DxcRadioComponent, selector: "dxc-radio", inputs: { checked: "checked", value: "value", label: "label", labelPosition: "labelPosition", name: "name", disabled: "disabled", required: "required", margin: "margin", size: "size" }, outputs: { onChange: "onChange" }, host: { properties: { "class": "this.className", "class.dark": "this.darkBackground", "class.light": "this.lightBackground" } }, providers: [CssUtils], usesOnChanges: true, ngImport: i0, template: "<mat-radio-button\n  disableRipple\n  [labelPosition]=\"labelPosition ? labelPosition : 'after'\"\n  [disabled]=\"disabled\"\n  [name]=\"name\"\n  [required]=\"required\"\n  (change)=\"onValueChange($event)\"\n  [checked]=\"renderedChecked\"\n  [value]=\"value\"\n>\n  <span\n    *ngIf=\"label\"\n    [ngClass]=\"labelPosition === 'before' ? 'label-before' : 'label-after'\"\n  >\n    <span *ngIf=\"required\" class=\"mat-radio-required\">*</span>\n    <span>{{ label }}</span>\n  </span>\n</mat-radio-button>\n", components: [{ type: i3$2.MatRadioButton, selector: "mat-radio-button", inputs: ["disableRipple", "tabIndex"], exportAs: ["matRadioButton"] }], directives: [{ type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcRadioComponent, decorators: [{
            type: Component,
            args: [{ selector: "dxc-radio", providers: [CssUtils], template: "<mat-radio-button\n  disableRipple\n  [labelPosition]=\"labelPosition ? labelPosition : 'after'\"\n  [disabled]=\"disabled\"\n  [name]=\"name\"\n  [required]=\"required\"\n  (change)=\"onValueChange($event)\"\n  [checked]=\"renderedChecked\"\n  [value]=\"value\"\n>\n  <span\n    *ngIf=\"label\"\n    [ngClass]=\"labelPosition === 'before' ? 'label-before' : 'label-after'\"\n  >\n    <span *ngIf=\"required\" class=\"mat-radio-required\">*</span>\n    <span>{{ label }}</span>\n  </span>\n</mat-radio-button>\n" }]
        }], ctorParameters: function () { return [{ type: CssUtils }, { type: BackgroundProviderService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { checked: [{
                type: Input
            }], value: [{
                type: Input
            }], label: [{
                type: Input
            }], labelPosition: [{
                type: Input
            }], name: [{
                type: Input
            }], disabled: [{
                type: Input
            }], required: [{
                type: Input
            }], onChange: [{
                type: Output
            }], margin: [{
                type: Input
            }], size: [{
                type: Input
            }], className: [{
                type: HostBinding,
                args: ["class"]
            }], darkBackground: [{
                type: HostBinding,
                args: ["class.dark"]
            }], lightBackground: [{
                type: HostBinding,
                args: ["class.light"]
            }] } });

class DxcRadioModule {
}
DxcRadioModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcRadioModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DxcRadioModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcRadioModule, declarations: [DxcRadioComponent], imports: [CommonModule, FormsModule, MatRadioModule], exports: [DxcRadioComponent] });
DxcRadioModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcRadioModule, imports: [[CommonModule, FormsModule, MatRadioModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcRadioModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [DxcRadioComponent],
                    imports: [CommonModule, FormsModule, MatRadioModule],
                    exports: [DxcRadioComponent],
                }]
        }] });

class DxcSelectHelper {
    constructor(utils) {
        this.utils = utils;
        this.sizes = {
            small: "240px",
            medium: "360px",
            large: "480px",
            fillParent: "100%",
        };
    }
    calculateWidth(inputs) {
        if (inputs.size === "fillParent") {
            return this.utils.calculateWidth(this.sizes, inputs);
        }
        return css `
      width: ${this.sizes[inputs.size]};
    `;
    }
    getDynamicStyle(inputs) {
        return css `
      display: flex;
      flex-direction: column;
      ${this.utils.getMargins(inputs.margin)}
      ${this.calculateWidth(inputs)}
      .container {
        background: ${inputs.disabled
            ? "var(--select-disabledInputBackgroundColor) 0% 0% no-repeat padding-box"
            : "#ffffff 0% 0% no-repeat padding-box"};
        border: 1px solid;
        border-color: ${inputs.disabled
            ? "var(--select-disabledInputBorderColor)"
            : inputs.error
                ? "transparent"
                : "var(--select-enabledInputBorderColor)"};
        ${inputs.error && !inputs.disabled
            ? "box-shadow: inset 0 0 0 2px var(--select-errorInputBorderColor);"
            : ""}
        border-radius: 0.25rem;
        opacity: 1;
        width: 100%;
        padding: 8px;
        box-sizing: border-box;
        position: relative;
        display: flex;
        align-items: center;
        height: 40px;
        outline: 0;
        cursor: ${inputs.disabled ? "not-allowed" : "pointer"};
        justify-content: space-between;
        margin-top: 4px;
        margin-bottom: 4px;
        :hover {
          ${!inputs.error && !inputs.disabled
            ? "border: 1px solid var(--select-hoverInputBorderColor);"
            : ""}
        }
        :focus-within {
          ${!inputs.disabled
            ? "border-color: transparent; box-shadow: inset 0 0 0 2px var(--select-focusInputBorderColor);"
            : ""}
        }
        .valueContainer {
          &.noValuesSelected {
            display: none;
          }
          display: flex;
          flex-direction: row;
          width: ${inputs.searchable && inputs.multiple ? "" : "100%"};
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: ${inputs.searchable && inputs.multiple ? "" : "hidden"};
          .numberOfSelected {
            display: flex;
            width: 50px;
            .sizeContainer {
              width: 24px;
              height: 22px;
              background: var(--select-selectionIndicatorBackgroundColor) 0% 0%
                no-repeat padding-box;
              display: flex;
              justify-content: center;
              text-align: left;
              font: normal normal 600 11px/15px Open Sans;
              letter-spacing: 0.98px;
              color: var(--select-selectionIndicatorFontColor);
              border-bottom-left-radius: 0.125rem;
              border-top-left-radius: 0.125rem;
              align-items: center;
              border-left: 1px solid var(--select-selectionIndicatorBorderColor);
              border-top: 1px solid var(--select-selectionIndicatorBorderColor);
              border-bottom: 1px solid
                var(--select-selectionIndicatorBorderColor);
            }
            .removeContainer {
              width: 24px;
              height: 22px;
              background: var(
                  --select-enabledSelectionIndicatorActionBackgroundColor
                )
                0% 0% no-repeat padding-box;
              border: 1px solid var(--select-selectionIndicatorBorderColor);
              display: flex;
              justify-content: center;
              text-align: left;
              font: normal normal 600 11px/15px Open Sans;
              letter-spacing: 0.98px;
              color: var(--select-selectionIndicatorFontColor);
              border-bottom-right-radius: 0.125rem;
              border-top-right-radius: 0.125rem;
              align-items: center;
              outline: none;
              svg {
                height: 16px;
                width: 16px;
                fill: var(--select-enabledSelectionIndicatorActionIconColor);
              }
              &:hover {
                background: var(
                  --select-hoverSelectionIndicatorActionBackgroundColor
                );
                svg {
                  fill: var(--select-hoverSelectionIndicatorActionIconColor);
                }
              }
              &:active {
                background: var(
                  --select-activeSelectionIndicatorActionBackgroundColor
                );
                svg {
                  fill: var(--select-activeSelectionIndicatorActionIconColor);
                }
              }
            }
          }
          .selectedOptionContainer {
            margin-left: 8px;
            width: ${inputs.multiple
            ? "calc(100% - 58px)"
            : "calc(100% - 8px)"};
          }
        }
        .iconsContainer {
          display: flex;
          flex-direction: row;
          align-items: center;
          .errorIcon {
            height: 18px;
            width: 18px;
            margin-right: 8px;
            display: flex;
            align-items: center;
            justify-content: center;
            pointer-events: none;
            color: var(--select-errorIconColor);
            svg {
              line-height: 18px;
              height: 18px;
              width: 18px;
            }
          }
          .collapseIndicator {
            display: flex;
            transform: rotate(0deg);
            height: 24px;
            width: 24px;
            align-items: center;
            justify-content: center;
            margin-left: 0.25rem;
            &.opened {
              transform: rotate(180deg);
            }
            svg {
              height: 16px;
              width: 16px;
              fill: ${!inputs.disabled
            ? "var(--select-collapseIndicatorColor)"
            : "var(--select-disabledColor)"};
            }
          }
        }
        .searchContainer {
          overflow: hidden;
          display: flex;
          flex-direction: row;
          width: 100%;
          align-items: center;
          margin-left: 8px;
          .searchGrid {
            width: 100%;
            display: flex;
            input {
              border: none;
              width: 100%;
              padding: 0px;
              height: 100%;
              text-align: left;
              font-family: var(--select-fontFamily);
              font-size: var(--select-valueFontSize);
              font-style: var(--select-valueFontStyle);
              font-weight: var(--select-valueFontWeight);
              line-height: var(--select-valueLineHeight);
              color: ${inputs.disabled
            ? "var(--select-disabledColor)"
            : "var(--select-valueFontColor)"};
              :focus-visible,
              :focus,
              :focus-within {
                outline: none;
              }
              &.hiddenInput {
                visibility: hidden;
              }
              ::placeholder {
                font-family: var(--select-fontFamily);
                font-size: var(--select-placeholderFontSize);
                font-style: var(--select-placeholderFontStyle);
                font-weight: var(--select-placeholderFontWeight);
                color: ${inputs.disabled
            ? "var(--select-disabledColor)"
            : "var(--select-placeholderFontColor)"};
              }
            }
            input:placeholder-shown {
              text-overflow: ellipsis;
            }
          }
          .inputClear {
            height: 24px;
            max-width: 24px;
            padding: 3px;
            font-size: 1rem;
            font-family: var(--select-fontFamily);
            border: 2px solid transparent;
            border-radius: 4px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            background-color: var(--select-actionBackgroundColor);
            color: var(--select-actionIconColor);
            &:hover {
              background-color: var(--select-hoverActionBackgroundColor);
              color: var(--select-hoverActionIconColor);
            }
            &:active {
              background-color: var(--select-activeActionBackgroundColor);
              color: var(--select-activeActionIconColor);
            }
            svg {
              line-height: 18px;
            }
          }
        }
      }
      .options {
        left: 0;
        margin-top: 0.25rem;
        margin-bottom: 0.25rem;
        top: 100%;
        overflow: auto;
        overflow-x: hidden;
        box-shadow: inset 0 4px 6px -1px rgba(0, 0, 0, 0.1);
        background: var(--select-listDialogBackgroundColor) 0% 0% no-repeat
          padding-box;
        border: 1px solid var(--select-listDialogBorderColor);
        border-radius: 4px;
        opacity: 1;
        width: inherit;
        box-sizing: border-box;
        position: relative;
        display: flex;
        flex-direction: column;
        padding: 0.5rem 0px;
        position: absolute;
        z-index: 100;
        max-height: 312px;
        li {
          list-style-type: none;
          text-align: left;
          font: normal normal normal 14px/19px Open Sans;
          letter-spacing: 0px;
          color: #000000;
          opacity: 1;
          display: flex;
          align-items: center;
          box-sizing: border-box;
          width: 100%;
          .optionsGroup {
            position: relative;
            display: flex;
            flex-direction: column;
            padding: 0px;
            width: 100%;
            .groupLabelElement {
              padding-left: 16px;
              text-align: left;
              height: 32px;
              display: flex;
              align-items: center;
              cursor: default;
              font-weight: var(--select-listGroupLabelFontWeight);
              line-height: 1.715em;
            }
            .optionLabel {
              padding: 2px 0px 2px 14px;
            }
          }
          &.lastItem .optionsGroup li.lastItemGroup,
          &.lastItem > dxc-select-option {
            .optionLabel {
              border-bottom: none;
            }
          }
          &.resultsNotFound {
            width: 100%;
            display: flex;
            align-items: center;
            height: 28px;
            flex-direction: row;
            padding: 0px 16px;
            box-sizing: border-box;
            cursor: default;
            .notFoundIcon {
              height: 100%;
              align-items: center;
              width: 24px;
              justify-content: center;
              margin-right: 4px;
              display: flex;
              svg {
                fill: var(--select-systemMessageFontColor);
                height: 18px;
                width: 18px;
              }
            }
            span.systemMessage {
              color: var(--select-systemMessageFontColor);
            }
          }
          .optionalContainer {
            width: 100%;
            height: 100%;
            :hover {
              background-color: #f2f2f2;
              cursor: pointer;
            }
            .optionalLabel {
              width: 100%;
              height: 32px;
              flex-direction: row;
              margin-left: 16px;
              margin-right: 16px;
              padding-top: 4px;
              padding-bottom: 4px;
              box-sizing: border-box;
              border-bottom: 1px solid var(--select-listItemDividerColor);
              display: flex;
              align-items: center;
            }
          }
        }
      }
      .inputLabel {
        font-family: var(--select-fontFamily);
        font-size: var(--select-labelFontSize);
        font-style: var(--select-labelFontStyle);
        font-weight: var(--select-labelFontWeight);
        color: ${inputs.disabled
            ? "var(--select-disabledColor)"
            : "var(--select-labelFontColor)"};
        line-height: var(--select-labelLineHeight);
      }
      .optional {
        font-family: var(--select-fontFamily);
        font-size: var(--select-labelFontSize);
        font-style: var(--select-labelFontStyle);
        font-weight: var(--select-optionalLabelFontWeight);
        color: ${inputs.disabled
            ? "var(--select-disabledColor)"
            : "var(--select-labelFontColor)"};
        line-height: var(--select-labelLineHeight);
      }
      .helperText {
        font-family: var(--select-fontFamily);
        font-size: var(--select-helperTextFontSize);
        font-style: var(--select-helperTextFontStyle);
        font-weight: var(--select-helperTextFontWeight);
        color: ${inputs.disabled
            ? "var(--select-disabledColor)"
            : "var(--select-helperTextFontColor)"};
        line-height: var(--select-helperTextLineHeight);
      }
      .errorMessage {
        font-family: var(--select-fontFamily);
        font-size: var(--select-errorMessageFontSize);
        font-style: var(--select-errorMessagetFontStyle);
        font-weight: var(--select-errorMessageFontWeight);
        color: ${inputs.disabled
            ? "var(--select-disabledColor)"
            : "var(--select-errorMessageColor)"};
        line-height: var(--select-errorMessagetLineHeight);
        min-height: 18px;
      }
    `;
    }
}
DxcSelectHelper.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcSelectHelper, deps: [{ token: CssUtils }], target: i0.ɵɵFactoryTarget.Injectable });
DxcSelectHelper.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcSelectHelper });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcSelectHelper, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: CssUtils }]; } });

class SelectService {
    constructor() {
        this.selectedValues = new BehaviorSubject(null);
        this.filteredOptions = new BehaviorSubject(null);
        this.visualFocused = new BehaviorSubject({
            group: -1,
            option: -1,
        });
        this.activeOption = new BehaviorSubject({
            group: -1,
            option: -1,
        });
    }
    setSelectedValues(newOptions) {
        this.selectedValues.next(newOptions ?? null);
    }
    setVisualFocused(newFocus) {
        this.visualFocused.next(newFocus);
    }
    getSizeSelectedValues() {
        if (this.selectedValues.getValue() != null &&
            this.selectedValues.getValue() != undefined) {
            return this.selectedValues.getValue().length;
        }
        return 0;
    }
    getSelectedValues() {
        return this.selectedValues.getValue();
    }
    setFilteredOptions(array) {
        this.filteredOptions.next(array);
    }
    onArrowDown(optional, isDirty) {
        if (!isDirty &&
            this.getSelectedValues() !== undefined &&
            this.getSelectedValues() !== null) {
            this.setSelectedFocus();
        }
        else {
            if (this.filteredOptions &&
                this.filteredOptions.getValue() &&
                this.instanceOfOption(this.filteredOptions.getValue()[0])) {
                this.arrowDownOptions(optional);
            }
            else if (this.filteredOptions &&
                this.filteredOptions.getValue() &&
                !this.instanceOfOption(this.filteredOptions.getValue()[0])) {
                this.arrowDownGroups(optional);
            }
        }
    }
    setSelectedFocus() {
        if (this.instanceOfOption(this.filteredOptions.getValue()[0])) {
            this.visualFocused.next({
                option: this.visualFocused.getValue().option,
            });
        }
        else {
            this.visualFocused.next({
                option: this.visualFocused.getValue().option,
                group: this.visualFocused.getValue().group,
            });
        }
    }
    arrowDownOptions(optional) {
        const arrayOption = this.filteredOptions.getValue();
        if (this.visualFocused.getValue().option < arrayOption.length - 1) {
            this.visualFocused.next({
                option: this.visualFocused.getValue().option + 1,
            });
        }
        else if (this.visualFocused.getValue().option ===
            arrayOption.length - 1) {
            this.visualFocused.next({
                option: optional ? -1 : 0,
            });
        }
        if (this.activeOption.getValue().option > 0) {
            this.activeOption.next({
                option: -1,
            });
        }
    }
    arrowDownGroups(optional) {
        const arrayOption = this.filteredOptions.getValue();
        if (this.visualFocused.getValue().group <= -1 &&
            this.visualFocused.getValue().option <= -1) {
            this.visualFocused.next({
                group: this.visualFocused.getValue().option + 1,
                option: this.visualFocused.getValue().option + 1,
            });
        }
        else if (this.visualFocused.getValue().group === arrayOption.length - 1 &&
            this.visualFocused.getValue().option ===
                arrayOption[this.visualFocused.getValue().group].options.length - 1) {
            this.visualFocused.next({
                group: optional ? -1 : 0,
                option: optional ? -1 : 0,
            });
        }
        else {
            if (this.visualFocused.getValue().option <
                arrayOption[this.visualFocused.getValue().group].options.length - 1) {
                this.visualFocused.next({
                    group: this.visualFocused.getValue().group,
                    option: this.visualFocused.getValue().option + 1,
                });
            }
            else {
                this.visualFocused.next({
                    group: this.visualFocused.getValue().group + 1,
                    option: 0,
                });
            }
        }
    }
    onArrowUp(optional, isDirty) {
        if (!isDirty &&
            this.getSelectedValues() !== undefined &&
            this.getSelectedValues() !== null) {
            this.setSelectedFocus();
        }
        else {
            if (this.filteredOptions &&
                this.filteredOptions.getValue() &&
                this.instanceOfOption(this.filteredOptions.getValue()[0])) {
                this.arrowUpOptions(optional);
            }
            else if (this.filteredOptions &&
                this.filteredOptions.getValue() &&
                !this.instanceOfOption(this.filteredOptions.getValue()[0])) {
                this.arrowUpGroups(optional);
            }
        }
    }
    arrowUpOptions(optional) {
        const arrayOption = this.filteredOptions.getValue();
        if (this.visualFocused.getValue().option > 0) {
            this.visualFocused.next({
                option: this.visualFocused.getValue().option - 1,
            });
        }
        else if (this.visualFocused.getValue().option === 0) {
            this.visualFocused.next({
                option: optional ? -1 : arrayOption.length - 1,
            });
        }
        else if (this.visualFocused.getValue().option < 0) {
            this.visualFocused.next({ option: arrayOption.length - 1 });
        }
        if (this.activeOption.getValue().option > 0) {
            this.activeOption.next({
                option: -1,
            });
        }
    }
    arrowUpGroups(optional) {
        const arrayOption = this.filteredOptions.getValue();
        if (this.visualFocused.getValue().group <= -1 &&
            this.visualFocused.getValue().option <= -1) {
            this.visualFocused.next({
                group: arrayOption.length - 1,
                option: arrayOption[arrayOption.length - 1].options.length - 1,
            });
        }
        else if (this.visualFocused.getValue().group === 0 &&
            this.visualFocused.getValue().option === 0) {
            this.visualFocused.next({
                group: optional ? -1 : arrayOption.length - 1,
                option: optional
                    ? -1
                    : arrayOption[arrayOption.length - 1].options.length - 1,
            });
        }
        else {
            if (this.visualFocused.getValue().option > 0) {
                this.visualFocused.next({
                    group: this.visualFocused.getValue().group,
                    option: this.visualFocused.getValue().option - 1,
                });
            }
            else {
                this.visualFocused.next({
                    group: this.visualFocused.getValue().group - 1,
                    option: arrayOption[this.visualFocused.getValue().group - 1].options
                        .length - 1,
                });
            }
        }
    }
    instanceOfOption(option) {
        return "value" in option;
    }
}
SelectService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: SelectService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
SelectService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: SelectService, providedIn: "root" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: SelectService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: "root",
                }]
        }], ctorParameters: function () { return []; } });

class DxcSelectOptionSelectedComponent {
    constructor(service) {
        this.service = service;
        this.selectedOptions = "";
        this.array = [];
        this.defaultInputs = new BehaviorSubject({
            multiple: false,
            disabled: false,
        });
        this.subscriptor = this.service.selectedValues.subscribe((newOptions) => {
            if (newOptions) {
                this.selectedOptions = "";
                if (Array.isArray(newOptions)) {
                    this.array = newOptions;
                    newOptions.forEach((option, index) => {
                        if (index === 0) {
                            this.selectedOptions = option.label;
                        }
                        else {
                            this.selectedOptions = this.selectedOptions + ", " + option.label;
                        }
                    });
                }
                else {
                    this.array[0] = newOptions;
                    this.selectedOptions = newOptions.label;
                }
            }
            else {
                this.selectedOptions = "";
            }
        });
    }
    ngOnChanges(changes) {
        this.setPlaceholder();
        const inputs = Object.keys(changes).reduce((result, item) => {
            result[item] = changes[item].currentValue;
            return result;
        }, {});
        this.defaultInputs.next({ ...this.defaultInputs.getValue(), ...inputs });
        this.className = `${this.getDynamicStyle({
            ...this.defaultInputs.getValue(),
        })}`;
    }
    ngOnInit() {
        this.setPlaceholder();
        this.className = `${this.getDynamicStyle({
            ...this.defaultInputs.getValue(),
        })}`;
    }
    setPlaceholder() {
        if (this.multiple) {
            if (!this.placeholder) {
                this.placeholder = "Choose options";
            }
        }
        else {
            if (!this.placeholder) {
                this.placeholder = "Choose an option";
            }
        }
    }
    isOptionalLabel() {
        return !this.multiple && this.array[0]?.value === "";
    }
    getDynamicStyle(inputs) {
        return css `
      display: flex;
      max-width: 100%;
      width: 100%;
      div.labelsContainer {
        width: 100%;
        .selectedOption {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          display: block;
          width: 100%;
          font-family: var(--select-fontFamily);
          font-size: var(--select-valueFontSize);
          font-style: var(--select-valueFontStyle);
          font-weight: var(--select-valueFontWeight);
          color: ${inputs.disabled
            ? "var(--select-disabledColor)"
            : "var(--select-valueFontColor)"};
          &.isOptionalLabel {
            color: ${inputs.disabled
            ? "var(--select-disabledColor)"
            : "#000000b3"};
          }
        }
        .notSelectedLabel {
          text-align: left;
          white-space: nowrap;
          font-family: var(--select-fontFamily);
          font-size: var(--select-placeholderFontSize);
          font-style: var(--select-placeholderFontStyle);
          font-weight: var(--select-placeholderFontWeight);
          color: ${inputs.disabled
            ? "var(--select-disabledColor)"
            : "var(--select-placeholderFontColor)"};
        }
      }
    `;
    }
    ngOnDestroy() {
        if (this.subscriptor) {
            this.subscriptor.unsubscribe();
        }
    }
}
DxcSelectOptionSelectedComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcSelectOptionSelectedComponent, deps: [{ token: SelectService }], target: i0.ɵɵFactoryTarget.Component });
DxcSelectOptionSelectedComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.5", type: DxcSelectOptionSelectedComponent, selector: "dxc-select-option-selected", inputs: { multiple: "multiple", disabled: "disabled", searchable: "searchable", placeholder: "placeholder" }, host: { properties: { "class": "this.className" } }, usesOnChanges: true, ngImport: i0, template: "<div class=\"labelsContainer\" #labelsContainer>\n  <ng-container *ngIf=\"!(multiple && searchable)\">\n    <span\n      class=\"selectedOption\"\n      [ngClass]=\"{\n        isOptionalLabel: isOptionalLabel()\n      }\"\n    >\n      {{ selectedOptions }}\n    </span>\n  </ng-container>\n\n  <span\n    *ngIf=\"service.getSizeSelectedValues() == 0 || (multiple && searchable)\"\n    class=\"notSelectedLabel\"\n  >\n    {{ placeholder }}\n  </span>\n</div>\n", directives: [{ type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcSelectOptionSelectedComponent, decorators: [{
            type: Component,
            args: [{ selector: "dxc-select-option-selected", template: "<div class=\"labelsContainer\" #labelsContainer>\n  <ng-container *ngIf=\"!(multiple && searchable)\">\n    <span\n      class=\"selectedOption\"\n      [ngClass]=\"{\n        isOptionalLabel: isOptionalLabel()\n      }\"\n    >\n      {{ selectedOptions }}\n    </span>\n  </ng-container>\n\n  <span\n    *ngIf=\"service.getSizeSelectedValues() == 0 || (multiple && searchable)\"\n    class=\"notSelectedLabel\"\n  >\n    {{ placeholder }}\n  </span>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: SelectService }]; }, propDecorators: { className: [{
                type: HostBinding,
                args: ["class"]
            }], multiple: [{
                type: Input
            }], disabled: [{
                type: Input
            }], searchable: [{
                type: Input
            }], placeholder: [{
                type: Input
            }] } });

class DxcSelectOptionComponent {
    constructor(service) {
        this.service = service;
        this.selected = false;
        this.isfocused = false;
        this.optionClick = new EventEmitter();
        this.optionMouseDown = new EventEmitter();
        this.defaultInputs = new BehaviorSubject({
            option: null,
            multiple: false,
            checked: null,
            optional: false,
        });
        this.isValueSelected = (value) => this.service.getSelectedValues() &&
            this.service.getSelectedValues().includes(value);
    }
    ngOnChanges(changes) {
        this.isfocused = this.focused;
        const inputs = Object.keys(changes).reduce((result, item) => {
            result[item] = changes[item].currentValue;
            return result;
        }, {});
        this.defaultInputs.next({ ...this.defaultInputs.getValue(), ...inputs });
        this.className = `${this.getDynamicStyle({
            ...this.defaultInputs.getValue(),
        })}`;
    }
    ngOnInit() {
        this.className = `${this.getDynamicStyle({
            ...this.defaultInputs.getValue(),
        })}`;
        this.service.selectedValues.subscribe((selectedValues) => {
            this.selected = this.isSelected(selectedValues);
        });
    }
    handleOptionClick(event) {
        this.optionClick.emit(event);
    }
    handleOptionMouseDown(event) {
        this.optionMouseDown.emit(event);
    }
    isSelected(selectedValues) {
        if (!this.multiple) {
            return selectedValues?.value === this.option.value ? true : false;
        }
        else {
            if (this.service.getSizeSelectedValues() > 0) {
                const selected = selectedValues.find((op) => op.value === this.option.value);
                return selected !== null && selected !== undefined;
            }
            else
                return false;
        }
    }
    setSelectedStyles() {
        return css `
      background-color: var(--select-selectedListOptionBackgroundColor);
      :hover {
        background-color: var(--select-selectedHoverListOptionBackgroundColor);
      }
      :active {
        background-color: var(--select-selectedActiveListOptionBackgroundColor);
      }
    `;
    }
    getDynamicStyle(inputs) {
        return css `
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      height: 32px;
      :hover {
        cursor: pointer;
        background-color: var(
          --select-unselectedHoverListOptionBackgroundColor
        );
      }
      :active {
        background-color: var(
          --select-unselectedActiveListOptionBackgroundColor
        );
      }
      ${inputs.checked && inputs.multiple ? this.setSelectedStyles() : ""}
      &.selected {
        ${this.setSelectedStyles()}
        &.focused {
          background-color: var(
            --select-selectedHoverListOptionBackgroundColor
          );
        }
        .optionLabel {
          border-bottom: 1px solid transparent;
        }
      }
      &.focused {
        box-shadow: inset 0 0 0 2px var(--select-focusListOptionBorderColor);
        .optionLabel {
          border-bottom: 1px solid transparent;
        }
      }
      .optionLabel {
        display: flex;
        flex-direction: row;
        width: 100%;
        margin: 2px 8px;
        height: 100%;
        box-sizing: border-box;
        border-bottom: 1px solid var(--select-listOptionDividerColor);
        overflow: hidden;
        .iconLabel {
          display: flex;
          align-items: center;
          margin-left: ${!inputs.multiple ? "8px" : ""};
          svg {
            fill: var(--select-listOptionIconColor);
          }
        }
        .label {
          width: 100%;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          display: inline-block;
          align-self: center;
          margin-left: 0.5rem;
          margin-right: 0.5rem;
          span {
            width: 100%;
            height: 100%;
            font-family: var(--select-fontFamily);
            font-size: var(--select-listOptionFontSize);
            font-style: var(--select-listOptionFontStyle);
            font-weight: var(--select-listOptionFontWeight);
            color: var(--select-listOptionFontColor);
          }
        }
        .checkIcon {
          display: flex;
          margin-right: 0.5rem;
          align-items: center;
          svg {
            fill: var(--select-selectedListOptionIconColor);
            width: 16px;
            height: 16px;
          }
        }
      }
      .checkboxContainer {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        div {
          display: flex;
          overflow: hidden;
        }
        dxc-checkbox {
          .mat-checkbox-label {
            span:last-child {
              display: inline-grid;
              .checkboxLabel {
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                display: block;
                width: 100%;
              }
            }
          }
        }
      }
    `;
    }
}
DxcSelectOptionComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcSelectOptionComponent, deps: [{ token: SelectService }], target: i0.ɵɵFactoryTarget.Component });
DxcSelectOptionComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.5", type: DxcSelectOptionComponent, selector: "dxc-select-option", inputs: { option: "option", multiple: "multiple", checked: "checked", focused: "focused", optional: "optional" }, outputs: { optionClick: "optionClick", optionMouseDown: "optionMouseDown" }, host: { properties: { "class": "this.className", "class.selected": "this.selected", "class.focused": "this.isfocused" } }, usesOnChanges: true, ngImport: i0, template: "<div\n  #optionRef\n  *ngIf=\"option.value && !multiple\"\n  class=\"optionLabel\"\n  (click)=\"handleOptionClick($event)\"\n  (mousedown)=\"handleOptionMouseDown($event)\"\n  tabindex=\"-1\"\n>\n  <div\n    *ngIf=\"option.icon\"\n    class=\"iconLabel\"\n    [innerHTML]=\"option.icon | safeHtml\"\n  ></div>\n  <span class=\"label\"\n    ><span [attr.aria-selected]=\"this.selected\" role=\"option\">{{\n      option.label\n    }}</span></span\n  >\n  <span\n    class=\"checkIcon\"\n    *ngIf=\"\n      !multiple && this.service.getSelectedValues()?.value === option.value\n    \"\n  >\n    <svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"#000000\">\n      <path d=\"M0 0h24v24H0z\" fill=\"none\" />\n      <path d=\"M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z\" />\n    </svg>\n  </span>\n</div>\n\n<div\n  #optionRef\n  *ngIf=\"optional && !multiple\"\n  class=\"optionLabel\"\n  (click)=\"handleOptionClick($event)\"\n  (mousedown)=\"handleOptionMouseDown($event)\"\n  tabindex=\"-1\"\n>\n  <span class=\"label\"\n    ><span [attr.aria-selected]=\"this.selected\" role=\"option\">{{\n      option.label\n    }}</span></span\n  >\n  <span\n    class=\"checkIcon\"\n    *ngIf=\"\n      !multiple && this.service.getSelectedValues()?.value === option.value\n    \"\n  >\n    <svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"#000000\">\n      <path d=\"M0 0h24v24H0z\" fill=\"none\" />\n      <path d=\"M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z\" />\n    </svg>\n  </span>\n</div>\n\n<span\n  *ngIf=\"option.value && multiple\"\n  (click)=\"handleOptionClick($event)\"\n  (mousedown)=\"handleOptionMouseDown($event)\"\n  class=\"checkboxContainer optionLabel\"\n>\n  <dxc-checkbox\n    [label]=\"\n      option.icon === undefined || option.icon === null ? option.label : ''\n    \"\n    labelPosition=\"after\"\n    [checked]=\"checked\"\n    tabIndexValue=\"-1\"\n  >\n  </dxc-checkbox>\n  <div *ngIf=\"option.icon !== undefined && option.icon !== null\">\n    <span class=\"iconLabel\" [innerHTML]=\"option.icon | safeHtml\"></span>\n    <span class=\"label\"\n      ><span [attr.aria-selected]=\"this.selected\" role=\"option\">{{\n        option.label\n      }}</span></span\n    >\n  </div>\n</span>\n", components: [{ type: DxcCheckboxComponent, selector: "dxc-checkbox", inputs: ["checked", "defaultChecked", "value", "label", "labelPosition", "name", "disabled", "required", "tabIndexValue", "margin", "size", "id"], outputs: ["onChange"] }], directives: [{ type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], pipes: { "safeHtml": SafeHTMLPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcSelectOptionComponent, decorators: [{
            type: Component,
            args: [{ selector: "dxc-select-option", template: "<div\n  #optionRef\n  *ngIf=\"option.value && !multiple\"\n  class=\"optionLabel\"\n  (click)=\"handleOptionClick($event)\"\n  (mousedown)=\"handleOptionMouseDown($event)\"\n  tabindex=\"-1\"\n>\n  <div\n    *ngIf=\"option.icon\"\n    class=\"iconLabel\"\n    [innerHTML]=\"option.icon | safeHtml\"\n  ></div>\n  <span class=\"label\"\n    ><span [attr.aria-selected]=\"this.selected\" role=\"option\">{{\n      option.label\n    }}</span></span\n  >\n  <span\n    class=\"checkIcon\"\n    *ngIf=\"\n      !multiple && this.service.getSelectedValues()?.value === option.value\n    \"\n  >\n    <svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"#000000\">\n      <path d=\"M0 0h24v24H0z\" fill=\"none\" />\n      <path d=\"M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z\" />\n    </svg>\n  </span>\n</div>\n\n<div\n  #optionRef\n  *ngIf=\"optional && !multiple\"\n  class=\"optionLabel\"\n  (click)=\"handleOptionClick($event)\"\n  (mousedown)=\"handleOptionMouseDown($event)\"\n  tabindex=\"-1\"\n>\n  <span class=\"label\"\n    ><span [attr.aria-selected]=\"this.selected\" role=\"option\">{{\n      option.label\n    }}</span></span\n  >\n  <span\n    class=\"checkIcon\"\n    *ngIf=\"\n      !multiple && this.service.getSelectedValues()?.value === option.value\n    \"\n  >\n    <svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"#000000\">\n      <path d=\"M0 0h24v24H0z\" fill=\"none\" />\n      <path d=\"M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z\" />\n    </svg>\n  </span>\n</div>\n\n<span\n  *ngIf=\"option.value && multiple\"\n  (click)=\"handleOptionClick($event)\"\n  (mousedown)=\"handleOptionMouseDown($event)\"\n  class=\"checkboxContainer optionLabel\"\n>\n  <dxc-checkbox\n    [label]=\"\n      option.icon === undefined || option.icon === null ? option.label : ''\n    \"\n    labelPosition=\"after\"\n    [checked]=\"checked\"\n    tabIndexValue=\"-1\"\n  >\n  </dxc-checkbox>\n  <div *ngIf=\"option.icon !== undefined && option.icon !== null\">\n    <span class=\"iconLabel\" [innerHTML]=\"option.icon | safeHtml\"></span>\n    <span class=\"label\"\n      ><span [attr.aria-selected]=\"this.selected\" role=\"option\">{{\n        option.label\n      }}</span></span\n    >\n  </div>\n</span>\n" }]
        }], ctorParameters: function () { return [{ type: SelectService }]; }, propDecorators: { className: [{
                type: HostBinding,
                args: ["class"]
            }], selected: [{
                type: HostBinding,
                args: ["class.selected"]
            }], isfocused: [{
                type: HostBinding,
                args: ["class.focused"]
            }], option: [{
                type: Input
            }], multiple: [{
                type: Input
            }], checked: [{
                type: Input
            }], focused: [{
                type: Input
            }], optional: [{
                type: Input
            }], optionClick: [{
                type: Output
            }], optionMouseDown: [{
                type: Output
            }] } });

class FilterOptionsPipe {
    constructor(service) {
        this.service = service;
    }
    transform(options, inputValue) {
        const value = inputValue?.toLowerCase();
        const array = options;
        let newOptions = [];
        if (array && array?.length > 0 && this.service.instanceOfOption(array[0])) {
            const arrayOption = array;
            if (arrayOption?.length > 0) {
                newOptions = this.filterOptions(arrayOption, value);
            }
        }
        else if (array && array?.length > 0 && !this.service.instanceOfOption(array[0])) {
            const arrayOption = array;
            if (arrayOption?.length > 0) {
                arrayOption.map((op) => {
                    const arr = this.filterOptions(op.options, value);
                    if (arr?.length > 0) {
                        const newGroup = {
                            label: op.label,
                            options: arr,
                        };
                        newOptions.push(newGroup);
                    }
                });
            }
        }
        const filteredArray = (newOptions?.length > 0 || inputValue?.length > 0) ? newOptions : options;
        this.service.setFilteredOptions(filteredArray);
        return filteredArray;
    }
    filterOptions(array, inputValue) {
        let newArray = [];
        array.map((op) => {
            const label = op.label.toLowerCase();
            if (label.includes(inputValue)) {
                newArray.push(op);
            }
        });
        return newArray;
    }
}
FilterOptionsPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: FilterOptionsPipe, deps: [{ token: SelectService }], target: i0.ɵɵFactoryTarget.Pipe });
FilterOptionsPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: FilterOptionsPipe, name: "filterOptions" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: FilterOptionsPipe, decorators: [{
            type: Pipe,
            args: [{ name: "filterOptions", pure: true }]
        }], ctorParameters: function () { return [{ type: SelectService }]; } });

class DxcSelectComponent {
    constructor(helper, service, ref) {
        this.helper = helper;
        this.service = service;
        this.ref = ref;
        this._searchable = false;
        this._disabled = false;
        this._multiple = false;
        this._optional = false;
        /**
         * If it is a defined value and also a truthy string, the component will
         * change its appearance, showing the error below the select component. If
         * the defined value is an empty string, it will reserve a space below the
         * component for a future error, but it would not change its look. In case of
         * being undefined or null, both the appearance and the space for the error
         * message would not be modified.
         */
        this.error = undefined;
        /**
         * Text to be put as placeholder of the select.
         */
        this.placeholder = "";
        this.defaultInputs = new BehaviorSubject({
            label: "",
            name: "",
            value: null,
            defaultValue: null,
            placeholder: "",
            helperText: "",
            searchable: false,
            multiple: false,
            optional: false,
            disabled: false,
            error: undefined,
            margin: undefined,
            size: "medium",
            options: [],
            tabIndexValue: 0,
        });
        /**
         * This event will be emitted when the user selects an option. An object including the new value (or values)
         * and the error (if the value selected is not valid) will be passed to this function.
         */
        this.onChange = new EventEmitter();
        /**
         * This event will be emitted when the select loses the focus. An object including the value (or values)
         * and the error (if the value selected is not valid) will be passed to this function.
         */
        this.onBlur = new EventEmitter();
        this.isOpened = false;
        this.isInputVisible = true;
        this.controlled = false;
        this.isDirty = false;
        this.isNotSelectable = false;
        this.onTouched = () => { };
        this.onChangeRegister = (val) => {
            this.setInputValue(val);
        };
        this.isValueSelected = (value) => this.service.getSelectedValues() &&
            this.service.getSelectedValues().find((op) => op.value === value);
        this.isFocused = (indexGroup, indexOption) => this.focusedOption.option === indexOption &&
            this.focusedOption.group === indexGroup;
        this.isRequired = () => !this.optional
            ? `This field is required. Please, enter a value.`
            : undefined;
        this.service.selectedValues?.subscribe((selectedValues) => {
            if (selectedValues) {
                this.formValues = this.multiple
                    ? selectedValues.map((item) => item.value).toString()
                    : selectedValues.value;
            }
        });
    }
    /**
     * If true, enables search functionality.
     */
    get searchable() {
        return this._searchable;
    }
    set searchable(value) {
        this._searchable = coerceBooleanProperty(value);
    }
    /**
     * If true, the component will be disabled.
     */
    get disabled() {
        return this._disabled;
    }
    set disabled(value) {
        this._disabled = coerceBooleanProperty(value);
    }
    /**
     * If true, the select component will support multiple selected options.
     * In that case, value will be an array of strings with each selected option value.
     */
    get multiple() {
        return this._multiple;
    }
    set multiple(value) {
        this._multiple = coerceBooleanProperty(value);
    }
    /**
     * If true, the select will be optional, showing (Optional) next to the label
     * and adding a default first option with an empty string as value,
     * been the placeholder (if defined) its label.
     * Otherwise, the field will be considered required and an error will be passed
     * as a parameter to the OnBlur and onChange functions if an option wasn't selected.
     */
    get optional() {
        return this._optional;
    }
    set optional(value) {
        this._optional = coerceBooleanProperty(value);
    }
    clickout(event) {
        if (!this.ref.nativeElement.contains(event.target)) {
            if (this.isOpened) {
                this.isOpened = false;
                this.setInitialFocusOption();
            }
            this.setInputValue("");
        }
    }
    writeValue(val) {
        this.formValues = val || "";
    }
    registerOnChange(fn) {
        this.onChangeRegister = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    ngOnChanges(changes) {
        this.optionalOption = { label: this.setPlaceholderOptional(), value: "" };
        const inputs = Object.keys(changes).reduce((result, item) => {
            result[item] = changes[item].currentValue;
            return result;
        }, {});
        this.setDefaultValues();
        this.setInitialFocusOption();
        this.defaultInputs.next({ ...this.defaultInputs.getValue(), ...inputs });
        this.className = `${this.helper.getDynamicStyle({
            ...this.defaultInputs.getValue(),
        })}`;
    }
    ngOnInit() {
        this.optionalOption = { label: this.setPlaceholderOptional(), value: "" };
        if (this.optional && !this.multiple && !(this.value || this.value === "")) {
            this.service.setSelectedValues(this.optionalOption);
        }
        this.id = `select-${v4()}`;
        this.selectLabelId = `label-${this.id}`;
        this.optionsListId = `${this.id}-listbox`;
        this.className = `${this.helper.getDynamicStyle({
            ...this.defaultInputs.getValue(),
        })}`;
        this.controlled = this.value || this.value === "" ? true : false;
        if (this.defaultValue || (this.defaultValue === "" && !this.controlled)) {
            this.value = this.defaultValue;
            this.setDefaultValues();
        }
        this.service.visualFocused.subscribe((value) => {
            this.focusedOption = value;
            this.setActiveDescendantAttr();
            if (this.focusedOption.option === -1) {
                this.scrollByIndex(this.optionsRef, 0);
            }
            else if ((value.group === undefined || value.group === null) &&
                !(this.focusedOption.option === -1)) {
                if (this.optionsRef &&
                    this.optionsRef.nativeElement.children[value.option]) {
                    this.scrollByIndex(this.optionsRef, value.option + 1);
                }
            }
            else {
                if (this.optionGroupRef) {
                    const optionGroupElement = this.optionGroupRef?.toArray()[value.group];
                    optionGroupElement &&
                        this.scrollByIndex(optionGroupElement, value.option + 1);
                }
            }
        });
    }
    setActiveDescendantAttr() {
        const indexOptionalLabel = this.optional ? -1 : 0;
        this.activeDescendant =
            this.focusedOption.option < indexOptionalLabel
                ? "false"
                : this.focusedOption.group !== undefined
                    ? `option-${this.focusedOption.group}-${this.focusedOption.option}`
                    : `option-${this.focusedOption.option}`;
    }
    handleOptionMouseDown(event) {
        event.preventDefault();
    }
    handleOptionClick(option, event) {
        if (!this.disabled) {
            this.focusContainer(event, true);
            if (this.multiple) {
                const arr = this.service.getSelectedValues() || [];
                const index = arr.indexOf(option);
                if (index >= 0) {
                    arr.splice(index, 1);
                }
                else {
                    arr.push(option);
                }
                if (arr) {
                    let op = { value: [], error: undefined };
                    arr.map((el) => {
                        op.value.push(el.value);
                    });
                    this.onChange.emit(op);
                }
                else {
                    this.onChange.emit({ value: [], error: this.isRequired() });
                }
                this.service.setSelectedValues(arr);
                this.showInput();
                this.isOpened = true;
            }
            else {
                if (option) {
                    this.onChange.emit({ value: option.value, error: undefined });
                }
                else {
                    this.onChange.emit({ value: "", error: this.isRequired() });
                }
                if (!this.controlled) {
                    this.service.setSelectedValues(option);
                }
                this.isOpened = false;
            }
            this.setInitialFocusOption();
            this.setInputValue("");
            if (this.searchable && !this.multiple) {
                this.isInputVisible = false;
            }
        }
    }
    handleOnFocusOut() {
        const options = this.service.getSelectedValues();
        if (this.multiple) {
            if (options) {
                let op = { value: [], error: undefined };
                options.map((el) => {
                    op.value.push(el.value);
                });
                if (op.value.length === 0) {
                    op.error = this.isRequired();
                }
                this.onBlur.emit(op);
            }
            else {
                this.onBlur.emit({ value: [], error: this.isRequired() });
            }
        }
        else {
            if (options) {
                // if (options.value === "") {
                //   this.service.setSelectedValues([]);
                // }
                this.onBlur.emit({ value: options.value, error: undefined });
            }
            else {
                this.onBlur.emit({ value: "", error: this.isRequired() });
            }
        }
    }
    focusContainer(event, isOptionClicked) {
        if (!this.disabled && this.searchable) {
            event.preventDefault();
            event.stopPropagation();
            this.isInputVisible = true;
            this.inputRef.nativeElement.focus();
            this.isOpened = !isOptionClicked ? true : false;
        }
        else if (!this.disabled && this.multiple) {
            event.preventDefault();
            event.stopPropagation();
        }
    }
    labelClick(event) {
        if (!this.disabled && !this.searchable) {
            event.preventDefault();
            event.stopPropagation();
            this.containerRef?.nativeElement?.focus();
        }
        if (!this.disabled && this.searchable) {
            event.preventDefault();
            event.stopPropagation();
            this.isInputVisible = true;
            setTimeout(() => {
                this.inputRef.nativeElement.focus();
            }, 0);
        }
    }
    removeSelectedValues(event) {
        event.preventDefault();
        event.stopPropagation();
        if (!this.controlled) {
            this.service.setSelectedValues([]);
        }
        if (this.multiple) {
            this.onChange.emit({ value: [], error: this.isRequired() });
        }
        else {
            this.onChange.emit({ value: "", error: this.isRequired() });
        }
    }
    setDefaultValues() {
        if (this.value !== undefined && this.value !== null) {
            if (Array.isArray(this.value)) {
                const arr = [];
                this.value.map((value) => {
                    const option = this.findOptionByValue(value);
                    if (option !== undefined && option !== null) {
                        arr.push(option);
                    }
                });
                this.service.setSelectedValues(arr);
            }
            else {
                const option = this.findOptionByValue(this.value);
                this.service.setSelectedValues(option);
            }
        }
    }
    findOptionByValue(value) {
        let selected;
        const array = this.options;
        if (this.service.instanceOfOption(this.options[0])) {
            const arrayOption = array;
            if (arrayOption?.length > 0) {
                selected = this.findOption(arrayOption, value);
            }
        }
        else {
            const arrayOption = array;
            if (arrayOption?.length > 0) {
                arrayOption.map((op) => {
                    const found = this.findOption(op.options, value);
                    if (found !== undefined && found != null) {
                        selected = found;
                    }
                });
            }
        }
        return selected;
    }
    findOption(options, value) {
        return options.find((op) => {
            if (op.value === value) {
                return op;
            }
        });
    }
    handleSelectOpen() {
        if (!this.disabled) {
            if (this.searchable) {
                this.showInput();
            }
            else if (!this.isNotSelectable) {
                this.isOpened = !this.isOpened;
            }
            this.isNotSelectable = false;
            this.isOpened && this.handleScrollSelected();
            this.setInitialFocusOption();
        }
    }
    handleScrollSelected() {
        const array = this.options;
        if (array && array?.length > 0 && !this.multiple) {
            if (this.service?.getSelectedValues()?.value === "" && this.optional) {
                this.service.setVisualFocused({
                    group: -1,
                    option: -1,
                });
            }
            else if (this.service.instanceOfOption(array[0]) && this.optionsRef) {
                const arrayOption = array;
                if (this.service.getSelectedValues()) {
                    this.setFocusSelectedOption(arrayOption);
                }
            }
            else if (!this.service.instanceOfOption(array[0]) &&
                this.optionGroupRef) {
                if (this.service.getSelectedValues()) {
                    const arrayOption = array;
                    this.setFocusSelectedOptionGroup(arrayOption);
                }
            }
        }
    }
    setFocusSelectedOption(arrayOption) {
        const index = arrayOption.indexOf(this.service.getSelectedValues());
        this.service.setVisualFocused({
            group: -1,
            option: index,
        });
    }
    setFocusSelectedOptionGroup(arrayOption) {
        let indexOption, indexGroup;
        arrayOption.map((op, index) => {
            const found = this.findOption(op.options, this.service.getSelectedValues().value);
            if (found !== undefined && found != null) {
                indexOption = op.options.indexOf(found);
                indexGroup = index;
            }
        });
        if (indexGroup !== undefined && indexOption !== undefined) {
            this.service.setVisualFocused({
                group: indexGroup,
                option: indexOption,
            });
        }
        else {
            if (this.optionalOption === this.service.getSelectedValues()) {
                this.service.setVisualFocused({
                    group: -1,
                    option: -1,
                });
            }
        }
    }
    scrollByIndex(element, index) {
        if (element !== undefined && index !== undefined) {
            element.nativeElement?.children[index]?.scrollIntoView({
                behavior: "smooth",
                block: "nearest",
                inline: "nearest",
            });
        }
    }
    handleOnChangeInput(value) {
        this.inputValue = value;
    }
    handlePropagation(event) {
        event.preventDefault();
        event.stopPropagation();
    }
    handleClearInput(event) {
        event.preventDefault();
        event.stopPropagation();
        this.setInputValue("");
    }
    setInputValue(value) {
        if (this.inputRef) {
            this.inputRef.nativeElement.value = value;
            this.inputValue = value;
        }
    }
    showInput() {
        this.isInputVisible = true;
        setTimeout(() => {
            this.inputRef?.nativeElement.focus();
            if (!this.multiple && this.isNotSelectable) {
                this.isOpened = !this.isOpened;
            }
            else {
                this.isOpened = true;
            }
            this.setInitialFocusOption();
        });
    }
    handleBlurInput() {
        this.isInputVisible = false;
    }
    setPlaceholderOptional() {
        if (this.placeholder) {
            return this.placeholder;
        }
        else {
            if (!this.multiple) {
                return "Choose an option";
            }
            else {
                return "Choose options";
            }
        }
    }
    setPlaceholder() {
        if (this.service.getSelectedValues()?.label && !this.multiple) {
            return this.service.getSelectedValues()?.label;
        }
        else {
            if (this.placeholder) {
                return this.placeholder;
            }
            else {
                if (!this.multiple) {
                    this.placeholder = "Choose an option";
                    return this.placeholder;
                }
                else {
                    this.placeholder = "Choose options";
                    return this.placeholder;
                }
            }
        }
    }
    handleOnKeyDown(event) {
        if (!this.isOpened) {
            switch (event.key) {
                case "ArrowDown":
                    event.preventDefault();
                    this.isOpened = true;
                    if (this.service.getSelectedValues() !== undefined &&
                        this.service.getSelectedValues() !== null) {
                        this.setActualSelectedFocus();
                        this.service.onArrowDown(this.optional, this.isDirty);
                        this.isDirty = true;
                    }
                    else {
                        this.isDirty = true;
                        this.service.onArrowDown(this.optional, this.isDirty);
                    }
                    break;
                case "ArrowUp":
                    event.preventDefault();
                    this.isOpened = true;
                    if (this.service.getSelectedValues() !== undefined &&
                        this.service.getSelectedValues() !== null) {
                        this.setActualSelectedFocus();
                        this.service.onArrowUp(this.optional, this.isDirty);
                        this.isDirty = true;
                    }
                    else {
                        this.isDirty = true;
                        this.service.onArrowUp(this.optional, this.isDirty);
                    }
                    break;
            }
        }
        else {
            switch (event.key) {
                case "ArrowDown":
                    event.preventDefault();
                    this.service.onArrowDown(this.optional, this.isDirty);
                    this.isDirty = true;
                    break;
                case "ArrowUp":
                    event.preventDefault();
                    this.service.onArrowUp(this.optional, this.isDirty);
                    this.isDirty = true;
                    break;
                case "Enter":
                    this.handleEnterKey(event);
                    break;
                case "Tab":
                    this.isOpened = false;
                    break;
                case "Escape":
                    event.preventDefault();
                    this.isOpened = false;
                    this.setInitialFocusOption();
                    this.setInputValue("");
                    this.inputRef?.nativeElement?.blur();
                    break;
            }
        }
    }
    setActualSelectedFocus() {
        if (!this.multiple) {
            const array = this.options;
            if (this.service.instanceOfOption(this.options[0])) {
                const arrayOption = array;
                if (this.service.getSelectedValues()) {
                    this.setFocusSelectedOption(arrayOption);
                }
            }
            else {
                const arrayOption = array;
                if (this.service.getSelectedValues()) {
                    this.setFocusSelectedOptionGroup(arrayOption);
                }
            }
        }
    }
    handleEnterKey(event) {
        if (this.focusedOption.option === -1 && this.optional) {
            this.handleOptionClick(this.optionalOption, event);
        }
        else if (this.focusedOption.option > -1) {
            let arrayOption, option;
            if (this.service.instanceOfOption(this.options[0])) {
                arrayOption = this.service.filteredOptions.getValue();
                option = arrayOption[this.focusedOption.option];
            }
            else {
                arrayOption = this.service.filteredOptions.getValue();
                option =
                    arrayOption[this.focusedOption.group].options[this.focusedOption.option];
            }
            this.handleOptionClick(option, event);
        }
    }
    setInitialFocusOption() {
        if (!this.isOpened) {
            this.isDirty = false;
            this.service.setVisualFocused({
                option: this.optional ? -2 : -1,
                group: this.optional ? -2 : -1,
            });
        }
    }
    hasOptional() {
        return (this.optional &&
            (this.inputValue?.length <= 0 ||
                this.inputValue === undefined ||
                this.inputValue === null));
    }
    clickNotSelectable() {
        this.isNotSelectable = true;
    }
    setDisplayValueContainer() {
        return (this.service.getSizeSelectedValues() <= 0 &&
            this.multiple &&
            this.searchable);
    }
}
DxcSelectComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcSelectComponent, deps: [{ token: DxcSelectHelper }, { token: SelectService, self: true }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
DxcSelectComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.5", type: DxcSelectComponent, selector: "dxc-select", inputs: { label: "label", name: "name", value: "value", defaultValue: "defaultValue", helperText: "helperText", searchable: "searchable", disabled: "disabled", multiple: "multiple", optional: "optional", error: "error", placeholder: "placeholder", margin: "margin", tabIndexValue: "tabIndexValue", size: "size", options: "options" }, outputs: { onChange: "onChange", onBlur: "onBlur" }, host: { listeners: { "document:click": "clickout($event)" }, properties: { "class": "this.className" } }, providers: [
        DxcSelectHelper,
        CssUtils,
        SelectService,
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => DxcSelectComponent),
            multi: true,
        },
    ], viewQueries: [{ propertyName: "containerRef", first: true, predicate: ["containerRef"], descendants: true }, { propertyName: "optionsRef", first: true, predicate: ["optionsRef"], descendants: true }, { propertyName: "inputRef", first: true, predicate: ["inputRef"], descendants: true }, { propertyName: "optionGroupRef", predicate: ["optionGroupRef"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<span\n  *ngIf=\"label\"\n  class=\"inputLabel\"\n  id=\"{{ selectLabelId }}\"\n  role=\"label\"\n  (click)=\"labelClick($event)\"\n  >{{ label }}\n  <span *ngIf=\"optional\" class=\"optional\">(Optional)</span>\n</span>\n<input\n  *ngIf=\"!searchable\"\n  type=\"text\"\n  [id]=\"id\"\n  ngModel\n  [name]=\"name\"\n  [value]=\"formValues\"\n  style=\"display: none\"\n  readOnly\n  attr.aria-hidden=\"true\"\n/>\n<span *ngIf=\"helperText\" class=\"helperText\">{{ helperText }}</span>\n<div\n  class=\"container\"\n  [tabindex]=\"disabled ? -1 : tabIndexValue\"\n  (focus)=\"focusContainer($event, false)\"\n  (click)=\"handleSelectOpen()\"\n  (keydown)=\"handleOnKeyDown($event)\"\n  (focusout)=\"handleOnFocusOut()\"\n  attr.aria-label=\"{{ label }}\"\n  attr.aria-labelledby=\"{{ selectLabelId }}\"\n  #containerRef\n  role=\"combobox\"\n  attr.aria-controls=\"{{ optionsListId }}\"\n  attr.aria-expanded=\"{{ isOpened }}\"\n  attr.aria-haspopup=\"listbox\"\n  attr.aria-activedescendant=\"{{ activeDescendant }}\"\n  [attr.aria-invalid]=\"error ? 'true' : 'false'\"\n  attr.aria-required=\"{{ !optional }}\"\n>\n  <div\n    class=\"valueContainer\"\n    *ngIf=\"!searchable || (searchable && multiple)\"\n    [ngClass]=\"setDisplayValueContainer() ? 'noValuesSelected' : ''\"\n  >\n    <div\n      class=\"numberOfSelected\"\n      *ngIf=\"service.getSizeSelectedValues() > 0 && multiple\"\n    >\n      <div class=\"sizeContainer\">\n        {{ service.getSizeSelectedValues() }}\n      </div>\n      <div\n        class=\"removeContainer\"\n        (click)=\"removeSelectedValues($event)\"\n        tabindex=\"0\"\n        title=\"Clear selected options\"\n        attr.aria-label=\"Clear selected options\"\n        role=\"button\"\n      >\n        <svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\">\n          <path d=\"M0 0h24v24H0z\" fill=\"none\" />\n          <path\n            d=\"M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z\"\n          />\n        </svg>\n      </div>\n    </div>\n    <span\n      *ngIf=\"!searchable\"\n      class=\"selectedOptionContainer\"\n      [ngClass]=\"{\n        notSelectedLabel: !(service.getSizeSelectedValues() > 0)\n      }\"\n      ><dxc-select-option-selected\n        [multiple]=\"multiple\"\n        [disabled]=\"disabled\"\n        [placeholder]=\"placeholder\"\n      ></dxc-select-option-selected\n    ></span>\n  </div>\n  <div *ngIf=\"searchable\" class=\"searchContainer\">\n    <span class=\"searchGrid\">\n      <dxc-select-option-selected\n        [multiple]=\"multiple\"\n        [disabled]=\"disabled\"\n        [placeholder]=\"placeholder\"\n        [searchable]=\"searchable\"\n        *ngIf=\"!isInputVisible\"\n      ></dxc-select-option-selected>\n      <input\n        #inputRef\n        [ngClass]=\"{\n          hiddenInput: !isInputVisible\n        }\"\n        type=\"text\"\n        [id]=\"id\"\n        [placeholder]=\"setPlaceholder()\"\n        [name]=\"name\"\n        [disabled]=\"disabled\"\n        [tabindex]=\"disabled ? -1 : tabIndexValue\"\n        autocomplete=\"off\"\n        autocorrect=\"off\"\n        (ngModelChange)=\"handleOnChangeInput($event)\"\n        [ngModel]=\"inputValue\"\n        (blur)=\"handleBlurInput()\"\n      />\n    </span>\n\n    <button\n      *ngIf=\"inputValue?.length > 0 && !disabled && isInputVisible\"\n      class=\"inputClear\"\n      (mousedown)=\"handlePropagation($event)\"\n      (mouseup)=\"handleClearInput($event)\"\n      [disabled]=\"disabled\"\n      [tabindex]=\"disabled ? -1 : tabIndexValue\"\n      title=\"Clear search text\"\n      attr.aria-label=\"Clear search text\"\n    >\n      <svg\n        xmlns=\"http://www.w3.org/2000/svg\"\n        width=\"24\"\n        height=\"24\"\n        viewBox=\"0 0 24 24\"\n        fill=\"currentColor\"\n      >\n        <path d=\"M0 0h24v24H0V0z\" fill=\"none\" />\n        <path\n          d=\"M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z\"\n        />\n      </svg>\n    </button>\n  </div>\n  <div class=\"iconsContainer\">\n    <span *ngIf=\"error && !disabled\" class=\"errorIcon\" aria-label=\"Error\">\n      <svg\n        xmlns=\"http://www.w3.org/2000/svg\"\n        height=\"24px\"\n        viewBox=\"0 0 24 24\"\n        width=\"24px\"\n        fill=\"currentColor\"\n      >\n        <path\n          d=\"M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z\"\n        />\n      </svg>\n    </span>\n    <span\n      class=\"collapseIndicator\"\n      [ngClass]=\"{\n        opened: this.isOpened\n      }\"\n    >\n      <svg\n        role=\"img\"\n        xmlns=\"http://www.w3.org/2000/svg\"\n        viewBox=\"0 0 24 24\"\n        fill=\"currentColor\"\n      >\n        <path d=\"M0 0h24v24H0V0z\" fill=\"none\"></path>\n        <path\n          d=\"M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z\"\n        ></path>\n      </svg>\n    </span>\n  </div>\n\n  <ul\n    class=\"options\"\n    *ngIf=\"!multiple && options?.length > 0 && this.isOpened\"\n    role=\"listbox\"\n    attr.aria-labelledby=\"{{ selectLabelId }}\"\n    attr.aria-multiselectable=\"{{ multiple }}\"\n    #optionsRef\n  >\n    <li *ngIf=\"hasOptional()\">\n      <dxc-select-option\n        [multiple]=\"false\"\n        [option]=\"optionalOption\"\n        [focused]=\"isDirty && focusedOption.option === -1\"\n        [optional]=\"optional\"\n        (optionClick)=\"handleOptionClick(optionalOption, $event)\"\n        (optionMouseDown)=\"handleOptionMouseDown($event)\"\n      ></dxc-select-option>\n    </li>\n    <li\n      *ngFor=\"\n        let option of options && !searchable\n          ? options\n          : (options | filterOptions: inputValue);\n        let i = index;\n        last as lastOption\n      \"\n      [ngClass]=\"{\n        lastItem: lastOption\n      }\"\n    >\n      <ul\n        *ngIf=\"!service.instanceOfOption(option)\"\n        class=\"optionsGroup\"\n        #optionGroupRef\n      >\n        <li class=\"groupLabelElement\" (click)=\"clickNotSelectable()\">\n          <span>{{ option.label }}</span>\n        </li>\n        <li\n          *ngFor=\"\n            let op of option.options;\n            last as lastOptionGroup;\n            let indexOptionGroup = index\n          \"\n          [ngClass]=\"{\n            lastItemGroup: lastOption && lastOptionGroup\n          }\"\n        >\n          <dxc-select-option\n            [multiple]=\"multiple\"\n            [option]=\"op\"\n            [focused]=\"isDirty && isFocused(i, indexOptionGroup)\"\n            (optionClick)=\"handleOptionClick(op, $event)\"\n            (optionMouseDown)=\"handleOptionMouseDown($event)\"\n          ></dxc-select-option>\n        </li>\n      </ul>\n      <dxc-select-option\n        *ngIf=\"service.instanceOfOption(option)\"\n        [multiple]=\"multiple\"\n        [option]=\"option\"\n        [focused]=\"isDirty && focusedOption.option === i\"\n        (optionClick)=\"handleOptionClick(option, $event)\"\n        (optionMouseDown)=\"handleOptionMouseDown($event)\"\n      ></dxc-select-option>\n    </li>\n    <li\n      *ngIf=\"(options | filterOptions: inputValue).length === 0\"\n      (click)=\"clickNotSelectable()\"\n      class=\"resultsNotFound\"\n    >\n      <span class=\"notFoundIcon\">\n        <svg\n          xmlns=\"http://www.w3.org/2000/svg\"\n          enable-background=\"new 0 0 24 24\"\n          height=\"24px\"\n          viewBox=\"0 0 24 24\"\n          width=\"24px\"\n          fill=\"#000000\"\n        >\n          <g><rect fill=\"none\" height=\"24\" width=\"24\" /></g>\n          <g>\n            <g>\n              <path\n                d=\"M15.5,14h-0.79l-0.28-0.27C15.41,12.59,16,11.11,16,9.5C16,5.91,13.09,3,9.5,3C6.08,3,3.28,5.64,3.03,9h2.02 C5.3,6.75,7.18,5,9.5,5C11.99,5,14,7.01,14,9.5S11.99,14,9.5,14c-0.17,0-0.33-0.03-0.5-0.05v2.02C9.17,15.99,9.33,16,9.5,16 c1.61,0,3.09-0.59,4.23-1.57L14,14.71v0.79l5,4.99L20.49,19L15.5,14z\"\n              />\n              <polygon\n                points=\"6.47,10.82 4,13.29 1.53,10.82 0.82,11.53 3.29,14 0.82,16.47 1.53,17.18 4,14.71 6.47,17.18 7.18,16.47 4.71,14 7.18,11.53\"\n              />\n            </g>\n          </g>\n        </svg>\n      </span>\n      <span class=\"systemMessage\">No matches found</span>\n    </li>\n  </ul>\n\n  <ul\n    class=\"options\"\n    *ngIf=\"multiple && options?.length > 0 && this.isOpened\"\n    tabindex=\"-1\"\n    role=\"listbox\"\n    attr.aria-labelledby=\"{{ selectLabelId }}\"\n    attr.aria-multiselectable=\"{{ multiple }}\"\n    #optionsRef\n  >\n    <li\n      *ngFor=\"\n        let option of options && !searchable\n          ? options\n          : (options | filterOptions: inputValue);\n        let i = index;\n        last as lastOption\n      \"\n      [ngClass]=\"{\n        lastItem: lastOption\n      }\"\n    >\n      <ul\n        *ngIf=\"!service.instanceOfOption(option)\"\n        class=\"optionsGroup\"\n        #optionGroupRef\n      >\n        <li class=\"groupLabelElement\" (click)=\"clickNotSelectable()\">\n          <span>{{ option.label }}</span>\n        </li>\n        <li\n          *ngFor=\"\n            let op of option.options;\n            last as lastOptionGroup;\n            let indexOptionGroup = index\n          \"\n          [ngClass]=\"{\n            lastItemGroup: lastOption && lastOptionGroup\n          }\"\n        >\n          <dxc-select-option\n            [multiple]=\"multiple\"\n            [option]=\"op\"\n            [checked]=\"isValueSelected(op.value)\"\n            [focused]=\"\n              focusedOption.option === indexOptionGroup &&\n              focusedOption.group === i\n            \"\n            (optionClick)=\"handleOptionClick(op, $event)\"\n            (optionMouseDown)=\"handleOptionMouseDown($event)\"\n          ></dxc-select-option>\n        </li>\n      </ul>\n      <dxc-select-option\n        *ngIf=\"service.instanceOfOption(option)\"\n        [multiple]=\"multiple\"\n        [option]=\"option\"\n        [checked]=\"isValueSelected(option.value)\"\n        [focused]=\"focusedOption.option === i\"\n        (optionClick)=\"handleOptionClick(option, $event)\"\n        (optionMouseDown)=\"handleOptionMouseDown($event)\"\n      ></dxc-select-option>\n    </li>\n    <li\n      *ngIf=\"(options | filterOptions: inputValue).length === 0\"\n      (click)=\"clickNotSelectable()\"\n      class=\"resultsNotFound\"\n    >\n      <span class=\"notFoundIcon\">\n        <svg\n          xmlns=\"http://www.w3.org/2000/svg\"\n          enable-background=\"new 0 0 24 24\"\n          height=\"24px\"\n          viewBox=\"0 0 24 24\"\n          width=\"24px\"\n          fill=\"#000000\"\n        >\n          <g><rect fill=\"none\" height=\"24\" width=\"24\" /></g>\n          <g>\n            <g>\n              <path\n                d=\"M15.5,14h-0.79l-0.28-0.27C15.41,12.59,16,11.11,16,9.5C16,5.91,13.09,3,9.5,3C6.08,3,3.28,5.64,3.03,9h2.02 C5.3,6.75,7.18,5,9.5,5C11.99,5,14,7.01,14,9.5S11.99,14,9.5,14c-0.17,0-0.33-0.03-0.5-0.05v2.02C9.17,15.99,9.33,16,9.5,16 c1.61,0,3.09-0.59,4.23-1.57L14,14.71v0.79l5,4.99L20.49,19L15.5,14z\"\n              />\n              <polygon\n                points=\"6.47,10.82 4,13.29 1.53,10.82 0.82,11.53 3.29,14 0.82,16.47 1.53,17.18 4,14.71 6.47,17.18 7.18,16.47 4.71,14 7.18,11.53\"\n              />\n            </g>\n          </g>\n        </svg>\n      </span>\n      <span>No matches found</span>\n    </li>\n  </ul>\n</div>\n\n<span *ngIf=\"(error || error === '') && !disabled\" class=\"errorMessage\">{{\n  error\n}}</span>\n", components: [{ type: DxcSelectOptionSelectedComponent, selector: "dxc-select-option-selected", inputs: ["multiple", "disabled", "searchable", "placeholder"] }, { type: DxcSelectOptionComponent, selector: "dxc-select-option", inputs: ["option", "multiple", "checked", "focused", "optional"], outputs: ["optionClick", "optionMouseDown"] }], directives: [{ type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i5.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i5.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i5.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i4.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], pipes: { "filterOptions": FilterOptionsPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcSelectComponent, decorators: [{
            type: Component,
            args: [{ selector: "dxc-select", providers: [
                        DxcSelectHelper,
                        CssUtils,
                        SelectService,
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => DxcSelectComponent),
                            multi: true,
                        },
                    ], template: "<span\n  *ngIf=\"label\"\n  class=\"inputLabel\"\n  id=\"{{ selectLabelId }}\"\n  role=\"label\"\n  (click)=\"labelClick($event)\"\n  >{{ label }}\n  <span *ngIf=\"optional\" class=\"optional\">(Optional)</span>\n</span>\n<input\n  *ngIf=\"!searchable\"\n  type=\"text\"\n  [id]=\"id\"\n  ngModel\n  [name]=\"name\"\n  [value]=\"formValues\"\n  style=\"display: none\"\n  readOnly\n  attr.aria-hidden=\"true\"\n/>\n<span *ngIf=\"helperText\" class=\"helperText\">{{ helperText }}</span>\n<div\n  class=\"container\"\n  [tabindex]=\"disabled ? -1 : tabIndexValue\"\n  (focus)=\"focusContainer($event, false)\"\n  (click)=\"handleSelectOpen()\"\n  (keydown)=\"handleOnKeyDown($event)\"\n  (focusout)=\"handleOnFocusOut()\"\n  attr.aria-label=\"{{ label }}\"\n  attr.aria-labelledby=\"{{ selectLabelId }}\"\n  #containerRef\n  role=\"combobox\"\n  attr.aria-controls=\"{{ optionsListId }}\"\n  attr.aria-expanded=\"{{ isOpened }}\"\n  attr.aria-haspopup=\"listbox\"\n  attr.aria-activedescendant=\"{{ activeDescendant }}\"\n  [attr.aria-invalid]=\"error ? 'true' : 'false'\"\n  attr.aria-required=\"{{ !optional }}\"\n>\n  <div\n    class=\"valueContainer\"\n    *ngIf=\"!searchable || (searchable && multiple)\"\n    [ngClass]=\"setDisplayValueContainer() ? 'noValuesSelected' : ''\"\n  >\n    <div\n      class=\"numberOfSelected\"\n      *ngIf=\"service.getSizeSelectedValues() > 0 && multiple\"\n    >\n      <div class=\"sizeContainer\">\n        {{ service.getSizeSelectedValues() }}\n      </div>\n      <div\n        class=\"removeContainer\"\n        (click)=\"removeSelectedValues($event)\"\n        tabindex=\"0\"\n        title=\"Clear selected options\"\n        attr.aria-label=\"Clear selected options\"\n        role=\"button\"\n      >\n        <svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\">\n          <path d=\"M0 0h24v24H0z\" fill=\"none\" />\n          <path\n            d=\"M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z\"\n          />\n        </svg>\n      </div>\n    </div>\n    <span\n      *ngIf=\"!searchable\"\n      class=\"selectedOptionContainer\"\n      [ngClass]=\"{\n        notSelectedLabel: !(service.getSizeSelectedValues() > 0)\n      }\"\n      ><dxc-select-option-selected\n        [multiple]=\"multiple\"\n        [disabled]=\"disabled\"\n        [placeholder]=\"placeholder\"\n      ></dxc-select-option-selected\n    ></span>\n  </div>\n  <div *ngIf=\"searchable\" class=\"searchContainer\">\n    <span class=\"searchGrid\">\n      <dxc-select-option-selected\n        [multiple]=\"multiple\"\n        [disabled]=\"disabled\"\n        [placeholder]=\"placeholder\"\n        [searchable]=\"searchable\"\n        *ngIf=\"!isInputVisible\"\n      ></dxc-select-option-selected>\n      <input\n        #inputRef\n        [ngClass]=\"{\n          hiddenInput: !isInputVisible\n        }\"\n        type=\"text\"\n        [id]=\"id\"\n        [placeholder]=\"setPlaceholder()\"\n        [name]=\"name\"\n        [disabled]=\"disabled\"\n        [tabindex]=\"disabled ? -1 : tabIndexValue\"\n        autocomplete=\"off\"\n        autocorrect=\"off\"\n        (ngModelChange)=\"handleOnChangeInput($event)\"\n        [ngModel]=\"inputValue\"\n        (blur)=\"handleBlurInput()\"\n      />\n    </span>\n\n    <button\n      *ngIf=\"inputValue?.length > 0 && !disabled && isInputVisible\"\n      class=\"inputClear\"\n      (mousedown)=\"handlePropagation($event)\"\n      (mouseup)=\"handleClearInput($event)\"\n      [disabled]=\"disabled\"\n      [tabindex]=\"disabled ? -1 : tabIndexValue\"\n      title=\"Clear search text\"\n      attr.aria-label=\"Clear search text\"\n    >\n      <svg\n        xmlns=\"http://www.w3.org/2000/svg\"\n        width=\"24\"\n        height=\"24\"\n        viewBox=\"0 0 24 24\"\n        fill=\"currentColor\"\n      >\n        <path d=\"M0 0h24v24H0V0z\" fill=\"none\" />\n        <path\n          d=\"M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z\"\n        />\n      </svg>\n    </button>\n  </div>\n  <div class=\"iconsContainer\">\n    <span *ngIf=\"error && !disabled\" class=\"errorIcon\" aria-label=\"Error\">\n      <svg\n        xmlns=\"http://www.w3.org/2000/svg\"\n        height=\"24px\"\n        viewBox=\"0 0 24 24\"\n        width=\"24px\"\n        fill=\"currentColor\"\n      >\n        <path\n          d=\"M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z\"\n        />\n      </svg>\n    </span>\n    <span\n      class=\"collapseIndicator\"\n      [ngClass]=\"{\n        opened: this.isOpened\n      }\"\n    >\n      <svg\n        role=\"img\"\n        xmlns=\"http://www.w3.org/2000/svg\"\n        viewBox=\"0 0 24 24\"\n        fill=\"currentColor\"\n      >\n        <path d=\"M0 0h24v24H0V0z\" fill=\"none\"></path>\n        <path\n          d=\"M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z\"\n        ></path>\n      </svg>\n    </span>\n  </div>\n\n  <ul\n    class=\"options\"\n    *ngIf=\"!multiple && options?.length > 0 && this.isOpened\"\n    role=\"listbox\"\n    attr.aria-labelledby=\"{{ selectLabelId }}\"\n    attr.aria-multiselectable=\"{{ multiple }}\"\n    #optionsRef\n  >\n    <li *ngIf=\"hasOptional()\">\n      <dxc-select-option\n        [multiple]=\"false\"\n        [option]=\"optionalOption\"\n        [focused]=\"isDirty && focusedOption.option === -1\"\n        [optional]=\"optional\"\n        (optionClick)=\"handleOptionClick(optionalOption, $event)\"\n        (optionMouseDown)=\"handleOptionMouseDown($event)\"\n      ></dxc-select-option>\n    </li>\n    <li\n      *ngFor=\"\n        let option of options && !searchable\n          ? options\n          : (options | filterOptions: inputValue);\n        let i = index;\n        last as lastOption\n      \"\n      [ngClass]=\"{\n        lastItem: lastOption\n      }\"\n    >\n      <ul\n        *ngIf=\"!service.instanceOfOption(option)\"\n        class=\"optionsGroup\"\n        #optionGroupRef\n      >\n        <li class=\"groupLabelElement\" (click)=\"clickNotSelectable()\">\n          <span>{{ option.label }}</span>\n        </li>\n        <li\n          *ngFor=\"\n            let op of option.options;\n            last as lastOptionGroup;\n            let indexOptionGroup = index\n          \"\n          [ngClass]=\"{\n            lastItemGroup: lastOption && lastOptionGroup\n          }\"\n        >\n          <dxc-select-option\n            [multiple]=\"multiple\"\n            [option]=\"op\"\n            [focused]=\"isDirty && isFocused(i, indexOptionGroup)\"\n            (optionClick)=\"handleOptionClick(op, $event)\"\n            (optionMouseDown)=\"handleOptionMouseDown($event)\"\n          ></dxc-select-option>\n        </li>\n      </ul>\n      <dxc-select-option\n        *ngIf=\"service.instanceOfOption(option)\"\n        [multiple]=\"multiple\"\n        [option]=\"option\"\n        [focused]=\"isDirty && focusedOption.option === i\"\n        (optionClick)=\"handleOptionClick(option, $event)\"\n        (optionMouseDown)=\"handleOptionMouseDown($event)\"\n      ></dxc-select-option>\n    </li>\n    <li\n      *ngIf=\"(options | filterOptions: inputValue).length === 0\"\n      (click)=\"clickNotSelectable()\"\n      class=\"resultsNotFound\"\n    >\n      <span class=\"notFoundIcon\">\n        <svg\n          xmlns=\"http://www.w3.org/2000/svg\"\n          enable-background=\"new 0 0 24 24\"\n          height=\"24px\"\n          viewBox=\"0 0 24 24\"\n          width=\"24px\"\n          fill=\"#000000\"\n        >\n          <g><rect fill=\"none\" height=\"24\" width=\"24\" /></g>\n          <g>\n            <g>\n              <path\n                d=\"M15.5,14h-0.79l-0.28-0.27C15.41,12.59,16,11.11,16,9.5C16,5.91,13.09,3,9.5,3C6.08,3,3.28,5.64,3.03,9h2.02 C5.3,6.75,7.18,5,9.5,5C11.99,5,14,7.01,14,9.5S11.99,14,9.5,14c-0.17,0-0.33-0.03-0.5-0.05v2.02C9.17,15.99,9.33,16,9.5,16 c1.61,0,3.09-0.59,4.23-1.57L14,14.71v0.79l5,4.99L20.49,19L15.5,14z\"\n              />\n              <polygon\n                points=\"6.47,10.82 4,13.29 1.53,10.82 0.82,11.53 3.29,14 0.82,16.47 1.53,17.18 4,14.71 6.47,17.18 7.18,16.47 4.71,14 7.18,11.53\"\n              />\n            </g>\n          </g>\n        </svg>\n      </span>\n      <span class=\"systemMessage\">No matches found</span>\n    </li>\n  </ul>\n\n  <ul\n    class=\"options\"\n    *ngIf=\"multiple && options?.length > 0 && this.isOpened\"\n    tabindex=\"-1\"\n    role=\"listbox\"\n    attr.aria-labelledby=\"{{ selectLabelId }}\"\n    attr.aria-multiselectable=\"{{ multiple }}\"\n    #optionsRef\n  >\n    <li\n      *ngFor=\"\n        let option of options && !searchable\n          ? options\n          : (options | filterOptions: inputValue);\n        let i = index;\n        last as lastOption\n      \"\n      [ngClass]=\"{\n        lastItem: lastOption\n      }\"\n    >\n      <ul\n        *ngIf=\"!service.instanceOfOption(option)\"\n        class=\"optionsGroup\"\n        #optionGroupRef\n      >\n        <li class=\"groupLabelElement\" (click)=\"clickNotSelectable()\">\n          <span>{{ option.label }}</span>\n        </li>\n        <li\n          *ngFor=\"\n            let op of option.options;\n            last as lastOptionGroup;\n            let indexOptionGroup = index\n          \"\n          [ngClass]=\"{\n            lastItemGroup: lastOption && lastOptionGroup\n          }\"\n        >\n          <dxc-select-option\n            [multiple]=\"multiple\"\n            [option]=\"op\"\n            [checked]=\"isValueSelected(op.value)\"\n            [focused]=\"\n              focusedOption.option === indexOptionGroup &&\n              focusedOption.group === i\n            \"\n            (optionClick)=\"handleOptionClick(op, $event)\"\n            (optionMouseDown)=\"handleOptionMouseDown($event)\"\n          ></dxc-select-option>\n        </li>\n      </ul>\n      <dxc-select-option\n        *ngIf=\"service.instanceOfOption(option)\"\n        [multiple]=\"multiple\"\n        [option]=\"option\"\n        [checked]=\"isValueSelected(option.value)\"\n        [focused]=\"focusedOption.option === i\"\n        (optionClick)=\"handleOptionClick(option, $event)\"\n        (optionMouseDown)=\"handleOptionMouseDown($event)\"\n      ></dxc-select-option>\n    </li>\n    <li\n      *ngIf=\"(options | filterOptions: inputValue).length === 0\"\n      (click)=\"clickNotSelectable()\"\n      class=\"resultsNotFound\"\n    >\n      <span class=\"notFoundIcon\">\n        <svg\n          xmlns=\"http://www.w3.org/2000/svg\"\n          enable-background=\"new 0 0 24 24\"\n          height=\"24px\"\n          viewBox=\"0 0 24 24\"\n          width=\"24px\"\n          fill=\"#000000\"\n        >\n          <g><rect fill=\"none\" height=\"24\" width=\"24\" /></g>\n          <g>\n            <g>\n              <path\n                d=\"M15.5,14h-0.79l-0.28-0.27C15.41,12.59,16,11.11,16,9.5C16,5.91,13.09,3,9.5,3C6.08,3,3.28,5.64,3.03,9h2.02 C5.3,6.75,7.18,5,9.5,5C11.99,5,14,7.01,14,9.5S11.99,14,9.5,14c-0.17,0-0.33-0.03-0.5-0.05v2.02C9.17,15.99,9.33,16,9.5,16 c1.61,0,3.09-0.59,4.23-1.57L14,14.71v0.79l5,4.99L20.49,19L15.5,14z\"\n              />\n              <polygon\n                points=\"6.47,10.82 4,13.29 1.53,10.82 0.82,11.53 3.29,14 0.82,16.47 1.53,17.18 4,14.71 6.47,17.18 7.18,16.47 4.71,14 7.18,11.53\"\n              />\n            </g>\n          </g>\n        </svg>\n      </span>\n      <span>No matches found</span>\n    </li>\n  </ul>\n</div>\n\n<span *ngIf=\"(error || error === '') && !disabled\" class=\"errorMessage\">{{\n  error\n}}</span>\n" }]
        }], ctorParameters: function () { return [{ type: DxcSelectHelper }, { type: SelectService, decorators: [{
                    type: Self
                }] }, { type: i0.ElementRef }]; }, propDecorators: { className: [{
                type: HostBinding,
                args: ["class"]
            }], label: [{
                type: Input
            }], name: [{
                type: Input
            }], value: [{
                type: Input
            }], defaultValue: [{
                type: Input
            }], helperText: [{
                type: Input
            }], searchable: [{
                type: Input
            }], disabled: [{
                type: Input
            }], multiple: [{
                type: Input
            }], optional: [{
                type: Input
            }], error: [{
                type: Input
            }], placeholder: [{
                type: Input
            }], margin: [{
                type: Input
            }], tabIndexValue: [{
                type: Input
            }], size: [{
                type: Input
            }], options: [{
                type: Input
            }], onChange: [{
                type: Output
            }], onBlur: [{
                type: Output
            }], containerRef: [{
                type: ViewChild,
                args: ["containerRef", { static: false }]
            }], optionsRef: [{
                type: ViewChild,
                args: ["optionsRef", { static: false }]
            }], inputRef: [{
                type: ViewChild,
                args: ["inputRef", { static: false }]
            }], optionGroupRef: [{
                type: ViewChildren,
                args: ["optionGroupRef"]
            }], clickout: [{
                type: HostListener,
                args: ["document:click", ["$event"]]
            }] } });

class DxcSelectModule {
}
DxcSelectModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcSelectModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DxcSelectModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcSelectModule, declarations: [DxcSelectComponent,
        DxcSelectOptionComponent,
        DxcSelectOptionSelectedComponent,
        FilterOptionsPipe], imports: [CommonModule, DxcCheckboxModule, PipesModule, FormsModule], exports: [DxcSelectComponent] });
DxcSelectModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcSelectModule, imports: [[CommonModule, DxcCheckboxModule, PipesModule, FormsModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcSelectModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        DxcSelectComponent,
                        DxcSelectOptionComponent,
                        DxcSelectOptionSelectedComponent,
                        FilterOptionsPipe,
                    ],
                    imports: [CommonModule, DxcCheckboxModule, PipesModule, FormsModule],
                    exports: [DxcSelectComponent],
                }]
        }] });

class DxcSliderComponent {
    constructor(utils, bgProviderService) {
        this.utils = utils;
        this.bgProviderService = bgProviderService;
        this.isDisabled = false;
        /**
         * The minimum value available for selection.
         */
        this.minValue = 0;
        /**
         * The maximum value available for selection.
         */
        this.maxValue = 100;
        /**
         * The step interval between values available for selection.
         */
        this.step = 1;
        this._showLimitsValues = false;
        this._showInput = false;
        this._marks = false;
        /**
         * Size of the component.
         */
        this.size = "fillParent";
        this._tabIndexValue = 0;
        /**
         * This event will emit in case the slider changes its value, as it's being dragged.
         * The new value will be passed as a parameter.
         */
        this.onChange = new EventEmitter();
        /**
         * This event will emit in case the slider changes its value, but only when the thumb is released.
         * The new value will be passed as a parameter.
         */
        this.onDragEnd = new EventEmitter();
        this.darkBackground = false;
        this.defaultInputs = new BehaviorSubject({
            minValue: 0,
            maxValue: 100,
            step: 1,
            showLimitsValues: false,
            showInput: false,
            value: 0,
            name: null,
            disabled: false,
            margin: null,
            size: "fillParent",
            tabIndexValue: 0,
        });
        this.sizes = {
            medium: "240px",
            large: "480px",
            fillParent: "100%",
            fitContent: "unset",
        };
        this.bgProviderService.$changeColor.subscribe((value) => {
            if (value === "dark") {
                this.darkBackground = true;
            }
            else if (value === "light") {
                this.darkBackground = false;
            }
        });
    }
    /**
     * Whether the min/max value labels should be displayed next to the slider.
     */
    get showLimitsValues() {
        return this._showLimitsValues;
    }
    set showLimitsValues(value) {
        this._showLimitsValues = coerceBooleanProperty(value);
    }
    /**
     * Whether the input element for displaying/controlling the slider value should be displayed next to the slider.
     */
    get showInput() {
        return this._showInput;
    }
    set showInput(value) {
        this._showInput = coerceBooleanProperty(value);
    }
    /**
     * If true, the component will be disabled.
     */
    get disabled() {
        return this._disabled;
    }
    set disabled(value) {
        this._disabled = coerceBooleanProperty(value);
    }
    /**
     * Whether the marks between each step should be shown or not.
     */
    get marks() {
        return this._marks;
    }
    set marks(value) {
        this._marks = coerceBooleanProperty(value);
    }
    /**
     * Value of the tabindex attribute.
     */
    get tabIndexValue() {
        return this._tabIndexValue;
    }
    set tabIndexValue(value) {
        this._tabIndexValue = coerceNumberProperty(value);
    }
    ngOnInit() {
        this.value = this.defaultValue ?? this.value;
        this.renderedValue = this.value;
        if (this.labelFormatCallback) {
            this.minValueLabel = this.labelFormatCallback(this.minValue).toString();
            this.maxValueLabel = this.labelFormatCallback(this.maxValue).toString();
        }
        else {
            this.minValueLabel = this.minValue;
            this.maxValueLabel = this.maxValue;
        }
        this.updateStyles(this.defaultInputs.getValue());
    }
    ngOnChanges(changes) {
        if (this.marks) {
            this.tickInterval = this.step > 1 ? 1 : 0;
        }
        this.isDisabled = this.disabled;
        this.renderedValue = this.value;
        const inputs = Object.keys(changes).reduce((result, item) => {
            result[item] = changes[item].currentValue;
            return result;
        }, {});
        this.defaultInputs.next({ ...this.defaultInputs.getValue(), ...inputs });
        this.updateStyles(this.defaultInputs.getValue());
    }
    updateStyles(inputs) {
        this.className = `${this.getDynamicStyle(inputs)}`;
        this.minValueClass = `${this.getMinLabelContainerClass()}`;
        this.maxValueClass = `${this.getMaxLabelContainerClass(inputs)}`;
    }
    /**
     * Executed while slider value moves or when user press a key in input
     * @param $event
     */
    valueChanged($event) {
        let newValue = ($event.target ? $event.target.value : $event.value) * 1;
        newValue = newValue < this.minValue ? this.minValue : newValue;
        newValue = newValue > this.maxValue ? this.maxValue : newValue;
        this.onChange.emit(newValue);
        if (this.value === undefined || this.value === null) {
            this.renderedValue = newValue;
        }
        else {
            $event.value = this.renderedValue;
            $event.source._value = this.renderedValue;
            $event.source._percent = this.renderedValue / 100;
        }
    }
    /**
     * Controlled dxc-input behaviour
     * @param $event
     */
    inputValueChanged($event) {
        let newValue = $event.value * 1;
        newValue = newValue < this.minValue ? this.minValue : newValue;
        newValue = newValue > this.maxValue ? this.maxValue : newValue;
        this.onChange.emit(newValue);
        if (this.value === undefined || this.value === null) {
            this.renderedValue = newValue;
        }
    }
    /**
     * Executed once the user has ended dragging
     * @param $event
     */
    mouseUp($event) {
        this.onDragEnd.emit(this.renderedValue);
    }
    calculateWidth(sizes, inputs) {
        if (inputs.size === "fillParent") {
            return css `
        width: calc(
          ${sizes[inputs.size]} - ${this.getMargin(inputs.margin, "left")} -
            ${this.getMargin(inputs.margin, "right")}
        );
      `;
        }
        return css `
      width: ${sizes[inputs.size]};
    `;
    }
    getMargin(paddingOrMargin, side) {
        if (paddingOrMargin && typeof paddingOrMargin === "object") {
            return (paddingOrMargin[side] && spaces[paddingOrMargin[side]]) || "0px";
        }
        return (paddingOrMargin && spaces[paddingOrMargin]) || "0px";
    }
    getDynamicStyle(inputs) {
        return css `
      .container {
        display: flex;
        flex-direction: column;
        ${this.calculateWidth(this.sizes, inputs)}
        ${this.utils.getMargins(inputs.margin)}
      }

      .sliderLabel {
        color: var(--slider-labelFontColor);
        font-family: var(--slider-labelFontFamily);
        font-size: var(--slider-labelFontSize);
        font-style: var(--slider-labelFontStyle);
        font-weight: var(--slider-labelFontWeight);
        line-height: var(--slider-labelLineHeight);
      }

      .sliderHelperText {
        color: var(--slider-helperTextFontColor);
        font-family: var(--slider-helperTextFontFamily);
        font-size: var(--slider-helperTextFontSize);
        font-style: var(--slider-helperTextFontstyle);
        font-weight: var(--slider-helperTextFontWeight);
        line-height: var(--slider-helperTextLineHeight);
      }

      .sliderContainer {
        display: flex;
        height: 48px;
        align-items: center;

        .mat-slider-has-ticks .mat-slider-wrapper::after {
          height: var(--slider-tickSize);
          border-left-width: 2px;
          top: var(--slider-tickVerticalPosition);
        }

        &.disabled {
          color: var(--slider-disabledFontColor) !important;
          cursor: not-allowed;
          input {
            cursor: not-allowed;
          }
        }
        mat-slider {
          flex-grow: 1;
          padding: 0px;
          .mat-slider-track-fill {
            height: 100%;
          }
          .mat-slider-ticks-container {
            height: var(--slider-tickSize);
            top: var(--slider-tickVerticalPosition);
          }
          .mat-slider-track-wrapper {
            top: var(--slider-lineVerticalPosition);
          }
          .mat-slider-track-wrapper,
          .mat-slider-track-background,
          .mat-slider-wrapper {
            height: var(--slider-lineThickness);
          }
          .mat-slider-focus-ring {
            background-color: transparent;
          }
          .mat-slider-thumb {
            transform: none !important;
            width: var(--slider-thumbWidth);
            height: var(--slider-thumbHeight);
            bottom: var(--slider-thumbVerticalPosition);
            &:hover {
              width: calc(var(--slider-thumbWidth) + 4px);
              height: calc(var(--slider-thumbHeight) + 4px);
              bottom: calc(var(--slider-thumbVerticalPosition) - 2px);
              background-color: var(--slider-hoverThumbBackgroundColor);
              border-color: var(--slider-hoverThumbBackgroundColor) !important;
            }
          }
          &:not(.mat-slider-disabled) {
            .mat-slider-ticks {
              height: var(--slider-tickSize);
            }
            &.mat-slider-sliding {
              .mat-slider-thumb {
                cursor: grabbing;
              }
            }
            &:focus:not(.mat-slider-sliding) {
              .mat-slider-thumb {
                transform: none;
                outline: -webkit-focus-ring-color auto 2px;
                outline-offset: 3px;
              }
              .mat-slider-focus-ring {
                width: 0px;
                height: 0px;
              }
            }
            &.mat-slider-has-ticks {
              .mat-slider-ticks {
                opacity: 1 !important;
              }
            }
          }
          &.mat-slider-disabled {
            pointer-events: none;
            .mat-slider-thumb {
              transform: none !important;
              bottom: var(--slider-disabledThumbVerticalPosition);
            }
            .mat-slider-ticks {
              height: var(--slider-tickSize);
            }
            .mat-slider-ticks-container {
              top: var(--slider-disabledTickVerticalPosition);
            }
          }
          &.cdk-focused,
          &.mat-slider-sliding {
            .mat-slider-thumb {
              width: calc(var(--slider-thumbWidth) + 4px);
              height: calc(var(--slider-thumbWidth) + 4px);
              bottom: calc(var(--slider-thumbVerticalPosition) - 2px);
            }
          }
        }
      }

      dxc-text-input {
        margin-left: 2rem;
        max-width: 70px;
      }
      ${this.darkBackground ? this.getDarkStyle() : this.getLightStyle()}
    `;
    }
    getMinLabelContainerClass() {
        return css `
      margin-right: 16px;
    `;
    }
    getMaxLabelContainerClass(inputs) {
        return css `
      margin-left: ${inputs.step === 1 ? "16px" : "20px"};
    `;
    }
    getDarkStyle() {
        return css `
      color: var(--slider-fontColorOnDark);
      .mat-slider-has-ticks .mat-slider-wrapper::after {
        border-color: var(--slider-tickBackgroundColorOnDark);
      }
      mat-slider {
        &:not(.mat-slider-disabled) {
          .mat-slider-track-fill {
            background-color: var(--slider-trackLineColorOnDark);
          }
          .mat-slider-track-background {
            background-color: var(--slider-totalLineColorOnDark) !important;
            opacity: 0.38;
          }
          .mat-slider-thumb {
            background-color: var(--slider-thumbBackgroundColorOnDark);
            border-color: var(--slider-thumbBackgroundColorOnDark) !important;
            &:hover {
              background-color: var(--slider-hoverThumbBackgroundColorOnDark);
              border-color: var(
                --slider-hoverThumbBackgroundColorOnDark
              ) !important;
            }
          }
          .mat-slider-ticks {
            background-image: repeating-linear-gradient(
              to right,
              var(--slider-tickBackgroundColorOnDark),
              var(--slider-tickBackgroundColorOnDark) var(--slider-tickSize)
                var(--slider-tickSize),
              transparent 2px,
              #e2141400
            );
          }
          &.mat-slider-sliding {
            .mat-slider-thumb {
              background-color: var(--slider-activeThumbBackgroundColorOnDark);
              border-color: var(
                --slider-activeThumbBackgroundColorOnDark
              ) !important;
            }
          }
          &:focus:not(.mat-slider-sliding) {
            .mat-slider-thumb {
              background-color: var(--slider-focusThumbBackgroundColorOnDark);
              border-color: var(
                --slider-focusThumbBackgroundColorOnDark
              ) !important;
              outline-color: var(--slider-focusColorOnDark);
            }
          }
        }
      }
      &.disabled {
        .mat-slider-horizontal .mat-slider-wrapper::after {
          border-color: var(--slider-disabledTickBackgroundColorOnDark);
        }
        .mat-slider-thumb {
          border-color: var(
            --slider-disabledThumbBackgroundColorOnDark
          ) !important;
          background-color: var(--slider-disabledThumbBackgroundColorOnDark);
        }
        .mat-slider-track-background {
          background-color: var(
            --slider-disabledTotalLineColorOnDark
          ) !important;
        }
        .mat-slider-track-fill {
          transform: translateX(2px) scale3d(0.5, 1, 1) !important;
          background-color: var(
            --slider-disabledTrackLineColorOnDark
          ) !important;
        }
        .mat-slider-ticks {
          background-image: repeating-linear-gradient(
            to right,
            var(--slider-disabledTickBackgroundColorOnDark),
            var(--slider-disabledTickBackgroundColorOnDark)
              var(--slider-tickSize) var(--slider-tickSize),
            transparent 2px,
            #e2141400
          );
        }
      }
    `;
    }
    getLightStyle() {
        return css `
      color: var(--slider-fontColor);
      .mat-slider-has-ticks .mat-slider-wrapper::after {
        border-color: var(--slider-tickBackgroundColor);
      }
      mat-slider {
        &:not(.mat-slider-disabled) {
          .mat-slider-track-fill {
            background-color: var(--slider-trackLineColor);
          }
          .mat-slider-track-background {
            background-color: var(--slider-totalLineColor) !important;
          }
          .mat-slider-thumb {
            background-color: var(--slider-thumbBackgroundColor);
            border-color: var(--slider-thumbBackgroundColor) !important;
          }
          .mat-slider-ticks {
            background-image: repeating-linear-gradient(
              to right,
              var(--slider-tickBackgroundColor),
              var(--slider-tickBackgroundColor) var(--slider-tickSize)
                var(--slider-tickSize),
              transparent 2px,
              #e2141400
            );
          }
          &.mat-slider-sliding {
            .mat-slider-thumb {
              background-color: var(--slider-activeThumbBackgroundColor);
              border-color: var(--slider-activeThumbBackgroundColor) !important;
            }
          }
          &:focus:not(.mat-slider-sliding) {
            .mat-slider-thumb {
              background-color: var(--slider-focusThumbBackgroundColor);
              border-color: var(--slider-focusThumbBackgroundColor) !important;
              outline-color: var(--slider-focusColor);
            }
          }
        }
      }
      &.disabled {
        .mat-slider-horizontal .mat-slider-wrapper::after {
          border-color: var(--slider-disabledTickBackgroundColor);
        }
        .mat-slider-thumb {
          border-color: var(--slider-disabledThumbBackgroundColor) !important;
          background-color: var(--slider-disabledThumbBackgroundColor);
        }
        .mat-slider-track-background {
          background-color: var(--slider-disabledTotalLineColor) !important;
        }
        .mat-slider-track-fill {
          transform: translateX(2px) scale3d(0.5, 1, 1) !important;
          background-color: var(--slider-disabledTrackLineColor) !important;
        }
        .mat-slider-ticks {
          background-image: repeating-linear-gradient(
            to right,
            var(--slider-disabledTickBackgroundColor),
            var(--slider-disabledTickBackgroundColor) var(--slider-tickSize)
              var(--slider-tickSize),
            transparent 2px,
            #e2141400
          );
        }
      }
    `;
    }
}
DxcSliderComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcSliderComponent, deps: [{ token: CssUtils, self: true }, { token: BackgroundProviderService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
DxcSliderComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.5", type: DxcSliderComponent, selector: "dxc-slider", inputs: { minValue: "minValue", maxValue: "maxValue", step: "step", showLimitsValues: "showLimitsValues", showInput: "showInput", value: "value", name: "name", label: "label", defaultValue: "defaultValue", helperText: "helperText", disabled: "disabled", marks: "marks", margin: "margin", size: "size", labelFormatCallback: "labelFormatCallback", tabIndexValue: "tabIndexValue" }, outputs: { onChange: "onChange", onDragEnd: "onDragEnd" }, host: { properties: { "class": "this.className", "class.disabled": "this.isDisabled" } }, providers: [CssUtils], usesOnChanges: true, ngImport: i0, template: "<div class=\"container\">\n  <label *ngIf=\"label\" class=\"sliderLabel\"> {{label}}</label>\n  <span *ngIf=\"helperText\" class=\"sliderHelperText\">{{helperText}}</span>\n  <div class=\"sliderContainer\">\n    <span\n    [ngClass]=\"disabled ? 'disabled-span' : ''\"\n    *ngIf=\"showLimitsValues\"\n    [class]=\"minValueClass\"\n    >\n    {{ minValueLabel }}</span\n    >\n    <mat-slider\n    disableRipple\n    [min]=\"minValue\"\n    [max]=\"maxValue\"\n    [step]=\"step\"\n    [value]=\"renderedValue\"\n    [tickInterval]=\"tickInterval\"\n    [disabled]=\"disabled\"\n    (input)=\"valueChanged($event)\"\n    (mouseup)=\"mouseUp($event)\"\n    [tabIndex]=\"tabIndexValue\"\n    ></mat-slider>\n    <span\n    [ngClass]=\"disabled ? 'disabled-span' : ''\"\n    *ngIf=\"showLimitsValues\"\n    [class]=\"maxValueClass\"\n    >\n    {{ maxValueLabel }}</span\n    >\n    <dxc-text-input\n    *ngIf=\"showInput\"\n    [value]=\"renderedValue\"\n    [name]=\"name\"\n    [disabled]=\"disabled\"\n    (onChange)=\"inputValueChanged($event)\"\n    size=\"fillParent\"\n    [tabIndex]=\"tabIndexValue\"\n    ></dxc-text-input>\n  </div>\n</div>\n", components: [{ type: i3$3.MatSlider, selector: "mat-slider", inputs: ["disabled", "color", "tabIndex", "invert", "max", "min", "step", "thumbLabel", "tickInterval", "value", "vertical", "displayWith", "valueText"], outputs: ["change", "input", "valueChange"], exportAs: ["matSlider"] }, { type: DxcTextInputComponent, selector: "dxc-text-input", inputs: ["label", "name", "value", "defaultValue", "helperText", "placeholder", "autocomplete", "disabled", "optional", "clearable", "error", "pattern", "minLength", "maxLength", "margin", "suggestions", "tabIndexValue", "size"], outputs: ["onChange", "onBlur", "onActionClick"] }], directives: [{ type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcSliderComponent, decorators: [{
            type: Component,
            args: [{ selector: "dxc-slider", providers: [CssUtils], template: "<div class=\"container\">\n  <label *ngIf=\"label\" class=\"sliderLabel\"> {{label}}</label>\n  <span *ngIf=\"helperText\" class=\"sliderHelperText\">{{helperText}}</span>\n  <div class=\"sliderContainer\">\n    <span\n    [ngClass]=\"disabled ? 'disabled-span' : ''\"\n    *ngIf=\"showLimitsValues\"\n    [class]=\"minValueClass\"\n    >\n    {{ minValueLabel }}</span\n    >\n    <mat-slider\n    disableRipple\n    [min]=\"minValue\"\n    [max]=\"maxValue\"\n    [step]=\"step\"\n    [value]=\"renderedValue\"\n    [tickInterval]=\"tickInterval\"\n    [disabled]=\"disabled\"\n    (input)=\"valueChanged($event)\"\n    (mouseup)=\"mouseUp($event)\"\n    [tabIndex]=\"tabIndexValue\"\n    ></mat-slider>\n    <span\n    [ngClass]=\"disabled ? 'disabled-span' : ''\"\n    *ngIf=\"showLimitsValues\"\n    [class]=\"maxValueClass\"\n    >\n    {{ maxValueLabel }}</span\n    >\n    <dxc-text-input\n    *ngIf=\"showInput\"\n    [value]=\"renderedValue\"\n    [name]=\"name\"\n    [disabled]=\"disabled\"\n    (onChange)=\"inputValueChanged($event)\"\n    size=\"fillParent\"\n    [tabIndex]=\"tabIndexValue\"\n    ></dxc-text-input>\n  </div>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: CssUtils, decorators: [{
                    type: Self
                }] }, { type: BackgroundProviderService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { className: [{
                type: HostBinding,
                args: ["class"]
            }], isDisabled: [{
                type: HostBinding,
                args: ["class.disabled"]
            }], minValue: [{
                type: Input
            }], maxValue: [{
                type: Input
            }], step: [{
                type: Input
            }], showLimitsValues: [{
                type: Input
            }], showInput: [{
                type: Input
            }], value: [{
                type: Input
            }], name: [{
                type: Input
            }], label: [{
                type: Input
            }], defaultValue: [{
                type: Input
            }], helperText: [{
                type: Input
            }], disabled: [{
                type: Input
            }], marks: [{
                type: Input
            }], margin: [{
                type: Input
            }], size: [{
                type: Input
            }], labelFormatCallback: [{
                type: Input
            }], tabIndexValue: [{
                type: Input
            }], onChange: [{
                type: Output
            }], onDragEnd: [{
                type: Output
            }] } });

class DxcSliderModule {
}
DxcSliderModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcSliderModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DxcSliderModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcSliderModule, declarations: [DxcSliderComponent], imports: [CommonModule, MatSliderModule, FormsModule, DxcTextInputModule], exports: [DxcSliderComponent] });
DxcSliderModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcSliderModule, imports: [[CommonModule, MatSliderModule, FormsModule, DxcTextInputModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcSliderModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [DxcSliderComponent],
                    imports: [CommonModule, MatSliderModule, FormsModule, DxcTextInputModule],
                    exports: [DxcSliderComponent],
                }]
        }] });

class DxcSpinnerComponent {
    constructor(utils) {
        this.utils = utils;
        /**
         * Available modes of the spinner ('large' | 'small' | 'overlay').
         */
        this.mode = "large";
        this._showValue = false;
        this.isOverlayed = false;
        this.isSmall = false;
        this.isLarge = true;
        this.isIndeterminate = true;
        this.largeSize = 140;
        this.smallSize = 16;
        this.radioLargeSize = 65;
        this.radioSmallSize = 6;
        this.defaultInputs = new BehaviorSubject({
            showValue: false,
            mode: "large",
            value: 0,
            label: null,
            margin: null,
        });
    }
    /**
     * If true, the value is displayed inside the spinner..
     */
    get showValue() {
        return this._showValue;
    }
    set showValue(value) {
        this._showValue = coerceBooleanProperty(value);
    }
    ngOnChanges(changes) {
        if (this.value || this.value === 0) {
            if (this.value <= 100 && this.value >= 0) {
                this.isIndeterminate = false;
            }
            else {
                if (this.value > 100) {
                    this.isIndeterminate = false;
                    this.value = 100;
                }
                else if (this.value < 0) {
                    this.isIndeterminate = false;
                    this.value = 0;
                }
                else {
                    this.value = undefined;
                    this.isIndeterminate = true;
                }
            }
        }
        else {
            this.isIndeterminate = true;
        }
        if (this.mode === "overlay") {
            this.isOverlayed = true;
            this.isLarge = false;
            this.isSmall = false;
        }
        else if (this.mode === "small") {
            this.isOverlayed = false;
            this.isLarge = false;
            this.isSmall = true;
        }
        else if (this.mode === "large") {
            this.isOverlayed = false;
            this.isLarge = true;
            this.isSmall = false;
        }
        const inputs = Object.keys(changes).reduce((result, item) => {
            result[item] = changes[item].currentValue;
            return result;
        }, {});
        this.defaultInputs.next({ ...this.defaultInputs.getValue(), ...inputs });
        this.className = `${this.getDynamicStyle(this.defaultInputs.getValue())}`;
    }
    ngOnInit() {
        this.className = `${this.getDynamicStyle(this.defaultInputs.getValue())}`;
        if (this.value) {
            this.isIndeterminate = false;
        }
    }
    ngAfterViewInit() {
        if (this.mode !== "small") {
            this.svgBackgroundLarge.nativeElement.setAttribute("viewBox", "0 0 " + this.largeSize + " " + this.largeSize);
            this.svgLarge.nativeElement.setAttribute("viewBox", "0 0 " + this.largeSize + " " + this.largeSize);
            this.circleBackgroundLarge.nativeElement.setAttribute("cx", this.largeSize / 2);
            this.circleBackgroundLarge.nativeElement.setAttribute("cy", this.largeSize / 2);
            this.circleLarge.nativeElement.setAttribute("cx", this.largeSize / 2);
            this.circleLarge.nativeElement.setAttribute("cy", this.largeSize / 2);
            this.circleBackgroundLarge.nativeElement.setAttribute("r", this.radioLargeSize);
            this.circleLarge.nativeElement.setAttribute("r", this.radioLargeSize);
        }
        else {
            this.svgBackgroundSmall.nativeElement.setAttribute("viewBox", "0 0 " + this.smallSize + " " + this.smallSize);
            this.svgSmall.nativeElement.setAttribute("viewBox", "0 0 " + this.smallSize + " " + this.smallSize);
            this.circleBackgroundSmall.nativeElement.setAttribute("cx", this.smallSize / 2);
            this.circleBackgroundSmall.nativeElement.setAttribute("cy", this.smallSize / 2);
            this.circleSmall.nativeElement.setAttribute("cx", this.smallSize / 2);
            this.circleSmall.nativeElement.setAttribute("cy", this.smallSize / 2);
            this.circleBackgroundSmall.nativeElement.setAttribute("r", this.radioSmallSize);
            this.circleSmall.nativeElement.setAttribute("r", this.radioSmallSize);
        }
    }
    calculateValue(strokeDashArray) {
        let val = 0;
        if (this.value >= 0 && this.value <= 100) {
            val = strokeDashArray * (1 - this.value / 100);
        }
        return val;
    }
    getSpinnerStyle() {
        return css `
      position: relative;
      z-index: 2;
      svg {
        transform: rotate(-90deg);
        top: 0;
        left: 0;
        transform-origin: center;
        overflow: visible;
      }
      circle {
        fill: transparent;
        stroke-linecap: initial;
        vector-effect: non-scaling-stroke;
      }
    `;
    }
    getIndeterminateStyle(inputs, size, strokeWidth, strokeDashArray) {
        return css `
      .spinnerIndeterminate {
        ${this.getSpinnerStyle()}
        height: ${size};
        width: ${size};
        svg {
          animation: 1.4s linear infinite both spinner-svg;
        }
        circle {
          ${inputs.mode !== "small"
            ? "animation: 1.4s ease-in-out infinite both svg-circle-large;"
            : "animation: 1.4s ease-in-out infinite both svg-circle-small;"}
          ${inputs.mode === "overlay"
            ? "stroke: var(--spinner-trackCircleColorOnDark);"
            : "stroke: var(--spinner-trackCircleColor);"}
          stroke-dasharray: ${strokeDashArray};
          stroke-width: ${strokeWidth}px;
          transform-origin: 50% 50%;
        }
      }
    `;
    }
    getDeterminateStyle(inputs, size, strokeWidth, strokeDashArray) {
        return css `
      .spinnerDeterminate {
        ${this.getSpinnerStyle()}
        height: ${size};
        width: ${size};
        circle {
          animation: none;
          ${inputs.mode === "overlay"
            ? "stroke: var(--spinner-trackCircleColorOnDark);"
            : "stroke: var(--spinner-trackCircleColor);"}
          stroke-width: ${strokeWidth}px;
          stroke-dashoffset: ${inputs.mode !== "small"
            ? this.calculateValue(408)
            : this.calculateValue(38)};
          stroke-dasharray: ${strokeDashArray};
        }
      }
    `;
    }
    getBackgroundCircleStyle(size, strokeWidth, strokeDashArray) {
        return css `
      .backgroundSpinner {
        height: ${size};
        width: ${size};
        position: absolute;
        z-index: 1;
        circle {
          animation: none;
          fill: transparent;
          stroke: var(--spinner-totalCircleColor);
          stroke-dasharray: ${strokeDashArray};
          stroke-linecap: initial;
          stroke-width: ${strokeWidth}px;
          transform-origin: 50% 50%;
          vector-effect: non-scaling-stroke;
        }
      }
    `;
    }
    getDynamicStyle(inputs) {
        return css `
      ${inputs.mode != "overlay" ? this.utils.getMargins(inputs.margin) : ""}
      display: inline-block;
      &.overlay {
        height: 100vh;
        width: 100vw;
        display: flex;
        position: fixed;
        top: 0;
        left: 0;
        justify-content: center;
        align-items: center;
        z-index: 1000;
      }
      .spinnerContainer {
        align-items: center;
        display: flex;
        height: inherit;
        justify-content: center;
        position: relative;
        width: inherit;
        .backOverlay {
          width: 100vw;
          height: 100vh;
          opacity: 1;
          transition: opacity 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
          position: fixed;
          top: 0;
          left: 0;
          background-color: var(--spinner-overlayBackgroundColor);
          opacity: var(--spinner-overlayOpacity);
        }
        &.overlayed {
          .labelsContainer {
            p {
              &.label {
                text-align: var(--spinner-overlayLabelTextAlign);
                font-family: var(--spinner-overlayLabelFontFamily);
                font-size: var(--spinner-overlayLabelFontSize);
                font-weight: var(--spinner-overlayLabelFontWeight);
                font-style: var(--spinner-overlayLabelFontStyle);
                color: var(--spinner-overlayLabelFontColor);
              }
              &.value {
                text-align: var(--spinner-overlayProgressValueTextAlign);
                font-family: var(--spinner-overlayProgressValueFontFamily);
                font-size: var(--spinner-overlayProgressValueFontSize);
                font-weight: var(--spinner-overlayProgressValueFontWeight);
                font-style: var(--spinner-overlayProgressValueFontStyle);
                color: var(--spinner-overlayProgressValueFontColor);
              }
            }
          }
        }
        &.overlayed,
        &.larger {
          ${this.getBackgroundCircleStyle("140px", 8.5, 408)}
          ${this.getIndeterminateStyle(inputs, "140px", 8.5, 408)}
          ${this.getDeterminateStyle(inputs, "140px", 8.5, 408)}
        }
        &.smaller {
          ${this.getBackgroundCircleStyle("16px", 2, 38)}
          ${this.getIndeterminateStyle(inputs, "16px", 2, 38)}
          ${this.getDeterminateStyle(inputs, "16px", 2, 38)}
        }
        .labelsContainer {
          display: block;
          margin: 0 auto;
          position: absolute;
          text-align: center;
          width: 110px;
          p {
            margin: 0;
            &.label,
            &.value {
              width: 100%;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            &.label {
              text-align: var(--spinner-labelTextAlign);
              font-family: var(--spinner-labelFontFamily);
              font-size: var(--spinner-labelFontSize);
              font-weight: var(--spinner-labelFontWeight);
              font-style: var(--spinner-labelFontStyle);
              color: var(--spinner-labelFontColor);
            }
            &.value {
              text-align: var(--spinner-progressValueTextAlign);
              font-family: var(--spinner-progressValueFontFamily);
              font-size: var(--spinner-progressValueFontSize);
              font-weight: var(--spinner-progressValueFontWeight);
              font-style: var(--spinner-progressValueFontStyle);
              color: var(--spinner-progressValueFontColor);
            }
          }
        }
        @keyframes spinner-svg {
          0% {
            transform: rotateZ(0deg);
          }
          100% {
            transform: rotateZ(360deg);
          }
        }
        @keyframes svg-circle-large {
          0% {
            stroke-dashoffset: 400;
            transform: rotate(0);
          }

          50% {
            stroke-dashoffset: 75;
            transform: rotate(45deg);
          }

          100% {
            stroke-dashoffset: 400;
            transform: rotate(360deg);
          }
        }
        @keyframes svg-circle-small {
          0% {
            stroke-dashoffset: 35;
            transform: rotate(0);
          }

          50% {
            stroke-dashoffset: 8;
            transform: rotate(45deg);
          }

          100% {
            stroke-dashoffset: 35;
            transform: rotate(360deg);
          }
        }
      }
    `;
    }
}
DxcSpinnerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcSpinnerComponent, deps: [{ token: CssUtils }], target: i0.ɵɵFactoryTarget.Component });
DxcSpinnerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.5", type: DxcSpinnerComponent, selector: "dxc-spinner", inputs: { value: "value", label: "label", mode: "mode", margin: "margin", showValue: "showValue" }, host: { properties: { "class": "this.className", "class.overlay": "this.isOverlayed", "class.small": "this.isSmall", "class.large": "this.isLarge" } }, providers: [CssUtils], viewQueries: [{ propertyName: "svgBackgroundLarge", first: true, predicate: ["svgBackgroundLarge"], descendants: true }, { propertyName: "svgBackgroundSmall", first: true, predicate: ["svgBackgroundSmall"], descendants: true }, { propertyName: "svgLarge", first: true, predicate: ["svgLarge"], descendants: true }, { propertyName: "svgSmall", first: true, predicate: ["svgSmall"], descendants: true }, { propertyName: "circleBackgroundLarge", first: true, predicate: ["circleBackgroundLarge"], descendants: true }, { propertyName: "circleBackgroundSmall", first: true, predicate: ["circleBackgroundSmall"], descendants: true }, { propertyName: "circleLarge", first: true, predicate: ["circleLarge"], descendants: true }, { propertyName: "circleSmall", first: true, predicate: ["circleSmall"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<div\n  class=\"spinnerContainer\"\n  [ngClass]=\"{\n    overlayed: mode === 'overlay',\n    smaller: mode === 'small',\n    larger: mode === 'large'\n  }\"\n>\n  <div class=\"backOverlay\" *ngIf=\"mode === 'overlay'\"></div>\n  <div class=\"backgroundSpinner\">\n    <svg *ngIf=\"mode !== 'small'\" #svgBackgroundLarge>\n      <circle #circleBackgroundLarge />\n    </svg>\n    <svg *ngIf=\"mode === 'small'\" #svgBackgroundSmall>\n      <circle #circleBackgroundSmall />\n    </svg>\n  </div>\n\n  <div\n    [ngClass]=\"isIndeterminate ? 'spinnerIndeterminate' : 'spinnerDeterminate'\"\n  >\n    <svg *ngIf=\"mode !== 'small'\" #svgLarge>\n      <circle #circleLarge />\n    </svg>\n    <svg *ngIf=\"mode === 'small'\" #svgSmall>\n      <circle #circleSmall />\n    </svg>\n  </div>\n\n  <div\n    *ngIf=\"mode !== 'small'\"\n    [ngClass]=\"{ notOverlayed: mode !== 'overlay' }\"\n    class=\"labelsContainer\"\n  >\n    <p class=\"label\">{{ label }}</p>\n    <p class=\"value\" *ngIf=\"(value || value === 0) && showValue\">\n      {{ value }}%\n    </p>\n  </div>\n</div>", directives: [{ type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcSpinnerComponent, decorators: [{
            type: Component,
            args: [{ selector: "dxc-spinner", providers: [CssUtils], template: "<div\n  class=\"spinnerContainer\"\n  [ngClass]=\"{\n    overlayed: mode === 'overlay',\n    smaller: mode === 'small',\n    larger: mode === 'large'\n  }\"\n>\n  <div class=\"backOverlay\" *ngIf=\"mode === 'overlay'\"></div>\n  <div class=\"backgroundSpinner\">\n    <svg *ngIf=\"mode !== 'small'\" #svgBackgroundLarge>\n      <circle #circleBackgroundLarge />\n    </svg>\n    <svg *ngIf=\"mode === 'small'\" #svgBackgroundSmall>\n      <circle #circleBackgroundSmall />\n    </svg>\n  </div>\n\n  <div\n    [ngClass]=\"isIndeterminate ? 'spinnerIndeterminate' : 'spinnerDeterminate'\"\n  >\n    <svg *ngIf=\"mode !== 'small'\" #svgLarge>\n      <circle #circleLarge />\n    </svg>\n    <svg *ngIf=\"mode === 'small'\" #svgSmall>\n      <circle #circleSmall />\n    </svg>\n  </div>\n\n  <div\n    *ngIf=\"mode !== 'small'\"\n    [ngClass]=\"{ notOverlayed: mode !== 'overlay' }\"\n    class=\"labelsContainer\"\n  >\n    <p class=\"label\">{{ label }}</p>\n    <p class=\"value\" *ngIf=\"(value || value === 0) && showValue\">\n      {{ value }}%\n    </p>\n  </div>\n</div>" }]
        }], ctorParameters: function () { return [{ type: CssUtils }]; }, propDecorators: { value: [{
                type: Input
            }], label: [{
                type: Input
            }], mode: [{
                type: Input
            }], margin: [{
                type: Input
            }], showValue: [{
                type: Input
            }], className: [{
                type: HostBinding,
                args: ["class"]
            }], isOverlayed: [{
                type: HostBinding,
                args: ["class.overlay"]
            }], isSmall: [{
                type: HostBinding,
                args: ["class.small"]
            }], isLarge: [{
                type: HostBinding,
                args: ["class.large"]
            }], svgBackgroundLarge: [{
                type: ViewChild,
                args: ["svgBackgroundLarge"]
            }], svgBackgroundSmall: [{
                type: ViewChild,
                args: ["svgBackgroundSmall"]
            }], svgLarge: [{
                type: ViewChild,
                args: ["svgLarge"]
            }], svgSmall: [{
                type: ViewChild,
                args: ["svgSmall"]
            }], circleBackgroundLarge: [{
                type: ViewChild,
                args: ["circleBackgroundLarge"]
            }], circleBackgroundSmall: [{
                type: ViewChild,
                args: ["circleBackgroundSmall"]
            }], circleLarge: [{
                type: ViewChild,
                args: ["circleLarge"]
            }], circleSmall: [{
                type: ViewChild,
                args: ["circleSmall"]
            }] } });

class DxcSpinnerModule {
}
DxcSpinnerModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcSpinnerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DxcSpinnerModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcSpinnerModule, declarations: [DxcSpinnerComponent], imports: [CommonModule], exports: [DxcSpinnerComponent] });
DxcSpinnerModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcSpinnerModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcSpinnerModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [DxcSpinnerComponent],
                    imports: [CommonModule],
                    exports: [DxcSpinnerComponent],
                }]
        }] });

class DxcSwitchComponent {
    constructor(utils, bgProviderService) {
        this.utils = utils;
        this.bgProviderService = bgProviderService;
        this.darkBackground = false;
        this.lightBackground = true;
        this._disabled = false;
        this._required = false;
        /**
         * Text to be placed next to the switch.
         */
        this.label = "";
        /**
         * Name attribute of the input element.
         */
        this.name = "";
        /**
         * Whether the label should appear after or before the switch.
         */
        this.labelPosition = "before";
        /**
         * Size of the component.
         */
        this.size = "fitContent";
        this._tabIndexValue = 0;
        this.defaultInputs = new BehaviorSubject({
            value: null,
            checked: false,
            disabled: false,
            required: false,
            name: null,
            labelPosition: "before",
            margin: null,
            size: "fitContent",
            tabIndexValue: 0,
        });
        this.sizes = {
            small: "60px",
            medium: "240px",
            large: "480px",
            fillParent: "100%",
            fitContent: "unset",
        };
        this.onChange = new EventEmitter();
        this.bgProviderService.$changeColor.subscribe((value) => {
            if (value === "dark") {
                this.lightBackground = false;
                this.darkBackground = true;
            }
            else if (value === "light") {
                this.lightBackground = true;
                this.darkBackground = false;
            }
        });
    }
    /**
     * If true, the component is checked. If undefined, the component will be uncontrolled and the value will be managed internally by the component.
     */
    get checked() {
        return this._checked;
    }
    set checked(value) {
        this._checked = coerceBooleanProperty(value);
    }
    /**
     * 	Initial state of the switch, only when it is uncontrolled.
     */
    get defaultChecked() {
        return this._defaultChecked;
    }
    set defaultChecked(value) {
        this._defaultChecked = coerceBooleanProperty(value);
    }
    /**
     * If true, the component will be disabled.
     */
    get disabled() {
        return this._disabled;
    }
    set disabled(value) {
        this._disabled = coerceBooleanProperty(value);
    }
    /**
     * If true, the switch will change its appearence, showing that the value is required.
     */
    get required() {
        return this._required;
    }
    set required(value) {
        this._required = coerceBooleanProperty(value);
    }
    /**
     * Value of the tabindex.
     */
    get tabIndexValue() {
        return this._tabIndexValue;
    }
    set tabIndexValue(value) {
        this._tabIndexValue = coerceNumberProperty(value);
    }
    ngOnChanges(changes) {
        this.renderedChecked = this.checked;
        this.labelPosition === "after" ? "after" : "before";
        const inputs = Object.keys(changes).reduce((result, item) => {
            result[item] = changes[item].currentValue;
            return result;
        }, {});
        this.defaultInputs.next({ ...this.defaultInputs.getValue(), ...inputs });
        this.className = `${this.getDynamicStyle(this.defaultInputs.getValue())}`;
    }
    ngOnInit() {
        this.renderedChecked = this.checked || this.defaultChecked;
        this.className = `${this.getDynamicStyle(this.defaultInputs.getValue())}`;
    }
    onChangeHandler($event) {
        this.onChange.emit($event.checked);
        if (this.checked === undefined || this.checked === null) {
            this.renderedChecked = $event.checked;
        }
        else {
            $event.checked = this.renderedChecked;
            $event.source._checked = this.renderedChecked;
            $event.source._inputElement.nativeElement.checked = this.renderedChecked;
        }
    }
    calculateWidth(margin, size) {
        if (size === "fillParent") {
            return css `
        width: ${this.sizes[size]};
      `;
        }
        return css `
      width: ${this.sizes[size]};
    `;
    }
    setTextAlign(labelPosition) {
        if (labelPosition === "before") {
            return css `
        text-align: end;
      `;
        }
    }
    getDarkStyle() {
        return css `
      &.dark {
        .mat-slide-toggle-thumb:not(.mat-checked) {
          background-color: var(--switch-uncheckedThumbBackgroundColorOnDark);
        }
        div.mat-slide-toggle-bar {
          background-color: var(--switch-uncheckedTrackBackgroundColorOnDark);
        }
        span.mat-slide-toggle-content {
          color: var(--switch-labelFontColorOnDark);
        }
        .mat-checked:not(.mat-disabled) {
          .mat-slide-toggle-thumb {
            background-color: var(--switch-checkedThumbBackgroundColorOnDark);
          }
          .mat-slide-toggle-bar {
            background-color: var(--switch-checkedTrackBackgroundColorOnDark);
          }
        }
        .mat-disabled {
          &.mat-checked .mat-slide-toggle-thumb {
            background-color: var(
              --switch-disabledCheckedThumbBackgroundColorOnDark
            ) !important;
          }
          &:not(.mat-checked) {
            .mat-slide-toggle-thumb {
              background-color: var(
                --switch-disabledUncheckedThumbBackgroundColorOnDark
              ) !important;
            }
            .mat-slide-toggle-bar {
              background-color: var(
                --switch-disabledUncheckedTrackBackgroundColorOnDark
              ) !important;
            }
          }
          .mat-slide-toggle-content {
            color: var(--switch-disabledLabelFontColorOnDark) !important;
          }
          .mat-slide-toggle-bar {
            background-color: var(
              --switch-disabledCheckedTrackBackgroundColorOnDark
            ) !important;
          }
        }
        .mat-slide-toggle:not(.mat-disabled).cdk-focused
          .mat-slide-toggle-persistent-ripple {
          outline: -webkit-focus-ring-color auto 1px;
          outline-offset: 2px;
          outline-color: var(--switch-thumbFocusColorOnDark);
        }
      }
    `;
    }
    getLightStyle() {
        return css `
      &.light {
        .mat-slide-toggle-thumb:not(.mat-checked) {
          background-color: var(--switch-uncheckedThumbBackgroundColor);
        }
        span.mat-slide-toggle-required {
          color: var(--switch-requiredColor);
        }
        div.mat-slide-toggle-bar {
          background-color: var(--switch-uncheckedTrackBackgroundColor);
        }
        span.mat-slide-toggle-content {
          color: var(--switch-labelFontColor);
        }
        .mat-checked:not(.mat-disabled) {
          .mat-slide-toggle-thumb {
            background-color: var(--switch-checkedThumbBackgroundColor);
          }
          .mat-slide-toggle-bar {
            background-color: var(--switch-checkedTrackBackgroundColor);
          }
        }
        .mat-disabled {
          &.mat-checked .mat-slide-toggle-thumb {
            background-color: var(
              --switch-disabledCheckedThumbBackgroundColor
            ) !important;
          }
          &:not(.mat-checked) {
            .mat-slide-toggle-thumb {
              background-color: var(
                --switch-disabledUncheckedThumbBackgroundColor
              ) !important;
            }
            .mat-slide-toggle-bar {
              background-color: var(
                --switch-disabledUncheckedTrackBackgroundColor
              ) !important;
            }
          }
          .mat-slide-toggle-content {
            color: var(--switch-disabledLabelFontColor) !important;
          }
          .mat-slide-toggle-bar {
            background-color: var(
              --switch-disabledCheckedTrackBackgroundColor
            ) !important;
          }
        }
        .mat-slide-toggle:not(.mat-disabled).cdk-focused
          .mat-slide-toggle-persistent-ripple {
          outline: -webkit-focus-ring-color auto 1px;
          outline-offset: 2px;
          outline-color: var(--switch-thumbFocusColor);
        }
      }
    `;
    }
    getDynamicStyle(inputs) {
        return css `
      ${this.utils.getMargins(inputs.margin)}
      ${this.utils.calculateWidth(this.sizes, inputs)}
      display: inline-flex;
      ${this.getLightStyle()}
      ${this.getDarkStyle()}
      mat-slide-toggle {
        margin-top: 5px;
        margin-bottom: 5px;
        display: inline-flex;
        height: auto;
        span.mat-slide-toggle-required {
          color: var(--switch-requiredColor);
        }
        div.mat-slide-toggle-thumb {
          height: var(--switch-thumbHeight);
          width: var(--switch-thumbWidth);
          position: absolute;
          top: -3px;
          right: var(--switch-thumbShift);
        }
        div.mat-slide-toggle-bar {
          height: var(--switch-trackHeight);
          margin: 15px;
          left: var(--switch-spaceBetweenLabelSwitch);
        }
        span.mat-slide-toggle-content {
          white-space: normal;
          ${this.setTextAlign(inputs.labelPosition)}
          font-family: var(--switch-labelFontFamily);
          font-size: var(--switch-labelFontSize);
          font-style: var(--switch-labelFontStyle);
          font-weight: var(--switch-labelFontWeight);
        }
      }
      .mat-slide-toggle:not(.mat-disabled).cdk-focused
        .mat-slide-toggle-persistent-ripple {
        opacity: 1;
        outline: solid 2px;
        margin: 5px;
        height: 29px;
        width: 30px;
      }
      .mat-slide-toggle.mat-checked .mat-ripple-element,
      .mat-slide-toggle:not(.mat-checked) .mat-ripple-element {
        background-color: transparent;
      }
      .mat-slide-toggle.mat-disabled {
        opacity: 1;
        .mat-slide-toggle-label {
          cursor: not-allowed;
        }
        .mat-slide-toggle-thumb {
          cursor: not-allowed;
        }
        .mat-slide-toggle-content {
          font-style: var(--switch-disabledLabelFontStyle);
        }
      }
    `;
    }
}
DxcSwitchComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcSwitchComponent, deps: [{ token: CssUtils }, { token: BackgroundProviderService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
DxcSwitchComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.5", type: DxcSwitchComponent, selector: "dxc-switch", inputs: { checked: "checked", defaultChecked: "defaultChecked", value: "value", disabled: "disabled", required: "required", label: "label", name: "name", labelPosition: "labelPosition", margin: "margin", size: "size", tabIndexValue: "tabIndexValue" }, outputs: { onChange: "onChange" }, host: { properties: { "class": "this.className", "class.dark": "this.darkBackground", "class.light": "this.lightBackground" } }, providers: [CssUtils], usesOnChanges: true, ngImport: i0, template: "<mat-slide-toggle\n  [checked]=\"renderedChecked\"\n  [labelPosition]=\"labelPosition ? labelPosition : 'before'\"\n  [disabled]=\"disabled\"\n  [required]=\"required\"\n  [name]=\"name\"\n  (change)=\"onChangeHandler($event)\"\n  [tabIndex]=\"disabled ? -1 : tabIndexValue\"\n>\n  <span\n    *ngIf=\"label\"\n    [ngClass]=\"labelPosition === 'after' ? 'label-after' : 'label-before'\"\n  >\n    <span *ngIf=\"required\" class=\"mat-slide-toggle-required\">*</span>\n    <span>{{ label }}</span>\n  </span>\n</mat-slide-toggle>\n", components: [{ type: i3$4.MatSlideToggle, selector: "mat-slide-toggle", inputs: ["disabled", "disableRipple", "color", "tabIndex", "name", "id", "labelPosition", "aria-label", "aria-labelledby", "required", "checked", "aria-describedby"], outputs: ["change", "toggleChange"], exportAs: ["matSlideToggle"] }], directives: [{ type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcSwitchComponent, decorators: [{
            type: Component,
            args: [{ selector: "dxc-switch", providers: [CssUtils], template: "<mat-slide-toggle\n  [checked]=\"renderedChecked\"\n  [labelPosition]=\"labelPosition ? labelPosition : 'before'\"\n  [disabled]=\"disabled\"\n  [required]=\"required\"\n  [name]=\"name\"\n  (change)=\"onChangeHandler($event)\"\n  [tabIndex]=\"disabled ? -1 : tabIndexValue\"\n>\n  <span\n    *ngIf=\"label\"\n    [ngClass]=\"labelPosition === 'after' ? 'label-after' : 'label-before'\"\n  >\n    <span *ngIf=\"required\" class=\"mat-slide-toggle-required\">*</span>\n    <span>{{ label }}</span>\n  </span>\n</mat-slide-toggle>\n" }]
        }], ctorParameters: function () { return [{ type: CssUtils }, { type: BackgroundProviderService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { className: [{
                type: HostBinding,
                args: ["class"]
            }], darkBackground: [{
                type: HostBinding,
                args: ["class.dark"]
            }], lightBackground: [{
                type: HostBinding,
                args: ["class.light"]
            }], checked: [{
                type: Input
            }], defaultChecked: [{
                type: Input
            }], value: [{
                type: Input
            }], disabled: [{
                type: Input
            }], required: [{
                type: Input
            }], label: [{
                type: Input
            }], name: [{
                type: Input
            }], labelPosition: [{
                type: Input
            }], margin: [{
                type: Input
            }], size: [{
                type: Input
            }], tabIndexValue: [{
                type: Input
            }], onChange: [{
                type: Output
            }] } });

class DxcSwitchModule {
}
DxcSwitchModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcSwitchModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DxcSwitchModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcSwitchModule, declarations: [DxcSwitchComponent], imports: [CommonModule,
        MatSlideToggleModule,
        FormsModule], exports: [DxcSwitchComponent] });
DxcSwitchModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcSwitchModule, imports: [[
            CommonModule,
            MatSlideToggleModule,
            FormsModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcSwitchModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [DxcSwitchComponent],
                    imports: [
                        CommonModule,
                        MatSlideToggleModule,
                        FormsModule,
                    ],
                    exports: [DxcSwitchComponent],
                }]
        }] });

class DxcTabIconComponent {
    constructor() { }
}
DxcTabIconComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcTabIconComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
DxcTabIconComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.5", type: DxcTabIconComponent, selector: "dxc-tab-icon", ngImport: i0, template: "<ng-content></ng-content>" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcTabIconComponent, decorators: [{
            type: Component,
            args: [{ selector: "dxc-tab-icon", template: "<ng-content></ng-content>" }]
        }], ctorParameters: function () { return []; } });

class TabService {
    constructor() {
        this.iconPosition = new BehaviorSubject(undefined);
    }
}
TabService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: TabService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
TabService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: TabService, providedIn: "root" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: TabService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: "root",
                }]
        }], ctorParameters: function () { return []; } });

class DxcBadgeComponent {
    constructor(utils) {
        this.utils = utils;
        this.defaultInputs = new BehaviorSubject({});
    }
    ngOnChanges(changes) {
        if (this.notificationText > 99) {
            this.notificationText = "+99";
        }
        const inputs = Object.keys(changes).reduce((result, item) => {
            result[item] = changes[item].currentValue;
            return result;
        }, {});
        this.defaultInputs.next({ ...this.defaultInputs.getValue(), ...inputs });
        this.className = `${this.getDynamicStyle(this.defaultInputs.getValue())}`;
    }
    ngOnInit() {
        this.className = `${this.getDynamicStyle(this.defaultInputs.getValue())}`;
    }
    getDynamicStyle(inputs) {
        return css `
      display: flex;
      padding-bottom: 1px;
      padding-right: 1px;
      flex-wrap: wrap;
      box-sizing: border-box;
      align-items: center;
      line-height: 1;
      align-content: center;
      flex-direction: row;
      justify-content: center;
      background-color: var(--tabs-badgeBackgroundColor);
      font-family: var(--tabs-badgeFontFamily);
      font-size: var(--tabs-badgeFontSize);
      font-style: var(--tabs-badgeFontStyle);
      font-weight: var(--tabs-badgeFontWeight);
      color: var(--tabs-badgeFontColor);
      letter-spacing: var("--tabs-badgeLetterSpacing);
      width: ${!this.notificationText
            ? "var(--tabs-badgeWidth)"
            : "var(--tabs-badgeWidthWithNotificationNumber)"};
      height: ${!this.notificationText
            ? "var(--tabs-badgeHeight)"
            : "var(--tabs-badgeHeightWithNotificationNumber)"};
      border-radius: ${!this.notificationText
            ? "var(--tabs-badgeRadius)"
            : "var(--tabs-badgeRadiusWithNotificationNumber)"};
    `;
    }
}
DxcBadgeComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcBadgeComponent, deps: [{ token: CssUtils }], target: i0.ɵɵFactoryTarget.Component });
DxcBadgeComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.5", type: DxcBadgeComponent, selector: "dxc-badge", inputs: { notificationText: "notificationText" }, host: { properties: { "class": "this.className" } }, providers: [CssUtils], usesOnChanges: true, ngImport: i0, template: "<span>{{notificationText}}</span>" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcBadgeComponent, decorators: [{
            type: Component,
            args: [{ selector: "dxc-badge", providers: [CssUtils], template: "<span>{{notificationText}}</span>" }]
        }], ctorParameters: function () { return [{ type: CssUtils }]; }, propDecorators: { className: [{
                type: HostBinding,
                args: ["class"]
            }], notificationText: [{
                type: Input
            }] } });

class DxcTabComponent {
    constructor(cdRef, service) {
        this.cdRef = cdRef;
        this.service = service;
        /**
         * Whether the tab is disabled or not.
         */
        this.disabled = false;
        /**
         * This event will emit when the user clicks on a tab. The index
         * of the clicked tab will be passed as a parameter.
         */
        this.onTabClick = new EventEmitter();
        /**
         * This event will emit when the user is on hover on a tab.
         */
        this.onTabHover = new EventEmitter();
        this.showDotIndicator = false;
        this.tabIcon = false;
        this.service.iconPosition.subscribe((value) => {
            if (value) {
                this.iconPosition = value;
                this.getLabelClass();
            }
        });
    }
    ngOnInit() {
        this.notificationValue =
            typeof this.notificationNumber === "boolean"
                ? ""
                : this.notificationNumber;
    }
    ngOnChanges() {
        this.getLabelClass();
        if (this.matTab) {
            this.matTab.disabled = this.disabled;
            this.cdRef.detectChanges();
        }
    }
    ngAfterViewInit() {
        if (this.dxcTabIcon.length !== 0) {
            this.iconSrc = "";
            this.tabIcon = true;
        }
        this.getLabelClass();
        this.matTab.disabled = this.disabled;
        this.cdRef.detectChanges();
    }
    onClickHandler() {
        if (!this.matTab.disabled) {
            this.onTabClick.emit(this.id);
        }
        else {
            this.matTab.isActive = false;
        }
    }
    onHoverHandler() {
        this.onTabHover.emit();
    }
    getLabelClass() {
        if ((this.iconSrc || this.tabIcon) && this.label) {
            if (this.iconPosition === "top") {
                this.labelClass = "icon-top";
            }
            else {
                this.labelClass = "icon-left";
            }
        }
        else if (!this.iconSrc && !this.tabIcon) {
            this.labelClass = "only-text";
        }
        else {
            this.labelClass = "only-icon";
        }
    }
}
DxcTabComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcTabComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: TabService }], target: i0.ɵɵFactoryTarget.Component });
DxcTabComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.5", type: DxcTabComponent, selector: "dxc-tab", inputs: { label: "label", iconSrc: "iconSrc", disabled: "disabled", notificationNumber: "notificationNumber", id: "id" }, outputs: { onTabClick: "onTabClick", onTabHover: "onTabHover" }, queries: [{ propertyName: "dxcTabIcon", predicate: DxcTabIconComponent }], viewQueries: [{ propertyName: "matTab", first: true, predicate: MatTab, descendants: true }], usesOnChanges: true, ngImport: i0, template: "<mat-tab [disabled]=\"disabled\">\n  <ng-template mat-tab-label>\n    <div [ngClass]=\"labelClass\">\n      <img *ngIf=\"iconSrc\" src=\"{{ iconSrc }}\" />\n      <ng-content select=\"dxc-tab-icon\"></ng-content>\n      <div class=\"dxc-tab-label\">\n        <span>{{ label }}</span>\n      </div>\n      <dxc-badge\n        *ngIf=\"notificationNumber\"\n        [notificationText]=\"notificationValue\"\n      ></dxc-badge>\n    </div>\n  </ng-template>\n  <ng-content></ng-content>\n</mat-tab>\n", components: [{ type: i2$3.MatTab, selector: "mat-tab", inputs: ["disabled", "label", "aria-label", "aria-labelledby"], exportAs: ["matTab"] }, { type: DxcBadgeComponent, selector: "dxc-badge", inputs: ["notificationText"] }], directives: [{ type: i2$3.MatTabLabel, selector: "[mat-tab-label], [matTabLabel]" }, { type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcTabComponent, decorators: [{
            type: Component,
            args: [{ selector: "dxc-tab", template: "<mat-tab [disabled]=\"disabled\">\n  <ng-template mat-tab-label>\n    <div [ngClass]=\"labelClass\">\n      <img *ngIf=\"iconSrc\" src=\"{{ iconSrc }}\" />\n      <ng-content select=\"dxc-tab-icon\"></ng-content>\n      <div class=\"dxc-tab-label\">\n        <span>{{ label }}</span>\n      </div>\n      <dxc-badge\n        *ngIf=\"notificationNumber\"\n        [notificationText]=\"notificationValue\"\n      ></dxc-badge>\n    </div>\n  </ng-template>\n  <ng-content></ng-content>\n</mat-tab>\n" }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: TabService }]; }, propDecorators: { label: [{
                type: Input
            }], iconSrc: [{
                type: Input
            }], disabled: [{
                type: Input
            }], notificationNumber: [{
                type: Input
            }], onTabClick: [{
                type: Output
            }], onTabHover: [{
                type: Output
            }], id: [{
                type: Input
            }], matTab: [{
                type: ViewChild,
                args: [MatTab, { static: false }]
            }], dxcTabIcon: [{
                type: ContentChildren,
                args: [DxcTabIconComponent]
            }] } });

const globalRippleConfig = {
    animation: {
        enterDuration: 0,
        exitDuration: 0,
    },
};
class DxcTabsComponent {
    constructor(utils, _element, cdRef, service) {
        this.utils = utils;
        this._element = _element;
        this.cdRef = cdRef;
        this.service = service;
        this._activeTabIndex = 0;
        this._defaultActiveTabIndex = 0;
        /**
         * Position of icons in tabs.
         */
        this.iconPosition = "left";
        this.allTabWithLabelAndIcon = false;
        this.defaultInputs = new BehaviorSubject({
            activeTabIndex: 0,
            iconPosition: "left",
            margin: null,
        });
    }
    /**
     * The index of the active tab.
     */
    get activeTabIndex() {
        return this._activeTabIndex;
    }
    set activeTabIndex(value) {
        this._activeTabIndex = coerceNumberProperty(value);
    }
    /**
     * Initially active tab, only when it is uncontrolled
     */
    get defaultActiveTabIndex() {
        return this._defaultActiveTabIndex;
    }
    set defaultActiveTabIndex(value) {
        this._defaultActiveTabIndex = coerceNumberProperty(value);
    }
    ngOnChanges(changes) {
        this.service.iconPosition.next(this.iconPosition || "left");
        this.renderedActiveTabIndex = this.activeTabIndex;
        if (this.tabs && this.tabs.length > 0) {
            this.generateTabs();
        }
        const inputs = Object.keys(changes).reduce((result, item) => {
            result[item] = changes[item].currentValue;
            return result;
        }, {});
        this.defaultInputs.next({ ...this.defaultInputs.getValue(), ...inputs });
        this.className = `${this.getDynamicStyle(this.defaultInputs.getValue())}`;
    }
    ngOnInit() {
        this.service.iconPosition.next(this.iconPosition || "left");
        this.activeTabIndex = this.defaultActiveTabIndex
            ? this.defaultActiveTabIndex
            : this.activeTabIndex;
        this.renderedActiveTabIndex = this.activeTabIndex;
        this.className = `${this.getDynamicStyle(this.defaultInputs.getValue())}`;
    }
    onSelectedTabChangeHandler($event) {
        this.setActiveTab();
    }
    setActiveTab() {
        if (this.activeTabIndex) {
            this.tabGroup.selectedIndex = this.renderedActiveTabIndex;
        }
    }
    ngAfterViewInit() {
        this.generateTabs();
        this.className = `${this.getDynamicStyle(this.defaultInputs.getValue())}`;
        this.insertUnderline();
        this.cdRef.detectChanges();
        this.setEventListeners();
        this.cdRef.detectChanges();
        this.tabs.changes.subscribe((value) => {
            const matTabsFromQueryList = value.map((tab, index) => {
                if (tab.label && tab.iconSrc) {
                    this.allTabWithLabelAndIcon = true;
                }
                tab.id = index;
                return tab.matTab;
            });
            const list = new QueryList();
            list.reset([matTabsFromQueryList]);
            this.tabGroup._tabs = list;
            this.setActiveTab();
            this.cdRef.detectChanges();
        });
    }
    hasLabelAndIcon() {
        return (this.tabs &&
            this.tabs.filter((tab) => tab.label !== null && tab.iconSrc !== null)
                .length > 0);
    }
    generateTabs() {
        const matTabsFromQueryList = this.tabs.map((tab, index) => {
            if (tab.label && tab.iconSrc) {
                this.allTabWithLabelAndIcon = true;
            }
            tab.id = index;
            return tab.matTab;
        });
        const list = new QueryList();
        list.reset([matTabsFromQueryList]);
        this.tabGroup._tabs = list;
        this.setActiveTab();
    }
    setEventListeners() {
        let tabLabels = this._element.nativeElement.getElementsByClassName("mat-tab-label");
        if (tabLabels?.length > 0) {
            this.tabs.map((tab, index) => {
                tabLabels[index].addEventListener("click", function () {
                    tab.onClickHandler();
                });
                tabLabels[index].addEventListener("mouseenter", function () {
                    tab.onHoverHandler();
                });
            });
        }
    }
    insertUnderline() {
        let tabList = this._element.nativeElement.getElementsByClassName("mat-tab-list")[0];
        tabList.insertAdjacentHTML("beforeend", '<div class="underline"></div>');
    }
    getDynamicStyle(inputs) {
        return css `
      .mat-tab-header-pagination-controls-enabled .mat-tab-header-pagination {
        box-shadow: none;
      }
      .mat-tab-list .underline {
        height: var(--tabs-dividerThickness);
        width: 100%;
        background-color: var(--tabs-dividerColor);
      }
      .mat-tab-group {
        position: relative;
        display: flex;
        flex-direction: column;
        ${this.utils.getMargins(inputs.margin)}
        .mat-tab-header {
          background-color: white;
        }
        .mat-ink-bar {
          background-color: var(--tabs-selectedUnderlineColor);
          height: var(--tabs-selectedUnderlineThickness);
        }
      }
      .mat-tab-list .mat-tab-label {
        height: ${this.getTabHeight()} !important;
        padding-right: 16px;
        padding-left: 16px;
        min-width: 90px;
        max-width: 360px;
        text-transform: var(--tabs-fontTextTransform) !important;
        opacity: 1 !important;
        color: var(--tabs-unselectedFontColor);
        background: var(--tabs-unselectedBackgroundColor) 0% 0% no-repeat;
        .dxc-tab-label span:not(.show-dot) {
          opacity: 1;
          white-space: normal;
        }
        .dxc-tab-label span {
          color: var(--tabs-fontColor);
          opacity: 1;
          font-family: var(--tabs-fontFamily);
          font-size: var(--tabs-fontSize);
          font-style: var(--tabs-fontStyle);
          font-weight: var(--tabs-fontWeight);
        }
        &.cdk-focused {
          outline: -webkit-focus-ring-color auto 1px;
          outline-color: var(--tabs-focusOutline);
          background-color: var(--tabs-hoverBackgroundColor) !important;
        }
        dxc-tab-icon {
          fill: var(--tabs-fontColor);
        }
        .mat-ripple-element {
          font-weight: var(--tabs-pressedFontWeight) !important;
          background-color: var(--tabs-pressedBackgroundColor);
        }
        .mat-tab-label-content {
          font-size: 16px;
          display: inline-grid;
          text-align: -webkit-center;
          z-index: 1;

          dxc-badge {
            position: absolute;
            top: 12px;
            right: 4px;
          }

          img,
          svg {
            width: 22px;
            height: 22px;
          }
        }
        .icon-left {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          dxc-tab-icon {
            padding-right: 12px;
            align-items: center;
            justify-content: center;
            display: flex;
          }
        }
        .icon-top {
          min-height: 72px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
        }
        .only-text {
          min-height: 46px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
        }
        .only-icon {
          min-height: 64px;
          .dxc-tab-label {
            margin-top: 4px;
            display: grid;
          }
        }
        &.mat-tab-label-active {
          background-color: var(--tabs-selectedBackgroundColor);
          opacity: 1 !important;
          .dxc-tab-label span {
            color: var(--tabs-selectedFontColor);
            opacity: 1;
            white-space: normal;
          }
          dxc-tab-icon {
            fill: var(--tabs-selectedIconColor);
          }
        }
        &.mat-tab-disabled {
          .dxc-tab-label span {
            color: var(--tabs-disabledFontColor) !important;
            font-style: var(--tabs-disabledFontStyle);
          }
          dxc-tab-icon {
            fill: var(--tabs-disabledIconColor);
          }
          opacity: 0.5 !important;
          cursor: not-allowed;
          pointer-events: all !important;
        }
      }
      &.label-icons {
        .mat-tab-list .mat-tab-label {
          height: 76px;
        }
      }
    `;
    }
    getTabHeight() {
        return (((!this.hasLabelAndIcon ||
            (this.hasLabelAndIcon &&
                this.defaultInputs.value.iconPosition !== "top")) &&
            "48px") ||
            "72px");
    }
}
DxcTabsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcTabsComponent, deps: [{ token: CssUtils }, { token: i0.ElementRef }, { token: i0.ChangeDetectorRef }, { token: TabService }], target: i0.ɵɵFactoryTarget.Component });
DxcTabsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.5", type: DxcTabsComponent, selector: "dxc-tabs", inputs: { activeTabIndex: "activeTabIndex", defaultActiveTabIndex: "defaultActiveTabIndex", iconPosition: "iconPosition", margin: "margin" }, host: { properties: { "class": "this.className", "class.label-icons": "this.allTabWithLabelAndIcon" } }, providers: [
        CssUtils,
        TabService,
        { provide: MAT_RIPPLE_GLOBAL_OPTIONS, useValue: globalRippleConfig },
    ], queries: [{ propertyName: "tabs", predicate: DxcTabComponent }], viewQueries: [{ propertyName: "ripple", first: true, predicate: MatRipple, descendants: true }, { propertyName: "tabGroup", first: true, predicate: ["tabGroup"], descendants: true, static: true }], usesOnChanges: true, ngImport: i0, template: "<mat-tab-group\n  #tabGroup\n  matRipple \n  [ngClass]=\"'filled-tabs'\"\n  [selectedIndex]=\"renderedActiveTabIndex\"\n  (selectedTabChange)=\"onSelectedTabChangeHandler($event)\"\n>\n  <ng-content #outlet></ng-content>\n</mat-tab-group>\n", styles: [":host .filled-tabs ::ng-deep .mat-ink-bar{background-color:var(--tabs-selectedUnderlineColor)}:host ::ng-deep .mat-tab-list .mat-tab-labels .mat-tab-label:hover:not(.mat-tab-disabled){background-color:var(--tabs-hoverBackgroundColor)}\n"], components: [{ type: i2$3.MatTabGroup, selector: "mat-tab-group", inputs: ["color", "disableRipple"], exportAs: ["matTabGroup"] }], directives: [{ type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcTabsComponent, decorators: [{
            type: Component,
            args: [{ selector: "dxc-tabs", providers: [
                        CssUtils,
                        TabService,
                        { provide: MAT_RIPPLE_GLOBAL_OPTIONS, useValue: globalRippleConfig },
                    ], template: "<mat-tab-group\n  #tabGroup\n  matRipple \n  [ngClass]=\"'filled-tabs'\"\n  [selectedIndex]=\"renderedActiveTabIndex\"\n  (selectedTabChange)=\"onSelectedTabChangeHandler($event)\"\n>\n  <ng-content #outlet></ng-content>\n</mat-tab-group>\n", styles: [":host .filled-tabs ::ng-deep .mat-ink-bar{background-color:var(--tabs-selectedUnderlineColor)}:host ::ng-deep .mat-tab-list .mat-tab-labels .mat-tab-label:hover:not(.mat-tab-disabled){background-color:var(--tabs-hoverBackgroundColor)}\n"] }]
        }], ctorParameters: function () { return [{ type: CssUtils }, { type: i0.ElementRef }, { type: i0.ChangeDetectorRef }, { type: TabService }]; }, propDecorators: { activeTabIndex: [{
                type: Input
            }], defaultActiveTabIndex: [{
                type: Input
            }], iconPosition: [{
                type: Input
            }], margin: [{
                type: Input
            }], className: [{
                type: HostBinding,
                args: ["class"]
            }], allTabWithLabelAndIcon: [{
                type: HostBinding,
                args: ["class.label-icons"]
            }], ripple: [{
                type: ViewChild,
                args: [MatRipple]
            }], tabGroup: [{
                type: ViewChild,
                args: ["tabGroup", { static: true }]
            }], tabs: [{
                type: ContentChildren,
                args: [DxcTabComponent]
            }] } });

class DxcBadgeModule {
}
DxcBadgeModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcBadgeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DxcBadgeModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcBadgeModule, declarations: [DxcBadgeComponent], imports: [CommonModule], exports: [DxcBadgeComponent] });
DxcBadgeModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcBadgeModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcBadgeModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [DxcBadgeComponent],
                    imports: [CommonModule],
                    exports: [DxcBadgeComponent],
                }]
        }] });

class DxcTabsModule {
}
DxcTabsModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcTabsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DxcTabsModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcTabsModule, declarations: [DxcTabsComponent, DxcTabComponent, DxcTabIconComponent], imports: [CommonModule,
        MatInputModule,
        MatTabsModule,
        MatFormFieldModule,
        DxcBadgeModule,
        FormsModule], exports: [DxcTabsComponent, DxcTabComponent, DxcTabIconComponent] });
DxcTabsModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcTabsModule, imports: [[
            CommonModule,
            MatInputModule,
            MatTabsModule,
            MatFormFieldModule,
            DxcBadgeModule,
            FormsModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcTabsModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [DxcTabsComponent, DxcTabComponent, DxcTabIconComponent],
                    imports: [
                        CommonModule,
                        MatInputModule,
                        MatTabsModule,
                        MatFormFieldModule,
                        DxcBadgeModule,
                        FormsModule,
                    ],
                    exports: [DxcTabsComponent, DxcTabComponent, DxcTabIconComponent],
                    entryComponents: [MatTab, MatTabGroup],
                }]
        }] });

class InputTextService {
    constructor() {
        this.isDisabled = new BehaviorSubject(false);
        this.hasPrefixIcon = new BehaviorSubject(false);
    }
    setIsDisabled(value) {
        this.isDisabled.next(value);
    }
    setHasPrefixIcon(value) {
        this.hasPrefixIcon.next(value);
    }
}
InputTextService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: InputTextService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
InputTextService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: InputTextService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: InputTextService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return []; } });

class DxcInputPrefixIconComponent {
    constructor(service) {
        this.service = service;
        this.onClickPrefix = new EventEmitter();
        this.hasOnClick = false;
        this.isDisabled = false;
    }
    get tabIndexValue() {
        return this._tabIndexValue;
    }
    set tabIndexValue(value) {
        this._tabIndexValue = coerceNumberProperty(value);
    }
    prefixClicked() {
        this.onClickPrefix.emit();
    }
    ngOnChanges() { }
    ngOnInit() {
        this.service.isDisabled.subscribe((value) => {
            if (value) {
                this.isDisabled = value;
            }
        });
        if (this.onClickPrefix.observers.length > 0) {
            this.hasOnClick = true;
        }
        this.service.setHasPrefixIcon(true);
    }
}
DxcInputPrefixIconComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcInputPrefixIconComponent, deps: [{ token: InputTextService }], target: i0.ɵɵFactoryTarget.Component });
DxcInputPrefixIconComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.5", type: DxcInputPrefixIconComponent, selector: "dxc-input-prefix-icon", inputs: { tabIndexValue: "tabIndexValue" }, outputs: { onClickPrefix: "onClickPrefix" }, host: { listeners: { "click": "prefixClicked()" }, properties: { "class.onClickIconElement": "this.hasOnClick" } }, usesOnChanges: true, ngImport: i0, template: "<div class=\"containerIcon\" [tabindex]=\"hasOnClick && !isDisabled ? tabIndexValue : -1\">\n  <ng-content></ng-content>\n</div>\n" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcInputPrefixIconComponent, decorators: [{
            type: Component,
            args: [{ selector: "dxc-input-prefix-icon", template: "<div class=\"containerIcon\" [tabindex]=\"hasOnClick && !isDisabled ? tabIndexValue : -1\">\n  <ng-content></ng-content>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: InputTextService }]; }, propDecorators: { tabIndexValue: [{
                type: Input
            }], onClickPrefix: [{
                type: Output
            }], hasOnClick: [{
                type: HostBinding,
                args: ["class.onClickIconElement"]
            }], prefixClicked: [{
                type: HostListener,
                args: ["click"]
            }] } });

class DxcInputSuffixIconComponent {
    constructor(service) {
        this.service = service;
        this.onClickSuffix = new EventEmitter();
        this.hasOnClick = false;
        this.isDisabled = false;
    }
    get tabIndexValue() {
        return this._tabIndexValue;
    }
    set tabIndexValue(value) {
        this._tabIndexValue = coerceNumberProperty(value);
    }
    suffixClicked() {
        this.onClickSuffix.emit();
    }
    ngOnInit() {
        this.service.isDisabled.subscribe((value) => {
            if (value) {
                this.isDisabled = value;
            }
        });
        if (this.onClickSuffix.observers.length > 0) {
            this.hasOnClick = true;
        }
    }
    ngOnChanges() { }
}
DxcInputSuffixIconComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcInputSuffixIconComponent, deps: [{ token: InputTextService }], target: i0.ɵɵFactoryTarget.Component });
DxcInputSuffixIconComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.5", type: DxcInputSuffixIconComponent, selector: "dxc-input-suffix-icon", inputs: { tabIndexValue: "tabIndexValue" }, outputs: { onClickSuffix: "onClickSuffix" }, host: { listeners: { "click": "suffixClicked()" }, properties: { "class.onClickIconElement": "this.hasOnClick" } }, usesOnChanges: true, ngImport: i0, template: "<div class=\"containerIcon\" [tabindex]=\"hasOnClick && !isDisabled ? tabIndexValue : -1\">\n    <ng-content></ng-content>\n</div>" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcInputSuffixIconComponent, decorators: [{
            type: Component,
            args: [{ selector: "dxc-input-suffix-icon", template: "<div class=\"containerIcon\" [tabindex]=\"hasOnClick && !isDisabled ? tabIndexValue : -1\">\n    <ng-content></ng-content>\n</div>" }]
        }], ctorParameters: function () { return [{ type: InputTextService }]; }, propDecorators: { tabIndexValue: [{
                type: Input
            }], onClickSuffix: [{
                type: Output
            }], hasOnClick: [{
                type: HostBinding,
                args: ["class.onClickIconElement"]
            }], suffixClicked: [{
                type: HostListener,
                args: ["click"]
            }] } });

class DxcInputTextComponent {
    constructor(utils, ref, service, bgProviderService) {
        this.utils = utils;
        this.ref = ref;
        this.service = service;
        this.bgProviderService = bgProviderService;
        this.isDisabled = false;
        this.lightBackground = true;
        this.darkBackground = false;
        this.hasPrefixIcon = false;
        this._disabled = false;
        this._required = false;
        this._invalid = false;
        this.onClickSuffix = new EventEmitter();
        this.onClickPrefix = new EventEmitter();
        this.onChange = new EventEmitter();
        this.onBlur = new EventEmitter();
        this.prefixPointer = false;
        this.suffixPointer = false;
        this.loading = new BehaviorSubject(false);
        this.isError = new BehaviorSubject(false);
        this.renderedValue = "";
        this.dxcAutocompleteMenu = this.getAutoCompleteStyle();
        this.selectionStart = 0;
        this.selectionEnd = 0;
        this.clicked = false;
        this.sizes = {
            small: "42px",
            medium: "240px",
            large: "480px",
            fillParent: "100%",
        };
        this.defaultInputs = new BehaviorSubject({
            prefix: null,
            suffix: null,
            prefixIconSrc: null,
            suffixIconSrc: null,
            disabled: false,
            required: false,
            invalid: false,
            label: null,
            assistiveText: null,
            placeholder: null,
            name: null,
            value: null,
            margin: null,
            size: "medium",
            isMasked: false,
            tabIndexValue: 0,
        });
        this.bgProviderService.$changeColor.subscribe((value) => {
            if (value === "dark") {
                this.lightBackground = false;
                this.darkBackground = true;
            }
            else if (value === "light") {
                this.lightBackground = true;
                this.darkBackground = false;
            }
        });
    }
    get disabled() {
        return this._disabled;
    }
    set disabled(value) {
        this._disabled = coerceBooleanProperty(value);
    }
    get required() {
        return this._required;
    }
    set required(value) {
        this._required = coerceBooleanProperty(value);
    }
    get invalid() {
        return this._invalid;
    }
    set invalid(value) {
        this._invalid = coerceBooleanProperty(value);
    }
    get isMasked() {
        return this._isMasked;
    }
    set isMasked(value) {
        this._isMasked = coerceBooleanProperty(value);
    }
    get tabIndexValue() {
        return this._tabIndexValue;
    }
    set tabIndexValue(value) {
        this._tabIndexValue = coerceNumberProperty(value);
    }
    ngOnInit() {
        this.renderedValue = this.value || "";
        this.bindAutocompleteOptions();
        this.autocompleteFunction("");
        this.service.hasPrefixIcon.subscribe((value) => {
            if (value) {
                this.hasPrefixIcon = value;
            }
        });
    }
    bindAutocompleteOptions() {
        if (this.autocompleteOptions && Array.isArray(this.autocompleteOptions)) {
            this.options = this.autocompleteOptions;
        }
    }
    ngAfterViewChecked() {
        if (this._valueChangeTrack) {
            this._valueChangeTrack = false;
            this.setCursorSelection(this.singleInput);
        }
        if (this.dxcInputPrefixIcon && this.dxcInputPrefixIcon.length !== 0) {
            this.prefixIconSrc = "";
        }
        if (this.dxcInputSuffixIcon && this.dxcInputSuffixIcon.length !== 0) {
            this.suffixIconSrc = "";
        }
        this.ref.detectChanges();
    }
    ngOnChanges(changes) {
        if (this.isMasked) {
            this.type = "password";
        }
        else {
            this.type = "text";
        }
        this.isDisabled = this.disabled;
        this.renderedValue = this.value || "";
        this.label = this.label || "";
        this.service.setIsDisabled(this.disabled);
        if (this.onClickSuffix.observers !== undefined &&
            this.onClickSuffix.observers.length !== 0) {
            this.suffixPointer = true;
        }
        if (this.onClickPrefix.observers !== undefined &&
            this.onClickPrefix.observers.length !== 0) {
            this.prefixPointer = true;
        }
        const inputs = Object.keys(changes).reduce((result, item) => {
            result[item] = changes[item].currentValue;
            return result;
        }, {});
        this.defaultInputs.next({ ...this.defaultInputs.getValue(), ...inputs });
        this.className = `${this.getDynamicStyle(this.defaultInputs.getValue())}`;
        this._valueChangeTrack = true;
    }
    onChanged($event) {
        this.clicked = false;
        this.selectionStart = $event.target.selectionStart;
        this.selectionEnd = $event.target.selectionEnd;
        this.onChange.emit($event.target.value);
        this.autocompleteFunction($event.target.value);
        if (this.value === undefined || this.value === null) {
            this.renderedValue = $event.target.value;
        }
        else {
            $event.target.value = this.renderedValue;
        }
    }
    onClickOption($event) {
        this.onChange.emit($event);
        if (this.value === undefined || this.value === null) {
            this.renderedValue = $event;
        }
        else {
            this.singleInput.nativeElement.value = this.renderedValue;
        }
    }
    autocompleteFunction(value) {
        if (value !== undefined &&
            this.autocompleteOptions &&
            Array.isArray(this.autocompleteOptions)) {
            const inputValue = value.toLowerCase();
            this.options = this.autocompleteOptions.filter((option) => option.toLowerCase().includes(inputValue));
        }
        else if (this.autocompleteOptions &&
            typeof this.autocompleteOptions === "function") {
            this.loading.next(true);
            this.isError.next(false);
            this.autocompleteOptions(value).subscribe((autocompleteOptionsList) => {
                this.options = autocompleteOptionsList;
                this.ref.markForCheck();
                this.loading.next(false);
            }, (err) => {
                this.isError.next(true);
                this.loading.next(false);
                this.ref.markForCheck();
            });
        }
        else if (this.autocompleteOptions) {
            this.isError.next(true);
            this.loading.next(false);
            this.ref.markForCheck();
        }
    }
    /**
     * internal click event handler
     *
     * @param $event
     */
    onClickHandle($event) {
        this.clicked = true;
    }
    /**
     *Executed when input lost the focus
     */
    onBlurHandle($event) {
        this.onBlur.emit(this.renderedValue);
    }
    onClickSuffixHandler($event) {
        this.onClickSuffix.emit($event);
    }
    onClickPrefixHandler($event) {
        this.onClickPrefix.emit($event);
    }
    setCursorSelection(input) {
        if (!this.clicked && input) {
            input.nativeElement.selectionStart = this.selectionStart;
            input.nativeElement.selectionEnd = this.selectionEnd;
        }
    }
    calculateWidth(inputs) {
        if (inputs.size === "fillParent") {
            return this.utils.calculateWidth(this.sizes, inputs);
        }
        return css `
      width: ${this.sizes[inputs.size]};
    `;
    }
    getNoIconStyle() {
        return css `
      &:focus {
        outline: none;
      }
      cursor: default;
    `;
    }
    getOnClickPrefixIconStyle() {
        return css `
      &:focus {
        outline: none;
      }
      cursor: default;
    `;
    }
    getStyleOnClickPrefixIconLight() {
        if (this.prefixPointer) {
            return css `
        &:focus {
          outline: -webkit-focus-ring-color auto 1px;
          outline-color: #005FCC;
        }
        cursor: pointer;
      `;
        }
        else {
            this.getNoIconStyle();
        }
    }
    getStyleOnClickSuffixIconLight() {
        if (this.suffixPointer) {
            return css `
        &:focus {
          outline: -webkit-focus-ring-color auto 1px;
          outline-color: #005FCC;
        }
        cursor: pointer;
      `;
        }
        else {
            this.getNoIconStyle();
        }
    }
    getStyleOnClickPrefixIconDark() {
        if (this.prefixPointer) {
            return css `
        &:focus {
          outline: -webkit-focus-ring-color auto 1px;
          outline-color: #005FCC;
        }
        cursor: pointer;
      `;
        }
        else {
            this.getNoIconStyle();
        }
    }
    getStyleOnClickSuffixIconDark() {
        if (this.suffixPointer) {
            return css `
        &:focus {
          outline: -webkit-focus-ring-color auto 1px;
          outline-color: #005FCC;
        }
        cursor: pointer;
      `;
        }
        else {
            this.getNoIconStyle();
        }
    }
    getDynamicStyle(inputs) {
        return css `
      min-height: 34px;
      max-height: 74px;
      ${this.calculateWidth(inputs)}
      ${this.utils.getMargins(inputs.margin)}
      ${this.getLightStyle()}
      ${this.getDarkStyle()}
      display: inline-flex;
      font-family: var(--inputText-fontFamily);
      &.prefixIcon {
        .mat-form-field .mat-form-field-label-wrapper .mat-form-field-label {
          margin-left: 32px;
          width: 100%;
        }
      }
      dxc-input-prefix-icon,
      dxc-input-suffix-icon {
        display: flex;
        cursor: default;
        &:focus {
          outline: none;
        }
        .containerIcon {
          &:focus {
            outline: none;
          }
        }
      }
      dxc-input-prefix-icon {
        margin-right: 12px;
      }
      dxc-input-suffix-icon {
        margin-left: 8px;
        margin-right: 8px;
      }
      .onClickIconElement {
        cursor: pointer !important;
      }
      .prefixElement {
        margin-right: 12px;
      }
      .suffixElement {
        margin-left: 8px;
        margin-right: 8px;
      }
      .mat-form-field-prefix span {
        font-size: var(--inputText-prefixLabelFontSize);
        font-style: var(--inputText-prefixLabelFontStyle);
        font-weight: var(--inputText-prefixLabelFontWeight);
      }
      .mat-form-field-suffix span {
        font-size: var(--inputText-suffixLabelFontSize);
        font-style: var(--inputText-suffixLabelFontStyle);
        font-weight: var(--inputText-suffixLabelFontWeight);
      }
      .mat-form-field.mat-focused .mat-form-field-ripple {
        height: calc(var(--inputText-underlineThickness) * 2) !important;
      }
      .mat-form-field {
        font-family: var(--inputText-fontFamily);
        line-height: unset;
        width: 100%;
        max-height: 74px;
        input {
          color: var(--inputText-valueFontColor);
          font-size: var(--inputText-valueFontSize);
          font-style: var(--inputText-valueFontStyle);
          font-weight: var(--inputText-valueFontWeight);
          min-height: 22px;
          text-overflow: ellipsis;
        }
        img,
        svg {
          width: 20px;
          height: 20px;
        }
        &.disabled {
          pointer-events: none;
        }
      }
      .mat-form-field {
        &.mat-form-field-should-float {
          .mat-form-field-infix {
            padding-bottom: 6px;
          }
          mat-label {
            font-size: var(--inputText-labelFontSize);
            font-family: var(--inputText-fontFamily);
            font-style: var(--inputText-labelFontStyle);
            font-weight: var(--inputText-labelFontWeight);
          }
        }
        .mat-form-field-label-wrapper {
          display: flex;
          .mat-form-field-label {
            flex-direction: row-reverse;
            justify-content: flex-end;
            display: flex;
          }
        }
        .mat-form-field-subscript-wrapper {
          margin-top: 7px;
        }
        .mat-form-field-infix {
          padding-top: 6px;
          display: flex;
        }
      }
      .mat-form-field-flex {
        align-items: center;
        .mat-form-field-infix {
          color: var(--inputText-labelFontColor);
          font-size: var(--inputText-labelFontSize);
          font-family: var(--inputText-fontFamily);
          font-style: var(--inputText-labelFontStyle);
          font-weight: var(--inputText-labelFontWeight);
          border-top: unset;
        }
      }
      .mat-hint {
        font-family: var(--inputText-fontFamily);
        font-size: var(--inputText-assistiveTextFontSize);
        font-style: var(--inputText-assistiveTextFontStyle);
        font-weight: var(--inputText-assistiveTextFontWeight);
      }
      .mat-form-field-appearance-standard .mat-form-field-underline {
        height: var(--inputText-underlineThickness);
      }
    `;
    }
    getInvalidLightStyle() {
        return css `
      .mat-hint {
        color: var(--inputText-errorColor);
      }
      .mat-form-field-ripple {
        background-color: var(--inputText-errorColor) !important;
        height: 0px !important;
      }
      .mat-form-field-underline {
        background-color: var(--inputText-underlineColor) !important;
        &:focus {
          outline: -webkit-focus-ring-color auto 1px;
          outline-color: var(--inputText-errorColor);
        }
      }
      .mat-form-field.mat-form-field-should-float mat-label {
        color: var(--inputText-errorColor) !important;
      }
      &.mat-focused .mat-form-field-empty mat-label {
        color: var(--inputText-errorColor);
      }
      .mat-form-field-label:not(.mat-form-field-empty) mat-label {
        color: var(--inputText-errorColor);
      }
    `;
    }
    getInvalidDarkStyle() {
        return css `
      .mat-hint {
        color: var(--inputText-errorColorOnDark);
      }
      .mat-form-field-ripple {
        background-color: var(--inputText-errorColorOnDark) !important;
        height: 0px !important;
      }
      .mat-form-field-underline {
        background-color: var(--inputText-underlineColorOnDark) !important;
        &:focus {
          outline: -webkit-focus-ring-color auto 1px;
          outline-color: var(--inputText-errorColorOnDark);
          outline-style: solid !important;
        }
      }
      .mat-form-field.mat-form-field-should-float mat-label {
        color: var(--inputText-errorColorOnDark) !important;
      }
      &.mat-focused .mat-form-field-empty mat-label {
        color: var(--inputText-errorColorOnDark);
      }
      .mat-form-field-label:not(.mat-form-field-empty) mat-label {
        color: var(--inputText-errorColorOnDark);
      }
    `;
    }
    getAutoCompleteStyle() {
        return css `
      padding: 0px 2px;
      border-color: var(--inputText-optionBorderColor);
      border-width: var(--inputText-optionBorderThickness);
      border-style: var(--inputText-optionBorderStyle);
      &::-webkit-scrollbar {
        width: 3px;
      }
      &::-webkit-scrollbar-track {
        background-color: var(--inputText-scrollBarTrackColor);
        opacity: 0.34;
        border-radius: 3px;
      }
      &::-webkit-scrollbar-thumb {
        background-color: var(--inputText-scrollBarThumbColor);
        border-radius: 3px;
      }
      .mat-option {
        background-color: var(--inputText-optionBackgroundColor);
        padding-bottom:  var(--inputText-optionPaddingBottom);
        padding-top:  var(--inputText-optionPaddingTop);
        height: 36px;
        .mat-option-text {
          color: var(--inputText-optionFontColor);
          font-family: var(--inputText-fontFamily);
          font-size: var(--inputText-optionFontSize);
          font-style: var(--inputText-optionFontStyle);
          font-weight: var(--inputText-optionFontWeight);
        }
      }
      .mat-option.mat-selected:not(:hover):not(.mat-option-disabled) {
        color: var(--inputText-optionFontColor);
      }
      .mat-option:hover:not(.mat-option-disabled) {
        background-color: var(--inputText-hoverOptionBackgroundColor);
        .mat-option-text{
          color: var(--inputText-hoverOptionColor);
        }
      }
      .mat-option:focus:not(.mat-option-disabled) {
        outline: -webkit-focus-ring-color auto 2px;
        outline-color: #005FCC;
        outline-style: solid !important;
        outline-offset: -1px;
      }
      .mat-option:active:not(.mat-option-disabled) {
        background-color: var(--inputText-selectedOptionBackgroundColor);
      }
      .errorOption {
        .mat-option-text {
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
      }
    `;
    }
    getLightStyle() {
        return css `
      &.light {
        &.disabled {
          cursor: not-allowed;
          dxc-input-prefix-icon,
          dxc-input-suffix-icon {
            .containerIcon {
              fill: var(--inputText-disabledColor);
            }
          }
          .prefixElement,
          .suffixElement {
            fill: var(--inputText-disabledColor);
            color: var(--inputText-disabledColor);
          }
          .mat-hint {
            color: var(--inputText-disabledColor);
          }
          .mat-form-field-underline {
            background-color: var(--inputText-disabledColor) !important;
          }
          .mat-form-field-empty mat-label {
            color: var(--inputText-disabledColor);
          }
          &.mat-focused .mat-form-field-empty mat-label {
            color: var(--inputText-disabledColor);
          }
          .mat-form-field-label:not(.mat-form-field-empty) mat-label {
            color: var(--inputText-disabledColor);
          }
          .mat-form-field-wrapper {
            .mat-form-field-flex {
              .mat-form-field-infix input {
                color: var(--inputText-disabledColor);
              }
            }
          }
        }
        .onClickIconElement {
          .containerIcon {
            &:focus {
              outline: -webkit-focus-ring-color auto 1px;
              outline-color: #005FCC;
            }
          }
        }
        .mat-form-field.mat-focused .mat-form-field-label {
          color: var(--inputText-labelFontColor) !important;
        }
        .mat-form-field.mat-focused .mat-form-field-ripple {
          background-color: ${this.invalid
            ? "var(--inputText-errorColor) !important"
            : "var(--inputText-underlineFocusColor) !important"};
        }
        .mat-form-field {
          input {
            caret-color: var(--inputText-valueFontColor);
            color: var(--inputText-valueFontColor);
          }
        }
        dxc-input-suffix-icon {
          color: var(--inputText-suffixIconColor);
        }
        dxc-input-prefix-icon {
          color: var(--inputText-prefixIconColor);
        }
        .mat-form-field-prefix span {
          color: var(--inputText-prefixLabelFontColor);
        }
        .mat-form-field-suffix span {
          color: var(--inputText-suffixLabelFontColor);
        }
        label.mat-form-field-label {
          color: var(--inputText-labelFontColor);
        }
        input::placeholder {
          color: var(--inputText-labelFontColor);
        }
        .mat-form-field {
          .mat-form-field-label-wrapper {
            .mat-form-field-label {
              span {
                color: var(--inputText-errorColor);
              }
            }
          }
        }
        ${this.invalid
            ? this.getInvalidLightStyle()
            : css `
              .mat-hint {
                color: var(--inputText-assistiveTextFontColor);
              }
              .mat-form-field-underline {
                background-color: var(--inputText-underlineColor) !important;
                .mat-form-field-ripple {
                  height: 0px;
                  background-color: var(
                    --inputText-underlineFocusColor
                  ) !important;
                }
              }
            `}
        .prefixElement {
          ${this.getStyleOnClickPrefixIconLight()}
          color: var(--inputText-prefixIconColor);
          fill: var(--inputText-prefixIconColor);
        }
        .suffixElement {
          ${this.getStyleOnClickSuffixIconLight()}
          color: var(--inputText-suffixIconColor);
          fill: var(--inputText-suffixIconColor);
        }
      }
    `;
    }
    getDarkStyle() {
        return css `
      &.dark {
        &.disabled {
          cursor: not-allowed;
          dxc-input-prefix-icon,
          dxc-input-suffix-icon {
            .containerIcon {
              fill: var(--inputText-disabledColorOnDark);
            }
          }
          .prefixElement,
          .suffixElement {
            fill: var(--inputText-disabledColorOnDark);
            color: var(--inputText-disabledColorOnDark);
          }
          .mat-hint {
            color: var(--inputText-disabledColorOnDark);
          }
          .mat-form-field-underline {
            background-color: var(
              --inputText-disabledColorOnDark
            ) !important;
          }
          .mat-form-field-empty mat-label {
            color: var(--inputText-disabledColorOnDark);
          }
          &.mat-focused .mat-form-field-empty mat-label {
            color: var(--inputText-disabledColorOnDark);
          }
          .mat-form-field-label:not(.mat-form-field-empty) mat-label {
            color: var(--inputText-disabledColorOnDark);
          }
          .mat-form-field-wrapper {
            .mat-form-field-flex {
              .mat-form-field-infix input {
                color: var(--inputText-disabledColorOnDark);
              }
            }
          }
        }
        .onClickIconElement {
          .containerIcon {
            &:focus {
              outline: -webkit-focus-ring-color auto 1px;
              outline-color: #005FCC;
            }
          }
        }
        .mat-form-field.mat-focused .mat-form-field-label {
          color: var(--inputText-labelFontColorOnDark) !important;
        }
        .mat-form-field.mat-focused .mat-form-field-ripple {
          background-color: ${this.invalid
            ? "var(--inputText-errorColorOnDark) !important"
            : "var(--inputText-underlineFocusColorOnDark) !important"};
        }
        .mat-form-field {
          input {
            caret-color: var(--inputText-valueFontColorOnDark);
            color: var(--inputText-valueFontColorOnDark);
          }
        }
        label.mat-form-field-label {
          color: var(--inputText-labelFontColorOnDark);
        }
        dxc-input-suffix-icon {
          color: var(--inputText-suffixIconColorOnDark);
          fill: var(--inputText-suffixIconColorOnDark);
        }
        dxc-input-prefix-icon {
          color: var(--inputText-prefixIconColorOnDark);
          fill: var(--inputText-prefixIconColorOnDark);
        }
        .mat-form-field-prefix span {
          color: var(--inputText-prefixLabelFontColorOnDark);
        }
        .mat-form-field-suffix span {
          color: var(--inputText-suffixLabelFontColorOnDark);
        }
        label.mat-form-field-label {
          color: var(--inputText-labelFontColorOnDark);
        }
        input::placeholder {
          color: var(--inputText-labelFontColorOnDark);
        }
        .mat-form-field {
          .mat-form-field-label-wrapper {
            .mat-form-field-label {
              span {
                color: var(--inputText-errorColorOnDark);
              }
            }
          }
        }
        ${this.invalid
            ? this.getInvalidDarkStyle()
            : css `
              .mat-hint {
                color: var(--inputText-assistiveTextFontColorOnDark);
              }
              .mat-form-field-underline {
                background-color: var(
                  --inputText-underlineColorOnDark
                ) !important;
                .mat-form-field-ripple {
                  height: 0px;
                  background-color: var(
                    --inputText-underlineColorOnDark
                  ) !important;
                }
              }
            `}
        .prefixElement {
          ${this.getStyleOnClickPrefixIconDark()}
        }
        .suffixElement {
          ${this.getStyleOnClickSuffixIconDark()}
        }
      }
    `;
    }
}
DxcInputTextComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcInputTextComponent, deps: [{ token: CssUtils }, { token: i0.ChangeDetectorRef }, { token: InputTextService }, { token: BackgroundProviderService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
DxcInputTextComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.5", type: DxcInputTextComponent, selector: "dxc-input-text", inputs: { prefix: "prefix", suffix: "suffix", prefixIconSrc: "prefixIconSrc", suffixIconSrc: "suffixIconSrc", disabled: "disabled", required: "required", invalid: "invalid", isMasked: "isMasked", label: "label", assistiveText: "assistiveText", name: "name", value: "value", placeholder: "placeholder", autocompleteOptions: "autocompleteOptions", margin: "margin", size: "size", tabIndexValue: "tabIndexValue" }, outputs: { onClickSuffix: "onClickSuffix", onClickPrefix: "onClickPrefix", onChange: "onChange", onBlur: "onBlur" }, host: { properties: { "class": "this.className", "class.disabled": "this.isDisabled", "class.light": "this.lightBackground", "class.dark": "this.darkBackground", "class.prefixIcon": "this.hasPrefixIcon" } }, providers: [CssUtils, InputTextService], queries: [{ propertyName: "dxcInputPrefixIcon", predicate: DxcInputPrefixIconComponent }, { propertyName: "dxcInputSuffixIcon", predicate: DxcInputSuffixIconComponent }], viewQueries: [{ propertyName: "singleInput", first: true, predicate: ["dxcSingleInput"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<mat-form-field\n  [class.invalid]=\"invalid\"\n  [class.disabled]=\"disabled\"\n  appearance=\"standard\"\n>\n  <span\n    matPrefix\n    (click)=\"onClickPrefixHandler($event)\"\n    class=\"prefixElement\"\n    *ngIf=\"prefix && !prefixIconSrc\"\n    id=\"prefixElement\"\n    [tabIndex]=\"prefixPointer ? tabIndexValue : -1\"\n  >\n    {{ prefix }}</span\n  >\n  <img\n    matPrefix\n    (click)=\"onClickPrefixHandler($event)\"\n    class=\"prefixElement\"\n    *ngIf=\"prefixIconSrc\"\n    src=\"{{ prefixIconSrc }}\"\n    id=\"prefixElement\"\n    [tabIndex]=\"prefixPointer ? tabIndexValue : -1\"\n  />\n  <ng-content select=\"dxc-input-prefix-icon\"></ng-content>\n  <mat-label *ngIf=\"label\">{{ label }}</mat-label>\n  <input\n    matInput\n    #dxcSingleInput\n    [value]=\"renderedValue\"\n    (input)=\"onChanged($event)\"\n    (blur)=\"onBlurHandle($event)\"\n    (click)=\"onClickHandle($event)\"\n    [required]=\"required\"\n    [name]=\"name\"\n    [type]=\"type\"\n    [placeholder]=\"placeholder\"\n    [matAutocomplete]=\"auto\"\n    [attr.aria-label]=\"label\"\n    [attr.aria-disabled]=\"disabled\"\n    [tabIndex]=\"disabled ? -1 : tabIndexValue\"\n  />\n  <span\n    matSuffix\n    (click)=\"onClickSuffixHandler($event)\"\n    class=\"suffixElement\"\n    *ngIf=\"suffix && !suffixIconSrc\"\n    [tabIndex]=\"suffixPointer ? tabIndexValue : -1\"\n    >{{ suffix }}</span\n  >\n  <img\n    matSuffix\n    (click)=\"onClickSuffixHandler($event)\"\n    class=\"suffixElement\"\n    *ngIf=\"suffixIconSrc\"\n    src=\"{{ suffixIconSrc }}\"\n    [tabIndex]=\"suffixPointer ? tabIndexValue : -1\"\n  />\n  <ng-content select=\"dxc-input-suffix-icon\"></ng-content>\n  <mat-hint *ngIf=\"assistiveText\">{{ assistiveText }}</mat-hint>\n</mat-form-field>\n\n<mat-autocomplete [class]=\"dxcAutocompleteMenu\" #auto=\"matAutocomplete\" disableRipple>\n  <ng-container *ngIf=\"!loading.getValue() && options && options.length > 0\">\n    <mat-option\n      (click)=\"onClickOption(option)\"\n      *ngFor=\"let option of options\"\n      [value]=\"option\"\n      >{{ option }}\n    </mat-option>\n  </ng-container>\n  <ng-container *ngIf=\"loading.getValue()\">\n    <mat-option disabled=\"true\">Searching...</mat-option>\n  </ng-container>\n  <ng-container *ngIf=\"!loading.getValue() && isError.getValue()\">\n    <mat-option class=\"errorOption\" disabled=\"true\"\n      >Error fetching data\n      <svg xmlns=\"http://www.w3.org/2000/svg\" height=\"24\" width=\"24\">\n        <rect\n          id=\"backgroundrect\"\n          width=\"100%\"\n          height=\"100%\"\n          x=\"0\"\n          y=\"0\"\n          fill=\"none\"\n          stroke=\"none\"\n        />\n        <g class=\"currentLayer\">\n          <title>Layer 1</title>\n          <path\n            d=\"M0 0h24v24H0V0z\"\n            fill=\"transparent\"\n            id=\"svg_1\"\n            class=\"\"\n            stroke=\"transparent\"\n            stroke-opacity=\"1\"\n            fill-opacity=\"1\"\n          />\n          <path\n            d=\"M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z\"\n            id=\"svg_2\"\n            class=\"selected\"\n            stroke=\"#eb1a1a\"\n            stroke-opacity=\"1\"\n            fill=\"#FF6161\"\n            fill-opacity=\"1\"\n          />\n        </g>\n      </svg>\n    </mat-option>\n  </ng-container>\n  <ng-container\n    *ngIf=\"\n      !loading.getValue() &&\n      !isError.getValue() &&\n      options &&\n      options.length === 0\n    \"\n  >\n    <mat-option class=\"errorOption\" disabled=\"true\"\n      >No matches found.</mat-option\n    >\n  </ng-container>\n</mat-autocomplete>\n", components: [{ type: i4$4.MatFormField, selector: "mat-form-field", inputs: ["color", "floatLabel", "appearance", "hideRequiredMarker", "hintLabel"], exportAs: ["matFormField"] }, { type: i5$1.MatAutocomplete, selector: "mat-autocomplete", inputs: ["disableRipple"], exportAs: ["matAutocomplete"] }, { type: i6$1.MatOption, selector: "mat-option", exportAs: ["matOption"] }], directives: [{ type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i4$4.MatPrefix, selector: "[matPrefix]" }, { type: i4$4.MatLabel, selector: "mat-label" }, { type: i8.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["id", "disabled", "required", "type", "value", "readonly", "placeholder", "errorStateMatcher", "aria-describedby"], exportAs: ["matInput"] }, { type: i5$1.MatAutocompleteTrigger, selector: "input[matAutocomplete], textarea[matAutocomplete]", exportAs: ["matAutocompleteTrigger"] }, { type: i4$4.MatSuffix, selector: "[matSuffix]" }, { type: i4$4.MatHint, selector: "mat-hint", inputs: ["align", "id"] }, { type: i4.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcInputTextComponent, decorators: [{
            type: Component,
            args: [{ selector: "dxc-input-text", changeDetection: ChangeDetectionStrategy.OnPush, providers: [CssUtils, InputTextService], template: "<mat-form-field\n  [class.invalid]=\"invalid\"\n  [class.disabled]=\"disabled\"\n  appearance=\"standard\"\n>\n  <span\n    matPrefix\n    (click)=\"onClickPrefixHandler($event)\"\n    class=\"prefixElement\"\n    *ngIf=\"prefix && !prefixIconSrc\"\n    id=\"prefixElement\"\n    [tabIndex]=\"prefixPointer ? tabIndexValue : -1\"\n  >\n    {{ prefix }}</span\n  >\n  <img\n    matPrefix\n    (click)=\"onClickPrefixHandler($event)\"\n    class=\"prefixElement\"\n    *ngIf=\"prefixIconSrc\"\n    src=\"{{ prefixIconSrc }}\"\n    id=\"prefixElement\"\n    [tabIndex]=\"prefixPointer ? tabIndexValue : -1\"\n  />\n  <ng-content select=\"dxc-input-prefix-icon\"></ng-content>\n  <mat-label *ngIf=\"label\">{{ label }}</mat-label>\n  <input\n    matInput\n    #dxcSingleInput\n    [value]=\"renderedValue\"\n    (input)=\"onChanged($event)\"\n    (blur)=\"onBlurHandle($event)\"\n    (click)=\"onClickHandle($event)\"\n    [required]=\"required\"\n    [name]=\"name\"\n    [type]=\"type\"\n    [placeholder]=\"placeholder\"\n    [matAutocomplete]=\"auto\"\n    [attr.aria-label]=\"label\"\n    [attr.aria-disabled]=\"disabled\"\n    [tabIndex]=\"disabled ? -1 : tabIndexValue\"\n  />\n  <span\n    matSuffix\n    (click)=\"onClickSuffixHandler($event)\"\n    class=\"suffixElement\"\n    *ngIf=\"suffix && !suffixIconSrc\"\n    [tabIndex]=\"suffixPointer ? tabIndexValue : -1\"\n    >{{ suffix }}</span\n  >\n  <img\n    matSuffix\n    (click)=\"onClickSuffixHandler($event)\"\n    class=\"suffixElement\"\n    *ngIf=\"suffixIconSrc\"\n    src=\"{{ suffixIconSrc }}\"\n    [tabIndex]=\"suffixPointer ? tabIndexValue : -1\"\n  />\n  <ng-content select=\"dxc-input-suffix-icon\"></ng-content>\n  <mat-hint *ngIf=\"assistiveText\">{{ assistiveText }}</mat-hint>\n</mat-form-field>\n\n<mat-autocomplete [class]=\"dxcAutocompleteMenu\" #auto=\"matAutocomplete\" disableRipple>\n  <ng-container *ngIf=\"!loading.getValue() && options && options.length > 0\">\n    <mat-option\n      (click)=\"onClickOption(option)\"\n      *ngFor=\"let option of options\"\n      [value]=\"option\"\n      >{{ option }}\n    </mat-option>\n  </ng-container>\n  <ng-container *ngIf=\"loading.getValue()\">\n    <mat-option disabled=\"true\">Searching...</mat-option>\n  </ng-container>\n  <ng-container *ngIf=\"!loading.getValue() && isError.getValue()\">\n    <mat-option class=\"errorOption\" disabled=\"true\"\n      >Error fetching data\n      <svg xmlns=\"http://www.w3.org/2000/svg\" height=\"24\" width=\"24\">\n        <rect\n          id=\"backgroundrect\"\n          width=\"100%\"\n          height=\"100%\"\n          x=\"0\"\n          y=\"0\"\n          fill=\"none\"\n          stroke=\"none\"\n        />\n        <g class=\"currentLayer\">\n          <title>Layer 1</title>\n          <path\n            d=\"M0 0h24v24H0V0z\"\n            fill=\"transparent\"\n            id=\"svg_1\"\n            class=\"\"\n            stroke=\"transparent\"\n            stroke-opacity=\"1\"\n            fill-opacity=\"1\"\n          />\n          <path\n            d=\"M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z\"\n            id=\"svg_2\"\n            class=\"selected\"\n            stroke=\"#eb1a1a\"\n            stroke-opacity=\"1\"\n            fill=\"#FF6161\"\n            fill-opacity=\"1\"\n          />\n        </g>\n      </svg>\n    </mat-option>\n  </ng-container>\n  <ng-container\n    *ngIf=\"\n      !loading.getValue() &&\n      !isError.getValue() &&\n      options &&\n      options.length === 0\n    \"\n  >\n    <mat-option class=\"errorOption\" disabled=\"true\"\n      >No matches found.</mat-option\n    >\n  </ng-container>\n</mat-autocomplete>\n" }]
        }], ctorParameters: function () { return [{ type: CssUtils }, { type: i0.ChangeDetectorRef }, { type: InputTextService }, { type: BackgroundProviderService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { className: [{
                type: HostBinding,
                args: ["class"]
            }], isDisabled: [{
                type: HostBinding,
                args: ["class.disabled"]
            }], lightBackground: [{
                type: HostBinding,
                args: ["class.light"]
            }], darkBackground: [{
                type: HostBinding,
                args: ["class.dark"]
            }], hasPrefixIcon: [{
                type: HostBinding,
                args: ["class.prefixIcon"]
            }], prefix: [{
                type: Input
            }], suffix: [{
                type: Input
            }], prefixIconSrc: [{
                type: Input
            }], suffixIconSrc: [{
                type: Input
            }], disabled: [{
                type: Input
            }], required: [{
                type: Input
            }], invalid: [{
                type: Input
            }], isMasked: [{
                type: Input
            }], label: [{
                type: Input
            }], assistiveText: [{
                type: Input
            }], name: [{
                type: Input
            }], value: [{
                type: Input
            }], placeholder: [{
                type: Input
            }], autocompleteOptions: [{
                type: Input
            }], margin: [{
                type: Input
            }], size: [{
                type: Input
            }], tabIndexValue: [{
                type: Input
            }], onClickSuffix: [{
                type: Output
            }], onClickPrefix: [{
                type: Output
            }], onChange: [{
                type: Output
            }], onBlur: [{
                type: Output
            }], singleInput: [{
                type: ViewChild,
                args: ["dxcSingleInput", { static: false }]
            }], dxcInputPrefixIcon: [{
                type: ContentChildren,
                args: [DxcInputPrefixIconComponent]
            }], dxcInputSuffixIcon: [{
                type: ContentChildren,
                args: [DxcInputSuffixIconComponent]
            }] } });

class DxcInputTextModule {
}
DxcInputTextModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcInputTextModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DxcInputTextModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcInputTextModule, declarations: [DxcInputTextComponent, DxcInputPrefixIconComponent, DxcInputSuffixIconComponent], imports: [CommonModule,
        ReactiveFormsModule,
        MatInputModule,
        MatFormFieldModule,
        FormsModule,
        MatAutocompleteModule], exports: [DxcInputTextComponent, DxcInputPrefixIconComponent, DxcInputSuffixIconComponent] });
DxcInputTextModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcInputTextModule, imports: [[
            CommonModule,
            ReactiveFormsModule,
            MatInputModule,
            MatFormFieldModule,
            FormsModule,
            MatAutocompleteModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcInputTextModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [DxcInputTextComponent, DxcInputPrefixIconComponent, DxcInputSuffixIconComponent],
                    imports: [
                        CommonModule,
                        ReactiveFormsModule,
                        MatInputModule,
                        MatFormFieldModule,
                        FormsModule,
                        MatAutocompleteModule,
                    ],
                    exports: [DxcInputTextComponent, DxcInputPrefixIconComponent, DxcInputSuffixIconComponent],
                }]
        }] });

class DxcTextareaHelper {
    constructor(utils) {
        this.utils = utils;
        this.sizes = {
            small: "240px",
            medium: "360px",
            large: "480px",
            fillParent: "100%",
        };
        this.debounced = (cb, time) => {
            const db = new Subject();
            const sub = db.pipe(debounceTime(time)).subscribe(cb);
            const func = (v) => db.next(v);
            func.unsubscribe = () => sub.unsubscribe();
            return func;
        };
    }
    calculateWidth(inputs) {
        if (inputs.size === "fillParent") {
            return this.utils.calculateWidth(this.sizes, inputs);
        }
        return css `
      width: ${this.sizes[inputs.size]};
    `;
    }
    getDisabledStyle() {
        return css `
      .textareaLabel,
      .textareaOptionalLabel {
        color: var(--textarea-disabledLabelFontColor);
      }
      .helperText {
        color: var(--textarea-disabledHelperTextFontColor);
      }
      .textarea,
      .textarea:hover {
        color: var(--textarea-disabledValueFontColor);
        border: 1px solid var(--textarea-disabledBorderColor);
        box-shadow: none;
        cursor: not-allowed;
        background-color: var(--textarea-disabledContainerFillColor);
      }
      .textarea::placeholder {
        color: var(--textarea-disabledPlaceholderFontColor);
      }
    `;
    }
    getDisabledDarkStyle() {
        return css `
      .textareaLabel,
      .textareaOptionalLabel {
        color: var(--textarea-disabledLabelFontColorOnDark);
      }
      .helperText {
        color: var(--textarea-disabledHelperTextFontColorOnDark);
      }
      .textarea,
      .textarea:hover {
        color: var(--textarea-disabledValueFontColorOnDark);
        border: 1px solid var(--textarea-disabledBorderColorOnDark);
        box-shadow: none;
        cursor: not-allowed;
        background-color: var(--textarea-disabledContainerFillColorOnDark);
      }
      .textarea::placeholder {
        color: var(--textarea-disabledPlaceholderFontColorOnDark);
      }
    `;
    }
    getDynamicStyle(inputs) {
        return css `
      position: relative;
      display: flex;
      flex-direction: column;
      ${this.utils.getMargins(inputs.margin)}
      ${this.calculateWidth(inputs)}

      &.hasError {
        .textareaContainer {
          border: 1px solid var(--textarea-errorBorderColor);
          box-shadow: inset 0 0 0 1px var(--textarea-errorBorderColor);
          &:hover {
            border-color: var(--textarea-hoverErrorBorderColor);
            box-shadow: inset 0 0 0 1px var(--textarea-hoverErrorBorderColor);
          }
        }
      }

      .overlay:not(.overlayVisible) {
        display: none;
      }
      .overlay.overlayVisible {
        display: block;
        position: fixed;
        top: 0px;
        left: 0px;
        z-index
      }
      .textareaLabel, .textareaOptionalLabel {
        color: var(--textarea-labelFontColor);
        font-family: var(--textarea-fontFamily);
        font-size: var(--textarea-labelFontSize);
        font-style: var(--textarea-labelFontStyle);
        font-weight: var(--textarea-labelFontWeight);
        line-height: var(--textarea-labelLineHeight);
        min-height: 24px;
      }
      .textareaOptionalLabel {
        font-weight: var(--textarea-optionalLabelFontWeight);
      }

      .helperText {
        color: var(--textarea-helperTextFontColor);
        font-family: var(--textarea-fontFamily);
        font-size: var(--textarea-helperTextFontSize);
        font-style: var(--textarea-helperTextFontStyle);
        font-weight: var(--textarea-helperTextFontWeight);
        line-height: var(--textarea-helperTextLineHeight);
        min-height: 18px;
      }

      .textarea {
        ${inputs.verticalGrow === "manual"
            ? "resize: vertical;"
            : inputs.verticalGrow === "auto"
                ? `resize: none; overflow: hidden;`
                : "resize: none;"};
        margin: calc(1rem * 0.25) 0;
        padding: calc(1rem * 0.5) calc(1rem * 1);
        box-shadow: 0 0 0 2px transparent;
        border-radius: calc(1rem * 0.25);
        height: calc(100% - 2px);
        width: 100%;
        background: none;
        outline: none;
        underline: none;
        color: var(--textarea-valueFontColor);
        font-family: var(--textarea-fontFamily);
        font-size: var(--textarea-valueFontSize);
        font-style: var(--textarea-valueFontStyle);
        font-weight: var(--textarea-valueFontWeight);
        caret-color: var(--textarea-valueFontColor);
        border: ${inputs.error
            ? `1px solid var(--textarea-errorBorderColor)`
            : "1px solid var(--textarea-enabledBorderColor)"};
        ${inputs.error && !inputs.disabled
            ? `border-color: transparent; box-shadow: 0 0 0 2px var(--textarea-errorBorderColor);`
            : ""};
        &::placeholder {
          color: var(--textarea-placeholderFontColor);
        }
        &:hover {
            ${inputs.error
            ? `border-color: transparent;
                   box-shadow: 0 0 0 2px var(--textarea-hoverErrorBorderColor);`
            : `border-color: var(--textarea-hoverBorderColor);`};
        }
        &:focus-within {
            border: 1px solid transparent;
            box-shadow: 0 0 0 2px var(--textarea-focusBorderColor);
            outline: none;
        }
      }
      .textareaErrorMessage {
        font-family: var(--textarea-fontFamily);
        color: var(--textarea-errorMessageColor);
        font-size: var(--textarea-errorFontSize);
        font-style: var(--textarea-errorFontStyle);
        font-weight: var(--textarea-errorFontWeight);
        line-height: 1.5em;
        min-height: 18px;
      }
      ${inputs.darkBackground ? this.getDarkStyle(inputs) : ""}

      ${inputs.disabled
            ? inputs.darkBackground
                ? this.getDisabledDarkStyle()
                : this.getDisabledStyle()
            : ""}
    `;
    }
    getDarkStyle(inputs) {
        return css `
      .textareaLabel,
      .textareaOptionalLabel {
        color: var(--textarea-labelFontColorOnDark);
      }
      .helperText {
        color: var(--textarea-helperTextFontColorOnDark);
      }
      .textarea {
        color: var(--textarea-valueFontColorOnDark);
        caret-color: var(--textarea-valueFontColorOnDark);
        &::placeholder {
          color: var(--textarea-placeholderFontColorOnDark);
        }
        border: ${inputs.error
            ? `1px solid var(--textarea-errorBorderColorOnDark)`
            : "1px solid var(--textarea-enabledBorderColorOnDark)"};
        ${inputs.error
            ? `box-shadow: 0 0 0 2px var(--textarea-errorBorderColorOnDark);`
            : ""};
        &:hover {
          ${inputs.error
            ? `border-color: transparent;
                box-shadow: 0 0 0 2px var(--textarea-hoverErrorBorderColorOnDark);`
            : `border-color: var(--textarea-hoverBorderColorOnDark);`};
        }
        &:focus-within {
          border: 1px solid transparent;
          box-shadow: 0 0 0 2px var(--textarea-focusBorderColorOnDark);
          outline: none;
        }
      }
      .textareaErrorMessage {
        color: var(--textarea-errorMessageColorOnDark);
      }
    `;
    }
}
DxcTextareaHelper.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcTextareaHelper, deps: [{ token: CssUtils }], target: i0.ɵɵFactoryTarget.Injectable });
DxcTextareaHelper.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcTextareaHelper });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcTextareaHelper, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: CssUtils }]; } });

class DxcTextareaComponent {
    constructor(cdRef, helper, bgProviderService) {
        this.cdRef = cdRef;
        this.helper = helper;
        this.bgProviderService = bgProviderService;
        this.hasError = false;
        /**
         * Text to be placed above the textarea.
         */
        this.label = "";
        /**
         * Name attribute of the textarea element.
         */
        this.name = "";
        /**
         * Helper text to be placed above the textarea.
         */
        this.helperText = "";
        this._disabled = false;
        this._optional = false;
        this._rows = 4;
        /**
         * Defines the textarea's ability to resize vertically. It can be:
            'auto': The textarea grows or shrinks automatically in order to fit the content.
            'manual': The height of the textarea is enabled to be manually modified.
            'none': The textarea has a fixed height and can't be modified.
         */
        this.verticalGrow = "auto";
        /**
         * If it is a defined value and also a truthy string, the component will
         * change its appearance, showing the error below the textarea. If the defined
         * value is an empty string, it will reserve a space below the component for a
         * future error, but it would not change its look. In case of being undefined
         * or null, both the appearance and the space for the error message would not
         * be modified.
         */
        this.error = undefined;
        /**
         * Text to be put as placeholder of the textarea.
         */
        this.placeholder = "";
        /**
         * Regular expression that defines the valid format allowed by the textarea.
         * This will be checked when the textarea loses the focus.
         * If the value entered does not match the pattern, the onBlur function will be called with the value
         * entered and the error informing that the value does not match the pattern as parameters. If the pattern is accomplished,
         * the error parameter will be null.
         */
        this.pattern = "";
        /**
         * Value of the tabindex attribute.
         */
        this.tabIndexValue = 0;
        /**
         * Size of the component ('small' | 'medium' | 'large' | 'fillParent').
         */
        this.size = "medium";
        /**
         * HTML autocomplete attribute. Lets the user specify if any permission the user agent has to provide automated assistance in filling out
         * the textarea value. Its value must be one of all the possible values of the HTML autocomplete attribute: 'on', 'off', 'email', 'username', 'new-password', ...
         */
        this.autocomplete = "off";
        this.defaultInputs = new BehaviorSubject({
            placeholder: "",
            error: undefined,
            optional: false,
            disabled: false,
            helperText: "",
            value: undefined,
            name: "",
            label: "",
            margin: undefined,
            tabIndexValue: 0,
            size: "medium",
            rows: 4,
            verticalGrow: "auto",
        });
        /**
         * This event will emit when the user types within the textarea. An object including the new value and the error will be passed to this function.
         * An example of this object is: { value: value, error: error }. If there is no error, error will be null.
         */
        this.onChange = new EventEmitter();
        /**
         * This event will emit when the textarea loses the focus. An object including the textarea value and the error will be passed to this function.
         * An example of this object is: { value: value, error: error }. If there is no error, error will be null.
         */
        this.onBlur = new EventEmitter();
        this.darkBackground = false;
        this.isDirty = false;
        this.validationError = "";
        this.textareaId = `textarea-${v4()}`;
        this.isRequired = (value) => value === "" && !this.optional;
        this.isLengthIncorrect = (value) => (value !== "" &&
            this.minLength &&
            value &&
            value.length < +this.minLength) ||
            (this.maxLength && value && value.length > +this.maxLength);
        this.bgProviderService.$changeColor.subscribe((value) => {
            setTimeout(() => {
                if (value === "dark") {
                    this.darkBackground = true;
                }
                else if (value === "light") {
                    this.darkBackground = false;
                }
                this.className = `${this.helper.getDynamicStyle({
                    ...this.defaultInputs.getValue(),
                    darkBackground: this.darkBackground,
                })}`;
            }, 0);
        });
    }
    /**
     * If true, the component will be disabled.
     */
    get disabled() {
        return this._disabled;
    }
    set disabled(value) {
        this._disabled = coerceBooleanProperty(value);
    }
    /**
     * If true, the textarea will be optional, showing (Optional) next to the label.
     * Otherwise, the field will be considered required and an error will be passed as a parameter to the OnBlur and onChange functions when it has not been filled.
     */
    get optional() {
        return this._optional;
    }
    set optional(value) {
        this._optional = coerceBooleanProperty(value);
    }
    /**
     * Number of rows of the textarea.
     */
    get rows() {
        return this._rows;
    }
    set rows(value) {
        this._rows = coerceNumberProperty(value);
    }
    ngOnChanges(changes) {
        this.checkHeight();
        this.hasError = this.error && !this.disabled ? true : false;
        const inputs = Object.keys(changes).reduce((result, item) => {
            result[item] = changes[item].currentValue;
            return result;
        }, {});
        this.defaultInputs.next({ ...this.defaultInputs.getValue(), ...inputs });
        this.className = `${this.helper.getDynamicStyle({
            ...this.defaultInputs.getValue(),
            darkBackground: this.darkBackground,
        })}`;
    }
    ngOnInit() {
        if (this.value === undefined) {
            this.value = this.defaultValue ?? "";
            this.controlled = false;
        }
        else {
            this.controlled = true;
        }
        this.className = `${this.helper.getDynamicStyle({
            ...this.defaultInputs.getValue(),
            darkBackground: this.darkBackground,
        })}`;
    }
    ngAfterViewInit() {
        if (this.textareaRef) {
            this.textareaRef.nativeElement.ariaDisabled = this.disabled;
        }
        this.checkHeight();
    }
    handleOnChange(event) {
        if (this.value !== event && this.isDirty) {
            this.onChange.emit({ value: event, error: this.validateValue(event) });
        }
        if (!this.controlled) {
            this.value = event;
        }
        else {
            setTimeout(() => {
                if (this.textareaRef.nativeElement.value !== this.value) {
                    this.textareaRef.nativeElement.value = this.value;
                    this.cdRef.detectChanges();
                }
            }, 0);
        }
        this.cdRef.detectChanges();
    }
    handleOnBlur() {
        this.onBlur.emit({
            value: this.value,
            error: this.handleValidationError(),
        });
    }
    handleOnFocus() {
        if (!this.isDirty) {
            this.isDirty = true;
        }
    }
    validateValue(value) {
        if (this.isRequired(value))
            return `This field is required. Please, enter a value.`;
        if (this.isLengthIncorrect(value))
            return `Min length ${this.minLength}, Max length ${this.maxLength}`;
        if (value && !this.patternMatch(this.pattern, value))
            return `Please use a valid pattern`;
        return undefined;
    }
    handleValidationError() {
        const validationError = this.validateValue(this.value);
        this.validationError = validationError;
        return validationError;
    }
    patternMatch(pattern, value) {
        const patternToMatch = new RegExp(pattern);
        return patternToMatch.test(value);
    }
    checkHeight() {
        if (this.textareaRef) {
            if (this.verticalGrow === "auto") {
                const textareaLineHeight = parseInt(window.getComputedStyle(this.textareaRef.nativeElement)["line-height"]);
                const textareaPaddingTopBottom = parseInt(window.getComputedStyle(this.textareaRef.nativeElement)["padding-top"]) * 2;
                this.textareaRef.nativeElement.style.height = `${textareaLineHeight * this.rows}px`;
                const newHeight = this.textareaRef.nativeElement.scrollHeight -
                    textareaPaddingTopBottom;
                this.textareaRef.nativeElement.style.height = `${newHeight}px`;
            }
        }
    }
}
DxcTextareaComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcTextareaComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: DxcTextareaHelper }, { token: BackgroundProviderService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
DxcTextareaComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.5", type: DxcTextareaComponent, selector: "dxc-textarea", inputs: { label: "label", name: "name", value: "value", defaultValue: "defaultValue", helperText: "helperText", disabled: "disabled", optional: "optional", rows: "rows", verticalGrow: "verticalGrow", error: "error", placeholder: "placeholder", pattern: "pattern", minLength: "minLength", maxLength: "maxLength", margin: "margin", tabIndexValue: "tabIndexValue", size: "size", autocomplete: "autocomplete" }, outputs: { onChange: "onChange", onBlur: "onBlur" }, host: { properties: { "class": "this.className", "class.hasError": "this.hasError" } }, providers: [DxcTextareaHelper, CssUtils], viewQueries: [{ propertyName: "textareaRef", first: true, predicate: ["textareaRef"], descendants: true, static: true }], usesOnChanges: true, ngImport: i0, template: "<label *ngIf=\"label\" class=\"textareaLabel\" htmlFor=\"{{ textareaId }}\">\n  {{ label }}\n  <span *ngIf=\"optional\" class=\"textareaOptionalLabel\">(Optional)</span>\n</label>\n<span *ngIf=\"helperText\" class=\"helperText\">{{ helperText }}</span>\n<textarea\n  #textareaRef\n  [id]=\"textareaId\"\n  [name]=\"name\"\n  [placeholder]=\"placeholder\"\n  [ngModel]=\"value\"\n  [rows]=\"rows\"\n  (ngModelChange)=\"handleOnChange($event)\"\n  (blur)=\"handleOnBlur()\"\n  [disabled]=\"disabled\"\n  [tabindex]=\"tabIndexValue\"\n  type=\"text\"\n  class=\"textarea\"\n  (focus)=\"handleOnFocus()\"\n  [attr.autocomplete]=\"autocomplete\"\n></textarea>\n<span\n  *ngIf=\"(error || error === '') && !disabled\"\n  class=\"textareaErrorMessage\"\n  >{{ error }}</span\n>\n", directives: [{ type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i5.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i5.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i5.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcTextareaComponent, decorators: [{
            type: Component,
            args: [{ selector: "dxc-textarea", providers: [DxcTextareaHelper, CssUtils], template: "<label *ngIf=\"label\" class=\"textareaLabel\" htmlFor=\"{{ textareaId }}\">\n  {{ label }}\n  <span *ngIf=\"optional\" class=\"textareaOptionalLabel\">(Optional)</span>\n</label>\n<span *ngIf=\"helperText\" class=\"helperText\">{{ helperText }}</span>\n<textarea\n  #textareaRef\n  [id]=\"textareaId\"\n  [name]=\"name\"\n  [placeholder]=\"placeholder\"\n  [ngModel]=\"value\"\n  [rows]=\"rows\"\n  (ngModelChange)=\"handleOnChange($event)\"\n  (blur)=\"handleOnBlur()\"\n  [disabled]=\"disabled\"\n  [tabindex]=\"tabIndexValue\"\n  type=\"text\"\n  class=\"textarea\"\n  (focus)=\"handleOnFocus()\"\n  [attr.autocomplete]=\"autocomplete\"\n></textarea>\n<span\n  *ngIf=\"(error || error === '') && !disabled\"\n  class=\"textareaErrorMessage\"\n  >{{ error }}</span\n>\n" }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: DxcTextareaHelper }, { type: BackgroundProviderService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { className: [{
                type: HostBinding,
                args: ["class"]
            }], hasError: [{
                type: HostBinding,
                args: ["class.hasError"]
            }], label: [{
                type: Input
            }], name: [{
                type: Input
            }], value: [{
                type: Input
            }], defaultValue: [{
                type: Input
            }], helperText: [{
                type: Input
            }], disabled: [{
                type: Input
            }], optional: [{
                type: Input
            }], rows: [{
                type: Input
            }], verticalGrow: [{
                type: Input
            }], error: [{
                type: Input
            }], placeholder: [{
                type: Input
            }], pattern: [{
                type: Input
            }], minLength: [{
                type: Input
            }], maxLength: [{
                type: Input
            }], margin: [{
                type: Input
            }], tabIndexValue: [{
                type: Input
            }], size: [{
                type: Input
            }], autocomplete: [{
                type: Input
            }], onChange: [{
                type: Output
            }], onBlur: [{
                type: Output
            }], textareaRef: [{
                type: ViewChild,
                args: ["textareaRef", { static: true }]
            }] } });

class DxcTextareaModule {
}
DxcTextareaModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcTextareaModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DxcTextareaModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcTextareaModule, declarations: [DxcTextareaComponent], imports: [CommonModule, FormsModule], exports: [DxcTextareaComponent] });
DxcTextareaModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcTextareaModule, imports: [[CommonModule, FormsModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcTextareaModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        DxcTextareaComponent,
                    ],
                    imports: [CommonModule, FormsModule],
                    exports: [
                        DxcTextareaComponent,
                    ],
                }]
        }] });

class DxcPasswordInputHelper {
    constructor(utils) {
        this.utils = utils;
    }
    getDynamicStyle(inputs) {
        return css `
      input::-ms-reveal {
        display: none;
      }
    `;
    }
}
DxcPasswordInputHelper.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcPasswordInputHelper, deps: [{ token: CssUtils }], target: i0.ɵɵFactoryTarget.Injectable });
DxcPasswordInputHelper.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcPasswordInputHelper });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcPasswordInputHelper, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: CssUtils }]; } });

class DxcPasswordInputComponent {
    constructor(cdRef, helper) {
        this.cdRef = cdRef;
        this.helper = helper;
        /**
         * Text to be placed above the password.
         */
        this.label = "";
        /**
         * Name attribute of the input element.
         */
        this.name = "";
        /**
         * Helper text to be placed above the password.
         */
        this.helperText = "";
        this._clearable = false;
        /**
         * If it is defined, the component will change its appearance, showing
         * the error below the password input component. If it is not defined, the
         * error messages will be managed internally, but never displayed on its own.
         */
        this.error = "";
        /**
         * HTML autocomplete attribute. Lets the user specify if any permission the user agent has to provide automated assistance in filling out the input value.
         * Its value must be one of all the possible values of the HTML autocomplete attribute: 'on', 'off', 'email', 'username', 'new-password', ...
         */
        this.autocomplete = "off";
        /**
         * Size of the component ('small' | 'medium' | 'large' | 'fillParent').
         */
        this.size = "medium";
        /**
         * Value of the tabindex attribute.
         */
        this.tabIndexValue = 0;
        this.defaultInputs = new BehaviorSubject({
            error: "",
            helperText: "",
            value: undefined,
            label: "",
            margin: null,
            tabIndexValue: 0,
            size: "medium",
            clearable: false,
            name: null,
            defaultValue: null,
            autocomplete: "off",
            minLength: null,
            maxLength: null,
        });
        /**
         * This function will be called when the user types within the input
         * element of the component. An object including the current value and
         * the error (if the value entered is not valid) will be passed to this
         * function. If there is no error, error will be undefined.
         * */
        this.onChange = new EventEmitter();
        /**
         * This function will be called when the input element loses the focus.
         * An object including the input value and the error (if the value entered is
         * not valid) will be passed to this function. If there is no error, error will be undefined.
         */
        this.onBlur = new EventEmitter();
        this.hidden = true;
    }
    /**
     * If true, the password input will have an action to clear the entered value.
     */
    get clearable() {
        return this._clearable;
    }
    set clearable(value) {
        this._clearable = coerceBooleanProperty(value);
    }
    ngOnInit() {
        this.type = "password";
        if (this.value === undefined) {
            this.value = this.defaultValue ?? "";
            this.controlled = false;
        }
        else {
            this.controlled = true;
        }
        this.className = `${this.helper.getDynamicStyle(this.defaultInputs.getValue())}`;
    }
    ngAfterViewInit() {
        this.dxcInputRef.inputRef.nativeElement.attributes.type.value = this.type;
        this.dxcInputRef.actionButton.nativeElement.ariaExpanded = !this.hidden;
        this.dxcInputRef.actionButton.nativeElement.ariaLabel = this.hidden
            ? "Show"
            : "Hide";
    }
    ngOnChanges(changes) {
        if (this.dxcInputRef && this.dxcInputRef.inputRef) {
            this.controlled
                ? (this.dxcInputRef.inputRef.nativeElement.value = this.value)
                : (this.value = this.dxcInputRef.inputRef.nativeElement.value);
        }
        const inputs = Object.keys(changes).reduce((result, item) => {
            result[item] = changes[item].currentValue;
            return result;
        }, {});
        this.defaultInputs.next({ ...this.defaultInputs.getValue(), ...inputs });
        this.className = `${this.helper.getDynamicStyle(this.defaultInputs.getValue())}`;
    }
    handleOnChange({ value, error }) {
        this.cdRef.detectChanges();
        this.onChange.emit({ value, error });
        this.controlled
            ? (this.dxcInputRef.inputRef.nativeElement.value = this.value)
            : (this.value = value);
    }
    handleOnBlur({ value, error }) {
        this.onBlur.emit({ value: value, error: error });
        if (!this.controlled) {
            this.value = value;
            this.cdRef.detectChanges();
        }
    }
    handleMaskPassword() {
        this.hidden ? (this.type = "text") : (this.type = "password");
        this.hidden = !this.hidden;
        this.dxcInputRef.inputRef.nativeElement.attributes.type.value = this.type;
        this.dxcInputRef.actionButton.nativeElement.ariaExpanded = !this.hidden;
        this.dxcInputRef.actionButton.nativeElement.ariaLabel = this.hidden
            ? "Show"
            : "Hide";
    }
}
DxcPasswordInputComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcPasswordInputComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: DxcPasswordInputHelper }], target: i0.ɵɵFactoryTarget.Component });
DxcPasswordInputComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.5", type: DxcPasswordInputComponent, selector: "dxc-password-input", inputs: { label: "label", name: "name", value: "value", defaultValue: "defaultValue", helperText: "helperText", clearable: "clearable", error: "error", pattern: "pattern", minLength: "minLength", maxLength: "maxLength", autocomplete: "autocomplete", margin: "margin", size: "size", tabIndexValue: "tabIndexValue" }, outputs: { onChange: "onChange", onBlur: "onBlur" }, host: { properties: { "class": "this.className" } }, providers: [DxcPasswordInputHelper, CssUtils], viewQueries: [{ propertyName: "dxcInputRef", first: true, predicate: ["dxcInput"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<dxc-text-input\n  #dxcInput\n  [value]=\"value\"\n  [defaultValue]=\"defaultValue\"\n  [clearable]=\"clearable\"\n  [error]=\"error\"\n  [label]=\"label\"\n  [helperText]=\"helperText\"\n  [margin]=\"margin\"\n  [pattern]=\"pattern\"\n  [minLength]=\"minLength\"\n  [maxLength]=\"maxLength\"\n  [size]=\"size\"\n  (onChange)=\"handleOnChange($event)\"\n  (onBlur)=\"handleOnBlur($event)\"\n  (onActionClick)=\"handleMaskPassword()\"\n  [tabIndexValue]=\"tabIndexValue\"\n  [autocomplete]=\"autocomplete\"\n>\n  <dxc-text-input-action>\n    <svg\n      *ngIf=\"hidden\"\n      xmlns=\"http://www.w3.org/2000/svg\"\n      viewBox=\"0 0 24 24\"\n      fill=\"currentColor\"\n    >\n      <path d=\"M0 0h24v24H0V0z\" fill=\"none\" />\n      <path\n        d=\"M12 6c3.79 0 7.17 2.13 8.82 5.5C19.17 14.87 15.79 17 12 17s-7.17-2.13-8.82-5.5C4.83 8.13 8.21 6 12 6m0-2C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 5c1.38 0 2.5 1.12 2.5 2.5S13.38 14 12 14s-2.5-1.12-2.5-2.5S10.62 9 12 9m0-2c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7z\"\n      />\n    </svg>\n    <svg\n      *ngIf=\"!hidden\"\n      xmlns=\"http://www.w3.org/2000/svg\"\n      viewBox=\"0 0 24 24\"\n      fill=\"currentColor\"\n    >\n      <path\n        d=\"M0 0h24v24H0V0zm0 0h24v24H0V0zm0 0h24v24H0V0zm0 0h24v24H0V0z\"\n        fill=\"none\"\n      />\n      <path\n        d=\"M12 6c3.79 0 7.17 2.13 8.82 5.5-.59 1.22-1.42 2.27-2.41 3.12l1.41 1.41c1.39-1.23 2.49-2.77 3.18-4.53C21.27 7.11 17 4 12 4c-1.27 0-2.49.2-3.64.57l1.65 1.65C10.66 6.09 11.32 6 12 6zm-1.07 1.14L13 9.21c.57.25 1.03.71 1.28 1.28l2.07 2.07c.08-.34.14-.7.14-1.07C16.5 9.01 14.48 7 12 7c-.37 0-.72.05-1.07.14zM2.01 3.87l2.68 2.68C3.06 7.83 1.77 9.53 1 11.5 2.73 15.89 7 19 12 19c1.52 0 2.98-.29 4.32-.82l3.42 3.42 1.41-1.41L3.42 2.45 2.01 3.87zm7.5 7.5l2.61 2.61c-.04.01-.08.02-.12.02-1.38 0-2.5-1.12-2.5-2.5 0-.05.01-.08.01-.13zm-3.4-3.4l1.75 1.75c-.23.55-.36 1.15-.36 1.78 0 2.48 2.02 4.5 4.5 4.5.63 0 1.23-.13 1.77-.36l.98.98c-.88.24-1.8.38-2.75.38-3.79 0-7.17-2.13-8.82-5.5.7-1.43 1.72-2.61 2.93-3.53z\"\n      />\n    </svg>\n  </dxc-text-input-action>\n</dxc-text-input>\n", components: [{ type: DxcTextInputComponent, selector: "dxc-text-input", inputs: ["label", "name", "value", "defaultValue", "helperText", "placeholder", "autocomplete", "disabled", "optional", "clearable", "error", "pattern", "minLength", "maxLength", "margin", "suggestions", "tabIndexValue", "size"], outputs: ["onChange", "onBlur", "onActionClick"] }, { type: DxcTextInputActionComponent, selector: "dxc-text-input-action" }], directives: [{ type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcPasswordInputComponent, decorators: [{
            type: Component,
            args: [{ selector: "dxc-password-input", providers: [DxcPasswordInputHelper, CssUtils], template: "<dxc-text-input\n  #dxcInput\n  [value]=\"value\"\n  [defaultValue]=\"defaultValue\"\n  [clearable]=\"clearable\"\n  [error]=\"error\"\n  [label]=\"label\"\n  [helperText]=\"helperText\"\n  [margin]=\"margin\"\n  [pattern]=\"pattern\"\n  [minLength]=\"minLength\"\n  [maxLength]=\"maxLength\"\n  [size]=\"size\"\n  (onChange)=\"handleOnChange($event)\"\n  (onBlur)=\"handleOnBlur($event)\"\n  (onActionClick)=\"handleMaskPassword()\"\n  [tabIndexValue]=\"tabIndexValue\"\n  [autocomplete]=\"autocomplete\"\n>\n  <dxc-text-input-action>\n    <svg\n      *ngIf=\"hidden\"\n      xmlns=\"http://www.w3.org/2000/svg\"\n      viewBox=\"0 0 24 24\"\n      fill=\"currentColor\"\n    >\n      <path d=\"M0 0h24v24H0V0z\" fill=\"none\" />\n      <path\n        d=\"M12 6c3.79 0 7.17 2.13 8.82 5.5C19.17 14.87 15.79 17 12 17s-7.17-2.13-8.82-5.5C4.83 8.13 8.21 6 12 6m0-2C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 5c1.38 0 2.5 1.12 2.5 2.5S13.38 14 12 14s-2.5-1.12-2.5-2.5S10.62 9 12 9m0-2c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7z\"\n      />\n    </svg>\n    <svg\n      *ngIf=\"!hidden\"\n      xmlns=\"http://www.w3.org/2000/svg\"\n      viewBox=\"0 0 24 24\"\n      fill=\"currentColor\"\n    >\n      <path\n        d=\"M0 0h24v24H0V0zm0 0h24v24H0V0zm0 0h24v24H0V0zm0 0h24v24H0V0z\"\n        fill=\"none\"\n      />\n      <path\n        d=\"M12 6c3.79 0 7.17 2.13 8.82 5.5-.59 1.22-1.42 2.27-2.41 3.12l1.41 1.41c1.39-1.23 2.49-2.77 3.18-4.53C21.27 7.11 17 4 12 4c-1.27 0-2.49.2-3.64.57l1.65 1.65C10.66 6.09 11.32 6 12 6zm-1.07 1.14L13 9.21c.57.25 1.03.71 1.28 1.28l2.07 2.07c.08-.34.14-.7.14-1.07C16.5 9.01 14.48 7 12 7c-.37 0-.72.05-1.07.14zM2.01 3.87l2.68 2.68C3.06 7.83 1.77 9.53 1 11.5 2.73 15.89 7 19 12 19c1.52 0 2.98-.29 4.32-.82l3.42 3.42 1.41-1.41L3.42 2.45 2.01 3.87zm7.5 7.5l2.61 2.61c-.04.01-.08.02-.12.02-1.38 0-2.5-1.12-2.5-2.5 0-.05.01-.08.01-.13zm-3.4-3.4l1.75 1.75c-.23.55-.36 1.15-.36 1.78 0 2.48 2.02 4.5 4.5 4.5.63 0 1.23-.13 1.77-.36l.98.98c-.88.24-1.8.38-2.75.38-3.79 0-7.17-2.13-8.82-5.5.7-1.43 1.72-2.61 2.93-3.53z\"\n      />\n    </svg>\n  </dxc-text-input-action>\n</dxc-text-input>\n" }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: DxcPasswordInputHelper }]; }, propDecorators: { className: [{
                type: HostBinding,
                args: ["class"]
            }], label: [{
                type: Input
            }], name: [{
                type: Input
            }], value: [{
                type: Input
            }], defaultValue: [{
                type: Input
            }], helperText: [{
                type: Input
            }], clearable: [{
                type: Input
            }], error: [{
                type: Input
            }], pattern: [{
                type: Input
            }], minLength: [{
                type: Input
            }], maxLength: [{
                type: Input
            }], autocomplete: [{
                type: Input
            }], margin: [{
                type: Input
            }], size: [{
                type: Input
            }], tabIndexValue: [{
                type: Input
            }], onChange: [{
                type: Output
            }], onBlur: [{
                type: Output
            }], dxcInputRef: [{
                type: ViewChild,
                args: ["dxcInput", { static: false }]
            }] } });

class DxcPasswordInputModule {
}
DxcPasswordInputModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcPasswordInputModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DxcPasswordInputModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcPasswordInputModule, declarations: [DxcPasswordInputComponent], imports: [CommonModule, DxcTextInputModule], exports: [DxcPasswordInputComponent] });
DxcPasswordInputModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcPasswordInputModule, imports: [[CommonModule, DxcTextInputModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcPasswordInputModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [DxcPasswordInputComponent],
                    imports: [CommonModule, DxcTextInputModule],
                    exports: [DxcPasswordInputComponent],
                }]
        }] });

class DxcNumberInputHelper {
    constructor(utils) {
        this.utils = utils;
    }
    getDynamicStyle(inputs) {
        return css `
      // Chrome, Safari, Edge, Opera
      input::-webkit-outer-spin-button,
      input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }
      // Firefox
      input[type="number"] {
        -moz-appearance: textfield;
      }
    `;
    }
}
DxcNumberInputHelper.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcNumberInputHelper, deps: [{ token: CssUtils }], target: i0.ɵɵFactoryTarget.Injectable });
DxcNumberInputHelper.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcNumberInputHelper });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcNumberInputHelper, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: CssUtils }]; } });

class DxcNumberInputComponent {
    constructor(cdRef, helper) {
        this.cdRef = cdRef;
        this.helper = helper;
        /**
         * Text to be placed above the number.
         */
        this.label = "";
        /**
         * Name attribute of the input element.
         */
        this.name = "";
        /**
         * Helper text to be placed above the number.
         */
        this.helperText = "";
        /**
         * Text to be put as placeholder of the number.
         */
        this.placeholder = "";
        this._disabled = false;
        this._min = null;
        this._max = null;
        this._step = 1;
        this._optional = false;
        /**
         * If it is defined, the component will change its appearance, showing
         * the error below the input component. If it is not defined, the error
         * messages will be managed internally, but never displayed on its own.
         */
        this.error = "";
        /**
         * HTML autocomplete attribute. Lets the user specify if any permission the user agent has to provide automated assistance in filling out the input value.
         * Its value must be one of all the possible values of the HTML autocomplete attribute: 'on', 'off', 'email', 'username', 'new-password', ...
         */
        this.autocomplete = "off";
        /**
         * Size of the component ('small' | 'medium' | 'large' | 'fillParent').
         */
        this.size = "medium";
        /**
         * Value of the tabindex attribute.
         */
        this.tabIndexValue = 0;
        this.defaultInputs = new BehaviorSubject({
            placeholder: "",
            error: "",
            optional: false,
            disabled: false,
            helperText: "",
            value: undefined,
            name: "",
            label: "",
            margin: null,
            step: 1,
            min: null,
            max: null,
            tabIndexValue: 0,
            size: "medium",
        });
        /**
         * This event will emit in case the user types within the input
         * element of the component. An object including the current value and
         * the error (if the value entered is not valid) will be passed to this
         * function. If there is no error, error will be undefined.
         */
        this.onChange = new EventEmitter();
        /**
         * This event will emit in case the number loses the focus.
         * An object including the input value and the error (if the value
         * entered is not valid) will be passed to this function. If there is no error,
         * error will be undefined.
         */
        this.onBlur = new EventEmitter();
        this.isFocused = false;
        this.validationError = undefined;
    }
    /**
     * If true, the component will be disabled.
     */
    get disabled() {
        return this._disabled;
    }
    set disabled(value) {
        this._disabled = coerceBooleanProperty(value);
    }
    /**
     * Minimum value allowed by the number input. If the typed value by the user is
     * lower than min, the onBlur and onChange functions will be called with
     * the current value and an internal error informing that the current
     * value is not correct. If a valid state is reached, the error parameter
     * will be undefined in both events.
     */
    get min() {
        return this._min;
    }
    set min(value) {
        this._min = coerceNumberProperty(value);
    }
    /**
     * Maximum value allowed by the number input. If the typed value by the user
     * surpasses max, the onBlur and onChange functions will be called with
     * the current value and an internal error informing that the current
     * value is not correct. If a valid state is reached, the error parameter
     * will be undefined in both events.
     */
    get max() {
        return this._max;
    }
    set max(value) {
        this._max = coerceNumberProperty(value);
    }
    /**
     * The step interval to use when using the up and down arrows to adjust the value.
     */
    get step() {
        return this._step;
    }
    set step(value) {
        this._step = coerceNumberProperty(value);
    }
    /**
     * If true, the number will be optional, showing '(Optional)'
     * next to the label. Otherwise, the field will be considered required
     * and an error will be passed as a parameter to the OnBlur and onChange
     * functions when it has not been filled.
     */
    get optional() {
        return this._optional;
    }
    set optional(value) {
        this._optional = coerceBooleanProperty(value);
    }
    keyEvent(event) {
        if (this.isFocused) {
            if (event.key === "ArrowUp") {
                this.handleStepPlus();
            }
            if (event.key === "ArrowDown") {
                this.handleStepMinus();
            }
        }
    }
    ngOnDestroy() { }
    ngOnInit() {
        this.randomId = `input-${Math.floor(Math.random() * 1000000000000000) + 1}`;
        if (this.value === undefined) {
            this.value = this.defaultValue ?? "";
            this.controlled = false;
        }
        else {
            this.controlled = true;
        }
        this.className = `${this.helper.getDynamicStyle(this.defaultInputs.getValue())}`;
    }
    ngAfterViewInit() {
        if (this.dxcInputRef && this.dxcInputRef.inputRef) {
            this.dxcInputRef.inputRef.nativeElement.attributes.type.value = "number";
            this.dxcInputRef.inputRef.nativeElement.min = this.min;
            this.dxcInputRef.inputRef.nativeElement.max = this.max;
            this.dxcInputRef.inputRef.nativeElement.step = this.step;
            this.dxcInputRef.isInputNumber = true;
        }
        this.cdRef.detectChanges();
        if (this.dxcInputRef &&
            this.dxcInputRef.stepButtonMinus &&
            this.dxcInputRef.stepButtonPlus) {
            this.dxcInputRef.stepButtonMinus.nativeElement.addEventListener("click", this.handleStepMinus.bind(this));
            this.dxcInputRef.stepButtonPlus.nativeElement.addEventListener("click", this.handleStepPlus.bind(this));
            this.dxcInputRef.inputRef.nativeElement.addEventListener("focus", this.isFocus.bind(this));
            this.dxcInputRef.inputRef.nativeElement.addEventListener("blur", this.isBlur.bind(this));
        }
        this.cdRef.detectChanges();
    }
    ngOnChanges(changes) {
        this.className = `${this.helper.getDynamicStyle(this.defaultInputs.getValue())}`;
    }
    handleOnChange({ value, error }) {
        this.cdRef.detectChanges();
        this.onChange.emit({ value, error });
        this.controlled
            ? (this.dxcInputRef.inputRef.nativeElement.value = this.value)
            : (this.value = value);
    }
    handleOnBlur({ value, error }) {
        this.validationError = this.validation();
        this.onBlur.emit({ value, error });
        if (!this.controlled) {
            this.value = value;
            this.cdRef.detectChanges();
        }
    }
    validation() {
        let err;
        const currentValue = coerceNumberProperty(this.value);
        if (this.value && this.min && currentValue < this.min) {
            err = `Value must be greater than or equal to ${this.min}.`;
        }
        else if (this.value && this.max && currentValue > this.max) {
            err = `Value must be less than or equal to ${this.max}.`;
        }
        return err;
    }
    handleStepMinus() {
        this.handleOnBlur({ value: this.value, error: this.validation() });
        let currentValue;
        if (this.value === null || this.value === undefined) {
            currentValue = 0;
        }
        else {
            currentValue = coerceNumberProperty(this.value);
        }
        let calculatedValue = this.calculateMinus(currentValue);
        this.handleOnChange({ value: calculatedValue.toString(), error: undefined });
        this.dxcInputRef.inputRef.nativeElement.focus();
    }
    handleStepPlus() {
        this.handleOnBlur({ value: this.value, error: this.validation() });
        let currentValue;
        if (this.value === null || this.value === undefined) {
            currentValue = 0;
        }
        else {
            currentValue = coerceNumberProperty(this.value);
        }
        let calculatedValue = this.calculatePlus(currentValue);
        this.handleOnChange({ value: calculatedValue.toString(), error: undefined });
        this.dxcInputRef.inputRef.nativeElement.focus();
    }
    calculatePlus(currentValue) {
        let calculated = parseInt(this.value);
        if (this.max && currentValue > this.max) {
            calculated = currentValue;
        }
        else if (this.min && (currentValue < this.min || this.value === "")) {
            calculated = this.min;
        }
        else if (this.max &&
            (currentValue === this.max ||
                (this.step && currentValue + this.step > this.max))) {
            calculated = this.max;
        }
        else if ((this.step && this.max && currentValue + this.step <= this.max) ||
            (this.step && this.value !== "")) {
            calculated = currentValue + this.step;
        }
        else if (this.step && this.value === "") {
            calculated = this.step;
        }
        else if (this.value === "") {
            calculated = 1;
        }
        else {
            calculated = currentValue + 1;
        }
        return calculated;
    }
    calculateMinus(currentValue) {
        let calculated = parseInt(this.value);
        if (this.min && currentValue < this.min && this.value !== "") {
            calculated = currentValue;
        }
        else if (this.max && currentValue > this.max) {
            calculated = this.max;
        }
        else if (this.min &&
            (currentValue === this.min ||
                this.value === "" ||
                (this.step && currentValue - this.step < this.min))) {
            calculated = this.min;
        }
        else if ((this.step && this.min && currentValue - this.step >= this.min) ||
            (this.step && this.value !== "")) {
            calculated = currentValue - this.step;
        }
        else if (this.step && this.value === "") {
            calculated = -this.step;
        }
        else if (this.value === "") {
            calculated = -1;
        }
        else {
            calculated = currentValue - 1;
        }
        return calculated;
    }
    isFocus() {
        this.isFocused = true;
    }
    isBlur() {
        this.isFocused = false;
    }
}
DxcNumberInputComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcNumberInputComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: DxcNumberInputHelper }], target: i0.ɵɵFactoryTarget.Component });
DxcNumberInputComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.5", type: DxcNumberInputComponent, selector: "dxc-number-input", inputs: { label: "label", name: "name", value: "value", defaultValue: "defaultValue", helperText: "helperText", placeholder: "placeholder", disabled: "disabled", min: "min", max: "max", step: "step", optional: "optional", error: "error", autocomplete: "autocomplete", margin: "margin", size: "size", tabIndexValue: "tabIndexValue" }, outputs: { onChange: "onChange", onBlur: "onBlur" }, host: { listeners: { "window:keydown": "keyEvent($event)" }, properties: { "class": "this.className" } }, providers: [DxcNumberInputHelper, CssUtils], viewQueries: [{ propertyName: "dxcInputRef", first: true, predicate: ["dxcInputRef"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<dxc-text-input\n  #dxcInputRef\n  [label]=\"label\"\n  [placeholder]=\"placeholder\"\n  [helperText]=\"helperText\"\n  [margin]=\"margin\"\n  [value]=\"value\"\n  [error]=\"error\"\n  [size]=\"size\"\n  (onBlur)=\"handleOnBlur($event)\"\n  (onChange)=\"handleOnChange($event)\"\n  [tabIndexValue]=\"tabIndexValue\"\n  [disabled]=\"disabled\"\n  [optional]=\"optional\"\n  [autocomplete]=\"autocomplete\"\n  [defaultValue]=\"defaultValue\"\n>\n  <ng-content\n    select=\"dxc-text-input-suffix\"\n    ngProjectAs=\"dxc-text-input-suffix\"\n  ></ng-content>\n  <ng-content\n    select=\"dxc-text-input-prefix\"\n    ngProjectAs=\"dxc-text-input-prefix\"\n  ></ng-content>\n</dxc-text-input>\n", components: [{ type: DxcTextInputComponent, selector: "dxc-text-input", inputs: ["label", "name", "value", "defaultValue", "helperText", "placeholder", "autocomplete", "disabled", "optional", "clearable", "error", "pattern", "minLength", "maxLength", "margin", "suggestions", "tabIndexValue", "size"], outputs: ["onChange", "onBlur", "onActionClick"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcNumberInputComponent, decorators: [{
            type: Component,
            args: [{ selector: "dxc-number-input", providers: [DxcNumberInputHelper, CssUtils], template: "<dxc-text-input\n  #dxcInputRef\n  [label]=\"label\"\n  [placeholder]=\"placeholder\"\n  [helperText]=\"helperText\"\n  [margin]=\"margin\"\n  [value]=\"value\"\n  [error]=\"error\"\n  [size]=\"size\"\n  (onBlur)=\"handleOnBlur($event)\"\n  (onChange)=\"handleOnChange($event)\"\n  [tabIndexValue]=\"tabIndexValue\"\n  [disabled]=\"disabled\"\n  [optional]=\"optional\"\n  [autocomplete]=\"autocomplete\"\n  [defaultValue]=\"defaultValue\"\n>\n  <ng-content\n    select=\"dxc-text-input-suffix\"\n    ngProjectAs=\"dxc-text-input-suffix\"\n  ></ng-content>\n  <ng-content\n    select=\"dxc-text-input-prefix\"\n    ngProjectAs=\"dxc-text-input-prefix\"\n  ></ng-content>\n</dxc-text-input>\n" }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: DxcNumberInputHelper }]; }, propDecorators: { className: [{
                type: HostBinding,
                args: ["class"]
            }], label: [{
                type: Input
            }], name: [{
                type: Input
            }], value: [{
                type: Input
            }], defaultValue: [{
                type: Input
            }], helperText: [{
                type: Input
            }], placeholder: [{
                type: Input
            }], disabled: [{
                type: Input
            }], min: [{
                type: Input
            }], max: [{
                type: Input
            }], step: [{
                type: Input
            }], optional: [{
                type: Input
            }], error: [{
                type: Input
            }], autocomplete: [{
                type: Input
            }], margin: [{
                type: Input
            }], size: [{
                type: Input
            }], tabIndexValue: [{
                type: Input
            }], onChange: [{
                type: Output
            }], onBlur: [{
                type: Output
            }], dxcInputRef: [{
                type: ViewChild,
                args: ["dxcInputRef", { static: false }]
            }], keyEvent: [{
                type: HostListener,
                args: ["window:keydown", ["$event"]]
            }] } });

class DxcNumberInputModule {
}
DxcNumberInputModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcNumberInputModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DxcNumberInputModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcNumberInputModule, declarations: [DxcNumberInputComponent], imports: [CommonModule, DxcTextInputModule], exports: [DxcNumberInputComponent] });
DxcNumberInputModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcNumberInputModule, imports: [[CommonModule, DxcTextInputModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcNumberInputModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        DxcNumberInputComponent,
                    ],
                    imports: [CommonModule, DxcTextInputModule],
                    exports: [
                        DxcNumberInputComponent,
                    ],
                }]
        }] });

class UploadService {
    constructor() {
        this.success = new BehaviorSubject(null);
        this.errorMessage = new BehaviorSubject("");
    }
    setSuccess(newValue) {
        this.success.next(newValue);
    }
    setErrorMessage(newValue) {
        this.errorMessage.next(newValue);
    }
}
UploadService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: UploadService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
UploadService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: UploadService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: UploadService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return []; } });

class DxcTransactionComponent {
    constructor() {
        this.fileFormat = "default";
    }
    ngOnInit() {
        if (this.file.format.includes("image")) {
            this.fileFormat = "image";
        }
        else if (this.file.format.includes("video")) {
            this.fileFormat = "video";
        }
        else if (this.file.format.includes("audio")) {
            this.fileFormat = "audio";
        }
    }
    ngOnChanges() { }
}
DxcTransactionComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcTransactionComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
DxcTransactionComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.5", type: DxcTransactionComponent, selector: "dxc-transaction", inputs: { file: "file" }, usesOnChanges: true, ngImport: i0, template: "<div class=\"previewIcon\" [ngClass]=\"{ errorIcon: file.status == 'error' }\">\n  <svg\n    xmlns=\"http://www.w3.org/2000/svg\"\n    viewBox=\"0 0 24 24\"\n    *ngIf=\"fileFormat == 'default'\"\n  >\n    <path fill=\"none\" d=\"M0 0h24v24H0V0z\" />\n    <path\n      d=\"M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zM6 20V4h7v5h5v11H6z\"\n    />\n  </svg>\n  <svg\n    xmlns=\"http://www.w3.org/2000/svg\"\n    viewBox=\"0 0 24 24\"\n    *ngIf=\"fileFormat == 'image'\"\n  >\n    <path d=\"M0 0h24v24H0V0z\" fill=\"none\" />\n    <path\n      d=\"M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4.86 8.86l-3 3.87L9 13.14 6 17h12l-3.86-5.14z\"\n    />\n  </svg>\n  <svg\n    xmlns=\"http://www.w3.org/2000/svg\"\n    viewBox=\"0 0 24 24\"\n    *ngIf=\"fileFormat == 'video'\"\n  >\n    <path d=\"M0 0h24v24H0V0z\" fill=\"none\" />\n    <path\n      d=\"M4 6.47L5.76 10H20v8H4V6.47M22 4h-4l2 4h-3l-2-4h-2l2 4h-3l-2-4H8l2 4H7L5 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4z\"\n    />\n  </svg>\n  <svg\n    xmlns=\"http://www.w3.org/2000/svg\"\n    viewBox=\"0 0 24 24\"\n    *ngIf=\"fileFormat == 'audio'\"\n  >\n    <path fill=\"none\" d=\"M0 0h24v24H0V0z\" />\n    <path\n      d=\"M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h18v14zM8 15c0-1.66 1.34-3 3-3 .35 0 .69.07 1 .18V6h5v2h-3v7.03c-.02 1.64-1.35 2.97-3 2.97-1.66 0-3-1.34-3-3z\"\n    />\n  </svg>\n</div>\n<span [ngClass]=\"{ errorLabel: file.status == 'error' }\" class=\"fileName\">{{\n  file.name\n}}</span>\n<dxc-spinner\n  class=\"fileStatus\"\n  *ngIf=\"file.status == 'processing'\"\n  [mode]=\"'small'\"\n></dxc-spinner>\n\n<div class=\"fileStatus\" *ngIf=\"file.status == 'error'\">\n  <svg\n    xmlns=\"http://www.w3.org/2000/svg\"\n    width=\"24\"\n    height=\"24\"\n    viewBox=\"0 0 24 24\"\n    fill=\"#D0011B\"\n  >\n    <path\n      d=\"M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z\"\n    />\n    <path d=\"M0 0h24v24H0z\" fill=\"none\" />\n  </svg>\n</div>\n\n<div class=\"fileStatus\" *ngIf=\"file.status == 'success'\">\n  <svg\n    xmlns=\"http://www.w3.org/2000/svg\"\n    width=\"24\"\n    height=\"24\"\n    viewBox=\"0 0 24 24\"\n    fill=\"#50B50F\"\n  >\n    <path fill=\"none\" d=\"M0 0h24v24H0z\" />\n    <path d=\"M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z\" />\n  </svg>\n</div>\n", styles: [":host{display:flex;align-items:center;margin-bottom:16px;height:30px;max-width:95%}:host label{font-family:var(--upload-fontFamily);letter-spacing:.49px;font-size:16px}:host .fileStatus{display:flex;align-items:center}:host .previewIcon{margin-right:8px;fill:var(--upload-uploadedFileIconColor)}:host .previewIcon svg{width:var(--upload-uploadedFileIconSize);height:var(--upload-uploadedFileIconSize)}:host .errorIcon svg{fill:var(--upload-errorColor)}:host .fileName{margin-right:16px;text-overflow:ellipsis;max-width:75%;overflow:hidden;white-space:nowrap;font-size:var(--upload-fileNameFontSize);font-style:var(--upload-fileNameFontStyle);font-weight:var(--upload-fileNameFontWeight);text-transform:var(--upload-fileNameFontTextTransform);color:var(--upload-fileNameFontColor);font-family:var(--upload-fontFamily)}:host .fileName.errorLabel{color:var(--upload-errorColor)}\n"], components: [{ type: DxcSpinnerComponent, selector: "dxc-spinner", inputs: ["value", "label", "mode", "margin", "showValue"] }], directives: [{ type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcTransactionComponent, decorators: [{
            type: Component,
            args: [{ selector: "dxc-transaction", template: "<div class=\"previewIcon\" [ngClass]=\"{ errorIcon: file.status == 'error' }\">\n  <svg\n    xmlns=\"http://www.w3.org/2000/svg\"\n    viewBox=\"0 0 24 24\"\n    *ngIf=\"fileFormat == 'default'\"\n  >\n    <path fill=\"none\" d=\"M0 0h24v24H0V0z\" />\n    <path\n      d=\"M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zM6 20V4h7v5h5v11H6z\"\n    />\n  </svg>\n  <svg\n    xmlns=\"http://www.w3.org/2000/svg\"\n    viewBox=\"0 0 24 24\"\n    *ngIf=\"fileFormat == 'image'\"\n  >\n    <path d=\"M0 0h24v24H0V0z\" fill=\"none\" />\n    <path\n      d=\"M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4.86 8.86l-3 3.87L9 13.14 6 17h12l-3.86-5.14z\"\n    />\n  </svg>\n  <svg\n    xmlns=\"http://www.w3.org/2000/svg\"\n    viewBox=\"0 0 24 24\"\n    *ngIf=\"fileFormat == 'video'\"\n  >\n    <path d=\"M0 0h24v24H0V0z\" fill=\"none\" />\n    <path\n      d=\"M4 6.47L5.76 10H20v8H4V6.47M22 4h-4l2 4h-3l-2-4h-2l2 4h-3l-2-4H8l2 4H7L5 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4z\"\n    />\n  </svg>\n  <svg\n    xmlns=\"http://www.w3.org/2000/svg\"\n    viewBox=\"0 0 24 24\"\n    *ngIf=\"fileFormat == 'audio'\"\n  >\n    <path fill=\"none\" d=\"M0 0h24v24H0V0z\" />\n    <path\n      d=\"M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h18v14zM8 15c0-1.66 1.34-3 3-3 .35 0 .69.07 1 .18V6h5v2h-3v7.03c-.02 1.64-1.35 2.97-3 2.97-1.66 0-3-1.34-3-3z\"\n    />\n  </svg>\n</div>\n<span [ngClass]=\"{ errorLabel: file.status == 'error' }\" class=\"fileName\">{{\n  file.name\n}}</span>\n<dxc-spinner\n  class=\"fileStatus\"\n  *ngIf=\"file.status == 'processing'\"\n  [mode]=\"'small'\"\n></dxc-spinner>\n\n<div class=\"fileStatus\" *ngIf=\"file.status == 'error'\">\n  <svg\n    xmlns=\"http://www.w3.org/2000/svg\"\n    width=\"24\"\n    height=\"24\"\n    viewBox=\"0 0 24 24\"\n    fill=\"#D0011B\"\n  >\n    <path\n      d=\"M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z\"\n    />\n    <path d=\"M0 0h24v24H0z\" fill=\"none\" />\n  </svg>\n</div>\n\n<div class=\"fileStatus\" *ngIf=\"file.status == 'success'\">\n  <svg\n    xmlns=\"http://www.w3.org/2000/svg\"\n    width=\"24\"\n    height=\"24\"\n    viewBox=\"0 0 24 24\"\n    fill=\"#50B50F\"\n  >\n    <path fill=\"none\" d=\"M0 0h24v24H0z\" />\n    <path d=\"M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z\" />\n  </svg>\n</div>\n", styles: [":host{display:flex;align-items:center;margin-bottom:16px;height:30px;max-width:95%}:host label{font-family:var(--upload-fontFamily);letter-spacing:.49px;font-size:16px}:host .fileStatus{display:flex;align-items:center}:host .previewIcon{margin-right:8px;fill:var(--upload-uploadedFileIconColor)}:host .previewIcon svg{width:var(--upload-uploadedFileIconSize);height:var(--upload-uploadedFileIconSize)}:host .errorIcon svg{fill:var(--upload-errorColor)}:host .fileName{margin-right:16px;text-overflow:ellipsis;max-width:75%;overflow:hidden;white-space:nowrap;font-size:var(--upload-fileNameFontSize);font-style:var(--upload-fileNameFontStyle);font-weight:var(--upload-fileNameFontWeight);text-transform:var(--upload-fileNameFontTextTransform);color:var(--upload-fileNameFontColor);font-family:var(--upload-fontFamily)}:host .fileName.errorLabel{color:var(--upload-errorColor)}\n"] }]
        }], propDecorators: { file: [{
                type: Input
            }] } });

class DxcTransactionsComponent {
    constructor() {
        this.filesSummary = [];
    }
    ngOnInit() { }
    ngOnChanges() { }
}
DxcTransactionsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcTransactionsComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
DxcTransactionsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.5", type: DxcTransactionsComponent, selector: "dxc-transactions", inputs: { filesSummary: "filesSummary", successfulCount: "successfulCount" }, usesOnChanges: true, ngImport: i0, template: "<div class=\"header\">\n  <span class=\"uploadedLabel\">Files uploaded</span>\n  <span class=\"successCount\"\n    ><span>{{ successfulCount }}</span> files uploaded in total</span\n  >\n</div>\n<div *ngFor=\"let file of filesSummary; index as i; let first = first;\" class=\"filesSummary\" [class.first-item]=\"first\">\n  <dxc-transaction\n    matTooltip=\"{{ file.errorMessage }}\"\n    [file]=\"file\"\n    id=\"i\"\n  ></dxc-transaction>\n</div>\n", styles: [":host{width:35%;padding:46px 0 20px 65px;overflow-y:auto}:host::-webkit-scrollbar{width:3px}:host::-webkit-scrollbar-track{background-color:var(--upload-scrollBarTrackColor);border-radius:3px}:host::-webkit-scrollbar-thumb{background-color:var(--upload-scrollBarThumbColor);border-radius:3px}:host .filesSummary{margin-top:18px}:host .filesSummary.first-item{margin-top:30px}:host .header{display:flex;flex-direction:column}:host .header .uploadedLabel{font-family:var(--upload-fontFamily);letter-spacing:.26px;color:var(--upload-uploadedFilesTitleFontColor);margin-bottom:4px;font-size:var(--upload-uploadedFilesTitleFontSize);font-style:var(--upload-uploadedFilesTitleFontStyle);font-weight:var(--upload-uploadedFilesTitleFontWeight);text-transform:var(--upload-uploadedFilesTitleFontTextTransform)}:host .header .successCount{font-family:var(--upload-fontFamily);color:var(--upload-uploadedFilesSubtitleFontColor);font-size:var(--upload-uploadedFilesSubtitleFontSize);font-style:var(--upload-uploadedFilesSubtitleFontStyle);font-weight:var(--upload-uploadedFilesSubtitleFontWeight);text-transform:var(--upload-uploadedFilesSubtitleFontTextTransform)}:host .header .successCount span{font-weight:var(--upload-uploadedFilesNumberFontWeight)}\n"], components: [{ type: DxcTransactionComponent, selector: "dxc-transaction", inputs: ["file"] }], directives: [{ type: i4.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i3$5.MatTooltip, selector: "[matTooltip]", exportAs: ["matTooltip"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcTransactionsComponent, decorators: [{
            type: Component,
            args: [{ selector: "dxc-transactions", template: "<div class=\"header\">\n  <span class=\"uploadedLabel\">Files uploaded</span>\n  <span class=\"successCount\"\n    ><span>{{ successfulCount }}</span> files uploaded in total</span\n  >\n</div>\n<div *ngFor=\"let file of filesSummary; index as i; let first = first;\" class=\"filesSummary\" [class.first-item]=\"first\">\n  <dxc-transaction\n    matTooltip=\"{{ file.errorMessage }}\"\n    [file]=\"file\"\n    id=\"i\"\n  ></dxc-transaction>\n</div>\n", styles: [":host{width:35%;padding:46px 0 20px 65px;overflow-y:auto}:host::-webkit-scrollbar{width:3px}:host::-webkit-scrollbar-track{background-color:var(--upload-scrollBarTrackColor);border-radius:3px}:host::-webkit-scrollbar-thumb{background-color:var(--upload-scrollBarThumbColor);border-radius:3px}:host .filesSummary{margin-top:18px}:host .filesSummary.first-item{margin-top:30px}:host .header{display:flex;flex-direction:column}:host .header .uploadedLabel{font-family:var(--upload-fontFamily);letter-spacing:.26px;color:var(--upload-uploadedFilesTitleFontColor);margin-bottom:4px;font-size:var(--upload-uploadedFilesTitleFontSize);font-style:var(--upload-uploadedFilesTitleFontStyle);font-weight:var(--upload-uploadedFilesTitleFontWeight);text-transform:var(--upload-uploadedFilesTitleFontTextTransform)}:host .header .successCount{font-family:var(--upload-fontFamily);color:var(--upload-uploadedFilesSubtitleFontColor);font-size:var(--upload-uploadedFilesSubtitleFontSize);font-style:var(--upload-uploadedFilesSubtitleFontStyle);font-weight:var(--upload-uploadedFilesSubtitleFontWeight);text-transform:var(--upload-uploadedFilesSubtitleFontTextTransform)}:host .header .successCount span{font-weight:var(--upload-uploadedFilesNumberFontWeight)}\n"] }]
        }], propDecorators: { filesSummary: [{
                type: Input
            }], successfulCount: [{
                type: Input
            }] } });

class DxcDragAndDropComponent {
    constructor(service) {
        this.service = service;
        this.hoveringWithFile = false;
        this.onAddFile = new EventEmitter();
        this.summaryVisible = false;
        this.visibleAlert = false;
        this.errorMessage = "";
        this.reduced = false;
    }
    get tabIndexValue() {
        return this._tabIndexValue;
    }
    set tabIndexValue(value) {
        this._tabIndexValue = coerceNumberProperty(value);
    }
    ngOnInit() {
        this.service.success.subscribe((value) => {
            this.visibleAlert = value;
        });
        this.service.errorMessage.subscribe((value) => {
            this.errorMessage = value;
        });
    }
    ngOnChanges() {
        this.reduced = this.summaryVisible;
    }
    dragOver(event) {
        this.hoveringWithFile = true;
        event.preventDefault();
    }
    dragLeave(event) {
        this.hoveringWithFile = false;
        event.preventDefault();
    }
    drop(event) {
        this.hoveringWithFile = false;
        this.onAddFile.emit(event.dataTransfer.files);
        event.preventDefault();
    }
    onFileInput(event) {
        this.onAddFile.emit(event.target.files);
    }
    handleVisibleAlert() {
        this.visibleAlert = !this.visibleAlert;
        this.service.setSuccess(this.visibleAlert);
        this.service.setErrorMessage("");
    }
}
DxcDragAndDropComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcDragAndDropComponent, deps: [{ token: UploadService }], target: i0.ɵɵFactoryTarget.Component });
DxcDragAndDropComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.5", type: DxcDragAndDropComponent, selector: "dxc-drag-and-drop", inputs: { summaryVisible: "summaryVisible", tabIndexValue: "tabIndexValue" }, outputs: { onAddFile: "onAddFile" }, host: { properties: { "class.reduced": "this.reduced" } }, usesOnChanges: true, ngImport: i0, template: "<div\n  id=\"dropZone\"\n  [ngClass]=\"[\n    hoveringWithFile === true ? 'hovering' : 'notHovering',\n    summaryVisible === true ? 'summaryVisible' : ''\n  ]\"\n  (drop)=\"drop($event)\"\n  (dragleave)=\"dragLeave($event)\"\n  (dragover)=\"dragOver($event)\"\n>\n  <div *ngIf=\"!hoveringWithFile\" class=\"dropZone\">\n    <div class=\"alertMessage\" *ngIf=\"summaryVisible\">\n      <dxc-alert\n        *ngIf=\"visibleAlert && !errorMessage\"\n        margin=\"small\"\n        type=\"confirm\"\n        size=\"medium\"\n        inlineText=\"Files uploaded successfully\"\n        (onClose)=\"handleVisibleAlert()\"\n      ></dxc-alert>\n      <dxc-alert\n        *ngIf=\"visibleAlert && errorMessage\"\n        margin=\"small\"\n        type=\"error\"\n        size=\"medium\"\n        inlineText=\"A file couldn't be uploaded\"\n        (onClose)=\"handleVisibleAlert()\"\n      ></dxc-alert>\n    </div>\n    <div class=\"dropZoneContent\">\n      <svg\n        xmlns=\"http://www.w3.org/2000/svg\"\n        height=\"24\"\n        viewBox=\"0 0 24 24\"\n        width=\"24\"\n      >\n        <path d=\"M0 0h24v24H0V0z\" fill=\"none\" />\n        <path\n          d=\"M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM19 18H6c-2.21 0-4-1.79-4-4 0-2.05 1.53-3.76 3.56-3.97l1.07-.11.5-.95C8.08 7.14 9.94 6 12 6c2.62 0 4.88 1.86 5.39 4.43l.3 1.5 1.53.11c1.56.1 2.78 1.41 2.78 2.96 0 1.65-1.35 3-3 3zM8 13h2.55v3h2.9v-3H16l-4-4z\"\n        />\n      </svg>\n      <h6>There are no files to upload</h6>\n      <span class=\"dropLabel\">\n        Drag and drop your files here or choose one from your computer\n      </span>\n      <dxc-button\n        (onClick)=\"fileInput.click()\"\n        mode=\"secondary\"\n        label=\"Choose File\"\n        [tabIndexValue]=\"tabIndexValue\"\n      ></dxc-button>\n      <input\n        #fileInput\n        data-testid=\"fileInput\"\n        type=\"file\"\n        multiple=\"true\"\n        (change)=\"onFileInput($event)\"\n        style=\"display: none\"\n      />\n    </div>\n  </div>\n  <div *ngIf=\"hoveringWithFile\" class=\"droppingZone dropZone\">\n    <svg\n      xmlns=\"http://www.w3.org/2000/svg\"\n      enable-background=\"new 0 0 24 24\"\n      height=\"24\"\n      viewBox=\"0 0 24 24\"\n      width=\"24\"\n    >\n      <rect fill=\"none\" height=\"24\" width=\"24\" />\n      <path\n        d=\"M18,2H9C7.9,2,7,2.9,7,4v12c0,1.1,0.9,2,2,2h9c1.1,0,2-0.9,2-2V4C20,2.9,19.1,2,18,2z M18,16H9V4h9V16z M3,15v-2h2v2H3z M3,9.5h2v2H3V9.5z M10,20h2v2h-2V20z M3,18.5v-2h2v2H3z M5,22c-1.1,0-2-0.9-2-2h2V22z M8.5,22h-2v-2h2V22z M13.5,22L13.5,22l0-2h2 v0C15.5,21.1,14.6,22,13.5,22z M5,6L5,6l0,2H3v0C3,6.9,3.9,6,5,6z\"\n      />\n    </svg>\n    <span class=\"dropLabel\">Drop your file here</span>\n  </div>\n</div>\n", styles: [":host{width:100%}:host.reduced{max-width:65%}:host .dropZone{display:flex;flex-direction:column;justify-content:center;min-height:400px;border-radius:4px;position:relative}:host .dropZone svg{width:var(--upload-dragAndDropIconSize);height:var(--upload-dragAndDropIconSize);fill:var(--upload-dragAndDropIconColor)}:host .dropZone .dropZoneContent{align-items:center;display:flex;flex-direction:column;justify-content:center}:host .dropZone .alertMessage{z-index:2;position:absolute;width:100%;height:100%;display:flex;justify-content:flex-end}:host .summaryVisible{--border-color: #666666;--border-weight: 1px;--dash-size: 8px;--gap-size: 8px;background:linear-gradient(90deg,var(--border-color) 100%,transparent 100%) top left no-repeat,linear-gradient(90deg,transparent calc(var(--gap-size) / 2),var(--border-color) calc(var(--gap-size) / 2),var(--border-color) calc(var(--gap-size) / 2 + var(--dash-size)),transparent calc(var(--gap-size) / 2 + var(--dash-size))) top center repeat-x,linear-gradient(90deg,var(--border-color) 100%,transparent 100%) top right no-repeat,linear-gradient(0deg,var(--border-color) 100%,transparent 100%) top left no-repeat,linear-gradient(0deg,transparent calc(var(--gap-size) / 2),var(--border-color) calc(var(--gap-size) / 2),var(--border-color) calc(var(--gap-size) / 2 + var(--dash-size)),transparent calc(var(--gap-size) / 2 + var(--dash-size))) center left repeat-y,linear-gradient(0deg,var(--border-color) 100%,transparent 100%) bottom left no-repeat,linear-gradient(90deg,var(--border-color) 100%,transparent 100%) bottom left no-repeat,linear-gradient(90deg,transparent calc(var(--gap-size) / 2),var(--border-color) calc(var(--gap-size) / 2),var(--border-color) calc(var(--gap-size) / 2 + var(--dash-size)),transparent calc(var(--gap-size) / 2 + var(--dash-size))) bottom center repeat-x,linear-gradient(90deg,var(--border-color) 100%,transparent 100%) bottom right no-repeat,linear-gradient(0deg,var(--border-color) 100%,transparent 100%) top right no-repeat,linear-gradient(0deg,transparent calc(var(--gap-size) / 2),var(--border-color) calc(var(--gap-size) / 2),var(--border-color) calc(var(--gap-size) / 2 + var(--dash-size)),transparent calc(var(--gap-size) / 2 + var(--dash-size))) center right repeat-y,linear-gradient(0deg,var(--border-color) 100%,transparent 100%) bottom right no-repeat;background-size:var(--dash-size) var(--border-weight),calc(var(--dash-size) + var(--gap-size)) var(--border-weight),var(--dash-size) var(--border-weight),var(--border-weight) var(--dash-size),var(--border-weight) calc(var(--dash-size) + var(--gap-size)),var(--border-weight) var(--dash-size);background-color:var(--upload-draggingStateBackgroundColor)}:host .droppingZone{background-color:#f2f2f2;--border-color: #666666;--border-weight: 1px;--dash-size: 8px;--gap-size: 8px;background:linear-gradient(90deg,var(--border-color) 100%,transparent 100%) top left no-repeat,linear-gradient(90deg,transparent calc(var(--gap-size) / 2),var(--border-color) calc(var(--gap-size) / 2),var(--border-color) calc(var(--gap-size) / 2 + var(--dash-size)),transparent calc(var(--gap-size) / 2 + var(--dash-size))) top center repeat-x,linear-gradient(90deg,var(--border-color) 100%,transparent 100%) top right no-repeat,linear-gradient(0deg,var(--border-color) 100%,transparent 100%) top left no-repeat,linear-gradient(0deg,transparent calc(var(--gap-size) / 2),var(--border-color) calc(var(--gap-size) / 2),var(--border-color) calc(var(--gap-size) / 2 + var(--dash-size)),transparent calc(var(--gap-size) / 2 + var(--dash-size))) center left repeat-y,linear-gradient(0deg,var(--border-color) 100%,transparent 100%) bottom left no-repeat,linear-gradient(90deg,var(--border-color) 100%,transparent 100%) bottom left no-repeat,linear-gradient(90deg,transparent calc(var(--gap-size) / 2),var(--border-color) calc(var(--gap-size) / 2),var(--border-color) calc(var(--gap-size) / 2 + var(--dash-size)),transparent calc(var(--gap-size) / 2 + var(--dash-size))) bottom center repeat-x,linear-gradient(90deg,var(--border-color) 100%,transparent 100%) bottom right no-repeat,linear-gradient(0deg,var(--border-color) 100%,transparent 100%) top right no-repeat,linear-gradient(0deg,transparent calc(var(--gap-size) / 2),var(--border-color) calc(var(--gap-size) / 2),var(--border-color) calc(var(--gap-size) / 2 + var(--dash-size)),transparent calc(var(--gap-size) / 2 + var(--dash-size))) center right repeat-y,linear-gradient(0deg,var(--border-color) 100%,transparent 100%) bottom right no-repeat;background-size:var(--dash-size) var(--border-weight),calc(var(--dash-size) + var(--gap-size)) var(--border-weight),var(--dash-size) var(--border-weight),var(--border-weight) var(--dash-size),var(--border-weight) calc(var(--dash-size) + var(--gap-size)),var(--border-weight) var(--dash-size)}:host .droppingZone .dropLabel{font-size:var(--upload-dragAndDropDraggingStateFontSize);font-style:var(--upload-dragAndDropDraggingStateFontStyle);font-weight:var(--upload-dragAndDropDraggingStateFontWeight);text-transform:var(--upload-dragAndDropDraggingStateFontTextTransform);color:var(--upload-dragAndDropDraggingStateFontColor)}:host .droppingZone svg{margin-bottom:15px;fill:var(--upload-dragAndDropDraggingStateIconColor);height:var(--upload-dragAndDropDraggingStateIconSize);width:var(--upload-dragAndDropDraggingStateIconSize)}:host h6{margin:20px 0 10px;font-size:var(--upload-dragAndDropTitleFontSize);font-style:var(--upload-dragAndDropTitleFontStyle);font-weight:var(--upload-dragAndDropTitleFontWeight);text-transform:var(--upload-dragAndDropTitleFontTextTransform);color:var(--upload-dragAndDropTitleFontColor)}:host .dropLabel{margin-bottom:20px;font-size:var(--upload-dragAndDropDescriptionFontSize);font-style:var(--upload-dragAndDropDescriptionFontStyle);font-weight:var(--upload-dragAndDropDescriptionFontWeight);text-transform:var(--upload-dragAndDropDescriptionFontTextTransform);color:var(--upload-dragAndDropDescriptionFontColor)}:host h6,:host .dropLabel{font-family:var(--upload-fontFamily)!important}\n"], components: [{ type: DxcAlertComponent, selector: "dxc-alert", inputs: ["type", "mode", "inlineText", "tabIndexValue", "margin", "size"], outputs: ["onClose"] }, { type: DxcButtonComponent, selector: "dxc-button", inputs: ["mode", "disabled", "label", "iconSrc", "iconPosition", "margin", "size", "type", "tabIndexValue"], outputs: ["onClick"] }], directives: [{ type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcDragAndDropComponent, decorators: [{
            type: Component,
            args: [{ selector: "dxc-drag-and-drop", template: "<div\n  id=\"dropZone\"\n  [ngClass]=\"[\n    hoveringWithFile === true ? 'hovering' : 'notHovering',\n    summaryVisible === true ? 'summaryVisible' : ''\n  ]\"\n  (drop)=\"drop($event)\"\n  (dragleave)=\"dragLeave($event)\"\n  (dragover)=\"dragOver($event)\"\n>\n  <div *ngIf=\"!hoveringWithFile\" class=\"dropZone\">\n    <div class=\"alertMessage\" *ngIf=\"summaryVisible\">\n      <dxc-alert\n        *ngIf=\"visibleAlert && !errorMessage\"\n        margin=\"small\"\n        type=\"confirm\"\n        size=\"medium\"\n        inlineText=\"Files uploaded successfully\"\n        (onClose)=\"handleVisibleAlert()\"\n      ></dxc-alert>\n      <dxc-alert\n        *ngIf=\"visibleAlert && errorMessage\"\n        margin=\"small\"\n        type=\"error\"\n        size=\"medium\"\n        inlineText=\"A file couldn't be uploaded\"\n        (onClose)=\"handleVisibleAlert()\"\n      ></dxc-alert>\n    </div>\n    <div class=\"dropZoneContent\">\n      <svg\n        xmlns=\"http://www.w3.org/2000/svg\"\n        height=\"24\"\n        viewBox=\"0 0 24 24\"\n        width=\"24\"\n      >\n        <path d=\"M0 0h24v24H0V0z\" fill=\"none\" />\n        <path\n          d=\"M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM19 18H6c-2.21 0-4-1.79-4-4 0-2.05 1.53-3.76 3.56-3.97l1.07-.11.5-.95C8.08 7.14 9.94 6 12 6c2.62 0 4.88 1.86 5.39 4.43l.3 1.5 1.53.11c1.56.1 2.78 1.41 2.78 2.96 0 1.65-1.35 3-3 3zM8 13h2.55v3h2.9v-3H16l-4-4z\"\n        />\n      </svg>\n      <h6>There are no files to upload</h6>\n      <span class=\"dropLabel\">\n        Drag and drop your files here or choose one from your computer\n      </span>\n      <dxc-button\n        (onClick)=\"fileInput.click()\"\n        mode=\"secondary\"\n        label=\"Choose File\"\n        [tabIndexValue]=\"tabIndexValue\"\n      ></dxc-button>\n      <input\n        #fileInput\n        data-testid=\"fileInput\"\n        type=\"file\"\n        multiple=\"true\"\n        (change)=\"onFileInput($event)\"\n        style=\"display: none\"\n      />\n    </div>\n  </div>\n  <div *ngIf=\"hoveringWithFile\" class=\"droppingZone dropZone\">\n    <svg\n      xmlns=\"http://www.w3.org/2000/svg\"\n      enable-background=\"new 0 0 24 24\"\n      height=\"24\"\n      viewBox=\"0 0 24 24\"\n      width=\"24\"\n    >\n      <rect fill=\"none\" height=\"24\" width=\"24\" />\n      <path\n        d=\"M18,2H9C7.9,2,7,2.9,7,4v12c0,1.1,0.9,2,2,2h9c1.1,0,2-0.9,2-2V4C20,2.9,19.1,2,18,2z M18,16H9V4h9V16z M3,15v-2h2v2H3z M3,9.5h2v2H3V9.5z M10,20h2v2h-2V20z M3,18.5v-2h2v2H3z M5,22c-1.1,0-2-0.9-2-2h2V22z M8.5,22h-2v-2h2V22z M13.5,22L13.5,22l0-2h2 v0C15.5,21.1,14.6,22,13.5,22z M5,6L5,6l0,2H3v0C3,6.9,3.9,6,5,6z\"\n      />\n    </svg>\n    <span class=\"dropLabel\">Drop your file here</span>\n  </div>\n</div>\n", styles: [":host{width:100%}:host.reduced{max-width:65%}:host .dropZone{display:flex;flex-direction:column;justify-content:center;min-height:400px;border-radius:4px;position:relative}:host .dropZone svg{width:var(--upload-dragAndDropIconSize);height:var(--upload-dragAndDropIconSize);fill:var(--upload-dragAndDropIconColor)}:host .dropZone .dropZoneContent{align-items:center;display:flex;flex-direction:column;justify-content:center}:host .dropZone .alertMessage{z-index:2;position:absolute;width:100%;height:100%;display:flex;justify-content:flex-end}:host .summaryVisible{--border-color: #666666;--border-weight: 1px;--dash-size: 8px;--gap-size: 8px;background:linear-gradient(90deg,var(--border-color) 100%,transparent 100%) top left no-repeat,linear-gradient(90deg,transparent calc(var(--gap-size) / 2),var(--border-color) calc(var(--gap-size) / 2),var(--border-color) calc(var(--gap-size) / 2 + var(--dash-size)),transparent calc(var(--gap-size) / 2 + var(--dash-size))) top center repeat-x,linear-gradient(90deg,var(--border-color) 100%,transparent 100%) top right no-repeat,linear-gradient(0deg,var(--border-color) 100%,transparent 100%) top left no-repeat,linear-gradient(0deg,transparent calc(var(--gap-size) / 2),var(--border-color) calc(var(--gap-size) / 2),var(--border-color) calc(var(--gap-size) / 2 + var(--dash-size)),transparent calc(var(--gap-size) / 2 + var(--dash-size))) center left repeat-y,linear-gradient(0deg,var(--border-color) 100%,transparent 100%) bottom left no-repeat,linear-gradient(90deg,var(--border-color) 100%,transparent 100%) bottom left no-repeat,linear-gradient(90deg,transparent calc(var(--gap-size) / 2),var(--border-color) calc(var(--gap-size) / 2),var(--border-color) calc(var(--gap-size) / 2 + var(--dash-size)),transparent calc(var(--gap-size) / 2 + var(--dash-size))) bottom center repeat-x,linear-gradient(90deg,var(--border-color) 100%,transparent 100%) bottom right no-repeat,linear-gradient(0deg,var(--border-color) 100%,transparent 100%) top right no-repeat,linear-gradient(0deg,transparent calc(var(--gap-size) / 2),var(--border-color) calc(var(--gap-size) / 2),var(--border-color) calc(var(--gap-size) / 2 + var(--dash-size)),transparent calc(var(--gap-size) / 2 + var(--dash-size))) center right repeat-y,linear-gradient(0deg,var(--border-color) 100%,transparent 100%) bottom right no-repeat;background-size:var(--dash-size) var(--border-weight),calc(var(--dash-size) + var(--gap-size)) var(--border-weight),var(--dash-size) var(--border-weight),var(--border-weight) var(--dash-size),var(--border-weight) calc(var(--dash-size) + var(--gap-size)),var(--border-weight) var(--dash-size);background-color:var(--upload-draggingStateBackgroundColor)}:host .droppingZone{background-color:#f2f2f2;--border-color: #666666;--border-weight: 1px;--dash-size: 8px;--gap-size: 8px;background:linear-gradient(90deg,var(--border-color) 100%,transparent 100%) top left no-repeat,linear-gradient(90deg,transparent calc(var(--gap-size) / 2),var(--border-color) calc(var(--gap-size) / 2),var(--border-color) calc(var(--gap-size) / 2 + var(--dash-size)),transparent calc(var(--gap-size) / 2 + var(--dash-size))) top center repeat-x,linear-gradient(90deg,var(--border-color) 100%,transparent 100%) top right no-repeat,linear-gradient(0deg,var(--border-color) 100%,transparent 100%) top left no-repeat,linear-gradient(0deg,transparent calc(var(--gap-size) / 2),var(--border-color) calc(var(--gap-size) / 2),var(--border-color) calc(var(--gap-size) / 2 + var(--dash-size)),transparent calc(var(--gap-size) / 2 + var(--dash-size))) center left repeat-y,linear-gradient(0deg,var(--border-color) 100%,transparent 100%) bottom left no-repeat,linear-gradient(90deg,var(--border-color) 100%,transparent 100%) bottom left no-repeat,linear-gradient(90deg,transparent calc(var(--gap-size) / 2),var(--border-color) calc(var(--gap-size) / 2),var(--border-color) calc(var(--gap-size) / 2 + var(--dash-size)),transparent calc(var(--gap-size) / 2 + var(--dash-size))) bottom center repeat-x,linear-gradient(90deg,var(--border-color) 100%,transparent 100%) bottom right no-repeat,linear-gradient(0deg,var(--border-color) 100%,transparent 100%) top right no-repeat,linear-gradient(0deg,transparent calc(var(--gap-size) / 2),var(--border-color) calc(var(--gap-size) / 2),var(--border-color) calc(var(--gap-size) / 2 + var(--dash-size)),transparent calc(var(--gap-size) / 2 + var(--dash-size))) center right repeat-y,linear-gradient(0deg,var(--border-color) 100%,transparent 100%) bottom right no-repeat;background-size:var(--dash-size) var(--border-weight),calc(var(--dash-size) + var(--gap-size)) var(--border-weight),var(--dash-size) var(--border-weight),var(--border-weight) var(--dash-size),var(--border-weight) calc(var(--dash-size) + var(--gap-size)),var(--border-weight) var(--dash-size)}:host .droppingZone .dropLabel{font-size:var(--upload-dragAndDropDraggingStateFontSize);font-style:var(--upload-dragAndDropDraggingStateFontStyle);font-weight:var(--upload-dragAndDropDraggingStateFontWeight);text-transform:var(--upload-dragAndDropDraggingStateFontTextTransform);color:var(--upload-dragAndDropDraggingStateFontColor)}:host .droppingZone svg{margin-bottom:15px;fill:var(--upload-dragAndDropDraggingStateIconColor);height:var(--upload-dragAndDropDraggingStateIconSize);width:var(--upload-dragAndDropDraggingStateIconSize)}:host h6{margin:20px 0 10px;font-size:var(--upload-dragAndDropTitleFontSize);font-style:var(--upload-dragAndDropTitleFontStyle);font-weight:var(--upload-dragAndDropTitleFontWeight);text-transform:var(--upload-dragAndDropTitleFontTextTransform);color:var(--upload-dragAndDropTitleFontColor)}:host .dropLabel{margin-bottom:20px;font-size:var(--upload-dragAndDropDescriptionFontSize);font-style:var(--upload-dragAndDropDescriptionFontStyle);font-weight:var(--upload-dragAndDropDescriptionFontWeight);text-transform:var(--upload-dragAndDropDescriptionFontTextTransform);color:var(--upload-dragAndDropDescriptionFontColor)}:host h6,:host .dropLabel{font-family:var(--upload-fontFamily)!important}\n"] }]
        }], ctorParameters: function () { return [{ type: UploadService }]; }, propDecorators: { onAddFile: [{
                type: Output
            }], summaryVisible: [{
                type: Input
            }], tabIndexValue: [{
                type: Input
            }], reduced: [{
                type: HostBinding,
                args: ["class.reduced"]
            }] } });

class DxcFilePreviewComponent {
    constructor() {
        this.fileFormat = "default";
    }
    get tabIndexValue() {
        return this._tabIndexValue;
    }
    set tabIndexValue(value) {
        this._tabIndexValue = coerceNumberProperty(value);
    }
    ngOnInit() {
        if (this.file.format.includes("image")) {
            this.fileFormat = "image";
        }
        else if (this.file.format.includes("video")) {
            this.fileFormat = "video";
        }
        else if (this.file.format.includes("audio")) {
            this.fileFormat = "audio";
        }
    }
    onCloseHandler() {
        this.file.removeFile();
    }
}
DxcFilePreviewComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcFilePreviewComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
DxcFilePreviewComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.5", type: DxcFilePreviewComponent, selector: "dxc-file-preview", inputs: { file: "file", tabIndexValue: "tabIndexValue" }, ngImport: i0, template: "<div class=\"info\">\n  <div class=\"previewImage\" *ngIf=\"!file.image\">\n    <svg\n      xmlns=\"http://www.w3.org/2000/svg\"\n      viewBox=\"0 0 24 24\"\n      *ngIf=\"fileFormat == 'default'\"\n    >\n      <path fill=\"none\" d=\"M0 0h24v24H0V0z\" />\n      <path\n        d=\"M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zM6 20V4h7v5h5v11H6z\"\n      />\n    </svg>\n    <svg\n      xmlns=\"http://www.w3.org/2000/svg\"\n      viewBox=\"0 0 24 24\"\n      *ngIf=\"fileFormat == 'image'\"\n    >\n      <path d=\"M0 0h24v24H0z\" fill=\"none\" />\n      <path\n        d=\"M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z\"\n      />\n    </svg>\n    <svg\n      xmlns=\"http://www.w3.org/2000/svg\"\n      viewBox=\"0 0 24 24\"\n      *ngIf=\"fileFormat == 'video'\"\n    >\n      <path d=\"M0 0h24v24H0V0z\" fill=\"none\" />\n      <path\n        d=\"M4 6.47L5.76 10H20v8H4V6.47M22 4h-4l2 4h-3l-2-4h-2l2 4h-3l-2-4H8l2 4H7L5 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4z\"\n      />\n    </svg>\n    <svg\n      xmlns=\"http://www.w3.org/2000/svg\"\n      viewBox=\"0 0 24 24\"\n      *ngIf=\"fileFormat == 'audio'\"\n    >\n      <path fill=\"none\" d=\"M0 0h24v24H0V0z\" />\n      <path\n        d=\"M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h18v14zM8 15c0-1.66 1.34-3 3-3 .35 0 .69.07 1 .18V6h5v2h-3v7.03c-.02 1.64-1.35 2.97-3 2.97-1.66 0-3-1.34-3-3z\"\n      />\n    </svg>\n  </div>\n  <img class=\"previewImage\" *ngIf=\"file.image\" [src]=\"file.image\" />\n  <div class=\"labels\">\n    <label class=\"fileName\">{{ file.name }}</label>\n    <label class=\"fileSize\">{{ file.size }}</label>\n  </div>\n</div>\n\n<div class=\"removeIcon\" (click)=\"onCloseHandler()\">\n  <svg\n    [tabIndex]=\"tabIndexValue\"\n    xmlns=\"http://www.w3.org/2000/svg\"\n    viewBox=\"0 0 24 24\"\n  >\n    <path\n      d=\"M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z\"\n    />\n    <path d=\"M0 0h24v24H0z\" fill=\"none\" />\n  </svg>\n</div>\n", styles: [":host{padding:24px 40px 24px 24px;height:48px;display:flex;justify-content:space-between;border-bottom:var(--upload-fileUnderlineThickness) solid var(--upload-fileUnderlineColor)}:host .removeIcon{display:flex;align-items:center;cursor:pointer;fill:var(--upload-fileDeleteIconColor)}:host .removeIcon svg{width:var(--upload-fileDeleteIconSize);height:var(--upload-fileDeleteIconSize)}:host:hover{background-color:var(--upload-hoverFileColor)}:host .info{display:flex;width:90%}:host .info .previewImage{width:70px;display:flex;justify-content:center;margin-right:24px;object-fit:contain}:host .info .previewImage svg{height:48px;width:48px}:host .info .labels{width:85%;display:flex;flex-direction:column;justify-content:space-between}:host .info .labels label{text-overflow:ellipsis;overflow:hidden;white-space:nowrap}:host .info .fileName{font-size:var(--upload-fileNameFontSize);font-style:var(--upload-fileNameFontStyle);font-weight:var(--upload-fileNameFontWeight);text-transform:var(--upload-fileNameFontTextTransform);color:var(--upload-fileNameFontColor);font-family:var(--upload-fontFamily)}:host .info .fileSize{font-size:var(--upload-fileTypeFontSize);font-family:var(--upload-fontFamily);letter-spacing:1.88px;color:var(--upload-fileTypeFontColor);font-style:var(--upload-fileTypeFontStyle);font-weight:var(--upload-fileTypeFontWeight);text-transform:var(--upload-fileTypeFontTextTransform)}\n"], directives: [{ type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcFilePreviewComponent, decorators: [{
            type: Component,
            args: [{ selector: "dxc-file-preview", template: "<div class=\"info\">\n  <div class=\"previewImage\" *ngIf=\"!file.image\">\n    <svg\n      xmlns=\"http://www.w3.org/2000/svg\"\n      viewBox=\"0 0 24 24\"\n      *ngIf=\"fileFormat == 'default'\"\n    >\n      <path fill=\"none\" d=\"M0 0h24v24H0V0z\" />\n      <path\n        d=\"M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zM6 20V4h7v5h5v11H6z\"\n      />\n    </svg>\n    <svg\n      xmlns=\"http://www.w3.org/2000/svg\"\n      viewBox=\"0 0 24 24\"\n      *ngIf=\"fileFormat == 'image'\"\n    >\n      <path d=\"M0 0h24v24H0z\" fill=\"none\" />\n      <path\n        d=\"M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z\"\n      />\n    </svg>\n    <svg\n      xmlns=\"http://www.w3.org/2000/svg\"\n      viewBox=\"0 0 24 24\"\n      *ngIf=\"fileFormat == 'video'\"\n    >\n      <path d=\"M0 0h24v24H0V0z\" fill=\"none\" />\n      <path\n        d=\"M4 6.47L5.76 10H20v8H4V6.47M22 4h-4l2 4h-3l-2-4h-2l2 4h-3l-2-4H8l2 4H7L5 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4z\"\n      />\n    </svg>\n    <svg\n      xmlns=\"http://www.w3.org/2000/svg\"\n      viewBox=\"0 0 24 24\"\n      *ngIf=\"fileFormat == 'audio'\"\n    >\n      <path fill=\"none\" d=\"M0 0h24v24H0V0z\" />\n      <path\n        d=\"M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h18v14zM8 15c0-1.66 1.34-3 3-3 .35 0 .69.07 1 .18V6h5v2h-3v7.03c-.02 1.64-1.35 2.97-3 2.97-1.66 0-3-1.34-3-3z\"\n      />\n    </svg>\n  </div>\n  <img class=\"previewImage\" *ngIf=\"file.image\" [src]=\"file.image\" />\n  <div class=\"labels\">\n    <label class=\"fileName\">{{ file.name }}</label>\n    <label class=\"fileSize\">{{ file.size }}</label>\n  </div>\n</div>\n\n<div class=\"removeIcon\" (click)=\"onCloseHandler()\">\n  <svg\n    [tabIndex]=\"tabIndexValue\"\n    xmlns=\"http://www.w3.org/2000/svg\"\n    viewBox=\"0 0 24 24\"\n  >\n    <path\n      d=\"M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z\"\n    />\n    <path d=\"M0 0h24v24H0z\" fill=\"none\" />\n  </svg>\n</div>\n", styles: [":host{padding:24px 40px 24px 24px;height:48px;display:flex;justify-content:space-between;border-bottom:var(--upload-fileUnderlineThickness) solid var(--upload-fileUnderlineColor)}:host .removeIcon{display:flex;align-items:center;cursor:pointer;fill:var(--upload-fileDeleteIconColor)}:host .removeIcon svg{width:var(--upload-fileDeleteIconSize);height:var(--upload-fileDeleteIconSize)}:host:hover{background-color:var(--upload-hoverFileColor)}:host .info{display:flex;width:90%}:host .info .previewImage{width:70px;display:flex;justify-content:center;margin-right:24px;object-fit:contain}:host .info .previewImage svg{height:48px;width:48px}:host .info .labels{width:85%;display:flex;flex-direction:column;justify-content:space-between}:host .info .labels label{text-overflow:ellipsis;overflow:hidden;white-space:nowrap}:host .info .fileName{font-size:var(--upload-fileNameFontSize);font-style:var(--upload-fileNameFontStyle);font-weight:var(--upload-fileNameFontWeight);text-transform:var(--upload-fileNameFontTextTransform);color:var(--upload-fileNameFontColor);font-family:var(--upload-fontFamily)}:host .info .fileSize{font-size:var(--upload-fileTypeFontSize);font-family:var(--upload-fontFamily);letter-spacing:1.88px;color:var(--upload-fileTypeFontColor);font-style:var(--upload-fileTypeFontStyle);font-weight:var(--upload-fileTypeFontWeight);text-transform:var(--upload-fileTypeFontTextTransform)}\n"] }]
        }], propDecorators: { file: [{
                type: Input
            }], tabIndexValue: [{
                type: Input
            }] } });

class DxcFilesPreviewComponent {
    constructor(service) {
        this.service = service;
        this.showOverlay = new EventEmitter();
    }
    get tabIndexValue() {
        return this._tabIndexValue;
    }
    set tabIndexValue(value) {
        this._tabIndexValue = coerceNumberProperty(value);
    }
    ngOnInit() {
        this.service.setSuccess(false);
        this.service.setErrorMessage("");
    }
    dragEnter(event) {
        event.preventDefault();
        event.stopPropagation();
        this.showOverlay.emit(true);
    }
}
DxcFilesPreviewComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcFilesPreviewComponent, deps: [{ token: UploadService }], target: i0.ɵɵFactoryTarget.Component });
DxcFilesPreviewComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.5", type: DxcFilesPreviewComponent, selector: "dxc-files-preview", inputs: { filesList: "filesList", tabIndexValue: "tabIndexValue" }, outputs: { showOverlay: "showOverlay" }, ngImport: i0, template: "<div class=\"previewContainer\" (dragenter)=\"dragEnter($event)\">\n  <div *ngFor=\"let file of filesList\">\n    <dxc-file-preview [file]=\"file\" [tabIndexValue]=\"tabIndexValue\"></dxc-file-preview>\n  </div>\n</div>\n", styles: [":host{display:block;width:inherit;height:83%;overflow-y:auto}:host ::-webkit-scrollbar{width:3px}:host ::-webkit-scrollbar-track{background-color:var(--upload-scrollBarTrackColor);border-radius:3px}:host ::-webkit-scrollbar-thumb{background-color:var(--upload-scrollBarThumbColor);border-radius:3px}:host .previewContainer{overflow-y:auto;display:block;padding:24px;height:inherit}\n"], components: [{ type: DxcFilePreviewComponent, selector: "dxc-file-preview", inputs: ["file", "tabIndexValue"] }], directives: [{ type: i4.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcFilesPreviewComponent, decorators: [{
            type: Component,
            args: [{ selector: "dxc-files-preview", template: "<div class=\"previewContainer\" (dragenter)=\"dragEnter($event)\">\n  <div *ngFor=\"let file of filesList\">\n    <dxc-file-preview [file]=\"file\" [tabIndexValue]=\"tabIndexValue\"></dxc-file-preview>\n  </div>\n</div>\n", styles: [":host{display:block;width:inherit;height:83%;overflow-y:auto}:host ::-webkit-scrollbar{width:3px}:host ::-webkit-scrollbar-track{background-color:var(--upload-scrollBarTrackColor);border-radius:3px}:host ::-webkit-scrollbar-thumb{background-color:var(--upload-scrollBarThumbColor);border-radius:3px}:host .previewContainer{overflow-y:auto;display:block;padding:24px;height:inherit}\n"] }]
        }], ctorParameters: function () { return [{ type: UploadService }]; }, propDecorators: { showOverlay: [{
                type: Output
            }], filesList: [{
                type: Input
            }], tabIndexValue: [{
                type: Input
            }] } });

class DxcUploadButtonsComponent {
    constructor() {
        this.onAddFile = new EventEmitter();
        this.upload = new EventEmitter();
        this.showOverlay = new EventEmitter();
        this.margins = { left: "small" };
    }
    get tabIndexValue() {
        return this._tabIndexValue;
    }
    set tabIndexValue(value) {
        this._tabIndexValue = coerceNumberProperty(value);
    }
    ngOnInit() { }
    ngOnChanges() { }
    onFileInput(event) {
        this.onAddFile.emit(event.target.files);
    }
    onUploadHandler() {
        this.upload.emit("upload");
    }
    dragEnter(event) {
        event.preventDefault();
        event.stopPropagation();
        this.showOverlay.emit(true);
    }
}
DxcUploadButtonsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcUploadButtonsComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
DxcUploadButtonsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.5", type: DxcUploadButtonsComponent, selector: "dxc-upload-buttons", inputs: { tabIndexValue: "tabIndexValue" }, outputs: { onAddFile: "onAddFile", upload: "upload", showOverlay: "showOverlay" }, usesOnChanges: true, ngImport: i0, template: "<div class=\"uploadButtons\" (dragenter)=\"dragEnter($event)\">\n  <div class=\"dragAndDropLabel\">\n    <svg\n      xmlns=\"http://www.w3.org/2000/svg\"\n      enable-background=\"new 0 0 24 24\"\n      height=\"24\"\n      viewBox=\"0 0 24 24\"\n      width=\"24\"\n    >\n      <rect fill=\"none\" height=\"24\" width=\"24\" />\n      <path\n        d=\"M18,2H9C7.9,2,7,2.9,7,4v12c0,1.1,0.9,2,2,2h9c1.1,0,2-0.9,2-2V4C20,2.9,19.1,2,18,2z M18,16H9V4h9V16z M3,15v-2h2v2H3z M3,9.5h2v2H3V9.5z M10,20h2v2h-2V20z M3,18.5v-2h2v2H3z M5,22c-1.1,0-2-0.9-2-2h2V22z M8.5,22h-2v-2h2V22z M13.5,22L13.5,22l0-2h2 v0C15.5,21.1,14.6,22,13.5,22z M5,6L5,6l0,2H3v0C3,6.9,3.9,6,5,6z\"\n      />\n    </svg>\n    <label class=\"dragAreaLabel\">Drag and drop area</label>\n  </div>\n  <div class=\"buttonsContainer\">\n    <dxc-button\n      (onClick)=\"fileInput.click()\"\n      mode=\"text\"\n      label=\"Choose File\"\n      [tabIndexValue]=\"tabIndexValue\"\n    ></dxc-button>\n    <input\n      #fileInput\n      type=\"file\"\n      multiple=\"true\"\n      (change)=\"onFileInput($event)\"\n      style=\"display: none\"\n    />\n    <span class=\"uploadBtn\">\n      <dxc-button\n        (onClick)=\"onUploadHandler()\"\n        mode=\"secondary\"\n        label=\"Upload\"\n        [tabIndexValue]=\"tabIndexValue\"\n      >\n        <dxc-button-icon>\n          <svg\n            xmlns=\"http://www.w3.org/2000/svg\"\n            height=\"24\"\n            viewBox=\"0 0 24 24\"\n            width=\"24\"\n          >\n            <path d=\"M0 0h24v24H0V0z\" fill=\"none\" />\n            <path\n              d=\"M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM19 18H6c-2.21 0-4-1.79-4-4 0-2.05 1.53-3.76 3.56-3.97l1.07-.11.5-.95C8.08 7.14 9.94 6 12 6c2.62 0 4.88 1.86 5.39 4.43l.3 1.5 1.53.11c1.56.1 2.78 1.41 2.78 2.96 0 1.65-1.35 3-3 3zM8 13h2.55v3h2.9v-3H16l-4-4z\"\n            />\n          </svg>\n        </dxc-button-icon>\n      </dxc-button>\n    </span>\n  </div>\n</div>\n", styles: [":host{display:block}:host .dragAndDropLabel{display:flex;align-items:center;margin-right:50px}:host .dragAndDropLabel .dragAreaLabel{margin-left:5px;font-size:var(--upload-dragAndDropAreaTextFontSize);font-style:var(--upload-dragAndDropAreaTextFontStyle);font-weight:var(--upload-dragAndDropAreaTextFontWeight);text-transform:var(--upload-dragAndDropAreaTextFontTextTransform);color:var(--upload-dragAndDropAreaTextFontColor);font-family:var(--upload-fontFamily)}:host .dragAndDropLabel svg{fill:var(--upload-dragAndDropAreaIconColor);height:var(--upload-dragAndDropAreaIconSize);width:var(--upload-dragAndDropAreaIconSize)}:host .buttonsContainer .uploadBtn{margin-left:8px}:host .uploadButtons{display:flex;align-items:center;justify-content:space-between;padding:0 24px}\n"], components: [{ type: DxcButtonComponent, selector: "dxc-button", inputs: ["mode", "disabled", "label", "iconSrc", "iconPosition", "margin", "size", "type", "tabIndexValue"], outputs: ["onClick"] }, { type: DxcButtonIconComponent, selector: "dxc-button-icon" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcUploadButtonsComponent, decorators: [{
            type: Component,
            args: [{ selector: "dxc-upload-buttons", template: "<div class=\"uploadButtons\" (dragenter)=\"dragEnter($event)\">\n  <div class=\"dragAndDropLabel\">\n    <svg\n      xmlns=\"http://www.w3.org/2000/svg\"\n      enable-background=\"new 0 0 24 24\"\n      height=\"24\"\n      viewBox=\"0 0 24 24\"\n      width=\"24\"\n    >\n      <rect fill=\"none\" height=\"24\" width=\"24\" />\n      <path\n        d=\"M18,2H9C7.9,2,7,2.9,7,4v12c0,1.1,0.9,2,2,2h9c1.1,0,2-0.9,2-2V4C20,2.9,19.1,2,18,2z M18,16H9V4h9V16z M3,15v-2h2v2H3z M3,9.5h2v2H3V9.5z M10,20h2v2h-2V20z M3,18.5v-2h2v2H3z M5,22c-1.1,0-2-0.9-2-2h2V22z M8.5,22h-2v-2h2V22z M13.5,22L13.5,22l0-2h2 v0C15.5,21.1,14.6,22,13.5,22z M5,6L5,6l0,2H3v0C3,6.9,3.9,6,5,6z\"\n      />\n    </svg>\n    <label class=\"dragAreaLabel\">Drag and drop area</label>\n  </div>\n  <div class=\"buttonsContainer\">\n    <dxc-button\n      (onClick)=\"fileInput.click()\"\n      mode=\"text\"\n      label=\"Choose File\"\n      [tabIndexValue]=\"tabIndexValue\"\n    ></dxc-button>\n    <input\n      #fileInput\n      type=\"file\"\n      multiple=\"true\"\n      (change)=\"onFileInput($event)\"\n      style=\"display: none\"\n    />\n    <span class=\"uploadBtn\">\n      <dxc-button\n        (onClick)=\"onUploadHandler()\"\n        mode=\"secondary\"\n        label=\"Upload\"\n        [tabIndexValue]=\"tabIndexValue\"\n      >\n        <dxc-button-icon>\n          <svg\n            xmlns=\"http://www.w3.org/2000/svg\"\n            height=\"24\"\n            viewBox=\"0 0 24 24\"\n            width=\"24\"\n          >\n            <path d=\"M0 0h24v24H0V0z\" fill=\"none\" />\n            <path\n              d=\"M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM19 18H6c-2.21 0-4-1.79-4-4 0-2.05 1.53-3.76 3.56-3.97l1.07-.11.5-.95C8.08 7.14 9.94 6 12 6c2.62 0 4.88 1.86 5.39 4.43l.3 1.5 1.53.11c1.56.1 2.78 1.41 2.78 2.96 0 1.65-1.35 3-3 3zM8 13h2.55v3h2.9v-3H16l-4-4z\"\n            />\n          </svg>\n        </dxc-button-icon>\n      </dxc-button>\n    </span>\n  </div>\n</div>\n", styles: [":host{display:block}:host .dragAndDropLabel{display:flex;align-items:center;margin-right:50px}:host .dragAndDropLabel .dragAreaLabel{margin-left:5px;font-size:var(--upload-dragAndDropAreaTextFontSize);font-style:var(--upload-dragAndDropAreaTextFontStyle);font-weight:var(--upload-dragAndDropAreaTextFontWeight);text-transform:var(--upload-dragAndDropAreaTextFontTextTransform);color:var(--upload-dragAndDropAreaTextFontColor);font-family:var(--upload-fontFamily)}:host .dragAndDropLabel svg{fill:var(--upload-dragAndDropAreaIconColor);height:var(--upload-dragAndDropAreaIconSize);width:var(--upload-dragAndDropAreaIconSize)}:host .buttonsContainer .uploadBtn{margin-left:8px}:host .uploadButtons{display:flex;align-items:center;justify-content:space-between;padding:0 24px}\n"] }]
        }], propDecorators: { tabIndexValue: [{
                type: Input
            }], onAddFile: [{
                type: Output
            }], upload: [{
                type: Output
            }], showOverlay: [{
                type: Output
            }] } });

class DxcFilesToUploadComponent {
    constructor() {
        this.onAddFile = new EventEmitter();
        this.upload = new EventEmitter();
        this.summaryVisible = false;
        this.reduced = false;
        this.overlay = false;
    }
    get tabIndexValue() {
        return this._tabIndexValue;
    }
    set tabIndexValue(value) {
        this._tabIndexValue = coerceNumberProperty(value);
    }
    ngOnChanges() {
        this.reduced = this.summaryVisible;
    }
    dragOver(event) {
        event.preventDefault();
        event.stopPropagation();
    }
    dragLeave(event) {
        event.preventDefault();
        event.stopPropagation();
        this.overlay = false;
    }
    addFiles(event) {
        this.onAddFile.emit(event);
    }
    drop(event) {
        this.onAddFile.emit(event.dataTransfer.files);
        event.preventDefault();
        this.overlay = false;
    }
    showOverlay() {
        this.overlay = true;
    }
    handleUploadEvent() {
        this.upload.emit("upload");
    }
}
DxcFilesToUploadComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcFilesToUploadComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
DxcFilesToUploadComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.5", type: DxcFilesToUploadComponent, selector: "dxc-files-to-upload", inputs: { filesToUpload: "filesToUpload", summaryVisible: "summaryVisible", tabIndexValue: "tabIndexValue" }, outputs: { onAddFile: "onAddFile", upload: "upload" }, host: { properties: { "class.reduced": "this.reduced" } }, usesOnChanges: true, ngImport: i0, template: "<div\n  *ngIf=\"overlay\"\n  class=\"dropOverlay\"\n  (drop)=\"drop($event)\"\n  (dragleave)=\"dragLeave($event)\"\n  (dragover)=\"dragOver($event)\"\n></div>\n<dxc-files-preview\n  [ngClass]=\"[summaryVisible === true ? 'summaryVisible' : '']\"\n  *ngIf=\"filesToUpload\"\n  (showOverlay)=\"showOverlay()\"\n  [filesList]=\"filesToUpload\"\n  [tabIndexValue]=\"tabIndexValue\"\n></dxc-files-preview>\n<dxc-upload-buttons\n  *ngIf=\"filesToUpload\"\n  (showOverlay)=\"showOverlay()\"\n  (onAddFile)=\"addFiles($event)\"\n  (upload)=\"handleUploadEvent()\"\n  [tabIndexValue]=\"tabIndexValue\"\n></dxc-upload-buttons>\n", styles: [":host{display:block;max-width:inherit;width:100%;height:400px}:host.reduced{max-width:65%}:host .dropOverlay{background-color:transparent;width:100%;height:400px;z-index:100;position:fixed}\n"], components: [{ type: DxcFilesPreviewComponent, selector: "dxc-files-preview", inputs: ["filesList", "tabIndexValue"], outputs: ["showOverlay"] }, { type: DxcUploadButtonsComponent, selector: "dxc-upload-buttons", inputs: ["tabIndexValue"], outputs: ["onAddFile", "upload", "showOverlay"] }], directives: [{ type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcFilesToUploadComponent, decorators: [{
            type: Component,
            args: [{ selector: "dxc-files-to-upload", template: "<div\n  *ngIf=\"overlay\"\n  class=\"dropOverlay\"\n  (drop)=\"drop($event)\"\n  (dragleave)=\"dragLeave($event)\"\n  (dragover)=\"dragOver($event)\"\n></div>\n<dxc-files-preview\n  [ngClass]=\"[summaryVisible === true ? 'summaryVisible' : '']\"\n  *ngIf=\"filesToUpload\"\n  (showOverlay)=\"showOverlay()\"\n  [filesList]=\"filesToUpload\"\n  [tabIndexValue]=\"tabIndexValue\"\n></dxc-files-preview>\n<dxc-upload-buttons\n  *ngIf=\"filesToUpload\"\n  (showOverlay)=\"showOverlay()\"\n  (onAddFile)=\"addFiles($event)\"\n  (upload)=\"handleUploadEvent()\"\n  [tabIndexValue]=\"tabIndexValue\"\n></dxc-upload-buttons>\n", styles: [":host{display:block;max-width:inherit;width:100%;height:400px}:host.reduced{max-width:65%}:host .dropOverlay{background-color:transparent;width:100%;height:400px;z-index:100;position:fixed}\n"] }]
        }], propDecorators: { filesToUpload: [{
                type: Input
            }], onAddFile: [{
                type: Output
            }], upload: [{
                type: Output
            }], summaryVisible: [{
                type: Input
            }], tabIndexValue: [{
                type: Input
            }], reduced: [{
                type: HostBinding,
                args: ["class.reduced"]
            }] } });

class DxcUploadComponent {
    constructor(utils, service) {
        this.utils = utils;
        this.service = service;
        this.files = [];
        this.uploadedFiles = [];
        this.newFile = new EventEmitter();
        this.defaultInputs = new BehaviorSubject({
            margin: null,
            tabIndexValue: 0,
        });
    }
    /**
     * Value of the tabindex given to every interactuable elements.
     */
    get tabIndexValue() {
        return this._tabIndexValue;
    }
    set tabIndexValue(value) {
        this._tabIndexValue = coerceNumberProperty(value);
    }
    ngOnInit() {
        this.className = `${this.setDxcUploadDynamicStyle(this.defaultInputs.getValue())}`;
    }
    ngOnChanges(changes) {
        const inputs = Object.keys(changes).reduce((result, item) => {
            result[item] = changes[item].currentValue;
            return result;
        }, {});
        this.defaultInputs.next({ ...this.defaultInputs.getValue(), ...inputs });
        this.className = `${this.setDxcUploadDynamicStyle(this.defaultInputs.getValue())}`;
    }
    addFiles($event) {
        Array.from($event).forEach((file) => {
            this.getPreview(file);
        });
    }
    getPreview(file) {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (event) => {
            if (!file.type.includes("image") || file.type.includes("image/svg")) {
                const fileToPush = {};
                fileToPush["status"] = "pending";
                fileToPush["fileData"] = file;
                fileToPush["image"] = null;
                this.files.push(fileToPush);
            }
            else {
                const fileToPush = {};
                fileToPush["status"] = "pending";
                fileToPush["fileData"] = file;
                fileToPush["image"] = event.target["result"];
                this.files.push(fileToPush);
            }
        };
    }
    getFilesToUpload() {
        const aux = this;
        return this.files
            .filter(function (file) {
            return file.status === "pending";
        })
            .map(function (file) {
            const fileInfo = {};
            let sizeValue = file.fileData.size / (1024 * 1024);
            let size;
            sizeValue < 0.001
                ? (size = `${(file.fileData.size / 1024).toFixed(2)} KB`)
                : (size = `${sizeValue.toFixed(2)} MB`);
            fileInfo["name"] = file.fileData.name;
            fileInfo["size"] = size;
            fileInfo["format"] = file.fileData.type;
            fileInfo["image"] = file.image;
            fileInfo["removeFile"] = function () {
                const index = aux.files.indexOf(file, 0);
                if (index > -1) {
                    aux.files.splice(index, 1);
                }
            };
            return fileInfo;
        });
    }
    getUploadedFiles() {
        this.uploadedFiles = this.files
            .filter(function (file) {
            return file.status !== "pending";
        })
            .map(function (file) {
            const fileInfo = {};
            fileInfo["name"] = file.fileData.name;
            fileInfo["format"] = file.fileData.type;
            fileInfo["status"] = file.status;
            fileInfo["errorMessage"] = file.errorMessage;
            return fileInfo;
        });
    }
    getSuccessfullyUploadedFiles() {
        return this.files.filter(function (file) {
            return file.status === "success";
        }).length;
    }
    toUploadVisibility() {
        const pending = this.files.filter(function (file) {
            return file.status === "pending";
        });
        if (pending.length === 0) {
            return true;
        }
        else {
            return false;
        }
    }
    uploadedVisibility() {
        const pending = this.files.filter(function (file) {
            return file.status !== "pending";
        });
        if (pending.length === 0) {
            return false;
        }
        else {
            return true;
        }
    }
    handleUpload() {
        const aux = this;
        let promises = [];
        let errorMessage = "";
        this.files.forEach((file) => {
            if (file.status === "pending") {
                file.status = "processing";
                promises.push(this.uploadCallback(file)
                    .then(() => {
                    file.status = "success";
                    aux.getUploadedFiles();
                })
                    .catch((err) => {
                    errorMessage = err;
                    file.status = "error";
                    file.errorMessage = err;
                    aux.getUploadedFiles();
                })
                    .finally());
                this.getUploadedFiles();
            }
        });
        Promise.all(promises).then(() => {
            errorMessage
                ? this.service.setErrorMessage(errorMessage)
                : this.service.setSuccess(true);
        });
    }
    setDxcUploadDynamicStyle(input) {
        return css `
      ${this.utils.getMargins(input.margin)};
    `;
    }
}
DxcUploadComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcUploadComponent, deps: [{ token: CssUtils }, { token: UploadService }], target: i0.ɵɵFactoryTarget.Component });
DxcUploadComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.5", type: DxcUploadComponent, selector: "dxc-upload", inputs: { uploadCallback: "uploadCallback", margin: "margin", tabIndexValue: "tabIndexValue" }, host: { properties: { "class": "this.className" } }, providers: [CssUtils, UploadService], usesOnChanges: true, ngImport: i0, template: "<dxc-transactions\n  *ngIf=\"uploadedVisibility()\"\n  [successfulCount]=\"getSuccessfullyUploadedFiles()\"\n  [filesSummary]=\"uploadedFiles\"\n></dxc-transactions>\n<dxc-drag-and-drop\n  *ngIf=\"toUploadVisibility()\"\n  [summaryVisible]=\"uploadedVisibility()\"\n  (onAddFile)=\"addFiles($event)\"\n  [tabIndexValue]=\"tabIndexValue\"\n></dxc-drag-and-drop>\n<dxc-files-to-upload\n  data-testid=\"filesToUpload\"\n  *ngIf=\"!toUploadVisibility()\"\n  [summaryVisible]=\"uploadedVisibility()\"\n  [filesToUpload]=\"getFilesToUpload()\"\n  (onAddFile)=\"addFiles($event)\"\n  (upload)=\"handleUpload()\"\n  [tabIndexValue]=\"tabIndexValue\"\n></dxc-files-to-upload>\n", styles: [":host{box-shadow:0 3px 6px var(--upload-shadowColor);border-radius:4px;height:400px;display:flex;background-color:var(--upload-backgroundColor)}\n"], components: [{ type: DxcTransactionsComponent, selector: "dxc-transactions", inputs: ["filesSummary", "successfulCount"] }, { type: DxcDragAndDropComponent, selector: "dxc-drag-and-drop", inputs: ["summaryVisible", "tabIndexValue"], outputs: ["onAddFile"] }, { type: DxcFilesToUploadComponent, selector: "dxc-files-to-upload", inputs: ["filesToUpload", "summaryVisible", "tabIndexValue"], outputs: ["onAddFile", "upload"] }], directives: [{ type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcUploadComponent, decorators: [{
            type: Component,
            args: [{ selector: "dxc-upload", providers: [CssUtils, UploadService], template: "<dxc-transactions\n  *ngIf=\"uploadedVisibility()\"\n  [successfulCount]=\"getSuccessfullyUploadedFiles()\"\n  [filesSummary]=\"uploadedFiles\"\n></dxc-transactions>\n<dxc-drag-and-drop\n  *ngIf=\"toUploadVisibility()\"\n  [summaryVisible]=\"uploadedVisibility()\"\n  (onAddFile)=\"addFiles($event)\"\n  [tabIndexValue]=\"tabIndexValue\"\n></dxc-drag-and-drop>\n<dxc-files-to-upload\n  data-testid=\"filesToUpload\"\n  *ngIf=\"!toUploadVisibility()\"\n  [summaryVisible]=\"uploadedVisibility()\"\n  [filesToUpload]=\"getFilesToUpload()\"\n  (onAddFile)=\"addFiles($event)\"\n  (upload)=\"handleUpload()\"\n  [tabIndexValue]=\"tabIndexValue\"\n></dxc-files-to-upload>\n", styles: [":host{box-shadow:0 3px 6px var(--upload-shadowColor);border-radius:4px;height:400px;display:flex;background-color:var(--upload-backgroundColor)}\n"] }]
        }], ctorParameters: function () { return [{ type: CssUtils }, { type: UploadService }]; }, propDecorators: { uploadCallback: [{
                type: Input
            }], margin: [{
                type: Input
            }], tabIndexValue: [{
                type: Input
            }], className: [{
                type: HostBinding,
                args: ["class"]
            }] } });

class DxcUploadModule {
}
DxcUploadModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcUploadModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DxcUploadModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcUploadModule, declarations: [DxcUploadComponent,
        DxcDragAndDropComponent,
        DxcFilePreviewComponent,
        DxcFilesPreviewComponent,
        DxcUploadButtonsComponent,
        DxcFilesToUploadComponent,
        DxcTransactionsComponent,
        DxcTransactionComponent], imports: [CommonModule,
        MatButtonModule,
        MatTooltipModule,
        DxcButtonModule,
        DxcSpinnerModule,
        MatProgressSpinnerModule,
        DxcAlertModule], exports: [DxcUploadComponent,
        DxcDragAndDropComponent,
        DxcFilePreviewComponent,
        DxcFilesPreviewComponent,
        DxcUploadButtonsComponent,
        DxcFilesToUploadComponent,
        DxcTransactionsComponent,
        DxcTransactionComponent] });
DxcUploadModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcUploadModule, imports: [[
            CommonModule,
            MatButtonModule,
            MatTooltipModule,
            DxcButtonModule,
            DxcSpinnerModule,
            MatProgressSpinnerModule,
            DxcAlertModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcUploadModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        DxcUploadComponent,
                        DxcDragAndDropComponent,
                        DxcFilePreviewComponent,
                        DxcFilesPreviewComponent,
                        DxcUploadButtonsComponent,
                        DxcFilesToUploadComponent,
                        DxcTransactionsComponent,
                        DxcTransactionComponent,
                    ],
                    imports: [
                        CommonModule,
                        MatButtonModule,
                        MatTooltipModule,
                        DxcButtonModule,
                        DxcSpinnerModule,
                        MatProgressSpinnerModule,
                        DxcAlertModule
                    ],
                    exports: [
                        DxcUploadComponent,
                        DxcDragAndDropComponent,
                        DxcFilePreviewComponent,
                        DxcFilesPreviewComponent,
                        DxcUploadButtonsComponent,
                        DxcFilesToUploadComponent,
                        DxcTransactionsComponent,
                        DxcTransactionComponent,
                    ],
                }]
        }] });

class DxcTabbedSectionComponent {
    constructor() {
        this.tabChange = new EventEmitter$1();
        this.selectecTab = 0;
        this.TABS_HEIGHT = 54;
        this.offset = 0;
        this.defaultInputs = new BehaviorSubject({
            stickAtPx: 0,
        });
        this.stickAtPx = 0;
    }
    //input attributes
    get stickAtPx() {
        return this._stickAtPx;
    }
    set stickAtPx(value) {
        this._stickAtPx = coerceNumberProperty(value);
    }
    get sections() {
        return this._sections;
    }
    set sections(value) {
        this._sections = coerceArray(value);
    }
    ngOnInit() {
        this.styledDxcSectionTabbedGroup = `${this.setStyledDxcSectionTabbedGroup(this.defaultInputs.getValue())}`;
        this.calculateOffset(this.defaultInputs.getValue().stickAtPx);
    }
    ngOnChanges(changes) {
        const inputs = Object.keys(changes).reduce((result, item) => {
            result[item] = changes[item].currentValue;
            return result;
        }, {});
        this.defaultInputs.next({ ...this.defaultInputs.getValue(), ...inputs });
        this.styledDxcSectionTabbedGroup = `${this.setStyledDxcSectionTabbedGroup(this.defaultInputs.getValue())}`;
        this.calculateOffset(this.defaultInputs.getValue().stickAtPx);
    }
    scroll(section) {
        const topOfElement = document.getElementById(section).offsetTop - 1;
        window.scroll({ top: topOfElement - this.offset + 10, behavior: "smooth" });
    }
    onSectionChange(sectionId) {
        if (sectionId !== undefined && sectionId !== null) {
            this.tabId = +sectionId;
        }
        else {
            this.tabId = 0;
        }
    }
    calculateOffset(stickAtPx) {
        this.offset = +stickAtPx + this.TABS_HEIGHT;
    }
    setStyledDxcSectionTabbedGroup(input) {
        return css `
      #dxcTabbedSection .mat-tab-group {
        ${input.stickAtPx
            ? css `
              z-index: 300;
              position: sticky;
              top: ${+input.stickAtPx}px;
            `
            : css `
              z-index: 10;
              position: initial;
              top: unset;
            `};
      }
    `;
    }
}
DxcTabbedSectionComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcTabbedSectionComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
DxcTabbedSectionComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.5", type: DxcTabbedSectionComponent, selector: "dxc-tabbed-section", inputs: { stickAtPx: "stickAtPx", sections: "sections" }, viewQueries: [{ propertyName: "sectionTabGroup", first: true, predicate: DxcTabsComponent, descendants: true, static: true }], usesOnChanges: true, ngImport: i0, template: "<div [class]=\"styledDxcSectionTabbedGroup\">\n  <dxc-tabs\n    disableRipple\n    id=\"dxcTabbedSection\"\n    [activeTabIndex]=\"tabId\"\n  >\n    <dxc-tab\n      *ngFor=\"let currentSection of sections; let i = index\"\n      [label]=\"currentSection.label\"\n      (onTabClick)=\"scroll(currentSection.selector + i)\"\n    >\n    </dxc-tab>\n  </dxc-tabs>\n  <div\n    id=\"parentTabbedContainer\"\n    scroll-spy\n    [spiedTags]=\"['DIV']\"\n    (sectionChange)=\"onSectionChange($event)\"\n    [offset]=\"offset\"\n  >\n    <ng-content></ng-content>\n  </div>\n</div>\n", components: [{ type: DxcTabsComponent, selector: "dxc-tabs", inputs: ["activeTabIndex", "defaultActiveTabIndex", "iconPosition", "margin"] }, { type: DxcTabComponent, selector: "dxc-tab", inputs: ["label", "iconSrc", "disabled", "notificationNumber", "id"], outputs: ["onTabClick", "onTabHover"] }], directives: [{ type: i4.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: ScrollSpyDirective, selector: "[scroll-spy]", inputs: ["spiedTags", "offset"], outputs: ["sectionChange"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcTabbedSectionComponent, decorators: [{
            type: Component,
            args: [{ selector: "dxc-tabbed-section", template: "<div [class]=\"styledDxcSectionTabbedGroup\">\n  <dxc-tabs\n    disableRipple\n    id=\"dxcTabbedSection\"\n    [activeTabIndex]=\"tabId\"\n  >\n    <dxc-tab\n      *ngFor=\"let currentSection of sections; let i = index\"\n      [label]=\"currentSection.label\"\n      (onTabClick)=\"scroll(currentSection.selector + i)\"\n    >\n    </dxc-tab>\n  </dxc-tabs>\n  <div\n    id=\"parentTabbedContainer\"\n    scroll-spy\n    [spiedTags]=\"['DIV']\"\n    (sectionChange)=\"onSectionChange($event)\"\n    [offset]=\"offset\"\n  >\n    <ng-content></ng-content>\n  </div>\n</div>\n" }]
        }], ctorParameters: function () { return []; }, propDecorators: { stickAtPx: [{
                type: Input
            }], sections: [{
                type: Input
            }], sectionTabGroup: [{
                type: ViewChild,
                args: [DxcTabsComponent, { static: true }]
            }] } });

class DxcTabbedSectionModule {
}
DxcTabbedSectionModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcTabbedSectionModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DxcTabbedSectionModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcTabbedSectionModule, declarations: [DxcTabbedSectionComponent], imports: [ReactiveFormsModule,
        FormsModule,
        CommonModule,
        MatTabsModule,
        MatIconModule,
        ScrollSpyModule,
        DxcTabsModule], exports: [DxcTabbedSectionComponent] });
DxcTabbedSectionModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcTabbedSectionModule, imports: [[
            ReactiveFormsModule,
            FormsModule,
            CommonModule,
            MatTabsModule,
            MatIconModule,
            ScrollSpyModule,
            DxcTabsModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcTabbedSectionModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [DxcTabbedSectionComponent],
                    imports: [
                        ReactiveFormsModule,
                        FormsModule,
                        CommonModule,
                        MatTabsModule,
                        MatIconModule,
                        ScrollSpyModule,
                        DxcTabsModule,
                    ],
                    exports: [DxcTabbedSectionComponent],
                }]
        }] });

class DxcToggleIconComponent {
    constructor() {
        this.classes = "icon";
    }
    ngOnChanges() {
    }
}
DxcToggleIconComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcToggleIconComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
DxcToggleIconComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.5", type: DxcToggleIconComponent, selector: "dxc-toggle-icon", host: { properties: { "class": "this.classes" } }, usesOnChanges: true, ngImport: i0, template: "<ng-content></ng-content>" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcToggleIconComponent, decorators: [{
            type: Component,
            args: [{ selector: "dxc-toggle-icon", template: "<ng-content></ng-content>" }]
        }], ctorParameters: function () { return []; }, propDecorators: { classes: [{
                type: HostBinding,
                args: ["class"]
            }] } });

class DxcToggleComponent {
    constructor() {
        this.onClick = new EventEmitter();
        this.onKeyPress = new EventEmitter();
        this.selected = false;
        this.tabIndexValue = 0;
    }
    get valid() {
        return this.selected;
    }
    onClickHandler() {
        this.onClick.emit(this.value);
    }
    onHandleKeyPressHandler(event) {
        if (event.code === "Enter" || event.code === "Space") {
            this.onKeyPress.emit(this.value);
        }
    }
    setRole(role) {
        this.role = role;
    }
    ngOnInit() {
        this.style = `${this.getDynamicStyle()}`;
    }
    getDynamicStyle() {
        return css `
      display: flex;
      background: var(--toggleGroup-unselectedBackgroundColor);
      color: var(--toggleGroup-unselectedFontColor);
      border-radius: var(--toggleGroup-optionBorderRadius);
      border-width: var(--toggleGroup-optionBorderThickness);
      border-style: var(--toggleGroup-optionBorderStyle);
      .toggleContent {
        ${this.label
            ? `padding-left: var(--toggleGroup-labelPaddingLeft);
          padding-right: var(--toggleGroup-labelPaddingRight);`
            : `
          padding-left: var(--toggleGroup-iconPaddingLeft);
          padding-right: var(--toggleGroup-iconPaddingRight);
          `}

        &:focus,
          &:focus-within,
          &:focus-visible {
          outline: none;
        }
        height: 40px;
        width: 100% !important;
        display: flex;
        align-items: center;
        .label {
          font-family: var(--toggleGroup-labelFontFamily);
          font-size: var(--toggleGroup-labelFontSize);
          font-style: var(--toggleGroup-labelFontStyle);
          font-weight: var(--toggleGroup-labelFontWeight);
        }
        .icon {
          ${this.label
            ? `margin-right: var(--toggleGroup-iconMarginRight);`
            : ``}
          display: flex;
          height: 24px;
          overflow: hidden;
          width: 24px;
          svg {
            fill: var(--toggleGroup-unselectedFontColor);
            height: 100%;
            width: 100%;
          }
        }
      }
    `;
    }
}
DxcToggleComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcToggleComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
DxcToggleComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.5", type: DxcToggleComponent, selector: "dxc-toggle", inputs: { label: "label", value: "value" }, outputs: { onClick: "onClick", onKeyPress: "onKeyPress" }, host: { properties: { "class": "this.style", "class.selected": "this.valid" } }, providers: [], ngImport: i0, template: "<div\n  class=\"toggleContent\"\n  [attr.aria-checked]=\"selected\"\n  [attr.role]=\"role\"\n  (click)=\"onClickHandler()\"\n  (keypress)=\"onHandleKeyPressHandler($event)\"\n  [tabIndex]=\"tabIndexValue\"\n>\n  <ng-content select=\"dxc-toggle-icon\"></ng-content>\n  <span class=\"label\" *ngIf=\"label\"> {{ label }} </span>\n</div>\n", directives: [{ type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcToggleComponent, decorators: [{
            type: Component,
            args: [{ selector: "dxc-toggle", providers: [], template: "<div\n  class=\"toggleContent\"\n  [attr.aria-checked]=\"selected\"\n  [attr.role]=\"role\"\n  (click)=\"onClickHandler()\"\n  (keypress)=\"onHandleKeyPressHandler($event)\"\n  [tabIndex]=\"tabIndexValue\"\n>\n  <ng-content select=\"dxc-toggle-icon\"></ng-content>\n  <span class=\"label\" *ngIf=\"label\"> {{ label }} </span>\n</div>\n" }]
        }], propDecorators: { label: [{
                type: Input
            }], value: [{
                type: Input
            }], onClick: [{
                type: Output
            }], onKeyPress: [{
                type: Output
            }], style: [{
                type: HostBinding,
                args: ["class"]
            }], valid: [{
                type: HostBinding,
                args: ["class.selected"]
            }] } });

class DxcToggleGroupComponent {
    constructor(utils, ref) {
        this.utils = utils;
        this.ref = ref;
        this._multiple = false;
        this._disabled = false;
        /**
         * This event will emit when the user changes the state of any toggle.
         * The new value or values will be passed as a parameter.
         */
        this.onChange = new EventEmitter();
        this.selectedOptions = [];
        this.isControlled = false;
        this.defaultInputs = new BehaviorSubject({
            label: "",
            multiple: false,
            disabled: false,
            margin: null,
            tabIndexValue: 0,
        });
        this.toggleGroupId = `file-input${v4()}`;
    }
    /**
     * If true, the toggle group will support multiple selection.
     * In that case, value must be an array of numbers with the keys of the selected values.
     */
    get multiple() {
        return this._multiple;
    }
    set multiple(value) {
        this._multiple = coerceBooleanProperty(value);
    }
    /**
     * If true, the component will be disabled.
     */
    get disabled() {
        return this._disabled;
    }
    set disabled(value) {
        this._disabled = coerceBooleanProperty(value);
    }
    /**
     * Value of the tabindex which its propagated to their children components.
     */
    get tabIndexValue() {
        return this._tabIndexValue;
    }
    set tabIndexValue(value) {
        this._tabIndexValue = coerceNumberProperty(value);
    }
    ngOnInit() {
        if (this.value || this.value === "") {
            this.isControlled = true;
        }
        else {
            if (this.defaultValue || this.defaultValue === "") {
                if (Array.isArray(this.defaultValue)) {
                    this.defaultValue.forEach((item) => {
                        this.valueChanged(item);
                    });
                }
                else {
                    this.valueChanged(this.defaultValue);
                }
            }
        }
        this.styledDxcToggleGroup = `${this.setDxcToggleGroupDynamicStyle(this.defaultInputs.getValue())}`;
    }
    ngAfterContentInit() {
        // reference to the dxc-toggles and manipulating them depending on the given data
        if (this.toggleGroup) {
            this.toggleGroup.forEach((item, index) => {
                item.onClick.subscribe((value) => {
                    if (!this.disabled) {
                        this.valueChanged(value);
                    }
                });
                item.onKeyPress.subscribe((value) => {
                    if (!this.disabled) {
                        this.valueChanged(value);
                    }
                });
                setTimeout(() => {
                    item.tabIndexValue = this.disabled ? -1 : this.tabIndexValue;
                    item.role = this.multiple ? "switch" : "radio";
                    this.setToggleSelected(item);
                });
            });
        }
    }
    ngOnChanges(changes) {
        const inputs = Object.keys(changes).reduce((result, item) => {
            result[item] = changes[item].currentValue;
            return result;
        }, {});
        this.defaultInputs.next({ ...this.defaultInputs.getValue(), ...inputs });
        this.styledDxcToggleGroup = `${this.setDxcToggleGroupDynamicStyle(this.defaultInputs.getValue())}`;
        if (this.isControlled) {
            this.changeSelectedToggle();
        }
    }
    valueChanged(selectedOption) {
        let newSelectedOptions = [];
        //handle When value is defined
        if (!this.isControlled) {
            if (this.multiple) {
                newSelectedOptions = this.selectedOptions.map((value) => value);
                if (newSelectedOptions.includes(selectedOption)) {
                    const index = newSelectedOptions.indexOf(selectedOption);
                    newSelectedOptions.splice(index, 1);
                }
                else {
                    newSelectedOptions.push(selectedOption);
                }
                this.selectedOptions = newSelectedOptions;
            }
            else {
                this.selectedOptions =
                    selectedOption === this.selectedOptions ? null : selectedOption;
            }
        }
        else if (this.multiple && Array.isArray(this.value)) {
            newSelectedOptions = this.value.map((v) => v);
            if (newSelectedOptions.includes(selectedOption)) {
                const index = newSelectedOptions.indexOf(selectedOption);
                newSelectedOptions.splice(index, 1);
            }
            else {
                newSelectedOptions.push(selectedOption);
            }
        }
        else {
            newSelectedOptions = selectedOption;
        }
        this.changeSelectedToggle(this.multiple ? selectedOption : null);
        // Emit the new selected values
        this.onChange.emit(this.isControlled ? newSelectedOptions : this.selectedOptions);
    }
    changeSelectedToggle(selectedValue) {
        if (this.toggleGroup) {
            if (selectedValue) {
                const filterToggles = this.toggleGroup.filter((item) => item.value === selectedValue);
                filterToggles.forEach((item) => {
                    this.setToggleSelected(item);
                });
            }
            else {
                this.toggleGroup.forEach((item) => {
                    this.setToggleSelected(item);
                });
            }
            this.ref.detectChanges();
        }
    }
    setToggleSelected(item) {
        if (this.multiple) {
            this.isControlled
                ? (item.selected = this.value.includes(item.value))
                : (item.selected = this.selectedOptions.includes(item.value));
        }
        else {
            this.isControlled
                ? (item.selected = item.value === this.value)
                : (item.selected =
                    this.selectedOptions && this.selectedOptions.includes(item.value));
        }
    }
    disabledStyles() {
        if (this.disabled) {
            return css `
        dxc-toggle {
          background: var(--toggleGroup-unselectedDisabledBackgroundColor);
          color: var(--toggleGroup-unselectedDisabledFontColor);
          .toggleContent {
            &:focus {
              outline: none;
            }
            outline: none;
            .icon img,
            .icon svg {
              fill: var(--toggleGroup-unselectedDisabledFontColor);
            }
          }
          &:hover {
            cursor: not-allowed;
          }
          &.selected {
            background: var(--toggleGroup-selectedDisabledBackgroundColor);
            color: var(--toggleGroup-selectedDisabledFontColor);
            .icon img,
            .icon svg {
              fill: var(--toggleGroup-selectedDisabledFontColor);
            }
          }
        }
      `;
        }
        else {
            return css `
        dxc-toggle {
          color: var(--toggleGroup-unselectedFontColor);
          &:hover {
            cursor: pointer;
            background: var(--toggleGroup-unselectedHoverBackgroundColor);
            .icon img,
            .icon svg {
              fill: var(--toggleGroup-unselectedFontColor);
            }
          }
          &:active {
            cursor: pointer;
            background: var(--toggleGroup-unselectedActiveBackgroundColor);
            color: #ffffff;
            .icon img,
            .icon svg {
              fill: var(--toggleGroup-selectedFontColor);
            }
          }
          &:focus,
          &:focus-within,
          &:focus-visible {
            outline: solid 2px var(--toggleGroup-focusColor);
            outline-offset: -2px;
          }
          &.selected {
            background: var(--toggleGroup-selectedBackgroundColor);
            color: var(--toggleGroup-selectedFontColor);
            .icon img,
            .icon svg {
              fill: var(--toggleGroup-selectedFontColor);
            }
            &:active {
              background: var(--toggleGroup-selectedActiveBackgroundColor);
              color: #ffffff;
            }
            &:hover {
              background: var(--toggleGroup-selectedHoverBackgroundColor);
              .icon img,
              .icon svg {
                fill: var(--toggleGroup-selectedHoverFontColor);
              }
            }
          }
        }
      `;
        }
    }
    setDxcToggleGroupDynamicStyle(inputs) {
        return css `
      display: inline-flex;
      flex-direction: column;
      ${this.utils.getMargins(inputs.margin)};
      label {
        color: ${this.disabled
            ? "var(--toggleGroup-disabledLabelFontColor)"
            : "var(--toggleGroup-labelFontColor)"};
        font-family: var(--toggleGroup-labelFontFamily);
        font-size: var(--toggleGroup-labelFontSize);
        font-style: var(--toggleGroup-labelFontStyle);
        font-weight: var(--toggleGroup-labelFontWeight);
        line-height: var(--toggleGroup-labelLineHeight);
      }

      .helperText {
        color: ${this.disabled
            ? "var(--toggleGroup-disabledHelperTextFontColor)"
            : "var(--toggleGroup-helperTextFontColor)"};
        font-family: var(--toggleGroup-helperTextFontFamily);
        font-size: var(--toggleGroup-helperTextFontSize);
        font-style: var(--toggleGroup-helperTextFontStyle);
        font-weight: var(--toggleGroup-helperTextFontWeight);
        line-height: var(--toggleGroup-helperTextLineHeight);
      }
      .toggleContainer {
        width: max-content;
        display: inline-flex;
        flex-direction: row;
        opacity: 1;
        height: 48px;
        padding: 4px;
        margin-top: var(--toggleGroup-containerMarginTop);
        border-width: var(--toggleGroup-containerBorderThickness);
        border-style: var(--toggleGroup-containerBorderStyle);
        border-radius: var(--toggleGroup-containerBorderRadius);
        border-color: var(--toggleGroup-containerBorderColor);
        background-color: var(--toggleGroup-containerBackgroundColor);
        margin-top: var(--toggleGroup-containerMarginTop);
        align-items: center;
        min-height: 40px;
        box-sizing: border-box;
      }
      ${this.disabledStyles()};

      dxc-toggle:not(:last-of-type) {
        margin-right: 4px;
      }
    `;
    }
}
DxcToggleGroupComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcToggleGroupComponent, deps: [{ token: CssUtils }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
DxcToggleGroupComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.5", type: DxcToggleGroupComponent, selector: "dxc-togglegroup", inputs: { multiple: "multiple", disabled: "disabled", tabIndexValue: "tabIndexValue", margin: "margin", label: "label", helperText: "helperText", value: "value", defaultValue: "defaultValue" }, outputs: { onChange: "onChange" }, host: { properties: { "class": "this.styledDxcToggleGroup" } }, providers: [CssUtils], queries: [{ propertyName: "toggleGroup", predicate: DxcToggleComponent }], usesOnChanges: true, ngImport: i0, template: "  <label *ngIf=\"label\" [htmlFor]=\"toggleGroupId\">\n    {{label}}\n  </label>\n  <span class=\"helperText\" *ngIf=\"helperText\" class=\"helperText\">{{helperText}}</span>\n  <div class=\"toggleContainer\" [id]=\"toggleGroupId\" attr.role=\"{{multiple ? 'group': 'radiogroup'}}\">\n    <ng-content></ng-content>\n  </div>\n\n\n", directives: [{ type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcToggleGroupComponent, decorators: [{
            type: Component,
            args: [{ selector: "dxc-togglegroup", changeDetection: ChangeDetectionStrategy.OnPush, providers: [CssUtils], template: "  <label *ngIf=\"label\" [htmlFor]=\"toggleGroupId\">\n    {{label}}\n  </label>\n  <span class=\"helperText\" *ngIf=\"helperText\" class=\"helperText\">{{helperText}}</span>\n  <div class=\"toggleContainer\" [id]=\"toggleGroupId\" attr.role=\"{{multiple ? 'group': 'radiogroup'}}\">\n    <ng-content></ng-content>\n  </div>\n\n\n", styles: [] }]
        }], ctorParameters: function () { return [{ type: CssUtils }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { multiple: [{
                type: Input
            }], disabled: [{
                type: Input
            }], tabIndexValue: [{
                type: Input
            }], margin: [{
                type: Input
            }], label: [{
                type: Input
            }], helperText: [{
                type: Input
            }], value: [{
                type: Input
            }], defaultValue: [{
                type: Input
            }], onChange: [{
                type: Output
            }], toggleGroup: [{
                type: ContentChildren,
                args: [DxcToggleComponent]
            }], styledDxcToggleGroup: [{
                type: HostBinding,
                args: ["class"]
            }] } });

class DxcToggleGroupModule {
}
DxcToggleGroupModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcToggleGroupModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DxcToggleGroupModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcToggleGroupModule, declarations: [DxcToggleGroupComponent, DxcToggleComponent, DxcToggleIconComponent], imports: [CommonModule, MatIconModule], exports: [DxcToggleGroupComponent, DxcToggleComponent, DxcToggleIconComponent] });
DxcToggleGroupModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcToggleGroupModule, imports: [[CommonModule, MatIconModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcToggleGroupModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [DxcToggleGroupComponent, DxcToggleComponent, DxcToggleIconComponent],
                    imports: [CommonModule, MatIconModule],
                    exports: [DxcToggleGroupComponent, DxcToggleComponent, DxcToggleIconComponent],
                    entryComponents: [],
                }]
        }] });

class DxcPaginatorComponent {
    constructor(cdRef) {
        this.cdRef = cdRef;
        this._currentPage = 1;
        this._itemsPerPage = 5;
        /**
         * If true, a select will be displayed with the page numbers to move through them.
         */
        this.showGoToPage = false;
        this._totalItems = 1;
        this._tabIndexValue = 0;
        /**
         * This event will emit the new page when the user interacts with the page navigation
         * buttons or select. The page number will be passed as a parameter.
         */
        this.onGoToPage = new EventEmitter();
        /**
         * This event will emit in case of the user picks an option for the itemsPerPage select.
         * The value selected will be passed as a parameter.
         */
        this.itemsPerPageFunction = new EventEmitter();
        this.buttonMargin = { left: "xxsmall", right: "xxsmall" };
        this.showFirst = false;
        this.showLast = false;
        this.showNext = false;
        this.showPrev = false;
        this.defaultInputs = new BehaviorSubject({
            currentPage: 1,
            itemsPerPage: 5,
            showGoToPage: false,
            itemsPerPageOptions: [],
            totalItems: 1,
            paginationActions: null,
            tabIndexValue: 0,
        });
        this.currentPage = 1;
        this.itemsPerPage = 5;
        this.totalItems = 1;
    }
    /**
     * Number of the current selected page.
     */
    get currentPage() {
        return this._currentPage;
    }
    set currentPage(value) {
        this._currentPage = coerceNumberProperty(value);
    }
    /**
     * Number of items per page.
     */
    get itemsPerPage() {
        return this._itemsPerPage;
    }
    set itemsPerPage(value) {
        this._itemsPerPage = coerceNumberProperty(value);
    }
    /**
     * Total number of items in the pages.
     */
    get totalItems() {
        return this._totalItems;
    }
    set totalItems(value) {
        this._totalItems = coerceNumberProperty(value);
    }
    /**
     * Pagination actions to be rendered.
     * In case the property is not defined all actions will be rendered.
     */
    get paginationActions() {
        return this._paginationActions;
    }
    set paginationActions(value) {
        this._paginationActions = coerceArray(value);
    }
    /**
     * Value of the tabindex attribute.
     */
    get tabIndexValue() {
        return this._tabIndexValue;
    }
    set tabIndexValue(value) {
        this._tabIndexValue = coerceNumberProperty(value);
    }
    ngOnInit() {
        this.calculateInternalValues(this.defaultInputs.getValue());
        this.setButtonVisibility(this.paginationActions);
        this.className = `${this.getDynamicStyle()}`;
    }
    ngOnChanges(changes) {
        this.selectOptions = [];
        if (this.itemsPerPageOptions) {
            this.itemsPerPageOptions.map((value) => {
                const option = {
                    label: value.toString(),
                    value: value.toString(),
                };
                this.selectOptions.push(option);
            });
        }
        const inputs = Object.keys(changes).reduce((result, item) => {
            result[item] = changes[item].currentValue;
            return result;
        }, {});
        this.defaultInputs.next({ ...this.defaultInputs.getValue(), ...inputs });
        this.calculateInternalValues({
            ...this.defaultInputs.getValue(),
            ...inputs,
        });
        if (this.totalPages > 0) {
            this.totalPagesOptions = [];
            for (let i = 0; i < this.totalPages; i++) {
                const op = i + 1;
                const option = {
                    label: op.toString(),
                    value: op.toString(),
                };
                this.totalPagesOptions.push(option);
            }
        }
        this.className = `${this.getDynamicStyle()}`;
        this.cdRef.detectChanges();
    }
    onFirstHandler($event) {
        this.onGoToPage.emit(1);
    }
    onNextHandler($event) {
        this.onGoToPage.emit(+this.currentPage + 1);
    }
    onPrevHandler($event) {
        this.onGoToPage.emit(+this.currentPage - 1);
    }
    onLastHandler($event) {
        this.onGoToPage.emit(this.totalPages);
    }
    onItemsPerPageHandler(event) {
        this.itemsPerPageFunction.emit(parseInt(event.value));
    }
    goToPageHandler(event) {
        this.onGoToPage.emit(parseInt(event.value));
    }
    setButtonVisibility(paginationActions) {
        if (paginationActions) {
            paginationActions.forEach((item) => {
                switch (item) {
                    case "first":
                        this.showFirst = true;
                        break;
                    case "next":
                        this.showNext = true;
                        break;
                    case "prev":
                        this.showPrev = true;
                        break;
                    case "last":
                        this.showLast = true;
                        break;
                }
            });
        }
        else {
            this.showFirst = true;
            this.showNext = true;
            this.showPrev = true;
            this.showLast = true;
        }
    }
    calculateInternalValues(input) {
        this.totalPages = Math.ceil(input.totalItems / input.itemsPerPage);
        this.currentPageInternal =
            input.currentPage === -1 ? this.totalPages : input.currentPage;
        this.minItemsPerPage =
            this.currentPageInternal === 1
                ? this.currentPageInternal
                : (this.currentPageInternal - 1) * input.itemsPerPage + 1;
        this.maxItemsPerPage =
            this.minItemsPerPage - 1 + +input.itemsPerPage > +input.totalItems
                ? input.totalItems
                : this.minItemsPerPage - 1 + +input.itemsPerPage;
    }
    disabledFirstBtn() {
        return this.currentPageInternal == 1;
    }
    disabledLastBtn() {
        return this.currentPageInternal == this.totalPages;
    }
    getDynamicStyle() {
        return css `
      .mat-button-disabled {
        background-color: transparent !important;
        opacity: 0.3 !important;
      }
      dxc-select {
        margin-right: 0px;
      }
    `;
    }
}
DxcPaginatorComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcPaginatorComponent, deps: [{ token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
DxcPaginatorComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.5", type: DxcPaginatorComponent, selector: "dxc-paginator", inputs: { currentPage: "currentPage", itemsPerPage: "itemsPerPage", showGoToPage: "showGoToPage", itemsPerPageOptions: "itemsPerPageOptions", totalItems: "totalItems", paginationActions: "paginationActions", tabIndexValue: "tabIndexValue" }, outputs: { onGoToPage: "onGoToPage", itemsPerPageFunction: "itemsPerPageFunction" }, host: { properties: { "class": "this.className" } }, usesOnChanges: true, ngImport: i0, template: "<div class=\"paginator-container\">\n  <div class=\"labels-container\">\n    <span *ngIf=\"itemsPerPageOptions\" class=\"items-per-page\">\n      <span>Items per page</span>\n      <div class=\"selectContainer\">\n        <dxc-select\n          [value]=\"itemsPerPage.toString()\"\n          size=\"fillParent\"\n          [options]=\"selectOptions\"\n          (onChange)=\"onItemsPerPageHandler($event)\"\n          [tabIndex]=\"tabIndexValue\"\n        >\n        </dxc-select>\n      </div>\n    </span>\n\n    <span class=\"total-items-container\">\n      {{ minItemsPerPage }} to {{ maxItemsPerPage }} of {{ totalItems }}\n    </span>\n\n    <dxc-button\n      *ngIf=\"showFirst\"\n      mode=\"secondary\"\n      (onClick)=\"onFirstHandler($event)\"\n      size=\"small\"\n      [margin]=\"buttonMargin\"\n      [disabled]=\"disabledFirstBtn()\"\n      [tabIndexValue]=\"tabIndexValue\"\n    >\n      <dxc-button-icon>\n        <svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12.41 12\">\n          <path\n            id=\"Path_2463\"\n            data-name=\"Path 2463\"\n            d=\"M18.41,16.59,13.82,12l4.59-4.59L17,6l-6,6,6,6ZM6,6H8V18H6Z\"\n            transform=\"translate(-6 -6)\"\n          />\n        </svg>\n      </dxc-button-icon>\n    </dxc-button>\n    <dxc-button\n      *ngIf=\"showPrev\"\n      mode=\"secondary\"\n      (onClick)=\"onPrevHandler($event)\"\n      size=\"small\"\n      [margin]=\"buttonMargin\"\n      [disabled]=\"disabledFirstBtn()\"\n      [tabIndexValue]=\"tabIndexValue\"\n    >\n      <dxc-button-icon>\n        <svg\n          xmlns=\"http://www.w3.org/2000/svg\"\n          width=\"7.41\"\n          height=\"12\"\n          viewBox=\"0 0 7.41 12\"\n        >\n          <path\n            id=\"Path_2459\"\n            data-name=\"Path 2459\"\n            d=\"M15.41,7.41,14,6,8,12l6,6,1.41-1.41L10.83,12Z\"\n            transform=\"translate(-8 -6)\"\n          />\n        </svg>\n      </dxc-button-icon>\n    </dxc-button>\n    <span *ngIf=\"!showGoToPage\">\n      Page: {{ currentPageInternal }} of {{ totalPages }}\n    </span>\n    <span *ngIf=\"showGoToPage\" class=\"go-to-page\">\n      <span>Go to page</span>\n      <div class=\"selectContainer\">\n        <dxc-select\n          [value]=\"currentPage.toString()\"\n          size=\"fillParent\"\n          [options]=\"totalPagesOptions\"\n          (onChange)=\"goToPageHandler($event)\"\n          [tabIndex]=\"tabIndexValue\"\n        >\n        </dxc-select>\n      </div>\n    </span>\n    <dxc-button\n      *ngIf=\"showNext\"\n      mode=\"secondary\"\n      (onClick)=\"onNextHandler($event)\"\n      size=\"small\"\n      [margin]=\"buttonMargin\"\n      [disabled]=\"disabledLastBtn()\"\n      [tabIndexValue]=\"tabIndexValue\"\n    >\n      <dxc-button-icon>\n        <svg\n          xmlns=\"http://www.w3.org/2000/svg\"\n          width=\"7.41\"\n          height=\"12\"\n          viewBox=\"0 0 7.41 12\"\n        >\n          <path\n            id=\"Path_2461\"\n            data-name=\"Path 2461\"\n            d=\"M10,6,8.59,7.41,13.17,12,8.59,16.59,10,18l6-6Z\"\n            transform=\"translate(-8.59 -6)\"\n          />\n        </svg>\n      </dxc-button-icon>\n    </dxc-button>\n    <dxc-button\n      *ngIf=\"showLast\"\n      mode=\"secondary\"\n      (onClick)=\"onLastHandler($event)\"\n      size=\"small\"\n      [margin]=\"buttonMargin\"\n      [disabled]=\"disabledLastBtn()\"\n      [tabIndexValue]=\"tabIndexValue\"\n    >\n      <dxc-button-icon>\n        <svg\n          xmlns=\"http://www.w3.org/2000/svg\"\n          width=\"12.41\"\n          height=\"12\"\n          viewBox=\"0 0 12.41 12\"\n        >\n          <path\n            id=\"Path_2465\"\n            data-name=\"Path 2465\"\n            d=\"M5.59,7.41,10.18,12,5.59,16.59,7,18l6-6L7,6ZM16,6h2V18H16Z\"\n            transform=\"translate(-5.59 -6)\"\n          />\n        </svg>\n      </dxc-button-icon>\n    </dxc-button>\n  </div>\n</div>\n", styles: [".items-per-page,.go-to-page{display:flex;align-items:center}.items-per-page span,.go-to-page span{font-family:var(--paginator-fontFamily);color:var(--paginator-fontColor);font-size:var(--paginator-fontSize);font-style:var(--paginator-fontStyle);font-weight:var(--paginator-fontWeight);text-transform:var(--paginator-fontTextTransform);margin-right:15px}.items-per-page .selectContainer,.go-to-page .selectContainer{max-width:100px}.go-to-page{margin-right:var(--paginator-pageSelectorMarginRight);margin-left:var(--paginator-pageSelectorMarginLeft)}.items-per-page{margin-right:var(--paginator-itemsPerPageSelectorMarginRight);margin-left:var(--paginator-itemsPerPageSelectorMarginLeft)}.pagination{margin-top:20px;display:flex;flex-direction:row;justify-content:center;align-items:center}.paginator-container{display:flex;height:var(--paginator-height);background-color:var(--paginator-backgroundColor);width:var(--paginator-width)}.total-items-container{margin-right:var(--paginator-totalItemsContainerMarginRight);margin-left:var(--paginator-totalItemsContainerMarginLeft);font-family:var(--paginator-fontFamily);color:var(--paginator-fontColor);font-size:var(--paginator-fontSize);font-style:var(--paginator-fontStyle);font-weight:var(--paginator-fontWeight)}.labels-container{display:flex;width:100%;justify-content:flex-end;align-items:center;margin-right:var(--paginator-marginRight);margin-left:var(--paginator-marginLeft)}\n"], components: [{ type: DxcSelectComponent, selector: "dxc-select", inputs: ["label", "name", "value", "defaultValue", "helperText", "searchable", "disabled", "multiple", "optional", "error", "placeholder", "margin", "tabIndexValue", "size", "options"], outputs: ["onChange", "onBlur"] }, { type: DxcButtonComponent, selector: "dxc-button", inputs: ["mode", "disabled", "label", "iconSrc", "iconPosition", "margin", "size", "type", "tabIndexValue"], outputs: ["onClick"] }, { type: DxcButtonIconComponent, selector: "dxc-button-icon" }], directives: [{ type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcPaginatorComponent, decorators: [{
            type: Component,
            args: [{ selector: "dxc-paginator", template: "<div class=\"paginator-container\">\n  <div class=\"labels-container\">\n    <span *ngIf=\"itemsPerPageOptions\" class=\"items-per-page\">\n      <span>Items per page</span>\n      <div class=\"selectContainer\">\n        <dxc-select\n          [value]=\"itemsPerPage.toString()\"\n          size=\"fillParent\"\n          [options]=\"selectOptions\"\n          (onChange)=\"onItemsPerPageHandler($event)\"\n          [tabIndex]=\"tabIndexValue\"\n        >\n        </dxc-select>\n      </div>\n    </span>\n\n    <span class=\"total-items-container\">\n      {{ minItemsPerPage }} to {{ maxItemsPerPage }} of {{ totalItems }}\n    </span>\n\n    <dxc-button\n      *ngIf=\"showFirst\"\n      mode=\"secondary\"\n      (onClick)=\"onFirstHandler($event)\"\n      size=\"small\"\n      [margin]=\"buttonMargin\"\n      [disabled]=\"disabledFirstBtn()\"\n      [tabIndexValue]=\"tabIndexValue\"\n    >\n      <dxc-button-icon>\n        <svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12.41 12\">\n          <path\n            id=\"Path_2463\"\n            data-name=\"Path 2463\"\n            d=\"M18.41,16.59,13.82,12l4.59-4.59L17,6l-6,6,6,6ZM6,6H8V18H6Z\"\n            transform=\"translate(-6 -6)\"\n          />\n        </svg>\n      </dxc-button-icon>\n    </dxc-button>\n    <dxc-button\n      *ngIf=\"showPrev\"\n      mode=\"secondary\"\n      (onClick)=\"onPrevHandler($event)\"\n      size=\"small\"\n      [margin]=\"buttonMargin\"\n      [disabled]=\"disabledFirstBtn()\"\n      [tabIndexValue]=\"tabIndexValue\"\n    >\n      <dxc-button-icon>\n        <svg\n          xmlns=\"http://www.w3.org/2000/svg\"\n          width=\"7.41\"\n          height=\"12\"\n          viewBox=\"0 0 7.41 12\"\n        >\n          <path\n            id=\"Path_2459\"\n            data-name=\"Path 2459\"\n            d=\"M15.41,7.41,14,6,8,12l6,6,1.41-1.41L10.83,12Z\"\n            transform=\"translate(-8 -6)\"\n          />\n        </svg>\n      </dxc-button-icon>\n    </dxc-button>\n    <span *ngIf=\"!showGoToPage\">\n      Page: {{ currentPageInternal }} of {{ totalPages }}\n    </span>\n    <span *ngIf=\"showGoToPage\" class=\"go-to-page\">\n      <span>Go to page</span>\n      <div class=\"selectContainer\">\n        <dxc-select\n          [value]=\"currentPage.toString()\"\n          size=\"fillParent\"\n          [options]=\"totalPagesOptions\"\n          (onChange)=\"goToPageHandler($event)\"\n          [tabIndex]=\"tabIndexValue\"\n        >\n        </dxc-select>\n      </div>\n    </span>\n    <dxc-button\n      *ngIf=\"showNext\"\n      mode=\"secondary\"\n      (onClick)=\"onNextHandler($event)\"\n      size=\"small\"\n      [margin]=\"buttonMargin\"\n      [disabled]=\"disabledLastBtn()\"\n      [tabIndexValue]=\"tabIndexValue\"\n    >\n      <dxc-button-icon>\n        <svg\n          xmlns=\"http://www.w3.org/2000/svg\"\n          width=\"7.41\"\n          height=\"12\"\n          viewBox=\"0 0 7.41 12\"\n        >\n          <path\n            id=\"Path_2461\"\n            data-name=\"Path 2461\"\n            d=\"M10,6,8.59,7.41,13.17,12,8.59,16.59,10,18l6-6Z\"\n            transform=\"translate(-8.59 -6)\"\n          />\n        </svg>\n      </dxc-button-icon>\n    </dxc-button>\n    <dxc-button\n      *ngIf=\"showLast\"\n      mode=\"secondary\"\n      (onClick)=\"onLastHandler($event)\"\n      size=\"small\"\n      [margin]=\"buttonMargin\"\n      [disabled]=\"disabledLastBtn()\"\n      [tabIndexValue]=\"tabIndexValue\"\n    >\n      <dxc-button-icon>\n        <svg\n          xmlns=\"http://www.w3.org/2000/svg\"\n          width=\"12.41\"\n          height=\"12\"\n          viewBox=\"0 0 12.41 12\"\n        >\n          <path\n            id=\"Path_2465\"\n            data-name=\"Path 2465\"\n            d=\"M5.59,7.41,10.18,12,5.59,16.59,7,18l6-6L7,6ZM16,6h2V18H16Z\"\n            transform=\"translate(-5.59 -6)\"\n          />\n        </svg>\n      </dxc-button-icon>\n    </dxc-button>\n  </div>\n</div>\n", styles: [".items-per-page,.go-to-page{display:flex;align-items:center}.items-per-page span,.go-to-page span{font-family:var(--paginator-fontFamily);color:var(--paginator-fontColor);font-size:var(--paginator-fontSize);font-style:var(--paginator-fontStyle);font-weight:var(--paginator-fontWeight);text-transform:var(--paginator-fontTextTransform);margin-right:15px}.items-per-page .selectContainer,.go-to-page .selectContainer{max-width:100px}.go-to-page{margin-right:var(--paginator-pageSelectorMarginRight);margin-left:var(--paginator-pageSelectorMarginLeft)}.items-per-page{margin-right:var(--paginator-itemsPerPageSelectorMarginRight);margin-left:var(--paginator-itemsPerPageSelectorMarginLeft)}.pagination{margin-top:20px;display:flex;flex-direction:row;justify-content:center;align-items:center}.paginator-container{display:flex;height:var(--paginator-height);background-color:var(--paginator-backgroundColor);width:var(--paginator-width)}.total-items-container{margin-right:var(--paginator-totalItemsContainerMarginRight);margin-left:var(--paginator-totalItemsContainerMarginLeft);font-family:var(--paginator-fontFamily);color:var(--paginator-fontColor);font-size:var(--paginator-fontSize);font-style:var(--paginator-fontStyle);font-weight:var(--paginator-fontWeight)}.labels-container{display:flex;width:100%;justify-content:flex-end;align-items:center;margin-right:var(--paginator-marginRight);margin-left:var(--paginator-marginLeft)}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }]; }, propDecorators: { currentPage: [{
                type: Input
            }], itemsPerPage: [{
                type: Input
            }], showGoToPage: [{
                type: Input
            }], itemsPerPageOptions: [{
                type: Input
            }], totalItems: [{
                type: Input
            }], paginationActions: [{
                type: Input
            }], tabIndexValue: [{
                type: Input
            }], onGoToPage: [{
                type: Output
            }], itemsPerPageFunction: [{
                type: Output
            }], className: [{
                type: HostBinding,
                args: ["class"]
            }] } });

class DxcPaginatorModule {
}
DxcPaginatorModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcPaginatorModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DxcPaginatorModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcPaginatorModule, declarations: [DxcPaginatorComponent], imports: [CommonModule, DxcButtonModule, DxcSelectModule], exports: [DxcPaginatorComponent] });
DxcPaginatorModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcPaginatorModule, imports: [[CommonModule, DxcButtonModule, DxcSelectModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcPaginatorModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [DxcPaginatorComponent],
                    imports: [CommonModule, DxcButtonModule, DxcSelectModule],
                    exports: [DxcPaginatorComponent],
                }]
        }] });

class DxcWizardIconComponent {
    constructor() { }
    ngOnInit() { }
}
DxcWizardIconComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcWizardIconComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
DxcWizardIconComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.5", type: DxcWizardIconComponent, selector: "dxc-wizard-icon", ngImport: i0, template: "<ng-content></ng-content>" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcWizardIconComponent, decorators: [{
            type: Component,
            args: [{ selector: "dxc-wizard-icon", template: "<ng-content></ng-content>" }]
        }], ctorParameters: function () { return []; } });

class WizardService {
    constructor() {
        this.steps = undefined;
        this.innerCurrentStep = new BehaviorSubject(undefined);
        this.newCurrentStep = new BehaviorSubject(undefined);
        this.mode = new BehaviorSubject(undefined);
        this.tabIndexValue = new BehaviorSubject(0);
        this.innerCurrentStep.subscribe((newCurrent) => {
            if (this.steps && (newCurrent || newCurrent === 0)) {
                this.steps.forEach((element, index) => {
                    element.setIsCurrent(index === newCurrent, newCurrent);
                });
            }
        });
    }
    setSteps(steps) {
        this.steps = steps;
        if (this.steps) {
            this.steps.forEach((element, index) => {
                element.isFirst = index === 0;
                element.setIsLast(index === this.steps.length - 1);
                element.position = index;
                element.setIsCurrent(index === this.innerCurrentStep.value, this.innerCurrentStep.value);
            });
        }
    }
}
WizardService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: WizardService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
WizardService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: WizardService, providedIn: "root" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: WizardService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: "root",
                }]
        }], ctorParameters: function () { return []; } });

class DxcWizardStepComponent {
    constructor(cdRef, service) {
        this.cdRef = cdRef;
        this.service = service;
        this._disabled = false;
        //Props controlled by father component
        this.position = 0;
        this.isCurrent = false;
        this.mode = "horizontal";
        this.isVisited = false;
        this.tabIndexValue = 0;
        this.validIcon = "assets/valid_icon.svg";
        this.invalidIcon = "assets/invalid_icon.svg";
        this.containsIcon = false;
        this.defaultInputs = new BehaviorSubject({
            label: null,
            description: null,
            disabled: false,
            valid: null,
        });
        this.service.mode.subscribe((value) => {
            if (value) {
                this.mode = value;
            }
        });
        this.service.tabIndexValue.subscribe((value) => {
            if (value) {
                this.tabIndexValue = value;
            }
        });
    }
    /**
     * Whether the step is disabled or not.
     */
    get disabled() {
        return this._disabled;
    }
    set disabled(value) {
        this._disabled = coerceBooleanProperty(value);
    }
    /**
     * Whether the step is valid or not.
     */
    get valid() {
        return this._valid;
    }
    set valid(value) {
        this._valid = coerceBooleanProperty(value);
    }
    ngOnInit() {
        this.defaultInputs.next({
            ...this.defaultInputs.getValue(),
            mode: this.mode,
        });
        this.className = `${this.getDynamicStyle(this.defaultInputs.getValue())}`;
    }
    ngAfterViewInit() {
        this.containsIcon = this.dxcWizardIcon.length !== 0;
        this.cdRef.detectChanges();
    }
    setIsLast(value) {
        this.isLast = value;
        this.cdRef.detectChanges();
    }
    setIsCurrent(value, newCurrent) {
        this.isCurrent = value;
        this.position <= newCurrent
            ? (this.isVisited = true)
            : (this.isVisited = false);
        this.cdRef.detectChanges();
    }
    ngOnChanges(changes) {
        const inputs = Object.keys(changes).reduce((result, item) => {
            result[item] = changes[item].currentValue;
            return result;
        }, {});
        this.defaultInputs.next({
            ...this.defaultInputs.getValue(),
            ...inputs,
            mode: this.mode,
        });
        this.className = `${this.getDynamicStyle(this.defaultInputs.getValue())}`;
    }
    handleStepClick() {
        if (this.position || this.position === 0) {
            this.service.newCurrentStep.next(this.position);
        }
    }
    getDynamicStyle(inputs) {
        return css `
      display: inline-flex;
      ${inputs.mode === "vertical" ? "" : "align-items: center;"}
      flex-grow: 1;
      flex-direction: ${inputs.mode === "vertical" ? "column" : "row"};
      ${inputs.mode === "vertical" ? "width: 100%;" : ""}
      .last {
        flex-grow: 0;
        margin: ${inputs.mode === "vertical"
            ? "24px 0 0 0"
            : "0 0 0 24px"} !important;
        &:focus {
          margin: ${inputs.mode === "vertical"
            ? "24px 0px 0px 0px"
            : "0px 0px 0px 24px"} !important;
        }
      }
      .first {
        margin: ${inputs.mode === "vertical"
            ? "0 0 24px 0"
            : "0 24px 0 0"} !important;
        &:focus {
          margin: ${inputs.mode === "vertical"
            ? "0px 0px 24px 0px"
            : "0px 24px 0px 0px"} !important;
        }
      }
      .step {
        border: none;
        background: inherit;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin: ${inputs.mode === "vertical" ? "24px 0" : "0 24px"};
        padding: 0px;
        ${inputs.disabled ? "cursor: not-allowed;" : ""}
        margin: ${inputs.mode === "vertical" ? "24px 1px" : "1px 24px"};
        &:focus {
          outline: var(--wizard-focusColor) auto 1px;
          outline-offset: 2px;
        }
        &:hover {
          ${inputs.disabled ? "" : "cursor: pointer;"}
        }
      }
      .stepHeader {
        position: relative;
        display: inline-flex;
        padding-bottom: 4px;
      }
      svg,
      img {
        width: var(--wizard-stepContainerIconSize);
        height: var(--wizard-stepContainerIconSize);
        vertical-align: middle;
      }
      .iconContainer:not(.current) {
        width: var(--wizard-circleWidth);
        height: var(--wizard-circleHeight);
        border: var(--wizard-circleBorderThickness)
          var(--wizard-circleBorderStyle) var(--wizard-circleBorderColor);
        border-radius: var(--wizard-circleBorderRadius);
        background: var(--wizard-stepContainerBackgroundColor);
      }
      .current .iconContainer {
        width: var(--wizard-selectedCircleWidth);
        height: var(--wizard-selectedCircleHeight);
        border: var(--wizard-selectedCircleBorderThickness)
          var(--wizard-selectedCircleBorderStyle)
          var(--wizard-selectedCircleBorderColor);
        border-radius: var(--wizard-selectedCircleBorderRadius);
        background: var(--wizard-stepContainerSelectedBackgroundColor);
        .number {
          color: var(--wizard-stepContainerSelectedFontColor) !important;
        }
        svg,
        img {
          fill: var(--wizard-stepContainerSelectedFontColor);
        }
      }
      .iconContainer {
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .disabled {
        .iconContainer {
          background: var(--wizard-disabledBackgroundColor);
          color: var(--wizard-disabledFontColor);
          width: var(--wizard-disabledCircleWidth);
          height: var(--wizard-disabledCircleHeight);
          border: var(--wizard-disabledCircleBorderThickness)
            var(--wizard-disabledCircleBorderStyle)
            var(--wizard-disabledCircleBorderColor);
          border-radius: var(--wizard-disabledCircleBorderRadius);
        }
        .number {
          color: var(--wizard-disabledFontColor);
        }
        .infoContainer .label,
        .infoContainer .description {
          color: var(--wizard-disabledFontColor);
        }
      }
      .number {
        color: var(--wizard-stepContainerFontColor);
        font-family: var(--wizard-stepContainerFontFamily);
        font-weight: var(--wizard-stepContainerFontWeight);
        font-style: var(--wizard-stepContainerFontStyle);
        letter-spacing: var(--wizard-stepContainerLetterSpacing);
        font-size: var(--wizard-stepContainerFontSize);
        opacity: 1;
        margin: 0;
      }
      .validityIcon {
        width: 18px;
        height: 18px;
        position: absolute;
        top: 22.5px;
        left: 22.5px;
      }
      .infoContainer {
        margin-left: 12px;
      }
      :not(.visited) .label {
        color: var(--wizard-labelFontColor);
      }
      .visited .infoContainer .label {
        color: var(--wizard-visitedLabelFontColor);
      }
      .label {
        text-align: var(--wizard-labelTextAlign);
        text-transform: var(--wizard-labelFontTextTransform);
        font-size: var(--wizard-labelFontSize);
        font-family: var(--wizard-labelFontFamily);
        font-weight: var(--wizard-labelFontWeight);
        font-style: var(--wizard-labelFontStyle);
        letter-spacing: var(--wizard-labelLetterSpacing);
        margin: 0;
      }
      :not(.visited) .description {
        color: var(--wizard-descriptionFontColor);
      }
      .visited .infoContainer .description {
        color: var(--wizard-visitedDescriptionFontColor);
      }
      .description {
        text-align: var(--wizard-descriptionTextAlign);
        text-transform: var(--wizard-descriptionFontTextTransform);
        font-size: var(--wizard-descriptionFontSize);
        font-family: var(--wizard-descriptionFontFamily);
        font-weight: var(--wizard-descriptionFontWeight);
        font-style: var(--wizard-descriptionFontStyle);
        letter-spacing: var(--wizard-descriptionLetterSpacing);
        margin: 0;
      }
      .stepSeparator {
        width: ${inputs.mode === "horizontal" ? "" : "0"};
        height: ${inputs.mode === "horizontal" ? "0" : ""};
        ${inputs.mode === "vertical" ? "margin: 0 18px;" : ""}
        border: var(--wizard-separatorBorderThickness) var(--wizard-separatorBorderStyle) var(--wizard-separatorColor);
        opacity: 1;
        flex-grow: 1;
      }
    `;
    }
}
DxcWizardStepComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcWizardStepComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: WizardService }], target: i0.ɵɵFactoryTarget.Component });
DxcWizardStepComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.5", type: DxcWizardStepComponent, selector: "dxc-wizard-step", inputs: { label: "label", description: "description", disabled: "disabled", valid: "valid" }, host: { properties: { "class": "this.className" } }, queries: [{ propertyName: "dxcWizardIcon", predicate: DxcWizardIconComponent }], usesOnChanges: true, ngImport: i0, template: "<button\n  class=\"step\"\n  [ngClass]=\"{\n    current: isCurrent,\n    disabled: disabled,\n    last: isLast,\n    first: isFirst,\n    visited: isVisited\n  }\"\n  [disabled]=\"disabled\"\n  (click)=\"!disabled ? handleStepClick() : ''\"\n  [tabindex]=\"disabled ? -1 : tabIndexValue\"\n  [attr.aria-current]=\"isCurrent\"\n>\n  <div class=\"stepHeader\">\n    <div class=\"iconContainer\">\n      <ng-content\n        select=\"dxc-wizard-icon\"\n        *ngIf=\"containsIcon; else numberBlock\"\n      ></ng-content>\n      <ng-template #numberBlock>\n        <p class=\"number\">{{ position + 1 }}</p>\n      </ng-template>\n    </div>\n    <img\n      class=\"validityIcon\"\n      *ngIf=\"valid !== undefined && valid\"\n      [src]=\"validIcon\"\n    />\n    <img\n      class=\"validityIcon\"\n      *ngIf=\"valid !== undefined && !valid\"\n      [src]=\"invalidIcon\"\n    />\n  </div>\n  <div class=\"infoContainer\" *ngIf=\"label || description\">\n    <p class=\"label\" *ngIf=\"label\">{{ label }}</p>\n    <p class=\"description\" *ngIf=\"description\">{{ description }}</p>\n  </div>\n</button>\n<div class=\"stepSeparator\" *ngIf=\"!isLast\"></div>\n", directives: [{ type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcWizardStepComponent, decorators: [{
            type: Component,
            args: [{ selector: "dxc-wizard-step", template: "<button\n  class=\"step\"\n  [ngClass]=\"{\n    current: isCurrent,\n    disabled: disabled,\n    last: isLast,\n    first: isFirst,\n    visited: isVisited\n  }\"\n  [disabled]=\"disabled\"\n  (click)=\"!disabled ? handleStepClick() : ''\"\n  [tabindex]=\"disabled ? -1 : tabIndexValue\"\n  [attr.aria-current]=\"isCurrent\"\n>\n  <div class=\"stepHeader\">\n    <div class=\"iconContainer\">\n      <ng-content\n        select=\"dxc-wizard-icon\"\n        *ngIf=\"containsIcon; else numberBlock\"\n      ></ng-content>\n      <ng-template #numberBlock>\n        <p class=\"number\">{{ position + 1 }}</p>\n      </ng-template>\n    </div>\n    <img\n      class=\"validityIcon\"\n      *ngIf=\"valid !== undefined && valid\"\n      [src]=\"validIcon\"\n    />\n    <img\n      class=\"validityIcon\"\n      *ngIf=\"valid !== undefined && !valid\"\n      [src]=\"invalidIcon\"\n    />\n  </div>\n  <div class=\"infoContainer\" *ngIf=\"label || description\">\n    <p class=\"label\" *ngIf=\"label\">{{ label }}</p>\n    <p class=\"description\" *ngIf=\"description\">{{ description }}</p>\n  </div>\n</button>\n<div class=\"stepSeparator\" *ngIf=\"!isLast\"></div>\n" }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: WizardService }]; }, propDecorators: { label: [{
                type: Input
            }], description: [{
                type: Input
            }], disabled: [{
                type: Input
            }], valid: [{
                type: Input
            }], dxcWizardIcon: [{
                type: ContentChildren,
                args: [DxcWizardIconComponent]
            }], className: [{
                type: HostBinding,
                args: ["class"]
            }] } });

class DxcWizardComponent {
    constructor(cdRef, utils, service) {
        this.cdRef = cdRef;
        this.utils = utils;
        this.service = service;
        /**
         * The wizard can be showed in horizontal or vertical.
         */
        this.mode = "horizontal";
        this._currentStep = 0;
        this._defaultCurrentStep = 0;
        this._tabIndexValue = 0;
        /**
         * This event will emit in case the user clicks a step. The step
         * number will be passed as a parameter.
         */
        this.onStepClick = new EventEmitter();
        this.defaultInputs = new BehaviorSubject({
            mode: "horizontal",
            currentStep: 0,
            margin: null,
            tabIndexValue: 0,
            defaultCurrentStep: 0,
        });
    }
    /**
     * Defines which step is marked as the current. The numeration starts at 0.
     * If undefined, the component will be uncontrolled and the step will be managed internally by the component.
     */
    get currentStep() {
        return this._currentStep;
    }
    set currentStep(value) {
        this._currentStep = coerceNumberProperty(value);
    }
    /**
     * Initially selected step, only when it is uncontrolled.
     */
    get defaultCurrentStep() {
        return this._defaultCurrentStep;
    }
    set defaultCurrentStep(value) {
        this._defaultCurrentStep = coerceNumberProperty(value);
    }
    /**
     * Value of the tabindex attribute that is given to all the steps.
     */
    get tabIndexValue() {
        return this._tabIndexValue;
    }
    set tabIndexValue(value) {
        this._tabIndexValue = coerceNumberProperty(value);
    }
    ngAfterViewInit() {
        this.service.setSteps(this.dxcWizardSteps);
        this.service.innerCurrentStep.next(this.currentStep);
        this.service.newCurrentStep.subscribe((value) => {
            if (value || value === 0) {
                this.handleStepClick(value);
            }
        });
        this.dxcWizardSteps.changes.subscribe(() => {
            this.service.setSteps(this.dxcWizardSteps);
        });
        this.cdRef.detectChanges();
    }
    ngOnInit() {
        this.className = `${this.getDynamicStyle(this.defaultInputs.getValue())}`;
        this.currentStep = this.currentStep
            ? this.currentStep
            : this.defaultCurrentStep ?? 0;
        this.service.innerCurrentStep.next(this.currentStep);
        this.service.mode.next(this.mode || "horizontal");
        this.service.tabIndexValue.next(this.tabIndexValue);
    }
    ngOnChanges(changes) {
        this.service.innerCurrentStep.next(this.currentStep);
        this.service.mode.next(this.mode || "horizontal");
        const inputs = Object.keys(changes).reduce((result, item) => {
            result[item] = changes[item].currentValue;
            return result;
        }, {});
        this.defaultInputs.next({ ...this.defaultInputs.getValue(), ...inputs });
        this.className = `${this.getDynamicStyle(this.defaultInputs.getValue())}`;
        this.cdRef.detectChanges();
    }
    handleStepClick(i) {
        this.service.innerCurrentStep.next(i);
        this.onStepClick.emit(i);
    }
    getDynamicStyle(inputs) {
        return css `
      ${this.utils.getMargins(inputs.margin)}
      display: inline-flex;
      flex-direction: ${inputs.mode === "vertical" ? "column" : "row"};
      justify-content: center;
      ${inputs.mode === "vertical" ? "height: 500px" : "width: 100%"};
    `;
    }
}
DxcWizardComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcWizardComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: CssUtils }, { token: WizardService }], target: i0.ɵɵFactoryTarget.Component });
DxcWizardComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.5", type: DxcWizardComponent, selector: "dxc-wizard", inputs: { mode: "mode", currentStep: "currentStep", defaultCurrentStep: "defaultCurrentStep", margin: "margin", tabIndexValue: "tabIndexValue" }, outputs: { onStepClick: "onStepClick" }, host: { properties: { "class": "this.className" } }, providers: [CssUtils, WizardService], queries: [{ propertyName: "dxcWizardSteps", predicate: DxcWizardStepComponent }], usesOnChanges: true, ngImport: i0, template: "<ng-content></ng-content>" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcWizardComponent, decorators: [{
            type: Component,
            args: [{ selector: "dxc-wizard", providers: [CssUtils, WizardService], template: "<ng-content></ng-content>" }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: CssUtils }, { type: WizardService }]; }, propDecorators: { mode: [{
                type: Input
            }], currentStep: [{
                type: Input
            }], defaultCurrentStep: [{
                type: Input
            }], margin: [{
                type: Input
            }], tabIndexValue: [{
                type: Input
            }], onStepClick: [{
                type: Output
            }], dxcWizardSteps: [{
                type: ContentChildren,
                args: [DxcWizardStepComponent]
            }], className: [{
                type: HostBinding,
                args: ["class"]
            }] } });

class DxcWizardModule {
}
DxcWizardModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcWizardModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DxcWizardModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcWizardModule, declarations: [DxcWizardComponent, DxcWizardStepComponent, DxcWizardIconComponent], imports: [CommonModule], exports: [DxcWizardComponent, DxcWizardStepComponent, DxcWizardIconComponent] });
DxcWizardModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcWizardModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcWizardModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [DxcWizardComponent, DxcWizardStepComponent, DxcWizardIconComponent],
                    imports: [CommonModule],
                    exports: [DxcWizardComponent, DxcWizardStepComponent, DxcWizardIconComponent],
                }]
        }] });

class DxcLinkIconComponent {
    constructor() { }
    ngOnInit() { }
}
DxcLinkIconComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcLinkIconComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
DxcLinkIconComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.5", type: DxcLinkIconComponent, selector: "dxc-link-icon", ngImport: i0, template: "<ng-content></ng-content>" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcLinkIconComponent, decorators: [{
            type: Component,
            args: [{ selector: "dxc-link-icon", template: "<ng-content></ng-content>" }]
        }], ctorParameters: function () { return []; } });

class DxcLinkComponent {
    constructor(utils, cdRef) {
        this.utils = utils;
        this.cdRef = cdRef;
        this._underlined = true;
        this._inheritColor = false;
        this._disabled = false;
        this._newWindow = false;
        this._tabIndexValue = 0;
        /**
         * This event will emit in case the user clicks the component. If defined,
         * the link will be displayed as a button.
         */
        this.onClick = new EventEmitter();
        this.styledLink = css `
    display: inline;
  `;
        this.isClickDefined = false;
        this.defaultInputs = new BehaviorSubject({
            underlined: false,
            inheritColor: false,
            disabled: false,
            text: null,
            iconSrc: null,
            iconPosition: "before",
            href: null,
            newWindow: false,
            margin: null,
            tabIndexValue: 0,
        });
    }
    get underlined() {
        return this._underlined;
    }
    set underlined(value) {
        this._underlined = coerceBooleanProperty(value);
    }
    /**
     * If true, the color is inherited from parent.
     */
    get inheritColor() {
        return this._inheritColor;
    }
    set inheritColor(value) {
        this._inheritColor = coerceBooleanProperty(value);
    }
    /**
     * If true, the link is disabled.
     */
    get disabled() {
        return this._disabled;
    }
    set disabled(value) {
        this._disabled = coerceBooleanProperty(value);
    }
    /**
     * If true, the page is opened in a new browser tab.
     */
    get newWindow() {
        return this._newWindow;
    }
    set newWindow(value) {
        this._newWindow = coerceBooleanProperty(value);
    }
    /**
     * Value of the tabindex.
     */
    get tabIndexValue() {
        return this._tabIndexValue;
    }
    set tabIndexValue(value) {
        this._tabIndexValue = coerceNumberProperty(value);
    }
    ngOnInit() {
        this.isClickDefined = this.onClick.observers.length > 0;
        this.className = `${this.getDynamicStyle(this.defaultInputs.getValue())}`;
        this.styledButton = `${this.getDynamicStyledButton(this.defaultInputs.getValue())}`;
    }
    ngAfterViewChecked() {
        if (this.dxcLinkIcon.length !== 0) {
            this.iconSrc = "";
        }
        this.cdRef.detectChanges();
    }
    ngOnChanges(changes) {
        const inputs = Object.keys(changes).reduce((result, item) => {
            result[item] = changes[item].currentValue;
            return result;
        }, {});
        this.defaultInputs.next({ ...this.defaultInputs.getValue(), ...inputs });
        this.className = `${this.getDynamicStyle(this.defaultInputs.getValue())}`;
        this.styledButton = `${this.getDynamicStyledButton(this.defaultInputs.getValue())}`;
    }
    onClickHandler($event) {
        if (!this.disabled) {
            this.onClick.emit($event);
        }
    }
    getDynamicStyle(inputs) {
        return css `
      a {
        ${this.utils.getMargins(inputs.margin)}
        display: inline-flex;
        align-items: center;
        max-width: 100%;
        font-size: var(--link-fontSize);
        padding-bottom: 2px;
        text-decoration: none;
        font-family: var(--link-fontFamily);
        font-style: var(--link-fontStyle);
        font-weight: var(--link-fontWeight);
        ${inputs.iconPosition === "before"
            ? ""
            : "flex-direction: row-reverse;"}

        ${this.getUnderlineStyles(inputs)}

        color: ${!inputs.inheritColor
            ? "var(--link-fontColor)"
            : `inherit`} !important;

        ${this.getStateStyles(inputs)}

        img,svg {
          width: var(--link-iconSize);
          height: var(--link-iconSize);
          ${inputs.iconPosition === "before"
            ? "margin-right: var(--link-iconSpacing);"
            : "margin-left: var(--link-iconSpacing);"}
        }
      }
    `;
    }
    getDynamicStyledButton(inputs) {
        return css `
      background: none;
      border: none;
      padding: 0;
      cursor: ${inputs.disabled ? "default" : "pointer"};
      outline: 0;
      font-family: var(--link-fontFamily);
      font-size: var(--link-fontSize);
      text-decoration: none;
      font-style: var(--link-fontStyle);
      font-weight: var(--link-fontWeight);
    `;
    }
    getUnderlineStyles(inputs) {
        if (inputs.underlined) {
            if (!inputs.disabled) {
                return css `
          padding-bottom: var(--link-underlineSpacing) !important;
          border-bottom: var(--link-underlineThickness)
            var(--link-underlineStyle) var(--link-underlinedBackgroundColor);
        `;
            }
        }
        else {
            return css ``;
        }
    }
    getStateStyles(inputs) {
        if (inputs.disabled) {
            return css `
        pointer-events: none;
        color: var(--link-disabledColor) !important;
      `;
        }
        else {
            return css `
        &:hover {
          color: var(--link-hoverFontColor) !important;
          padding-bottom: var(--link-underlineSpacing) !important;
          border-bottom: var(--link-underlineThickness)
            var(--link-underlineStyle) var(--link-hoverUnderlineColor);
          cursor: pointer;
        }

        &:focus {
          outline: -webkit-focus-ring-color auto 2px;
          outline-color: var(--link-focusColor);
          color: var(--link-focusColor) !important;
          padding-bottom: var(--link-underlineSpacing) !important;
          border-bottom: var(--link-underlineThickness)
            var(--link-underlineStyle) var(--link-focusColor);
        }

        &:active {
          color: var(--link-activeFontColor) !important;
          padding-bottom: var(--link-underlineSpacing) !important;
          border-bottom: var(--link-underlineThickness)
            var(--link-underlineStyle) var(--link-activeUnderlineColor);
        }

        &:visited {
          color: var(--link-visitedFontColor) !important;
          padding-bottom: var(--link-underlineSpacing) !important;
          border-bottom: var(--link-underlineThickness)
            var(--link-underlineStyle) var(--link-visitedUnderlineColor);
        }
      `;
        }
    }
}
DxcLinkComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcLinkComponent, deps: [{ token: CssUtils }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
DxcLinkComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.5", type: DxcLinkComponent, selector: "dxc-link", inputs: { underlined: "underlined", inheritColor: "inheritColor", disabled: "disabled", text: "text", iconSrc: "iconSrc", iconPosition: "iconPosition", href: "href", newWindow: "newWindow", margin: "margin", tabIndexValue: "tabIndexValue" }, outputs: { onClick: "onClick" }, host: { properties: { "class": "this.className" } }, providers: [CssUtils], queries: [{ propertyName: "dxcLinkIcon", predicate: DxcLinkIconComponent }], usesOnChanges: true, ngImport: i0, template: "<div [class]=\"styledLink\" (click)=\"onClickHandler($event)\">\n  <button *ngIf=\"isClickDefined == true\" [class]=\"styledButton\">\n    <a [href]=\"href\" [target]=\"newWindow ? '_blank' : '_self'\"  [tabindex]=\"disabled ? -1 : tabIndexValue\">\n      <img\n        src=\"{{ iconSrc }}\"\n        *ngIf=\"iconSrc\"\n        class=\"icon\"\n      />\n      <ng-content></ng-content>\n      {{ text }}\n    </a>\n  </button>\n\n  <a\n    [href]=\"href\"\n    [target]=\"newWindow ? '_blank' : '_self'\"\n    *ngIf=\"isClickDefined == false\"\n    [tabindex]=\"disabled ? -1 : tabIndexValue\"\n  >\n    <img\n      src=\"{{ iconSrc }}\"\n      *ngIf=\"iconSrc\"\n      class=\"icon\"\n    />\n    <ng-content></ng-content>\n    {{ text }}\n  </a>\n</div>\n", directives: [{ type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcLinkComponent, decorators: [{
            type: Component,
            args: [{ selector: "dxc-link", providers: [CssUtils], template: "<div [class]=\"styledLink\" (click)=\"onClickHandler($event)\">\n  <button *ngIf=\"isClickDefined == true\" [class]=\"styledButton\">\n    <a [href]=\"href\" [target]=\"newWindow ? '_blank' : '_self'\"  [tabindex]=\"disabled ? -1 : tabIndexValue\">\n      <img\n        src=\"{{ iconSrc }}\"\n        *ngIf=\"iconSrc\"\n        class=\"icon\"\n      />\n      <ng-content></ng-content>\n      {{ text }}\n    </a>\n  </button>\n\n  <a\n    [href]=\"href\"\n    [target]=\"newWindow ? '_blank' : '_self'\"\n    *ngIf=\"isClickDefined == false\"\n    [tabindex]=\"disabled ? -1 : tabIndexValue\"\n  >\n    <img\n      src=\"{{ iconSrc }}\"\n      *ngIf=\"iconSrc\"\n      class=\"icon\"\n    />\n    <ng-content></ng-content>\n    {{ text }}\n  </a>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: CssUtils }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { underlined: [{
                type: Input
            }], inheritColor: [{
                type: Input
            }], disabled: [{
                type: Input
            }], text: [{
                type: Input
            }], iconSrc: [{
                type: Input
            }], iconPosition: [{
                type: Input
            }], href: [{
                type: Input
            }], newWindow: [{
                type: Input
            }], margin: [{
                type: Input
            }], tabIndexValue: [{
                type: Input
            }], onClick: [{
                type: Output
            }], className: [{
                type: HostBinding,
                args: ["class"]
            }], dxcLinkIcon: [{
                type: ContentChildren,
                args: [DxcLinkIconComponent]
            }] } });

class DxcLinkModule {
}
DxcLinkModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcLinkModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DxcLinkModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcLinkModule, declarations: [DxcLinkComponent, DxcLinkIconComponent], imports: [CommonModule], exports: [DxcLinkComponent, DxcLinkIconComponent] });
DxcLinkModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcLinkModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcLinkModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [DxcLinkComponent, DxcLinkIconComponent],
                    imports: [CommonModule],
                    exports: [DxcLinkComponent, DxcLinkIconComponent],
                }]
        }] });

class DxcSidenavComponent {
    constructor(utils) {
        this.utils = utils;
        this.firstClick = false; //remove animation on first load
        this.defaultInputs = new BehaviorSubject({
            padding: null,
        });
    }
    ngOnInit() {
        this.sidenavStyles = `${this.getDynamicStyle({
            ...this.defaultInputs.getValue(),
        })}`;
    }
    ngOnChanges(changes) {
        this.currentBackgroundColor = this.utils.readProperty("--sidenav-backgroundColor");
        const inputs = Object.keys(changes).reduce((result, item) => {
            result[item] = changes[item].currentValue;
            return result;
        }, {});
        this.defaultInputs.next({ ...this.defaultInputs.getValue(), ...inputs });
    }
    getDynamicStyle(inputs) {
        return css `
      z-index: auto;
      width: 300px;
      max-width: 300px;
      position: relative;
      height: 100%;
      background-color: var(--sidenav-backgroundColor);
      position: sticky;
      display: flex;
      background-provider-inner {
        display: flex;
        flex-direction: column;
        ${this.utils.getPaddings(inputs.padding)}
        width: ${"calc(300px" +
            this.utils.getPaddingOrMargin(null, inputs.padding) +
            ")"};
        overflow-y: auto;
        overflow-x: hidden;
        &::-webkit-scrollbar {
          width: 2px;
        }
        &::-webkit-scrollbar-track {
          background-color: var(--sidenav-scrollBarTrackColor);
          border-radius: 3px;
        }
        &::-webkit-scrollbar-thumb {
          background-color: var(--sidenav-scrollBarThumbColor);
          border-radius: 3px;
        }
        dxc-sidenav-title {
          margin: 15px 0px;
          font-family: var(--sidenav-titleFontFamily);
          font-size: var(--sidenav-titleFontSize);
          font-style: var(--sidenav-titleFontStyle);
          font-weight: var(--sidenav-titleFontWeight);
          color: var(--sidenav-titleFontColor);
          text-transform: var(--sidenav-titleFontTextTransform);
          letter-spacing: var(--sidenav-titleFontLetterSpacing);
        }
        dxc-sidenav-subtitle {
          margin-top: 15px;
          font-family: var(--sidenav-subtitleFontFamily);
          font-size: var(--sidenav-subtitleFontSize);
          font-style: var(--sidenav-subtitleFontStyle);
          font-weight: var(--sidenav-subtitleFontWeight);
          color: var(--sidenav-subtitleFontColor);
          text-transform: var(--sidenav-subtitleFontTextTransform);
          letter-spacing: var(--sidenav-subtitleFontLetterSpacing);
        }
        dxc-sidenav-link {
          margin-top: var(--sidenav-linkMarginTop);
          margin-right: var(--sidenav-linkMarginRight);
          margin-bottom: var(--sidenav-linkMarginBottom);
          margin-left: var(--sidenav-linkMarginLeft);
          cursor: pointer;
          font-family: var(--sidenav-linkFontFamily);
          font-size: var(--sidenav-linkFontSize);
          font-style: var(--sidenav-linkFontStyle);
          font-weight: var(--sidenav-linkFontWeight);
          color: var(--sidenav-linkFontColor);
          text-transform: var(--sidenav-linkFontTextTransform);
          letter-spacing: var(--sidenav-linkFontLetterSpacing);
          text-decoration: var(--sidenav-linkTextDecoration);
          a {
            text-decoration: inherit;
            color: inherit;
          }
        }
      }
    `;
    }
}
DxcSidenavComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcSidenavComponent, deps: [{ token: CssUtils }], target: i0.ɵɵFactoryTarget.Component });
DxcSidenavComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.5", type: DxcSidenavComponent, selector: "dxc-sidenav", inputs: { padding: "padding" }, host: { properties: { "class": "this.sidenavStyles" } }, providers: [CssUtils, BackgroundProviderService], viewQueries: [{ propertyName: "sidenav", first: true, predicate: ["sidenavContainer"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<background-provider-inner color=\"{{ currentBackgroundColor }}\">\n  <ng-content></ng-content>\n</background-provider-inner>\n", components: [{ type: BackgroundProviderInnerComponent, selector: "background-provider-inner", inputs: ["color"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcSidenavComponent, decorators: [{
            type: Component,
            args: [{ selector: "dxc-sidenav", providers: [CssUtils, BackgroundProviderService], template: "<background-provider-inner color=\"{{ currentBackgroundColor }}\">\n  <ng-content></ng-content>\n</background-provider-inner>\n" }]
        }], ctorParameters: function () { return [{ type: CssUtils }]; }, propDecorators: { sidenavStyles: [{
                type: HostBinding,
                args: ["class"]
            }], padding: [{
                type: Input
            }], sidenav: [{
                type: ViewChild,
                args: ["sidenavContainer", { static: false }]
            }] } });

class DxcSidenavTitleComponent {
    constructor(element) {
        this.element = element;
    }
    ngOnInit() {
    }
}
DxcSidenavTitleComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcSidenavTitleComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
DxcSidenavTitleComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.5", type: DxcSidenavTitleComponent, selector: "dxc-sidenav-title", providers: [CssUtils], ngImport: i0, template: "<ng-content></ng-content>" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcSidenavTitleComponent, decorators: [{
            type: Component,
            args: [{ selector: "dxc-sidenav-title", providers: [CssUtils], template: "<ng-content></ng-content>" }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; } });

class DxcSidenavSubtitleComponent {
    constructor(element) {
        this.element = element;
    }
    ngOnInit() {
    }
}
DxcSidenavSubtitleComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcSidenavSubtitleComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
DxcSidenavSubtitleComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.5", type: DxcSidenavSubtitleComponent, selector: "dxc-sidenav-subtitle", providers: [CssUtils], ngImport: i0, template: "<ng-content></ng-content>" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcSidenavSubtitleComponent, decorators: [{
            type: Component,
            args: [{ selector: "dxc-sidenav-subtitle", providers: [CssUtils], template: "<ng-content></ng-content>" }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; } });

class DxcSidenavLinkComponent {
    constructor(element) {
        this.element = element;
        /**
         * This event will be emit when the user clicks the link.
         */
        this.onClick = new EventEmitter();
    }
    /**
     * Value of the tabindex given to the DxcSidenavLink.
     */
    get tabIndexValue() {
        return this._tabIndexValue;
    }
    set tabIndexValue(value) {
        this._tabIndexValue = coerceNumberProperty(value);
    }
    ngOnInit() {
    }
    onClickHandler($event) {
        this.onClick.emit($event);
    }
}
DxcSidenavLinkComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcSidenavLinkComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
DxcSidenavLinkComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.5", type: DxcSidenavLinkComponent, selector: "dxc-sidenav-link", inputs: { href: "href", tabIndexValue: "tabIndexValue" }, outputs: { onClick: "onClick" }, providers: [CssUtils], ngImport: i0, template: "<a [href]=\"href\" (click)=\"onClickHandler($event)\" [tabIndex]=\"tabIndexValue\">\n  <ng-content></ng-content>\n</a>\n" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcSidenavLinkComponent, decorators: [{
            type: Component,
            args: [{ selector: "dxc-sidenav-link", providers: [CssUtils], template: "<a [href]=\"href\" (click)=\"onClickHandler($event)\" [tabIndex]=\"tabIndexValue\">\n  <ng-content></ng-content>\n</a>\n" }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { href: [{
                type: Input
            }], onClick: [{
                type: Output
            }], tabIndexValue: [{
                type: Input
            }] } });

class DxcSideNavModule {
}
DxcSideNavModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcSideNavModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DxcSideNavModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcSideNavModule, declarations: [DxcSidenavComponent,
        DxcSidenavTitleComponent,
        DxcSidenavSubtitleComponent,
        DxcSidenavLinkComponent], imports: [CommonModule, BackgroundProviderInnerModule], exports: [DxcSidenavComponent,
        DxcSidenavTitleComponent,
        DxcSidenavSubtitleComponent,
        DxcSidenavLinkComponent] });
DxcSideNavModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcSideNavModule, imports: [[CommonModule, BackgroundProviderInnerModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcSideNavModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        DxcSidenavComponent,
                        DxcSidenavTitleComponent,
                        DxcSidenavSubtitleComponent,
                        DxcSidenavLinkComponent,
                    ],
                    imports: [CommonModule, BackgroundProviderInnerModule],
                    exports: [
                        DxcSidenavComponent,
                        DxcSidenavTitleComponent,
                        DxcSidenavSubtitleComponent,
                        DxcSidenavLinkComponent,
                    ],
                }]
        }] });

class DxcHeadingComponent {
    constructor(utils) {
        this.utils = utils;
        /**
         * Defines the heading level from 1 to 5. The styles of the heading are applied according to the level.
         */
        this.level = 1;
        this.defaultInputs = new BehaviorSubject({
            level: 1,
            asTag: null,
            text: null,
            weight: null,
            margin: null,
        });
    }
    ngOnInit() {
        this.className = `${this.getDynamicStyle(this.defaultInputs.getValue())}`;
    }
    ngOnChanges(changes) {
        if (this.asTag == null) {
            if (this.level === 1)
                this.asTag = "h1";
            else if (this.level === 2)
                this.asTag = "h2";
            else if (this.level === 3)
                this.asTag = "h3";
            else if (this.level === 4)
                this.asTag = "h4";
            else if (this.level === 5)
                this.asTag = "h5";
        }
        const inputs = Object.keys(changes).reduce((result, item) => {
            result[item] = changes[item].currentValue;
            return result;
        }, {});
        this.defaultInputs.next({ ...this.defaultInputs.getValue(), ...inputs });
        this.className = `${this.getDynamicStyle(this.defaultInputs.getValue())}`;
    }
    getDynamicStyle(inputs) {
        return css `
      .container {
        ${this.utils.getMargins(inputs.margin)}
      }
      h1,
      h2,
      h3,
      h4,
      h5 {
        margin: 0px;
        ${this.setClassByLevel(inputs.level, inputs.weight)}
      }
    `;
    }
    setClassByLevel(level, weight) {
        switch (level) {
            case 1:
                return css `
          font-weight: ${weight === "light"
                    ? 200
                    : weight === "normal"
                        ? 400
                        : weight === "bold"
                            ? 600
                            : "var(--heading-level1FontWeight)"};
          letter-spacing: var(--heading-level1LetterSpacing);
          font-size: var(--heading-level1FontSize);
          line-height: var(--heading-level1LineHeight);
          color: var(--heading-level1FontColor);
          font-family: var(--heading-level1FontFamily);
          font-style: var(--heading-level1FontStyle);
        `;
            case 2:
                return css `
          font-weight: ${weight === "light"
                    ? 200
                    : weight === "normal"
                        ? 400
                        : weight === "bold"
                            ? 600
                            : "var(--heading-level2FontWeight)"};
          letter-spacing: var(--heading-level2LetterSpacing);
          font-size: var(--heading-level2FontSize);
          line-height: var(--heading-level2LineHeight);
          color: var(--heading-level2FontColor);
          font-family: var(--heading-level2FontFamily);
          font-style: var(--heading-level2FontStyle);
        `;
            case 3:
                return css `
          font-weight: ${weight === "light"
                    ? 200
                    : weight === "normal"
                        ? 400
                        : weight === "bold"
                            ? 600
                            : "var(--heading-level3FontWeight)"};
          letter-spacing: var(--heading-level3LetterSpacing);
          font-size: var(--heading-level3FontSize);
          line-height: var(--heading-level3LineHeight);
          color: var(--heading-level3FontColor);
          font-family: var(--heading-level3FontFamily);
          font-style: var(--heading-level3FontStyle);
        `;
            case 4:
                return css `
          font-weight: ${weight === "light"
                    ? 200
                    : weight === "normal"
                        ? 400
                        : weight === "bold"
                            ? 600
                            : "var(--heading-level4FontWeight)"};
          letter-spacing: var(--heading-level4LetterSpacing);
          font-size: var(--heading-level4FontSize);
          line-height: var(--heading-level4LineHeight);
          color: var(--heading-level4FontColor);
          font-family: var(--heading-level4FontFamily);
          font-style: var(--heading-level4FontStyle);
        `;
            case 5:
                return css `
          font-weight: ${weight === "light"
                    ? 200
                    : weight === "normal"
                        ? 400
                        : weight === "bold"
                            ? 600
                            : "var(--heading-level5FontWeight)"};
          letter-spacing: var(--heading-level5LetterSpacing);
          font-size: var(--heading-level5FontSize);
          line-height: var(--heading-level5LineHeight);
          color: var(--heading-level5FontColor);
          font-family: var(--heading-level5FontFamily);
          font-style: var(--heading-level5FontStyle);
        `;
        }
    }
}
DxcHeadingComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcHeadingComponent, deps: [{ token: CssUtils }], target: i0.ɵɵFactoryTarget.Component });
DxcHeadingComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.5", type: DxcHeadingComponent, selector: "dxc-heading", inputs: { level: "level", asTag: "asTag", text: "text", weight: "weight", margin: "margin" }, host: { properties: { "class": "this.className" } }, providers: [CssUtils], usesOnChanges: true, ngImport: i0, template: "<div class=\"container\" [ngSwitch]=\"asTag\">\n  <h1 *ngSwitchCase=\"'h1'\">{{ text }}</h1>\n  <h2 *ngSwitchCase=\"'h2'\">{{ text }}</h2>\n  <h3 *ngSwitchCase=\"'h3'\">{{ text }}</h3>\n  <h4 *ngSwitchCase=\"'h4'\">{{ text }}</h4>\n  <h5 *ngSwitchCase=\"'h5'\">{{ text }}</h5>\n</div>\n", directives: [{ type: i4.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { type: i4.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcHeadingComponent, decorators: [{
            type: Component,
            args: [{ selector: "dxc-heading", providers: [CssUtils], template: "<div class=\"container\" [ngSwitch]=\"asTag\">\n  <h1 *ngSwitchCase=\"'h1'\">{{ text }}</h1>\n  <h2 *ngSwitchCase=\"'h2'\">{{ text }}</h2>\n  <h3 *ngSwitchCase=\"'h3'\">{{ text }}</h3>\n  <h4 *ngSwitchCase=\"'h4'\">{{ text }}</h4>\n  <h5 *ngSwitchCase=\"'h5'\">{{ text }}</h5>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: CssUtils }]; }, propDecorators: { level: [{
                type: Input
            }], asTag: [{
                type: Input
            }], text: [{
                type: Input
            }], weight: [{
                type: Input
            }], margin: [{
                type: Input
            }], className: [{
                type: HostBinding,
                args: ["class"]
            }] } });

class DxcHeadingModule {
}
DxcHeadingModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcHeadingModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DxcHeadingModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcHeadingModule, declarations: [DxcHeadingComponent], imports: [CommonModule], exports: [DxcHeadingComponent] });
DxcHeadingModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcHeadingModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcHeadingModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [DxcHeadingComponent],
                    imports: [CommonModule],
                    exports: [DxcHeadingComponent],
                }]
        }] });

class DxcHeaderRowComponent {
    constructor(elementRef) {
        this.elementRef = elementRef;
    }
    ngAfterViewInit() {
        this.setSortIcon();
    }
    /** Paint icon for sorting depending on header state (up for asc, down for desc and default) */
    setSortIcon() {
        if (this.isSortable) {
            let divHeader = this.elementRef.nativeElement;
            let spanIcon = divHeader.getElementsByTagName("span")[0];
            switch (this.state) {
                case "up":
                    let up = this.getAscIcon(this.columnName);
                    spanIcon.insertAdjacentHTML("beforeend", up);
                    divHeader.setAttribute("state", this.state);
                    break;
                case "down":
                    let down = this.getDescIcon(this.columnName);
                    spanIcon.insertAdjacentHTML("beforeend", down);
                    divHeader.setAttribute("state", this.state);
                    break;
                default:
                    let defaultIcon = this.getDefaultIcon(this.columnName);
                    spanIcon.insertAdjacentHTML("beforeend", defaultIcon);
                    divHeader.setAttribute("state", this.state);
                    break;
            }
        }
    }
    /** Return default icon for the given header. */
    getDefaultIcon(columnName) {
        return `<svg id="icon_default-${columnName}" class="iconHeader" xmlns="http://www.w3.org/2000/svg" height="14" viewBox="0 0 24 24" width="24" fill="white"><path d="M0 0h24v24H0z" fill="none"/><path d="M12 5.83L15.17 9l1.41-1.41L12 3 7.41 7.59 8.83 9 12 5.83zm0 12.34L8.83 15l-1.41 1.41L12 21l4.59-4.59L15.17 15 12 18.17z"/></svg>`;
    }
    /** Return asc icon for the given header. */
    getAscIcon(columnName) {
        return `<svg id="icon_asc-${columnName}" class="iconHeader" xmlns="http://www.w3.org/2000/svg" height="14" viewBox="0 0 24 24" width="24" fill="white"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z"/></svg>`;
    }
    /** Return desc icon for the given header. */
    getDescIcon(columnName) {
        return `<svg id="icon_desc-${columnName}" class="iconHeader" xmlns="http://www.w3.org/2000/svg" height="14" viewBox="0 0 24 24" width="24" fill="white"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"/></svg>`;
    }
}
DxcHeaderRowComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcHeaderRowComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
DxcHeaderRowComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.5", type: DxcHeaderRowComponent, selector: "th", ngImport: i0, template: `<div
    id="header-{{ columnName }}-{{ parentClassName }}"
    [ngClass]="[isSortable ? 'isSortable' : '']"
    [tabIndex]="isSortable ? tabIndexValue : -1"
  >
    {{ columnName }}
    <span
      id="iconSort-{{ columnName }}-{{ parentClassName }}"
      *ngIf="isSortable"
    ></span>
  </div>`, isInline: true, styles: [".isSortable{display:inline-flex;cursor:pointer;width:-moz-fit-content;width:fit-content}.isSortable svg{fill:var(--table-headerFontColor)}.isSortable span{display:inline-flex;align-items:center}\n"], directives: [{ type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], changeDetection: i0.ChangeDetectionStrategy.Default, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcHeaderRowComponent, decorators: [{
            type: Component,
            args: [{ selector: "th", template: `<div
    id="header-{{ columnName }}-{{ parentClassName }}"
    [ngClass]="[isSortable ? 'isSortable' : '']"
    [tabIndex]="isSortable ? tabIndexValue : -1"
  >
    {{ columnName }}
    <span
      id="iconSort-{{ columnName }}-{{ parentClassName }}"
      *ngIf="isSortable"
    ></span>
  </div>`, changeDetection: ChangeDetectionStrategy.Default, encapsulation: ViewEncapsulation.None, styles: [".isSortable{display:inline-flex;cursor:pointer;width:-moz-fit-content;width:fit-content}.isSortable svg{fill:var(--table-headerFontColor)}.isSortable span{display:inline-flex;align-items:center}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; } });

/**
 * Outlet for rendering cells inside of a row or header row.
 * @docs-private
 */
class DxcCellOutlet {
    constructor(_viewContainer) {
        this._viewContainer = _viewContainer;
        DxcCellOutlet.mostRecentCellOutlet = this;
    }
    ngOnDestroy() {
        // If this was the last outlet being rendered in the view, remove the reference
        // from the static property after it has been destroyed to avoid leaking memory.
        if (DxcCellOutlet.mostRecentCellOutlet === this) {
            DxcCellOutlet.mostRecentCellOutlet = null;
        }
    }
}
/**
 * Static property containing the latest constructed instance of this class.
 * Used by the CDK table when each CdkHeaderRow and CdkRow component is created using
 * createEmbeddedView. After one of these components are created, this property will provide
 * a handle to provide that component's cells and context. After init, the CdkCellOutlet will
 * construct the cells with the provided context.
 */
DxcCellOutlet.mostRecentCellOutlet = null;
DxcCellOutlet.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcCellOutlet, deps: [{ token: i0.ViewContainerRef }], target: i0.ɵɵFactoryTarget.Directive });
DxcCellOutlet.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.2.5", type: DxcCellOutlet, selector: "[cdkCellOutlet]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcCellOutlet, decorators: [{
            type: Directive,
            args: [{ selector: "[cdkCellOutlet]" }]
        }], ctorParameters: function () { return [{ type: i0.ViewContainerRef }]; } });

class DxcRowComponent {
    constructor() { }
    ngOnInit() { }
}
DxcRowComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcRowComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
DxcRowComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.5", type: DxcRowComponent, selector: "tr", ngImport: i0, template: `<ng-container cdkCellOutlet></ng-container>`, isInline: true, directives: [{ type: DxcCellOutlet, selector: "[cdkCellOutlet]" }], changeDetection: i0.ChangeDetectionStrategy.Default, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcRowComponent, decorators: [{
            type: Component,
            args: [{
                    selector: "tr",
                    template: `<ng-container cdkCellOutlet></ng-container>`,
                    changeDetection: ChangeDetectionStrategy.Default,
                    encapsulation: ViewEncapsulation.None,
                }]
        }], ctorParameters: function () { return []; } });

/**
 * Cell definition for a CDK table.
 * Captures the template of a column's data row cell as well as cell-specific properties.
 */
class DxcCellDef {
    constructor(template) {
        this.template = template;
    }
}
DxcCellDef.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcCellDef, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive });
DxcCellDef.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.2.5", type: DxcCellDef, selector: "[dxcCellDef]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcCellDef, decorators: [{
            type: Directive,
            args: [{ selector: "[dxcCellDef]" }]
        }], ctorParameters: function () { return [{ type: i0.TemplateRef }]; } });

/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Used to provide a table to some of the sub-components without causing a circular dependency.
 * @docs-private
 */
const DXC_RESULTSET_TABLE = new InjectionToken("DXC_RESULTSET_TABLE");

/** Base interface for a cell definition. Captures a column's cell template definition. */
// Boilerplate for applying mixins to CdkColumnDef.
/** @docs-private */
class DxcColumnDefBase {
}
const _DxcColumnDefBase = DxcColumnDefBase;

/**
 * Column definition for the CDK table.
 * Defines a set of cells available for a table column.
 */
class DxcColumnDef extends _DxcColumnDefBase {
    constructor(_table) {
        super();
        this._table = _table;
        this.sortable = { isSortable: false, propertyName: "" };
    }
    /** Unique name for this column. */
    get name() {
        return this._name;
    }
    set name(name) {
        // If the directive is set without a name (updated programatically), then this setter will
        // trigger with an empty string and should not overwrite the programatically set value.
        if (name) {
            this._name = name;
        }
    }
}
DxcColumnDef.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcColumnDef, deps: [{ token: DXC_RESULTSET_TABLE, optional: true }], target: i0.ɵɵFactoryTarget.Directive });
DxcColumnDef.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.2.5", type: DxcColumnDef, selector: "[dxcColumnDef]", inputs: { name: ["dxcColumnDef", "name"], sortable: "sortable" }, queries: [{ propertyName: "cell", first: true, predicate: DxcCellDef, descendants: true, static: true }], usesInheritance: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcColumnDef, decorators: [{
            type: Directive,
            args: [{
                    selector: "[dxcColumnDef]",
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [DXC_RESULTSET_TABLE]
                }, {
                    type: Optional
                }] }]; }, propDecorators: { name: [{
                type: Input,
                args: ["dxcColumnDef"]
            }], sortable: [{
                type: Input,
                args: ["sortable"]
            }], cell: [{
                type: ContentChild,
                args: [DxcCellDef, { static: true }]
            }] } });

/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Returns an error to be thrown when attempting to find an unexisting column.
 * @param id Id whose lookup failed.
 * @docs-private
 */
function getTableUnknownColumnError(id) {
    return Error(`Could not find column with id "${id}".`);
}
/**
 * Returns an error to be thrown when two column definitions have the same name.
 * @docs-private
 */
function getTableDuplicateColumnNameError(name) {
    return Error(`Duplicate column definition name provided: "${name}".`);
}
/**
 * Returns an error to be thrown when there are multiple rows that are missing a when function.
 * @docs-private
 */
function getTableMultipleDefaultRowDefsError() {
    return Error(`There can only be one default row without a when predicate function.`);
}
/**
 * Returns an error to be thrown when there are no matching row defs for a particular set of data.
 * @docs-private
 */
function getTableMissingMatchingRowDefError(data) {
    return Error(`Could not find a matching row definition for the` +
        `provided row data: ${JSON.stringify(data)}`);
}
/**
 * Returns an error to be thrown when there is no row definitions present in the content.
 * @docs-private
 */
function getTableMissingRowDefsError() {
    return Error("Missing definitions for header, footer, and row; " +
        "cannot determine which columns should be rendered.");
}
/**
 * Returns an error to be thrown when the data source does not match the compatible types.
 * @docs-private
 */
function getTableUnknownDataSourceError() {
    return Error(`Provided data source did not match an array, Observable, or DataSource`);
}
/**
 * Returns an error to be thrown when the text column cannot find a parent table to inject.
 * @docs-private
 */
function getTableTextColumnMissingParentTableError() {
    return Error(`Text column could not find a parent table for registration.`);
}
/**
 * Returns an error to be thrown when a table text column doesn't have a name.
 * @docs-private
 */
function getTableTextColumnMissingNameError() {
    return Error(`Table text column must have a name.`);
}

class PaginationService {
    constructor() {
        this.start = 0;
        this.end = 5;
    }
    calculatePagination(pageNumber, itemsPerPage, callback) {
        if (pageNumber === 0) {
            callback({ start: 0, end: 5 });
        }
        this.start = pageNumber * itemsPerPage - itemsPerPage;
        this.end = pageNumber * itemsPerPage;
        callback({ start: this.start, end: this.end });
    }
    getCurrentStart() {
        return this.start;
    }
    getCurrentEnd() {
        return this.end;
    }
}
PaginationService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: PaginationService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
PaginationService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: PaginationService, providedIn: "root" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: PaginationService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: "root",
                }]
        }], ctorParameters: function () { return []; } });

class SortService {
    constructor() {
        //Map with all header's state
        this.mapStatesHeaders = new Map();
    }
    /** Get sorted list from given list, header's name and type of order ("asc" or "desc"). */
    getSortedList(collectionResource, columnName, order) {
        return collectionResource.sort(this.compareValues(columnName, order));
    }
    /** Compare values for sorting with given order ("asc" or "desc") and header's name. */
    compareValues(key, order) {
        return function innerSort(a, b) {
            if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
                return 0;
            }
            let varA = typeof a[key] === "string" ? a[key].toUpperCase() : a[key];
            let varB = typeof b[key] === "string" ? b[key].toUpperCase() : b[key];
            let comparison = 0;
            if (varA > varB) {
                comparison = 1;
            }
            else if (varA < varB) {
                comparison = -1;
            }
            return order === "desc" ? comparison * -1 : comparison;
        };
    }
    /** Set to default state the given header id (like "header-user-user"). */
    removeOtherSortings(id) {
        let columnName = id.split("-")[1];
        let className = id.split("-")[2];
        let spanIcon = document.getElementById(`iconSort-${columnName}-${className}`);
        spanIcon.innerHTML = this.getDefaultIcon(columnName);
        this.mapStatesHeaders.set(columnName, "default");
        document.getElementById(id).setAttribute("state", "default");
    }
    /** Set default icon to the header. */
    setDefaultIconSort(el) {
        let columnName = el.nativeElement.id;
        el.nativeElement.children[0].innerHTML = this.getDefaultIcon(columnName);
    }
    /** Set asc icon to the header. */
    setAscIconSort(el) {
        let columnName = el.nativeElement.id;
        el.nativeElement.children[0].innerHTML = this.getAscIcon(columnName);
    }
    /** Set desc icon to the header. */
    setDescIconSort(el) {
        let columnName = el.nativeElement.id;
        el.nativeElement.children[0].innerHTML = this.getDescIcon(columnName);
    }
    /** Return default icon for the given header. */
    getDefaultIcon(columnName) {
        return `<svg id="icon_default-${columnName}" class="iconHeader" xmlns="http://www.w3.org/2000/svg" height="14" viewBox="0 0 24 24" width="24" fill="white"><path d="M0 0h24v24H0z" fill="none"/><path d="M12 5.83L15.17 9l1.41-1.41L12 3 7.41 7.59 8.83 9 12 5.83zm0 12.34L8.83 15l-1.41 1.41L12 21l4.59-4.59L15.17 15 12 18.17z"/></svg>`;
    }
    /** Return asc icon for the given header. */
    getAscIcon(columnName) {
        return `<svg id="icon_asc-${columnName}" class="iconHeader" xmlns="http://www.w3.org/2000/svg" height="14" viewBox="0 0 24 24" width="24" fill="white"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z"/></svg>`;
    }
    /** Return desc icon for the given header. */
    getDescIcon(columnName) {
        return `<svg id="icon_desc-${columnName}" class="iconHeader" xmlns="http://www.w3.org/2000/svg" height="14" viewBox="0 0 24 24" width="24" fill="white"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"/></svg>`;
    }
}
SortService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: SortService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
SortService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: SortService, providedIn: "root" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: SortService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: "root",
                }]
        }], ctorParameters: function () { return []; } });

/**
 * Provides a handle for the table to grab the view container's ng-container to insert data rows.
 * @docs-private
 */
class HeaderOutlet {
    constructor(viewContainer, elementRef) {
        this.viewContainer = viewContainer;
        this.elementRef = elementRef;
    }
}
HeaderOutlet.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: HeaderOutlet, deps: [{ token: i0.ViewContainerRef }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
HeaderOutlet.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.2.5", type: HeaderOutlet, selector: "[headerOutlet]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: HeaderOutlet, decorators: [{
            type: Directive,
            args: [{ selector: "[headerOutlet]" }]
        }], ctorParameters: function () { return [{ type: i0.ViewContainerRef }, { type: i0.ElementRef }]; } });

/**
 * Provides a handle for the table to grab the view container's ng-container to insert data rows.
 * @docs-private
 */
class DataRowOutlet {
    constructor(viewContainer, elementRef) {
        this.viewContainer = viewContainer;
        this.elementRef = elementRef;
    }
}
DataRowOutlet.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DataRowOutlet, deps: [{ token: i0.ViewContainerRef }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
DataRowOutlet.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.2.5", type: DataRowOutlet, selector: "[rowOutlet]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DataRowOutlet, decorators: [{
            type: Directive,
            args: [{ selector: "[rowOutlet]" }]
        }], ctorParameters: function () { return [{ type: i0.ViewContainerRef }, { type: i0.ElementRef }]; } });

class TableDataSource extends DataSource {
    constructor(items) {
        super();
        /** Stream of data that is provided to the table. */
        this.data = new BehaviorSubject([]);
        this.data = items;
    }
    getData() {
        return this.data;
    }
    /** Connect function called by the table to retrieve one stream containing the data to render. */
    connect() {
        return this.data;
    }
    disconnect() { }
}

/**
 * A data table that can render a header row, data rows, and a footer row.
 * Uses the dataSource input to determine the data to be rendered. The data can be provided either
 * as a data array, an Observable stream that emits the data array to render, or a DataSource with a
 * connect function that will return an Observable stream that emits the data array to render.
 */
class DxcResultTable {
    constructor(_differs, _changeDetectorRef, _elementRef, role, _dir, _document, resolver, paginationService, sortService) {
        this._differs = _differs;
        this._changeDetectorRef = _changeDetectorRef;
        this._elementRef = _elementRef;
        this._dir = _dir;
        this.resolver = resolver;
        this.paginationService = paginationService;
        this.sortService = sortService;
        /**
         * Number of items per page.
         */
        this.itemsPerPage = 5;
        /**
         * Show page navigation select.
         */
        this.showGoToPage = true;
        this._tabIndexValue = 0;
        /**
         *  This event will emit in case of the user selects an item per page
         * option. The value selected will be passed as a parameter.
         */
        this.itemsPerPageFunction = new EventEmitter();
        this.collectionData = new BehaviorSubject([]);
        this.displayedColumns = [];
        this.totalItems = 0;
        this.page = 1;
        /** List of ordering directives. */
        this._allOrderingRefs = [];
        /** Subject that emits when the component has been destroyed. */
        this._onDestroy = new Subject();
        /**
         * Map of all the user's defined columns (header, data, and footer cell template) identified by
         * name. Collection populated by the column definitions gathered by `ContentChildren` as well as
         * any custom column definitions added to `_customColumnDefs`.
         */
        this._columnDefsByName = new Map();
        /**
         * Column definitions that were defined outside of the direct content children of the table.
         * These will be defined when, e.g., creating a wrapper around the cdkTable that has
         * column definitions as *its* content child.
         */
        this._customColumnDefs = new Set();
        /**
         * Cache of the latest rendered `RenderRow` objects as a map for easy retrieval when constructing
         * a new list of `RenderRow` objects for rendering rows. Since the new list is constructed with
         * the cached `RenderRow` objects when possible, the row identity is preserved when the data
         * and row template matches, which allows the `IterableDiffer` to check rows by reference
         * and understand which rows are added/moved/removed.
         *
         * Implemented as a map of maps where the first key is the `data: T` object and the second is the
         * `CdkRowDef<T>` object. With the two keys, the cache points to a `RenderRow<T>` object that
         * contains an array of created pairs. The array is necessary to handle cases where the data
         * array contains multiple duplicate data objects and each instantiated `RenderRow` must be
         * stored.
         */
        this._cachedRenderRowsMap = new Map();
        // TODO(andrewseguin): Remove max value as the end index
        //   and instead calculate the view on init and scroll.
        /**
         * Stream containing the latest information on what rows are being displayed on screen.
         * Can be used by the data source to as a heuristic of what data should be provided.
         *
         * @docs-private
         */
        this.viewChange = new BehaviorSubject({
            start: 0,
            end: Number.MAX_VALUE,
        });
        if (!role) {
            this._elementRef.nativeElement.setAttribute("role", "grid");
        }
        this._document = _document;
        this._isNativeHtmlTable =
            this._elementRef.nativeElement.nodeName === "TABLE";
        this.setClassName();
    }
    /**
     * An array of objects with the values to display in the table.
     * The key is the column and the value is the property to be displayed in the cell.
     */
    get collectionResource() {
        return this._collectionResource;
    }
    set collectionResource(value) {
        this._collectionResource = coerceArray(value);
    }
    /**
     * Value of the tabindex attribute given to the sortable icon.
     */
    get tabIndexValue() {
        return this._tabIndexValue;
    }
    set tabIndexValue(value) {
        this._tabIndexValue = coerceNumberProperty(value);
    }
    /**
     * Tracking function that will be used to check the differences in data changes. Used similarly
     * to `ngFor` `trackBy` function. Optimize row operations by identifying a row based on its data
     * relative to the function to know if a row should be added/removed/moved.
     * Accepts a function that takes two parameters, `index` and `item`.
     */
    get trackBy() {
        return this._trackByFn;
    }
    set trackBy(fn) {
        if (isDevMode() &&
            fn != null &&
            typeof fn !== "function" &&
            console &&
            console.warn) {
            console.warn(`trackBy must be a function, but received ${JSON.stringify(fn)}.`);
        }
        this._trackByFn = fn;
    }
    ngOnInit() {
        this.collectionData.next(this.collectionResource.slice(0, this.itemsPerPage));
        this.dataSource = new TableDataSource(this.collectionData);
        this.totalItems = this.collectionResource.length;
        if (this._isNativeHtmlTable) {
            this._applyNativeTableSections();
        }
        // Set up the trackBy function so that it uses the `RenderRow` as its identity by default. If
        // the user has provided a custom trackBy, return the result of that function as evaluated
        // with the values of the `RenderRow`'s data and index.
        this._dataDiffer = this._differs
            .find([])
            .create((_i, dataRow) => {
            return this.trackBy
                ? this.trackBy(dataRow.dataIndex, dataRow.data)
                : dataRow;
        });
    }
    ngOnChanges() {
        this.page = 1;
        this.navigate(this.page, "");
    }
    ngAfterContentChecked() {
        // Cache the row and column definitions gathered by ContentChildren and programmatic injection.
        //this._cacheRowDefs();
        this._cacheColumnDefs();
        // Render updates if the list of columns have been changed for the header, row, or footer defs.
        // If there is a data source and row definitions, connect to the data source unless a
        // connection has already been made.
        if (this.dataSource && !this._renderChangeSubscription) {
            this._observeRenderChanges();
        }
    }
    ngOnDestroy() {
        this._headerOutlet.viewContainer.clear();
        this._rowOutlet.viewContainer.clear();
        this._cachedRenderRowsMap.clear();
        this._onDestroy.next();
        this._onDestroy.complete();
        if (isDataSource(this.dataSource)) {
            this.dataSource.disconnect(this);
        }
    }
    handleItemsPerPageSelect($event) {
        this.itemsPerPageFunction.emit($event);
    }
    renderHeaders() {
        this._headerOutlet.viewContainer.clear();
        if (this._columnDefsByName !== null) {
            this._columnDefsByName.forEach((value, key) => {
                const factory = this.resolver.resolveComponentFactory(DxcHeaderRowComponent);
                const viewRef = this._headerOutlet.viewContainer.createComponent(factory);
                viewRef.instance.columnName = key;
                viewRef.instance.isSortable = value.sortable.isSortable; //Save if header is sortable in the created component
                viewRef.instance.tabIndexValue = this.tabIndexValue;
                viewRef.instance.state = this.getMapStateHeaders().get(key); //Get header's current state for sorting and save it in the created component
                viewRef.instance.parentClassName = this.className; // just in case there are more tables in the page
                viewRef.instance.propertyName = value.sortable.propertyName;
                if (!this.displayedColumns.includes(key)) {
                    this.displayedColumns.push(key);
                }
            });
        }
    }
    /**
     * Renders rows based on the table's latest set of data, which was either provided directly as an
     * input or retrieved through an Observable stream (directly or from a DataSource).
     * Checks for differences in the data since the last diff to perform only the necessary
     * changes (add/remove/move rows).
     *
     * If the table's data source is a DataSource or Observable, this will be invoked automatically
     * each time the provided Observable stream emits a new data array. Otherwise if your data is
     * an array, this function will need to be called to render any changes.
     */
    renderRows() {
        this._renderRows = this._getAllRenderRows();
        const changes = this._dataDiffer.diff(this._renderRows);
        if (!changes) {
            return;
        }
        const viewContainer = this._rowOutlet.viewContainer;
        changes.forEachOperation((record, prevIndex, currentIndex) => {
            if (record.previousIndex == null) {
                this._insertRow(record.item, currentIndex);
            }
            else if (currentIndex == null) {
                viewContainer.remove(prevIndex);
            }
            else {
                const view = viewContainer.get(prevIndex);
                viewContainer.move(view, currentIndex);
            }
        });
        // Update the meta context of a row's context data (index, count, first, last, ...)
        this._updateRowIndexContext();
        // Update rows that did not get added/removed/moved but may have had their identity changed,
        // e.g. if trackBy matched data on some property but the actual data reference changed.
        changes.forEachIdentityChange((record) => {
            const rowView = viewContainer.get(record.currentIndex);
            rowView.context.$implicit = record.item.data;
        });
    }
    /**
     * Get the list of RenderRow objects to render according to the current list of data and defined
     * row definitions. If the previous list already contained a particular pair, it should be reused
     * so that the differ equates their references.
     */
    _getAllRenderRows() {
        const renderRows = [];
        // Store the cache and create a new one. Any re-used RenderRow objects will be moved into the
        // new cache while unused ones can be picked up by garbage collection.
        const prevCachedRenderRows = this._cachedRenderRowsMap;
        this._cachedRenderRowsMap = new Map();
        // For each data object, get the list of rows that should be rendered, represented by the
        // respective `RenderRow` object which is the pair of `data` and `CdkRowDef`.
        for (let i = 0; i < this._data.length; i++) {
            let data = this._data[i];
            const renderRowsForData = this._getRenderRowsForData(data, i, prevCachedRenderRows.get(data));
            if (!this._cachedRenderRowsMap.has(data)) {
                this._cachedRenderRowsMap.set(data, new WeakMap());
            }
            for (let j = 0; j < renderRowsForData.length; j++) {
                let renderRow = renderRowsForData[j];
                const cache = this._cachedRenderRowsMap.get(renderRow.data);
                if (cache.has(renderRow.data)) {
                    cache.get(renderRow.data).push(renderRow);
                }
                else {
                    cache.set(renderRow.data, [renderRow]);
                    renderRows.push(renderRow);
                }
            }
        }
        return renderRows;
    }
    /**
     * Gets a list of `RenderRow<T>` for the provided data object and any `DxcRowDef` objects that
     * should be rendered for this data. Reuses the cached RenderRow objects if they match the same
     * `(T, DxcRowDef)` pair.
     */
    _getRenderRowsForData(data, dataIndex, cache) {
        return this.displayedColumns.map((rowDef) => {
            const cachedRenderRows = cache && cache.has(rowDef) ? cache.get(rowDef) : [];
            if (cachedRenderRows.length) {
                const dataRow = cachedRenderRows.shift();
                dataRow.dataIndex = dataIndex;
                return dataRow;
            }
            else {
                return { data, rowDef, dataIndex };
            }
        });
    }
    /** Update the map containing the content's column definitions. */
    _cacheColumnDefs() {
        this._columnDefsByName.clear();
        const columnDefs = this.mergeArrayAndSet(this._getOwnDefs(this._contentColumnDefs), this._customColumnDefs);
        columnDefs.forEach((columnDef) => {
            // if (this._columnDefsByName.has(columnDef.name)) {
            //   throw getTableDuplicateColumnNameError(columnDef.name);
            // }
            this._columnDefsByName.set(columnDef.name, columnDef);
        });
    }
    /** Set up a subscription for the data provided by the data source. */
    _observeRenderChanges() {
        // If no data source has been set, there is nothing to observe for changes.
        if (!this.dataSource) {
            return;
        }
        let dataStream;
        if (isDataSource(this.dataSource)) {
            dataStream = this.dataSource.connect(this);
        }
        else if (isObservable(this.dataSource)) {
            dataStream = this.dataSource;
        }
        else if (Array.isArray(this.dataSource)) {
            dataStream = of(this.dataSource);
        }
        if (dataStream === undefined) {
            throw getTableUnknownDataSourceError();
        }
        this._renderChangeSubscription = dataStream
            .pipe(takeUntil(this._onDestroy))
            .subscribe((data) => {
            this._data = data || [];
            this.renderHeaders();
            this.renderRows();
        });
    }
    /**
     * Create the embedded view for the data row template and place it in the correct index location
     * within the data row view container.
     */
    _insertRow(renderRow, renderIndex) {
        const context = { $implicit: renderRow.data };
        this._renderRow(this._rowOutlet, renderRow, renderIndex, context);
    }
    /**
     * Creates a new row template in the outlet and fills it with the set of cell templates.
     * Optionally takes a context to provide to the row and cells, as well as an optional index
     * of where to place the new row template in the outlet.
     */
    _renderRow(outlet, renderRow, index, context = {}) {
        // TODO(andrewseguin): enforce that one outlet was instantiated from createEmbeddedView
        const factory = this.resolver.resolveComponentFactory(DxcRowComponent);
        outlet.viewContainer.createComponent(factory, index);
        //outlet.viewContainer.createEmbeddedView(this.cdkRow.template, context, index);
        for (let cellTemplate of this._getCellTemplates(renderRow)) {
            if (DxcCellOutlet.mostRecentCellOutlet) {
                DxcCellOutlet.mostRecentCellOutlet._viewContainer.createEmbeddedView(cellTemplate, context);
            }
        }
        this._changeDetectorRef.markForCheck();
    }
    /**
     * Updates the index-related context for each row to reflect any changes in the index of the rows,
     * e.g. first/last/even/odd.
     */
    _updateRowIndexContext() {
        const viewContainer = this._rowOutlet.viewContainer;
        for (let renderIndex = 0, count = viewContainer.length; renderIndex < count; renderIndex++) {
            const viewRef = viewContainer.get(renderIndex);
            if (viewRef.context) {
                const context = viewRef.context;
                context.count = count;
                context.first = renderIndex === 0;
                context.last = renderIndex === count - 1;
                context.even = renderIndex % 2 === 0;
                context.odd = !context.even;
                context.index = this._renderRows[renderIndex].dataIndex;
            }
        }
    }
    /** Gets the column definitions for the provided row def. */
    _getCellTemplates(rowDef) {
        if (!rowDef || !this.displayedColumns) {
            return [];
        }
        return Array.from(this.displayedColumns, (columnId) => {
            const column = this._columnDefsByName.get(columnId);
            return column.cell.template;
        });
    }
    /** Adds native table sections (e.g. tbody) and moves the row outlets into them. */
    _applyNativeTableSections() {
        const documentFragment = this._document.createDocumentFragment();
        const sections = [
            // {tag: 'thead', outlet: this._headerRowOutlet},
            { tag: "tbody", outlet: this._rowOutlet },
        ];
        for (const section of sections) {
            const element = this._document.createElement(section.tag);
            element.setAttribute("role", "rowgroup");
            element.appendChild(section.outlet.elementRef.nativeElement);
            documentFragment.appendChild(element);
        }
        // Use a DocumentFragment so we don't hit the DOM on each iteration.
        this._elementRef.nativeElement.appendChild(documentFragment);
    }
    /** Filters definitions that belong to this table from a QueryList. */
    _getOwnDefs(items) {
        return items.filter((item) => !item._table || item._table === this);
    }
    /** Calculate pagination for the data displayed in the table after click event */
    navigate(page, operation) {
        this.page = page;
        this.paginationService.calculatePagination(this.page, this.itemsPerPage, (parameters) => {
            this.collectionData.next(this.collectionResource.slice(parameters.start, parameters.end));
        });
    }
    /** Set to default others header's states if they are different to default state ("up" or "down"). */
    removeOtherSorts(actualIdHeader) {
        this._allOrderingRefs.forEach((element) => {
            let nativeElement = element.nativeElement;
            if (actualIdHeader != nativeElement.id) {
                let stateElement = nativeElement.getAttribute("state");
                if (stateElement === "up" || stateElement === "down") {
                    this.sortService.removeOtherSortings(nativeElement.id);
                }
            }
        });
    }
    ngAfterViewInit() {
        this.setDefaultStateHeaders();
    }
    /** Set to default all headers that are sortable. */
    setDefaultStateHeaders() {
        this._allOrderingRefs.forEach((element) => {
            let id = element.nativeElement.id;
            let columnName = id.split("-")[1];
            this.sortService.mapStatesHeaders.set(columnName, "default");
        });
    }
    /** Register all ordering directives references. */
    registerOrderingRef(ref) {
        this._allOrderingRefs.push(ref);
    }
    /** Sort row elements from given column depending on given state. */
    sortCells(columnName, state) {
        let start = this.paginationService.getCurrentStart();
        let end = this.paginationService.getCurrentEnd();
        let list;
        if (state === "up") {
            list = this.ascSort(columnName, start, end);
        }
        else if (state === "down") {
            list = this.descSort(columnName, start, end);
        }
        this.collectionData.next(list);
    }
    /** Sort row elements by ascendant */
    ascSort(columnName, start, end) {
        return this.sortService
            .getSortedList(this.collectionResource, columnName, "asc")
            .slice(start, end);
    }
    /** Sort row elements by descendant */
    descSort(columnName, start, end) {
        return this.sortService
            .getSortedList(this.collectionResource, columnName, "desc")
            .slice(start, end);
    }
    /** Change icon to up icon */
    changeAscIcon(el) {
        this.sortService.setAscIconSort(el);
    }
    /** Change icon to down icon */
    changeDescIcon(el) {
        this.sortService.setDescIconSort(el);
    }
    /** Change icon to default icon */
    changeDefaultIcon(el) {
        this.sortService.setDefaultIconSort(el);
    }
    /** Return map with header's states */
    getMapStateHeaders() {
        return this.sortService.mapStatesHeaders;
    }
    //It is needed to give a unique id to the resultset table
    setClassName() {
        this.className = `${Math.round(Math.random() * 100)}`;
    }
    /** Utility function that gets a merged list of the entries in an array and values of a Set. */
    mergeArrayAndSet(array, set) {
        return array.concat(Array.from(set));
    }
}
DxcResultTable.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcResultTable, deps: [{ token: i0.IterableDiffers }, { token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: "role", attribute: true }, { token: i1$1.Directionality, optional: true }, { token: DOCUMENT }, { token: i0.ComponentFactoryResolver }, { token: PaginationService }, { token: SortService }], target: i0.ɵɵFactoryTarget.Component });
DxcResultTable.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.5", type: DxcResultTable, selector: "dxc-resultset-table, table[dxc-resultset-table]", inputs: { itemsPerPage: "itemsPerPage", collectionResource: "collectionResource", margin: "margin", itemsPerPageOptions: "itemsPerPageOptions", showGoToPage: "showGoToPage", tabIndexValue: "tabIndexValue", trackBy: "trackBy" }, outputs: { itemsPerPageFunction: "itemsPerPageFunction" }, host: { properties: { "class": "this.className" } }, providers: [
        { provide: DXC_RESULTSET_TABLE, useExisting: DxcResultTable },
        PaginationService,
        SortService,
    ], queries: [{ propertyName: "_contentColumnDefs", predicate: DxcColumnDef, descendants: true }], viewQueries: [{ propertyName: "_headerOutlet", first: true, predicate: HeaderOutlet, descendants: true, static: true }, { propertyName: "_rowOutlet", first: true, predicate: DataRowOutlet, descendants: true, static: true }], exportAs: ["dxcResultsetTable"], usesOnChanges: true, ngImport: i0, template: `
    <dxc-table [margin]="margin">
      <ng-container headerOutlet></ng-container>
      <ng-container rowOutlet></ng-container>
    </dxc-table>

    <dxc-paginator
      *ngIf="totalItems !== null"
      [totalItems]="totalItems"
      [itemsPerPage]="itemsPerPage"
      [itemsPerPageOptions]="itemsPerPageOptions"
      [currentPage]="page"
      [showGoToPage]="showGoToPage"
      (onGoToPage)="navigate($event)"
      (itemsPerPageFunction)="handleItemsPerPageSelect($event)"
    ></dxc-paginator>
  `, isInline: true, components: [{ type: DxcTableComponent, selector: "dxc-table", inputs: ["margin"] }, { type: DxcPaginatorComponent, selector: "dxc-paginator", inputs: ["currentPage", "itemsPerPage", "showGoToPage", "itemsPerPageOptions", "totalItems", "paginationActions", "tabIndexValue"], outputs: ["onGoToPage", "itemsPerPageFunction"] }], directives: [{ type: HeaderOutlet, selector: "[headerOutlet]" }, { type: DataRowOutlet, selector: "[rowOutlet]" }, { type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], changeDetection: i0.ChangeDetectionStrategy.Default, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcResultTable, decorators: [{
            type: Component,
            args: [{
                    selector: "dxc-resultset-table, table[dxc-resultset-table]",
                    exportAs: "dxcResultsetTable",
                    template: `
    <dxc-table [margin]="margin">
      <ng-container headerOutlet></ng-container>
      <ng-container rowOutlet></ng-container>
    </dxc-table>

    <dxc-paginator
      *ngIf="totalItems !== null"
      [totalItems]="totalItems"
      [itemsPerPage]="itemsPerPage"
      [itemsPerPageOptions]="itemsPerPageOptions"
      [currentPage]="page"
      [showGoToPage]="showGoToPage"
      (onGoToPage)="navigate($event)"
      (itemsPerPageFunction)="handleItemsPerPageSelect($event)"
    ></dxc-paginator>
  `,
                    encapsulation: ViewEncapsulation.None,
                    // The "OnPush" status for the `MatTable` component is effectively a noop, so we are removing it.
                    // The view for `MatTable` consists entirely of templates declared in other views. As they are
                    // declared elsewhere, they are checked when their declaration points are checked.
                    // tslint:disable-next-line:validate-decorators
                    changeDetection: ChangeDetectionStrategy.Default,
                    providers: [
                        { provide: DXC_RESULTSET_TABLE, useExisting: DxcResultTable },
                        PaginationService,
                        SortService,
                    ],
                }]
        }], ctorParameters: function () { return [{ type: i0.IterableDiffers }, { type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: undefined, decorators: [{
                    type: Attribute,
                    args: ["role"]
                }] }, { type: i1$1.Directionality, decorators: [{
                    type: Optional
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }, { type: i0.ComponentFactoryResolver }, { type: PaginationService }, { type: SortService }]; }, propDecorators: { itemsPerPage: [{
                type: Input
            }], collectionResource: [{
                type: Input
            }], margin: [{
                type: Input
            }], itemsPerPageOptions: [{
                type: Input
            }], showGoToPage: [{
                type: Input
            }], tabIndexValue: [{
                type: Input
            }], itemsPerPageFunction: [{
                type: Output
            }], className: [{
                type: HostBinding,
                args: ["class"]
            }], trackBy: [{
                type: Input
            }], _headerOutlet: [{
                type: ViewChild,
                args: [HeaderOutlet, { static: true }]
            }], _rowOutlet: [{
                type: ViewChild,
                args: [DataRowOutlet, { static: true }]
            }], _contentColumnDefs: [{
                type: ContentChildren,
                args: [DxcColumnDef, { descendants: true }]
            }] } });

/**
 * Provides a handle for sorting rows using table's headers.
 * @docs-private
 */
class Ordering {
    constructor(elementRef, viewContainerRef) {
        this.elementRef = elementRef;
        this.viewContainerRef = viewContainerRef;
        const _injector = this.viewContainerRef.parentInjector;
        const _parent = _injector.get(DxcResultTable);
        if (_parent) {
            this.parent = _parent;
            //Register directive in the parent
            this.parent.registerOrderingRef(this.elementRef);
        }
    }
    //Click event to change states and icons
    click() {
        if (this.ordering === "true") {
            let idHeader = this.elementRef.nativeElement.id; //Example: header-user
            let columnName = idHeader.split("-")[1];
            this.state = this.parent.getMapStateHeaders().get(columnName);
            if (this.state === "default" || this.state === "down") {
                this.state = "up";
                this.parent.getMapStateHeaders().set(columnName, "up");
                this.parent.changeAscIcon(this.elementRef);
            }
            else if (this.state === "up") {
                this.state = "down";
                this.parent.getMapStateHeaders().set(columnName, "down");
                this.parent.changeDescIcon(this.elementRef);
            }
            let divHeader = document.getElementById(idHeader);
            divHeader.setAttribute("state", this.state);
            this.parent.removeOtherSorts(idHeader); //Remove all header's state different from default state.
            this.parent.sortCells(this.propertyname, this.state); //Sort all data
            this.parent.navigate(1, "first"); //Navegate to first page from paginator
        }
    }
}
Ordering.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: Ordering, deps: [{ token: i0.ElementRef }, { token: i0.ViewContainerRef }], target: i0.ɵɵFactoryTarget.Directive });
Ordering.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.2.5", type: Ordering, selector: "[ordering]", inputs: { ordering: "ordering", propertyname: "propertyname" }, host: { listeners: { "click": "click()" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: Ordering, decorators: [{
            type: Directive,
            args: [{ selector: "[ordering]" }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.ViewContainerRef }]; }, propDecorators: { ordering: [{
                type: Input,
                args: ["ordering"]
            }], propertyname: [{
                type: Input,
                args: ["propertyname"]
            }], click: [{
                type: HostListener,
                args: ["click"]
            }] } });

/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * The row template that can be used by the mat-table. Should not be used outside of the
 * material library.
 */
const CDK_ROW_TEMPLATE = `<ng-container cdkCellOutlet></ng-container>`;
/**
 * Base class for the CdkHeaderRowDef and CdkRowDef that handles checking their columns inputs
 * for changes and notifying the table.
 */
class BaseRowDef {
    constructor(
    /** @docs-private */ template, _differs) {
        this.template = template;
        this._differs = _differs;
    }
    ngOnChanges(changes) {
        // Create a new columns differ if one does not yet exist. Initialize it based on initial value
        // of the columns property or an empty array if none is provided.
        if (!this._columnsDiffer) {
            const columns = (changes["columns"] && changes["columns"].currentValue) || [];
            this._columnsDiffer = this._differs.find(columns).create();
            this._columnsDiffer.diff(columns);
        }
    }
}
BaseRowDef.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: BaseRowDef, deps: [{ token: i0.TemplateRef }, { token: i0.IterableDiffers }], target: i0.ɵɵFactoryTarget.Directive });
BaseRowDef.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.2.5", type: BaseRowDef, usesOnChanges: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: BaseRowDef, decorators: [{
            type: Directive
        }], ctorParameters: function () { return [{ type: i0.TemplateRef }, { type: i0.IterableDiffers }]; } });

/**
 * Data row definition for the CDK table.
 * Captures the header row's template and other row properties such as the columns to display and
 * a when predicate that describes when this row should be used.
 */
class DxcRowDef extends BaseRowDef {
    // TODO(andrewseguin): Add an input for providing a switch function to determine
    //   if this template should be used.
    constructor(template, _differs, _table) {
        super(template, _differs);
        this._table = _table;
    }
}
DxcRowDef.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcRowDef, deps: [{ token: i0.TemplateRef }, { token: i0.IterableDiffers }, { token: DXC_RESULTSET_TABLE, optional: true }], target: i0.ɵɵFactoryTarget.Directive });
DxcRowDef.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.2.5", type: DxcRowDef, selector: "[dxcRowDef]", inputs: { columns: ["dxcRowDefColumns", "columns"], when: ["dxcRowDefWhen", "when"] }, usesInheritance: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcRowDef, decorators: [{
            type: Directive,
            args: [{
                    selector: "[dxcRowDef]",
                    inputs: ["columns: dxcRowDefColumns", "when: dxcRowDefWhen"],
                }]
        }], ctorParameters: function () { return [{ type: i0.TemplateRef }, { type: i0.IterableDiffers }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [DXC_RESULTSET_TABLE]
                }, {
                    type: Optional
                }] }]; } });

const DECLARATIONS = [
    DxcResultTable,
    DxcRowDef,
    DxcCellDef,
    DxcCellOutlet,
    DxcColumnDef,
    DxcHeaderRowComponent,
    HeaderOutlet,
    DataRowOutlet,
    DxcRowComponent,
    Ordering,
];
const EXPORTED_DECLARATIONS = [DxcResultTable, DxcCellDef, DxcColumnDef];
class DxcResultsetTableModule {
}
DxcResultsetTableModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcResultsetTableModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DxcResultsetTableModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcResultsetTableModule, declarations: [DxcResultTable,
        DxcRowDef,
        DxcCellDef,
        DxcCellOutlet,
        DxcColumnDef,
        DxcHeaderRowComponent,
        HeaderOutlet,
        DataRowOutlet,
        DxcRowComponent,
        Ordering], imports: [FormsModule, CommonModule, DxcTableModule, DxcPaginatorModule], exports: [DxcResultTable, DxcCellDef, DxcColumnDef] });
DxcResultsetTableModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcResultsetTableModule, imports: [[FormsModule, CommonModule, DxcTableModule, DxcPaginatorModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcResultsetTableModule, decorators: [{
            type: NgModule,
            args: [{
                    exports: [EXPORTED_DECLARATIONS],
                    imports: [FormsModule, CommonModule, DxcTableModule, DxcPaginatorModule],
                    declarations: DECLARATIONS,
                    entryComponents: [DxcRowComponent, DxcHeaderRowComponent],
                }]
        }] });

class SidenavService {
    constructor() {
        this._isShown = new BehaviorSubject(true);
        this.isMenuShown = this._isShown.asObservable();
        this._isPushMode = new BehaviorSubject(true);
        this.isPushMode = this._isPushMode.asObservable();
    }
    showMenu(state) {
        this._isShown.next(state);
    }
    setPushMode(isPushMode) {
        this._isPushMode.next(isPushMode);
    }
}
SidenavService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: SidenavService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
SidenavService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: SidenavService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: SidenavService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return []; } });

class DxcApplicationLayoutHeaderComponent {
    constructor(element) {
        this.element = element;
    }
    ngOnInit() {
    }
}
DxcApplicationLayoutHeaderComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcApplicationLayoutHeaderComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
DxcApplicationLayoutHeaderComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.5", type: DxcApplicationLayoutHeaderComponent, selector: "dxc-application-layout-header", providers: [CssUtils], ngImport: i0, template: "<ng-content></ng-content>" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcApplicationLayoutHeaderComponent, decorators: [{
            type: Component,
            args: [{ selector: "dxc-application-layout-header", providers: [CssUtils], template: "<ng-content></ng-content>" }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; } });

class DxcApplicationLayoutFooterComponent {
    constructor(element) {
        this.element = element;
    }
    ngOnInit() {
    }
}
DxcApplicationLayoutFooterComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcApplicationLayoutFooterComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
DxcApplicationLayoutFooterComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.5", type: DxcApplicationLayoutFooterComponent, selector: "dxc-application-layout-footer", providers: [CssUtils], ngImport: i0, template: "<ng-content></ng-content>" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcApplicationLayoutFooterComponent, decorators: [{
            type: Component,
            args: [{ selector: "dxc-application-layout-footer", providers: [CssUtils], template: "<ng-content></ng-content>" }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; } });

class DxcApplicationLayoutComponent {
    constructor(service, cdRef) {
        this.service = service;
        this.cdRef = cdRef;
        this.defaultHeader = false;
        this.defaultFooter = false;
        this.defaultInputs = new BehaviorSubject({
            innerWidth,
            isModePush: true,
        });
        this.service.isMenuShown.subscribe((value) => {
            this.isMenuShown = value;
            this.updateCss();
        });
        this.service.isPushMode.subscribe((value) => {
            this.isModePush = value;
            this.updateCss();
        });
    }
    onResize(event) {
        this.innerWidth = event.target.innerWidth;
        this.updateCss();
    }
    ngOnInit() {
        this.innerWidth = window.innerWidth;
        this.updateCss();
    }
    ngAfterContentInit() {
        if (this.dxcHeader.length === 0 && this.dxcCustomHeader.length !== 0) {
            this.customHeader = "customHeader";
        }
        else if (this.dxcHeader.length === 1) {
            this.customHeader = "customDxcHeader";
        }
        else if (this.dxcHeader.length === 0 &&
            this.dxcCustomHeader.length === 0) {
            this.defaultHeader = true;
        }
        if (this.dxcFooter.length === 0 && this.dxcCustomFooter.length !== 0) {
            this.customFooter = "customFooter";
        }
        else if (this.dxcFooter.length === 1) {
            this.customFooter = "customDxcFooter";
        }
        else if (this.dxcFooter.length === 0 &&
            this.dxcCustomFooter.length === 0) {
            this.defaultFooter = true;
        }
        this.cdRef.detectChanges();
    }
    updateCss() {
        this.layoutStyles = `${this.getDynamicStyle({
            ...this.defaultInputs.getValue(),
            innerWidth: this.innerWidth,
            isModePush: this.isModePush,
        })}`;
    }
    getDynamicStyle(inputs) {
        return css `
      z-index: 400;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      margin: 0;
      display: flex;
      flex-direction: column;
      height: 100vh;
      dxc-header {
        width: 100%;
        max-height: 64px;
        mat-toolbar {
          z-index: 500;
          mat-toolbar-row {
            height: 64px !important;
          }
        }
      }
      dxc-application-layout-header {
        width: 100%;
        z-index: 500;
        max-height: 64px;
        overflow: hidden;
      }
      dxc-application-layout-header, dxc-header {
        position: fixed;
        z-index: 500;
      }
      .application-content {
        display: flex;
        position: relative;
        height: 100%;
        margin-top: 64px;
        .sidenav {
          background-color: var(--sidenav-backgroundColor);
        }
      }
      div.main {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        dxc-application-layout-main {
          transition: width 0.4s ease-in-out;
          width: 100%;
          height: fit-content;
          display: flex;
          flex-direction: column;
        }
      }
      dxc-application-layout-sidenav {
        ${this.isModePush && this.isMenuShown ? "width: 300px; height: 100%; display: block;" : ""}
        .sidenavContainerClass {
          max-height: 100vh;
          position: fixed;
        }
      }
      dxc-footer {
        width: 100%;
        transition: width 0.4s ease-in-out;
      }
    `;
    }
}
DxcApplicationLayoutComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcApplicationLayoutComponent, deps: [{ token: SidenavService }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
DxcApplicationLayoutComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.5", type: DxcApplicationLayoutComponent, selector: "dxc-application-layout", host: { listeners: { "window:resize": "onResize($event)" }, properties: { "class": "this.layoutStyles" } }, providers: [CssUtils, SidenavService], queries: [{ propertyName: "dxcHeader", predicate: DxcHeaderComponent }, { propertyName: "dxcCustomHeader", predicate: DxcApplicationLayoutHeaderComponent }, { propertyName: "dxcFooter", predicate: DxcFooterComponent }, { propertyName: "dxcCustomFooter", predicate: DxcApplicationLayoutFooterComponent }], ngImport: i0, template: "<ng-content\n  *ngIf=\"customHeader === 'customDxcHeader'\"\n  select=\"dxc-header\"\n></ng-content>\n<ng-content\n  *ngIf=\"customHeader === 'customHeader'\"\n  select=\"dxc-application-layout-header\"\n></ng-content>\n<dxc-header *ngIf=\"defaultHeader\"></dxc-header>\n<div class=\"application-content\">\n  <div class=\"sidenav\">\n    <ng-content select=\"dxc-application-layout-sidenav\"></ng-content>\n  </div>\n  <div class=\"main\">\n    <ng-content select=\"dxc-application-layout-main\"></ng-content>\n    <ng-content\n      *ngIf=\"customFooter === 'customDxcFooter'\"\n      select=\"dxc-footer\"\n    ></ng-content>\n    <ng-content\n      *ngIf=\"customFooter === 'customFooter'\"\n      select=\"dxc-application-layout-footer\"\n    ></ng-content>\n    <dxc-footer class=\"footer\" *ngIf=\"defaultFooter\"></dxc-footer>\n  </div>\n</div>\n", components: [{ type: DxcHeaderComponent, selector: "dxc-header", inputs: ["underlined", "logoSrc", "logoResponsiveSrc", "tabIndexValue", "margin", "padding"], outputs: ["onClick"] }, { type: DxcFooterComponent, selector: "dxc-footer", inputs: ["socialLinks", "bottomLinks", "copyright", "margin", "padding", "logoSrc", "tabIndexValue"] }], directives: [{ type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcApplicationLayoutComponent, decorators: [{
            type: Component,
            args: [{ selector: "dxc-application-layout", providers: [CssUtils, SidenavService], template: "<ng-content\n  *ngIf=\"customHeader === 'customDxcHeader'\"\n  select=\"dxc-header\"\n></ng-content>\n<ng-content\n  *ngIf=\"customHeader === 'customHeader'\"\n  select=\"dxc-application-layout-header\"\n></ng-content>\n<dxc-header *ngIf=\"defaultHeader\"></dxc-header>\n<div class=\"application-content\">\n  <div class=\"sidenav\">\n    <ng-content select=\"dxc-application-layout-sidenav\"></ng-content>\n  </div>\n  <div class=\"main\">\n    <ng-content select=\"dxc-application-layout-main\"></ng-content>\n    <ng-content\n      *ngIf=\"customFooter === 'customDxcFooter'\"\n      select=\"dxc-footer\"\n    ></ng-content>\n    <ng-content\n      *ngIf=\"customFooter === 'customFooter'\"\n      select=\"dxc-application-layout-footer\"\n    ></ng-content>\n    <dxc-footer class=\"footer\" *ngIf=\"defaultFooter\"></dxc-footer>\n  </div>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: SidenavService }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { layoutStyles: [{
                type: HostBinding,
                args: ["class"]
            }], dxcHeader: [{
                type: ContentChildren,
                args: [DxcHeaderComponent]
            }], dxcCustomHeader: [{
                type: ContentChildren,
                args: [DxcApplicationLayoutHeaderComponent]
            }], dxcFooter: [{
                type: ContentChildren,
                args: [DxcFooterComponent]
            }], dxcCustomFooter: [{
                type: ContentChildren,
                args: [DxcApplicationLayoutFooterComponent]
            }], onResize: [{
                type: HostListener,
                args: ["window:resize", ["$event"]]
            }] } });

class DxcApplicationLayoutMainComponent {
    constructor() { }
    ngOnInit() { }
}
DxcApplicationLayoutMainComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcApplicationLayoutMainComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
DxcApplicationLayoutMainComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.5", type: DxcApplicationLayoutMainComponent, selector: "dxc-application-layout-main", providers: [CssUtils], ngImport: i0, template: "<ng-content></ng-content>\n" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcApplicationLayoutMainComponent, decorators: [{
            type: Component,
            args: [{ selector: "dxc-application-layout-main", providers: [CssUtils], template: "<ng-content></ng-content>\n" }]
        }], ctorParameters: function () { return []; } });

class DxcApplicationLayoutSidenavComponent {
    constructor(utils, sidenavService) {
        this.utils = utils;
        this.sidenavService = sidenavService;
        /**
         * Default action over the content of the page, overlay the content or push to the right ('push' | 'overlay').
         * In lower resolutions the mode will always be overlay.
         */
        this.mode = "overlay";
        this._displayArrow = true;
        this.firstClick = false; //remove animation on first load
        this.isResponsive = true;
        this.defaultInputs = new BehaviorSubject({
            displayArrow: true,
            padding: null,
            mode: "overlay",
        });
    }
    /**
     * If false, the arrow button is hidden.
     * In lower resolutions the arrow will be always displayed.
     */
    get displayArrow() {
        return this._displayArrow;
    }
    set displayArrow(value) {
        this._displayArrow = coerceBooleanProperty(value);
    }
    onResize() {
        this.updateCss();
    }
    ngOnInit() {
        this.updateState();
        this.sidenavStyles = `${this.getDynamicStyle({
            ...this.defaultInputs.getValue(),
            mode: this.mode,
            isResponsive: this.isResponsive,
            isShown: this.isShown,
        })}`;
    }
    arrowClicked() {
        this.isShown = !this.isShown;
        this.firstClick = true;
        this.sidenavService.showMenu(this.isShown);
        this.updateCss();
    }
    arrowKey($event) {
        if ($event.keyCode && $event.keyCode === 32) {
            $event.preventDefault();
            this.isShown = !this.isShown;
            this.updateCss();
        }
    }
    ngOnChanges(changes) {
        const inputs = Object.keys(changes).reduce((result, item) => {
            result[item] = changes[item].currentValue;
            return result;
        }, {});
        this.defaultInputs.next({ ...this.defaultInputs.getValue(), ...inputs });
        if (this.sidenav) {
            this.updateCss();
        }
    }
    updateState() {
        this.sidenavService.setPushMode(this.mode === "push");
        this.isResponsive = window.matchMedia(`(max-width: ${responsiveSizes.medium}rem)`).matches;
        this.isResponsive ? this.showArrow = true : this.showArrow = this.displayArrow;
        if (!this.isResponsive && !this.displayArrow && !this.isShown) {
            this.isShown = true;
        }
        this.isShown =
            this.isShown !== undefined
                ? this.isShown
                : this.isResponsive
                    ? false
                    : true;
        this.sidenavService.showMenu(this.isShown);
    }
    updateCss() {
        this.updateState();
        this.sidenavStyles = `${this.getDynamicStyle({
            ...this.defaultInputs.getValue(),
            mode: this.mode,
            isResponsive: this.isResponsive,
            isShown: this.isShown,
        })}`;
    }
    getDynamicStyle(inputs) {
        return css `
      z-index: 400;
      position: ${(inputs.mode === "overlay" && this.displayArrow) ||
            this.isResponsive
            ? "absolute"
            : "relative"};
      height: ${inputs.mode === "overlay" || this.isResponsive ? "100%" : ""};
      .sidenavContainerClass {
        background-color: var(--sidenav-backgroundColor);
        display: flex;
        position: sticky;
        height: 100%;
        .sidenavMenu {
          ${this.isShown ? this.utils.getPaddings(inputs.padding) : ""}
          width: ${inputs.isShown
            ? "calc(300px" +
                this.utils.getPaddingOrMargin(null, inputs.padding) +
                ")"
            : "0px"};
          overflow-y: auto;
          overflow-x: hidden;
          transform: ${inputs.isShown
            ? "translateX(0)"
            : !inputs.isShown
                ? "translateX(-100%) !important"
                : ""};
          opacity: ${inputs.isShown ? "1" : "0"};
          visibility: ${inputs.isShown ? "visible" : "hidden"};
          transition: ${this.firstClick
            ? "transform 0.4s ease-in-out, opacity 0.4s ease-in-out, visibility 0.4s ease-in-out, width 0.4s ease-in-out, padding 0.4s ease-in-out;"
            : "width 0.4s ease-in-out"};
          &::-webkit-scrollbar {
            width: 2px;
          }
          &::-webkit-scrollbar-track {
            background-color: #d9d9d9;
            border-radius: 3px;
          }
          &::-webkit-scrollbar-thumb {
            background-color: #66666626;
            border-radius: 3px;
          }
        }
        .sidenavArrow {
          visibility: ${!this.showArrow ? "hidden" : "visible"};
          width: 42px;
          height: 42px;
          background-color: var(--sidenav-arrowContainerColor);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          position: fixed;
          left: ${this.isShown ? "calc(300px - 21px)" : "calc(0px - 21px)"};
          top: calc(50% - 21px);
          transition: ${this.firstClick
            ? "transform 0.4s ease-in-out, left 0.4s ease-in-out;"
            : ""};
          cursor: pointer;
          z-index: ${inputs.mode === "overlay" || this.isResponsive
            ? "401"
            : "auto"};
          .sidenavArrowImage {
            height: 18px;
            width: 18px;
            display: flex;
            align-items: center;
            margin-left: ${inputs.isShown ? "0px" : "10px"};
            transform: ${inputs.isShown
            ? "rotate(-180deg)"
            : "rotate(0deg) !important"};
            transition: ${this.firstClick
            ? "margin 0.4s ease-in, transform 0.4s ease-in-out; "
            : ""};
            fill: var(--sidenav-arrowColor);
          }
        }
      }
    `;
    }
}
DxcApplicationLayoutSidenavComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcApplicationLayoutSidenavComponent, deps: [{ token: CssUtils }, { token: SidenavService }], target: i0.ɵɵFactoryTarget.Component });
DxcApplicationLayoutSidenavComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.5", type: DxcApplicationLayoutSidenavComponent, selector: "dxc-application-layout-sidenav", inputs: { mode: "mode", padding: "padding", displayArrow: "displayArrow" }, host: { listeners: { "window:resize": "onResize($event)" }, properties: { "class": "this.sidenavStyles" } }, providers: [CssUtils], viewQueries: [{ propertyName: "sidenav", first: true, predicate: ["sidenavContainer"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<div #sidenavContainer class=\"sidenavContainerClass\">\n  <div class=\"sidenavMenu\">\n    <ng-content></ng-content>\n  </div>\n  <div\n    tabindex=\"0\"\n    *ngIf=\"showArrow\"\n    class=\"sidenavArrow\"\n    (keydown)=\"arrowKey($event)\"\n    (click)=\"arrowClicked()\"\n  >\n    <span class=\"sidenavArrowImage\">\n      <svg\n        xmlns=\"http://www.w3.org/2000/svg\"\n        width=\"15.995\"\n        height=\"10.01\"\n        viewBox=\"0 0 15.995 10.01\"\n      >\n        <path\n          id=\"arrow-to-right\"\n          d=\"M17.71,11.29l-4-4a1,1,0,0,0-1.42,1.42L14.59,11H3a1,1,0,0,0,0,2H14.59l-2.3,2.29a1,1,0,1,0,1.42,1.42l4-4a1.034,1.034,0,0,0,0-1.42Z\"\n          transform=\"translate(-2 -6.996)\"\n        />\n      </svg>\n    </span>\n  </div>\n</div>\n", directives: [{ type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcApplicationLayoutSidenavComponent, decorators: [{
            type: Component,
            args: [{ selector: "dxc-application-layout-sidenav", providers: [CssUtils], template: "<div #sidenavContainer class=\"sidenavContainerClass\">\n  <div class=\"sidenavMenu\">\n    <ng-content></ng-content>\n  </div>\n  <div\n    tabindex=\"0\"\n    *ngIf=\"showArrow\"\n    class=\"sidenavArrow\"\n    (keydown)=\"arrowKey($event)\"\n    (click)=\"arrowClicked()\"\n  >\n    <span class=\"sidenavArrowImage\">\n      <svg\n        xmlns=\"http://www.w3.org/2000/svg\"\n        width=\"15.995\"\n        height=\"10.01\"\n        viewBox=\"0 0 15.995 10.01\"\n      >\n        <path\n          id=\"arrow-to-right\"\n          d=\"M17.71,11.29l-4-4a1,1,0,0,0-1.42,1.42L14.59,11H3a1,1,0,0,0,0,2H14.59l-2.3,2.29a1,1,0,1,0,1.42,1.42l4-4a1.034,1.034,0,0,0,0-1.42Z\"\n          transform=\"translate(-2 -6.996)\"\n        />\n      </svg>\n    </span>\n  </div>\n</div>\n", styles: [] }]
        }], ctorParameters: function () { return [{ type: CssUtils }, { type: SidenavService }]; }, propDecorators: { sidenavStyles: [{
                type: HostBinding,
                args: ["class"]
            }], mode: [{
                type: Input
            }], padding: [{
                type: Input
            }], displayArrow: [{
                type: Input
            }], sidenav: [{
                type: ViewChild,
                args: ["sidenavContainer", { static: false }]
            }], onResize: [{
                type: HostListener,
                args: ["window:resize", ["$event"]]
            }] } });

class DxcApplicationLayoutModule {
}
DxcApplicationLayoutModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcApplicationLayoutModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DxcApplicationLayoutModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcApplicationLayoutModule, declarations: [DxcApplicationLayoutComponent,
        DxcApplicationLayoutMainComponent,
        DxcApplicationLayoutSidenavComponent,
        DxcApplicationLayoutHeaderComponent,
        DxcApplicationLayoutFooterComponent], imports: [CommonModule, ObserversModule, DxcHeaderModule, DxcFooterModule], exports: [DxcApplicationLayoutComponent,
        DxcApplicationLayoutMainComponent,
        DxcApplicationLayoutSidenavComponent,
        DxcApplicationLayoutHeaderComponent,
        DxcApplicationLayoutFooterComponent] });
DxcApplicationLayoutModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcApplicationLayoutModule, providers: [], imports: [[CommonModule, ObserversModule, DxcHeaderModule, DxcFooterModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcApplicationLayoutModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        DxcApplicationLayoutComponent,
                        DxcApplicationLayoutMainComponent,
                        DxcApplicationLayoutSidenavComponent,
                        DxcApplicationLayoutHeaderComponent,
                        DxcApplicationLayoutFooterComponent
                    ],
                    imports: [CommonModule, ObserversModule, DxcHeaderModule, DxcFooterModule],
                    exports: [
                        DxcApplicationLayoutComponent,
                        DxcApplicationLayoutMainComponent,
                        DxcApplicationLayoutSidenavComponent,
                        DxcApplicationLayoutHeaderComponent,
                        DxcApplicationLayoutFooterComponent
                    ],
                    providers: [],
                }]
        }] });

class RadioGroupService {
    constructor() {
        this.optionList = new BehaviorSubject(null);
        this.selectedValue = new BehaviorSubject(undefined);
        this.indexToFocus = new BehaviorSubject(undefined);
        this.newValue = new BehaviorSubject(undefined);
        this.firstTabbedFocus = false;
    }
}
RadioGroupService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: RadioGroupService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
RadioGroupService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: RadioGroupService, providedIn: "root" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: RadioGroupService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: "root",
                }]
        }] });

class DxcRadioGroupItemComponent {
    constructor(service, elRef) {
        this.service = service;
        this.elRef = elRef;
        this.selected = false;
        this.disabled = false;
        this.errorState = false;
        this.readOnlyState = false;
        this.radioLabelId = "";
        this.defaultInputs = new BehaviorSubject({
            label: "",
            value: undefined,
            disabled: false,
        });
        this.service.indexToFocus.subscribe((index) => {
            if (index >= 0) {
                if (this.indexValue === index) {
                    this.elRef.nativeElement.focus();
                }
            }
        });
    }
    onClickHandler() {
        if (!this.disabled) {
            if (!this.service.firstTabbedFocus) {
                this.service.newValue.next(this.value);
                this.service.firstTabbedFocus = true;
            }
            if (this.service.newValue.value !== this.value) {
                this.service.newValue.next(this.value);
            }
        }
    }
    onFocusHandler() {
        if (!this.disabled) {
            if (this.service.firstTabbedFocus) {
                this.service.newValue.next(this.value);
            }
            this.service.firstTabbedFocus = true;
        }
    }
    ngOnInit() {
        this.service.selectedValue.subscribe((newValue) => {
            if (this.value || (this.value === "" && newValue) || newValue === "") {
                this.selected = this.value === newValue;
            }
        });
        this.radioLabelId = `radio-${v4()}`;
    }
    ngOnChanges(changes) {
        const inputs = Object.keys(changes).reduce((result, item) => {
            result[item] = changes[item].currentValue;
            return result;
        }, {});
        this.defaultInputs.next({ ...this.defaultInputs.getValue(), ...inputs });
        this.styles = `${this.getDynamicStyle({
            ...this.defaultInputs.getValue(),
        })}`;
    }
    getBorderColor() {
        if (this.disabled) {
            return "var(--radioGroup-disabledRadioInputColor)";
        }
        else if (this.errorState) {
            return "var(--radioGroup-errorRadioInputColor)";
        }
        else if (this.readOnlyState) {
            return "var(--radioGroup-readonlyRadioInputColor)";
        }
        else {
            return "var(--radioGroup-radioInputColor)";
        }
    }
    getHoverBorderColor() {
        if (this.errorState) {
            return "var(--radioGroup-hoverErrorRadioInputColor)";
        }
        else if (this.readOnlyState) {
            return "var(--radioGroup-hoverReadonlyRadioInputColor)";
        }
        else {
            return "var(--radioGroup-hoverRadioInputColor)";
        }
    }
    getActiveBorderColor() {
        if (this.errorState) {
            return "var(--radioGroup-activeErrorRadioInputColor)";
        }
        else if (this.readOnlyState) {
            return "var(--radioGroup-activeReadonlyRadioInputColor)";
        }
        else {
            return "var(--radioGroup-activeRadioInputColor)";
        }
    }
    getDynamicStyle(inputs) {
        return css `
      display: inline-flex;
      align-items: center;
      ${inputs.disabled ? "pointer-events: none" : inputs.readOnlyState ? "cursor: default" : "cursor: pointer"};
      width: fit-content;
      .radioInputContainer {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 24px;
        width: 24px;
        .radioInput {
          display: flex;
          align-items: center;
          justify-content: center;
          box-sizing: border-box;
          width: 18px;
          height: 18px;
          border: var(--radioGroup-radioInputBorderWidth)
            var(--radioGroup-radioInputBorderStyle);
          border-color: ${this.getBorderColor()};
          border-radius: 50%;
          box-shadow: 0 0 0 2px transparent;
        }
      }
      &.selected {
        .dot {
          height: 10px;
          width: 10px;
          border-radius: 50%;
          background-color: ${this.getBorderColor()};
        }
      }
      .radioLabel {
        margin-left: var(--radioGroup-radioInputLabelMargin);
        color: ${inputs.disabled
            ? "var(--radioGroup-disabledRadioInputLabelFontColor)"
            : "var(--radioGroup-radioInputLabelFontColor)"};
        font-family: var(--radioGroup-radioInputLabelFontFamily);
        font-size: var(--radioGroup-radioInputLabelFontSize);
        font-style: var(--radioGroup-radioInputLabelFontStyle);
        font-weight: var(--radioGroup-radioInputLabelFontWeight);
        line-height: var(--radioGroup-radioInputLabelLineHeight);
      }
      &:focus,
      &:focus-visible {
        outline: none;
        .radioInput {
          outline: var(--radioGroup-focusBorderWidth)
            var(--radioGroup-focusBorderStyle)
            var(--radioGroup-focusRadioInputColor);
          outline-offset: 1px;
        }
      }
      &:hover {
        .radioInput {
          border-color: ${this.getHoverBorderColor()};
        }
        &.selected {
          .dot {
            background-color: ${this.getHoverBorderColor()};
          }
        }
      }
      &:active {
        .radioInput {
          border-color: ${this.getActiveBorderColor()};
        }
        &.selected {
          .dot {
            background-color: ${this.getActiveBorderColor()};
          }
        }
      }
    `;
    }
}
DxcRadioGroupItemComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcRadioGroupItemComponent, deps: [{ token: RadioGroupService }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
DxcRadioGroupItemComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.5", type: DxcRadioGroupItemComponent, selector: "dxc-radio-group-item", inputs: { label: "label", value: "value", disabled: "disabled", errorState: "errorState", readOnlyState: "readOnlyState", indexValue: "indexValue" }, host: { listeners: { "click": "onClickHandler()", "focus": "onFocusHandler()" }, properties: { "class": "this.styles", "class.selected": "this.selected" } }, usesOnChanges: true, ngImport: i0, template: "<div\n  class=\"radioInputContainer\"\n  role=\"radio\"\n  [attr.aria-disabled]=\"disabled\"\n  [attr.aria-checked]=\"selected\"\n  [attr.aria-labelledby]=\"radioLabelId\"\n>\n  <div class=\"radioInput\"><div *ngIf=\"selected\" class=\"dot\"></div></div>\n</div>\n<span class=\"radioLabel\" [id]=\"radioLabelId\">{{ label }}</span>\n", directives: [{ type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcRadioGroupItemComponent, decorators: [{
            type: Component,
            args: [{ selector: "dxc-radio-group-item", template: "<div\n  class=\"radioInputContainer\"\n  role=\"radio\"\n  [attr.aria-disabled]=\"disabled\"\n  [attr.aria-checked]=\"selected\"\n  [attr.aria-labelledby]=\"radioLabelId\"\n>\n  <div class=\"radioInput\"><div *ngIf=\"selected\" class=\"dot\"></div></div>\n</div>\n<span class=\"radioLabel\" [id]=\"radioLabelId\">{{ label }}</span>\n" }]
        }], ctorParameters: function () { return [{ type: RadioGroupService }, { type: i0.ElementRef }]; }, propDecorators: { styles: [{
                type: HostBinding,
                args: ["class"]
            }], selected: [{
                type: HostBinding,
                args: ["class.selected"]
            }], label: [{
                type: Input
            }], value: [{
                type: Input
            }], disabled: [{
                type: Input
            }], errorState: [{
                type: Input
            }], readOnlyState: [{
                type: Input
            }], indexValue: [{
                type: Input
            }], onClickHandler: [{
                type: HostListener,
                args: ["click"]
            }], onFocusHandler: [{
                type: HostListener,
                args: ["focus"]
            }] } });

class DxcRadioGroupComponent {
    constructor(utils, service) {
        this.utils = utils;
        this.service = service;
        /**
         * Value of the radio group. If undefined, the component will be uncontrolled
         * and the value will be managed internally by the component.
         */
        this.label = "";
        /**
         * Helper text to be placed above the radio group.
         */
        this.helperText = "";
        /**
         * If true, the component will be marked as readonly.
         */
        this.readOnly = false;
        /**
         * If true, the component will be disabled.
         */
        this.disabled = false;
        /**
         * If true, the radio group will be optional, showing (Optional) next to the
         * label and adding a default last option with an empty string as value.
         * Otherwise, the field will be considered required and an error will be
         * passed as a parameter to the OnBlur functions if an option wasn't selected.
         */
        this.optional = false;
        /**
         * Label of the optional item.
         */
        this.optionalItemLabel = "N/A";
        /**
         * Sets the orientation of the options within the radio group.
         */
        this.stacking = "column";
        /**
         * Value of the tabindex attribute.
         */
        this.tabIndexValue = 0;
        this.onChange = new EventEmitter();
        this.onBlur = new EventEmitter();
        this.radioGroupId = "";
        this.optionList = [];
        this.indexToFocus = 0;
        this.isControlled = false;
        this.defaultInputs = new BehaviorSubject({
            label: "",
            helperText: "",
            name: "",
            value: undefined,
            readOnly: false,
            disabled: false,
            defaultValue: undefined,
            options: [],
            stacking: "column",
            tabIndexValue: 0,
            error: undefined,
        });
        this.subscriptionOptions = this.service.optionList.subscribe((options) => (this.optionList = options));
        this.subcriptionNewValue = this.service.newValue.subscribe((newValue) => {
            if (!this.disabled && !this.readOnly && (newValue || newValue === "")) {
                this.onChange.emit(newValue);
                if (!this.isControlled) {
                    this.value = newValue;
                    this.service.selectedValue.next(this.value);
                    this.focusHandler();
                }
            }
        });
    }
    onFocusOutHandler($event) {
        // whether you are leaving the radio group component
        if (!$event.currentTarget.contains($event.relatedTarget)) {
            if (this.value || this.value === "") {
                const selectedOption = this.optionList?.find((el) => el.value === this.value);
                if (selectedOption) {
                    this.indexToFocus = this.optionList.indexOf(selectedOption);
                }
            }
            else {
                this.indexToFocus = 0;
            }
            this.service.firstTabbedFocus = false;
            const errorMessage = !(this.value || this.value === "") && !this.optional
                ? "This is required"
                : undefined;
            this.onBlur.emit({ value: this.value, error: errorMessage });
        }
    }
    onKeyHandler($event) {
        if ($event.key === "ArrowDown" || $event.key === "ArrowRight") {
            $event.preventDefault();
            this.indexToFocusHandler("next");
        }
        if ($event.key === "ArrowUp" || $event.key === "ArrowLeft") {
            $event.preventDefault();
            this.indexToFocusHandler("previous");
        }
        if ($event.key === "Enter" || $event.key === " ") {
            $event.preventDefault();
            if (!this.readOnly) {
                this.onChange.emit(this.optionList[this.indexToFocus].value);
                if (!this.isControlled) {
                    this.value = this.optionList[this.indexToFocus].value;
                    this.service.selectedValue.next(this.value);
                    this.focusHandler();
                }
            }
        }
        this.service.indexToFocus.next(this.indexToFocus);
    }
    ngOnInit() {
        this.radioGroupId = `radioGroup-${v4()}`;
        const tempOptions = [];
        tempOptions.push(...this.options);
        if (this.optional) {
            // add empty option to the begginning of the array
            tempOptions.push({
                label: this.optionalItemLabel,
                value: "",
            });
        }
        this.service.optionList.next(tempOptions);
        if (this.value || this.value === "") {
            this.isControlled = true;
            this.service.selectedValue.next(this.value);
        }
        else {
            if (this.defaultValue || this.defaultValue === "") {
                this.value = this.defaultValue;
            }
        }
        if (this.disabled) {
            this.indexToFocus = -1;
        }
    }
    ngOnChanges(changes) {
        if (changes?.value &&
            this.service.selectedValue?.getValue() !== this.value) {
            this.service.selectedValue.next(this.value);
            this.focusHandler();
        }
        const inputs = Object.keys(changes).reduce((result, item) => {
            result[item] = changes[item].currentValue;
            return result;
        }, {});
        this.defaultInputs.next({ ...this.defaultInputs.getValue(), ...inputs });
        this.styles = `${this.getDynamicStyle({
            ...this.defaultInputs.getValue(),
        })}`;
    }
    focusHandler() {
        if (this.value || this.value === "") {
            const selectedOption = this.optionList?.find((el) => el.value === this.value);
            if (selectedOption) {
                this.indexToFocus = this.optionList.indexOf(selectedOption);
                if (this.indexToFocus !== this.service.indexToFocus.value)
                    this.service.indexToFocus.next(this.indexToFocus);
            }
        }
        else {
            if (this.indexToFocus !== this.service.indexToFocus.value)
                this.service.indexToFocus.next(this.indexToFocus);
        }
    }
    /**
     * Closest not disabled option to focus
     */
    indexToFocusHandler(direction) {
        let auxIndex = this.indexToFocus;
        switch (direction) {
            case "next":
                do {
                    auxIndex === this.optionList.length - 1 ? (auxIndex = 0) : auxIndex++;
                    if (!this.optionList[auxIndex].disabled || this.readOnly) {
                        this.indexToFocus = auxIndex;
                        break;
                    }
                } while (auxIndex !== this.indexToFocus);
                break;
            case "previous":
                do {
                    auxIndex === 0 ? (auxIndex = this.optionList.length - 1) : auxIndex--;
                    if (!this.optionList[auxIndex].disabled || this.readOnly) {
                        this.indexToFocus = auxIndex;
                        break;
                    }
                } while (auxIndex !== this.indexToFocus);
                break;
        }
    }
    getDynamicStyle(inputs) {
        return css `
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
      .label {
        color: ${inputs.disabled
            ? "var(--radioGroup-disabledLabelFontColor)"
            : "var(--radioGroup-labelFontColor)"};
        font-family: var(--radioGroup-labelFontFamily);
        font-size: var(--radioGroup-labelFontSize);
        font-style: var(--radioGroup-labelFontStyle);
        font-weight: var(--radioGroup-labelFontWeight);
        line-height: var(--radioGroup-labelLineHeight);
      }
      .groupLabel {
        ${inputs.helperText
            ? ""
            : "margin-bottom: var(--radioGroup-groupLabelMargin);"}
      }
      .helperText,
      .optionalLabel {
        color: ${inputs.disabled
            ? "var(--radioGroup-disabledHelperTextFontColor)"
            : "var(--radioGroup-helperTextFontColor)"};
        font-family: var(--radioGroup-helperTextFontFamily);
        font-size: var(--radioGroup-helperTextFontSize);
        font-style: var(--radioGroup-helperTextFontStyle);
        font-weight: var(--radioGroup-helperTextFontWeight);
        line-height: var(--radioGroup-helperTextLineHeight);
        margin-bottom: var(--radioGroup-groupLabelMargin);
      }
      .radio-list-container {
        display: flex;
        flex-direction: ${inputs.stacking};
        gap: ${inputs.stacking === "row"
            ? "var(--radioGroup-groupHorizontalGutter)"
            : "var(--radioGroup-groupVerticalGutter)"};
      }
      .errorMessage {
        color: var(--radioGroup-errorMessageColor);
        font-size: var(--radioGroup-errorMessageFontSize);
        font-weight: var(--radioGroup-errorMessageFontWeight);
        line-height: var(--radioGroup-errorMessageLineHeight);
        font-family: var(--radioGroup-labelFontFamily);
        min-height: var(--radioGroup-errorMessageLineHeight);
      }
      .valueInput {
        display: none;
      }
    `;
    }
    ngOnDestroy() {
        this.utils = null;
        this.subscriptionOptions.unsubscribe();
        this.subcriptionNewValue.unsubscribe();
    }
}
DxcRadioGroupComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcRadioGroupComponent, deps: [{ token: CssUtils }, { token: RadioGroupService }], target: i0.ɵɵFactoryTarget.Component });
DxcRadioGroupComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.5", type: DxcRadioGroupComponent, selector: "dxc-radio-group", inputs: { label: "label", helperText: "helperText", name: "name", value: "value", readOnly: "readOnly", disabled: "disabled", optional: "optional", optionalItemLabel: "optionalItemLabel", defaultValue: "defaultValue", options: "options", stacking: "stacking", tabIndexValue: "tabIndexValue", error: "error" }, outputs: { onChange: "onChange", onBlur: "onBlur" }, host: { listeners: { "focusout": "onFocusOutHandler($event)", "keydown": "onKeyHandler($event)" }, properties: { "class": "this.styles" } }, providers: [CssUtils, RadioGroupService], viewQueries: [{ propertyName: "inputRef", first: true, predicate: ["inputRef"], descendants: true, static: true }], usesOnChanges: true, ngImport: i0, template: "<div class=\"groupLabel\">\n  <span *ngIf=\"label\" class=\"label\" [id]=\"radioGroupId\">{{ label }}</span>\n  <span *ngIf=\"optional\" class=\"optionalLabel\"> (Optional)</span>\n</div>\n<span *ngIf=\"helperText\" class=\"helperText\">{{ helperText }}</span>\n<div\n  class=\"radio-list-container\"\n  role=\"radiogroup\"\n  [attr.aria-labelledby]=\"radioGroupId\"\n>\n  <ng-container *ngFor=\"let option of optionList; index as i\">\n    <dxc-radio-group-item\n      [tabindex]=\"indexToFocus === i && !option.disabled ? tabIndexValue : '-1'\"\n      [indexValue]=\"i\"\n      [value]=\"option.value\"\n      [label]=\"option.label\"\n      [disabled]=\"(option.disabled && !readOnly) || disabled\"\n      [errorState]=\"error ? true : false\"\n      [readOnlyState]=\"readOnly\"\n    ></dxc-radio-group-item>\n  </ng-container>\n</div>\n<input\n  #inputRef\n  class=\"valueInput\"\n  [name]=\"name\"\n  [value]=\"value\"\n  readOnly\n  aria-hidden=\"true\"\n/>\n<span *ngIf=\"error || error === ''\" class=\"errorMessage\">{{ error }}</span>\n", components: [{ type: DxcRadioGroupItemComponent, selector: "dxc-radio-group-item", inputs: ["label", "value", "disabled", "errorState", "readOnlyState", "indexValue"] }], directives: [{ type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i4.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcRadioGroupComponent, decorators: [{
            type: Component,
            args: [{ selector: "dxc-radio-group", providers: [CssUtils, RadioGroupService], template: "<div class=\"groupLabel\">\n  <span *ngIf=\"label\" class=\"label\" [id]=\"radioGroupId\">{{ label }}</span>\n  <span *ngIf=\"optional\" class=\"optionalLabel\"> (Optional)</span>\n</div>\n<span *ngIf=\"helperText\" class=\"helperText\">{{ helperText }}</span>\n<div\n  class=\"radio-list-container\"\n  role=\"radiogroup\"\n  [attr.aria-labelledby]=\"radioGroupId\"\n>\n  <ng-container *ngFor=\"let option of optionList; index as i\">\n    <dxc-radio-group-item\n      [tabindex]=\"indexToFocus === i && !option.disabled ? tabIndexValue : '-1'\"\n      [indexValue]=\"i\"\n      [value]=\"option.value\"\n      [label]=\"option.label\"\n      [disabled]=\"(option.disabled && !readOnly) || disabled\"\n      [errorState]=\"error ? true : false\"\n      [readOnlyState]=\"readOnly\"\n    ></dxc-radio-group-item>\n  </ng-container>\n</div>\n<input\n  #inputRef\n  class=\"valueInput\"\n  [name]=\"name\"\n  [value]=\"value\"\n  readOnly\n  aria-hidden=\"true\"\n/>\n<span *ngIf=\"error || error === ''\" class=\"errorMessage\">{{ error }}</span>\n" }]
        }], ctorParameters: function () { return [{ type: CssUtils }, { type: RadioGroupService }]; }, propDecorators: { styles: [{
                type: HostBinding,
                args: ["class"]
            }], label: [{
                type: Input
            }], helperText: [{
                type: Input
            }], name: [{
                type: Input
            }], value: [{
                type: Input
            }], readOnly: [{
                type: Input
            }], disabled: [{
                type: Input
            }], optional: [{
                type: Input
            }], optionalItemLabel: [{
                type: Input
            }], defaultValue: [{
                type: Input
            }], options: [{
                type: Input
            }], stacking: [{
                type: Input
            }], tabIndexValue: [{
                type: Input
            }], error: [{
                type: Input
            }], onChange: [{
                type: Output
            }], onBlur: [{
                type: Output
            }], inputRef: [{
                type: ViewChild,
                args: ["inputRef", { static: true }]
            }], onFocusOutHandler: [{
                type: HostListener,
                args: ["focusout", ["$event"]]
            }], onKeyHandler: [{
                type: HostListener,
                args: ["keydown", ["$event"]]
            }] } });

class DxcRadioGroupModule {
}
DxcRadioGroupModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcRadioGroupModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DxcRadioGroupModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcRadioGroupModule, declarations: [DxcRadioGroupComponent, DxcRadioGroupItemComponent], imports: [CommonModule, FormsModule], exports: [DxcRadioGroupComponent] });
DxcRadioGroupModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcRadioGroupModule, imports: [[CommonModule, FormsModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.5", ngImport: i0, type: DxcRadioGroupModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [DxcRadioGroupComponent, DxcRadioGroupItemComponent],
                    imports: [CommonModule, FormsModule],
                    exports: [DxcRadioGroupComponent],
                }]
        }] });

/*
 * Public API Surface of foo
 */

/**
 * Generated bundle index. Do not edit.
 */

export { BackgroundProviderComponent, BackgroundProviderModule, BackgroundProviderService, BaseRowDef, CDK_ROW_TEMPLATE, ClosableDirective, DxcAccordionComponent, DxcAccordionGroupComponent, DxcAccordionGroupModule, DxcAccordionIconComponent, DxcAccordionModule, DxcAlertComponent, DxcAlertModule, DxcApplicationLayoutComponent, DxcApplicationLayoutFooterComponent, DxcApplicationLayoutHeaderComponent, DxcApplicationLayoutMainComponent, DxcApplicationLayoutModule, DxcApplicationLayoutSidenavComponent, DxcBoxComponent, DxcBoxModule, DxcButtonComponent, DxcButtonIconComponent, DxcButtonModule, DxcCardComponent, DxcCardModule, DxcCellDef, DxcCheckboxComponent, DxcCheckboxModule, DxcChipComponent, DxcChipModule, DxcChipPrefixIconComponent, DxcChipSuffixIconComponent, DxcColumnDef, DxcDateInputComponent, DxcDateInputModule, DxcDialogComponent, DxcDialogModule, DxcDragAndDropComponent, DxcDropdownComponent, DxcDropdownIconComponent, DxcDropdownModule, DxcDropdownOptionComponent, DxcFileInputComponent, DxcFileInputModule, DxcFilePreviewComponent, DxcFilesPreviewComponent, DxcFilesToUploadComponent, DxcFooterComponent, DxcFooterModule, DxcHeaderComponent, DxcHeaderDropdownComponent, DxcHeaderModule, DxcHeaderRowComponent, DxcHeadingComponent, DxcHeadingModule, DxcInputPrefixIconComponent, DxcInputSuffixIconComponent, DxcInputTextComponent, DxcInputTextModule, DxcLinkComponent, DxcLinkIconComponent, DxcLinkModule, DxcNumberInputComponent, DxcNumberInputModule, DxcPaginatorComponent, DxcPaginatorModule, DxcPasswordInputComponent, DxcPasswordInputModule, DxcProgressbarComponent, DxcProgressbarModule, DxcRadioComponent, DxcRadioGroupComponent, DxcRadioGroupItemComponent, DxcRadioGroupModule, DxcRadioModule, DxcResultTable, DxcResultsetTableModule, DxcRowComponent, DxcSelectComponent, DxcSelectModule, DxcSideNavModule, DxcSidenavComponent, DxcSidenavLinkComponent, DxcSidenavSubtitleComponent, DxcSidenavTitleComponent, DxcSliderComponent, DxcSliderModule, DxcSpinnerComponent, DxcSpinnerModule, DxcSwitchComponent, DxcSwitchModule, DxcTabComponent, DxcTabIconComponent, DxcTabbedSectionComponent, DxcTabbedSectionModule, DxcTableComponent, DxcTableModule, DxcTabsComponent, DxcTabsModule, DxcTagComponent, DxcTagIconComponent, DxcTagModule, DxcTextInputActionComponent, DxcTextInputComponent, DxcTextInputModule, DxcTextInputPrefixComponent, DxcTextInputSuffixComponent, DxcTextareaComponent, DxcTextareaModule, DxcToggleComponent, DxcToggleGroupComponent, DxcToggleGroupModule, DxcToggleIconComponent, DxcTransactionComponent, DxcTransactionsComponent, DxcUploadButtonsComponent, DxcUploadComponent, DxcUploadModule, DxcWizardComponent, DxcWizardIconComponent, DxcWizardModule, DxcWizardStepComponent, Ordering, ScrollSpyDirective, ScrollSpyModule, ThemeDirective, ThemeModule, ThemeService };
